/**
 * thumbplayer-h5
 * Update Date: 2023-10-18 14:21:03
 * Author: thumbplayer-h5 team
 * ---
 * Copyright (c) 2023 Tencent
 */

var SuperPlayerExport = (function (exports) {
  "use strict";
  var extendStatics$1 = function (e, t) {
    return (
      (extendStatics$1 =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (e, t) {
            e.__proto__ = t;
          }) ||
        function (e, t) {
          for (var o in t)
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }),
      extendStatics$1(e, t)
    );
  };
  function __extends$1(e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError(
        "Class extends value " + String(t) + " is not a constructor or null"
      );
    function o() {
      this.constructor = e;
    }
    extendStatics$1(e, t),
      (e.prototype =
        null === t ? Object.create(t) : ((o.prototype = t.prototype), new o()));
  }
  var __assign$1 = function () {
    return (
      (__assign$1 =
        Object.assign ||
        function (e) {
          for (var t, o = 1, A = arguments.length; o < A; o++)
            for (var i in (t = arguments[o]))
              Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          return e;
        }),
      __assign$1.apply(this, arguments)
    );
  };
  function __rest(e, t) {
    var o = {};
    for (var A in e)
      Object.prototype.hasOwnProperty.call(e, A) &&
        t.indexOf(A) < 0 &&
        (o[A] = e[A]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var i = 0;
      for (A = Object.getOwnPropertySymbols(e); i < A.length; i++)
        t.indexOf(A[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(e, A[i]) &&
          (o[A[i]] = e[A[i]]);
    }
    return o;
  }
  function __decorate(e, t, o, A) {
    var i,
      r = arguments.length,
      n =
        r < 3
          ? t
          : null === A
          ? (A = Object.getOwnPropertyDescriptor(t, o))
          : A;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate)
      n = Reflect.decorate(e, t, o, A);
    else
      for (var a = e.length - 1; a >= 0; a--)
        (i = e[a]) && (n = (r < 3 ? i(n) : r > 3 ? i(t, o, n) : i(t, o)) || n);
    return r > 3 && n && Object.defineProperty(t, o, n), n;
  }
  function __metadata(e, t) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata)
      return Reflect.metadata(e, t);
  }
  function __awaiter$1(e, t, o, A) {
    return new (o || (o = Promise))(function (i, r) {
      function n(e) {
        try {
          s(A.next(e));
        } catch (e) {
          r(e);
        }
      }
      function a(e) {
        try {
          s(A.throw(e));
        } catch (e) {
          r(e);
        }
      }
      function s(e) {
        var t;
        e.done
          ? i(e.value)
          : ((t = e.value),
            t instanceof o
              ? t
              : new o(function (e) {
                  e(t);
                })).then(n, a);
      }
      s((A = A.apply(e, t || [])).next());
    });
  }
  function __generator$1(e, t) {
    var o,
      A,
      i,
      r,
      n = {
        label: 0,
        sent: function () {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: [],
      };
    return (
      (r = { next: a(0), throw: a(1), return: a(2) }),
      "function" == typeof Symbol &&
        (r[Symbol.iterator] = function () {
          return this;
        }),
      r
    );
    function a(a) {
      return function (s) {
        return (function (a) {
          if (o) throw new TypeError("Generator is already executing.");
          for (; r && ((r = 0), a[0] && (n = 0)), n; )
            try {
              if (
                ((o = 1),
                A &&
                  (i =
                    2 & a[0]
                      ? A.return
                      : a[0]
                      ? A.throw || ((i = A.return) && i.call(A), 0)
                      : A.next) &&
                  !(i = i.call(A, a[1])).done)
              )
                return i;
              switch (((A = 0), i && (a = [2 & a[0], i.value]), a[0])) {
                case 0:
                case 1:
                  i = a;
                  break;
                case 4:
                  return n.label++, { value: a[1], done: !1 };
                case 5:
                  n.label++, (A = a[1]), (a = [0]);
                  continue;
                case 7:
                  (a = n.ops.pop()), n.trys.pop();
                  continue;
                default:
                  if (
                    !((i = n.trys),
                    (i = i.length > 0 && i[i.length - 1]) ||
                      (6 !== a[0] && 2 !== a[0]))
                  ) {
                    n = 0;
                    continue;
                  }
                  if (3 === a[0] && (!i || (a[1] > i[0] && a[1] < i[3]))) {
                    n.label = a[1];
                    break;
                  }
                  if (6 === a[0] && n.label < i[1]) {
                    (n.label = i[1]), (i = a);
                    break;
                  }
                  if (i && n.label < i[2]) {
                    (n.label = i[2]), n.ops.push(a);
                    break;
                  }
                  i[2] && n.ops.pop(), n.trys.pop();
                  continue;
              }
              a = t.call(e, n);
            } catch (e) {
              (a = [6, e]), (A = 0);
            } finally {
              o = i = 0;
            }
          if (5 & a[0]) throw a[1];
          return { value: a[0] ? a[1] : void 0, done: !0 };
        })([a, s]);
      };
    }
  }
  function __spreadArray(e, t, o) {
    if (o || 2 === arguments.length)
      for (var A, i = 0, r = t.length; i < r; i++)
        (!A && i in t) ||
          (A || (A = Array.prototype.slice.call(t, 0, i)), (A[i] = t[i]));
    return e.concat(A || Array.prototype.slice.call(t));
  }
  Promise.prototype.finally ||
    (Promise.prototype.finally = function (e) {
      var t = this.constructor;
      return this.then(
        function (o) {
          return t.resolve(e()).then(function () {
            return o;
          });
        },
        function (o) {
          return t.resolve(e()).then(function () {
            return t.reject(o);
          });
        }
      );
    });
  var commonjsGlobal$3 =
      "undefined" != typeof globalThis
        ? globalThis
        : "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : "undefined" != typeof self
        ? self
        : {},
    lodash_merge$1 = { exports: {} };
  !(function (e, t) {
    var o = "__lodash_hash_undefined__",
      A = 9007199254740991,
      i = "[object Arguments]",
      r = "[object Function]",
      n = "[object Object]",
      a = /^\[object .+?Constructor\]$/,
      s = /^(?:0|[1-9]\d*)$/,
      g = {};
    (g["[object Float32Array]"] =
      g["[object Float64Array]"] =
      g["[object Int8Array]"] =
      g["[object Int16Array]"] =
      g["[object Int32Array]"] =
      g["[object Uint8Array]"] =
      g["[object Uint8ClampedArray]"] =
      g["[object Uint16Array]"] =
      g["[object Uint32Array]"] =
        !0),
      (g[i] =
        g["[object Array]"] =
        g["[object ArrayBuffer]"] =
        g["[object Boolean]"] =
        g["[object DataView]"] =
        g["[object Date]"] =
        g["[object Error]"] =
        g[r] =
        g["[object Map]"] =
        g["[object Number]"] =
        g[n] =
        g["[object RegExp]"] =
        g["[object Set]"] =
        g["[object String]"] =
        g["[object WeakMap]"] =
          !1);
    var l =
        "object" == typeof commonjsGlobal$3 &&
        commonjsGlobal$3 &&
        commonjsGlobal$3.Object === Object &&
        commonjsGlobal$3,
      E = "object" == typeof self && self && self.Object === Object && self,
      c = l || E || Function("return this")(),
      u = t && !t.nodeType && t,
      p = u && e && !e.nodeType && e,
      d = p && p.exports === u,
      B = d && l.process,
      h = (function () {
        try {
          var e = p && p.require && p.require("util").types;
          return e || (B && B.binding && B.binding("util"));
        } catch (e) {}
      })(),
      I = h && h.isTypedArray;
    function C(e, t, o) {
      switch (o.length) {
        case 0:
          return e.call(t);
        case 1:
          return e.call(t, o[0]);
        case 2:
          return e.call(t, o[0], o[1]);
        case 3:
          return e.call(t, o[0], o[1], o[2]);
      }
      return e.apply(t, o);
    }
    var _,
      f,
      y,
      m = Array.prototype,
      v = Function.prototype,
      Q = Object.prototype,
      T = c["__core-js_shared__"],
      S = v.toString,
      D = Q.hasOwnProperty,
      R = (_ = /[^.]+$/.exec((T && T.keys && T.keys.IE_PROTO) || ""))
        ? "Symbol(src)_1." + _
        : "",
      O = Q.toString,
      F = S.call(Object),
      N = RegExp(
        "^" +
          S.call(D)
            .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              "$1.*?"
            ) +
          "$"
      ),
      w = d ? c.Buffer : void 0,
      L = c.Symbol,
      P = c.Uint8Array,
      M = w ? w.allocUnsafe : void 0,
      Y =
        ((f = Object.getPrototypeOf),
        (y = Object),
        function (e) {
          return f(y(e));
        }),
      b = Object.create,
      k = Q.propertyIsEnumerable,
      x = m.splice,
      U = L ? L.toStringTag : void 0,
      K = (function () {
        try {
          var e = pe(Object, "defineProperty");
          return e({}, "", {}), e;
        } catch (e) {}
      })(),
      G = w ? w.isBuffer : void 0,
      H = Math.max,
      V = Date.now,
      q = pe(c, "Map"),
      J = pe(Object, "create"),
      j = (function () {
        function e() {}
        return function (t) {
          if (!Te(t)) return {};
          if (b) return b(t);
          e.prototype = t;
          var o = new e();
          return (e.prototype = void 0), o;
        };
      })();
    function W(e) {
      var t = -1,
        o = null == e ? 0 : e.length;
      for (this.clear(); ++t < o; ) {
        var A = e[t];
        this.set(A[0], A[1]);
      }
    }
    function $(e) {
      var t = -1,
        o = null == e ? 0 : e.length;
      for (this.clear(); ++t < o; ) {
        var A = e[t];
        this.set(A[0], A[1]);
      }
    }
    function z(e) {
      var t = -1,
        o = null == e ? 0 : e.length;
      for (this.clear(); ++t < o; ) {
        var A = e[t];
        this.set(A[0], A[1]);
      }
    }
    function Z(e) {
      var t = (this.__data__ = new $(e));
      this.size = t.size;
    }
    function X(e, t) {
      var o = fe(e),
        A = !o && _e(e),
        i = !o && !A && me(e),
        r = !o && !A && !i && De(e),
        n = o || A || i || r,
        a = n
          ? (function (e, t) {
              for (var o = -1, A = Array(e); ++o < e; ) A[o] = t(o);
              return A;
            })(e.length, String)
          : [],
        s = a.length;
      for (var g in e)
        (!t && !D.call(e, g)) ||
          (n &&
            ("length" == g ||
              (i && ("offset" == g || "parent" == g)) ||
              (r &&
                ("buffer" == g || "byteLength" == g || "byteOffset" == g)) ||
              de(g, s))) ||
          a.push(g);
      return a;
    }
    function ee(e, t, o) {
      ((void 0 !== o && !Ce(e[t], o)) || (void 0 === o && !(t in e))) &&
        Ae(e, t, o);
    }
    function te(e, t, o) {
      var A = e[t];
      (D.call(e, t) && Ce(A, o) && (void 0 !== o || t in e)) || Ae(e, t, o);
    }
    function oe(e, t) {
      for (var o = e.length; o--; ) if (Ce(e[o][0], t)) return o;
      return -1;
    }
    function Ae(e, t, o) {
      "__proto__" == t && K
        ? K(e, t, { configurable: !0, enumerable: !0, value: o, writable: !0 })
        : (e[t] = o);
    }
    (W.prototype.clear = function () {
      (this.__data__ = J ? J(null) : {}), (this.size = 0);
    }),
      (W.prototype.delete = function (e) {
        var t = this.has(e) && delete this.__data__[e];
        return (this.size -= t ? 1 : 0), t;
      }),
      (W.prototype.get = function (e) {
        var t = this.__data__;
        if (J) {
          var A = t[e];
          return A === o ? void 0 : A;
        }
        return D.call(t, e) ? t[e] : void 0;
      }),
      (W.prototype.has = function (e) {
        var t = this.__data__;
        return J ? void 0 !== t[e] : D.call(t, e);
      }),
      (W.prototype.set = function (e, t) {
        var A = this.__data__;
        return (
          (this.size += this.has(e) ? 0 : 1),
          (A[e] = J && void 0 === t ? o : t),
          this
        );
      }),
      ($.prototype.clear = function () {
        (this.__data__ = []), (this.size = 0);
      }),
      ($.prototype.delete = function (e) {
        var t = this.__data__,
          o = oe(t, e);
        return (
          !(o < 0) &&
          (o == t.length - 1 ? t.pop() : x.call(t, o, 1), --this.size, !0)
        );
      }),
      ($.prototype.get = function (e) {
        var t = this.__data__,
          o = oe(t, e);
        return o < 0 ? void 0 : t[o][1];
      }),
      ($.prototype.has = function (e) {
        return oe(this.__data__, e) > -1;
      }),
      ($.prototype.set = function (e, t) {
        var o = this.__data__,
          A = oe(o, e);
        return A < 0 ? (++this.size, o.push([e, t])) : (o[A][1] = t), this;
      }),
      (z.prototype.clear = function () {
        (this.size = 0),
          (this.__data__ = {
            hash: new W(),
            map: new (q || $)(),
            string: new W(),
          });
      }),
      (z.prototype.delete = function (e) {
        var t = ue(this, e).delete(e);
        return (this.size -= t ? 1 : 0), t;
      }),
      (z.prototype.get = function (e) {
        return ue(this, e).get(e);
      }),
      (z.prototype.has = function (e) {
        return ue(this, e).has(e);
      }),
      (z.prototype.set = function (e, t) {
        var o = ue(this, e),
          A = o.size;
        return o.set(e, t), (this.size += o.size == A ? 0 : 1), this;
      }),
      (Z.prototype.clear = function () {
        (this.__data__ = new $()), (this.size = 0);
      }),
      (Z.prototype.delete = function (e) {
        var t = this.__data__,
          o = t.delete(e);
        return (this.size = t.size), o;
      }),
      (Z.prototype.get = function (e) {
        return this.__data__.get(e);
      }),
      (Z.prototype.has = function (e) {
        return this.__data__.has(e);
      }),
      (Z.prototype.set = function (e, t) {
        var o = this.__data__;
        if (o instanceof $) {
          var A = o.__data__;
          if (!q || A.length < 199)
            return A.push([e, t]), (this.size = ++o.size), this;
          o = this.__data__ = new z(A);
        }
        return o.set(e, t), (this.size = o.size), this;
      });
    var ie,
      re = function (e, t, o) {
        for (var A = -1, i = Object(e), r = o(e), n = r.length; n--; ) {
          var a = r[ie ? n : ++A];
          if (!1 === t(i[a], a, i)) break;
        }
        return e;
      };
    function ne(e) {
      return null == e
        ? void 0 === e
          ? "[object Undefined]"
          : "[object Null]"
        : U && U in Object(e)
        ? (function (e) {
            var t = D.call(e, U),
              o = e[U];
            try {
              e[U] = void 0;
              var A = !0;
            } catch (e) {}
            var i = O.call(e);
            A && (t ? (e[U] = o) : delete e[U]);
            return i;
          })(e)
        : (function (e) {
            return O.call(e);
          })(e);
    }
    function ae(e) {
      return Se(e) && ne(e) == i;
    }
    function se(e) {
      return (
        !(
          !Te(e) ||
          (function (e) {
            return !!R && R in e;
          })(e)
        ) &&
        (ve(e) ? N : a).test(
          (function (e) {
            if (null != e) {
              try {
                return S.call(e);
              } catch (e) {}
              try {
                return e + "";
              } catch (e) {}
            }
            return "";
          })(e)
        )
      );
    }
    function ge(e) {
      if (!Te(e))
        return (function (e) {
          var t = [];
          if (null != e) for (var o in Object(e)) t.push(o);
          return t;
        })(e);
      var t = Be(e),
        o = [];
      for (var A in e)
        ("constructor" != A || (!t && D.call(e, A))) && o.push(A);
      return o;
    }
    function le(e, t, o, A, i) {
      e !== t &&
        re(
          t,
          function (r, a) {
            if ((i || (i = new Z()), Te(r)))
              !(function (e, t, o, A, i, r, a) {
                var s = he(e, o),
                  g = he(t, o),
                  l = a.get(g);
                if (l) return void ee(e, o, l);
                var E = r ? r(s, g, o + "", e, t, a) : void 0,
                  c = void 0 === E;
                if (c) {
                  var u = fe(g),
                    p = !u && me(g),
                    d = !u && !p && De(g);
                  (E = g),
                    u || p || d
                      ? fe(s)
                        ? (E = s)
                        : Se((_ = s)) && ye(_)
                        ? (E = (function (e, t) {
                            var o = -1,
                              A = e.length;
                            t || (t = Array(A));
                            for (; ++o < A; ) t[o] = e[o];
                            return t;
                          })(s))
                        : p
                        ? ((c = !1),
                          (E = (function (e, t) {
                            if (t) return e.slice();
                            var o = e.length,
                              A = M ? M(o) : new e.constructor(o);
                            return e.copy(A), A;
                          })(g, !0)))
                        : d
                        ? ((c = !1),
                          (B = g),
                          (h = !0
                            ? ((I = B.buffer),
                              (C = new I.constructor(I.byteLength)),
                              new P(C).set(new P(I)),
                              C)
                            : B.buffer),
                          (E = new B.constructor(h, B.byteOffset, B.length)))
                        : (E = [])
                      : (function (e) {
                          if (!Se(e) || ne(e) != n) return !1;
                          var t = Y(e);
                          if (null === t) return !0;
                          var o = D.call(t, "constructor") && t.constructor;
                          return (
                            "function" == typeof o &&
                            o instanceof o &&
                            S.call(o) == F
                          );
                        })(g) || _e(g)
                      ? ((E = s),
                        _e(s)
                          ? (E = (function (e) {
                              return (function (e, t, o, A) {
                                var i = !o;
                                o || (o = {});
                                var r = -1,
                                  n = t.length;
                                for (; ++r < n; ) {
                                  var a = t[r],
                                    s = A ? A(o[a], e[a], a, o, e) : void 0;
                                  void 0 === s && (s = e[a]),
                                    i ? Ae(o, a, s) : te(o, a, s);
                                }
                                return o;
                              })(e, Re(e));
                            })(s))
                          : (Te(s) && !ve(s)) ||
                            (E = (function (e) {
                              return "function" != typeof e.constructor || Be(e)
                                ? {}
                                : j(Y(e));
                            })(g)))
                      : (c = !1);
                }
                var B, h, I, C;
                var _;
                c && (a.set(g, E), i(E, g, A, r, a), a.delete(g));
                ee(e, o, E);
              })(e, t, a, o, le, A, i);
            else {
              var s = A ? A(he(e, a), r, a + "", e, t, i) : void 0;
              void 0 === s && (s = r), ee(e, a, s);
            }
          },
          Re
        );
    }
    function Ee(e, t) {
      return Ie(
        (function (e, t, o) {
          return (
            (t = H(void 0 === t ? e.length - 1 : t, 0)),
            function () {
              for (
                var A = arguments, i = -1, r = H(A.length - t, 0), n = Array(r);
                ++i < r;

              )
                n[i] = A[t + i];
              i = -1;
              for (var a = Array(t + 1); ++i < t; ) a[i] = A[i];
              return (a[t] = o(n)), C(e, this, a);
            }
          );
        })(e, t, Ne),
        e + ""
      );
    }
    var ce = K
      ? function (e, t) {
          return K(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value:
              ((o = t),
              function () {
                return o;
              }),
            writable: !0,
          });
          var o;
        }
      : Ne;
    function ue(e, t) {
      var o,
        A,
        i = e.__data__;
      return (
        "string" == (A = typeof (o = t)) ||
        "number" == A ||
        "symbol" == A ||
        "boolean" == A
          ? "__proto__" !== o
          : null === o
      )
        ? i["string" == typeof t ? "string" : "hash"]
        : i.map;
    }
    function pe(e, t) {
      var o = (function (e, t) {
        return null == e ? void 0 : e[t];
      })(e, t);
      return se(o) ? o : void 0;
    }
    function de(e, t) {
      var o = typeof e;
      return (
        !!(t = null == t ? A : t) &&
        ("number" == o || ("symbol" != o && s.test(e))) &&
        e > -1 &&
        e % 1 == 0 &&
        e < t
      );
    }
    function Be(e) {
      var t = e && e.constructor;
      return e === (("function" == typeof t && t.prototype) || Q);
    }
    function he(e, t) {
      if (
        ("constructor" !== t || "function" != typeof e[t]) &&
        "__proto__" != t
      )
        return e[t];
    }
    var Ie = (function (e) {
      var t = 0,
        o = 0;
      return function () {
        var A = V(),
          i = 16 - (A - o);
        if (((o = A), i > 0)) {
          if (++t >= 800) return arguments[0];
        } else t = 0;
        return e.apply(void 0, arguments);
      };
    })(ce);
    function Ce(e, t) {
      return e === t || (e != e && t != t);
    }
    var _e = ae(
        (function () {
          return arguments;
        })()
      )
        ? ae
        : function (e) {
            return Se(e) && D.call(e, "callee") && !k.call(e, "callee");
          },
      fe = Array.isArray;
    function ye(e) {
      return null != e && Qe(e.length) && !ve(e);
    }
    var me =
      G ||
      function () {
        return !1;
      };
    function ve(e) {
      if (!Te(e)) return !1;
      var t = ne(e);
      return (
        t == r ||
        "[object GeneratorFunction]" == t ||
        "[object AsyncFunction]" == t ||
        "[object Proxy]" == t
      );
    }
    function Qe(e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= A;
    }
    function Te(e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    }
    function Se(e) {
      return null != e && "object" == typeof e;
    }
    var De = I
      ? (function (e) {
          return function (t) {
            return e(t);
          };
        })(I)
      : function (e) {
          return Se(e) && Qe(e.length) && !!g[ne(e)];
        };
    function Re(e) {
      return ye(e) ? X(e, !0) : ge(e);
    }
    var Oe,
      Fe =
        ((Oe = function (e, t, o) {
          le(e, t, o);
        }),
        Ee(function (e, t) {
          var o = -1,
            A = t.length,
            i = A > 1 ? t[A - 1] : void 0,
            r = A > 2 ? t[2] : void 0;
          for (
            i = Oe.length > 3 && "function" == typeof i ? (A--, i) : void 0,
              r &&
                (function (e, t, o) {
                  if (!Te(o)) return !1;
                  var A = typeof t;
                  return (
                    !!("number" == A
                      ? ye(o) && de(t, o.length)
                      : "string" == A && (t in o)) && Ce(o[t], e)
                  );
                })(t[0], t[1], r) &&
                ((i = A < 3 ? void 0 : i), (A = 1)),
              e = Object(e);
            ++o < A;

          ) {
            var n = t[o];
            n && Oe(e, n, o, i);
          }
          return e;
        }));
    function Ne(e) {
      return e;
    }
    e.exports = Fe;
  })(lodash_merge$1, lodash_merge$1.exports);
  var merge$1 = lodash_merge$1.exports,
    e$1$1 = function () {
      return (e$1$1 =
        Object.assign ||
        function (e) {
          for (var t, o = 1, A = arguments.length; o < A; o++)
            for (var i in (t = arguments[o]))
              Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          return e;
        }).apply(this, arguments);
    },
    t$1$1 = (function () {
      function e() {}
      return (
        (e.setDefault = function (t) {
          e.defaultOptions = e$1$1(e$1$1({}, e.defaultOptions), t);
        }),
        (e.getCookie = function (t) {
          var o = void 0,
            A = document.cookie ? document.cookie.split("; ") : [],
            i = {};
          return (
            A.some(function (A) {
              var r = A.split("="),
                n = r[0],
                a = r.slice(1),
                s = e.decode(n),
                g = e.parseValue(a.join("="));
              return s === t ? ((o = g), !0) : ((i[s] = g), !1);
            }),
            void 0 === t ? i : o
          );
        }),
        (e.setCookie = function (t, o, A) {
          return void 0 === A && (A = {}), e.set(t, o, A);
        }),
        (e.clearCookie = function (t, o, A) {
          void 0 === o && (o = ""),
            void 0 === A && (A = ""),
            e.setCookie(t, "", { domain: o, path: A, expires: -1 });
        }),
        (e.clearAllCookies = function (t, o) {
          void 0 === t && (t = ""), void 0 === o && (o = "");
          var A = document.cookie ? document.cookie.split("; ") : [],
            i = { domain: t, path: o, expires: -1 };
          A.forEach(function (t) {
            var o = t.split("=")[0];
            e.set(o, "", i, !0);
          });
        }),
        (e.set = function (t, o, A, i) {
          void 0 === i && (i = !1);
          var r = e$1$1(e$1$1({}, e.defaultOptions), A),
            n = r.domain,
            a = r.path,
            s = r.secure,
            g = r.expires,
            l = r.sameSite,
            E = new Date(Date.now() + 24 * g * 60 * 60 * 1e3),
            c = [
              (i ? t : e.encode(t)) + "=" + e.stringifyValue(o),
              "; expires=" + E.toUTCString(),
              a ? "; path=" + a : "",
              n ? "; domain=" + n : "",
              l ? "; SameSite=" + l : "",
              s ? "; Secure" : "",
            ].join("");
          return (document.cookie = c), c;
        }),
        (e.encode = function (t) {
          return e.raw ? t : encodeURIComponent(t);
        }),
        (e.decode = function (t) {
          return e.raw ? t : decodeURIComponent(t);
        }),
        (e.stringifyValue = function (t) {
          return e.encode(e.json ? JSON.stringify(t) : String(t));
        }),
        (e.parseValue = function (t) {
          if (e.raw) return t;
          var o = t;
          0 === o.indexOf('"') &&
            (o = o.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
          try {
            return (
              (o = decodeURIComponent(o.replace(/\+/g, " "))),
              e.json ? JSON.parse(o) : o
            );
          } catch (t) {}
        }),
        (e.raw = !1),
        (e.json = !1),
        (e.defaultOptions = {
          domain: "",
          path: "/",
          expires: 365,
          secure: !0,
          sameSite: "",
        }),
        e
      );
    })(),
    n$2$1 = function (e, t) {
      var o = "" + e;
      return !o || o.length >= t
        ? o
        : "" + Array(t + 1 - o.length).join("0") + e;
    },
    i$2$1 =
      /\[([^\]]+)]|(Y|y){1,4}|M{1,4}|D{1,2}|d{1,2}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
    o$1$1;
  function r$2$1(e, t) {
    void 0 === t && (t = "yyyy-MM-DD HH:mm:ss");
    var o = new Date(e);
    if (isNaN(o.getTime())) return o.toString();
    var A = t,
      i = "" + o.getFullYear(),
      r = i.slice(-2),
      n = o.getHours(),
      a = "" + (n % 12 || 12),
      s = "" + (o.getMonth() + 1),
      g = "" + o.getDate(),
      l = "" + o.getDay(),
      E = "" + o.getMinutes(),
      c = "" + o.getSeconds(),
      u = "" + o.getMilliseconds(),
      p = 15 * Math.round(o.getTimezoneOffset() / 15),
      d = Math.abs(p),
      B = n$2$1(Math.floor(d / 60), 2),
      h = n$2$1(d % 60, 2),
      I = p <= 0 ? "+" : "-",
      C = "" + I + B + ":" + h,
      _ = "" + I + B + h,
      f = {
        YY: r,
        YYYY: i,
        yy: r,
        yyyy: i,
        M: s,
        MM: n$2$1(s, 2),
        D: g,
        DD: n$2$1(g, 2),
        d: l,
        dd: n$2$1(g, 2),
        H: "" + n,
        HH: n$2$1(n, 2),
        h: n$2$1(a, 1),
        hh: n$2$1(a, 2),
        a: n < 12 ? "am" : "pm",
        A: n < 12 ? "AM" : "PM",
        m: E,
        mm: n$2$1(E, 2),
        s: c,
        ss: n$2$1(c, 2),
        SSS: n$2$1(u, 3),
        Z: C,
        ZZ: _,
      };
    return A.replace(i$2$1, function (e, t) {
      return t || f[e] || e;
    });
  }
  function v$1$1(e) {
    try {
      return decodeURIComponent(e.replace(/\+/g, " "));
    } catch (e) {
      return null;
    }
  }
  function g$1(e, t) {
    var o = [null, void 0, "", NaN].includes(e);
    if (t.isSkipEmpty && o) return null;
    var A = !t.isSkipEmpty && o ? "" : e;
    try {
      return t.encode ? encodeURIComponent(A) : A;
    } catch (e) {
      return null;
    }
  }
  function h$1$1(e) {
    var t = e.split("#"),
      o = t[0],
      A = t[1],
      i = void 0 === A ? "" : A,
      r = o.split("?"),
      n = r[0],
      a = r[1],
      s = void 0 === a ? "" : a,
      g = v$1$1(i),
      l = Object.create(null);
    return (
      s.split("&").forEach(function (e) {
        var t = e.split("="),
          o = t[0],
          A = t[1],
          i = void 0 === A ? "" : A,
          r = v$1$1(o),
          n = v$1$1(i);
        null === r ||
          null === n ||
          ("" === r && "" === n) ||
          l[r] ||
          (l[r] = n);
      }),
      { url: n, query: l, hash: g }
    );
  }
  function m$1(e, t) {
    void 0 === t && (t = { encode: !0, isSkipEmpty: !1 });
    var o = e.url,
      A = e.query,
      i = void 0 === A ? {} : A,
      r = e.hash,
      n = o.split("#"),
      a = n[0],
      s = n[1],
      g = void 0 === s ? "" : s,
      l = a.split("?")[0],
      E = [],
      c = g$1(r || g, t),
      u = e$1$1(e$1$1({}, h$1$1(o).query), i);
    return (
      Object.keys(u).forEach(function (e) {
        var o = g$1(e, t),
          A = g$1(u[e], t);
        null !== o && null !== A && E.push(o + "=" + A);
      }),
      l + (E.length ? "?" + E.join("&") : "") + (c ? "#" + c : "")
    );
  }
  function y$2(e, t) {
    var o;
    if (!t || !document.querySelectorAll("style[data-tag=" + t + "]").length) {
      var A = document.createElement("style");
      (A.textContent = e.trim()),
        t && (A.dataset.tag = t),
        null === (o = document.getElementsByTagName("head")[0]) ||
          void 0 === o ||
          o.appendChild(A);
    }
  }
  function x$2(e, t) {
    return new Promise(function (o, A) {
      if (t && document.querySelectorAll("script[data-tag=" + t + "]").length)
        return o();
      var i = document.createElement("script"),
        r = e$1$1({ type: "text/javascript", charset: "utf-8" }, e);
      Object.keys(r).forEach(function (e) {
        return S$2(i, e, r[e]);
      }),
        t && (i.dataset.tag = t),
        (i.onload = function () {
          return o();
        }),
        (i.onreadystatechange = function () {
          var e = i.readyState;
          ["complete", "loaded"].includes(e) &&
            ((i.onreadystatechange = null), o());
        }),
        (i.onerror = A),
        document.body.appendChild(i);
    });
  }
  function S$2(e, t, o) {
    if (e) return void 0 === o ? e.getAttribute(t) : e.setAttribute(t, o);
  }
  function M$3(e, t) {
    return (
      !!(null == e ? void 0 : e.className) &&
      -1 !== e.getAttribute("class").split(" ").indexOf(t)
    );
  }
  function q$2(e, t) {
    if (e && !M$3(e, t)) {
      var o = (e.className + " " + t).trim();
      e.setAttribute("class", o);
    }
  }
  function _$2(e, t) {
    if (e) {
      var o = e.className.split(" "),
        A = o.indexOf(t);
      -1 !== A && (o.splice(A, 1), (e.className = o.join(" ")));
    }
  }
  function E$2(e, t, o) {
    if (e && t)
      if ("string" != typeof t || void 0 === o) {
        if ("string" == typeof t && void 0 === o)
          return (e.currentStyle ? e.currentStyle : getComputedStyle(e, null))[
            t
          ];
        "object" == typeof t &&
          Object.keys(t).forEach(function (o) {
            return E$2(e, o, t[o]);
          });
      } else {
        var A =
          /width|height|left|right|top|bottom|padding|margin/i.test(t) &&
          "number" == typeof o;
        e.style[t] = A ? o + "px" : o;
      }
  }
  function O$2(e) {
    E$2(e, { display: "none" });
  }
  function k$2(e, t) {
    void 0 === t && (t = "block"), E$2(e, { display: t });
  }
  function j$2(e, t) {
    if (e) return void 0 === t ? e.innerText : void (e.innerText = t);
  }
  function C$2(e, t) {
    if (e) return void 0 === t ? e.innerHTML : void (e.innerHTML = t);
  }
  !(function (e) {
    (e[(e.equal = 0)] = "equal"),
      (e[(e.low = -1)] = "low"),
      (e[(e.high = 1)] = "high");
  })(o$1$1 || (o$1$1 = {}));
  var A$2 =
    /^v?(?:\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+))?(?:-[\da-z-]+(?:\.[\da-z-]+)*)?(?:\+[\da-z-]+(?:\.[\da-z-]+)*)?)?)?$/i;
  function P$2(e) {
    var t,
      o = e.replace(/^v/, "").replace(/\+.*$/, ""),
      A = ("-", -1 === (t = o).indexOf("-") ? t.length : t.indexOf("-")),
      i = o.substring(0, A).split(".");
    return i.push(o.substring(A + 1)), i;
  }
  function N$2(e) {
    return isNaN(Number(e)) ? e : Number(e);
  }
  function D$2(e) {
    if ("string" != typeof e)
      throw new TypeError("Invalid argument expected string");
    if (!A$2.test(e))
      throw new Error(
        "Invalid argument not valid semver ('" + e + "' received)"
      );
  }
  function T$2(e, t) {
    [e, t].forEach(D$2);
    for (
      var o = P$2(e), A = P$2(t), i = 0;
      i < Math.max(o.length - 1, A.length - 1);
      i++
    ) {
      var r = parseInt(o[i] || "0", 10),
        n = parseInt(A[i] || "0", 10);
      if (r > n) return o$1$1.high;
      if (n > r) return o$1$1.low;
    }
    var a = o[o.length - 1],
      s = A[A.length - 1];
    if (a && s) {
      var g = a.split(".").map(N$2),
        l = s.split(".").map(N$2);
      for (i = 0; i < Math.max(g.length, l.length); i++) {
        if (
          void 0 === g[i] ||
          ("string" == typeof l[i] && "number" == typeof g[i])
        )
          return -1;
        if (
          void 0 === l[i] ||
          ("string" == typeof g[i] && "number" == typeof l[i])
        )
          return 1;
        if (g[i] > l[i]) return o$1$1.high;
        if (l[i] > g[i]) return o$1$1.low;
      }
    } else if (a || s) return a ? o$1$1.low : o$1$1.high;
    return o$1$1.equal;
  }
  var B$2 = /</g,
    I$2 = />/g,
    H$2 = /"/g,
    Q$2 = /'/g,
    R$2 = /&/g;
  function V$2(e) {
    return e
      ? ("" + e)
          .replace(R$2, "&amp;")
          .replace(B$2, "&lt;")
          .replace(I$2, "&gt;")
          .replace(H$2, "&quot;")
          .replace(Q$2, "&#39;")
      : "";
  }
  var commonTool$1 = {
      merge: merge$1,
      supportES6: function () {
        try {
          eval("var foo = (x)=>x+1");
        } catch (e) {
          return !1;
        }
        return !0;
      },
      isObject: function (e) {
        return "object" == typeof e && e.constructor === Object;
      },
      createGUID: function (e) {
        void 0 === e && (e = 32);
        for (var t = e || 32, o = "", A = 1; A <= t; A++) {
          o += Math.floor(16 * Math.random()).toString(16);
        }
        return o;
      },
      xss: V$2,
      removeDiscontinuityTimeRangesFromPlayTime: function (e, t) {
        var o = commonTool$1.findDiscontinuityTimeRangeAtPlaytime(e, t);
        if (o) return o.start;
        var A = e;
        return (
          t.forEach(function (t) {
            t.end < e && (A -= t.end - t.start);
          }),
          A
        );
      },
      findDiscontinuityTimeRangeAtPlaytime: function (e, t) {
        return commonTool$1.mergeTimeRanges(t).find(function (t) {
          return e >= t.start && e <= t.end;
        });
      },
      mergeTimeRanges: function (e) {
        var t = -1,
          o = -1,
          A = [];
        return (
          e.forEach(function (e) {
            var i = e.start,
              r = e.end;
            i <= o || (o >= 0 && A.push({ start: t, end: o }), (t = i)),
              (o = r);
          }),
          t >= 0 && o >= 0 && A.push({ start: t, end: o }),
          A
        );
      },
      compareVersion: T$2,
      formatPlayTime: function (e) {
        var t = e;
        if (
          ("string" == typeof t && (t = parseInt(t, 10)),
          "number" != typeof t || Number.isNaN(t))
        )
          return "00:00";
        var o = function (e) {
            return e < 10 ? "0".concat(e) : e;
          },
          A = Math.floor(t / 3600),
          i = Math.floor((t - 3600 * A) / 60),
          r = Math.floor(t - 3600 * A - 60 * i);
        return 0 === A ? [o(i), o(r)].join(":") : [A, o(i), o(r)].join(":");
      },
      dateFormat: function (e, t) {
        return (
          void 0 === t && (t = Date.now()), r$2$1(t, e || "yyyy-MM-dd hh:mm:ss")
        );
      },
      base64ToArrayBuffer: function (e) {
        for (
          var t = window.atob(e), o = t.length, A = new Uint8Array(o), i = 0;
          i < o;
          i++
        )
          A[i] = t.charCodeAt(i);
        return A;
      },
      isPageHidden: function () {
        var e = ["hidden", "msHidden", "webkitHidden"].find(function (e) {
          return void 0 !== document[e];
        });
        return e ? (document[e] ? 1 : 0) : -1;
      },
      setTimeoutByRAF: function (e, t) {
        var o =
            window.requestAnimationFrame || window.webkitRequestAnimationFrame,
          A = +new Date();
        !(function i() {
          +new Date() - A > t ? e() : o(i);
        })();
      },
      assignApiToPrototype: function (e, t, o) {
        for (
          var A = Object.getPrototypeOf(e),
            i = Object.getOwnPropertyNames(t),
            r = 0,
            n = o.length;
          r < n;
          r++
        ) {
          var a = o[r];
          -1 !== i.indexOf(a) ||
            "function" != typeof A[a] ||
            (t[a] = A[a].bind(e));
        }
      },
    },
    cookieTool$1 = {
      set: function (e, t, o, A, i) {
        var r = { domain: o, path: A };
        return i && (r.expires = i), t$1$1.setCookie(e, t, r), !0;
      },
      get: function (e) {
        return t$1$1.getCookie(e) || "";
      },
      del: t$1$1.clearCookie,
    },
    r$1$1;
  function t$3(e, t, o, A) {
    return new (o || (o = Promise))(function (i, r) {
      function n(e) {
        try {
          s(A.next(e));
        } catch (e) {
          r(e);
        }
      }
      function a(e) {
        try {
          s(A.throw(e));
        } catch (e) {
          r(e);
        }
      }
      function s(e) {
        var t;
        e.done
          ? i(e.value)
          : ((t = e.value),
            t instanceof o
              ? t
              : new o(function (e) {
                  e(t);
                })).then(n, a);
      }
      s((A = A.apply(e, t || [])).next());
    });
  }
  function e$3(e, t) {
    var o,
      A,
      i,
      r,
      n = {
        label: 0,
        sent: function () {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: [],
      };
    return (
      (r = { next: a(0), throw: a(1), return: a(2) }),
      "function" == typeof Symbol &&
        (r[Symbol.iterator] = function () {
          return this;
        }),
      r
    );
    function a(r) {
      return function (a) {
        return (function (r) {
          if (o) throw new TypeError("Generator is already executing.");
          for (; n; )
            try {
              if (
                ((o = 1),
                A &&
                  (i =
                    2 & r[0]
                      ? A.return
                      : r[0]
                      ? A.throw || ((i = A.return) && i.call(A), 0)
                      : A.next) &&
                  !(i = i.call(A, r[1])).done)
              )
                return i;
              switch (((A = 0), i && (r = [2 & r[0], i.value]), r[0])) {
                case 0:
                case 1:
                  i = r;
                  break;
                case 4:
                  return n.label++, { value: r[1], done: !1 };
                case 5:
                  n.label++, (A = r[1]), (r = [0]);
                  continue;
                case 7:
                  (r = n.ops.pop()), n.trys.pop();
                  continue;
                default:
                  if (
                    !(
                      (i = (i = n.trys).length > 0 && i[i.length - 1]) ||
                      (6 !== r[0] && 2 !== r[0])
                    )
                  ) {
                    n = 0;
                    continue;
                  }
                  if (3 === r[0] && (!i || (r[1] > i[0] && r[1] < i[3]))) {
                    n.label = r[1];
                    break;
                  }
                  if (6 === r[0] && n.label < i[1]) {
                    (n.label = i[1]), (i = r);
                    break;
                  }
                  if (i && n.label < i[2]) {
                    (n.label = i[2]), n.ops.push(r);
                    break;
                  }
                  i[2] && n.ops.pop(), n.trys.pop();
                  continue;
              }
              r = t.call(e, n);
            } catch (e) {
              (r = [6, e]), (A = 0);
            } finally {
              o = i = 0;
            }
          if (5 & r[0]) throw r[1];
          return { value: r[0] ? r[1] : void 0, done: !0 };
        })([r, a]);
      };
    }
  }
  function n$1$1(e, t, o) {
    if (o || 2 === arguments.length)
      for (var A, i = 0, r = t.length; i < r; i++)
        (!A && i in t) ||
          (A || (A = Array.prototype.slice.call(t, 0, i)), (A[i] = t[i]));
    return e.concat(A || Array.prototype.slice.call(t));
  }
  !(function (e) {
    (e[(e.sync = 1)] = "sync"), (e[(e.async = 0)] = "async");
  })(r$1$1 || (r$1$1 = {}));
  var i$1$2 = (function () {
      function e() {
        (this._hasPriority = !1), (this._array = []);
      }
      return (
        (e.prototype.insert = function (e, t) {
          if (
            (void 0 === t && (t = !1),
            0 !== e.priority && (this._hasPriority = !0),
            !this._hasPriority)
          )
            return t
              ? (this._array.unshift(e), 0)
              : (this._array.push(e), this._array.length - 1);
          var o = this._array.findIndex(function (o) {
            return o.priority === e.priority ? t : o.priority < e.priority;
          });
          return -1 === o
            ? (this._array.push(e), this._array.length - 1)
            : (this._array.splice(o, 0, e), o);
        }),
        (e.prototype.clone = function () {
          return n$1$1([], this._array, !0);
        }),
        (e.prototype.getListener = function (e) {
          return this._array[e];
        }),
        (e.prototype.getListeners = function () {
          return this._array.map(function (e) {
            return e.listener;
          });
        }),
        (e.prototype.remove = function (e) {
          var t = this._array.findIndex(function (t) {
            return t.listener === e;
          });
          -1 !== t &&
            ((this._array[t].isRemove = !0), this._array.splice(t, 1));
        }),
        (e.prototype.findIdx = function (e) {
          return this._array.findIndex(function (t) {
            return t.listener === e;
          });
        }),
        (e.prototype.size = function () {
          return this._array.length;
        }),
        e
      );
    })(),
    s$1$1 = (function () {
      function e(e) {
        void 0 === e && (e = {}),
          (this._events = Object.create(null)),
          (this._cacheEvents = Object.create(null));
        var t = e.maxListeners,
          o = void 0 === t ? 10 : t,
          A = e.replayType,
          i = void 0 === A ? r$1$1.sync : A,
          r = e.isCache,
          n = void 0 !== r && r;
        (this._isCache = n), (this._replayType = i), (this._maxListeners = o);
      }
      return (
        (e.prototype.setCacheStatus = function (e) {
          this._isCache = e;
        }),
        (e.prototype.setReplayType = function (e) {
          this._replayType = e;
        }),
        (e.prototype.getCacheStatus = function () {
          return this._isCache;
        }),
        (e.prototype.clearCache = function () {
          (this._isCache = !1), (this._cacheEvents = Object.create(null));
        }),
        (e.prototype.setMaxListeners = function (e) {
          return (this._maxListeners = e), this;
        }),
        (e.prototype.getMaxListeners = function () {
          return this._maxListeners;
        }),
        (e.prototype.emit = function (e) {
          for (var t = [], o = 1; o < arguments.length; o++)
            t[o - 1] = arguments[o];
          return this._emit.apply(this, n$1$1([!1, e], t, !1));
        }),
        (e.prototype.asyncEmit = function (e) {
          for (var t = [], o = 1; o < arguments.length; o++)
            t[o - 1] = arguments[o];
          return this._emit.apply(this, n$1$1([!0, e], t, !1));
        }),
        (e.prototype.addListener = function (e, t) {
          return this._addListener(e, { listener: t, priority: 0, isOnce: !1 });
        }),
        (e.prototype.on = function (e, t, o) {
          return (
            void 0 === o && (o = 0),
            this._addListener(e, { listener: t, priority: o, isOnce: !1 })
          );
        }),
        (e.prototype.listeners = function (e) {
          var t = this._events[e];
          return t ? t.getListeners() : [];
        }),
        (e.prototype.prependListener = function (e, t) {
          return this._addListener(
            e,
            { listener: t, priority: 0, isOnce: !1 },
            !0
          );
        }),
        (e.prototype.once = function (e, t, o) {
          return (
            void 0 === o && (o = 0),
            this._addListener(e, { listener: t, priority: o, isOnce: !0 })
          );
        }),
        (e.prototype.removeListener = function (e, t) {
          var o = this._events[e];
          return o ? (o.remove(t), this) : this;
        }),
        (e.prototype.off = function (e, t) {
          return this.removeListener(e, t);
        }),
        (e.prototype.removeAllListeners = function (e) {
          return void 0 === e
            ? ((this._events = Object.create(null)), this)
            : (this._events[e] && delete this._events[e], this);
        }),
        (e.prototype.listenerCount = function (e) {
          var t;
          return (
            (null === (t = this._events[e]) || void 0 === t
              ? void 0
              : t.size()) || 0
          );
        }),
        (e.prototype.eventNames = function () {
          return Object.getOwnPropertyNames(this._events);
        }),
        (e.prototype._emit = function (t, o) {
          var A = this;
          void 0 === t && (t = !1);
          for (var i = [], r = 2; r < arguments.length; r++)
            i[r - 2] = arguments[r];
          var n = [{ type: o, target: this, data: 1 === i.length ? i[0] : i }],
            a = this._events[o],
            s = { stopIndex: -1, onceCount: 0, emitData: n };
          if ((this._addCacheEvent(o, s, t), !a))
            return !!t && Promise.resolve(!1);
          var g = Promise.resolve();
          return (
            a.clone().some(function (o, i) {
              return (
                (o.isOnce || o.isRemove) && (s.onceCount += 1),
                !o.isRemove &&
                  (t
                    ? ((g = g.then(function () {
                        return t$3(A, void 0, void 0, function () {
                          return e$3(this, function (t) {
                            switch (t.label) {
                              case 0:
                                return s.stopIndex >= 0 || o.isRemove
                                  ? [2]
                                  : (o.isOnce && a.remove(o.listener),
                                    [4, o.listener.apply(this, n)]);
                              case 1:
                                return (
                                  t.sent() === e.STOP_IMMEDIATE_PROPAGATION &&
                                    (s.stopIndex = Math.max(
                                      i - s.onceCount,
                                      0
                                    )),
                                  [2]
                                );
                            }
                          });
                        });
                      })),
                      !1)
                    : (o.isOnce && a.remove(o.listener),
                      o.listener.apply(A, n) === e.STOP_IMMEDIATE_PROPAGATION &&
                        ((s.stopIndex = Math.max(i - s.onceCount, 0)), !0)))
              );
            }),
            !t ||
              g.then(function () {
                return !0;
              })
          );
        }),
        (e.prototype._addCacheEvent = function (e, t, o) {
          if (this._isCache) {
            var A = o ? Promise.resolve(t) : t;
            this._cacheEvents[e]
              ? this._cacheEvents[e].push(A)
              : (this._cacheEvents[e] = [A]);
          }
        }),
        (e.prototype._replayCacheEvent = function (t, o, A, i) {
          var r = this,
            n = i || this._cacheEvents[t];
          if (this._isCache && n) {
            var a = o.isOnce ? 1 : 0;
            n.some(function (i, s) {
              return i instanceof Promise
                ? ((n[s] = i.then(function (i) {
                    return t$3(r, void 0, void 0, function () {
                      var r;
                      return e$3(this, function (n) {
                        switch (n.label) {
                          case 0:
                            return i.stopIndex >= 0 && A > i.stopIndex
                              ? [2, i]
                              : [4, o.listener.apply(this, i.emitData)];
                          case 1:
                            return (
                              (r = n.sent()),
                              o.isOnce && this.off(t, o.listener),
                              r === e.STOP_IMMEDIATE_PROPAGATION
                                ? (i.stopIndex = Math.max(A - a, 0))
                                : i.stopIndex >= 0 &&
                                  A <= i.stopIndex &&
                                  (i.stopIndex = i.stopIndex - a + 1),
                              [2, i]
                            );
                        }
                      });
                    });
                  })),
                  o.isOnce)
                : ((i.stopIndex >= 0 && A > i.stopIndex) ||
                    (o.isOnce && r.off(t, o.listener),
                    o.listener.apply(r, i.emitData) ===
                    e.STOP_IMMEDIATE_PROPAGATION
                      ? (i.stopIndex = Math.max(A - a, 0))
                      : i.stopIndex >= 0 &&
                        A <= i.stopIndex &&
                        (i.stopIndex = i.stopIndex - a + 1)),
                  o.isOnce);
            });
          }
        }),
        (e.prototype._addListener = function (e, t, o) {
          var A = this;
          void 0 === o && (o = !1),
            this._events[e] || (this._events[e] = new i$1$2());
          var i = this._events[e].insert(t, o);
          if (
            (this._maxListeners > 0 &&
              this._events[e].size() === this._maxListeners &&
              console.warn(
                "Possible EventEmitter memory leak detected. "
                  .concat(this._events[e].size(), " ")
                  .concat(String(e), " listeners ") +
                  "added. Use emitter.setMaxListeners() to increase limit"
              ),
            this._replayType === r$1$1.async)
          ) {
            var r = this._cacheEvents[e]
              ? n$1$1([], this._cacheEvents[e], !0)
              : null;
            if (!r) return this;
            setTimeout(function () {
              var o = A._events[e].findIdx(t.listener);
              -1 !== o && A._replayCacheEvent(e, t, o, r);
            });
          } else this._replayCacheEvent(e, t, i);
          return this;
        }),
        (e.STOP_IMMEDIATE_PROPAGATION =
          "EventEmitter.STOP_IMMEDIATE_PROPAGATION"),
        e
      );
    })();
  function logMethodCallDecoratorCreator(e) {
    void 0 === e && (e = "");
    return function (t, o, A) {
      var i = A.value;
      A.value = function () {
        for (var t = [], A = 0; A < arguments.length; A++) t[A] = arguments[A];
        var r = this._logger || this.logger;
        return (
          "function" == typeof (null == r ? void 0 : r.log) &&
            r.log.apply(
              r,
              __spreadArray(
                __spreadArray(["@".concat(e, ".").concat(o, "(")], t, !1),
                [")"],
                !1
              )
            ),
          i.apply(this, t)
        );
      };
    };
  }
  var costTimeEmitter = new s$1$1();
  function performanceCostDecoratorCreator(e) {
    void 0 === e && (e = "");
    return function (t, o, A) {
      var i = A.value;
      A.value = function () {
        for (var t, A = [], r = 0; r < arguments.length; r++)
          A[r] = arguments[r];
        var n =
          (null === (t = this.config) || void 0 === t
            ? void 0
            : t.instanceId) ||
          this.playerInstanceId ||
          this.instanceId;
        if (!n) return i.apply(this, A);
        var a = performance.now(),
          s = i.apply(this, A),
          g = performance.now();
        return (
          costTimeEmitter.emit("done", {
            instanceId: n,
            methodName: "".concat(e, "::").concat(o),
            time: g - a,
          }),
          s
        );
      };
    };
  }
  function destroyProtectDecorator(e, t, o) {
    var A = o.value;
    o.value = function () {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      var o = this._destroyed || this.destroyed;
      if (!o) return A.apply(this, e);
    };
  }
  var SimpleDefer$1 = function () {
      var e = this;
      (this.state = "pending"),
        (this.promise = new Promise(function (t, o) {
          (e.resolve = function (o) {
            (e.state = "fulfilled"), t(o);
          }),
            (e.reject = function (t) {
              (e.state = "rejected"), o(t);
            });
        }));
    },
    TimeoutDefer$1 = (function (e) {
      function t(t) {
        var o = e.call(this) || this;
        return (
          t.timeoutMS > 0 &&
            setTimeout(function () {
              return o.reject();
            }, t.timeoutMS),
          o
        );
      }
      return __extends$1(t, e), t;
    })(SimpleDefer$1),
    domTool$1 = {
      insertStyle: y$2,
      loadScript: function (e, t, o, A) {
        var i = new TimeoutDefer$1({ timeoutMS: o });
        return (
          x$2(__assign$1(__assign$1({}, A), { src: e }), t)
            .then(i.resolve)
            .catch(i.reject),
          i.promise
        );
      },
      attr: S$2,
      removeAttr: function (e, t) {
        e && t && ("src" === t ? delete e.src : e.removeAttribute(t));
      },
      css: E$2,
      append: function (e, t) {
        e && e.appendChild(t);
      },
      prepend: function (e, t) {
        e.children[0] ? e.insertBefore(t, e.children[0]) : e.appendChild(t);
      },
      addClass: q$2,
      removeClass: _$2,
      hasClass: M$3,
      hide: O$2,
      show: k$2,
      text: j$2,
      html: C$2,
      creatDom: function (e) {
        return this.createDom(e);
      },
      createDom: function (e) {
        var t = document.createElement("div");
        return (t.innerHTML = e), t.firstChild;
      },
      getDomSize: function (e) {
        if (!e) return { width: 0, height: 0 };
        var t = e.currentStyle
          ? e.currentStyle
          : window.getComputedStyle(e, null);
        return { width: parseFloat(t.width), height: parseFloat(t.height) };
      },
      createVideoDom: function (e) {
        var t = e || {},
          o = t.attrOpts,
          A = void 0 === o ? {} : o,
          i = t.cssOpts,
          r = void 0 === i ? {} : i,
          n = document.createElement("video");
        return (
          Object.keys(A).forEach(function (e) {
            n.setAttribute(e, A[e]);
          }),
          E$2(n, r),
          n
        );
      },
      getElementFromConfig: function (e) {
        return "string" == typeof e ? document.querySelector(e) : e;
      },
    },
    masks = {};
  function setMask(e, t) {
    masks[e] = t;
  }
  var Base64 = (function () {
      function e() {}
      return (
        (e.fromUint8Array = function (e, t) {
          void 0 === t && (t = { urlSafe: !1, padding: !0 });
          for (
            var o = t.urlSafe,
              A = void 0 !== o && o,
              i = t.padding,
              r = void 0 === i || i ? "=" : "",
              n = "",
              a = new Uint8Array(e),
              s = a.byteLength,
              g = 0;
            g < s;
            g++
          )
            n += String.fromCharCode(a[g]);
          return (
            (n = btoa(n).replace(/=/g, r)),
            A ? n.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "") : n
          );
        }),
        (e.toUint8Array = function (e, t) {
          var o = e.replace(/=/g, "").replace(/-/g, "+").replace(/_/g, "/");
          if (t && masks[t]) {
            var A = masks[t].split(""),
              i = o.split("");
            o = i
              .map(function (e, t) {
                return String.fromCharCode(
                  e.charCodeAt(0) ^ A[t].charCodeAt(0)
                );
              })
              .join("");
          }
          var r = atob(o);
          return new Uint8Array(r.length).map(function (e, t) {
            return r.charCodeAt(t);
          });
        }),
        (e.fromUTF8 = function (t, o) {
          return (
            void 0 === o && (o = { urlSafe: !1, padding: !0 }),
            e.fromUint8Array(UTF8.toUint8Array(t), o)
          );
        }),
        (e.toUTF8 = function (t) {
          return UTF8.fromUint8Array(e.toUint8Array(t));
        }),
        e
      );
    })(),
    Hex = (function () {
      function e() {}
      return (
        (e.encode = function (e) {
          for (
            var t = "0123456789abcdef", o = "", A = 0;
            A < e.length;
            A += 1
          ) {
            var i = e.charCodeAt(A);
            o += t.charAt((i >>> 4) & 15) + t.charAt(15 & i);
          }
          return o;
        }),
        (e.toUint8Array = function (e) {
          var t = [],
            o = e;
          if (!o) return t;
          if (o.length % 2 != 0) return t;
          for (; o.length >= 2; )
            t.push(parseInt(o.substring(0, 2), 16)),
              (o = o.substring(2, o.length));
          return new Uint8Array(t);
        }),
        (e.fromUint8Array = function (e) {
          return Array.from(new Uint8Array(e))
            .map(function (e) {
              return e.toString(16).padStart(2, "0");
            })
            .join("");
        }),
        e
      );
    })(),
    UTF16 = (function () {
      function e() {}
      return (
        (e.toUint16Array = function (e) {
          for (var t = new Uint16Array(e.length), o = 0; o < e.length; o++)
            t[o] = e.charCodeAt(o);
          return t;
        }),
        (e.fromUint16Array = function (e) {
          return String.fromCharCode.apply(null, new Uint16Array(e));
        }),
        (e.fromTypeArray = function (e) {
          return String.fromCharCode.apply(null, new Uint16Array(e.buffer));
        }),
        e
      );
    })(),
    UTF8 = (function () {
      function e() {}
      return (
        (e.toUint8Array = function (e) {
          for (var t = [], o = 0; o < e.length; o += 1) {
            var A = e.charCodeAt(o);
            A < 128
              ? t.push(A)
              : A < 2048
              ? t.push(192 | (A >> 6), 128 | (63 & A))
              : A < 55296 || A >= 57344
              ? t.push(224 | (A >> 12), 128 | ((A >> 6) & 63), 128 | (63 & A))
              : ((o += 1),
                (A = 65536 + (((1023 & A) << 10) | (1023 & e.charCodeAt(o)))),
                t.push(
                  240 | (A >> 18),
                  128 | ((A >> 12) & 63),
                  128 | ((A >> 6) & 63),
                  128 | (63 & A)
                ));
          }
          return new Uint8Array(t);
        }),
        (e.fromUint8Array = function (e) {
          for (
            var t = new Uint8Array(e), o = t.byteLength, A = "", i = 0;
            i < o;

          ) {
            var r = t[i++];
            if (0 == (128 & r)) A += String.fromCharCode(r);
            else if (192 == (224 & r))
              A += String.fromCharCode(((31 & r) << 6) | (63 & t[i++]));
            else if (224 == (240 & r))
              A += String.fromCharCode(
                ((15 & r) << 12) | ((63 & t[i++]) << 6) | (63 & t[i++])
              );
            else {
              var n =
                ((7 & r) << 18) |
                ((63 & t[i++]) << 12) |
                ((63 & t[i++]) << 6) |
                (63 & t[i++]);
              A += String.fromCharCode(
                55296 | ((n - 65536) >> 10),
                56320 | ((n - 65536) & 1023)
              );
            }
          }
          return A;
        }),
        e
      );
    })(),
    encodingTool = {
      base64: Base64,
      utf8: UTF8,
      utf16: UTF16,
      hex: Hex,
      setMask: setMask,
    };
  function getEventEmitterBinder(e, t) {
    return t ? e.on.bind(e) : e.off.bind(e);
  }
  function getEventTargetBinder(e, t) {
    return t ? e.addEventListener.bind(e) : e.removeEventListener.bind(e);
  }
  var EXTRA = [128, 32768, 8388608, -2147483648],
    HEX_CHARS = "0123456789abcdef".split(""),
    MD5 = (function () {
      function e() {
        var e = new ArrayBuffer(68);
        (this.buffer8 = new Uint8Array(e)),
          (this.blocks = new Uint32Array(e)),
          (this.h0 = 0),
          (this.h1 = 0),
          (this.h2 = 0),
          (this.h3 = 0),
          (this.start = 0),
          (this.bytes = 0),
          (this.hBytes = 0),
          (this.finalized = !1),
          (this.hashed = !1),
          (this.first = !0);
      }
      return (
        (e.prototype.update = function (e) {
          if (!this.finalized) {
            for (
              var t = 0,
                o = 0,
                A = 0,
                i = e.length,
                r = this.blocks,
                n = this.buffer8;
              o < i;

            ) {
              if (this.hashed) {
                this.hashed = !1;
                for (var a = 0; a <= 16; a += 1) r[a] = 0;
              }
              for (A = this.start; o < i && A < 64; ++o)
                (t = e.charCodeAt(o)) < 128
                  ? (n[A++] = t)
                  : t < 2048
                  ? ((n[A++] = 192 | (t >> 6)), (n[A++] = 128 | (63 & t)))
                  : t < 55296 || t >= 57344
                  ? ((n[A++] = 224 | (t >> 12)),
                    (n[A++] = 128 | ((t >> 6) & 63)),
                    (n[A++] = 128 | (63 & t)))
                  : ((t =
                      65536 +
                      (((1023 & t) << 10) | (1023 & e.charCodeAt(++o)))),
                    (n[A++] = 240 | (t >> 18)),
                    (n[A++] = 128 | ((t >> 12) & 63)),
                    (n[A++] = 128 | ((t >> 6) & 63)),
                    (n[A++] = 128 | (63 & t)));
              (this.lastByteIndex = A),
                (this.bytes += A - this.start),
                A >= 64
                  ? ((this.start = A - 64), this.hash(), (this.hashed = !0))
                  : (this.start = A);
            }
            return (
              this.bytes > 4294967295 &&
                ((this.hBytes += (this.bytes / 4294967296) << 0),
                (this.bytes = this.bytes % 4294967296)),
              this
            );
          }
        }),
        (e.prototype.finalize = function () {
          if (!this.finalized) {
            this.finalized = !0;
            var e = this.blocks,
              t = this.lastByteIndex;
            (e[t >> 2] |= EXTRA[3 & t]),
              t >= 56 &&
                (this.hashed || this.hash(),
                (e[0] = e[16]),
                (e[16] =
                  e[1] =
                  e[2] =
                  e[3] =
                  e[4] =
                  e[5] =
                  e[6] =
                  e[7] =
                  e[8] =
                  e[9] =
                  e[10] =
                  e[11] =
                  e[12] =
                  e[13] =
                  e[14] =
                  e[15] =
                    0)),
              (e[14] = this.bytes << 3),
              (e[15] = (this.hBytes << 3) | (this.bytes >>> 29)),
              this.hash();
          }
        }),
        (e.prototype.output = function () {
          this.finalize();
          var e = this.h0,
            t = this.h1,
            o = this.h2,
            A = this.h3;
          return (
            HEX_CHARS[(e >> 4) & 15] +
            HEX_CHARS[15 & e] +
            HEX_CHARS[(e >> 12) & 15] +
            HEX_CHARS[(e >> 8) & 15] +
            HEX_CHARS[(e >> 20) & 15] +
            HEX_CHARS[(e >> 16) & 15] +
            HEX_CHARS[(e >> 28) & 15] +
            HEX_CHARS[(e >> 24) & 15] +
            HEX_CHARS[(t >> 4) & 15] +
            HEX_CHARS[15 & t] +
            HEX_CHARS[(t >> 12) & 15] +
            HEX_CHARS[(t >> 8) & 15] +
            HEX_CHARS[(t >> 20) & 15] +
            HEX_CHARS[(t >> 16) & 15] +
            HEX_CHARS[(t >> 28) & 15] +
            HEX_CHARS[(t >> 24) & 15] +
            HEX_CHARS[(o >> 4) & 15] +
            HEX_CHARS[15 & o] +
            HEX_CHARS[(o >> 12) & 15] +
            HEX_CHARS[(o >> 8) & 15] +
            HEX_CHARS[(o >> 20) & 15] +
            HEX_CHARS[(o >> 16) & 15] +
            HEX_CHARS[(o >> 28) & 15] +
            HEX_CHARS[(o >> 24) & 15] +
            HEX_CHARS[(A >> 4) & 15] +
            HEX_CHARS[15 & A] +
            HEX_CHARS[(A >> 12) & 15] +
            HEX_CHARS[(A >> 8) & 15] +
            HEX_CHARS[(A >> 20) & 15] +
            HEX_CHARS[(A >> 16) & 15] +
            HEX_CHARS[(A >> 28) & 15] +
            HEX_CHARS[(A >> 24) & 15]
          );
        }),
        (e.prototype.hash = function () {
          var e,
            t,
            o,
            A,
            i,
            r,
            n = this.blocks;
          this.first
            ? (t =
                ((((t =
                  ((e =
                    ((((e = n[0] - 680876937) << 7) | (e >>> 25)) -
                      271733879) <<
                    0) ^
                    ((o =
                      ((((o =
                        (-271733879 ^
                          ((A =
                            ((((A =
                              (-1732584194 ^ (2004318071 & e)) +
                              n[1] -
                              117830708) <<
                              12) |
                              (A >>> 20)) +
                              e) <<
                            0) &
                            (-271733879 ^ e))) +
                        n[2] -
                        1126478375) <<
                        17) |
                        (o >>> 15)) +
                        A) <<
                      0) &
                      (A ^ e))) +
                  n[3] -
                  1316259209) <<
                  22) |
                  (t >>> 10)) +
                  o) <<
                0)
            : ((e = this.h0),
              (t = this.h1),
              (o = this.h2),
              (t =
                ((((t +=
                  ((e =
                    ((((e +=
                      ((A = this.h3) ^ (t & (o ^ A))) + n[0] - 680876936) <<
                      7) |
                      (e >>> 25)) +
                      t) <<
                    0) ^
                    ((o =
                      ((((o +=
                        (t ^
                          ((A =
                            ((((A += (o ^ (e & (t ^ o))) + n[1] - 389564586) <<
                              12) |
                              (A >>> 20)) +
                              e) <<
                            0) &
                            (e ^ t))) +
                        n[2] +
                        606105819) <<
                        17) |
                        (o >>> 15)) +
                        A) <<
                      0) &
                      (A ^ e))) +
                  n[3] -
                  1044525330) <<
                  22) |
                  (t >>> 10)) +
                  o) <<
                0)),
            (t =
              ((((t +=
                ((e =
                  ((((e += (A ^ (t & (o ^ A))) + n[4] - 176418897) << 7) |
                    (e >>> 25)) +
                    t) <<
                  0) ^
                  ((o =
                    ((((o +=
                      (t ^
                        ((A =
                          ((((A += (o ^ (e & (t ^ o))) + n[5] + 1200080426) <<
                            12) |
                            (A >>> 20)) +
                            e) <<
                          0) &
                          (e ^ t))) +
                      n[6] -
                      1473231341) <<
                      17) |
                      (o >>> 15)) +
                      A) <<
                    0) &
                    (A ^ e))) +
                n[7] -
                45705983) <<
                22) |
                (t >>> 10)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((e =
                  ((((e += (A ^ (t & (o ^ A))) + n[8] + 1770035416) << 7) |
                    (e >>> 25)) +
                    t) <<
                  0) ^
                  ((o =
                    ((((o +=
                      (t ^
                        ((A =
                          ((((A += (o ^ (e & (t ^ o))) + n[9] - 1958414417) <<
                            12) |
                            (A >>> 20)) +
                            e) <<
                          0) &
                          (e ^ t))) +
                      n[10] -
                      42063) <<
                      17) |
                      (o >>> 15)) +
                      A) <<
                    0) &
                    (A ^ e))) +
                n[11] -
                1990404162) <<
                22) |
                (t >>> 10)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((e =
                  ((((e += (A ^ (t & (o ^ A))) + n[12] + 1804603682) << 7) |
                    (e >>> 25)) +
                    t) <<
                  0) ^
                  ((o =
                    ((((o +=
                      (t ^
                        ((A =
                          ((((A += (o ^ (e & (t ^ o))) + n[13] - 40341101) <<
                            12) |
                            (A >>> 20)) +
                            e) <<
                          0) &
                          (e ^ t))) +
                      n[14] -
                      1502002290) <<
                      17) |
                      (o >>> 15)) +
                      A) <<
                    0) &
                    (A ^ e))) +
                n[15] +
                1236535329) <<
                22) |
                (t >>> 10)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((A =
                  ((((A +=
                    (t ^
                      (o &
                        ((e =
                          ((((e += (o ^ (A & (t ^ o))) + n[1] - 165796510) <<
                            5) |
                            (e >>> 27)) +
                            t) <<
                          0) ^
                          t))) +
                    n[6] -
                    1069501632) <<
                    9) |
                    (A >>> 23)) +
                    e) <<
                  0) ^
                  (e &
                    ((o =
                      ((((o += (e ^ (t & (A ^ e))) + n[11] + 643717713) << 14) |
                        (o >>> 18)) +
                        A) <<
                      0) ^
                      A))) +
                n[0] -
                373897302) <<
                20) |
                (t >>> 12)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((A =
                  ((((A +=
                    (t ^
                      (o &
                        ((e =
                          ((((e += (o ^ (A & (t ^ o))) + n[5] - 701558691) <<
                            5) |
                            (e >>> 27)) +
                            t) <<
                          0) ^
                          t))) +
                    n[10] +
                    38016083) <<
                    9) |
                    (A >>> 23)) +
                    e) <<
                  0) ^
                  (e &
                    ((o =
                      ((((o += (e ^ (t & (A ^ e))) + n[15] - 660478335) << 14) |
                        (o >>> 18)) +
                        A) <<
                      0) ^
                      A))) +
                n[4] -
                405537848) <<
                20) |
                (t >>> 12)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((A =
                  ((((A +=
                    (t ^
                      (o &
                        ((e =
                          ((((e += (o ^ (A & (t ^ o))) + n[9] + 568446438) <<
                            5) |
                            (e >>> 27)) +
                            t) <<
                          0) ^
                          t))) +
                    n[14] -
                    1019803690) <<
                    9) |
                    (A >>> 23)) +
                    e) <<
                  0) ^
                  (e &
                    ((o =
                      ((((o += (e ^ (t & (A ^ e))) + n[3] - 187363961) << 14) |
                        (o >>> 18)) +
                        A) <<
                      0) ^
                      A))) +
                n[8] +
                1163531501) <<
                20) |
                (t >>> 12)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((A =
                  ((((A +=
                    (t ^
                      (o &
                        ((e =
                          ((((e += (o ^ (A & (t ^ o))) + n[13] - 1444681467) <<
                            5) |
                            (e >>> 27)) +
                            t) <<
                          0) ^
                          t))) +
                    n[2] -
                    51403784) <<
                    9) |
                    (A >>> 23)) +
                    e) <<
                  0) ^
                  (e &
                    ((o =
                      ((((o += (e ^ (t & (A ^ e))) + n[7] + 1735328473) << 14) |
                        (o >>> 18)) +
                        A) <<
                      0) ^
                      A))) +
                n[12] -
                1926607734) <<
                20) |
                (t >>> 12)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((r =
                  (A =
                    ((((A +=
                      ((i = t ^ o) ^
                        (e =
                          ((((e += (i ^ A) + n[5] - 378558) << 4) |
                            (e >>> 28)) +
                            t) <<
                          0)) +
                      n[8] -
                      2022574463) <<
                      11) |
                      (A >>> 21)) +
                      e) <<
                    0) ^ e) ^
                  (o =
                    ((((o += (r ^ t) + n[11] + 1839030562) << 16) |
                      (o >>> 16)) +
                      A) <<
                    0)) +
                n[14] -
                35309556) <<
                23) |
                (t >>> 9)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((r =
                  (A =
                    ((((A +=
                      ((i = t ^ o) ^
                        (e =
                          ((((e += (i ^ A) + n[1] - 1530992060) << 4) |
                            (e >>> 28)) +
                            t) <<
                          0)) +
                      n[4] +
                      1272893353) <<
                      11) |
                      (A >>> 21)) +
                      e) <<
                    0) ^ e) ^
                  (o =
                    ((((o += (r ^ t) + n[7] - 155497632) << 16) | (o >>> 16)) +
                      A) <<
                    0)) +
                n[10] -
                1094730640) <<
                23) |
                (t >>> 9)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((r =
                  (A =
                    ((((A +=
                      ((i = t ^ o) ^
                        (e =
                          ((((e += (i ^ A) + n[13] + 681279174) << 4) |
                            (e >>> 28)) +
                            t) <<
                          0)) +
                      n[0] -
                      358537222) <<
                      11) |
                      (A >>> 21)) +
                      e) <<
                    0) ^ e) ^
                  (o =
                    ((((o += (r ^ t) + n[3] - 722521979) << 16) | (o >>> 16)) +
                      A) <<
                    0)) +
                n[6] +
                76029189) <<
                23) |
                (t >>> 9)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((r =
                  (A =
                    ((((A +=
                      ((i = t ^ o) ^
                        (e =
                          ((((e += (i ^ A) + n[9] - 640364487) << 4) |
                            (e >>> 28)) +
                            t) <<
                          0)) +
                      n[12] -
                      421815835) <<
                      11) |
                      (A >>> 21)) +
                      e) <<
                    0) ^ e) ^
                  (o =
                    ((((o += (r ^ t) + n[15] + 530742520) << 16) | (o >>> 16)) +
                      A) <<
                    0)) +
                n[2] -
                995338651) <<
                23) |
                (t >>> 9)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((A =
                  ((((A +=
                    (t ^
                      ((e =
                        ((((e += (o ^ (t | ~A)) + n[0] - 198630844) << 6) |
                          (e >>> 26)) +
                          t) <<
                        0) |
                        ~o)) +
                    n[7] +
                    1126891415) <<
                    10) |
                    (A >>> 22)) +
                    e) <<
                  0) ^
                  ((o =
                    ((((o += (e ^ (A | ~t)) + n[14] - 1416354905) << 15) |
                      (o >>> 17)) +
                      A) <<
                    0) |
                    ~e)) +
                n[5] -
                57434055) <<
                21) |
                (t >>> 11)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((A =
                  ((((A +=
                    (t ^
                      ((e =
                        ((((e += (o ^ (t | ~A)) + n[12] + 1700485571) << 6) |
                          (e >>> 26)) +
                          t) <<
                        0) |
                        ~o)) +
                    n[3] -
                    1894986606) <<
                    10) |
                    (A >>> 22)) +
                    e) <<
                  0) ^
                  ((o =
                    ((((o += (e ^ (A | ~t)) + n[10] - 1051523) << 15) |
                      (o >>> 17)) +
                      A) <<
                    0) |
                    ~e)) +
                n[1] -
                2054922799) <<
                21) |
                (t >>> 11)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((A =
                  ((((A +=
                    (t ^
                      ((e =
                        ((((e += (o ^ (t | ~A)) + n[8] + 1873313359) << 6) |
                          (e >>> 26)) +
                          t) <<
                        0) |
                        ~o)) +
                    n[15] -
                    30611744) <<
                    10) |
                    (A >>> 22)) +
                    e) <<
                  0) ^
                  ((o =
                    ((((o += (e ^ (A | ~t)) + n[6] - 1560198380) << 15) |
                      (o >>> 17)) +
                      A) <<
                    0) |
                    ~e)) +
                n[13] +
                1309151649) <<
                21) |
                (t >>> 11)) +
                o) <<
              0),
            (t =
              ((((t +=
                ((A =
                  ((((A +=
                    (t ^
                      ((e =
                        ((((e += (o ^ (t | ~A)) + n[4] - 145523070) << 6) |
                          (e >>> 26)) +
                          t) <<
                        0) |
                        ~o)) +
                    n[11] -
                    1120210379) <<
                    10) |
                    (A >>> 22)) +
                    e) <<
                  0) ^
                  ((o =
                    ((((o += (e ^ (A | ~t)) + n[2] + 718787259) << 15) |
                      (o >>> 17)) +
                      A) <<
                    0) |
                    ~e)) +
                n[9] -
                343485551) <<
                21) |
                (t >>> 11)) +
                o) <<
              0),
            this.first
              ? ((this.h0 = (e + 1732584193) << 0),
                (this.h1 = (t - 271733879) << 0),
                (this.h2 = (o - 1732584194) << 0),
                (this.h3 = (A + 271733878) << 0),
                (this.first = !1))
              : ((this.h0 = (this.h0 + e) << 0),
                (this.h1 = (this.h1 + t) << 0),
                (this.h2 = (this.h2 + o) << 0),
                (this.h3 = (this.h3 + A) << 0));
        }),
        e
      );
    })(),
    hashTool = {
      md5: function (e) {
        return new MD5().update(e).output();
      },
    },
    jsonTool$1 = {
      safelyStringify: function (e, t, o) {
        try {
          return JSON.stringify(e, t, o);
        } catch (e) {
          return "{}";
        }
      },
    },
    lsTool = {
      getData: function (e) {
        var t = "";
        try {
          window.localStorage && (t = window.localStorage[e]);
        } catch (e) {
          window.console.log(e);
        }
        return t;
      },
      setData: function (e, t) {
        if ("undefined" !== e && void 0 !== e)
          try {
            window.localStorage && (window.localStorage[e] = t);
          } catch (e) {
            window.console.log(e);
          }
      },
      delData: function (e) {
        try {
          window.localStorage && window.localStorage.removeItem(e);
        } catch (e) {
          window.console.log(e);
        }
      },
    };
  function requireModule(e, t) {
    var o;
    return __awaiter$1(this, void 0, void 0, function () {
      var A;
      return __generator$1(this, function (i) {
        A = self;
        try {
          if (
            "object" ==
            typeof (null === (o = A.module) || void 0 === o ? void 0 : o.export)
          )
            return [2, A.module.export[e]];
          if (
            "function" == typeof A.define &&
            A.define.amd &&
            "function" == typeof A.require
          )
            return [
              2,
              new Promise(function (t) {
                A.require([e], function (e) {
                  t(e);
                });
              }),
            ];
        } catch (e) {}
        return [2, A[t || e]];
      });
    });
  }
  function mountGlobal(e) {
    var t = e.globalName,
      o = e.target,
      A = e.onDuplicate;
    window[t] && window[t] !== o
      ? null == A || A(window[t])
      : Object.defineProperty(window, t, {
          configurable: !0,
          enumerable: !0,
          get: function () {
            return o;
          },
          set: function (e) {
            e && e !== o
              ? null == A || A(window[t])
              : (delete window[t], (window[t] = e));
          },
        });
  }
  var r$3 = function () {
    return (r$3 =
      Object.assign ||
      function (e) {
        for (var t, o = 1, A = arguments.length; o < A; o++)
          for (var i in (t = arguments[o]))
            Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e;
      }).apply(this, arguments);
  };
  function n$3(e, t, o, A) {
    return new (o || (o = Promise))(function (i, r) {
      function n(e) {
        try {
          s(A.next(e));
        } catch (e) {
          r(e);
        }
      }
      function a(e) {
        try {
          s(A.throw(e));
        } catch (e) {
          r(e);
        }
      }
      function s(e) {
        var t;
        e.done
          ? i(e.value)
          : ((t = e.value),
            t instanceof o
              ? t
              : new o(function (e) {
                  e(t);
                })).then(n, a);
      }
      s((A = A.apply(e, t || [])).next());
    });
  }
  function o$2(e, t) {
    var o,
      A,
      i,
      r,
      n = {
        label: 0,
        sent: function () {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: [],
      };
    return (
      (r = { next: a(0), throw: a(1), return: a(2) }),
      "function" == typeof Symbol &&
        (r[Symbol.iterator] = function () {
          return this;
        }),
      r
    );
    function a(r) {
      return function (a) {
        return (function (r) {
          if (o) throw new TypeError("Generator is already executing.");
          for (; n; )
            try {
              if (
                ((o = 1),
                A &&
                  (i =
                    2 & r[0]
                      ? A.return
                      : r[0]
                      ? A.throw || ((i = A.return) && i.call(A), 0)
                      : A.next) &&
                  !(i = i.call(A, r[1])).done)
              )
                return i;
              switch (((A = 0), i && (r = [2 & r[0], i.value]), r[0])) {
                case 0:
                case 1:
                  i = r;
                  break;
                case 4:
                  return n.label++, { value: r[1], done: !1 };
                case 5:
                  n.label++, (A = r[1]), (r = [0]);
                  continue;
                case 7:
                  (r = n.ops.pop()), n.trys.pop();
                  continue;
                default:
                  if (
                    !(
                      (i = (i = n.trys).length > 0 && i[i.length - 1]) ||
                      (6 !== r[0] && 2 !== r[0])
                    )
                  ) {
                    n = 0;
                    continue;
                  }
                  if (3 === r[0] && (!i || (r[1] > i[0] && r[1] < i[3]))) {
                    n.label = r[1];
                    break;
                  }
                  if (6 === r[0] && n.label < i[1]) {
                    (n.label = i[1]), (i = r);
                    break;
                  }
                  if (i && n.label < i[2]) {
                    (n.label = i[2]), n.ops.push(r);
                    break;
                  }
                  i[2] && n.ops.pop(), n.trys.pop();
                  continue;
              }
              r = t.call(e, n);
            } catch (e) {
              (r = [6, e]), (A = 0);
            } finally {
              o = i = 0;
            }
          if (5 & r[0]) throw r[1];
          return { value: r[0] ? r[1] : void 0, done: !0 };
        })([r, a]);
      };
    }
  }
  var i$4 = (function () {
      function e() {
        this.interceptors = [];
      }
      return (
        (e.prototype.use = function (e, t) {
          return (
            this.interceptors.push({ resolved: e, rejected: t }),
            this.interceptors.length - 1
          );
        }),
        (e.prototype.traverse = function (e, t) {
          void 0 === t && (t = !1);
          var o = Promise.resolve(e);
          return (
            (t ? Array.prototype.reduceRight : Array.prototype.reduce).call(
              this.interceptors,
              function (e, t) {
                if (t) {
                  var A = t.resolved,
                    i = t.rejected;
                  o = o.then(A, i);
                }
                return e;
              },
              ""
            ),
            o
          );
        }),
        (e.prototype.eject = function (e) {
          this.interceptors[e] && (this.interceptors[e] = null);
        }),
        e
      );
    })(),
    c$1 = {
      defaults: {
        timeout: 0,
        method: "GET",
        mode: "cors",
        redirect: "follow",
        credentials: "same-origin",
      },
      headers: {
        common: { Accept: "application/json, text/plain, */*" },
        POST: { "Content-Type": "application/x-www-form-urlencoded" },
        PUT: { "Content-Type": "application/x-www-form-urlencoded" },
        PATCH: { "Content-Type": "application/x-www-form-urlencoded" },
      },
      baseURL: "",
      polyfillUrl: "https://vm.gtimg.cn/comps/script/fetch.min.js",
      interceptors: { request: new i$4(), response: new i$4() },
    },
    u$1 = /^([a-z][a-z\d+\-.]*:)?\/\//i,
    a$f = Object.prototype.toString;
  function s$2(e) {
    return n$3(this, void 0, void 0, function () {
      var t;
      return o$2(this, function (o) {
        switch (o.label) {
          case 0:
            if (window.fetch) return [2];
            o.label = 1;
          case 1:
            return o.trys.push([1, 3, , 4]), [4, x$2({ src: e })];
          case 2:
            return o.sent(), [3, 4];
          case 3:
            throw (
              ((t = o.sent()),
              new Error("鍔犺浇 polyfill " + e + " 澶辫触: " + t.message))
            );
          case 4:
            return [2];
        }
      });
    });
  }
  function l$1(e) {
    return (
      ["Accept", "Content-Type"].forEach(function (t) {
        return (
          (o = t),
          void (
            (A = e.headers) &&
            Object.keys(A).forEach(function (e) {
              e !== o &&
                e.toUpperCase() === o.toUpperCase() &&
                ((A[o] = A[e]), delete A[e]);
            })
          )
        );
        var o, A;
      }),
      (function (e) {
        if ("[object Object]" !== a$f.call(e)) return !1;
        var t = Object.getPrototypeOf(e);
        return null === t || t === Object.prototype;
      })(e.body) &&
        ((e.body = JSON.stringify(e.body)),
        e.headers &&
          (e.headers["Content-Type"] = "application/json;charset=utf-8")),
      e
    );
  }
  var f$1 = function () {},
    d$1 = 1;
  function h$2(e, t) {
    return (
      void 0 === t && (t = {}),
      new Promise(function (o, A) {
        var i,
          r = t.name,
          n = t.query,
          a = void 0 === n ? {} : n,
          s = t.param,
          g = void 0 === s ? "callback" : s,
          l = t.timeout,
          E = void 0 === l ? 6e4 : l,
          c = t.prefix,
          u = void 0 === c ? "jsonp_" : c,
          p = t.controller,
          d = t.charset,
          B = t.targetWindow,
          h = r || "" + u + d$1++,
          I = B || window,
          C = document.createElement("script"),
          _ = E
            ? setTimeout(function () {
                f(!0), A(new Error("jsonp timeout"));
              }, E)
            : null,
          f = function (e) {
            var t;
            void 0 === e && (e = !1),
              null === (t = C.parentNode) || void 0 === t || t.removeChild(C),
              _ && clearTimeout(_),
              p && (p.element = null),
              (I[h] = e ? f$1 : null);
          },
          y = m$1({
            url: e,
            query: r$3(r$3({}, a), ((i = {}), (i[g] = h), i)),
          });
        (C.src = y),
          d && (C.charset = d),
          p && (p.element = C),
          (C.onerror = function (e) {
            f(), A(e);
          }),
          (I[h] = function (e) {
            f(), o(e);
          }),
          document.body.appendChild(C);
      })
    );
  }
  function v$2(e) {
    return n$3(this, void 0, void 0, function () {
      var t, o, A, i, r, n, a, s, g, l, E, c, u, p, d, B, h;
      return o$2(this, function (I) {
        switch (I.label) {
          case 0:
            return (
              (t = c$1.baseURL),
              (o = c$1.defaults),
              (A = c$1.interceptors),
              [4, s$2(c$1.polyfillUrl)]
            );
          case 1:
            return (
              I.sent(),
              (i = r$3(r$3({}, o), e)).headers ||
                (i.headers = (function (e) {
                  void 0 === e && (e = "GET");
                  var t = c$1.headers[e] || {};
                  return r$3(r$3({}, c$1.headers.common), t);
                })(i.method)),
              l$1(i),
              [4, A.request.traverse(i, !0)]
            );
          case 2:
            if ((r = I.sent()) instanceof Error) throw r;
            return (
              (r.url = (function (e, t) {
                return !e || u$1.test(t)
                  ? t
                  : e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "");
              })(t, r.url)),
              (n = r.url),
              (a = r.timeout),
              (s = r.params),
              (g = r.method),
              (l =
                ["GET", "DELETE", "OPTIONS", "HEAD"].includes(
                  void 0 === g ? "GET" : g
                ) && !!s),
              (E = l ? m$1({ url: n, query: s }) : n),
              (c = []),
              a &&
                !r.signal &&
                ((d = new Promise(function (e) {
                  u = setTimeout(function () {
                    e(new Error("timeout"));
                  }, a);
                })),
                c.push(d),
                (p = new AbortController()),
                (r.signal = p.signal)),
              c.push(
                fetch(E, r).catch(function (e) {
                  return e;
                })
              ),
              [4, Promise.race(c)]
            );
          case 3:
            return (
              (B = I.sent()), u && clearTimeout(u), [4, A.response.traverse(B)]
            );
          case 4:
            if ((h = I.sent()) instanceof Error)
              throw (null == p || p.abort(), h);
            return [2, h];
        }
      });
    });
  }
  var targetWindow = window,
    netTool = {
      setJSONPTarget: function (e) {
        targetWindow = e;
      },
      jsonp: function (e, t) {
        return h$2(e, __assign$1({ targetWindow: targetWindow }, t));
      },
      img: function (e) {
        return new window.Promise(function (t) {
          (new Image().src = e), t();
        });
      },
      fetch: function (e, t) {
        return (
          void 0 === t && (t = {}),
          v$2({ url: e, method: t.method, body: t.body }).then(function (e) {
            return e.json();
          })
        );
      },
      xhr: function (e) {
        var t = e.retryCount || 0,
          o = +new Date(),
          A = 0,
          i = function (r, n) {
            var a = function (e) {
                void 0 === e && (e = "xhrNetworkError"),
                  A < t ? (A++, i(r, n)) : n({ error: e, target: s });
              },
              s = new XMLHttpRequest();
            s.open(e.method || "get", e.url),
              e.timeout && (s.timeout = e.timeout),
              e.responseType && (s.responseType = e.responseType),
              (s.withCredentials = !!e.withCredentials),
              (s.ontimeout = e.ontimeout),
              e.range &&
                s.setRequestHeader(
                  "Range",
                  "bytes=".concat(e.range[0], "-").concat(e.range[1])
                ),
              e.headers &&
                Object.keys(e.headers).forEach(function (t) {
                  s.setRequestHeader(t, e.headers[t]);
                }),
              (s.onload = function () {
                200 !== s.status && 206 !== s.status
                  ? a("xhrStatusCodeError")
                  : r({ data: s.response, target: s, startTimestamp: o });
              }),
              (s.onerror = function () {
                a();
              }),
              (s.onabort = function () {}),
              (s.ontimeout = function () {
                a("xhrTimeoutError");
              }),
              e.body ? s.send(e.body) : s.send();
          };
        return new Promise(function (e, t) {
          i(e, t);
        });
      },
    },
    ResizeObserverPolyfilled = (function () {
      function e(e) {
        var t = this;
        (this.targetOptionMap = new Map()),
          (this.pollTimer = null),
          (this.lastRectMap = new Map()),
          (this.pollTimeout = DEFAULT_INTERVAL_TIMEOUT),
          (this.onPollTimeout = function () {
            var e = [];
            t.removeDisconnectedElements(),
              t.targetOptionMap.forEach(function (o, A) {
                var i = A.getBoundingClientRect(),
                  r = t.lastRectMap.get(A);
                t.diffRect(r, i, null == o ? void 0 : o.box) &&
                  e.push(t.assembleEntries(A, i)),
                  t.lastRectMap.set(A, i);
              }),
              e.length && t.callback(e, t);
          }),
          (this.callback = e);
      }
      return (
        (e.prototype.disconnect = function () {
          this.targetOptionMap.clear(), this.setPoll(!1);
        }),
        (e.prototype.observe = function (e, t) {
          this.targetOptionMap.set(e, t), this.setPoll(!0);
        }),
        (e.prototype.unobserve = function (e) {
          this.targetOptionMap.delete(e);
        }),
        (e.prototype.setPoll = function (e) {
          void 0 === e && (e = !0),
            this.pollTimer &&
              (clearInterval(this.pollTimer), (this.pollTimer = null)),
            e &&
              (this.pollTimer = setInterval(
                this.onPollTimeout,
                this.pollTimeout
              ));
        }),
        (e.prototype.removeDisconnectedElements = function () {
          var e = this;
          this.targetOptionMap.forEach(function (t, o) {
            o.isConnected ||
              (e.targetOptionMap.delete(o), e.lastRectMap.delete(o));
          });
        }),
        (e.prototype.assembleEntries = function (e, t) {
          return {
            target: e,
            borderBoxSize: [],
            contentBoxSize: [],
            contentRect: t,
            devicePixelContentBoxSize: [],
          };
        }),
        (e.prototype.diffRect = function (e, t, o) {
          return (
            void 0 === o && (o = "content-box"),
            !e ||
              DIFF_ATTR_RULE_MAP[o].some(function (o) {
                return e[o] !== t[o];
              })
          );
        }),
        e
      );
    })(),
    DEFAULT_INTERVAL_TIMEOUT = 200,
    DIFF_ATTR_RULE_MAP = {
      "border-box": ["height", "width", "left", "right", "top", "bottom"],
      "content-box": ["height", "width"],
      "device-pixel-content-box": ["height", "width"],
    },
    ResizeObserver = window.ResizeObserver || ResizeObserverPolyfilled,
    stringTool = {
      arrayToString: encodingTool.utf16.fromUint16Array,
      base64ToUint8Array: encodingTool.base64.toUint8Array,
      arrayBufferToBase64: encodingTool.base64.fromUint8Array,
      stringToArray: encodingTool.utf16.toUint16Array,
    },
    mobileDevReg$1 = /android|iPod|ipad|iPhone|mobile/i;
  function uaMatch$1(e) {
    var t, o, A;
    if ("object" != typeof window && !e) return this;
    (e = (e = e || navigator.userAgent).toLowerCase()),
      (this.browser = {}),
      (this.os = {}),
      (this.mobile = !1),
      (this.spider =
        /(googlebot|bingbot|yandex|twitterbot|facebookexternalhit|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest\/0\.|pinterestbot|slackbot|vkShare|W3C_Validator|whatsapp|petalbot|applebot|mpcrawler|spider)/i.test(
          e
        )),
      (this.headless = /headless/i.test(e)),
      mobileDevReg$1.test(e) && (this.mobile = !0);
    for (
      var i,
        r,
        n = {
          android_1: /android[\s\/]([\d\.]+)/i,
          android_2: /android/i,
          android_3: /MIDP-/i,
          ipod_1: /iPod\stouch;\sCPU\siPhone\sos\s([\d_]+)/i,
          ipod_100: /iPod.*os\s?([\d_\.]+)/i,
          iphone: /iPhone;\sCPU\siPhone\sos\s([\d_]+)/i,
          iphone_100: /iPhone.*os\s?([\d_\.]+)/i,
          ipad_1: /ipad;\scpu\sos\s([\d_]+)/i,
          ipad_2: /ipad([\d]+)?/i,
          windows: /windows\snt\s([\d\.]+)/i,
          mac: /Macintosh.*mac\sos\sx\s([\d_\.]+)/i,
          linux: /Linux/i,
        },
        a = Object.keys(n),
        s = 0,
        g = a.length;
      s < g;
      s++
    ) {
      var l = a[s];
      if ((i = n[l].exec(e))) {
        (r = l.replace(/_\d+/, "")),
          (this.os[r] = !0),
          (this.os.osName = r),
          i[1] && (this.os.version = i[1].replace(/_/g, "."));
        break;
      }
    }
    (this.os.iphone || this.os.ipad || this.os.ipod) && (this.os.ios = !0);
    var E,
      c,
      u = {
        wechat: /MicroMessenger\/([\d\.]+)/i,
        ipadqq: /IPadQQ\/([\d\.]+)/i,
        mqq: /qq\/([\d\.]+)/i,
        qzone: /QZONEJSSDK\/([\d\.]+)/i,
        mqqbrowser: /mqqbrowser\/([\d\.]+)/i,
        qqbrowser: /[^m]QQBrowser\/([\d\.]+)/i,
        x5: /tbs\/(\d+)/i,
        xweb: /xweb\/(\d+)/i,
        uc: /UCBrowser\/([\d\.]+)/i,
        edg: /Edg\/([\d\.]+)/i,
        safari_1: /Version\/(([\d\.]+))\sSafari\/[\d\.]+/i,
        safari_2: /Safari\/([\d\.]+)/i,
        chrome_1: /CriOS\/([\d\.]+)/i,
        chrome_2: /Chrome\/([\d\.]+)/i,
        firefox: /Firefox\/([\d\.]+)/i,
        ie_1: /MSIE\s([\d\.]+)/i,
        ie_2: /(trident\/\d\.\d)/i,
        ie_3: /Edge\/(\d+\.\d+)/i,
        weibo: /weibo__([\d\.]+)/i,
        qqnews: /qqnews\/([\d\.]+)/i,
        qqlive_1: /QQLiveBrowser\/([\d\.]+)/i,
        qqlive_2: /QQLiveHDBrowser\/([\d\.]+)/i,
        kuaibao: /qnreading\/([\d\.]+)/i,
        liebao: /LieBaoFast\/([\d\.]+)/i,
        douban: /com\.douban\.frodo\/([\d\.]+)/i,
        miuibrowser: /MiuiBrowser/i,
        baidu: /baiduboxapp/i,
        browser360: /360browser/i,
        oppobrowser: /OppoBrowser/i,
        qqdownloader: /qqdownloader\/([\d\.]+)/i,
      },
      p = Object.keys(u),
      d = 0;
    for (g = p.length; d < g; d++) {
      var B = p[d];
      if ((E = u[B].exec(e))) {
        if (((c = B.replace(/_\d+/, "")), this.browser[c])) return this;
        (this.browser[c] = { version: E[1] }),
          (this.browser.browserName = c),
          (this.browser.version = E[1]);
      }
    }
    return (
      this.os.android && this.browser.safari && (this.browser.safari = null),
      this.browser.chrome &&
        this.browser.safari &&
        (this.browser.safari = null),
      (null ===
        (A =
          null ===
            (o = null === (t = this.browser) || void 0 === t ? void 0 : t.ie) ||
          void 0 === o
            ? void 0
            : o.version) || void 0 === A
        ? void 0
        : A.indexOf("trident")) > -1 &&
        (this.browser.ie.version.indexOf("6.0") > -1
          ? (this.browser.ie.version = "10")
          : this.browser.ie.version.indexOf("5.0") > -1
          ? (this.browser.ie.version = "9")
          : this.browser.ie.version.indexOf("4.0") > -1
          ? (this.browser.ie.version = "8")
          : (this.browser.ie.version = "11")),
      this
    );
  }
  var uaTool$1 = uaMatch$1.call({}),
    LoopMode$1;
  !(function (e) {
    (e[(e.Timer = 0)] = "Timer"), (e[(e.RAF = 1)] = "RAF");
  })(LoopMode$1 || (LoopMode$1 = {}));
  var TaskLoop = (function () {
      function e(e, t) {
        var o;
        (this.running = !1),
          (this.loopRunnerPair =
            (((o = {})[LoopMode$1.RAF] = [
              window.requestAnimationFrame.bind(window),
              window.cancelAnimationFrame.bind(window),
            ]),
            (o[LoopMode$1.Timer] = [
              window.setTimeout.bind(window),
              window.clearTimeout.bind(window),
            ]),
            o)),
          (this.callback = e),
          t === LoopMode$1.RAF && this.loopRunnerPair[t][0]
            ? (this.mode = LoopMode$1.RAF)
            : (this.mode = LoopMode$1.Timer),
          (this.runner = this.loopRunnerPair[this.mode][0]);
      }
      return (
        (e.prototype.start = function (e) {
          var t = this;
          if ((void 0 === e && (e = 0), !this.running)) {
            this.running = !0;
            var o = function () {
              var A;
              t.running &&
                (null === (A = t.callback) || void 0 === A || A.call(t),
                (t.loopId = t.runner(o, e)));
            };
            this.loopId = this.runner(o, e);
          }
        }),
        (e.prototype.stop = function () {
          this.running &&
            ((this.running = !1),
            this.loopId && this.loopRunnerPair[this.mode][1](this.loopId),
            (this.loopId = null));
        }),
        (e.prototype.destroy = function () {
          this.stop(),
            (this.callback = null),
            (this.loopId = null),
            (this.loopRunnerPair = null);
        }),
        e
      );
    })(),
    urlTool$1 = {
      object2string: function (e, t) {
        return void 0 === t && (t = "&"), this.convertUrlParam(e, t, !1);
      },
      convertUrlParam: function (e, t, o) {
        if ((void 0 === t && (t = "&"), void 0 === o && (o = !0), !e))
          return "";
        var A = Object.keys(e);
        if (A.length <= 0) return "";
        var i = [];
        return (
          A.forEach(function (t) {
            var A = "";
            (A = o
              ? ""
                  .concat(encodeURIComponent(t), "=")
                  .concat(encodeURIComponent(e[t]))
              : "".concat(t, "=").concat(e[t])),
              i.push(A);
          }),
          i.join(t)
        );
      },
      getRootDomain: function () {
        var e = window.location.hostname || window.location.host,
          t = window.location.host.split(".");
        return t.length > 1 && (e = t.slice(t.length - 2).join(".")), e;
      },
      getTopFrameUrl: function () {
        var e = "";
        if (window.top !== window)
          try {
            e = window.top.location.href;
          } catch (t) {
            e = document.referrer;
          }
        else e = window.location.href;
        return e;
      },
      isInFrame: function () {
        var e = !1;
        try {
          e = window.self !== window.top;
        } catch (e) {
          return !0;
        }
        return e;
      },
      getDomainOfURL: function (e) {
        if (null == e || "" === e) return "";
        try {
          return new URL(e).hostname;
        } catch (e) {
          return "";
        }
      },
      getUrlParamByKey: function (e, t) {
        return h$1$1(e || location.href).query[t] || "";
      },
      getUrlParams: function (e) {
        return h$1$1(e || location.href).query;
      },
      updateUrlParam: function (e, t, o) {
        var A = e,
          i = this.getUrlParamByKey(A, t),
          r = "".concat(t, "=").concat(o);
        return (A = i
          ? A.replace("".concat(t, "=").concat(i), r)
          : A + (-1 !== A.indexOf("?") ? "&" : "?") + r);
      },
      getFileName: function (e) {
        if (!e) return null;
        var t = e,
          o = t.indexOf("?");
        o > 0 && (t = t.slice(0, o));
        var A = t.lastIndexOf("/");
        A > 0 && (t = t.slice(A + 1, t.length));
        var i = t.lastIndexOf("#");
        return i > 0 && (t = t.slice(0, i)), t;
      },
      getFileExtension: function (e) {
        if (!e) return null;
        if (this.isWebRTCLink(e)) return "webrtc";
        var t = urlTool$1.getFileName(e);
        if (t) {
          var o = t.split(".");
          if (o && o.length > 1) return o[o.length - 1];
        }
        return null;
      },
      isWebRTCLink: function (e) {
        return /^webrtc:\/\//.test(e);
      },
    };
  function runValidators(e, t, o) {
    var A;
    return (
      void 0 === o && (o = null),
      e.length
        ? (e.every(function (e) {
            return (A = t.call(o, e) || EMPTY_VALIDATE_RESULT).isValid;
          }),
          A)
        : VALIDATE_PASS_RESULT
    );
  }
  var VALIDATE_PASS_RESULT = { isValid: !0, message: "" },
    EMPTY_VALIDATE_RESULT = {
      isValid: !1,
      message: "Validator does not return anything.",
    },
    wasmDetectionCache$1 = null,
    KeySystems$1,
    HDR_CAPABILITY$1;
  function getSupportedKeySystemConfig$1(e) {
    switch (e) {
      case KeySystems$1.FairPlayWebKit:
        return null;
      case KeySystems$1.Widevine:
        return {
          initDataTypes: ["cenc"],
          audioCapabilities: [
            {
              contentType: 'audio/mp4; codecs="mp4a.40.2"',
              robustness: "SW_SECURE_CRYPTO",
            },
          ],
          videoCapabilities: [
            {
              contentType: 'video/mp4; codecs="avc1.42E01E"',
              robustness: "SW_SECURE_CRYPTO",
            },
          ],
        };
      case KeySystems$1.FairPlay:
        return {
          initDataTypes: ["skd", "cenc"],
          videoCapabilities: [
            { contentType: "application/vnd.apple.mpegurl", robustness: "" },
          ],
        };
      case KeySystems$1.PlayReady:
      case KeySystems$1.PlayReadyHardware:
        return {
          initDataTypes: ["keyids", "cenc"],
          audioCapabilities: [{ contentType: 'audio/mp4; codecs="mp4a.40.2"' }],
          videoCapabilities: [
            { contentType: 'video/mp4; codecs="avc1.42E01E"' },
          ],
        };
      default:
        return null;
    }
  }
  !(function (e) {
    (e.FairPlayWebKit = "com.apple.fps.1_0"),
      (e.Widevine = "com.widevine.alpha"),
      (e.FairPlay = "com.apple.fps"),
      (e.Chacha = "com.tencent.chacha"),
      (e.PlayReady = "com.microsoft.playready"),
      (e.PlayReadyHardware = "com.microsoft.playready.hardware");
  })(KeySystems$1 || (KeySystems$1 = {})),
    (function (e) {
      (e[(e.NOT_SUPPORTED = 0)] = "NOT_SUPPORTED"),
        (e[(e.WCG_DISPLAY_BUT_NO_HDR = 1)] = "WCG_DISPLAY_BUT_NO_HDR"),
        (e[(e.SUPPORTED = 2)] = "SUPPORTED");
    })(HDR_CAPABILITY$1 || (HDR_CAPABILITY$1 = {}));
  var videoTool$1 = {
      getBuffered: function (e) {
        for (var t = [], o = e.buffered.length, A = 0; A < o; A++)
          t.push({ start: e.buffered.start(A), end: e.buffered.end(A) });
        return t;
      },
      checkTimeInBuffer: function (e, t) {
        for (var o = !1, A = t.length, i = 0; i < A; i++) {
          var r = t[i].start,
            n = t[i].end;
          if (e >= r && e <= n) {
            o = !0;
            break;
          }
        }
        return o;
      },
      clear: function (e) {
        e &&
          (e instanceof HTMLVideoElement
            ? (e.removeAttribute("src"), (e.srcObject = null))
            : ((e.srcConfig = null), (e.src = null)),
          e.load());
      },
      destroyElement: function (e) {
        var t;
        e &&
          (null === (t = e.destroy) || void 0 === t || t.call(e),
          videoTool$1.clear(e),
          videoTool$1.removeElement(e, null));
      },
      captureVideo: function (e, t) {
        var o = t.dx,
          A = t.dy,
          i = t.dw,
          r = t.dh,
          n = e.videoWidth,
          a = e.videoHeight,
          s = document.createElement("canvas");
        (s.width = n), (s.height = a);
        var g = s.getContext("2d");
        return (
          g.drawImage(e, 0, 0, n, a),
          {
            captureHeight: r,
            captureWidth: i,
            captureX: o,
            captureY: A,
            playtime: e.currentTime,
            data: g.getImageData(o, A, i, r),
          }
        );
      },
      resizeElement: function (e, t) {
        var o;
        if (t && e)
          if (e instanceof HTMLElement) domTool$1.css(e, t);
          else {
            var A = t.width,
              i = t.height;
            "number" == typeof A &&
              "number" == typeof i &&
              (null === (o = e.resize) || void 0 === o || o.call(e, A, i));
          }
      },
      appendElement: function (e, t) {
        var o;
        e instanceof HTMLElement
          ? domTool$1.append(t, e)
          : null === (o = e.appendToParent) || void 0 === o || o.call(e, t);
      },
      removeElement: function (e, t) {
        var o;
        e instanceof HTMLElement
          ? (null == e ? void 0 : e.parentNode) && e.remove()
          : null === (o = e.removeFromParent) || void 0 === o || o.call(e, t);
      },
      setElementFitType: function (e, t) {
        e && e instanceof HTMLElement && domTool$1.css(e, { "object-fit": t });
      },
      getDefaultMaxBufferTime: function () {
        var e = navigator.connection;
        return e && "wifi" === e.type ? 180 : e && "4g" === e.type ? 120 : 180;
      },
      isAutoPlayBlockedMessage: function (e) {
        return e && /interact|not allowed|user gesture/.test(e);
      },
      supportSameTimePlay: function () {
        return (
          (!uaTool$1.browser.x5 ||
            -1 ===
              ["45031", "45032"].indexOf(
                "".concat(uaTool$1.browser.x5.version)
              )) &&
          !(
            uaTool$1.browser.mqqbrowser &&
            !(
              uaTool$1.browser.qqlive ||
              uaTool$1.browser.wechat ||
              uaTool$1.browser.mqq
            )
          ) &&
          !(
            uaTool$1.os.ios &&
            uaTool$1.os.version &&
            commonTool$1.compareVersion(uaTool$1.os.version, "11.0") < 0
          )
        );
      },
      cannotDetectAutoPlayBlock: function () {
        return (
          uaTool$1.browser.chrome &&
          commonTool$1.compareVersion(uaTool$1.browser.chrome.version, "66.0") <
            0
        );
      },
      supportMediaFragmentsURISpec: function (e) {
        return void 0 !== e
          ? !!e
          : -1 === window.navigator.userAgent.indexOf("jsdom") &&
              (!uaTool$1.mobile || !!uaTool$1.os.ios);
      },
      getVideoPlaybackQuality: function (e) {
        var t = 0,
          o = 0;
        if (null == e ? void 0 : e.getVideoPlaybackQuality) {
          var A = e.getVideoPlaybackQuality();
          (o = A.droppedVideoFrames || 0), (t = A.totalVideoFrames || 0);
        } else
          e &&
            e.webkitDecodedFrameCount &&
            ((t = e.webkitDecodedFrameCount), (o = e.webkitDroppedFrameCount));
        return { totalVideoFrames: t, droppedVideoFrames: o };
      },
      supportMSE: function () {
        var e = videoTool$1.getMediaSource();
        if (!e) return !1;
        var t = window.SourceBuffer || window.WebKitSourceBuffer,
          o =
            e &&
            "function" == typeof e.isTypeSupported &&
            e.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'),
          A =
            !t ||
            (t.prototype &&
              "function" == typeof t.prototype.appendBuffer &&
              "function" == typeof t.prototype.remove);
        return !!o && !!A;
      },
      supportVideoFormat: function () {
        var e = document.createElement("video"),
          t = {
            mp4: "video/mp4",
            mov: "video/mp4",
            hls: "application/x-mpegURL",
            avi: "video/x-msvideo",
            mpeg: "video/mpeg",
            webm: "video/webm",
            ogg: "video/ogg",
          },
          o = [];
        return (
          Object.keys(t).forEach(function (A) {
            var i = t[A],
              r = e.canPlayType(i);
            -1 !== ["maybe", "probably"].indexOf(r) && o.push(A);
          }),
          o
        );
      },
      supportAV1: function () {
        return videoTool$1.isMediaSourceTypeSupported(
          "video/mp4;codecs=av01.0.12M.08"
        );
      },
      supportHevc: function () {
        return videoTool$1.isMediaSourceTypeSupported(
          'video/mp4;codecs="hvc1.1.6.L120.90"'
        );
      },
      supportHEVCMain10: function () {
        return videoTool$1.isMediaSourceTypeSupported(
          'video/mp4;codecs="hvc1.2.4.L120.90"'
        );
      },
      isVideoCanPlayType: function (e) {
        return document.createElement("video").canPlayType(e);
      },
      isMediaSourceTypeSupported: function (e) {
        var t;
        try {
          return null === (t = videoTool$1.getMediaSource()) || void 0 === t
            ? void 0
            : t.isTypeSupported(e);
        } catch (e) {
          return !1;
        }
      },
      isMediaCapabilitiesTypeSupported: function (e) {
        return __awaiter$1(this, void 0, void 0, function () {
          var t, o, A, i, r, n, a, s, g, l, E, c;
          return __generator$1(this, function (u) {
            switch (u.label) {
              case 0:
                (t = e.type),
                  (o = e.mimeType),
                  (A = e.resolution),
                  (i = void 0 === A ? "860x480" : A),
                  (r = e.bitrate),
                  (n = void 0 === r ? 800 : r),
                  (a = e.framerate),
                  (s = void 0 === a ? 30 : a),
                  (u.label = 1);
              case 1:
                switch (
                  (u.trys.push([1, 3, , 4]), (g = { type: "media-source" }), t)
                ) {
                  case "audio":
                    g.audio = { contentType: o };
                    break;
                  case "audio-spatial":
                    g.audio = { contentType: o, spatialRendering: !0 };
                    break;
                  case "video":
                    (l = i.toLowerCase().split("x")),
                      (E = l[0]),
                      (c = l[1]),
                      (g.video = {
                        contentType: o,
                        bitrate: n,
                        framerate: s,
                        height: +E,
                        width: +c,
                      });
                }
                return [4, navigator.mediaCapabilities.decodingInfo(g)];
              case 2:
                return [2, u.sent().supported];
              case 3:
                return u.sent(), [2, !1];
              case 4:
                return [2];
            }
          });
        });
      },
      isHDRSupported: function () {
        try {
          return window.matchMedia("(dynamic-range: high)").matches
            ? HDR_CAPABILITY$1.SUPPORTED
            : window.matchMedia("(color-gamut: p3)").matches
            ? HDR_CAPABILITY$1.WCG_DISPLAY_BUT_NO_HDR
            : HDR_CAPABILITY$1.NOT_SUPPORTED;
        } catch (e) {
          return HDR_CAPABILITY$1.NOT_SUPPORTED;
        }
      },
      isDolbyVisionSupported: function () {
        return videoTool$1.isMediaSourceTypeSupported(
          'video/mp4; codecs="dvhe"'
        );
      },
      isDolbyAtomsSupported: function () {
        return videoTool$1.isMediaSourceTypeSupported(
          'audio/mp4; codecs="ec-3"'
        );
      },
      getMediaSource: function () {
        if ("undefined" != typeof window)
          return window.MediaSource || window.WebKitMediaSource;
      },
      isEncryptionSupported: function (e, t) {
        return __awaiter$1(this, void 0, void 0, function () {
          var o, A;
          return __generator$1(this, function (i) {
            switch (i.label) {
              case 0:
                if (
                  ((o = t || getSupportedKeySystemConfig$1(e)),
                  (A = [window.MediaKeys, window.WebKitMediaKeys].some(
                    function (e) {
                      return e;
                    }
                  )),
                  !A)
                )
                  return [2, !1];
                if (!(void 0 !== window.navigator.requestMediaKeySystemAccess))
                  return [2, !1];
                i.label = 1;
              case 1:
                return (
                  i.trys.push([1, 3, , 4]),
                  [4, window.navigator.requestMediaKeySystemAccess(e, [o])]
                );
              case 2:
                return [2, !!i.sent()];
              case 3:
                return i.sent(), [2, !1];
              case 4:
                return [2];
            }
          });
        });
      },
      supportWidevine: function () {
        return __awaiter$1(this, void 0, void 0, function () {
          return __generator$1(this, function (e) {
            return [
              2,
              videoTool$1.isEncryptionSupported(KeySystems$1.Widevine),
            ];
          });
        });
      },
      supportFairplay: function () {
        var e = KeySystems$1.FairPlayWebKit;
        return (
          !!window.WebKitMediaKeys &&
          window.WebKitMediaKeys.isTypeSupported(e, "video/mp4")
        );
      },
      supportWebGL: function () {
        var e,
          t = document.createElement("canvas");
        try {
          e = t.getContext("webgl");
        } catch (e) {
          return !1;
        }
        return !!e;
      },
      isWebRTCSupported: function () {
        var e = Boolean(uaTool$1.os.ios),
          t = Boolean(uaTool$1.browser.uc),
          o = Boolean(uaTool$1.browser.safari);
        return (
          !t &&
          !(
            e &&
            o &&
            commonTool$1.compareVersion(uaTool$1.os.version, "11.1.2") < 0
          ) &&
          ("RTCPeerConnection" in window || "webkitRTCPeerConnection" in window)
        );
      },
      isPositionBuffered: function (e, t) {
        for (
          var o = e.buffered, A = t || e.currentTime, i = 0;
          i < o.length;
          i++
        )
          if (A >= o.start(i) && A <= o.end(i)) return !0;
        return !1;
      },
      getNextBufferedStart: function (e, t) {
        for (
          var o = e.buffered, A = t || e.currentTime, i = 0;
          i < o.length;
          i++
        )
          if (o.start(i) > A) return o.start(i);
        return -1;
      },
      getLastBufferedEnd: function (e, t) {
        for (
          var o = e.buffered, A = t || e.currentTime, i = o.length - 1;
          i >= 0;
          i--
        )
          if (o.end(i) < A) return o.end(i);
        return -1;
      },
      isHardwareAccelerated: function () {
        try {
          var e = document.createElement("canvas"),
            t = {
              alpha: !0,
              antialias: !1,
              depth: !0,
              failIfMajorPerformanceCaveat: !0,
              stencil: !0,
            };
          return !(
            !e.getContext("webgl", t) && !e.getContext("experimental-webgl", t)
          );
        } catch (e) {
          return !1;
        }
      },
      collectGPUInfo: function () {
        try {
          var e = document.createElement("canvas").getContext("webgl"),
            t =
              null == e ? void 0 : e.getExtension("WEBGL_debug_renderer_info");
          return t
            ? {
                vendor:
                  (null == e
                    ? void 0
                    : e.getParameter(t.UNMASKED_VENDOR_WEBGL)) || "",
                renderer:
                  (null == e
                    ? void 0
                    : e.getParameter(t.UNMASKED_RENDERER_WEBGL)) || "",
              }
            : null;
        } catch (e) {
          return null;
        }
      },
      isWasmSupported: function () {
        if (null !== wasmDetectionCache$1) return wasmDetectionCache$1;
        if (!window.WebAssembly) return (wasmDetectionCache$1 = !1), !1;
        try {
          var e = Uint8Array.from([0, 97, 115, 109, 1, 0, 0, 0]),
            t = new WebAssembly.Module(e),
            o = new WebAssembly.Instance(t);
          wasmDetectionCache$1 = o instanceof WebAssembly.Instance;
        } catch (e) {
          wasmDetectionCache$1 = !1;
        } finally {
          return wasmDetectionCache$1;
        }
      },
      isWasmKernelSupported: function () {
        return (
          this.isWasmSupported() &&
          !!window.customElements &&
          commonTool$1.supportES6() &&
          videoTool$1.supportWebGL()
        );
      },
      supportFetchStream: function () {
        if (
          window.fetch &&
          window.AbortController &&
          window.ReadableStream &&
          window.Request
        )
          try {
            return new window.ReadableStream({}), !0;
          } catch (e) {}
        return !1;
      },
    },
    SET_LEVEL_MODE,
    PLAY_MODE;
  !(function (e) {
    (e.SOFT = "soft"), (e.HARD = "hard"), (e.SMOOTH = "smooth");
  })(SET_LEVEL_MODE || (SET_LEVEL_MODE = {})),
    (exports.PLAY_MODE = void 0),
    (PLAY_MODE = exports.PLAY_MODE || (exports.PLAY_MODE = {})),
    (PLAY_MODE.VOD = "vod"),
    (PLAY_MODE.LIVE = "live");
  var CAN_PLAY_ALL = null,
    VIDEO_CONTAINER_CLASS = "txp_videos_container",
    END_STATE,
    VIDEO_READY_STATE,
    VIDEO_EVTS,
    VIDEO_STATE,
    ERROR_CODE,
    ERROR_MSG,
    PLAY_EVENT,
    PRELOAD_EVENT,
    VIDEO_NODE_EVENT,
    PAUSE_TYPE,
    PLAYER_LOG_LEVEL,
    PRELOAD_TYPE,
    CODEC,
    VIDEO_CODEC,
    AUDIO_CODEC,
    CONTAINER_FORMAT,
    VIDEO_ELEMENT_STATE;
  (exports.END_STATE = void 0),
    (END_STATE = exports.END_STATE || (exports.END_STATE = {})),
    (END_STATE.NORMAL = "normal"),
    (END_STATE.INTERRUPT = "interrupt"),
    (END_STATE.ERROR = "error"),
    (function (e) {
      (e[(e.HAVE_NOTHING = 0)] = "HAVE_NOTHING"),
        (e[(e.HAVE_METADATA = 1)] = "HAVE_METADATA"),
        (e[(e.HAVE_CURRENT_DATA = 2)] = "HAVE_CURRENT_DATA"),
        (e[(e.HAVE_FUTURE_DATA = 3)] = "HAVE_FUTURE_DATA"),
        (e[(e.HAVE_ENOUGH_DATA = 4)] = "HAVE_ENOUGH_DATA");
    })(VIDEO_READY_STATE || (VIDEO_READY_STATE = {})),
    (function (e) {
      (e.loadstart = "loadstart"),
        (e.timeupdate = "timeupdate"),
        (e.durationchange = "durationchange"),
        (e.volumechange = "volumechange"),
        (e.canplay = "canplay"),
        (e.playing = "playing"),
        (e.pause = "pause"),
        (e.waiting = "waiting"),
        (e.seeking = "seeking"),
        (e.seeked = "seeked"),
        (e.loadeddata = "loadeddata"),
        (e.loadedmetadata = "loadedmetadata"),
        (e.ended = "ended"),
        (e.error = "error"),
        (e.progress = "progress"),
        (e.ratechange = "ratechange"),
        (e.resize = "resize"),
        (e.frameRender = "videoFrameRender");
    })(VIDEO_EVTS || (VIDEO_EVTS = {})),
    (exports.VIDEO_STATE = void 0),
    (VIDEO_STATE = exports.VIDEO_STATE || (exports.VIDEO_STATE = {})),
    (VIDEO_STATE.IDLE = "idle"),
    (VIDEO_STATE.LOAD_START = "loadStart"),
    (VIDEO_STATE.CANPLAY = "canplay"),
    (VIDEO_STATE.PLAYING = "playing"),
    (VIDEO_STATE.PAUSE = "pause"),
    (VIDEO_STATE.SEEKING = "seeking"),
    (VIDEO_STATE.SEEKED = "seeked"),
    (VIDEO_STATE.BUFFERING = "buffering"),
    (VIDEO_STATE.END = "end"),
    (function (e) {
      (e.UNKNOWN_ERR = "70011000"),
        (e.MEDIA_ERR_ABORTED = "70016001"),
        (e.MEDIA_ERR_NETWORK = "70016002"),
        (e.MEDIA_ERR_DECODE = "70011102"),
        (e.MEDIA_ERR_SRC_NOT_SUPPORTED = "70011103"),
        (e.ORG_LOAD_TIMEOUT = "70011104"),
        (e.STATE_STUCK = "70011105"),
        (e.ORG_PLAY_STUCK_ERR = "70011111"),
        (e.NULL_URL = "70011112"),
        (e.MISSING_KERNEL = "70011113"),
        (e.KERNEL_NOT_SPT = "70011114");
    })(ERROR_CODE || (ERROR_CODE = {})),
    (function (e) {
      (e.UNKNOWN = "鏈煡閿欒"),
        (e.XHR_NET = "瑙嗛鑾峰彇閫斾腑鍑虹幇闂"),
        (e.PRELOAD_VIDEO_TIMEOUT = "瑙嗛鎾斁瓒呮椂"),
        (e.PLAY_STUCK = "瑙嗛鏃犳硶缁х画鎾斁"),
        (e.LOAD_STREAM_FAIL = "瑙嗛娴佽幏鍙栭€斾腑鍑虹幇闂"),
        (e.INNER = "鍐呴儴閿欒"),
        (e.NULL_URL = "浼犲叆鐨勫湴鍧€涓虹┖");
    })(ERROR_MSG || (ERROR_MSG = {})),
    (exports.PLAY_EVENT = void 0),
    (PLAY_EVENT = exports.PLAY_EVENT || (exports.PLAY_EVENT = {})),
    (PLAY_EVENT.RESTART = "restart"),
    (PLAY_EVENT.TIME_UPDATE = "timeupdate"),
    (PLAY_EVENT.METADATA_CHANGE = "metadataChange"),
    (PLAY_EVENT.RATE_CHANGE = "rateChange"),
    (PLAY_EVENT.VOLUME_CHANGE = "volumeChange"),
    (PLAY_EVENT.DURATION_CHANGE = "durationChange"),
    (PLAY_EVENT.AUTOPLAY_BLOCKED = "autoplayBlocked"),
    (PLAY_EVENT.LOAD_PROGRESS = "loadProgress"),
    (PLAY_EVENT.STATE_CHANGE = "stateChange"),
    (PLAY_EVENT.FIRST_PLAYING = "firstPlaying"),
    (PLAY_EVENT.VIDEONODE_PLAY_OVER = "videoNodePlayOver"),
    (PLAY_EVENT.VIDEONODE_START_PLAY = "videoNodeStartPlay"),
    (PLAY_EVENT.VIDEONODE_FIRST_PLAYING = "videoNodeFirstPlaying"),
    (PLAY_EVENT.VIDEONODE_CHANGE = "videoNodeChange"),
    (PLAY_EVENT.LIST_CHANGE = "listChange"),
    (PLAY_EVENT.SET_LOADING = "setLoading"),
    (PLAY_EVENT.PRELOAD_START = "preloadStart"),
    (PLAY_EVENT.PRELOAD_VIDEONODE_OVER = "preloadVideonodeOver"),
    (PLAY_EVENT.PRELOAD_VIDEONODE_CLEAR = "preloadVideonodeClear"),
    (PLAY_EVENT.PRELOAD_VIDEONODE_ERROR = "preloadVideonodeError"),
    (PLAY_EVENT.VIDEO_BUFFER_CHANGE = "videoBufferChange"),
    (PLAY_EVENT.SETLEVEL_START = "setLevelStart"),
    (PLAY_EVENT.SETLEVEL_OVER = "setLevelOver"),
    (PLAY_EVENT.SET_AUDIO_TRACK_START = "setAudioTrackStart"),
    (PLAY_EVENT.SET_AUDIO_TRACK_OVER = "setAudioTrackOver"),
    (PLAY_EVENT.RESIZE = "resize"),
    (PLAY_EVENT.STOPED = "stoped"),
    (PLAY_EVENT.ERROR = "error"),
    (PLAY_EVENT.RETRY_BACKURL = "retryBackUrl"),
    (PLAY_EVENT.VIDEO_FRAME_RENDER = "videoFrameRender"),
    (PLAY_EVENT.ELEMENT_EVTS = "elementEvts"),
    (PLAY_EVENT.VIDEO_RESIZE = "videoResize"),
    (PLAY_EVENT.FULLSCREEN_CHANGE = "fullscreenChange"),
    (PLAY_EVENT.CONTAINER_RESIZE = "containerResize"),
    (PLAY_EVENT.ENTER_INSERT_STREAM = "enterInsertStream"),
    (PLAY_EVENT.EXIT_INSERT_STREAM = "exitInsertStream"),
    (PLAY_EVENT.KERNEL_DESTROY = "kernelDestroy"),
    (function (e) {
      (e.START = "START_PRELOAD"),
        (e.STOP = "STOP_PRELOAD"),
        (e.UPDATE = "UPDATE_PRELOAD_INFO");
    })(PRELOAD_EVENT || (PRELOAD_EVENT = {})),
    (function (e) {
      (e.TIME_UPDATE = "vn_timeupdate"),
        (e.METADATA_CHANGE = "vn_metadataChange"),
        (e.VOLUME_CHANGE = "vn_volumeChange"),
        (e.DURATION_CHANGE = "vn_durationChange"),
        (e.PLAY_PROMISE_CATCHED = "vn_playPromiseCatched"),
        (e.LOAD_PROGRESS = "vn_loadProgress"),
        (e.RATE_CHANGE = "vn_rateChange"),
        (e.BUFFER_APPENDED = "vn_bufferAppended"),
        (e.STATE_CHANGE = "vn_stateChange"),
        (e.ERROR = "vn_error"),
        (e.RETRY = "vn_retry"),
        (e.SET_LOADING = "vn_setLoading"),
        (e.VIDEO_BUFFER_CHANGE = "vn_videoBufferChange"),
        (e.SETLEVEL_START = "vn_setLevelStart"),
        (e.SETLEVEL_OVER = "vn_setLevelOver"),
        (e.SET_AUDIO_TRACK_START = "vn_setAudioTrackStart"),
        (e.SET_AUDIO_TRACK_OVER = "vn_setAudioTrackOver"),
        (e.URL_CHANGE = "vn_urlChange"),
        (e.FIRST_PLAYING = "vn_firstPlaying"),
        (e.ELEMENT_EVTS = "vn_elementEvts"),
        (e.PLAY_OVER = "vn_playOver"),
        (e.VIDEO_RESIZE = "vn_videoResize"),
        (e.VIDEO_FRAME_RENDER = "vn_videoFrameRender"),
        (e.ENTER_INSERT_STREAM = "enterInsertStream"),
        (e.EXIT_INSERT_STREAM = "exitInsertStream");
    })(VIDEO_NODE_EVENT || (VIDEO_NODE_EVENT = {})),
    (function (e) {
      (e.USER = "user"), (e.INNER = "inner"), (e.SYS = "sys");
    })(PAUSE_TYPE || (PAUSE_TYPE = {})),
    (function (e) {
      (e[(e.NONE = 0)] = "NONE"),
        (e[(e.CORE = 1)] = "CORE"),
        (e[(e.KERNEL = 2)] = "KERNEL");
    })(PLAYER_LOG_LEVEL || (PLAYER_LOG_LEVEL = {})),
    (exports.PRELOAD_TYPE = void 0),
    (PRELOAD_TYPE = exports.PRELOAD_TYPE || (exports.PRELOAD_TYPE = {})),
    (PRELOAD_TYPE.META_DATA = "metadata"),
    (PRELOAD_TYPE.AUTO = "auto"),
    (PRELOAD_TYPE.AUTO_LOAD = "autoLoad"),
    (function (e) {
      (e[(e.H264 = 0)] = "H264"),
        (e[(e.H265 = 1)] = "H265"),
        (e[(e.AV1 = 2)] = "AV1");
    })(CODEC || (CODEC = {})),
    (exports.VIDEO_CODEC = void 0),
    (VIDEO_CODEC = exports.VIDEO_CODEC || (exports.VIDEO_CODEC = {})),
    (VIDEO_CODEC.UNKNOWN = "unknown"),
    (VIDEO_CODEC.H264 = "h264"),
    (VIDEO_CODEC.H265 = "h265"),
    (VIDEO_CODEC.H266 = "h266"),
    (VIDEO_CODEC.VP8 = "vp8"),
    (VIDEO_CODEC.VP9 = "vp9"),
    (VIDEO_CODEC.AV1 = "av1"),
    (VIDEO_CODEC.DOLBY_VISION = "dolbyVision"),
    (exports.AUDIO_CODEC = void 0),
    (AUDIO_CODEC = exports.AUDIO_CODEC || (exports.AUDIO_CODEC = {})),
    (AUDIO_CODEC.AAC = "aac"),
    (AUDIO_CODEC.OPUS = "opus"),
    (exports.CONTAINER_FORMAT = void 0),
    (CONTAINER_FORMAT =
      exports.CONTAINER_FORMAT || (exports.CONTAINER_FORMAT = {})),
    (CONTAINER_FORMAT.MPEG_TS = "mpegts"),
    (CONTAINER_FORMAT.FMP4 = "fmp4"),
    (CONTAINER_FORMAT.MP4 = "mp4"),
    (function (e) {
      (e.FREE = "0"), (e.USED = "1");
    })(VIDEO_ELEMENT_STATE || (VIDEO_ELEMENT_STATE = {}));
  var CDN_PATH_PREFIX = "https://vm.gtimg.cn/thumbplayer/",
    CACHE_SIZE_KEY,
    DRM_TYPE$1,
    VIDEO_TYPE,
    KERNEL_NAME,
    AUDIO_TRACK_ERROR_MSG;
  !(function (e) {
    e.DEMUX = "demux_cache_size";
  })(CACHE_SIZE_KEY || (CACHE_SIZE_KEY = {})),
    (function (e) {
      (e.FAIRPLAY = "fairplay"),
        (e.WIDEVINE = "widevine"),
        (e.PLAYREADY = "playready"),
        (e.CHACHA = "chacha"),
        (e.NONE = "none");
    })(DRM_TYPE$1 || (DRM_TYPE$1 = {})),
    (function (e) {
      (e.HLS = "hls"),
        (e.MP4 = "mp4"),
        (e.MOV = "mov"),
        (e.FLV = "flv"),
        (e.WEBRTC = "webrtc"),
        (e.AVI = "avi"),
        (e.MPEG = "mpeg"),
        (e.WEBM = "webm"),
        (e.OGG = "ogg"),
        (e.OTHER = "other");
    })(VIDEO_TYPE || (VIDEO_TYPE = {})),
    (exports.KERNEL_NAME = void 0),
    (KERNEL_NAME = exports.KERNEL_NAME || (exports.KERNEL_NAME = {})),
    (KERNEL_NAME.ORIGIN = "origin"),
    (KERNEL_NAME.DEMUX_2_FMP4 = "demux2fmp4"),
    (KERNEL_NAME.FLV_JS = "flv.js"),
    (KERNEL_NAME.HLS_JS = "hls.js"),
    (KERNEL_NAME.WASM = "wasm"),
    (KERNEL_NAME.WEBRTC = "webrtc"),
    (KERNEL_NAME.ELECTRON = "electron"),
    (function (e) {
      (e.KERNEL_NOT_EXISTS = "kernel not exists"),
        (e.NOT_SUPPORT = "not support"),
        (e.STATE_INVALID = "state invalid");
    })(AUDIO_TRACK_ERROR_MSG || (AUDIO_TRACK_ERROR_MSG = {}));
  var defaultI18nConfig = {
      common: {},
      core: {
        ERROR_MSG_UNKNOWN: "鏈煡閿欒",
        ERROR_XHR_NET: "瑙嗛鑾峰彇閫斾腑鍑虹幇闂",
        ERROR_PRELOAD_VIDEO_TIMEOUT: "鍔犺浇瑙嗛瓒呮椂",
        ERROR_INNER: "瑙嗛鏃犳硶缁х画鎾斁",
        ERROR_LOAD_STREAM_FAIL: "瑙嗛娴佽幏鍙栭€斾腑鍑虹幇闂",
        ERROR_PLAY_STUCK: "鎾斁缂撳啿鍑洪敊",
        ERROR_NULL_URL: "浼犲叆鐨勫湴鍧€涓虹┖",
        ERROR_MEDIA_ERR_ABORTED: "瑙嗛鑾峰彇琚粓姝�",
        ERROR_MEDIA_ERR_NETWORK: "涓嬭浇瑙嗛鍙戠敓閿欒",
        ERROR_MEDIA_ERR_DECODE: "灏濊瘯瑙ｇ爜鍑洪敊",
        ERROR_MEDIA_ERR_SRC_NOT_SUPPORTED: "娴忚鍣ㄤ笉鏀寔璇ラ煶瑙嗛",
        ERROR_KERNEL_NOT_FOUND: "鍒囨崲娓呮櫚搴︽椂鎵句笉鍒板搴斿唴鏍�",
        ERROR_STATUS_NOT_INITIALIZED: "鎾斁鍣ㄥ皻鏈垵濮嬪寲",
        ERROR_STATUS_NOT_PLAYING: "鎾斁鏈紑濮�",
        ERROR_STATUS_EMPTY_URL: "鍒囨崲鐩爣瑙嗛鍦板潃涓虹┖",
        ERROR_STATUS_VIDEO_INFO: "鎵句笉鍒板綋鍓嶆挱鏀句俊鎭�",
        ERROR_STATUS_PLAYTIME_CHECK: "鎾斁鏈紑濮�",
        ERROR_STATUS_CLOSE_TO_END: "鎾斁鍗冲皢缁撴潫",
        ERROR_STATUS_TARGET_UNCHANGED: "鍒囨崲鐨勮棰戝湴鍧€娌℃湁鍙樺寲",
        ERROR_DRM_UNKNOWN: "鏈煡閿欒",
        ERROR_DRM_LICENSE_NOT_EXIST:
          "瑙嗛璧勬簮宸插姞瀵嗭紝浣嗘湭閰嶇疆瑙ｅ瘑璇佷功鍦板潃",
        ERROR_DRM_KEY_SYS_NOT_REQUESTED:
          "瑙嗛璧勬簮宸插姞瀵嗭紝浣嗗皻鏈姹侰DM",
        ERROR_DRM_KEY_NOT_EXIST:
          "瑙嗛璧勬簮宸插姞瀵嗭紝浣嗗皻鏈幏鍙栧埌MediaKey",
        ERROR_DRM_KEY_SESSION_NOT_EXIST: "瑙嗛璧勬簮宸插姞瀵嗭紝浣咰DM",
        ERROR_DRM_INIT_DATA_EMPTY:
          "瑙嗛璧勬簮宸插姞瀵嗭紝浣嗕簨浠朵俊鎭腑娌℃湁鐢ㄤ簬鍒涘缓璇锋眰鐨� initData",
        ERROR_DRM_KEY_SESSION_REQUEST_FAILED:
          "瑙嗛璧勬簮宸插姞瀵嗭紝浣� CDM Session 璇锋眰澶辫触",
        ERROR_DRM_KEY_SYS_NOT_SUPPORTED: "$0 涓嶆敮鎸�",
        ERROR_DRM_KEY_SYS_ACCESS_FAILED: "璁块棶CDM澶辫触, keySystem $0",
        ERROR_DRM_KEY_SESSION_CREATION_FAILED: "CDM Session 鍒濆鍖栧け璐�",
        ERROR_DRM_HDCP: "浣犲彲鑳介摼鎺ヤ簡涓嶆敮鎸丠DCP鏍囧噯鐨勬樉绀哄櫒",
        ERROR_DRM_KEY_INTERNAL: "鍐呴儴閿欒",
        ERROR_DRM_KEY_EXPIRED: "MediaKey 宸茶繃鏈�",
        ERROR_DRM_KEY_RELEASED: "MediaKey 宸蹭粠CDM涓敞閿€",
        ERROR_DRM_MEDIA_KEYS_SET_FAILED: "failed to set media keys",
        ERROR_DRM_KEY_SESSION_UPDATE_FAILED:
          "CDM Session 鏇存柊澶辫触锛岃妫€鏌ヨ瘉涔﹁В鏋�",
        ERROR_DRM_LICENSE_REQUEST_FAILED: "璇佷功璇锋眰澶辫触 $0",
        ERROR_DRM_FPS_SET_KEY_FAILED: "Webkit MediaKey鍒涘缓澶辫触",
        ERROR_DRM_FPS_CERTIFICATE_NOT_EXIST:
          "瑙嗛璧勬簮宸插姞瀵嗭紝浣� Fairplay 鏈嶅姟绔瘉涔︽湭閰嶇疆",
        INFO_AUDIO_EFFECT_DEFAULT: "榛樿闊虫晥",
        INFO_AUDIO_EFFECT_SPATIAL_STEREO: "绔嬩綋鐜粫",
        INFO_AUDIO_EFFECT_BASE_BOOSTER: "閲嶄綆闊�",
        INFO_AUDIO_EFFECT_VOCAL_BOOSTER: "娓呮緢浜哄０",
        INFO_AUDIO_EFFECT_VOCAL_WEAK: "寮卞寲浜哄０",
        INFO_AUDIO_EFFECT_POP: "娴佽",
        INFO_AUDIO_EFFECT_CLASSICAL: "鍙ゅ吀",
        INFO_AUDIO_EFFECT_ELECTRONIC: "鐢靛瓙闊充箰",
        INFO_AUDIO_EFFECT_GUITAR: "鍚変粬",
        INFO_AUDIO_EFFECT_HIPHOP: "鍢诲搱",
        INFO_AUDIO_EFFECT_JAZZ: "鐖靛＋",
        INFO_AUDIO_EFFECT_RNB: "R&B",
        INFO_AUDIO_EFFECT_ROCK_N_ROLL: "鎽囨粴",
        INFO_AUDIO_EFFECT_CONCERT_HALL: "闊充箰鍘�",
        INFO_AUDIO_EFFECT_LIVE: "婕斿敱浼氱幇鍦�",
        INFO_AUDIO_EFFECT_LIVING_ROOM: "瀹㈠巺",
      },
    },
    i18nConfig = defaultI18nConfig;
  function compile(e) {
    for (var t = [], o = 1; o < arguments.length; o++) t[o - 1] = arguments[o];
    if ("function" == typeof e) return e.apply(void 0, t);
    for (var A = e, i = 0; i < t.length; i++)
      A = A.replace("$".concat(i), String(t[i]));
    return A;
  }
  var i18nTool = { compile: compile },
    _a$5;
  function compareUrlConfig(e, t) {
    return !(!e || !t) && (!(!e.uid || !t.uid || e.uid !== t.uid) || e === t);
  }
  function fileExtension2VideoType(e) {
    switch (null == e ? void 0 : e.toLocaleLowerCase()) {
      case "m3u8":
      case "m3u":
        return VIDEO_TYPE.HLS;
      case "mp4":
      case "mov":
        return VIDEO_TYPE.MP4;
      case "flv":
      case "f4v":
        return VIDEO_TYPE.FLV;
      case "avi":
        return VIDEO_TYPE.AVI;
      case "mpeg":
        return VIDEO_TYPE.MPEG;
      case "webm":
        return VIDEO_TYPE.WEBM;
      case "ogg":
        return VIDEO_TYPE.OGG;
    }
    return VIDEO_TYPE.OTHER;
  }
  function checkUrlConfigVailed(e) {
    if (!e)
      return {
        code: ERROR_CODE.NULL_URL,
        message: compile(i18nConfig.core.ERROR_NULL_URL),
        fatal: !0,
      };
    var t = function (e) {
      if (!e.url)
        return {
          code: ERROR_CODE.NULL_URL,
          message: compile(i18nConfig.core.ERROR_NULL_URL),
          fatal: !0,
        };
    };
    if (!(e instanceof Array)) return t(e);
    for (var o = 0, A = e.length; o < A; o++) {
      var i = t(e[o]);
      if (i) return i;
    }
  }
  function getUrlConfigVideoType(e) {
    var t = (e || {}).url;
    return !t || t.startsWith("blob:")
      ? VIDEO_TYPE.OTHER
      : t.startsWith("webrtc:")
      ? VIDEO_TYPE.WEBRTC
      : fileExtension2VideoType(urlTool$1.getFileExtension(t));
  }
  function findFreeBaseVideoElement(e) {
    if (!e || 0 === e.length)
      throw new Error("videoElements is null or length equal 0");
    for (var t = null, o = 0; o < e.length; o++) {
      var A = e[o];
      if (
        void 0 === A.dataset.used ||
        A.dataset.used === VIDEO_ELEMENT_STATE.FREE
      ) {
        t = e[o];
        break;
      }
    }
    if (!t) throw new Error("Unable to find free video element!");
    return (t.dataset.used = VIDEO_ELEMENT_STATE.USED), t;
  }
  var videoEvt2PlayerEvtMap =
      ((_a$5 = {}),
      (_a$5[VIDEO_NODE_EVENT.DURATION_CHANGE] =
        exports.PLAY_EVENT.DURATION_CHANGE),
      (_a$5[VIDEO_NODE_EVENT.VOLUME_CHANGE] = exports.PLAY_EVENT.VOLUME_CHANGE),
      (_a$5[VIDEO_NODE_EVENT.ERROR] = exports.PLAY_EVENT.ERROR),
      (_a$5[VIDEO_NODE_EVENT.METADATA_CHANGE] =
        exports.PLAY_EVENT.METADATA_CHANGE),
      (_a$5[VIDEO_NODE_EVENT.SETLEVEL_OVER] = exports.PLAY_EVENT.SETLEVEL_OVER),
      (_a$5[VIDEO_NODE_EVENT.SETLEVEL_START] =
        exports.PLAY_EVENT.SETLEVEL_START),
      (_a$5[VIDEO_NODE_EVENT.SET_LOADING] = exports.PLAY_EVENT.SET_LOADING),
      (_a$5[VIDEO_NODE_EVENT.STATE_CHANGE] = exports.PLAY_EVENT.STATE_CHANGE),
      (_a$5[VIDEO_NODE_EVENT.TIME_UPDATE] = exports.PLAY_EVENT.TIME_UPDATE),
      (_a$5[VIDEO_NODE_EVENT.VIDEO_BUFFER_CHANGE] =
        exports.PLAY_EVENT.VIDEO_BUFFER_CHANGE),
      (_a$5[VIDEO_NODE_EVENT.LOAD_PROGRESS] = exports.PLAY_EVENT.LOAD_PROGRESS),
      (_a$5[VIDEO_NODE_EVENT.FIRST_PLAYING] =
        exports.PLAY_EVENT.VIDEONODE_FIRST_PLAYING),
      (_a$5[VIDEO_NODE_EVENT.RATE_CHANGE] = exports.PLAY_EVENT.RATE_CHANGE),
      (_a$5[VIDEO_NODE_EVENT.RETRY] = exports.PLAY_EVENT.RETRY_BACKURL),
      (_a$5[VIDEO_NODE_EVENT.ELEMENT_EVTS] = exports.PLAY_EVENT.ELEMENT_EVTS),
      (_a$5[VIDEO_NODE_EVENT.PLAY_OVER] = exports.PLAY_EVENT.STOPED),
      (_a$5[VIDEO_NODE_EVENT.VIDEO_RESIZE] = exports.PLAY_EVENT.VIDEO_RESIZE),
      (_a$5[VIDEO_NODE_EVENT.VIDEO_FRAME_RENDER] =
        exports.PLAY_EVENT.VIDEO_FRAME_RENDER),
      (_a$5[VIDEO_NODE_EVENT.SET_AUDIO_TRACK_OVER] =
        exports.PLAY_EVENT.SET_AUDIO_TRACK_OVER),
      (_a$5[VIDEO_NODE_EVENT.SET_AUDIO_TRACK_START] =
        exports.PLAY_EVENT.SET_AUDIO_TRACK_START),
      (_a$5[VIDEO_NODE_EVENT.ENTER_INSERT_STREAM] =
        exports.PLAY_EVENT.ENTER_INSERT_STREAM),
      (_a$5[VIDEO_NODE_EVENT.EXIT_INSERT_STREAM] =
        exports.PLAY_EVENT.EXIT_INSERT_STREAM),
      _a$5),
    IGNORE_EVT_TYPE = [
      VIDEO_NODE_EVENT.TIME_UPDATE,
      VIDEO_NODE_EVENT.LOAD_PROGRESS,
      VIDEO_NODE_EVENT.VIDEO_BUFFER_CHANGE,
      VIDEO_NODE_EVENT.VIDEO_FRAME_RENDER,
    ],
    IGNORE_VIDEO_EVT = [
      VIDEO_EVTS.timeupdate,
      VIDEO_EVTS.progress,
      VIDEO_EVTS.frameRender,
    ];
  function transformInitData(e, t, o) {
    var A = encodingTool.utf16.toUint16Array(t),
      i = e.byteLength + 4 + A.byteLength + 4 + o.byteLength,
      r = 0,
      n = new ArrayBuffer(i),
      a = new DataView(n),
      s = new Uint8Array(n, r, e.byteLength);
    s.set(e), (r += s.byteLength), a.setUint32(r, A.byteLength, !0), (r += 4);
    var g = new Uint16Array(n, r, A.length);
    return (
      g.set(A),
      (r += g.byteLength),
      a.setUint32(r, o.byteLength, !0),
      (r += 4),
      new Uint8Array(n, r, o.byteLength).set(o),
      new Uint8Array(n, 0, n.byteLength)
    );
  }
  function getContentId(e) {
    var t, o, A;
    return null ===
      (A =
        null ===
          (o =
            null ===
              (t = encodingTool.utf16.fromTypeArray(e).split("skd://")) ||
            void 0 === t
              ? void 0
              : t[1]) || void 0 === o
          ? void 0
          : o.split("?")) || void 0 === A
      ? void 0
      : A[0];
  }
  function builtMessageXML(e) {
    return new DOMParser().parseFromString(
      String.fromCharCode.apply(null, new Uint16Array(e)),
      "application/xml"
    );
  }
  function getChallenge(e) {
    var t = e.getElementsByTagName("Challenge")[0];
    try {
      return atob(t.childNodes[0].nodeValue);
    } catch (e) {
      throw "cannot parse <Challenge> from init message";
    }
  }
  function builtHeadersFromXML(e) {
    var t = {},
      o = e.getElementsByTagName("name"),
      A = e.getElementsByTagName("value");
    if (o.length !== A.length) throw "header names and values are not match";
    for (var i = 0; i < o.length; i++)
      t[o[i].childNodes[0].nodeValue] = A[i].childNodes[0].nodeValue;
    return t;
  }
  var i18nCore$1 = i18nConfig.core,
    KeySystems$2;
  function getSupportedKeySystemConfig$2(e) {
    switch (e) {
      case KeySystems$2.FairPlayWebKit:
        return null;
      case KeySystems$2.Widevine:
        return {
          initDataTypes: ["cenc"],
          audioCapabilities: [
            {
              contentType: 'audio/mp4; codecs="mp4a.40.2"',
              robustness: "SW_SECURE_CRYPTO",
            },
          ],
          videoCapabilities: [
            {
              contentType: 'video/mp4; codecs="avc1.42E01E"',
              robustness: "SW_SECURE_CRYPTO",
            },
          ],
        };
      case KeySystems$2.FairPlay:
        return {
          initDataTypes: ["skd", "cenc"],
          videoCapabilities: [
            { contentType: "application/vnd.apple.mpegurl", robustness: "" },
          ],
        };
      case KeySystems$2.PlayReady:
      case KeySystems$2.PlayReadyHardware:
        return {
          initDataTypes: ["keyids", "cenc"],
          audioCapabilities: [{ contentType: 'audio/mp4; codecs="mp4a.40.2"' }],
          videoCapabilities: [
            { contentType: 'video/mp4; codecs="avc1.42E01E"' },
          ],
        };
      default:
        return null;
    }
  }
  !(function (e) {
    (e.FairPlayWebKit = "com.apple.fps.1_0"),
      (e.Widevine = "com.widevine.alpha"),
      (e.FairPlay = "com.apple.fps"),
      (e.Chacha = "com.tencent.chacha"),
      (e.PlayReady = "com.microsoft.playready"),
      (e.PlayReadyHardware = "com.microsoft.playready.hardware");
  })(KeySystems$2 || (KeySystems$2 = {}));
  var ERR = "error",
    DRM = (function (e) {
      function t(o, A, i) {
        var r = e.call(this) || this;
        return (
          (r.started = !1),
          (r.mediaKeyDescriptor = null),
          (r.mediaKeyPromise = null),
          (r.destroyed = !1),
          (r.onVideoEncrypted = function (e) {
            r.logger.log("media encrypted", e),
              r.mediaKeyPromise
                ? r.mediaKeyPromise.then(function () {
                    r.mediaKeyDescriptor
                      ? r.mediaKeyDescriptor.hasInitialized
                        ? r.logger.warn(
                            "Media key-session has been initialized but requested again"
                          )
                        : r.mediaKeyDescriptor.mediaKeys
                        ? r.mediaKeyDescriptor.mediaKeySession
                          ? e.initData
                            ? (r.mediaKeyDescriptor.mediaKeySession
                                .generateRequest(e.initDataType, e.initData)
                                .catch(function () {
                                  r.emit(ERR, {
                                    code: 13,
                                    message: compile(
                                      i18nConfig.ERROR_DRM_KEY_SESSION_REQUEST_FAILED
                                    ),
                                  });
                                }),
                              (r.mediaKeyDescriptor.initData = e.initData),
                              (r.mediaKeyDescriptor.hasInitialized = !0))
                            : r.emit(ERR, {
                                code: 7,
                                message: compile(
                                  i18nCore$1.ERROR_DRM_INIT_DATA_EMPTY
                                ),
                              })
                          : r.emit(ERR, {
                              code: 5,
                              message: compile(
                                i18nConfig.ERROR_DRM_KEY_SESSION_NOT_EXIST
                              ),
                            })
                        : r.emit(ERR, {
                            code: 6,
                            message: compile(
                              i18nCore$1.ERROR_DRM_KEY_NOT_EXIST
                            ),
                          })
                      : r.emit(ERR, {
                          code: 6,
                          message: compile(i18nCore$1.ERROR_DRM_KEY_NOT_EXIST),
                        });
                  })
                : r.emit(ERR, {
                    code: 4,
                    message: compile(
                      i18nCore$1.ERROR_DRM_KEY_SYS_NOT_REQUESTED
                    ),
                  });
          }),
          (r.onVideoWebkitneedkey = function (e) {
            var o = r.config.fpsCustomContentId(e.initData),
              A = t.serverCertificate[KeySystems$2.FairPlayWebKit];
            if (A) {
              var i = r.config.fpsCustomTransformInitData(e.initData, o, A);
              (r.mediaKeyDescriptor.initData = i),
                r.mediaKeyDescriptor.mediaKeySession
                  ? r.logger.warn(
                      "Media key-session has already been initialized"
                    )
                  : ((r.mediaKeyDescriptor.mediaKeySession =
                      r.createSessionWithMediaKey(
                        r.mediaKeyDescriptor.mediaKeys,
                        i
                      )),
                    (r.mediaKeyDescriptor.assetID = o),
                    (r.mediaKeyDescriptor.mediaKeySession.onwebkitkeyadded =
                      r.onFPSKeySessionKeyAdded),
                    (r.mediaKeyDescriptor.mediaKeySession.onwebkitkeyerror =
                      r.onFPSKeySessionKeyError),
                    (r.mediaKeyDescriptor.mediaKeySession.onwebkitkeymessage =
                      function (e) {
                        r.onMediaKeySessionMessage(
                          r.mediaKeyDescriptor.mediaKeySession,
                          e
                        );
                      }));
            } else
              r.emit(ERR, {
                code: 9,
                message: compile(
                  i18nCore$1.ERROR_DRM_FPS_CERTIFICATE_NOT_EXIST
                ),
              });
          }),
          (r.onFPSKeySessionKeyAdded = function (e) {}),
          (r.onFPSKeySessionKeyError = function (e) {
            var t = r.mediaKeyDescriptor.mediaKeySession.error;
            if (t.systemCode) {
              var o = { 1212433232: [10, compile(i18nCore$1.ERROR_DRM_HDCP)] };
              o[t.systemCode] &&
                r.emit(ERR, {
                  code: o[t.systemCode][0],
                  message: o[t.systemCode][1],
                });
            } else
              r.emit(ERR, {
                code: 0,
                message: compile(i18nCore$1.ERROR_DRM_UNKNOWN),
              });
          }),
          (r.media = o),
          (r.logger = i),
          (r.config = __assign$1(
            {
              keySystem: null,
              fpsCustomContentId: getContentId,
              fpsCustomTransformInitData: transformInitData,
            },
            A
          )),
          r
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "isFairPlay", {
          get: function () {
            var e = this.config.keySystem;
            return (
              e === KeySystems$2.FairPlay || e === KeySystems$2.FairPlayWebKit
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.isKeySystemSupported = function (e) {
          var t, o, A;
          return null ===
            (A = (((t = {})[KeySystems$2.FairPlayWebKit] = [
              null === (o = self.WebKitMediaKeys) || void 0 === o
                ? void 0
                : o.isTypeSupported(e, "video/mp4"),
            ]),
            (t[KeySystems$2.FairPlay] = [
              uaTool$1.browser.safari,
              self.MediaKeys,
              self.navigator.requestMediaKeySystemAccess,
            ]),
            (t[KeySystems$2.Widevine] = [
              self.MediaKeys,
              self.navigator.requestMediaKeySystemAccess,
            ]),
            (t[KeySystems$2.PlayReady] = [
              self.MediaKeys,
              self.navigator.requestMediaKeySystemAccess,
            ]),
            (t[KeySystems$2.PlayReadyHardware] = [
              self.MediaKeys,
              self.navigator.requestMediaKeySystemAccess,
            ]),
            t)[e]) || void 0 === A
            ? void 0
            : A.every(Boolean);
        }),
        (t.prototype.destroy = function () {
          this.reset(),
            this.removeAllListeners(),
            (this.logger = null),
            (this.destroyed = !0);
        }),
        (t.prototype.configure = function (e) {
          var o = this;
          (this.config = __assign$1(__assign$1({}, this.config), e)),
            this.config.certificate &&
              Object.keys(this.config.certificate).forEach(function (e) {
                t.serverCertificate[e] = o.config.certificate[e];
              });
        }),
        (t.prototype.hasStarted = function () {
          return this.started;
        }),
        (t.prototype.init = function (e) {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (o) {
              switch (o.label) {
                case 0:
                  return [4, this.reset()];
                case 1:
                  return (
                    o.sent(),
                    e && this.configure(e),
                    "string" !=
                    typeof t.serverCertificate[this.config.keySystem]
                      ? [3, 3]
                      : [
                          4,
                          this.requestServerCertificate(
                            this.config.keySystem,
                            t.serverCertificate[this.config.keySystem]
                          ),
                        ]
                  );
                case 2:
                  o.sent(), (o.label = 3);
                case 3:
                  return (
                    this.destroyed ||
                      (this.bind(),
                      this.logger.log("drm module initialized"),
                      this.logger.cache("drm config", this.config)),
                    [2]
                  );
              }
            });
          });
        }),
        (t.prototype.reset = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            var e, t, o;
            return __generator$1(this, function (A) {
              switch (A.label) {
                case 0:
                  if (
                    ((this.started = !1),
                    !this.config.keySystem || !this.mediaKeyDescriptor)
                  )
                    return [2];
                  if (
                    (((o = {})[KeySystems$2.FairPlayWebKit] =
                      this.cleanupFPSSession),
                    (o[KeySystems$2.FairPlay] = this.cleanupMediaKeySession),
                    (o[KeySystems$2.Widevine] = this.cleanupMediaKeySession),
                    (o[KeySystems$2.PlayReady] = this.cleanupMediaKeySession),
                    (o[KeySystems$2.PlayReadyHardware] =
                      this.cleanupMediaKeySession),
                    (e = o),
                    this.videoEncryptedEventPicker(!1),
                    !e[this.config.keySystem])
                  )
                    return [3, 4];
                  (t = this.mediaKeyDescriptor.mediaKeySession),
                    (this.mediaKeyPromise = null),
                    (this.mediaKeyDescriptor = null),
                    (A.label = 1);
                case 1:
                  return (
                    A.trys.push([1, 3, , 4]),
                    [4, e[this.config.keySystem].call(this, t)]
                  );
                case 2:
                case 3:
                  return A.sent(), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }),
        (t.prototype.bind = function () {
          var e = this.config.keySystem;
          e &&
            (t.isKeySystemSupported(e)
              ? ((this.started = !0),
                (this.mediaKeyPromise = this.createKeySystemAccess(e)),
                this.videoEncryptedEventPicker(!0))
              : this.logger.warn("褰撳墠鐜涓嶆敮鎸� ".concat(e)));
        }),
        (t.prototype.cleanupMediaKeySession = function (e) {
          return this.media && e
            ? ((e.onmessage = null),
              (e.onkeystatuseschange = null),
              e.close().catch(function () {}),
              this.media.setMediaKeys(null))
            : Promise.resolve();
        }),
        (t.prototype.videoEncryptedEventPicker = function (e) {
          var t;
          void 0 === e && (e = !0);
          var o = (((t = {})[KeySystems$2.FairPlayWebKit] = [
              "webkitneedkey",
              this.onVideoWebkitneedkey,
            ]),
            (t[KeySystems$2.Widevine] = ["encrypted", this.onVideoEncrypted]),
            (t[KeySystems$2.FairPlay] = ["encrypted", this.onVideoEncrypted]),
            (t[KeySystems$2.PlayReady] = ["encrypted", this.onVideoEncrypted]),
            (t[KeySystems$2.PlayReadyHardware] = [
              "encrypted",
              this.onVideoEncrypted,
            ]),
            t)[this.config.keySystem],
            A = o[0],
            i = o[1];
          e
            ? this.media.addEventListener(A, i)
            : this.media.removeEventListener(A, i);
        }),
        (t.prototype.createSessionWithMediaKey = function (e, t) {
          var o;
          return (((o = {})[KeySystems$2.FairPlayWebKit] =
            this.createFPSWebkitSession),
          (o[KeySystems$2.Widevine] = this.createMediaKeySession),
          (o[KeySystems$2.FairPlay] = this.createMediaKeySession),
          (o[KeySystems$2.PlayReady] = this.createMediaKeySession),
          (o[KeySystems$2.PlayReadyHardware] = this.createMediaKeySession),
          o)[this.config.keySystem].call(this, e, t);
        }),
        (t.prototype.createKeySystemAccess = function (e) {
          var t;
          return (((t = {})[KeySystems$2.Widevine] =
            this.requestKeySystemAccess),
          (t[KeySystems$2.FairPlay] = this.requestKeySystemAccess),
          (t[KeySystems$2.FairPlayWebKit] = this.requestFPSMediaKeys),
          (t[KeySystems$2.PlayReady] = this.requestKeySystemAccess),
          (t[KeySystems$2.PlayReadyHardware] = this.requestKeySystemAccess),
          t)[this.config.keySystem].call(this, e);
        }),
        (t.prototype.requestLicense = function (e, t) {
          var o;
          if (this.config.licenseUrl)
            return (((o = {})[KeySystems$2.FairPlayWebKit] =
              this.createFPSLicenseRequest),
            (o[KeySystems$2.Widevine] = this.createWidevineLicenseRequest),
            (o[KeySystems$2.PlayReady] = this.createPlayReadyLicenseRequest),
            (o[KeySystems$2.FairPlay] = this.createFPSLicenseRequest),
            (o[KeySystems$2.PlayReadyHardware] =
              this.createPlayReadyLicenseRequest),
            o)[this.config.keySystem].call(this, e, t);
          this.emit(ERR, {
            code: 12,
            message: compile(i18nCore$1.ERROR_DRM_LICENSE_NOT_EXIST),
          });
        }),
        (t.prototype.requestServerCertificate = function (e, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            var A;
            return __generator$1(this, function (i) {
              switch (i.label) {
                case 0:
                  return [
                    4,
                    netTool.xhr({
                      method: "GET",
                      responseType: "arraybuffer",
                      url: o,
                    }),
                  ];
                case 1:
                  return (
                    (A = i.sent().data),
                    (t.serverCertificate[e] = new Uint8Array(A)),
                    [2]
                  );
              }
            });
          });
        }),
        (t.prototype.requestKeySystemAccess = function (e) {
          return __awaiter$1(this, void 0, void 0, function () {
            var t, o;
            return __generator$1(this, function (A) {
              switch (A.label) {
                case 0:
                  if (!(t = getSupportedKeySystemConfig$2(e)))
                    return (
                      this.emit(ERR, {
                        code: 3,
                        message: compile(
                          i18nCore$1.ERROR_DRM_KEY_SYS_NOT_SUPPORTED,
                          e
                        ),
                      }),
                      [2]
                    );
                  A.label = 1;
                case 1:
                  return (
                    A.trys.push([1, 3, , 4]),
                    [4, self.navigator.requestMediaKeySystemAccess(e, [t])]
                  );
                case 2:
                  return (
                    (o = A.sent()), [2, this.onMediaKeySystemObtained(e, o)]
                  );
                case 3:
                  return (
                    A.sent(),
                    this.emit(ERR, {
                      code: 1,
                      message: compile(
                        i18nCore$1.ERROR_DRM_KEY_SYS_ACCESS_FAILED,
                        e
                      ),
                    }),
                    [2]
                  );
                case 4:
                  return [2];
              }
            });
          });
        }),
        (t.prototype.onMediaKeySystemObtained = function (e, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            var A;
            return __generator$1(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, o.createMediaKeys()];
                case 1:
                  (A = i.sent()),
                    (this.mediaKeyDescriptor = {
                      hasInitialized: !1,
                      mediaKeySession: null,
                      mediaKeySystemAccess: o,
                      mediaKeys: A,
                    }),
                    (i.label = 2);
                case 2:
                  return (
                    i.trys.push([2, 5, , 6]),
                    e !== KeySystems$2.FairPlay
                      ? [3, 4]
                      : [
                          4,
                          A.setServerCertificate(
                            t.serverCertificate[KeySystems$2.FairPlay]
                          ),
                        ]
                  );
                case 3:
                  i.sent(), (i.label = 4);
                case 4:
                  return this.createSessionWithMediaKey(A), [2, A];
                case 5:
                  return (
                    i.sent(),
                    this.emit(ERR, {
                      code: 2,
                      message: compile(
                        i18nCore$1.ERROR_DRM_KEY_SESSION_CREATION_FAILED
                      ),
                    }),
                    [2]
                  );
                case 6:
                  return [2];
              }
            });
          });
        }),
        (t.prototype.createMediaKeySession = function (e) {
          var t = this;
          if (this.mediaKeyDescriptor.mediaKeySession)
            this.logger.warn("Media key-session has already been initialized");
          else {
            var o = {
              "output-restricted": [10, compile(i18nCore$1.ERROR_DRM_HDCP)],
              "output-downscaled": [10, compile(i18nCore$1.ERROR_DRM_HDCP)],
              "status-pending": null,
              "internal-error": [
                17,
                compile(i18nCore$1.ERROR_DRM_KEY_INTERNAL),
              ],
              usable: null,
              expired: [15, compile(i18nCore$1.ERROR_DRM_KEY_EXPIRED)],
              released: [16, compile(i18nCore$1.ERROR_DRM_KEY_RELEASED)],
            };
            (this.mediaKeyDescriptor.mediaKeySession = e.createSession()),
              (this.mediaKeyDescriptor.mediaKeySession.onkeystatuseschange =
                function (e) {
                  var A, i, r;
                  null ===
                    (r =
                      null ===
                        (i =
                          null === (A = e.target) || void 0 === A
                            ? void 0
                            : A.keyStatuses) || void 0 === i
                        ? void 0
                        : i.forEach) ||
                    void 0 === r ||
                    r.call(i, function (e) {
                      if (t.mediaKeyDescriptor && o[e]) {
                        var A = o[e],
                          i = A[0],
                          r = A[1];
                        t.emit(ERR, { code: i, message: r });
                      }
                    });
                }),
              (this.mediaKeyDescriptor.mediaKeySession.onmessage = function (
                e
              ) {
                t.onMediaKeySessionMessage(
                  t.mediaKeyDescriptor.mediaKeySession,
                  e
                );
              }),
              this.media
                .setMediaKeys(e)
                .then(function () {
                  t.logger.log("media keys set");
                })
                .catch(function (e) {
                  t.logger.error("media keys set failed", e),
                    t.emit(ERR, {
                      code: 18,
                      message: compile(
                        i18nCore$1.ERROR_DRM_MEDIA_KEYS_SET_FAILED
                      ),
                    });
                });
          }
        }),
        (t.prototype.onMediaKeySessionMessage = function (e, t) {
          var o = this;
          if (
            (this.logger.log("received media key session message", t),
            this.config.enableChromeM113Workaround &&
              uaTool$1.browser.chrome &&
              0 ===
                commonTool$1.compareVersion(uaTool$1.browser.version, "113"))
          )
            try {
              if (new TextDecoder().decode(t.message).includes("4.10.2652.0"))
                return void this.emit(ERR, {
                  code: 14,
                  message:
                    "褰撳墠娴忚鍣ㄧ増鏈В瀵嗘ā鍧楀瓨鍦ㄩ棶棰樺鑷存棤娉曟挱鏀�, 璇峰皾璇曞崌绾ф垨閲嶅惎娴忚鍣ㄨ繘琛屼慨澶峓CDM=4.10.2652.0]",
                  fatal: !0,
                });
            } catch (e) {}
          this.requestLicense(t, function (t) {
            return __awaiter$1(o, void 0, void 0, function () {
              var o,
                A,
                i,
                r,
                n,
                a = this;
              return __generator$1(this, function (s) {
                switch (s.label) {
                  case 0:
                    if (
                      (s.trys.push([0, 5, , 6]),
                      (o = t.data),
                      !this.config.licenseResponseSetup)
                    )
                      return [3, 4];
                    s.label = 1;
                  case 1:
                    return (
                      s.trys.push([1, 3, , 4]),
                      [4, this.config.licenseResponseSetup(o)]
                    );
                  case 2:
                    return (o = s.sent() || o), [3, 4];
                  case 3:
                    return (
                      (A = s.sent()),
                      e.closed
                        ? [2]
                        : (this.emit(ERR, {
                            code: 20,
                            detail:
                              null !== (n = A.code) && void 0 !== n ? n : 0,
                            message: compile(
                              i18nCore$1.ERROR_DRM_LICENSE_REQUEST_FAILED
                            ),
                          }),
                          [2])
                    );
                  case 4:
                    return o
                      ? (null == (i = e.update(o)) ||
                          i.catch(function () {
                            e.closed ||
                              a.emit(ERR, {
                                code: 14,
                                message: compile(
                                  i18nCore$1.ERROR_DRM_KEY_SESSION_UPDATE_FAILED
                                ),
                              });
                          }),
                        [3, 6])
                      : (this.emit(ERR, {
                          code: 14,
                          message: compile(
                            i18nCore$1.ERROR_DRM_KEY_SESSION_UPDATE_FAILED
                          ),
                        }),
                        [2]);
                  case 5:
                    return (
                      (r = s.sent()),
                      e.closed
                        ? [2]
                        : (this.emit(ERR, {
                            code: 11,
                            detail: r.code,
                            message: compile(
                              i18nCore$1.ERROR_DRM_LICENSE_REQUEST_FAILED
                            ),
                          }),
                          [3, 6])
                    );
                  case 6:
                    return [2];
                }
              });
            });
          });
        }),
        (t.prototype.createWidevineLicenseRequest = function (e, t) {
          var o;
          return __awaiter$1(this, void 0, void 0, function () {
            var A, i, r, n, a, s;
            return __generator$1(this, function (g) {
              switch (g.label) {
                case 0:
                  if (
                    ((A = e.message),
                    (i = {
                      method: "POST",
                      responseType: "arraybuffer",
                      body: A,
                      url: this.config.licenseUrl,
                      headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                      },
                    }),
                    !this.config.licenseRequestSetup)
                  )
                    return [3, 4];
                  g.label = 1;
                case 1:
                  return (
                    g.trys.push([1, 3, , 4]),
                    [4, this.config.licenseRequestSetup(i)]
                  );
                case 2:
                  return (i = g.sent()), [3, 4];
                case 3:
                  return (
                    (r = g.sent()),
                    this.emit(ERR, {
                      code: 19,
                      detail: null !== (o = r.code) && void 0 !== o ? o : 0,
                      message: compile(
                        i18nConfig.core.ERROR_DRM_LICENSE_REQUEST_FAILED
                      ),
                    }),
                    [3, 4]
                  );
                case 4:
                  return g.trys.push([4, 6, , 7]), [4, netTool.xhr(i)];
                case 5:
                  return (n = g.sent()), t(n), [3, 7];
                case 6:
                  return (
                    (a = g.sent()),
                    (s = (a || {}).code),
                    this.emit(ERR, {
                      code: 11,
                      detail: s,
                      message: compile(
                        i18nConfig.core.ERROR_DRM_LICENSE_REQUEST_FAILED
                      ),
                    }),
                    [3, 7]
                  );
                case 7:
                  return [2];
              }
            });
          });
        }),
        (t.prototype.createPlayReadyLicenseRequest = function (e, t) {
          var o;
          return __awaiter$1(this, void 0, void 0, function () {
            var A, i, r, n, a, s, g;
            return __generator$1(this, function (l) {
              switch (l.label) {
                case 0:
                  if (
                    ((A = e.message),
                    (i = builtMessageXML(A)),
                    (r = {
                      method: "POST",
                      responseType: "arraybuffer",
                      body: getChallenge(i),
                      url: this.config.licenseUrl,
                      headers: builtHeadersFromXML(i),
                    }),
                    !this.config.licenseRequestSetup)
                  )
                    return [3, 4];
                  l.label = 1;
                case 1:
                  return (
                    l.trys.push([1, 3, , 4]),
                    [4, this.config.licenseRequestSetup(r)]
                  );
                case 2:
                  return (r = l.sent()), [3, 4];
                case 3:
                  return (
                    (n = l.sent()),
                    this.emit(ERR, {
                      code: 19,
                      detail: null !== (o = n.code) && void 0 !== o ? o : 0,
                      message: compile(
                        i18nConfig.core.ERROR_DRM_LICENSE_REQUEST_FAILED
                      ),
                    }),
                    [3, 4]
                  );
                case 4:
                  return l.trys.push([4, 6, , 7]), [4, netTool.xhr(r)];
                case 5:
                  return (a = l.sent()), t(a), [3, 7];
                case 6:
                  return (
                    (s = l.sent()),
                    (g = (s || {}).code),
                    this.emit(ERR, {
                      code: 11,
                      detail: g,
                      message: compile(
                        i18nConfig.core.ERROR_DRM_LICENSE_REQUEST_FAILED
                      ),
                    }),
                    [3, 7]
                  );
                case 7:
                  return [2];
              }
            });
          });
        }),
        (t.prototype.createFPSLicenseRequest = function (e, t) {
          var o;
          return __awaiter$1(this, void 0, void 0, function () {
            var A, i, r, n, a, s, g;
            return __generator$1(this, function (l) {
              switch (l.label) {
                case 0:
                  if (
                    ((A = e.message),
                    (i = encodeURIComponent(
                      encodingTool.base64.fromUint8Array(A)
                    )),
                    (r = {
                      method: "POST",
                      responseType: "arraybuffer",
                      body: "spc="
                        .concat(i, "&assetId=")
                        .concat(this.mediaKeyDescriptor.assetID),
                      url: this.config.licenseUrl,
                      headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                      },
                    }),
                    !this.config.licenseRequestSetup)
                  )
                    return [3, 4];
                  l.label = 1;
                case 1:
                  return (
                    l.trys.push([1, 3, , 4]),
                    [4, this.config.licenseRequestSetup(r)]
                  );
                case 2:
                  return (r = l.sent()), [3, 4];
                case 3:
                  return (
                    (n = l.sent()),
                    this.emit(ERR, {
                      code: 19,
                      detail: null !== (o = n.code) && void 0 !== o ? o : 0,
                      message: compile(
                        i18nConfig.core.ERROR_DRM_LICENSE_REQUEST_FAILED
                      ),
                    }),
                    [3, 4]
                  );
                case 4:
                  return l.trys.push([4, 6, , 7]), [4, netTool.xhr(r)];
                case 5:
                  return (a = l.sent()), t(a), [3, 7];
                case 6:
                  return (
                    (s = l.sent()),
                    (g = (s || {}).code),
                    this.emit(ERR, {
                      code: 11,
                      detail: g,
                      message: compile(
                        i18nConfig.core.ERROR_DRM_LICENSE_REQUEST_FAILED
                      ),
                    }),
                    [3, 7]
                  );
                case 7:
                  return [2];
              }
            });
          });
        }),
        (t.prototype.requestFPSMediaKeys = function () {
          var e = new window.WebKitMediaKeys(KeySystems$2.FairPlayWebKit);
          return (
            this.media.webkitSetMediaKeys(e),
            (this.mediaKeyDescriptor = {
              mediaKeySession: null,
              initData: null,
              hasInitialized: !1,
              mediaKeySystemAccess: null,
              mediaKeys: this.media.webkitKeys,
            }),
            Promise.resolve(e)
          );
        }),
        (t.prototype.createFPSWebkitSession = function (e, t) {
          if (e) {
            var o = e.createSession("video/mp4", t);
            if (o) return o;
            this.emit(ERR, {
              code: 2,
              message: compile(
                i18nCore$1.ERROR_DRM_KEY_SESSION_CREATION_FAILED
              ),
            });
          } else
            this.emit(ERR, {
              code: 8,
              message: compile(i18nCore$1.ERROR_DRM_FPS_SET_KEY_FAILED),
            });
        }),
        (t.prototype.cleanupFPSSession = function (e) {
          return e
            ? (this.media.webkitSetMediaKeys(null),
              (e.onwebkitkeyadded = null),
              (e.onwebkitkeyerror = null),
              (e.onwebkitkeymessage = null),
              Promise.resolve())
            : Promise.resolve();
        }),
        (t.serverCertificate = {}),
        t
      );
    })(s$1$1),
    logCache = {};
  function getLogCache(e) {
    return logCache[e];
  }
  function clearLogCache(e) {
    logCache[e] = [];
  }
  function mallocLogCache(e) {
    logCache[e] || (logCache[e] = []);
  }
  function appendLogCache(e, t) {
    var o;
    null === (o = logCache[e]) || void 0 === o || o.push(t);
  }
  var LogCacheLimit = 4e3,
    noop = function () {},
    dummyConsole = {
      trace: noop,
      debug: noop,
      info: noop,
      log: noop,
      warn: noop,
      error: noop,
    },
    LogMode;
  !(function (e) {
    (e[(e.console = 1)] = "console"), (e[(e.cache = 2)] = "cache");
  })(LogMode || (LogMode = {}));
  var patchedConsole = Object.assign({}, dummyConsole);
  function enable(e) {
    (e || Object.keys(dummyConsole)).forEach(function (e) {
      var t;
      patchedConsole[e] =
        (null === (t = self.console) || void 0 === t ? void 0 : t[e]) || noop;
    });
  }
  function consoleOutput(e, t) {
    for (var o = [], A = 2; A < arguments.length; A++) o[A - 2] = arguments[A];
    patchedConsole[e].apply(patchedConsole, __spreadArray([t], o, !1));
  }
  function checkDirectLogType(e) {
    return (
      -1 !==
      ["string", "number", "bigint", "boolean", "symbol", "undefined"].indexOf(
        typeof e
      )
    );
  }
  function stringifyLogArgs(e, t) {
    void 0 === t && (t = []);
    var o = [];
    return (
      e &&
        (o = e.map(function (e) {
          return checkDirectLogType(e) ? e : stringifyLog(e, t);
        })),
      o.join(" ")
    );
  }
  function stringifyLog(e, t) {
    return (
      void 0 === t && (t = []),
      jsonTool$1.safelyStringify(e, function (e, o) {
        return -1 !== t.indexOf(e)
          ? ""
          : !o || o instanceof Array || checkDirectLogType(o)
          ? o
          : "function" == typeof o
          ? "[function]"
          : o.constructor !== Object
          ? "".concat(o)
          : o;
      })
    );
  }
  function dumpLog(e) {
    var t = document.createElement("a"),
      o = e.join("\n\n");
    t.setAttribute(
      "href",
      "data:text/plain;charset=utf-8,".concat(encodeURIComponent(o))
    ),
      t.setAttribute("download", "tp-log-".concat(Date.now(), ".txt")),
      (t.style.display = "none"),
      document.body.appendChild(t),
      t.click(),
      document.body.removeChild(t);
  }
  function getLogTime() {
    var e = new Date();
    return (
      ""
        .concat(e.getHours(), ":")
        .concat(e.getMinutes(), ":")
        .concat(e.getSeconds()) +
      ".".concat("0000".concat(e.getMilliseconds()).slice(-3))
    );
  }
  var Logger = (function () {
    function e(e, t, o) {
      if (((this.playerId = e), (this.scopeName = t), !this.playerId))
        throw new Error("Missing logger id");
      mallocLogCache(e),
        (this.logModeConfig = __assign$1(
          {
            trace: LogMode.console,
            debug: LogMode.console,
            info: LogMode.console,
            log: LogMode.cache | LogMode.console,
            warn: LogMode.cache | LogMode.console,
            error: LogMode.cache | LogMode.console,
          },
          o
        ));
    }
    return (
      (e.prototype.trace = function () {
        for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
        this.callApi.apply(this, __spreadArray(["trace"], e, !1));
      }),
      (e.prototype.debug = function () {
        for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
        this.callApi.apply(this, __spreadArray(["debug"], e, !1));
      }),
      (e.prototype.info = function () {
        for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
        this.callApi.apply(this, __spreadArray(["info"], e, !1));
      }),
      (e.prototype.log = function () {
        for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
        this.callApi.apply(this, __spreadArray(["log"], e, !1));
      }),
      (e.prototype.warn = function () {
        for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
        this.callApi.apply(this, __spreadArray(["warn"], e, !1));
      }),
      (e.prototype.error = function () {
        for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
        this.callApi.apply(this, __spreadArray(["error"], e, !1));
      }),
      (e.prototype.cache = function () {
        for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
        var o = "log",
          A = this.getLogPrefix();
        this.callApiForCache.apply(this, __spreadArray([o, A], e, !1));
      }),
      (e.prototype.getLogPrefix = function () {
        var e = this.playerId,
          t = this.scopeName;
        return "["
          .concat(e.slice(-8), "][")
          .concat(getLogTime(), "]")
          .concat(t ? "[".concat(t, "]") : "");
      }),
      (e.prototype.callApi = function (e) {
        for (var t = [], o = 1; o < arguments.length; o++)
          t[o - 1] = arguments[o];
        var A = this.getLogPrefix();
        this.logModeConfig[e] & LogMode.console &&
          consoleOutput.apply(void 0, __spreadArray([e, A], t, !1)),
          this.callApiForCache.apply(this, __spreadArray([e, A], t, !1));
      }),
      (e.prototype.callApiForCache = function (e, t) {
        for (var o = [], A = 2; A < arguments.length; A++)
          o[A - 2] = arguments[A];
        if (this.logModeConfig[e] & LogMode.cache) {
          var i = "["
            .concat(e, "]")
            .concat(t, " ")
            .concat(stringifyLogArgs(o, this.getStringifyLogIgnoreKeys()));
          i.length >= LogCacheLimit &&
            (i = ""
              .concat(i.slice(0, LogCacheLimit), "...(")
              .concat(i.length, ")")),
            this.cacheLog(i);
        }
      }),
      (e.prototype.getStringifyLogIgnoreKeys = function () {
        return ["m3u8"];
      }),
      (e.prototype.cacheLog = function (e) {
        appendLogCache(this.playerId, e);
      }),
      Object.defineProperty(e.prototype, "ignoreKeyList", {
        get: function () {
          return [];
        },
        enumerable: !1,
        configurable: !0,
      }),
      (e.level = 0),
      e
    );
  })();
  function logTool() {}
  var AutoPlayPolicy = (function () {
      function e(e, t) {
        (this.logger = new Logger(t.instanceId, "AutoPlayPolicy")),
          (this.videoElement = e);
      }
      return (
        (e.prototype.userTrigger = function () {
          var e,
            t = this;
          (this.triggerDefer = new SimpleDefer$1()),
            this.logger.log("userTrigger(), start");
          var o = this.videoElement.play();
          if ((this.videoElement.pause(), 0 === this.videoElement.readyState))
            o &&
              o.catch(function (o) {
                e > 0 && (clearTimeout(e), (e = 0)),
                  t.logger.log("userTrigger(), catch: ", o.name, o.message),
                  videoTool$1.isAutoPlayBlockedMessage(o.message)
                    ? t.triggerDefer.reject(o)
                    : (t.logger.log("userTrigger() over, catched."),
                      t.triggerDefer.resolve());
              }),
              (e = window.setTimeout(function () {
                t.logger.log("userTrigger() over, timeout."),
                  t.triggerDefer.resolve();
              }, 300));
          else {
            this.logger.log("userTrigger() over, sync.");
            var A = uaTool$1.browser.safari && !uaTool$1.mobile ? 400 : 0;
            window.setTimeout(function () {
              t.triggerDefer.resolve();
            }, A);
          }
          return this.triggerDefer.promise;
        }),
        (e.prototype.destroy = function () {
          this.videoElement = null;
        }),
        e
      );
    })(),
    _a$4$1,
    BuiltInErrorType;
  !(function (e) {
    (e.Native = "native"),
      (e.Network = "network"),
      (e.Encryption = "encryption"),
      (e.Custom = "custom");
  })(BuiltInErrorType || (BuiltInErrorType = {}));
  var ErrorTypeCodeMap =
      ((_a$4$1 = {}),
      (_a$4$1[BuiltInErrorType.Native] = 11),
      (_a$4$1[BuiltInErrorType.Network] = 16),
      (_a$4$1[BuiltInErrorType.Encryption] = 90),
      (_a$4$1[BuiltInErrorType.Custom] = -1),
      _a$4$1),
    MediaElementNetworkErrorCode = [1, 2],
    MediaElementPlaybackErrorCode = [3, 4],
    MediaElementNativeDetail;
  !(function (e) {
    (e[(e.BaselineAVCNotSupported = 2)] = "BaselineAVCNotSupported"),
      (e[(e.HardwareAcceleratedOff = 1)] = "HardwareAcceleratedOff");
  })(MediaElementNativeDetail || (MediaElementNativeDetail = {}));
  var ErrorBase = (function () {
      function e(e, t) {
        this.detail = null;
        var o = t.code,
          A = t.detail,
          i = t.message,
          r = t.fatal,
          n = t.debugMessage;
        (this.type = e),
          (this.errorCode = o),
          (this.detail = null != A ? A : null),
          (this.fatal = null != r && r),
          (this.message =
            null != i ? i : compile(defaultI18nConfig.core.ERROR_MSG_UNKNOWN)),
          (this.debugMessage = n);
      }
      return (
        Object.defineProperty(e.prototype, "code", {
          get: function () {
            var e =
              this.type === BuiltInErrorType.Custom
                ? "".concat(this.errorCode)
                : ""
                    .concat(ThumbPlayerErrorPrefix)
                    .concat(ErrorTypeCodeMap[this.type])
                    .concat(patchCode(this.errorCode));
            return this.detail ? "".concat(e, ".").concat(this.detail) : e;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (e.prototype.equals = function (t, o) {
          return (
            void 0 === o && (o = !1),
            t instanceof e
              ? this.type === t.type &&
                this.errorCode === t.errorCode &&
                (!o || this.detail === t.detail)
              : this.code === (null == t ? void 0 : t.code)
          );
        }),
        (e.prototype.toString = function () {
          return this.serialize();
        }),
        (e.prototype.toJSON = function () {
          return this.serialize();
        }),
        (e.prototype.serialize = function () {
          var e, t;
          return "error="
            .concat(this.code, ";fatal=")
            .concat(+this.fatal, ";msg=")
            .concat(
              null !==
                (t =
                  null !== (e = this.debugMessage) && void 0 !== e
                    ? e
                    : this.message) && void 0 !== t
                ? t
                : ""
            );
        }),
        e
      );
    })(),
    ThumbPlayerErrorPrefix = "700";
  function patchCode(e) {
    return "000".concat(e).slice(-3);
  }
  var PlayerError = (function () {
    function e() {}
    return (
      (e.CustomError = function (e) {
        return new ErrorBase(BuiltInErrorType.Custom, e);
      }),
      (e.NativeError = function (e) {
        return new ErrorBase(BuiltInErrorType.Native, e);
      }),
      (e.NetworkError = function (e) {
        return new ErrorBase(BuiltInErrorType.Network, e);
      }),
      (e.EncryptionError = function (e) {
        return new ErrorBase(BuiltInErrorType.Encryption, e);
      }),
      e
    );
  })();
  function commonErrorParse(e) {
    if (e instanceof ErrorBase) return e;
    if (e) {
      var t = e.code,
        o = e.message;
      return /^(700)(\d{2})(\d{3})(\.(\d+))?$/g.test(t)
        ? e
        : PlayerError.NativeError({
            code: 0,
            detail: t,
            message: o || compile(i18nConfig.core.ERROR_MSG_UNKNOWN),
            debugMessage: o,
          });
    }
    return PlayerError.NativeError({
      code: 0,
      message: compile(i18nConfig.core.ERROR_MSG_UNKNOWN),
    });
  }
  function getVideoError(e) {
    var t,
      o = { 1: 1, 2: 2, 3: 102, 4: 103 },
      A = +(null === (t = e.error) || void 0 === t ? void 0 : t.code),
      i = {
        1: compile(i18nConfig.core.ERROR_MEDIA_ERR_ABORTED),
        2: compile(i18nConfig.core.ERROR_MEDIA_ERR_NETWORK),
        3: compile(i18nConfig.core.ERROR_MEDIA_ERR_DECODE),
        4: compile(i18nConfig.core.ERROR_MEDIA_ERR_SRC_NOT_SUPPORTED),
      }[A];
    if (MediaElementNetworkErrorCode.includes(A))
      return PlayerError.NetworkError({ code: o[A], fatal: !1, message: i });
    if (MediaElementPlaybackErrorCode.includes(A)) {
      var r = 0;
      return (
        videoTool$1.isVideoCanPlayType('video/mp4; codecs="avc1.42E01E"') ||
          (r |= MediaElementNativeDetail.BaselineAVCNotSupported),
        videoTool$1.isHardwareAccelerated() ||
          (r |= MediaElementNativeDetail.HardwareAcceleratedOff),
        PlayerError.NativeError({
          code: o[A],
          fatal: !1,
          detail: r,
          message: i,
        })
      );
    }
  }
  var CheckHealth = (function (e) {
      function t(t) {
        var o = e.call(this) || this;
        return (
          (o.stateStartTimeStamp = 0),
          (o.preFramePlaytime = 0),
          (o.playtimeStalledFrameCount = 0),
          (o.videoNode = t),
          o.setVideoNodeEvts(!0),
          o
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.loop = function () {
          var e = +new Date();
          this.checkStateStalled(e), this.checkPlaytimeStalled();
        }),
        (t.prototype.destroy = function () {
          this.setVideoNodeEvts(!1),
            this.removeAllListeners(),
            (this.stateStartTimeStamp = 0),
            (this.videoNode = null),
            (this.videoNodeEvtMap = null),
            (this.preFramePlaytime = 0),
            (this.playtimeStalledFrameCount = 0);
        }),
        (t.prototype.setVideoNodeEvts = function (e) {
          var t,
            o = this;
          this.videoNode &&
            (this.videoNodeEvtMap ||
              (this.videoNodeEvtMap =
                (((t = {})[VIDEO_NODE_EVENT.STATE_CHANGE] =
                  this.videoNodeStateChange.bind(this)),
                t)),
            Object.keys(this.videoNodeEvtMap).forEach(function (t) {
              e
                ? o.videoNode.on(t, o.videoNodeEvtMap[t])
                : o.videoNode.off(t, o.videoNodeEvtMap[t]);
            }));
        }),
        (t.prototype.videoNodeStateChange = function () {
          this.stateStartTimeStamp = +new Date();
        }),
        (t.prototype.checkStateStalled = function (e) {
          var t = this.videoNode,
            o = t.config,
            A = t.state;
          -1 !==
            [
              exports.VIDEO_STATE.BUFFERING,
              exports.VIDEO_STATE.SEEKING,
            ].indexOf(A) &&
            (this.stateStartTimeStamp <= 0 ||
              o.maxStateStalledTime <= 0 ||
              (e - this.stateStartTimeStamp > o.maxStateStalledTime &&
                ((this.stateStartTimeStamp = 0),
                this.emit(HEALTH_EVTS.STATE_STUCK, {
                  code: ERROR_CODE.STATE_STUCK,
                  message: compile(i18nConfig.core.ERROR_PLAY_STUCK),
                  state: A,
                }))));
        }),
        (t.prototype.checkPlaytimeStalled = function () {
          var e = this.videoNode,
            t = e.config,
            o = e.state,
            A = e.videoElement;
          o !== exports.VIDEO_STATE.PLAYING ||
            A.duration <= 0 ||
            A.currentTime <= 0 ||
            t.maxPlaytimeStalledTime <= 0 ||
            (this.preFramePlaytime > 0 &&
              (this.preFramePlaytime !== A.currentTime
                ? (this.playtimeStalledFrameCount = 0)
                : (this.playtimeStalledFrameCount++,
                  16.7 * this.playtimeStalledFrameCount >
                    t.maxPlaytimeStalledTime &&
                    ((this.playtimeStalledFrameCount = 0),
                    this.emit(HEALTH_EVTS.PLAYTIME_STUCK, {
                      code: ERROR_CODE.ORG_PLAY_STUCK_ERR,
                      message: compile(i18nConfig.core.ERROR_PLAY_STUCK),
                      state: o,
                    })))),
            (this.preFramePlaytime = A.currentTime));
        }),
        t
      );
    })(s$1$1),
    HEALTH_EVTS;
  !(function (e) {
    (e.STATE_STUCK = "state-stuck"), (e.PLAYTIME_STUCK = "playtime-stuck");
  })(HEALTH_EVTS || (HEALTH_EVTS = {}));
  var CheckVideoNodeStatus = (function () {
      function e(e) {
        this.videoNode = e;
      }
      return (
        (e.prototype.checkIsSetLevelOver = function (e, t) {
          var o;
          if (
            (void 0 === e && (e = VIDEO_EVTS.playing),
            void 0 === t && (t = 0),
            !(null === (o = this.videoNode) || void 0 === o
              ? void 0
              : o.videoElement))
          )
            throw new Error("Target VideoNode is null!");
          if (!this.videoNode.getLevelSwitching()) return null;
          var A = !1,
            i = !1,
            r = !1;
          if (this.videoNode.config.type === exports.PLAY_MODE.LIVE)
            (A = e === VIDEO_EVTS.playing), (r = e === VIDEO_EVTS.timeupdate);
          else {
            var n = videoTool$1.supportMediaFragmentsURISpec(
              this.videoNode.config.enableMediaFragmentsURI
            );
            (A = e === VIDEO_EVTS.playing && n),
              (i = e === VIDEO_EVTS.seeked && !n);
            var a = this.videoNode.videoElement.currentTime - t >= 0.3;
            r = e === VIDEO_EVTS.timeupdate && a;
          }
          return A || i || r
            ? { succInPlaying: A, succInSeeked: i, succInTimeupdate: r }
            : null;
        }),
        (e.prototype.checkCanSetLevel = function () {
          return this.videoNode
            ? this.videoNode.played
              ? this.videoNode.getLevelSwitching()
                ? { canSetLevel: !1, message: "setLevel(), in progress." }
                : !this.videoNode.currentVideoInfo ||
                  this.videoNode.currentVideoInfo.playtime <= 0
                ? {
                    canSetLevel: !1,
                    message: "setLevel(), setLevel can't start.",
                  }
                : this.videoNode.config.type === exports.PLAY_MODE.VOD &&
                  this.videoNode.currentVideoInfo.playtime + 1 >=
                    this.videoNode.currentVideoInfo.duration
                ? {
                    canSetLevel: !1,
                    message: "setLevel(), video is about to end.",
                  }
                : { canSetLevel: !0, message: "setLevel(), can set level now" }
              : {
                  canSetLevel: !1,
                  message: "setLevel(), play is not triggered.",
                }
            : { canSetLevel: !1, message: "videoNode is null" };
        }),
        (e.prototype.checkCanSeek = function (e) {
          var t;
          if (
            !(null === (t = this.videoNode) || void 0 === t
              ? void 0
              : t.currentVideoInfo)
          )
            return {
              canSeek: !1,
              message: "seek(), because videonode or videoInfo is null",
            };
          if (this.videoNode.videoElement.duration <= 0)
            return {
              canSeek: !1,
              message: "seek(), cannot seek when the duration is 0",
            };
          var o = e || {},
            A = o.seektime,
            i = void 0 === A ? NaN : A,
            r = o.userActivation,
            n = void 0 !== r && r,
            a = o.setLevelMode,
            s = void 0 === a ? SET_LEVEL_MODE.HARD : a;
          return Number.isNaN(i)
            ? { canSeek: !1, message: "target time is NaN" }
            : i - this.videoNode.currentVideoInfo.duration >= 1
            ? {
                canSeek: !1,
                message:
                  "seek(), return because too large time, uid="
                    .concat(this.videoNode.currentVideoInfo.uid, "/idx=")
                    .concat(this.videoNode.idx, "/time=")
                    .concat(i) +
                  "/duration=".concat(this.videoNode.currentVideoInfo.duration),
              }
            : void 0 !== s &&
              s !== SET_LEVEL_MODE.SMOOTH &&
              this.videoNode.getLevelSwitching() &&
              n
            ? {
                canSeek: !1,
                message: "seek(), cannot seek when hard/soft level switching",
              }
            : { canSeek: !0, message: "seek(), can seek now" };
        }),
        (e.prototype.checkCanSetAudioTrack = function (e) {
          return e
            ? { canSetAudioTrack: !1, message: "setAudioTrack(), in progress" }
            : this.videoNode
            ? this.videoNode.hasAltAudio
              ? this.videoNode.played
                ? {
                    canSetAudioTrack: !0,
                    message: "setAudioTrack(), can set audio track now",
                  }
                : {
                    canSetAudioTrack: !1,
                    message:
                      "setAudioTrack(), can only be invoked after content plays",
                  }
              : {
                  canSetAudioTrack: !1,
                  message:
                    "setAudioTrack(), current content does not contain alternative audio track",
                }
            : {
                canSetAudioTrack: !1,
                message: "setAudioTrack(), because videonode is null",
              };
        }),
        (e.prototype.destroy = function () {
          this.videoNode = null;
        }),
        e
      );
    })(),
    kernelEvtBus = new s$1$1(),
    preloadEvtBus = new s$1$1(),
    LatencyController = (function () {
      function e(e, t, o, A, i) {
        var r = this;
        (this.onLatencyExceeded = function () {}),
          (this.onLatencyDropped = function () {}),
          (this.latencyCalculationMethod = defaultLatencyCalculationMethod),
          (this.setupEvents = function () {
            r.media.addEventListener("timeupdate", r.onTimeUpdate);
          }),
          (this.onTimeUpdate = function () {
            var e = r.media,
              t = e.buffered,
              o = e.currentTime;
            if (!e.paused) {
              var A = r.latencyCalculationMethod(o, t);
              A < 0 ||
                isNaN(A) ||
                (A > r.config.expectedLatency && 1 !== r.state
                  ? (r.onLatencyExceeded(o, A, r.media), (r.state = 1))
                  : A <= r.config.minLatency &&
                    0 !== r.state &&
                    (r.onLatencyDropped(o, A, r.media), (r.state = 0)));
            }
          }),
          (this.media = e),
          (this.playerConfig = t),
          (this.state = 0),
          "function" == typeof o && (this.onLatencyExceeded = o),
          "function" == typeof A && (this.onLatencyDropped = A),
          "function" == typeof i && (this.latencyCalculationMethod = i),
          this.setupEvents();
      }
      return (
        Object.defineProperty(e.prototype, "config", {
          get: function () {
            return __assign$1(
              __assign$1({}, defaultConfig),
              this.playerConfig.latencyConfig
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (e.prototype.destroy = function () {
          this.media.removeEventListener("timeupdate", this.onTimeUpdate),
            (this.onLatencyExceeded = null),
            (this.onLatencyDropped = null),
            (this.latencyCalculationMethod = null);
        }),
        e
      );
    })(),
    defaultConfig = { expectedLatency: 5, minLatency: 2, syncSpeed: 1.75 };
  function defaultLatencyCalculationMethod(e, t) {
    if (!(t.length > 0 && e > 0)) return -1;
    for (var o = 0; o < t.length; o++) {
      var A = t.start(o),
        i = t.end(o);
      if (e >= A && e <= i) return i - e;
    }
  }
  var Loading = (function () {
      function e(e) {
        (this.delayTimeoutId = 0), (this.evtEmiter = e);
      }
      return (
        (e.prototype.show = function (e) {
          var t = this;
          void 0 === e && (e = 0),
            this.evtEmiter &&
              (this.clearDelay(),
              0 !== e
                ? (this.delayTimeoutId = window.setTimeout(function () {
                    t.evtEmiter.emit(VIDEO_NODE_EVENT.SET_LOADING, {
                      show: !0,
                    });
                  }, e))
                : this.evtEmiter.emit(VIDEO_NODE_EVENT.SET_LOADING, {
                    show: !0,
                  }));
        }),
        (e.prototype.hide = function () {
          this.evtEmiter &&
            (this.clearDelay(),
            this.evtEmiter.emit(VIDEO_NODE_EVENT.SET_LOADING, { show: !1 }));
        }),
        (e.prototype.clearDelay = function () {
          this.delayTimeoutId > 0 &&
            (window.clearTimeout(this.delayTimeoutId),
            (this.delayTimeoutId = 0));
        }),
        e
      );
    })(),
    PerformanceMonitor = (function () {
      function e(e) {
        (this.totalVideoFrames = 0),
          (this.droppedVideoFrames = 0),
          (this.totalDecodeTimeInMs = 0),
          (this.presentedVideoFrames = 0),
          (this.preTotalVideoFrames = -1),
          (this.preDroppedVideoFrames = -1),
          (this.calcIntervalFrameDroppedTickCount = 0),
          (this.video = e);
      }
      return (
        (e.prototype.calcIntervalFrameDropped = function () {
          if (
            (this.calcIntervalFrameDroppedTickCount++,
            !(this.calcIntervalFrameDroppedTickCount < 5))
          ) {
            if (
              ((this.calcIntervalFrameDroppedTickCount = 0),
              this.preVisiblityState !== document.visibilityState)
            )
              this.reset();
            else if ("visible" === this.preVisiblityState) {
              var e = videoTool$1.getVideoPlaybackQuality(this.video),
                t = e.totalVideoFrames,
                o = e.droppedVideoFrames;
              -1 === this.preTotalVideoFrames && (this.preTotalVideoFrames = t),
                -1 === this.preDroppedVideoFrames &&
                  (this.preDroppedVideoFrames = o);
              var A = t - this.preTotalVideoFrames,
                i = o - this.preDroppedVideoFrames;
              if (
                ((this.preTotalVideoFrames = t),
                (this.preDroppedVideoFrames = o),
                A > 0)
              )
                return i / A;
            }
            return 0;
          }
        }),
        (e.prototype.reset = function () {
          (this.preTotalVideoFrames = -1),
            (this.preDroppedVideoFrames = -1),
            (this.preVisiblityState = document.visibilityState);
        }),
        (e.prototype.report = function () {
          var e = videoTool$1.getVideoPlaybackQuality(this.video),
            t = e.totalVideoFrames,
            o = e.droppedVideoFrames;
          (this.totalVideoFrames = t), (this.droppedVideoFrames = o);
          var A = this.totalDecodeTimeInMs / this.presentedVideoFrames;
          isNaN(A) && (A = -1);
          var i = (this.droppedVideoFrames / this.totalVideoFrames) * 100;
          return (
            isNaN(i) && (i = -1),
            {
              totalDecodeTimeInMs: this.totalDecodeTimeInMs,
              droppedVideoFrames: this.droppedVideoFrames,
              presentedVideoFrames: this.presentedVideoFrames,
              totalVideoFrames: this.totalVideoFrames,
              averageDecodeTimeInMs: A,
              frameDroppedInPercentage: i,
            }
          );
        }),
        e
      );
    })(),
    _a$3$1,
    VALID_PREVIOUS_STATE_MAP =
      ((_a$3$1 = {}),
      (_a$3$1[exports.VIDEO_STATE.LOAD_START] = [exports.VIDEO_STATE.IDLE]),
      (_a$3$1[exports.VIDEO_STATE.CANPLAY] = [exports.VIDEO_STATE.LOAD_START]),
      (_a$3$1[exports.VIDEO_STATE.PLAYING] = [
        exports.VIDEO_STATE.CANPLAY,
        exports.VIDEO_STATE.SEEKED,
        exports.VIDEO_STATE.PAUSE,
        exports.VIDEO_STATE.BUFFERING,
      ]),
      (_a$3$1[exports.VIDEO_STATE.BUFFERING] = [exports.VIDEO_STATE.PLAYING]),
      (_a$3$1[exports.VIDEO_STATE.PAUSE] = [
        exports.VIDEO_STATE.PLAYING,
        exports.VIDEO_STATE.BUFFERING,
      ]),
      (_a$3$1[exports.VIDEO_STATE.SEEKING] = [
        exports.VIDEO_STATE.CANPLAY,
        exports.VIDEO_STATE.PLAYING,
        exports.VIDEO_STATE.PAUSE,
        exports.VIDEO_STATE.BUFFERING,
        exports.VIDEO_STATE.SEEKING,
      ]),
      (_a$3$1[exports.VIDEO_STATE.SEEKED] = [exports.VIDEO_STATE.SEEKING]),
      (_a$3$1[exports.VIDEO_STATE.END] = [
        exports.VIDEO_STATE.LOAD_START,
        exports.VIDEO_STATE.CANPLAY,
        exports.VIDEO_STATE.SEEKING,
        exports.VIDEO_STATE.SEEKED,
        exports.VIDEO_STATE.BUFFERING,
        exports.VIDEO_STATE.PLAYING,
        exports.VIDEO_STATE.PAUSE,
      ]),
      (_a$3$1[exports.VIDEO_STATE.IDLE] = [exports.VIDEO_STATE.END]),
      _a$3$1),
    VALID_STATE_IN_LEVEL_SWITCHING = [
      exports.VIDEO_STATE.PAUSE,
      exports.VIDEO_STATE.PLAYING,
      exports.VIDEO_STATE.END,
      exports.VIDEO_STATE.IDLE,
    ],
    logMethodCall$7 = logMethodCallDecoratorCreator("StateMgr"),
    StateMgr = (function () {
      function e(e) {
        var t;
        (this.videoEvtHandler =
          (((t = {})[VIDEO_EVTS.canplay] = this.onCanplayEvt.bind(this)),
          (t[VIDEO_EVTS.playing] = this.setPlaying.bind(this)),
          (t[VIDEO_EVTS.waiting] = this.setWaiting.bind(this)),
          (t[VIDEO_EVTS.pause] = this.onPauseEvt.bind(this)),
          (t[VIDEO_EVTS.seeking] = this.onSeekingEvt.bind(this)),
          (t[VIDEO_EVTS.seeked] = this.onSeekedEvt.bind(this)),
          t)),
          (this.videoNode = e),
          (this.logger = new Logger(e.config.instanceId, "StateMgr"));
      }
      return (
        (e.prototype.destroy = function () {
          this.videoNode = null;
        }),
        (e.prototype.validCallState = function (e) {
          var t;
          return null === (t = VALID_PREVIOUS_STATE_MAP[e]) || void 0 === t
            ? void 0
            : t.includes(this.videoNode.state);
        }),
        (e.prototype.setEnded = function () {
          this.setVideoNodeState(exports.VIDEO_STATE.END),
            this.setVideoNodeState(exports.VIDEO_STATE.IDLE);
        }),
        (e.prototype.setLoadStart = function () {
          this.setVideoNodeState(exports.VIDEO_STATE.LOAD_START);
        }),
        (e.prototype.setCanplay = function () {
          this.setVideoNodeState(exports.VIDEO_STATE.CANPLAY);
        }),
        (e.prototype.setWaiting = function () {
          this.setVideoNodeState(exports.VIDEO_STATE.BUFFERING);
        }),
        (e.prototype.setPlaying = function () {
          this.setVideoNodeState(exports.VIDEO_STATE.PLAYING);
        }),
        (e.prototype.onSetLevelOver = function () {
          this.videoNode.state === exports.VIDEO_STATE.PAUSE &&
            this.setVideoNodeState(exports.VIDEO_STATE.PLAYING);
        }),
        (e.prototype.receiveVideoEvt = function (e) {
          var t, o;
          null === (o = (t = this.videoEvtHandler)[e]) ||
            void 0 === o ||
            o.call(t);
        }),
        (e.prototype.setVideoNodeState = function (e) {
          !this.videoNode.getLevelSwitching() ||
          VALID_STATE_IN_LEVEL_SWITCHING.includes(e)
            ? VALID_PREVIOUS_STATE_MAP[e].includes(this.videoNode.state)
              ? (this.videoNode.state = e)
              : this.logger.log(
                  "can not set state from "
                    .concat(this.videoNode.state, " to ")
                    .concat(e)
                )
            : this.logger.log(
                "can not set state 2 ".concat(e, " when level switching")
              );
        }),
        (e.prototype.onCanplayEvt = function () {
          (uaTool$1.os.ios || uaTool$1.browser.safari) &&
          this.isVideoElementPlaying() &&
          this.videoNode.state === exports.VIDEO_STATE.BUFFERING
            ? this.setVideoNodeState(exports.VIDEO_STATE.PLAYING)
            : this.setVideoNodeState(exports.VIDEO_STATE.CANPLAY);
        }),
        (e.prototype.onPauseEvt = function () {
          this.setVideoNodeState(exports.VIDEO_STATE.PAUSE);
        }),
        (e.prototype.onSeekingEvt = function () {
          this.setVideoNodeState(exports.VIDEO_STATE.SEEKING);
        }),
        (e.prototype.onSeekedEvt = function () {
          this.setVideoNodeState(exports.VIDEO_STATE.SEEKED),
            (uaTool$1.os.ios || uaTool$1.browser.safari) &&
              this.isVideoElementPlaying() &&
              this.setVideoNodeState(exports.VIDEO_STATE.PLAYING);
        }),
        (e.prototype.isVideoElementPlaying = function () {
          return (
            !this.videoNode.videoElement.paused &&
            !this.videoNode.videoElement.ended
          );
        }),
        __decorate(
          [
            logMethodCall$7,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          e.prototype,
          "destroy",
          null
        ),
        __decorate(
          [
            logMethodCall$7,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String]),
            __metadata("design:returntype", void 0),
          ],
          e.prototype,
          "validCallState",
          null
        ),
        __decorate(
          [
            logMethodCall$7,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          e.prototype,
          "setEnded",
          null
        ),
        __decorate(
          [
            logMethodCall$7,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          e.prototype,
          "setLoadStart",
          null
        ),
        __decorate(
          [
            logMethodCall$7,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          e.prototype,
          "setCanplay",
          null
        ),
        __decorate(
          [
            logMethodCall$7,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          e.prototype,
          "setWaiting",
          null
        ),
        __decorate(
          [
            logMethodCall$7,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          e.prototype,
          "setPlaying",
          null
        ),
        e
      );
    })(),
    VideoFillType;
  !(function (e) {
    (e.COVER = "cover"), (e.CONTAIN = "contain");
  })(VideoFillType || (VideoFillType = {}));
  var VideoResizeAutoFill = (function () {
      function e(e, t) {
        void 0 === t && (t = 10),
          (this.minFillBlackBorder = 10),
          (this.videoElement = e),
          (this.minFillBlackBorder = t),
          this.addToObserver();
      }
      return (
        (e.prototype.resizeAutoFill = function () {
          if (
            this.videoElement instanceof HTMLVideoElement &&
            !(this.minFillBlackBorder <= 0) &&
            0 !== this.videoElement.videoWidth &&
            0 !== this.videoElement.videoHeight
          ) {
            var e = domTool$1.getDomSize(this.videoElement),
              t = e.width,
              o = e.height,
              A =
                this.videoElement.videoWidth *
                (o / this.videoElement.videoHeight),
              i =
                this.videoElement.videoHeight *
                (t / this.videoElement.videoWidth);
            (A < t && A >= t - this.minFillBlackBorder) ||
            (i < o && i >= o - this.minFillBlackBorder)
              ? videoTool$1.setElementFitType(
                  this.videoElement,
                  VideoFillType.COVER
                )
              : videoTool$1.setElementFitType(
                  this.videoElement,
                  VideoFillType.CONTAIN
                );
          }
        }),
        (e.prototype.destroy = function () {
          this.videoElement &&
            this.videoElement instanceof HTMLVideoElement &&
            this.videoResizeObserver &&
            (this.videoResizeObserver.disconnect(),
            this.videoResizeObserver.unobserve(this.videoElement),
            (this.videoResizeObserver = null),
            (this.videoElement = null));
        }),
        (e.prototype.addToObserver = function () {
          var e = this;
          this.videoElement &&
            this.videoElement instanceof HTMLVideoElement &&
            ((this.videoResizeObserver = new ResizeObserver(function () {
              e.resizeAutoFill();
            })),
            this.videoResizeObserver.observe(this.videoElement));
        }),
        e
      );
    })(),
    _a$2$1;
  function isEnvSupport() {
    return (
      !(!window.AudioContext && !window.webkitAudioContext) &&
      !uaTool$1.browser.safari
    );
  }
  function getPreCfgByName(e, t) {
    return t.find(function (t) {
      return t.name === e;
    });
  }
  function dbToGainValue(e) {
    return Math.pow(10, e / dbConstant);
  }
  var dbConstant = 20,
    AUDIO_EFFECT_NAME,
    AUDIO_CONTEXT_STATE;
  !(function (e) {
    (e.DEFAULT = "default"),
      (e.SPATIAL_STEREO = "spatial_stereo"),
      (e.BASE_BOOSTER = "base_booster"),
      (e.VOCAL_BOOSTER = "vocal_booster"),
      (e.VOCAL_WEAK = "vocal_weak"),
      (e.POP = "pop"),
      (e.CLASSICAL = "classcal"),
      (e.ELECTRONIC = "electronic"),
      (e.GUITAR = "guitar"),
      (e.HIPHOP = "hiphop"),
      (e.JAZZ = "jazz"),
      (e.RNB = "rnb"),
      (e.ROCK_N_ROLL = "rocknroll"),
      (e.CONCERT_HALL = "concert_hall"),
      (e.LIVE = "live"),
      (e.LIVING_ROOM = "living_room");
  })(AUDIO_EFFECT_NAME || (AUDIO_EFFECT_NAME = {})),
    (function (e) {
      (e.RUNNING = "running"),
        (e.SUSPENDED = "suspended"),
        (e.CLOSED = "closed");
    })(AUDIO_CONTEXT_STATE || (AUDIO_CONTEXT_STATE = {}));
  var AUDIO_EFFECT_CNNAME =
      ((_a$2$1 = {}),
      (_a$2$1[AUDIO_EFFECT_NAME.DEFAULT] =
        i18nConfig.core.INFO_AUDIO_EFFECT_DEFAULT),
      (_a$2$1[AUDIO_EFFECT_NAME.SPATIAL_STEREO] =
        i18nConfig.core.INFO_AUDIO_EFFECT_SPATIAL_STEREO),
      (_a$2$1[AUDIO_EFFECT_NAME.BASE_BOOSTER] =
        i18nConfig.core.INFO_AUDIO_EFFECT_BASE_BOOSTER),
      (_a$2$1[AUDIO_EFFECT_NAME.VOCAL_BOOSTER] =
        i18nConfig.core.INFO_AUDIO_EFFECT_VOCAL_BOOSTER),
      (_a$2$1[AUDIO_EFFECT_NAME.VOCAL_WEAK] =
        i18nConfig.core.INFO_AUDIO_EFFECT_VOCAL_WEAK),
      (_a$2$1[AUDIO_EFFECT_NAME.POP] = i18nConfig.core.INFO_AUDIO_EFFECT_POP),
      (_a$2$1[AUDIO_EFFECT_NAME.CLASSICAL] =
        i18nConfig.core.INFO_AUDIO_EFFECT_CLASSICAL),
      (_a$2$1[AUDIO_EFFECT_NAME.ELECTRONIC] =
        i18nConfig.core.INFO_AUDIO_EFFECT_ELECTRONIC),
      (_a$2$1[AUDIO_EFFECT_NAME.GUITAR] =
        i18nConfig.core.INFO_AUDIO_EFFECT_GUITAR),
      (_a$2$1[AUDIO_EFFECT_NAME.HIPHOP] =
        i18nConfig.core.INFO_AUDIO_EFFECT_HIPHOP),
      (_a$2$1[AUDIO_EFFECT_NAME.JAZZ] = i18nConfig.core.INFO_AUDIO_EFFECT_JAZZ),
      (_a$2$1[AUDIO_EFFECT_NAME.RNB] = i18nConfig.core.INFO_AUDIO_EFFECT_RNB),
      (_a$2$1[AUDIO_EFFECT_NAME.ROCK_N_ROLL] =
        i18nConfig.core.INFO_AUDIO_EFFECT_ROCK_N_ROLL),
      (_a$2$1[AUDIO_EFFECT_NAME.CONCERT_HALL] =
        i18nConfig.core.INFO_AUDIO_EFFECT_CONCERT_HALL),
      (_a$2$1[AUDIO_EFFECT_NAME.LIVE] = i18nConfig.core.INFO_AUDIO_EFFECT_LIVE),
      (_a$2$1[AUDIO_EFFECT_NAME.LIVING_ROOM] =
        i18nConfig.core.INFO_AUDIO_EFFECT_LIVING_ROOM),
      _a$2$1),
    AUDIO_EFFECT_DISPLAYLIST = [
      AUDIO_EFFECT_NAME.SPATIAL_STEREO,
      AUDIO_EFFECT_NAME.VOCAL_BOOSTER,
      AUDIO_EFFECT_NAME.BASE_BOOSTER,
      AUDIO_EFFECT_NAME.CLASSICAL,
      AUDIO_EFFECT_NAME.ROCK_N_ROLL,
      AUDIO_EFFECT_NAME.LIVE,
    ],
    audioSourceNodes = new WeakMap();
  function closeAudioSourceNode(e) {
    if (null == audioSourceNodes ? void 0 : audioSourceNodes.has(e)) {
      var t = audioSourceNodes.get(e).context;
      t && t.state !== AUDIO_CONTEXT_STATE.CLOSED && t.close(),
        audioSourceNodes.delete(e);
    }
  }
  var BaseAudioEffector = (function () {
      function e(e, t) {
        (this.using = !1),
          (this.effectorName = "BaseAudio"),
          (this.audioCtx = e),
          (this.logger = t);
      }
      return (
        (e.prototype.connectBy = function (e) {
          return e || null;
        }),
        (e.prototype.disconnect = function () {
          var e;
          null === (e = this.logger) ||
            void 0 === e ||
            e.log("".concat(this.effectorName, " disconnect()"));
        }),
        (e.prototype.destroy = function () {
          var e;
          this.disconnect(),
            null === (e = this.logger) ||
              void 0 === e ||
              e.log("".concat(this.effectorName, " destroy()")),
            (this.logger = null);
        }),
        (e.prototype.getEffectorName = function () {
          return this.effectorName;
        }),
        (e.prototype.setPreConfigName = function (e) {
          var t;
          e !== this.currPreCfgName &&
            ((this.currPreCfgName = e),
            null === (t = this.logger) ||
              void 0 === t ||
              t.log(
                "BaseAudioEffector setPreConfigName(), currPreCfgName=".concat(
                  e
                )
              ));
        }),
        (e.prototype.getPreConfigName = function () {
          return this.currPreCfgName;
        }),
        e
      );
    })(),
    CompressorEffector = (function (e) {
      function t(t, o) {
        var A = e.call(this, t, o) || this;
        return (
          (A.effectorName = "Compressor"),
          (A.compressor = t.createDynamicsCompressor()),
          A
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.connectBy = function (e) {
          return e && this.compressor
            ? (e.connect(this.compressor),
              this.setPreConfigName(AUDIO_EFFECT_NAME.DEFAULT),
              this.compressor)
            : null;
        }),
        (t.prototype.disconnect = function () {
          var e;
          this.compressor &&
            (this.compressor.disconnect(),
            null === (e = this.logger) ||
              void 0 === e ||
              e.log("".concat(this.effectorName, " disconnect()")));
        }),
        (t.prototype.destroy = function () {
          e.prototype.destroy.call(this), (this.compressor = null);
        }),
        (t.prototype.setPreConfigName = function (e) {
          var t;
          e !== this.currPreCfgName &&
            this.compressor &&
            ((this.currPreCfgName = e),
            (this.compressor.attack.value = cpsPreCfg.attack),
            (this.compressor.knee.value = cpsPreCfg.knee),
            (this.compressor.ratio.value = cpsPreCfg.ratio),
            (this.compressor.release.value = cpsPreCfg.release),
            (this.compressor.threshold.value = cpsPreCfg.threshold),
            null === (t = this.logger) ||
              void 0 === t ||
              t.log(
                "CompressorEffector setPreConfigName() effectName=".concat(e)
              ));
        }),
        t
      );
    })(BaseAudioEffector),
    cpsPreCfg = {
      attack: 0.003,
      knee: 30,
      ratio: 12,
      release: 0.25,
      threshold: -24,
    },
    EqualizerEffector = (function (e) {
      function t(t, o) {
        var A = e.call(this, t, o) || this;
        return (
          (A.audioFrequency = [
            31, 62, 125, 250, 500, 1e3, 2e3, 4e3, 8e3, 16e3,
          ]),
          (A.lowHz = 62),
          (A.highHz = 8e3),
          (A.peakQuality = 0.8),
          (A.gainTimeConstant = 0.02),
          (A.effectorName = "Equalizer"),
          (A.inputNode = t.createGain()),
          (A.outputNode = t.createGain()),
          (A.biquadFilterList = []),
          A
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.connectBy = function (e) {
          return e && this.inputNode
            ? (0 === this.biquadFilterList.length &&
                this.setPreConfigName(AUDIO_EFFECT_NAME.DEFAULT),
              e.connect(this.inputNode),
              this.outputNode)
            : null;
        }),
        (t.prototype.disconnect = function () {
          var e;
          this.outputNode &&
            (this.outputNode.disconnect(),
            null === (e = this.logger) ||
              void 0 === e ||
              e.log("".concat(this.effectorName, " disconnect()")));
        }),
        (t.prototype.destroy = function () {
          var e;
          this.inputNode &&
            (this.inputNode.disconnect(),
            this.outputNode.disconnect(),
            (this.inputNode = null),
            (this.outputNode = null),
            0 !== this.biquadFilterList.length &&
              (this.biquadFilterList.forEach(function (e) {
                e.disconnect();
              }),
              this.biquadFilterList.splice(0, this.biquadFilterList.length),
              null === (e = this.logger) ||
                void 0 === e ||
                e.log("".concat(this.effectorName, " destroy()")),
              (this.logger = null)));
        }),
        (t.prototype.setPreConfigName = function (e) {
          var t;
          if (e !== this.currPreCfgName && this.inputNode) {
            this.currPreCfgName = e;
            var o = getPreCfgByName(e, eqPreCfgList);
            if (o) {
              null === (t = this.logger) ||
                void 0 === t ||
                t.log(
                  "EqualizerEffector setPreConfigName() effectName=".concat(e)
                );
              for (
                var A = this.inputNode, i = 0;
                i < this.audioFrequency.length;
                i++
              ) {
                var r = this.audioFrequency[i],
                  n = void 0;
                this.biquadFilterList.length !== this.audioFrequency.length
                  ? ((n = this.audioCtx.createBiquadFilter()),
                    this.biquadFilterList.push(n),
                    A && A.connect(n),
                    this.biquadFilterList.length ===
                      this.audioFrequency.length && n.connect(this.outputNode))
                  : (n = this.biquadFilterList[i]),
                  r <= this.lowHz
                    ? (n.type = biquadFilterType.LOWSHELF)
                    : r >= this.highHz
                    ? (n.type = biquadFilterType.HIGHSHELF)
                    : ((n.Q.value = this.peakQuality),
                      (n.type = biquadFilterType.PEAKING)),
                  n.frequency.setValueAtTime(r, this.audioCtx.currentTime),
                  n.gain.setTargetAtTime(
                    o.eq[i],
                    this.audioCtx.currentTime,
                    this.gainTimeConstant
                  ),
                  (A = n);
              }
            }
          }
        }),
        t
      );
    })(BaseAudioEffector),
    eqPreCfgList = [
      { name: AUDIO_EFFECT_NAME.DEFAULT, eq: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
      {
        name: AUDIO_EFFECT_NAME.BASE_BOOSTER,
        eq: [6, 5, 5, 3, 1, 0, 0, 0, 0, 0],
      },
      {
        name: AUDIO_EFFECT_NAME.VOCAL_BOOSTER,
        eq: [-2, -3, -3, 1, 4, 4, 3, 1, 0, -2],
      },
      {
        name: AUDIO_EFFECT_NAME.VOCAL_WEAK,
        eq: [3, 2, 0, -1, -3, -3, -4, -3, -3, 2],
      },
      { name: AUDIO_EFFECT_NAME.POP, eq: [-2, -1, 0, 2, 4, 4, 2, 0, -1, -2] },
      {
        name: AUDIO_EFFECT_NAME.CLASSICAL,
        eq: [4.5, 4, 3, 2, -1, -1, 0, 2, 3, 4],
      },
      {
        name: AUDIO_EFFECT_NAME.ELECTRONIC,
        eq: [5, 3, 1, 0, -2, 2, 0.5, 1, 4, 5],
      },
      {
        name: AUDIO_EFFECT_NAME.GUITAR,
        eq: [-5, -3, -2, 2, -0.5, 0, 0, 2, 6, 0],
      },
      { name: AUDIO_EFFECT_NAME.HIPHOP, eq: [5, 4, 1, 3, -1, -1, 1, -1, 2, 3] },
      { name: AUDIO_EFFECT_NAME.JAZZ, eq: [4, 3, 1, 2, -2, -2, 0, 1, 3, 4] },
      { name: AUDIO_EFFECT_NAME.RNB, eq: [3, 7, 6, 2, -3, -2, 2, 3, 3, 4] },
      {
        name: AUDIO_EFFECT_NAME.ROCK_N_ROLL,
        eq: [5, 4, 3, 2, -1, -1, 1, 3, 4, 5],
      },
    ],
    biquadFilterType;
  !(function (e) {
    (e.LOWPASS = "lowpass"),
      (e.HIGHTPASS = "highpass"),
      (e.BANDPASS = "bandpass"),
      (e.LOWSHELF = "lowshelf"),
      (e.HIGHSHELF = "highshelf"),
      (e.PEAKING = "peaking");
  })(biquadFilterType || (biquadFilterType = {}));
  var GainEffector = (function (e) {
      function t(t, o) {
        var A = e.call(this, t, o) || this;
        return (
          (A.maxGainValue = 2),
          (A.minGainValue = 0),
          (A.currentGainValue = A.minGainValue),
          (A.gainTimeConstant = 0.02),
          (A.effectorName = "Gain"),
          (A.gainNode = t.createGain()),
          A
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.connectBy = function (e) {
          return e ? (e.connect(this.gainNode), this.gainNode) : null;
        }),
        (t.prototype.disconnect = function () {
          var e;
          this.gainNode &&
            (this.gainNode.disconnect(),
            null === (e = this.logger) ||
              void 0 === e ||
              e.log("".concat(this.effectorName, " disconnect()")));
        }),
        (t.prototype.destroy = function () {
          e.prototype.destroy.call(this), (this.gainNode = null);
        }),
        (t.prototype.getGainValue = function () {
          return this.currentGainValue;
        }),
        (t.prototype.setGainValue = function (e) {
          var t;
          if (this.gainNode) {
            (this.currentGainValue = Math.max(e, this.minGainValue)),
              (this.currentGainValue = Math.min(
                this.currentGainValue,
                this.maxGainValue
              ));
            var o = 10 * (this.currentGainValue - this.minGainValue);
            this.gainNode.gain.setTargetAtTime(
              dbToGainValue(o),
              this.audioCtx.currentTime,
              this.gainTimeConstant
            ),
              null === (t = this.logger) ||
                void 0 === t ||
                t.log(
                  "GainEffector setGainValue() value="
                    .concat(e, ",db=")
                    .concat(o)
                );
          }
        }),
        t
      );
    })(BaseAudioEffector),
    ReverbEffector = (function (e) {
      function t(t, o) {
        var A = e.call(this, t, o) || this;
        return (
          (A.channelNum = 2),
          (A.dryWetConstant = 0.5),
          (A.lowPassFrequency = 7e3),
          (A.highPassFrequency = 0),
          (A.effectorName = "Reverb"),
          (A.lowPassBfNode = t.createBiquadFilter()),
          (A.lowPassBfNode.type = biquadFilterType.LOWPASS),
          (A.highPassBfNode = t.createBiquadFilter()),
          (A.highPassBfNode.type = biquadFilterType.HIGHTPASS),
          (A.reverbNode = t.createConvolver()),
          (A.dryGainNode = t.createGain()),
          (A.wetGainNode = t.createGain()),
          (A.inputNode = t.createGain()),
          (A.outputNode = t.createGain()),
          A
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.connectBy = function (e) {
          return e && this.inputNode
            ? (e.connect(this.inputNode),
              this.setPreConfigName(AUDIO_EFFECT_NAME.DEFAULT),
              this.outputNode)
            : null;
        }),
        (t.prototype.disconnect = function () {
          var e;
          this.disconnectInnerNode(),
            this.outputNode && this.outputNode.disconnect(),
            null === (e = this.logger) ||
              void 0 === e ||
              e.log("".concat(this.effectorName, " disconnect()"));
        }),
        (t.prototype.destroy = function () {
          var e;
          this.disconnect(),
            (this.inputNode = null),
            (this.lowPassBfNode = null),
            (this.highPassBfNode = null),
            (this.reverbNode = null),
            (this.dryGainNode = null),
            (this.wetGainNode = null),
            (this.outputNode = null),
            null === (e = this.logger) ||
              void 0 === e ||
              e.log("".concat(this.effectorName, " destroy()")),
            (this.logger = null);
        }),
        (t.prototype.setPreConfigName = function (e) {
          var t, o, A;
          if (e !== this.currPreCfgName && this.inputNode)
            if (
              ((this.currPreCfgName = e),
              this.reconnect(),
              this.currPreCfgName !== AUDIO_EFFECT_NAME.DEFAULT)
            ) {
              var i = getPreCfgByName(e, rvbPreCfgList);
              if (i) {
                (this.reverbNode.buffer = this.rebuildImpulse(i)),
                  this.lowPassBfNode.frequency.setValueAtTime(
                    this.lowPassFrequency,
                    this.audioCtx.currentTime
                  ),
                  this.highPassBfNode.frequency.setValueAtTime(
                    this.highPassFrequency,
                    this.audioCtx.currentTime
                  );
                var r = this.getDryWebValue(i.mix);
                (this.dryGainNode.gain.value = r.dry),
                  (this.wetGainNode.gain.value = r.wet),
                  null === (A = this.logger) ||
                    void 0 === A ||
                    A.log(
                      "ReverbEffector setPreConfigName() effectName= "
                        .concat(e, " dry=")
                        .concat(r.dry, " wet=")
                        .concat(r.wet)
                    );
              } else
                null === (o = this.logger) ||
                  void 0 === o ||
                  o.log(
                    "ReverbEffector setPreConfigName() effectName= ".concat(
                      e,
                      " cfg is null!"
                    )
                  );
            } else
              null === (t = this.logger) ||
                void 0 === t ||
                t.log(
                  "ReverbEffector setPreConfigName() currPreCfgName is DEFAULT"
                );
        }),
        (t.prototype.reconnect = function () {
          this.disconnectInnerNode(),
            this.currPreCfgName === AUDIO_EFFECT_NAME.DEFAULT
              ? this.inputNode.connect(this.outputNode)
              : (this.inputNode.connect(this.dryGainNode),
                this.dryGainNode.connect(this.outputNode),
                this.inputNode.connect(this.lowPassBfNode),
                this.lowPassBfNode.connect(this.highPassBfNode),
                this.highPassBfNode.connect(this.reverbNode),
                this.reverbNode.connect(this.wetGainNode),
                this.wetGainNode.connect(this.outputNode)),
            (this.outputNode.gain.value = 1);
        }),
        (t.prototype.disconnectInnerNode = function () {
          this.inputNode &&
            (this.inputNode.disconnect(),
            this.lowPassBfNode.disconnect(),
            this.highPassBfNode.disconnect(),
            this.reverbNode.disconnect(),
            this.dryGainNode.disconnect(),
            this.wetGainNode.disconnect());
        }),
        (t.prototype.rebuildImpulse = function (e) {
          for (
            var t = this.audioCtx.sampleRate,
              o = e.time * t,
              A = this.audioCtx.createBuffer(
                this.channelNum,
                o,
                this.audioCtx.sampleRate
              ),
              i = A.getChannelData(0),
              r = A.getChannelData(1),
              n = 0;
            n < o;
            n++
          ) {
            var a = e.reverse ? o - n : n;
            (i[n] = this.getChannelSamples(a, o, e)),
              (r[n] = this.getChannelSamples(a, o, e));
          }
          if (!e.simpleImpulseMode) {
            var s = e.decay * t;
            for (n = 0; n < s; n++) {
              var g = (a = e.reverse ? o - n : n) / s;
              (i[a] *= g), (r[a] *= g);
            }
          }
          return A;
        }),
        (t.prototype.getChannelSamples = function (e, t, o) {
          return (
            (2 * Math.random() - 1) *
            (o.simpleImpulseMode
              ? Math.pow(1 - e / t, o.decay)
              : Math.pow(Math.pow(0.001, 1 / t), e))
          );
        }),
        (t.prototype.getDryWebValue = function (e) {
          var t = e;
          return (
            (e < 0 || e > 1) && (t = 0),
            t <= this.dryWetConstant
              ? { dry: 1, wet: 1 - 2 * (this.dryWetConstant - t) }
              : { dry: 1 - 2 * (t - this.dryWetConstant), wet: 1 }
          );
        }),
        t
      );
    })(BaseAudioEffector),
    rvbPreCfgList = [
      {
        name: AUDIO_EFFECT_NAME.CONCERT_HALL,
        label: "闊充箰鍘�",
        mix: 0.5,
        time: 1.8,
        decay: 15,
        reverse: !1,
        simpleImpulseMode: !1,
      },
      {
        name: AUDIO_EFFECT_NAME.LIVING_ROOM,
        label: "瀹㈠巺",
        mix: 0.5,
        time: 1.4,
        decay: 5,
        reverse: !1,
        simpleImpulseMode: !0,
      },
      {
        name: AUDIO_EFFECT_NAME.LIVE,
        label: "婕斿敱浼氱幇鍦�",
        mix: 0.3,
        time: 3,
        decay: 5,
        reverse: !1,
        simpleImpulseMode: !0,
      },
    ],
    SpatialStereoEffector = (function (e) {
      function t(t, o) {
        var A = e.call(this, t, o) || this;
        return (
          (A.intervalTime = 300),
          (A.startTimeStamp = 0),
          (A.radius = 3),
          (A.degreeSpeed = 4),
          (A.degreeStart = 0),
          (A.degreeMax = 360),
          (A.panningModel = "HRTF"),
          (A.distanceModel = "linear"),
          (A.effectorName = "Spatial Stereo"),
          (A.pannerNode = A.audioCtx.createPanner()),
          (A.pannerNode.panningModel = A.panningModel),
          (A.pannerNode.distanceModel = A.distanceModel),
          (A.pannerNode.refDistance = 1),
          (A.pannerNode.coneInnerAngle = 360),
          (A.pannerNode.coneOuterAngle = 0),
          (A.pannerNode.coneOuterGain = 1),
          (A.isConnected = !1),
          A
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.connectBy = function (e) {
          return e && this.pannerNode
            ? (e.connect(this.pannerNode),
              (this.isConnected = !0),
              this.pannerNode)
            : null;
        }),
        (t.prototype.disconnect = function () {
          var e, t;
          null === (e = this.pannerNode) || void 0 === e || e.disconnect(),
            (this.isConnected = !1),
            null === (t = this.logger) ||
              void 0 === t ||
              t.log("".concat(this.effectorName, " disconnect()"));
        }),
        (t.prototype.destroy = function () {
          e.prototype.destroy.call(this), (this.pannerNode = null);
        }),
        (t.prototype.updateLoop = function () {
          if (!this.isConnected) return !1;
          var e = +new Date();
          return (
            e - this.startTimeStamp > this.intervalTime &&
              (this.updatePanningPosition(), (this.startTimeStamp = e)),
            !0
          );
        }),
        (t.prototype.updatePanningPosition = function () {
          var e = (this.degreeStart * Math.PI) / 180;
          (this.pannerNode.positionX.value = this.radius * Math.cos(e)),
            (this.pannerNode.positionZ.value = this.radius * Math.sin(e)),
            (this.degreeStart += this.degreeSpeed),
            this.degreeStart >= this.degreeMax &&
              (this.degreeStart = this.degreeStart - this.degreeMax);
        }),
        t
      );
    })(BaseAudioEffector),
    AudioController = (function () {
      function e(e, t) {
        (this.effectorList = []),
          (this.currEffect = AUDIO_EFFECT_NAME.DEFAULT),
          (this.currGain = 0),
          (this.media = e),
          (this.logger = t);
      }
      return (
        (e.prototype.onPlay = function () {
          this.createContextAndConnect();
        }),
        (e.prototype.destroy = function () {
          this.effectorList.forEach(function (e) {
            e.destroy();
          }),
            this.effectorList.splice(0, this.effectorList.length),
            this.audioSource &&
              (this.audioSource.disconnect(), (this.audioSource = null)),
            this.audioCtx &&
              (this.audioCtx.state === AUDIO_CONTEXT_STATE.RUNNING &&
                this.audioCtx.suspend(),
              (this.audioCtx = null)),
            (this.gainEffector = null),
            (this.spatialEffector = null),
            (this.eqEffector = null),
            (this.cpsEffector = null),
            (this.rvbEffector = null),
            (this.logger = null),
            (this.currEffect = AUDIO_EFFECT_NAME.DEFAULT),
            (this.currGain = 0);
        }),
        (e.prototype.setGainValue = function (e) {
          isEnvSupport() && this.isMediaSupport()
            ? this.isContextRunning()
              ? ((this.currGain = e),
                this.gainEffector || this.connectAudioPath(),
                this.gainEffector.setGainValue(e))
              : this.logger.warn("setGainValue(), AudioContext is not running")
            : this.logger.warn(
                "setGainValue(), not supported, envi= "
                  .concat(isEnvSupport(), " ,media= ")
                  .concat(this.isMediaSupport())
              );
        }),
        (e.prototype.getGainValue = function () {
          return this.gainEffector
            ? this.gainEffector.getGainValue()
            : (this.logger.warn("getGainValue(),gainEffector is null"), 0);
        }),
        (e.prototype.setEffect = function (e) {
          isEnvSupport() && this.isMediaSupport()
            ? this.isContextRunning()
              ? this.currEffect !== e
                ? ((this.currEffect = e), this.connectAudioPath())
                : this.logger.log(
                    "setEffect(), this.currEffect === effectName, effectName=".concat(
                      e
                    )
                  )
              : this.logger.warn("setEffect(), AudioContext is not running")
            : this.logger.warn(
                "setEffect(), not supported, envi= "
                  .concat(isEnvSupport(), " ,media= ")
                  .concat(this.isMediaSupport())
              );
        }),
        (e.prototype.getEffect = function () {
          return this.currEffect;
        }),
        (e.prototype.loop = function () {
          var e;
          (null === (e = this.spatialEffector) || void 0 === e
            ? void 0
            : e.using) && this.spatialEffector.updateLoop();
        }),
        (e.prototype.createContextAndConnect = function () {
          var e,
            t = this;
          isEnvSupport() &&
            this.isMediaSupport() &&
            (audioSourceNodes.has(this.media)
              ? ((this.audioSource = audioSourceNodes.get(this.media)),
                (this.audioCtx = this.audioSource.context),
                (null === (e = this.audioCtx) || void 0 === e
                  ? void 0
                  : e.state) === AUDIO_CONTEXT_STATE.SUSPENDED &&
                  this.audioCtx.resume().then(function () {
                    return t.connectAudioPath();
                  }))
              : ((this.audioCtx = new (window.AudioContext ||
                  window.webkitAudioContext)()),
                (this.audioSource = this.audioCtx.createMediaElementSource(
                  this.media
                )),
                audioSourceNodes.set(this.media, this.audioSource),
                this.connectAudioPath()));
        }),
        (e.prototype.connectAudioPath = function () {
          0 === this.effectorList.length && this.createAudioEffectors(),
            this.disconnect(),
            this.activeEffects(),
            this.reconnect();
        }),
        (e.prototype.createAudioEffectors = function () {
          this.logger.log("audioController createAudioEffectors()"),
            (this.gainEffector = new GainEffector(this.audioCtx, this.logger)),
            this.effectorList.push(this.gainEffector),
            (this.spatialEffector = new SpatialStereoEffector(
              this.audioCtx,
              this.logger
            )),
            this.effectorList.push(this.spatialEffector),
            (this.eqEffector = new EqualizerEffector(
              this.audioCtx,
              this.logger
            )),
            this.effectorList.push(this.eqEffector),
            (this.cpsEffector = new CompressorEffector(
              this.audioCtx,
              this.logger
            )),
            this.effectorList.push(this.cpsEffector),
            (this.rvbEffector = new ReverbEffector(this.audioCtx, this.logger)),
            this.effectorList.push(this.rvbEffector);
        }),
        (e.prototype.isMediaSupport = function () {
          return (
            !!(this.media && this.media instanceof HTMLMediaElement) &&
            "anonymous" === this.media.getAttribute("crossorigin")
          );
        }),
        (e.prototype.isContextRunning = function () {
          return this.audioCtx && "running" === this.audioCtx.state;
        }),
        (e.prototype.reconnect = function () {
          var e = this,
            t = this.audioSource,
            o = "audioSource -> ";
          this.effectorList.forEach(function (A) {
            A.using &&
              ((t = A.connectBy(t)),
              A.setPreConfigName(e.currEffect),
              (o += "".concat(A.getEffectorName(), " -> ")));
          }),
            t.connect(this.audioCtx.destination),
            this.logger.log(
              "audioController reconnect(), using audioEffect = ".concat(
                o,
                " destination"
              )
            );
        }),
        (e.prototype.disconnect = function () {
          this.audioSource.disconnect(),
            this.effectorList.forEach(function (e) {
              e.using && (e.disconnect(), (e.using = !1));
            }),
            this.logger.log("audioController disconnect()");
        }),
        (e.prototype.activeEffects = function () {
          switch (
            ((this.gainEffector.using = !0),
            (this.cpsEffector.using = !0),
            this.currEffect)
          ) {
            case AUDIO_EFFECT_NAME.SPATIAL_STEREO:
              this.spatialEffector.using = !0;
              break;
            case AUDIO_EFFECT_NAME.CONCERT_HALL:
            case AUDIO_EFFECT_NAME.LIVING_ROOM:
            case AUDIO_EFFECT_NAME.LIVE:
              this.rvbEffector.using = !0;
              break;
            case AUDIO_EFFECT_NAME.DEFAULT:
              0 === this.currGain && (this.cpsEffector.using = !1);
              break;
            default:
              this.eqEffector.using = !0;
          }
        }),
        e
      );
    })(),
    logMethodCall$6 = logMethodCallDecoratorCreator("BaseVideoNode"),
    BaseVideoNode = (function (e) {
      function t(t) {
        var o,
          A = e.call(this) || this;
        (A._played = !1),
          (A._evtBlocking = !1),
          (A._pauseCloseToEndStateCheckTimeoutId = 0),
          (A._targetSeekTime = -1),
          (A._userStartTime = 0),
          (A._isUserSeek = !1),
          (A.isUserSwitchAudioTrack = !1),
          (A.loadTimeoutId = 0),
          (A.levelSwitchTargetPlaytime = -1),
          (A.setLevelMode = SET_LEVEL_MODE.SOFT),
          (A.altAudio = !1),
          (A.latencyController = null),
          (A._logger = new Logger(t.instanceId, "BaseVideoNode")),
          (A._config = t),
          (A.stateMgr = new StateMgr(A)),
          (A.checkPlayHealth = new CheckHealth(A)),
          (A.loading = new Loading(A)),
          A.setHealthEvents(),
          (A.mainTaskLoop = new TaskLoop(
            A.mainLoopInProcess.bind(A),
            LoopMode$1.RAF
          ));
        var i = A._config,
          r = i.container,
          n = i.enableAudioEffect;
        return (
          (A._video = A.findFreeVideoElement()),
          (A._autoPlayPolicy = new AutoPlayPolicy(A._video, {
            instanceId: t.instanceId,
          })),
          (A._state = exports.VIDEO_STATE.IDLE),
          (A._playbackRate = 1),
          (A._idx = 0),
          (A._videoInfo = null),
          (A._pauseType = void 0),
          (A._videoEventMap =
            (((o = {})[VIDEO_EVTS.loadstart] = A.onVideoEventLoadStart.bind(A)),
            (o[VIDEO_EVTS.timeupdate] = A.onVideoEventTimeUpdate.bind(A)),
            (o[VIDEO_EVTS.durationchange] =
              A.onVideoEventDurationChange.bind(A)),
            (o[VIDEO_EVTS.volumechange] = A.onVideoEventVolumeChange.bind(A)),
            (o[VIDEO_EVTS.canplay] = A.onVideoEventCanplay.bind(A)),
            (o[VIDEO_EVTS.playing] = A.onVideoEventPlaying.bind(A)),
            (o[VIDEO_EVTS.pause] = A.onVideoEventPause.bind(A)),
            (o[VIDEO_EVTS.waiting] = A.onVideoEventWaiting.bind(A)),
            (o[VIDEO_EVTS.seeking] = A.onVideoEventSeeking.bind(A)),
            (o[VIDEO_EVTS.seeked] = A.onVideoEventSeeked.bind(A)),
            (o[VIDEO_EVTS.loadeddata] = A.onVideoEventLoadeddata.bind(A)),
            (o[VIDEO_EVTS.loadedmetadata] =
              A.onVideoEventLoadedmetadata.bind(A)),
            (o[VIDEO_EVTS.ended] = A.onVideoEventEnded.bind(A)),
            (o[VIDEO_EVTS.error] = A.onVideoEventError.bind(A)),
            (o[VIDEO_EVTS.progress] = A.onVideoEventProgress.bind(A)),
            (o[VIDEO_EVTS.ratechange] = A.onVideoEventRateChange.bind(A)),
            (o[VIDEO_EVTS.resize] = A.onVideoEventResize.bind(A)),
            o)),
          (A._drm = new DRM(
            A._video,
            t.drmConfig,
            new Logger(t.instanceId, "DRM")
          )),
          A._drm.on("error", A.onDrmError.bind(A)),
          (A._eventMap = { video: A.onVideoEvents.bind(A) }),
          (A._eventAddedMap = {}),
          (A._videoElementContainer = domTool$1
            .getElementFromConfig(r)
            .querySelector(".".concat(VIDEO_CONTAINER_CLASS))),
          videoTool$1.appendElement(A._video, A._videoElementContainer),
          (A.performanceMonitor = new PerformanceMonitor(A._video)),
          (A.videoResizeAutoFill = new VideoResizeAutoFill(
            A._video,
            A._config.minFillBlackBorder
          )),
          (A.vnStatusChecker = new CheckVideoNodeStatus(A)),
          n &&
            (A.audioController = new AudioController(
              A._video,
              new Logger(t.instanceId, "AudioController")
            )),
          t.type === exports.PLAY_MODE.LIVE &&
            (A.latencyController = new LatencyController(
              A._video,
              t,
              A.onLatencyExceeded.bind(A),
              A.onLatencyDropped.bind(A),
              A.latencyCalculationMethod.bind(A)
            )),
          A
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.triggerAutoplay = function () {
          var e = this;
          return (
            (this._evtBlocking = !0),
            this._autoPlayPolicy
              .userTrigger()
              .then(function () {
                return (e._evtBlocking = !1);
              })
              .catch(function (t) {
                throw ((e._evtBlocking = !1), t);
              })
          );
        }),
        (t.prototype.videoplay = function () {
          var e,
            t,
            o = this;
          this._logger.log(
            "videoplay(), uid="
              .concat(
                null === (e = this._videoInfo) || void 0 === e ? void 0 : e.uid,
                "/state="
              )
              .concat(this.state, "/idx=")
              .concat(this.idx)
          );
          var A = this._video.play();
          return (
            A
              ? A.catch(function (e) {
                  o._logger.warn(
                    ""
                      .concat(o.idx, " play() catch: ")
                      .concat(e.name, ", ")
                      .concat(e.message)
                  );
                  var t = videoTool$1.isAutoPlayBlockedMessage(e.message);
                  t && o.loading.hide(),
                    o.emit(VIDEO_NODE_EVENT.PLAY_PROMISE_CATCHED, {
                      videoInfo: o._videoInfo,
                      isAutoPlayBlocked: t,
                    });
                })
              : (A = Promise.resolve()),
            null === (t = this.audioController) || void 0 === t || t.onPlay(),
            (this._video.playbackRate = this._playbackRate),
            A
          );
        }),
        (t.prototype.pause = function (e) {
          void 0 === e && (e = PAUSE_TYPE.USER),
            this._played
              ? this.stateMgr.validCallState(exports.VIDEO_STATE.PAUSE)
                ? this.pauseInner(e)
                : this._logger.log(
                    "call pause in invaild state ".concat(this._state)
                  )
              : this._logger.warn("pause(), VideoNode has not been played");
        }),
        (t.prototype.resume = function () {
          throw new Error("not implements");
        }),
        (t.prototype.stop = function () {
          this.stopInner();
        }),
        (t.prototype.destroy = function () {
          var e, t, o, A, i, r, n, a, s, g;
          this.stopInner(),
            null === (e = this.latencyController) ||
              void 0 === e ||
              e.destroy(),
            (this.latencyController = null),
            this._video &&
              (this._eventMap &&
                (this.setVideoEvents(!1), (this._eventMap = null)),
              videoTool$1.clear(this._video),
              videoTool$1.removeElement(
                this._video,
                this._videoElementContainer
              ),
              (this._video.dataset.used = VIDEO_ELEMENT_STATE.FREE)),
            null === (t = this._autoPlayPolicy) || void 0 === t || t.destroy(),
            (this._autoPlayPolicy = null),
            null === (o = this.stateMgr) || void 0 === o || o.destroy(),
            (this.stateMgr = null),
            this.removeAllListeners(),
            null === (A = this._drm) || void 0 === A || A.destroy(),
            (this._drm = null),
            (this._video = null),
            (this._videoInfo = null),
            (this._videoElementContainer = null),
            (this._played = !1),
            (this._config = null),
            null === (i = this.checkPlayHealth) || void 0 === i || i.destroy(),
            (this.checkPlayHealth = null),
            null === (r = this.loading) || void 0 === r || r.clearDelay(),
            (this.loading = null),
            null === (n = this.mainTaskLoop) || void 0 === n || n.destroy(),
            (this.mainTaskLoop = null),
            (this.performanceMonitor = null),
            null === (a = this.videoResizeAutoFill) ||
              void 0 === a ||
              a.destroy(),
            (this.videoResizeAutoFill = null),
            null === (s = this.vnStatusChecker) || void 0 === s || s.destroy(),
            (this.vnStatusChecker = null),
            null === (g = this.audioController) || void 0 === g || g.destroy(),
            (this.audioController = null),
            this._logger.log("VideoNode has been destroyed!");
        }),
        (t.prototype.setLevel = function (e) {
          if (
            (void 0 === e && (e = SET_LEVEL_MODE.HARD),
            !this.checkCanSetLevel())
          )
            return Promise.reject(new Error("setLevel can't start"));
          this._logger.log("setLevel(), succ exec: ", this._videoInfo);
          var t = this._videoInfo.playtime;
          this.load(this._videoInfo, { startTime: t }), this.play();
          var o = new SimpleDefer$1();
          return (
            (this._levelSwitchingDefer = o),
            (this.levelSwitchTargetPlaytime = t),
            this.loading.show(),
            this.emit(VIDEO_NODE_EVENT.SETLEVEL_START, {
              videoInfo: this._videoInfo,
              mode: e,
            }),
            o.promise
          );
        }),
        (t.prototype.getLevelSwitching = function () {
          return !!this._levelSwitchingDefer;
        }),
        (t.prototype.setAudioTrack = function (e) {
          return this.checkCanSetAudioTrack()
            ? Promise.reject(AUDIO_TRACK_ERROR_MSG.NOT_SUPPORT)
            : Promise.reject(AUDIO_TRACK_ERROR_MSG.STATE_INVALID);
        }),
        (t.prototype.hasAltAudio = function () {
          return this.altAudio;
        }),
        (t.prototype.isCurrentContentDRMEncrypted = function () {
          return (
            this._state !== exports.VIDEO_STATE.IDLE && this._drm.hasStarted()
          );
        }),
        Object.defineProperty(t.prototype, "volume", {
          get: function () {
            return this._video.muted ? 0 : this._video.volume;
          },
          set: function (e) {
            var t;
            if (e < 0 || e > 1)
              this._logger.warn("The volume value range is [0,1]");
            else {
              var o = this._video.muted && e > 0;
              (this._video.volume = e),
                (this._video.muted = e <= 0),
                this._played &&
                  o &&
                  (null === (t = this.audioController) ||
                    void 0 === t ||
                    t.onPlay());
            }
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "volumeGain", {
          get: function () {
            var e;
            return null === (e = this.audioController) || void 0 === e
              ? void 0
              : e.getGainValue();
          },
          set: function (e) {
            var t, o;
            e < 0 || e > 2
              ? this._logger.warn("The volume gain range is [0,2]")
              : (null === (t = this._videoInfo) || void 0 === t
                  ? void 0
                  : t.hasFirstPlaying) &&
                (null === (o = this.audioController) ||
                  void 0 === o ||
                  o.setGainValue(e));
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "audioEffect", {
          get: function () {
            var e;
            return null === (e = this.audioController) || void 0 === e
              ? void 0
              : e.getEffect();
          },
          set: function (e) {
            var t, o;
            (null === (t = this._videoInfo) || void 0 === t
              ? void 0
              : t.hasFirstPlaying) &&
              (null === (o = this.audioController) ||
                void 0 === o ||
                o.setEffect(e));
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "playtime", {
          get: function () {
            return this._videoInfo ? this._videoInfo.playtime : 0;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "state", {
          get: function () {
            return this._state;
          },
          set: function (e) {
            var t;
            if (this._state !== e) {
              var o = this._state;
              (this._state = e),
                this._videoInfo && (this._videoInfo.state = this._state),
                this._logger.log(
                  "set state(), uid="
                    .concat(
                      null === (t = this._videoInfo) || void 0 === t
                        ? void 0
                        : t.uid,
                      "/idx="
                    )
                    .concat(this._idx, "/old=")
                    .concat(o, "/new=")
                    .concat(e)
                );
              var A = { videoInfo: this._videoInfo, new: e, old: o };
              e === exports.VIDEO_STATE.PAUSE
                ? ((A.pauseType = this._pauseType || PAUSE_TYPE.SYS),
                  (this._pauseType = void 0))
                : e === exports.VIDEO_STATE.SEEKING
                ? ((A.seekingTime = this._targetSeekTime),
                  (A.isUserSeek = this._isUserSeek),
                  (this._targetSeekTime = -1))
                : e === exports.VIDEO_STATE.SEEKED &&
                  (A.isUserSeek = this._isUserSeek),
                this.setLoadingOnStateChange(),
                this.emit(VIDEO_NODE_EVENT.STATE_CHANGE, A);
            }
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "played", {
          get: function () {
            return this._played;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "useWorker", {
          get: function () {
            return !1;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "idx", {
          get: function () {
            return this._idx;
          },
          set: function (e) {
            (this._idx = e), (this._video.dataset.idx = "".concat(e));
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoElement", {
          get: function () {
            return this._video;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoSize", {
          get: function () {
            return {
              width: this._video.videoWidth,
              height: this._video.videoHeight,
            };
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoBuffered", {
          get: function () {
            return videoTool$1.getBuffered(this._video);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "config", {
          get: function () {
            return this._config;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "playbackRate", {
          get: function () {
            return this._video.playbackRate;
          },
          set: function (e) {
            this._playbackRate = e;
            try {
              this._video.playbackRate = e;
            } catch (e) {
              this._logger.warn(
                "set playbackRate: ".concat(null == e ? void 0 : e.message)
              );
            }
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "currentVideoInfo", {
          get: function () {
            return this._videoInfo;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "supportPlaybackRate", {
          get: function () {
            return !uaTool$1.browser.x5;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "duration", {
          get: function () {
            var e = this._videoInfo ? this._videoInfo.duration : 0;
            return Number.isNaN(e) ? 0 : e;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.latencyCalculationMethod = function (e, t) {
          return -1;
        }),
        (t.prototype.onLatencyExceeded = function (e, t, o) {}),
        (t.prototype.onLatencyDropped = function (e, t, o) {}),
        (t.prototype.setHealthEvents = function () {
          var e = this,
            t = function (t) {
              e._logger.warn(
                "get health evt!!! evt="
                  .concat(t.type, "/uid=")
                  .concat(e._videoInfo.uid, "/idx=")
                  .concat(e._idx, "/state=")
                  .concat(e._state)
              ),
                e.errorHandler(t.data);
            };
          this.checkPlayHealth.on(HEALTH_EVTS.STATE_STUCK, t),
            this.checkPlayHealth.on(HEALTH_EVTS.PLAYTIME_STUCK, t);
        }),
        (t.prototype.setVideoEvents = function (e) {
          var t,
            o = this;
          this._eventAddedMap.videoEventAdded !== e &&
            (this._logger.log(
              "setVideoEvents(), idx="
                .concat(this._idx, "/value=")
                .concat(e, "/uid=")
                .concat(
                  null === (t = this._videoInfo) || void 0 === t
                    ? void 0
                    : t.uid
                )
            ),
            (this._eventAddedMap.videoEventAdded = e),
            Object.keys(this._videoEventMap).forEach(function (t) {
              e
                ? o._video.addEventListener(t, o._eventMap.video)
                : o._video.removeEventListener(t, o._eventMap.video);
            }));
        }),
        (t.prototype.onVideoEvents = function (e) {
          var t,
            o = this;
          if (
            this.state !== exports.VIDEO_STATE.IDLE &&
            this._videoInfo &&
            !this._evtBlocking
          ) {
            IGNORE_VIDEO_EVT.includes(e.type) ||
              this._logger.log(
                "videoevt, uid="
                  .concat(this._videoInfo.uid, "/idx=")
                  .concat(this.idx, "/type=")
                  .concat(e.type, "/") +
                  "time="
                    .concat(this._video.currentTime, "/duration=")
                    .concat(this._video.duration)
              ),
              this.emit(VIDEO_NODE_EVENT.ELEMENT_EVTS, {
                videoInfo: this._videoInfo,
                elementEvtType: e.type,
              });
            var A =
              Math.abs(this._videoInfo.duration - this._videoInfo.playtime) <
                0.1 && this._videoInfo.duration > 0;
            "pause" === e.type && A
              ? (this._pauseCloseToEndStateCheckTimeoutId = window.setTimeout(
                  function () {
                    o._videoEventMap[e.type] && o._videoEventMap[e.type](e);
                  },
                  0
                ))
              : ("ended" === e.type &&
                  this._pauseCloseToEndStateCheckTimeoutId > 0 &&
                  (window.clearTimeout(
                    this._pauseCloseToEndStateCheckTimeoutId
                  ),
                  (this._pauseCloseToEndStateCheckTimeoutId = 0)),
                this._videoEventMap[e.type] && this._videoEventMap[e.type](e));
          } else
            this._logger.log(
              "videoevt discard, idx="
                .concat(this._idx, "/uid=")
                .concat(
                  null === (t = this._videoInfo) || void 0 === t
                    ? void 0
                    : t.uid,
                  "/evttype="
                )
                .concat(e.type, "/") +
                "state="
                  .concat(this.state, "/evtBlocking=")
                  .concat(this._evtBlocking)
            );
        }),
        (t.prototype.onVideoEventPlaying = function () {
          this.setCheckLoadTimeoutEnable(!1),
            (this._isUserSeek = !1),
            this.updateVideoSize(),
            uaTool$1.browser.x5 && this.onVideoEventDurationChange(),
            this._videoInfo.hasFirstPlaying ||
              this.emit(VIDEO_NODE_EVENT.FIRST_PLAYING, {
                videoInfo: this._videoInfo,
              }),
            this.stateMgr.receiveVideoEvt(VIDEO_EVTS.playing),
            this._videoInfo &&
              ((this._videoInfo.hasFirstPlaying = !0),
              (this._videoInfo.stateWhenErrorHappen = null)),
            (this._userStartTime = 0),
            this.checkSetLevelOver(VIDEO_EVTS.playing);
        }),
        (t.prototype.onVideoEventCanplay = function () {
          this.setCheckLoadTimeoutEnable(!1),
            this._videoInfo &&
              (this._videoInfo.qualityInfo.canplaytime ||
                (this._videoInfo.qualityInfo.canplaytime =
                  videoTool$1.getBuffered(this._video)),
              this.stateMgr.receiveVideoEvt(VIDEO_EVTS.canplay));
        }),
        (t.prototype.onVideoEventPause = function () {
          this._pauseType !== PAUSE_TYPE.INNER &&
            this.stateMgr.receiveVideoEvt(VIDEO_EVTS.pause);
        }),
        (t.prototype.onVideoEventEnded = function () {
          this._logger.log("setEndInner(), reason=endedEvt"),
            this.setEndInner();
        }),
        (t.prototype.onVideoEventSeeked = function () {
          this.stateMgr.receiveVideoEvt(VIDEO_EVTS.seeked),
            this.checkSetLevelOver(VIDEO_EVTS.seeked),
            this.resumeAfterSeek(),
            (this._isUserSeek = !1);
        }),
        (t.prototype.onVideoEventLoadStart = function () {}),
        (t.prototype.onVideoEventWaiting = function () {
          this.stateMgr.receiveVideoEvt(VIDEO_EVTS.waiting);
        }),
        (t.prototype.onVideoEventSeeking = function () {
          this.stateMgr.receiveVideoEvt(VIDEO_EVTS.seeking);
        }),
        (t.prototype.onVideoEventProgress = function () {
          this.emit(VIDEO_NODE_EVENT.VIDEO_BUFFER_CHANGE, {
            videoInfo: this._videoInfo,
          });
        }),
        (t.prototype.onVideoEventLoadedmetadata = function () {
          this.updateVideoSize(),
            this.emit(VIDEO_NODE_EVENT.METADATA_CHANGE, {
              videoInfo: this._videoInfo,
            });
        }),
        (t.prototype.onVideoEventResize = function () {
          this.updateVideoSize(!0);
        }),
        (t.prototype.onVideoEventRateChange = function () {
          var e = this._video.playbackRate;
          (this._playbackRate = e),
            this.emit(VIDEO_NODE_EVENT.RATE_CHANGE, {
              playbackRate: e,
              videoInfo: this._videoInfo,
            });
        }),
        (t.prototype.onVideoEventDurationChange = function () {
          this._video.duration > 0 &&
            this._video.duration !== this._videoInfo.duration &&
            ((this._videoInfo.duration = this._video.duration),
            this._logger.log(
              "onVideoEventDurationChange(), uid="
                .concat(this._videoInfo.uid, "/duration=")
                .concat(this._videoInfo.duration, "/") + "idx=".concat(this.idx)
            ),
            this.emit(VIDEO_NODE_EVENT.DURATION_CHANGE, {
              videoInfo: this._videoInfo,
            }));
        }),
        (t.prototype.onVideoEventVolumeChange = function () {
          this.emit(VIDEO_NODE_EVENT.VOLUME_CHANGE, {
            volume: this.volume,
            videoInfo: this._videoInfo,
          });
        }),
        (t.prototype.onVideoEventTimeUpdate = function () {
          var e;
          if (0 !== this._video.currentTime) {
            this.updatePlaytime(this._video.currentTime),
              this.checkSetLevelOver(VIDEO_EVTS.timeupdate),
              this._state === exports.VIDEO_STATE.BUFFERING &&
                this._video.readyState >= VIDEO_READY_STATE.HAVE_FUTURE_DATA &&
                this.stateMgr.setPlaying();
            var t =
              null === (e = this.performanceMonitor) || void 0 === e
                ? void 0
                : e.calcIntervalFrameDropped();
            "number" == typeof t &&
              this._videoInfo &&
              (this._videoInfo.qualityInfo.intervalFrameDropped = t);
          }
        }),
        (t.prototype.onAudioTrackSwitched = function (e, t) {
          void 0 === t && (t = !1),
            this.audioTrackSwitchingDefer &&
              (this.audioTrackSwitchingDefer.resolve({
                userTrigger: this.isUserSwitchAudioTrack,
                id: e,
                fail: t,
              }),
              (this.audioTrackSwitchingDefer = null),
              this.emit(VIDEO_NODE_EVENT.SET_AUDIO_TRACK_OVER, {
                videoInfo: this._videoInfo,
                id: e,
                fail: t,
                userTrigger: this.isUserSwitchAudioTrack,
              }));
        }),
        (t.prototype.onVideoEventLoadeddata = function () {
          this.emit(VIDEO_NODE_EVENT.VIDEO_BUFFER_CHANGE, {
            videoInfo: this._videoInfo,
          });
        }),
        (t.prototype.onVideoEventError = function () {
          this.errorHandler();
        }),
        (t.prototype.onDrmError = function (e) {
          var t = e.data,
            o = t.code,
            A = t.message,
            i = t.detail,
            r = PlayerError.EncryptionError({ code: o, detail: i, message: A });
          (this._videoInfo.error = r), this.stopInner(!1, this._videoInfo);
        }),
        (t.prototype.checkCanSetLevel = function () {
          var e = this.vnStatusChecker.checkCanSetLevel();
          return !!e.canSetLevel || (this._logger.warn(e.message), !1);
        }),
        (t.prototype.checkSetLevelOver = function (e) {
          var t = this.vnStatusChecker.checkIsSetLevelOver(
            e,
            this.levelSwitchTargetPlaytime
          );
          t &&
            (this._logger.log(
              "setLevelOver(), reason: " +
                "succOnPlaying="
                  .concat(t.succInPlaying, "/succOnSeeked=")
                  .concat(t.succInSeeked, "/succOnTimeupdate=")
                  .concat(t.succInTimeupdate)
            ),
            this.setLevelOver());
        }),
        (t.prototype.setLevelOver = function () {
          this._levelSwitchingDefer &&
            (this._levelSwitchingDefer.resolve(),
            (this._levelSwitchingDefer = null),
            (this.levelSwitchTargetPlaytime = -1),
            this.loading.hide(),
            this.stateMgr.onSetLevelOver(),
            this.emit(VIDEO_NODE_EVENT.SETLEVEL_OVER, {
              videoInfo: this._videoInfo,
            }));
        }),
        (t.prototype.checkCanSeek = function (e, t) {
          void 0 === t && (t = !1);
          var o = this.vnStatusChecker.checkCanSeek({
            seektime: e,
            userActivation: t,
            setLevelMode: this.setLevelMode,
          });
          return !!o.canSeek || (this._logger.warn(o.message), !1);
        }),
        (t.prototype.checkCanSetAudioTrack = function () {
          var e = this.vnStatusChecker.checkCanSetAudioTrack(
            this.audioTrackSwitchingDefer
          );
          return !!e.canSetAudioTrack || (this._logger.warn(e.message), !1);
        }),
        (t.prototype.findFreeVideoElement = function () {
          return findFreeBaseVideoElement(this._config.videoElements);
        }),
        (t.prototype.setMainLoopEnable = function (e) {
          e ? this.mainTaskLoop.start() : this.mainTaskLoop.stop();
        }),
        (t.prototype.mainLoopInProcess = function () {
          var e;
          this.updateAccuratePlaytime(),
            this.checkPlayHealth.loop(),
            null === (e = this.audioController) || void 0 === e || e.loop();
        }),
        (t.prototype.updateAccuratePlaytime = function () {
          var e;
          this._state !== exports.VIDEO_STATE.PLAYING ||
            this._video.duration <= 0 ||
            this._video.readyState < VIDEO_READY_STATE.HAVE_ENOUGH_DATA ||
            (null === (e = this.onAccurateTimeupdate) ||
              void 0 === e ||
              e.call(this, this._video.currentTime, this._video.duration),
            this.updatePlaytime(this._video.currentTime, !0));
        }),
        (t.prototype.updatePlaytime = function (e, t) {
          if ((void 0 === t && (t = !1), this._videoInfo)) {
            var o = this.performanceMonitor.report(),
              A = o.averageDecodeTimeInMs,
              i = o.totalVideoFrames,
              r = o.droppedVideoFrames,
              n = o.frameDroppedInPercentage;
            (this._videoInfo.qualityInfo.droppedVideoFrames = r),
              (this._videoInfo.qualityInfo.totalVideoFrames = i),
              (this._videoInfo.qualityInfo.averageDecodeTimeInMs = A),
              (this._videoInfo.qualityInfo.frameDroppedInPercentage = n),
              this._videoInfo.playtime !== e && (this._videoInfo.playtime = e),
              t ||
                this.emit(VIDEO_NODE_EVENT.TIME_UPDATE, {
                  videoInfo: this._videoInfo,
                });
          }
        }),
        (t.prototype.setCheckLoadTimeoutEnable = function (e) {
          var t = this;
          if ((this.loadTimeoutId && clearTimeout(this.loadTimeoutId), e)) {
            var o = this._config.maxPreloadTimeout;
            o <= 0 ||
              (this.loadTimeoutId = setTimeout(function () {
                "hidden" !== document.visibilityState &&
                  t.errorHandler(
                    PlayerError.NativeError({
                      code: 104,
                      detail: commonTool$1.isPageHidden(),
                      fatal: !1,
                      message: compile(
                        i18nConfig.core.ERROR_PRELOAD_VIDEO_TIMEOUT
                      ),
                    })
                  );
              }, o));
          }
        }),
        (t.prototype.resumeAfterSeek = function () {
          this._played &&
            !this._video.ended &&
            this._isUserSeek &&
            (this._video.paused
              ? this._config.remainPauseStateAfterSeek || this.videoplay()
              : this.stateMgr.setPlaying());
        }),
        (t.prototype.pauseInner = function (e) {
          var t;
          void 0 === e && (e = PAUSE_TYPE.INNER),
            this._logger.log(
              "pause(), uid="
                .concat(
                  null === (t = this._videoInfo) || void 0 === t
                    ? void 0
                    : t.uid,
                  "/state="
                )
                .concat(this.state, "/idx=")
                .concat(this.idx, "/type=")
                .concat(e)
            ),
            (this._pauseType = e),
            this._video.pause();
        }),
        (t.prototype.setEndInner = function () {
          this._state !== exports.VIDEO_STATE.END &&
            this._state !== exports.VIDEO_STATE.IDLE &&
            (this._logger.log(
              "setEndInner(), idx="
                .concat(this._idx, "/uid=")
                .concat(this._videoInfo.uid, "/playtime=")
                .concat(this._videoInfo.playtime) +
                "/duration=".concat(this._videoInfo.duration, "}")
            ),
            this.stateMgr.setEnded(),
            this.emit(VIDEO_NODE_EVENT.PLAY_OVER, {
              isUserStop: !1,
              endState: exports.END_STATE.NORMAL,
              videoInfo: this._videoInfo,
            }));
        }),
        (t.prototype.stopInner = function (e, t) {
          var o, A;
          this._video &&
            this._videoInfo &&
            (null === (o = this.performanceMonitor) ||
              void 0 === o ||
              o.reset(),
            this.setMainLoopEnable(!1),
            this.setCheckLoadTimeoutEnable(!1),
            (this._isUserSeek = !1),
            this._logger.log(
              "stopInner(), uid/state/idx: "
                .concat(
                  null === (A = this._videoInfo) || void 0 === A
                    ? void 0
                    : A.uid,
                  "/"
                )
                .concat(this.state, "/")
                .concat(this.idx)
            ),
            this.setVideoEvents(!1),
            this._config.clearVideoAfterStop
              ? videoTool$1.clear(this._video)
              : this._video.pause(),
            this._config.createVideoNodeWhenLoad &&
              (this._video.dataset.used = VIDEO_ELEMENT_STATE.FREE),
            this._videoInfo &&
              ((this._videoInfo.extraVars.isLoadstarted = !1),
              (this._videoInfo = null)),
            this._pauseCloseToEndStateCheckTimeoutId > 0 &&
              (window.clearTimeout(this._pauseCloseToEndStateCheckTimeoutId),
              (this._pauseCloseToEndStateCheckTimeoutId = 0)),
            this.state !== exports.VIDEO_STATE.IDLE &&
              (e ||
                (this.stateMgr.setEnded(),
                (this._played = !1),
                (this._levelSwitchingDefer = null),
                (null == t ? void 0 : t.error) &&
                  this.emit(VIDEO_NODE_EVENT.ERROR, { videoInfo: t }))));
        }),
        (t.prototype.updateVideoSize = function (e) {
          void 0 === e && (e = !1);
          var t = this._video.videoWidth,
            o = this._video.videoHeight;
          !this._videoInfo ||
            (this._videoInfo.videoWidth === t &&
              this._videoInfo.videoHeight === o) ||
            ((this._videoInfo.videoWidth = t),
            (this._videoInfo.videoHeight = o),
            this.emit(VIDEO_NODE_EVENT.VIDEO_RESIZE, {
              videoInfo: this._videoInfo,
              isNative: e,
            }),
            this.videoResizeAutoFill.resizeAutoFill());
        }),
        (t.prototype.setLoadingOnStateChange = function () {
          if (this._played)
            if (
              [
                exports.VIDEO_STATE.BUFFERING,
                exports.VIDEO_STATE.SEEKING,
              ].includes(this._state)
            ) {
              this.loading.show(500);
            } else
              ((this._config.type === exports.PLAY_MODE.LIVE &&
                exports.VIDEO_STATE.CANPLAY !== this._state) ||
                this._config.type === exports.PLAY_MODE.VOD) &&
                this.loading.hide();
          else this.loading.hide();
        }),
        (t.prototype.errorHandler = function (e) {
          var t = this.parseErrorData(e);
          this._logger.log("video encounter error", t);
          var o = videoTool$1.isPositionBuffered(this._video);
          this._logger.log("current position buffered=".concat(o)),
            o ||
              (this._logger.warn(
                "current position is not buffered, check close range"
              ),
              this._logger.warn(
                "next buffered start=".concat(
                  videoTool$1.getNextBufferedStart(this._video)
                )
              ),
              this._logger.warn(
                "last buffered end=".concat(
                  videoTool$1.getLastBufferedEnd(this._video)
                )
              )),
            this.retryWhenError(t);
        }),
        (t.prototype.retryWhenError = function (e) {
          var t = this._videoInfo,
            o = this.setRetryUrl(t),
            A = t.config.expireTimeStamp,
            i = void 0 !== A && A < +new Date();
          if (
            (null === this._videoInfo.stateWhenErrorHappen &&
              (this._videoInfo.stateWhenErrorHappen = this._state),
            !e.fatal && !i && o)
          ) {
            var r = t.getRetryCount();
            return (
              this._logger.log("retryOnError(), retryCount=", r),
              this.emit(
                VIDEO_NODE_EVENT.RETRY,
                __assign$1({ error: e, retryCount: r, videoInfo: t }, o)
              ),
              this.stopInner(!0),
              this.stateMgr.setWaiting(),
              this._state !== exports.VIDEO_STATE.BUFFERING &&
                this.loading.show(),
              void this.doRetry(t)
            );
          }
          this._logger.log("retryOnError(), fatal."),
            (this._videoInfo.error = e),
            this._levelSwitchingDefer && this._levelSwitchingDefer.reject(e),
            this.stopInner(!1, this._videoInfo);
        }),
        (t.prototype.parseErrorData = function (e) {
          var t;
          return e
            ? commonErrorParse(e)
            : null !== (t = getVideoError(this._video)) && void 0 !== t
            ? t
            : PlayerError.NativeError({
                code: 0,
                fatal: !1,
                message: compile(i18nConfig.core.ERROR_MSG_UNKNOWN),
                debugMessage: jsonTool$1.safelyStringify(this._video.error),
              });
        }),
        (t.prototype.doRetry = function (e) {
          var t = e.playtime,
            o = e.stateWhenErrorHappen,
            A = this._video.currentTime > 0 ? this._video.currentTime : t,
            i = this._played ? A : this._userStartTime;
          this._logger.log("do retry [url], stateWhenErrorHappen=".concat(o)),
            (e.playtime = i),
            this._played && o !== exports.VIDEO_STATE.PAUSE
              ? this.play(e, { startTime: i })
              : this.load(e, { startTime: i });
        }),
        (t.prototype.setRetryUrl = function (e) {
          var t = e.loadingUrl;
          return e.setNextBackUrl()
            ? { prevUrl: t, curUrl: e.loadingUrl }
            : null;
        }),
        (t.prototype.emitKernelEvt = function (e, t) {
          kernelEvtBus.emit(
            e,
            __assign$1(__assign$1({}, t), {
              playerInstanceId: this.config.instanceId,
            })
          );
        }),
        (t.prototype.adjustSeekTime = function (e) {
          var t = e;
          return (
            (uaTool$1.browser.x5 || uaTool$1.browser.safari) &&
              Math.abs(t - this._videoInfo.duration) <= 1 &&
              (t = this._videoInfo.duration - 1),
            t
          );
        }),
        __decorate(
          [
            logMethodCall$6,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "pause",
          null
        ),
        __decorate(
          [
            logMethodCall$6,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "stop",
          null
        ),
        __decorate(
          [
            logMethodCall$6,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "destroy",
          null
        ),
        __decorate(
          [
            logMethodCall$6,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "setLevel",
          null
        ),
        __decorate(
          [
            logMethodCall$6,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "setAudioTrack",
          null
        ),
        __decorate(
          [
            logMethodCall$6,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Boolean]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "setCheckLoadTimeoutEnable",
          null
        ),
        __decorate(
          [
            logMethodCall$6,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "pauseInner",
          null
        ),
        __decorate(
          [
            logMethodCall$6,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "setEndInner",
          null
        ),
        __decorate(
          [
            logMethodCall$6,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Boolean, Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "stopInner",
          null
        ),
        __decorate(
          [
            logMethodCall$6,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "retryWhenError",
          null
        ),
        t
      );
    })(s$1$1),
    logMethodCall$5 = logMethodCallDecoratorCreator("OrgVideoNode"),
    OrgVideoNode = (function (e) {
      function t(t) {
        var o = e.call(this, t) || this;
        return (o._logger = new Logger(t.instanceId, "OrgVideoNode")), o;
      }
      return (
        __extends$1(t, e),
        (t.prototype.onVideoEventCanplay = function () {
          var t;
          null === (t = this.canplayDefer) || void 0 === t || t.resolve(),
            e.prototype.onVideoEventCanplay.call(this);
        }),
        (t.prototype.onVideoEventLoadedmetadata = function () {
          e.prototype.onVideoEventLoadedmetadata.call(this),
            (uaTool$1.os.ios || uaTool$1.browser.safari) &&
              [
                exports.PRELOAD_TYPE.META_DATA,
                exports.PRELOAD_TYPE.AUTO,
              ].includes(this._config.preloadType) &&
              this.onVideoEventCanplay();
        }),
        (t.prototype.onVideoEventLoadeddata = function () {
          e.prototype.onVideoEventLoadeddata.call(this),
            this.checkPlayInitSeek();
        }),
        (t.prototype.onVideoEventTimeUpdate = function () {
          e.prototype.onVideoEventTimeUpdate.call(this),
            this.checkPlayInitSeek();
        }),
        (t.prototype.onVideoEventLoadStart = function () {
          this.resolveWaitVideoLoadStartEvt();
        }),
        (t.prototype.load = function (e, t) {
          var o = this;
          return (
            !!e.loadingUrl &&
            (this.stopInner(!0),
            this._drm.init(e.config.drmConfig),
            (this._videoInfo = e),
            (this._videoInfo.extraVars.isLoadstarted = !0),
            this.setVideoEvents(!0),
            this.stateMgr.setLoadStart(),
            this.assignStartTime((null == t ? void 0 : t.startTime) || 0),
            (this._video.src = this._videoInfo.loadingUrl),
            this._logger.log("load(), uid=".concat(this._videoInfo.uid)),
            this._config.preloadType === exports.PRELOAD_TYPE.AUTO_LOAD &&
              this._video.load(),
            this.setCheckLoadTimeoutEnable(!0),
            (this.canplayDefer = new SimpleDefer$1()),
            this.waitVideoLoadStartEvt()
              .then(function () {
                o._logger.log("load(), video load succ...");
              })
              .catch(function () {
                o._logger.error("load(), video load cannot be trigger..."),
                  o.onVideoEventCanplay();
              }),
            !0)
          );
        }),
        (t.prototype.play = function (e, t) {
          var o = this;
          this._logger.log(
            "play(), uid="
              .concat(null == e ? void 0 : e.uid, "/idx=")
              .concat(this.idx, "/state=")
              .concat(this.state)
          ),
            (this._played = !0),
            e && !e.extraVars.isLoadstarted && this.load(e, t);
          var A = null;
          return (
            uaTool$1.browser.safari && this.canplayDefer
              ? this.canplayDefer.promise.then(function () {
                  o.videoplay();
                })
              : (A = this.videoplay()),
            this.setMainLoopEnable(!0),
            A
          );
        }),
        (t.prototype.assignStartTime = function (e) {
          if (this._config.type !== exports.PLAY_MODE.LIVE) {
            this._userStartTime = e;
            var t = !Number.isNaN(e) && e >= 0 ? e : 0;
            t <= 0 ||
              (videoTool$1.supportMediaFragmentsURISpec(
                this._config.enableMediaFragmentsURI
              ) && !this._videoInfo.loadingUrl.startsWith("blob:")
                ? (this._logger.log("assignStartTime by #t"),
                  this._videoInfo.setLoadingUrlStartTime(t))
                : (this._logger.log("assignStartTime with seek()"),
                  (this.needPlaySeektime = t)));
          }
        }),
        (t.prototype.checkPlayInitSeek = function () {
          this.needPlaySeektime > 0 &&
            this._videoInfo &&
            this._video.duration > 0 &&
            (this._logger.log(
              "checkPlayInitSeek(), idx="
                .concat(this.idx, "/seektime=")
                .concat(this.needPlaySeektime)
            ),
            this.seek(this.needPlaySeektime),
            (this.needPlaySeektime = 0));
        }),
        (t.prototype.stopInner = function (t, o) {
          (this.canplayDefer = null),
            (this.needPlaySeektime = 0),
            e.prototype.stopInner.call(this, t, o);
        }),
        (t.prototype.seek = function (e, t) {
          void 0 === t && (t = !1);
          var o = e;
          return (
            !!this.checkCanSeek(o, t) &&
            ((o = this.adjustSeekTime(o)),
            (this._isUserSeek = t),
            this._logger.log(
              "seek(), uid"
                .concat(this._videoInfo.uid, "/idx=")
                .concat(this.idx, "/time=")
                .concat(o, "/duration=")
                .concat(this._video.duration, "/") + "state=".concat(this.state)
            ),
            (this._targetSeekTime = o),
            (this._video.currentTime = o),
            !0)
          );
        }),
        (t.prototype.updateAccuratePlaytime = function () {
          e.prototype.updateAccuratePlaytime.call(this);
          var t = Math.abs(this._video.duration - this._video.currentTime),
            o = this._config.originKernelConfig.advanceEndTime;
          o > 0 &&
            t <= o &&
            (this._logger.log("setEndInner(), reason=leftTimeCheck"),
            this.setEndInner());
        }),
        (t.prototype.setEndInner = function () {
          this.state !== exports.VIDEO_STATE.END &&
            this.state !== exports.VIDEO_STATE.IDLE &&
            (this.onAccurateTimeupdate && this.onAccurateTimeupdate(0),
            this.updatePlaytime(this._video.currentTime)),
            e.prototype.setEndInner.call(this);
        }),
        (t.prototype.waitVideoLoadStartEvt = function () {
          var e = this;
          this.waitVideoLoadStartEvtDefer = new SimpleDefer$1();
          return (
            window.setTimeout(function () {
              "rejected" !== e.waitVideoLoadStartEvtDefer.state &&
                e.waitVideoLoadStartEvtDefer.reject();
            }, 50),
            this.waitVideoLoadStartEvtDefer.promise
          );
        }),
        (t.prototype.resolveWaitVideoLoadStartEvt = function () {
          this.waitVideoLoadStartEvtDefer &&
            this.waitVideoLoadStartEvtDefer.resolve();
        }),
        __decorate(
          [
            logMethodCall$5,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "play",
          null
        ),
        __decorate(
          [
            logMethodCall$5,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Boolean, Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "stopInner",
          null
        ),
        __decorate(
          [
            logMethodCall$5,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Number, Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "seek",
          null
        ),
        t
      );
    })(BaseVideoNode),
    logMethodCall$4 = logMethodCallDecoratorCreator("OrgIOSVideoNode"),
    PAUSE_TIME_THRESHOLD = 5e3,
    OrgIOSVideoNode = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.lastPausePlayTime = null),
          (t.lastPauseTimeStamp = null),
          (t.disableSeekEvt = !1),
          t
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t, "shouldUseResumeFix", {
          get: function () {
            return (
              uaTool$1.os.ios &&
              commonTool$1.compareVersion(uaTool$1.os.version, "15.0") >= 0
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.setLevel = function (t) {
          return (
            void 0 === t && (t = SET_LEVEL_MODE.HARD),
            this.clearPauseMemTime(),
            e.prototype.setLevel.call(this, t)
          );
        }),
        (t.prototype.onVideoEventPause = function () {
          return (
            this.isOriginHlsPlaying() &&
              ((this.lastPausePlayTime = this._video.currentTime),
              (this.lastPauseTimeStamp = Date.now())),
            e.prototype.onVideoEventPause.call(this)
          );
        }),
        (t.prototype.onVideoEventSeeking = function () {
          if ((this.clearPauseMemTime(), !this.disableSeekEvt))
            return e.prototype.onVideoEventSeeking.call(this);
        }),
        (t.prototype.onVideoEventSeeked = function () {
          this.disableSeekEvt
            ? (this.disableSeekEvt = !1)
            : e.prototype.onVideoEventSeeked.call(this);
        }),
        (t.prototype.onVideoEventPlaying = function () {
          return (
            t.shouldUseResumeFix &&
              this.lastPausePlayTime &&
              Date.now() - this.lastPauseTimeStamp > PAUSE_TIME_THRESHOLD &&
              ((this.disableSeekEvt = !0),
              (this._video.currentTime = this.lastPausePlayTime)),
            this.clearPauseMemTime(),
            e.prototype.onVideoEventPlaying.call(this)
          );
        }),
        (t.prototype.clearPauseMemTime = function () {
          (this.lastPausePlayTime = null), (this.lastPauseTimeStamp = null);
        }),
        (t.prototype.isOriginHlsPlaying = function () {
          var e = this.currentVideoInfo.loadingUrl;
          return (
            fileExtension2VideoType(urlTool$1.getFileExtension(e)) ===
            VIDEO_TYPE.HLS
          );
        }),
        __decorate(
          [
            logMethodCall$4,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "setLevel",
          null
        ),
        t
      );
    })(OrgVideoNode);
  function detectStream(e) {
    return __awaiter$1(this, void 0, void 0, function () {
      var t, o, A, i, r, n, a, s, g, l;
      return __generator$1(this, function (E) {
        switch (E.label) {
          case 0:
            (t = { httpCode: -1 }), (E.label = 1);
          case 1:
            return (
              E.trys.push([1, 3, , 4]),
              [
                4,
                netTool.xhr({
                  url: e,
                  retryCount: 0,
                  responseType: "arraybuffer",
                  range: [0, 102400],
                }),
              ]
            );
          case 2:
            (o = E.sent()),
              (A = o.data),
              (l = o.target),
              (i = o.startTimestamp),
              (t.httpCode = l.status),
              (r = A.byteLength / 1024),
              (n = (+new Date() - i) / 1e3),
              (t.downloadSpeed = "".concat(Math.floor(r / n), "kb/s"));
            try {
              t.headers = l.getAllResponseHeaders();
            } catch (e) {}
            return [3, 4];
          case 3:
            return (
              (a = E.sent()),
              (g = (s = a || {}).error),
              (l = s.target),
              (t.httpCode = null == l ? void 0 : l.status),
              (t.error = g),
              [3, 4]
            );
          case 4:
            return [2, t];
        }
      });
    });
  }
  var i18nCore = i18nConfig.core,
    CheckPlayerStatus = (function () {
      function e(e) {
        var t = this;
        (this.setLevelValidator = {
          NOT_INITIALIZED: function () {
            return t.player
              ? VALIDATE_PASS_RESULT
              : {
                  isValid: !1,
                  message: compile(i18nCore.ERROR_STATUS_NOT_INITIALIZED),
                };
          },
          NOT_PLAYING: function () {
            return t.player.played
              ? VALIDATE_PASS_RESULT
              : {
                  isValid: !1,
                  message: compile(i18nCore.ERROR_STATUS_NOT_PLAYING),
                };
          },
          EMPTY_URL: function (e) {
            return e
              ? VALIDATE_PASS_RESULT
              : {
                  isValid: !1,
                  message: compile(i18nCore.ERROR_STATUS_EMPTY_URL),
                };
          },
          EMPTY_VIDEO_INFO: function () {
            return t.player.currentVideoInfo
              ? VALIDATE_PASS_RESULT
              : {
                  isValid: !1,
                  message: compile(i18nCore.ERROR_STATUS_VIDEO_INFO),
                };
          },
          PLAYTIME_CHECK: function () {
            return t.player.currentVideoInfo.playtime <= 0
              ? {
                  isValid: !1,
                  message: compile(i18nCore.ERROR_STATUS_PLAYTIME_CHECK),
                }
              : VALIDATE_PASS_RESULT;
          },
          CLOSE_TO_END: function () {
            var e = t.player.currentVideoInfo;
            return t.player.config.type === exports.PLAY_MODE.VOD &&
              e.playtime + 1 >= e.duration &&
              e.duration !== 1 / 0
              ? {
                  isValid: !1,
                  message: compile(i18nCore.ERROR_STATUS_CLOSE_TO_END),
                }
              : VALIDATE_PASS_RESULT;
          },
          TARGET_NOT_CHANGE: function (e) {
            return e === t.player.currentVideoInfo.loadingUrl
              ? {
                  isValid: !1,
                  message: compile(i18nCore.ERROR_STATUS_TARGET_UNCHANGED),
                }
              : VALIDATE_PASS_RESULT;
          },
        }),
          (this.player = e);
      }
      return (
        (e.prototype.checkSetLevelMode = function (e, t) {
          return e < 2 ? SET_LEVEL_MODE.HARD : t || SET_LEVEL_MODE.SOFT;
        }),
        (e.prototype.checkCanAppend = function (e) {
          var t;
          if (!(null === (t = this.player) || void 0 === t ? void 0 : t.config))
            return {
              canAppend: !1,
              message: "BasePlayer or basePlayer.config is null",
            };
          if (!this.player.config.isPlayList)
            return {
              canAppend: !1,
              message: "Only supported when [isPlayList] is true",
            };
          if (!this.player.played)
            return { canAppend: !1, message: "Player has not been played" };
          var o = checkUrlConfigVailed(e);
          return o
            ? { canAppend: !1, message: "urlconfig err=".concat(o) }
            : { canAppend: !0, message: "Can append video now" };
        }),
        (e.prototype.checkCanPreloadEnvi = function (e) {
          var t = this.checkCanAppend(e);
          return t.canAppend
            ? this.player.supportPreload
              ? { canPreload: !0, message: "Can preload video now" }
              : {
                  canPreload: !1,
                  message: "preloadNext() fail, browser not support preload.",
                }
            : { canPreload: !1, message: t.message };
        }),
        (e.prototype.checkCanPreloadEachConfig = function (e) {
          var t;
          if (
            !(null === (t = this.player) || void 0 === t
              ? void 0
              : t.videoInfos)
          )
            return {
              canPreload: !1,
              message:
                "preloadInner() fail, because player or videoInfo is null.",
            };
          var o = this.player.videoInfos.findIndex(function (t) {
            return compareUrlConfig(t.config, e);
          });
          return -1 !== o && o <= this.player.curUrlIdx
            ? {
                canPreload: !1,
                message:
                  "preloadInner() fail, because this videoInfo has been played.",
              }
            : -1 !== o && o > this.player.curUrlIdx + 1
            ? {
                canPreload: !1,
                message: "preloadInner() fail, can not skip next to preload.",
              }
            : this.player.nextVideoInfo &&
              !compareUrlConfig(this.player.nextVideoInfo.config, e)
            ? {
                canPreload: !1,
                message:
                  "preloadInner() fail, the next has been appended, you only can preload next.",
              }
            : -1 !==
              this.player.preloadVideoInfos.findIndex(function (t) {
                return compareUrlConfig(t.config, e);
              })
            ? {
                canPreload: !1,
                message:
                  "preloadInner() fail, the VideoInfo has been preloaded.",
              }
            : { canPreload: !0, message: "Can preload video now" };
        }),
        (e.prototype.checkSetLevelError = function (e) {
          var t = runValidators(
            Object.values(this.setLevelValidator),
            function (t) {
              return t(e);
            }
          );
          return t.isValid ? null : t.message;
        }),
        (e.prototype.checkCanPlayNext = function () {
          var e;
          return (
            null === (e = this.player) || void 0 === e ? void 0 : e.videoInfos
          )
            ? this.player.played
              ? this.player.nextVideoInfo
                ? {
                    canPlayNext: !0,
                    message:
                      "checkPlayNext(), curUrlIdx="
                        .concat(this.player.curUrlIdx, "/urlLength=")
                        .concat(this.player.videoInfos.length, "/") +
                      "nextStartTime: ".concat(
                        this.player.nextVideoInfo.playtime
                      ),
                  }
                : {
                    canPlayNext: !1,
                    message: "Playlist over>>>, total len: ', ".concat(
                      this.player.videoInfos.length
                    ),
                  }
              : { canPlayNext: !1, message: "Player has not been played" }
            : {
                canPlayNext: !1,
                message: "Player or player.videoInfo is null",
              };
        }),
        (e.prototype.checkAutoPreloadNext = function (e) {
          var t;
          if (
            !(null === (t = this.player) || void 0 === t
              ? void 0
              : t.currentVideoInfo)
          )
            return {
              canPreload: !1,
              message: "Player or player.currentVideoInfo is null",
            };
          if (
            !this.player.nextVideoInfo ||
            -1 !==
              this.player.preloadVideoInfos.indexOf(this.player.nextVideoInfo)
          )
            return {
              canPreload: !1,
              message:
                "nextVideoInfo is null or nextVideoInfo is already preload now",
            };
          var o = this.player.currentVideoInfo.config.autoPreloadLeftTime;
          return o <= 0
            ? {
                canPreload: !1,
                message: "Can not preload,autoPreloadLeftTime <= 0",
              }
            : (o >= this.player.currentVideoInfo.duration &&
                this.player.currentVideoInfo.playtime > 0) ||
              o >= e
            ? { canPreload: !0, message: "Can preload now" }
            : {
                canPreload: !1,
                message: "Can not preload,autoPreloadLeftTime is illegal",
              };
        }),
        (e.prototype.destroy = function () {
          this.player = null;
        }),
        e
      );
    })(),
    ScreenWakeLock = (function () {
      function e() {
        this.wakeLock = null;
      }
      return (
        Object.defineProperty(e.prototype, "isAlive", {
          get: function () {
            return !!this.wakeLock;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (e.prototype.keepAlive = function (e) {
          return e ? this.requestWakeLock() : this.realseWakeLock();
        }),
        (e.prototype.requestWakeLock = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            var e;
            return __generator$1(this, function (t) {
              switch (t.label) {
                case 0:
                  if (this.wakeLock) return [2];
                  t.label = 1;
                case 1:
                  return (
                    t.trys.push([1, 3, , 4]),
                    (e = this),
                    [4, window.navigator.wakeLock.request("screen")]
                  );
                case 2:
                  return (e.wakeLock = t.sent()), [3, 4];
                case 3:
                  return t.sent(), (this.wakeLock = null), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }),
        (e.prototype.realseWakeLock = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (e) {
              return this.wakeLock
                ? (this.wakeLock.release(), (this.wakeLock = null), [2])
                : [2];
            });
          });
        }),
        e
      );
    })(),
    GUID_LEN = 8,
    VideoInfo = (function () {
      function e(e, t) {
        (this.playtime = 0),
          (this.currentAudioTrack = NaN),
          (this.duration = 0),
          (this.performance = {}),
          (this.startTime = 0),
          (this.state = exports.VIDEO_STATE.IDLE),
          (this.fileSize = 0),
          (this.videoWidth = 0),
          (this.videoHeight = 0),
          (this.hasFirstPlaying = !1),
          (this.startPts = 0),
          (this.discontinuityTimeRanges = []),
          (this.videoFrameRate = 0),
          (this.audioTracks = []),
          (this.currentLevelIndex = -1),
          (this.levels = []),
          (this.currentLevel = null),
          (this.isAutoLevel = !1),
          (this.stateWhenErrorHappen = null),
          (this.logger = new Logger(t.instanceId, "VideoInfo")),
          (this.extraVarsInner = {}),
          (this.qualityInfoInner = {}),
          (this.uidInner = commonTool$1.createGUID(GUID_LEN)),
          (this.configInner = e),
          (this.playerConfigInner = t),
          (this.codecs = this.configInner.codec
            ? __assign$1({}, this.configInner.codec)
            : { video: "", audio: "" }),
          this.reset(),
          this.logger.log("new VideoInfo(), uid: ".concat(this.uid));
      }
      return (
        (e.prototype.toJSON = function () {
          return this.serializedString();
        }),
        (e.prototype.toString = function () {
          return this.serializedString();
        }),
        Object.defineProperty(e.prototype, "config", {
          get: function () {
            return this.configInner;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "qualityInfo", {
          get: function () {
            return this.qualityInfoInner;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "uid", {
          get: function () {
            return this.uidInner;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "loadingUrl", {
          get: function () {
            return this.loadingUrlInner;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "extraVars", {
          get: function () {
            return this.extraVarsInner;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (e.prototype.reset = function () {
          (this.nextBackUrlIdxInner = 0),
            (this.retryCountInner = 0),
            (this.performance = {}),
            (this.loadingUrlInner = this.configInner.url),
            (this.audioTracks = []);
        }),
        (e.prototype.setLoadingUrlStartTime = function (e) {
          this.loadingUrlInner &&
            e > 0 &&
            (this.loadingUrlInner = ""
              .concat(this.loadingUrlInner.split("#t=")[0], "#t=")
              .concat(e));
        }),
        (e.prototype.setDependVideoInfo = function (e) {
          return (
            (this.startTime = e ? e.startTime + e.duration : 0),
            this.logger.log(
              "setDependVideoInfo succ, uid/starttime: "
                .concat(this.uid, "/")
                .concat(this.startTime)
            ),
            !0
          );
        }),
        (e.prototype.setNextBackUrl = function () {
          return (
            !(
              !this.configInner.url ||
              this.retryCountInner >=
                this.playerConfigInner.backupUrlsMaxRetryCount
            ) &&
            (this.retryCountInner++,
            this.configInner.backupUrls &&
            this.configInner.backupUrls.length > 0
              ? this.nextBackUrlIdxInner >= this.configInner.backupUrls.length
                ? ((this.loadingUrlInner = this.configInner.url),
                  (this.nextBackUrlIdxInner = 0))
                : ((this.loadingUrlInner =
                    this.configInner.backupUrls[this.nextBackUrlIdxInner]),
                  this.nextBackUrlIdxInner++)
              : (this.loadingUrlInner = this.configInner.url),
            !0)
          );
        }),
        (e.prototype.getRetryCount = function () {
          return this.retryCountInner;
        }),
        (e.prototype.destroy = function () {
          this.extraVarsInner = null;
        }),
        (e.prototype.serializedString = function () {
          var e, t;
          return "VideoInfo{u:"
            .concat(this.loadingUrlInner, ",t:")
            .concat(this.playtime, ",s:")
            .concat(this.state, ",ec:")
            .concat(
              (null === (e = this.error) || void 0 === e ? void 0 : e.code) ||
                "",
              ",em:"
            )
            .concat(
              (null === (t = this.error) || void 0 === t
                ? void 0
                : t.message) || "",
              ",r:"
            )
            .concat(this.nextBackUrlIdxInner, "}");
        }),
        e
      );
    })(),
    logMethodCall$3 = logMethodCallDecoratorCreator("BasePlayer"),
    BasePlayer = (function (e) {
      function t(t) {
        var o,
          A = e.call(this) || this;
        return (
          (A._firstPlaying = !1),
          (A._hasUserGestures = !1),
          (A._volume = 1),
          (A.volumeGainInner = 0),
          (A.audioEffectInner = AUDIO_EFFECT_NAME.DEFAULT),
          (A._playbackRate = 1),
          (A._playBlocking = !1),
          (A.lastVideoInfo = null),
          (A.setAudioEffectTimeoutId = 0),
          (A._logger = new Logger(t.instanceId, "BasePlayer")),
          (A._config = t),
          (A._videoInfos = []),
          (A._curUrlIdx = -1),
          (A._curVideoNode = null),
          (A._preloaders = []),
          (A._vnList = []),
          (A._eventMap = {
            videonode: A.videonodeEventHandler.bind(A),
            document: A.visibilityChangeHandler.bind(A),
          }),
          (A._played = !1),
          (A.videoEvtHandlerMap =
            (((o = {})[VIDEO_NODE_EVENT.RATE_CHANGE] =
              A.onVideoNodeRateChange.bind(A)),
            (o[VIDEO_NODE_EVENT.STATE_CHANGE] =
              A.onVideoNodeStateChange.bind(A)),
            (o[VIDEO_NODE_EVENT.PLAY_PROMISE_CATCHED] =
              A.onVideoNodePlayPromiseCatched.bind(A)),
            (o[VIDEO_NODE_EVENT.FIRST_PLAYING] =
              A.onVideoNodeFirstPlaying.bind(A)),
            (o[VIDEO_NODE_EVENT.PLAY_OVER] = A.onVideoNodePlayOver.bind(A)),
            (o[VIDEO_NODE_EVENT.ERROR] = A.onVideoNodeError.bind(A)),
            o)),
          (A.screenWakeLock = new ScreenWakeLock()),
          (A.playerStatusChecker = new CheckPlayerStatus(A)),
          document.addEventListener("visibilitychange", A._eventMap.document),
          A._config.createVideoNodeWhenLoad ||
            A.createVideoNodes(A._config.maxVideoNodeCount),
          A
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.load = function (e, t) {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (o) {
              return !e || (e instanceof Array && e.length <= 0)
                ? (this.clearBeforeLoad(), [2])
                : (this.loadInner(e, t), [2]);
            });
          });
        }),
        (t.prototype.play = function (e, t) {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (o) {
              switch (o.label) {
                case 0:
                  return (
                    this._logger.log("play()"),
                    this.state !== exports.VIDEO_STATE.IDLE || e
                      ? ((this._checkPlayBlocked = !0),
                        this._vnList.length <= 1 || this._hasUserGestures
                          ? (this._logger.log(
                              "play(), skip triggerAutoplay()."
                            ),
                            this.triggerPlayResolve(e, t),
                            [3, 4])
                          : [3, 1])
                      : (this._logger.warn(
                          "play(), no urlConfig when idle state"
                        ),
                        [2])
                  );
                case 1:
                  return o.trys.push([1, 3, , 4]), [4, this.triggerAutoplay()];
                case 2:
                  return o.sent(), this.triggerPlayResolve(e, t), [3, 4];
                case 3:
                  return (
                    o.sent(),
                    this._config.type === exports.PLAY_MODE.VOD &&
                      e &&
                      this.loadInner(e, t),
                    [3, 4]
                  );
                case 4:
                  return [2];
              }
            });
          });
        }),
        (t.prototype.triggerAutoplay = function () {
          var e = this;
          if (this._triggerAutoplayPromise) return this._triggerAutoplayPromise;
          this._logger.log("triggerAutoplay(), start");
          for (var t = [], o = this._vnList.length, A = 0; A < o; A++) {
            var i = this._vnList[A].triggerAutoplay();
            t.push(i);
          }
          return (
            (this._triggerAutoplayPromise = Promise.all(t)),
            this._triggerAutoplayPromise.catch(function (t) {
              e._logger.log("play() triggerAutoplay catched: ", t),
                e.playBlocked();
            }),
            this._triggerAutoplayPromise
          );
        }),
        (t.prototype.seek = function (e) {
          var t;
          return (
            this.state !== exports.VIDEO_STATE.IDLE &&
            !(
              e < 0 ||
              !(null === (t = this._curVideoNode) || void 0 === t
                ? void 0
                : t.currentVideoInfo)
            ) &&
            this._curVideoNode.seek(e, !0)
          );
        }),
        (t.prototype.pause = function (e) {
          this._played
            ? this.pauseInner(e || PAUSE_TYPE.USER)
            : this._logger.warn("pause(), player has not been played");
        }),
        (t.prototype.stop = function (e) {
          void 0 === e && (e = exports.END_STATE.INTERRUPT),
            this.state !== exports.VIDEO_STATE.IDLE && this.stopInner(e, !0);
        }),
        (t.prototype.setLevel = function (e, t, o) {
          var A;
          "string" == typeof e
            ? (A = e)
            : ((A = e.url), (t = e.backupUrls), (o = e));
          var i = this.playerStatusChecker.checkSetLevelError(A);
          return i
            ? (this._logger.warn("setLevel(), ".concat(i)),
              Promise.reject(new Error(i)))
            : ((this._urlBeforeSetLevel = { url: A, backupUrls: t }),
              (this.currentVideoInfo.config.url = A),
              t && (this.currentVideoInfo.config.backupUrls = t),
              o &&
                (Object.assign(this._urlBeforeSetLevel, o),
                Object.assign(this.currentVideoInfo.config, o)),
              this.currentVideoInfo.reset(),
              this.setLevelInner(this.currentVideoInfo.config));
        }),
        (t.prototype.appendNext = function (e) {
          var t = this.playerStatusChecker.checkCanAppend(e);
          if (!t.canAppend) return this._logger.warn(t.message), !1;
          var o = this._videoInfos.find(function (t) {
            return compareUrlConfig(t.config, e);
          });
          if (o)
            return (
              this._logger.warn(
                "appendNext(), duplicate append! uid[".concat(o.uid, "]")
              ),
              !1
            );
          var A = this.preloadVideoInfos.find(function (t) {
            return compareUrlConfig(t.config, e);
          });
          return (
            A || (A = new VideoInfo(e, this._config)),
            this.clearAllPreloadInner(A),
            (this._videoInfos = this._videoInfos.slice(0, this._curUrlIdx + 1)),
            (this._videoInfos = this._videoInfos.concat(A)),
            this._logger.log("appendNext() succ, appendVideoInfo=", A),
            this.emit(exports.PLAY_EVENT.LIST_CHANGE),
            this.appendAfter(A),
            !0
          );
        }),
        (t.prototype.preloadNext = function () {
          for (var e = this, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          var A = this.playerStatusChecker.checkCanPreloadEnvi(t);
          if (!A.canPreload) return this._logger.warn(A.message), !1;
          var i = [];
          return (
            t.forEach(function (t) {
              var o = e.playerStatusChecker.checkCanPreloadEachConfig(t);
              o.canPreload
                ? e.nextVideoInfo && compareUrlConfig(t, e.nextVideoInfo.config)
                  ? i.push(e.nextVideoInfo)
                  : i.push(new VideoInfo(t, e._config))
                : e._logger.warn(o.message);
            }),
            this.preloadInner.apply(
              this,
              __spreadArray(
                [!1, { startTime: 0, kernelName: this.kernelName }],
                i,
                !1
              )
            ),
            !0
          );
        }),
        (t.prototype.clearAllPreload = function () {
          this.clearAllPreloadInner();
        }),
        (t.prototype.playNext = function (e) {
          this._played
            ? this.playNextInner({ isInterrupt: !0 })
            : this._logger.warn("playNext(), player has not been played");
        }),
        (t.prototype.hasAppended = function (e) {
          return !!this._videoInfos.find(function (t) {
            return compareUrlConfig(t.config, e);
          });
        }),
        (t.prototype.hasPreloaded = function (e) {
          return !!this.preloadVideoInfos.find(function (t) {
            return compareUrlConfig(t.config, e);
          });
        }),
        (t.prototype.setAudioTrack = function (e) {
          return Promise.reject(AUDIO_TRACK_ERROR_MSG.NOT_SUPPORT);
        }),
        (t.prototype.getAudioTrackList = function () {
          return this.currentVideoInfo ? this.currentVideoInfo.audioTracks : [];
        }),
        (t.prototype.getCurrentAudioTrack = function () {
          return this.currentVideoInfo
            ? this.currentVideoInfo.currentAudioTrack
            : NaN;
        }),
        (t.prototype.resizeVideoElements = function (e) {
          var t = this.videoElements;
          !e ||
            !t ||
            t.length <= 0 ||
            (t.forEach(function (t) {
              videoTool$1.resizeElement(t, e);
            }),
            this.emit(exports.PLAY_EVENT.RESIZE, e));
        }),
        (t.prototype.resize = function (e) {
          this.resizeVideoElements(e);
        }),
        (t.prototype.captureVideo = function (e, t, o, A) {
          var i,
            r = this.currentVideoElement;
          if (r) {
            if (r instanceof HTMLVideoElement)
              try {
                var n = videoTool$1.captureVideo(r, {
                  dx: e,
                  dy: t,
                  dw: o,
                  dh: A,
                });
                return Promise.resolve(n);
              } catch (e) {
                return Promise.reject(e);
              }
            return null === (i = r.captureVideo) || void 0 === i
              ? void 0
              : i.call(r, e, t, o, A);
          }
        }),
        (t.prototype.destroy = function () {
          var e, t;
          if ((this.stopInner(), this._vnList))
            for (var o = this._vnList.length, A = 0; A < o; A++)
              this._vnList[A].destroy();
          this._preloaders &&
            (this._preloaders.forEach(function (e) {
              e.clear();
            }),
            (this._preloaders = null)),
            document.removeEventListener(
              "visibilitychange",
              this._eventMap.document
            ),
            this.removeAllListeners(),
            null === (e = this.screenWakeLock) ||
              void 0 === e ||
              e.keepAlive(!1),
            (this.screenWakeLock = null),
            (this._videoInfos = null),
            (this._curVideoNode = null),
            (this._vnList = null),
            (this._eventMap = null),
            (this.lastVideoInfo = null),
            null === (t = this.playerStatusChecker) ||
              void 0 === t ||
              t.destroy(),
            (this.playerStatusChecker = null);
        }),
        Object.defineProperty(t.prototype, "duration", {
          get: function () {
            return this._curVideoNode ? this._curVideoNode.duration : 0;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "playtime", {
          get: function () {
            return this._curVideoNode ? this._curVideoNode.playtime : 0;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "state", {
          get: function () {
            return this._curVideoNode
              ? this._curVideoNode.state
              : exports.VIDEO_STATE.IDLE;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "played", {
          get: function () {
            return this._played;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "playbackRate", {
          get: function () {
            return this._playbackRate;
          },
          set: function (e) {
            this._playbackRate = e;
            for (var t = this._vnList.length, o = 0; o < t; o++)
              this._vnList[o].playbackRate = e;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "supportPlaybackRate", {
          get: function () {
            return !0;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "supportPreload", {
          get: function () {
            return !0;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "volume", {
          get: function () {
            return this._volume;
          },
          set: function (e) {
            this._volume = e;
            for (var t = this._vnList.length, o = 0; o < t; o++)
              this._vnList[o].volume = e;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "volumeGain", {
          get: function () {
            return this.volumeGainInner;
          },
          set: function (e) {
            (this.volumeGainInner = e),
              this._curVideoNode && (this._curVideoNode.volumeGain = e);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "audioEffect", {
          get: function () {
            return this.audioEffectInner;
          },
          set: function (e) {
            (this.audioEffectInner = e),
              this._curVideoNode && (this._curVideoNode.audioEffect = e);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "useWorker", {
          get: function () {
            return !!this._curVideoNode && this._curVideoNode.useWorker;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoElements", {
          get: function () {
            var e;
            return null === (e = this._vnList) || void 0 === e
              ? void 0
              : e.map(function (e) {
                  return e.videoElement;
                });
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "currentVideoElement", {
          get: function () {
            return this._curVideoNode ? this._curVideoNode.videoElement : null;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoInfos", {
          get: function () {
            return this._videoInfos;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "preloadVideoInfos", {
          get: function () {
            return this._preloaders.map(function (e) {
              return e.videoInfo;
            });
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoSize", {
          get: function () {
            return this._curVideoNode
              ? this._curVideoNode.videoSize
              : { width: 0, height: 0 };
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoBuffered", {
          get: function () {
            return this._curVideoNode
              ? this._curVideoNode.videoBuffered
              : [{ start: 0, end: 0 }];
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "currentVideoInfo", {
          get: function () {
            return this._curVideoNode
              ? this._curVideoNode.currentVideoInfo
              : this.lastVideoInfo;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "nextVideoInfo", {
          get: function () {
            return this._videoInfos[this._curUrlIdx + 1];
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "currentVideoInfoIdx", {
          get: function () {
            return this._curVideoNode
              ? this._videoInfos.indexOf(this._curVideoNode.currentVideoInfo)
              : -1;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "totalVideoInfoCount", {
          get: function () {
            return this._videoInfos.length;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "config", {
          get: function () {
            return this._config;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "curUrlIdx", {
          get: function () {
            return this._curUrlIdx;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.log = function () {
          for (var e, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          null === (e = this._logger) || void 0 === e || e.log.apply(e, t);
        }),
        (t.prototype.loadInner = function (e, t) {
          var o = this;
          this.clearBeforeLoad();
          var A = checkUrlConfigVailed(e);
          if (A)
            return (
              this.emit(exports.PLAY_EVENT.ERROR, { videoInfo: { error: A } }),
              !1
            );
          this._config.createVideoNodeWhenLoad &&
            (this._vnList.forEach(function (e) {
              return e.destroy();
            }),
            (this._vnList.length = 0),
            this.createVideoNodes(this._config.maxVideoNodeCount)),
            this.emit(exports.PLAY_EVENT.RESTART);
          var i = (t || {}).startTime,
            r = void 0 === i ? 0 : i;
          (this._videoInfos = [].concat(e).map(function (e) {
            return new VideoInfo(e, o._config);
          })),
            this.emit(exports.PLAY_EVENT.LIST_CHANGE);
          var n = this._videoInfos[0];
          return (
            this.preloadInner(
              !0,
              __assign$1(__assign$1({}, t), {
                startTime: r,
                kernelName: this.kernelName,
              }),
              n
            ),
            !0
          );
        }),
        (t.prototype.pauseInner = function (e) {
          void 0 === e && (e = PAUSE_TYPE.INNER),
            this.state !== exports.VIDEO_STATE.PAUSE &&
              this._curVideoNode &&
              this._curVideoNode.pause(e);
        }),
        (t.prototype.resumeInner = function () {
          var e;
          this._played &&
            (null === (e = this._curVideoNode) || void 0 === e
              ? void 0
              : e.currentVideoInfo) &&
            (0 === this._curVideoNode.duration ||
              this._curVideoNode.playtime < this._curVideoNode.duration) &&
            this._curVideoNode.videoplay();
        }),
        (t.prototype.stopInner = function (e, t, o) {
          var A;
          void 0 === e && (e = exports.END_STATE.NORMAL),
            void 0 === t && (t = !1),
            void 0 === o && (o = null),
            (null === (A = this._config) || void 0 === A ? void 0 : A.type) ===
              exports.PLAY_MODE.VOD && this.clearAllPreloadInner();
          var i = this._videoInfos;
          if (
            ((this.lastVideoInfo = null != o ? o : this.currentVideoInfo),
            (this._videoInfos = []),
            this._vnList)
          )
            for (var r = this._vnList.length, n = 0; n < r; n++)
              this._vnList[n].stop(), this.setPlayEvents(this._vnList[n], !1);
          (this._curUrlIdx = -1),
            i &&
              i.forEach(function (e) {
                e.destroy();
              }),
            this.setAudioEffectTimeoutId > 0 &&
              (clearTimeout(this.setAudioEffectTimeoutId),
              (this.setAudioEffectTimeoutId = 0)),
            (this._firstPlaying = !1),
            (this._played = !1),
            (this._curVideoNode = null);
          var a = null == o ? void 0 : o.error,
            s = a ? exports.END_STATE.ERROR : e;
          this._logger.log("stopInner(), endState=".concat(s)),
            t &&
              (this.emit(exports.PLAY_EVENT.STOPED, {
                videoInfo: o,
                isUserStop: e === exports.END_STATE.INTERRUPT,
                endState: s,
              }),
              a && this.emit(exports.PLAY_EVENT.ERROR, { videoInfo: o }));
        }),
        (t.prototype.preloadInner = function (e, t) {
          for (var o = [], A = 2; A < arguments.length; A++)
            o[A - 2] = arguments[A];
          this._logger.log("preloadInner(".concat(e, ", extra)"));
          var i = [],
            r = o.length;
          if (!(r <= 0)) {
            for (var n = 0; n < r; n++)
              if (o[n]) {
                this.clearPreloader(o[n]);
                var a = this.preparePreloader(e, o[n]);
                a &&
                  (o[n].setDependVideoInfo(this.currentVideoInfo),
                  a.load(e, this, o[n], t),
                  i.push(a));
              }
            (this._preloaders = this._preloaders.concat(i)),
              this._logger.log(
                "preload(), preloader's length: ",
                this._preloaders.length
              ),
              i.length > 0 &&
                this.emit(exports.PLAY_EVENT.PRELOAD_START, {
                  preloadVideoInfos: i.map(function (e) {
                    return e.videoInfo;
                  }),
                });
          }
        }),
        (t.prototype.playNextInner = function (e) {
          var t = (e || {}).isInterrupt;
          this._logger.log(
            "playNextInner(), curUrlIdx=".concat(this._curUrlIdx, "/") +
              "urlLength="
                .concat(this._videoInfos.length, "/isInterrupt=")
                .concat(t)
          );
          var o =
            Math.abs(this.playtime - this.duration) <=
            this._config.interruptPlayNextMinTime;
          if (t && o && this.state === exports.VIDEO_STATE.PLAYING)
            this._logger.log("playNextInner(), playNext right now! return!");
          else if (this._curUrlIdx + 1 >= this._videoInfos.length)
            this._logger.warn("There is no next VideoInfo.");
          else {
            (this._curUrlIdx += 1),
              this.setPlayEvents(this._curVideoNode, !1),
              t && this._curVideoNode.pause(PAUSE_TYPE.INNER);
            var A = this._videoInfos[this._curUrlIdx];
            this.clearAllPreloadInner(A),
              t &&
                this.emit(exports.PLAY_EVENT.VIDEONODE_PLAY_OVER, {
                  videoInfo: this.currentVideoInfo,
                }),
              this.playInner();
          }
        }),
        (t.prototype.clearAllPreloadInner = function (e) {
          var t = this;
          !this._preloaders ||
            this._preloaders.length <= 0 ||
            this._preloaders
              .filter(function (t) {
                return t.videoInfo !== e;
              })
              .forEach(function (e) {
                t.clearPreloader(e.videoInfo);
              });
        }),
        (t.prototype.clearBeforeLoad = function () {
          var e;
          null === (e = this._vnList) ||
            void 0 === e ||
            e.forEach(function (e) {
              videoTool$1.clear(e.videoElement);
            }),
            this.stopInner(
              this._played
                ? exports.END_STATE.INTERRUPT
                : exports.END_STATE.NORMAL,
              this._played,
              this._played ? this.currentVideoInfo : null
            );
        }),
        (t.prototype.clearPreloader = function (e, t) {
          if (this._preloaders && !(this._preloaders.length <= 0) && e) {
            var o = this.findPreloadIdxByVideoInfo(e);
            if (-1 !== o) this._preloaders.splice(o, 1)[0].clear(t);
          }
        }),
        (t.prototype.findPreloadIdxByVideoInfo = function (e) {
          return e
            ? this._preloaders.findIndex(function (t) {
                return t.videoInfo === e;
              })
            : -1;
        }),
        (t.prototype.decideSetLevelMode = function (e) {
          return this.playerStatusChecker.checkSetLevelMode(
            this._vnList.length,
            e
          );
        }),
        (t.prototype.createVideoNode = function (e) {
          return uaTool$1.os.ios ? new OrgIOSVideoNode(e) : new OrgVideoNode(e);
        }),
        (t.prototype.createVideoNodes = function (e) {
          for (var t = 0; t < e; t++) {
            var o = this.createVideoNode(this._config);
            (o.idx = t),
              (o.volume = this._volume),
              (o.playbackRate = this._playbackRate),
              o.videoElement instanceof HTMLElement &&
                (o.videoElement.dataset.idx = "".concat(t)),
              this._vnList.push(o);
          }
        }),
        (t.prototype.setPlayEvents = function (e, t) {
          var o = this;
          e &&
            (t && this.setPlayEvents(e, !1),
            this._logger.log(
              "set VideoNode evts, idx=".concat(e.idx, "/isSet=").concat(t)
            ),
            Object.keys(VIDEO_NODE_EVENT).forEach(function (A) {
              (t ? e.on : e.off).apply(e, [
                VIDEO_NODE_EVENT[A],
                o._eventMap.videonode,
              ]);
            }));
        }),
        (t.prototype.videonodeEventHandler = function (e) {
          this.logVideoNodeEvts(e);
          var t = !0;
          this.videoEvtHandlerMap[e.type] &&
            (t = this.videoEvtHandlerMap[e.type](e)),
            t &&
              e.type in videoEvt2PlayerEvtMap &&
              this.emit(videoEvt2PlayerEvtMap[e.type], e.data);
        }),
        (t.prototype.onVideoNodeRateChange = function (e) {
          var t = e.data.playbackRate;
          return (this._playbackRate = t), !0;
        }),
        (t.prototype.onVideoNodeStateChange = function (e) {
          return e.data.new === exports.VIDEO_STATE.PAUSE &&
            e.data.pauseType === PAUSE_TYPE.INNER
            ? (this._logger.log("inner pause does not emit event."), !1)
            : (e.data.new === exports.VIDEO_STATE.PLAYING &&
                (this._checkPlayBlocked = !1),
              this.screenWakeLock.keepAlive(
                e.data.new === exports.VIDEO_STATE.PLAYING
              ),
              !0);
        }),
        (t.prototype.onVideoNodePlayPromiseCatched = function (e) {
          return (
            this._checkPlayBlocked &&
              e.data.isAutoPlayBlocked &&
              ((this._checkPlayBlocked = !1), this.playBlocked()),
            !0
          );
        }),
        (t.prototype.onVideoNodeFirstPlaying = function (e) {
          var t = this;
          return (
            this._firstPlaying ||
              (this.emit(exports.PLAY_EVENT.FIRST_PLAYING, {
                videoInfo: this.currentVideoInfo,
              }),
              (this._firstPlaying = !0),
              (this._hasUserGestures = !0)),
            (this.setAudioEffectTimeoutId = setTimeout(function () {
              t._curVideoNode.volumeGain !== t.volumeGainInner &&
                (t.volumeGain = t.volumeGainInner),
                t._curVideoNode.audioEffect !== t.audioEffectInner &&
                  (t.audioEffect = t.audioEffectInner);
            }, 0)),
            !0
          );
        }),
        (t.prototype.onVideoNodePlayOver = function (e) {
          if (this._config.isPlayList || this.nextVideoInfo)
            this.emit(exports.PLAY_EVENT.VIDEONODE_PLAY_OVER, {
              videoInfo: this.currentVideoInfo,
            }),
              this.checkPlayNext();
          else {
            var t = this.currentVideoInfo;
            this.stopInner(exports.END_STATE.NORMAL, !0, t),
              this.emit(exports.PLAY_EVENT.VIDEONODE_PLAY_OVER, {
                videoInfo: t,
              });
          }
          return !1;
        }),
        (t.prototype.onVideoNodeError = function (e) {
          var t = (e.data || {}).videoInfo;
          return this.stopInner(exports.END_STATE.ERROR, !0, t), !1;
        }),
        (t.prototype.logVideoNodeEvts = function (e) {
          var t, o;
          if (
            !(
              IGNORE_EVT_TYPE.includes(e.type) ||
              (e.type === VIDEO_NODE_EVENT.ELEMENT_EVTS &&
                IGNORE_VIDEO_EVT.includes(e.data.elementEvtType))
            )
          ) {
            var A = e.data;
            e.type === VIDEO_NODE_EVENT.STATE_CHANGE
              ? (A = "[".concat(e.data.old, "->").concat(e.data.new, "]"))
              : e.type === VIDEO_NODE_EVENT.ELEMENT_EVTS &&
                (A = "[elementEvtType=".concat(e.data.elementEvtType, "]")),
              this._logger.log(
                "get VideoNode evt, type="
                  .concat(e.type, "/uid=")
                  .concat(
                    null ===
                      (o =
                        null === (t = this._curVideoNode) || void 0 === t
                          ? void 0
                          : t.currentVideoInfo) || void 0 === o
                      ? void 0
                      : o.uid,
                    "/data="
                  ),
                A
              );
          }
        }),
        (t.prototype.playBlocked = function () {
          var e = this;
          (this._playBlocking = !0),
            (this._triggerAutoplayPromise = null),
            setTimeout(function () {
              e.emit(exports.PLAY_EVENT.AUTOPLAY_BLOCKED, {
                videoInfo: e.currentVideoInfo,
              });
            }, 0),
            this.setLoading(!1);
        }),
        (t.prototype.checkPlayNext = function () {
          var e = this.playerStatusChecker.checkCanPlayNext();
          this._logger.log(e.message), e.canPlayNext && this.playNextInner();
        }),
        (t.prototype.checkAutoPreloadNext = function (e) {
          this.playerStatusChecker.checkAutoPreloadNext(e).canPreload &&
            this.preloadInner(
              !1,
              { startTime: 0, kernelName: this.kernelName },
              this.nextVideoInfo
            );
        }),
        (t.prototype.setCurVideoNode = function (e, t) {
          void 0 === t && (t = !1),
            (this._curVideoNode !== e || t) &&
              (this._curVideoNode &&
                ((this._curVideoNode.onAccurateTimeupdate = null),
                this.setPlayEvents(this._curVideoNode, !1)),
              e &&
                ((this._curVideoNode = e),
                (this._curVideoNode.onAccurateTimeupdate =
                  this.checkAccuratePlaytime.bind(this)),
                this.setPlayEvents(this._curVideoNode, !0)));
        }),
        (t.prototype.detectSourceOnError = function (e) {
          var t = this,
            o = e || {},
            A = o.loadingUrl,
            i = o.uid;
          A
            ? detectStream(A)
                .then(function (e) {
                  t._logger.error(
                    "detectSourceOnError=",
                    __assign$1({ uid: i }, e)
                  );
                })
                .catch(function (e) {
                  t._logger.error(
                    "detectSourceOnError err",
                    null == e ? void 0 : e.message
                  );
                })
            : this._logger.error("detectSourceOnError, url=null");
        }),
        (t.prototype.setLoading = function (e) {
          this.emit(exports.PLAY_EVENT.SET_LOADING, { show: e });
        }),
        (t.prototype.visibilityChangeHandler = function () {
          this.screenWakeLock.keepAlive(
            this.state === exports.VIDEO_STATE.PLAYING
          );
        }),
        (t.prototype.triggerPlayResolve = function (e, t) {
          var o = this;
          if (!e)
            return this._played
              ? this._playBlocking || videoTool$1.cannotDetectAutoPlayBlock()
                ? ((this._playBlocking = !1),
                  void setTimeout(function () {
                    var e, t;
                    (null ===
                      (t =
                        null === (e = o._curVideoNode) || void 0 === e
                          ? void 0
                          : e.videoBuffered) || void 0 === t
                      ? void 0
                      : t.length) <= 0 && o.setLoading(!0),
                      o.resumeInner();
                  }, 0))
                : void (-1 ===
                  [
                    exports.VIDEO_STATE.PAUSE,
                    exports.VIDEO_STATE.CANPLAY,
                    exports.VIDEO_STATE.SEEKED,
                  ].indexOf(this.state)
                    ? this._logger.log(
                        "play() has been called, but cannot do nothing."
                      )
                    : this.resumeInner())
              : (this.setLoading(!0), void this.triggerPlayAfterLoad());
          this.loadInner(e, t) &&
            (this.setLoading(!0), this.triggerPlayAfterLoad());
        }),
        (t.prototype.triggerPlayAfterLoad = function () {
          this._played ||
            -1 !== this._curUrlIdx ||
            (this._videoInfos[0] &&
              ((this._played = !0), (this._curUrlIdx = 0), this.playInner()));
        }),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "load",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Number]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "seek",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "stop",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Array, Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "setLevel",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "appendNext",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "preloadNext",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "playNext",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "setAudioTrack",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "resizeVideoElements",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "destroy",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "resumeInner",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String, Object, Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "stopInner",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "playNextInner",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "playBlocked",
          null
        ),
        __decorate(
          [
            logMethodCall$3,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "checkPlayNext",
          null
        ),
        t
      );
    })(s$1$1),
    defaultOriginKernelConfig = {
      maxVideoNodeCount: 1,
      advanceEndTime: 0,
      prePlayNextTime: 0,
    };
  function mergeKernelConfig(e) {
    return __assign$1(__assign$1({}, e), {
      originKernelConfig: __assign$1(
        __assign$1({}, defaultOriginKernelConfig),
        e.originKernelConfig
      ),
    });
  }
  var logMethodCall$2 = logMethodCallDecoratorCreator("OrgPreLoader"),
    OrgPreLoader = (function () {
      function e(e) {
        var t;
        (this.playerConfig = e),
          (this.deferInner = new SimpleDefer$1()),
          (this.logger = new Logger(e.instanceId, "OrgPreLoader")),
          (this.evtMaps =
            (((t = {})[VIDEO_NODE_EVENT.STATE_CHANGE] =
              this.firstLoadStateChangeHandler.bind(this)),
            (t[VIDEO_NODE_EVENT.ERROR] = this.errorHandler.bind(this)),
            t));
      }
      return (
        Object.defineProperty(e.prototype, "promise", {
          get: function () {
            return this.deferInner.promise;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "videoInfo", {
          get: function () {
            return this.videoInfoInner;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (e.prototype.getVideoNode = function () {
          var e;
          return null === (e = this.videoInfoInner) || void 0 === e
            ? void 0
            : e.extraVars.preloadVideoNode;
        }),
        (e.prototype.errorHandler = function (e) {
          this.preloadFail(e.data.videoInfo.error);
        }),
        (e.prototype.firstLoadStateChangeHandler = function (e) {
          e.data.new === exports.VIDEO_STATE.CANPLAY && this.preloadSucc();
        }),
        (e.prototype.preloadSucc = function () {
          this.logger.log(
            "preload url ready>>>>>> uid=".concat(this.videoInfoInner.uid)
          ),
            this.clearInner(!0),
            this.evtDispatcher.emit(exports.PLAY_EVENT.PRELOAD_VIDEONODE_OVER, {
              videoInfo: this.videoInfoInner,
            }),
            this.deferInner.resolve();
        }),
        (e.prototype.preloadFail = function (e) {
          this.logger.log(
            "preload url fail>>>>>> uid: ".concat(this.videoInfoInner.uid)
          ),
            this.clearInner(),
            this.evtDispatcher.emit(
              exports.PLAY_EVENT.PRELOAD_VIDEONODE_ERROR,
              { videoInfo: this.videoInfoInner }
            ),
            (this.videoInfoInner.error = e),
            this.deferInner.reject(e);
        }),
        (e.prototype.setVideoNodeEvents = function (e) {
          var t = this,
            o = this.getVideoNode();
          Object.keys(this.evtMaps).forEach(function (A) {
            e ? o.on(A, t.evtMaps[A]) : o.off(A, t.evtMaps[A]);
          });
        }),
        (e.prototype.load = function (e, t, o, A) {
          (this.videoInfoInner = o),
            (this.evtDispatcher = t),
            this.setVideoNodeEvents(!0),
            this.logger.log("load(), isFirstLoad=".concat(e)),
            this.getVideoNode().load(o, A);
        }),
        (e.prototype.clearInner = function (e, t) {
          if (this.videoInfoInner) {
            var o = this.getVideoNode();
            o &&
              (this.logger.log(
                "clear(), uid="
                  .concat(this.videoInfoInner.uid, "/keep=")
                  .concat(e)
              ),
              this.setVideoNodeEvents(!1),
              e ||
                ((this.videoInfoInner.extraVars.preloadVideoNode = null),
                o.stop()),
              t &&
                this.evtDispatcher.emit(
                  exports.PLAY_EVENT.PRELOAD_VIDEONODE_CLEAR,
                  { videoInfo: this.videoInfoInner }
                ));
          }
        }),
        (e.prototype.clear = function (e) {
          this.clearInner(e, !0);
        }),
        __decorate(
          [
            logMethodCall$2,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Boolean, s$1$1, Object, Object]),
            __metadata("design:returntype", void 0),
          ],
          e.prototype,
          "load",
          null
        ),
        __decorate(
          [
            logMethodCall$2,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Boolean]),
            __metadata("design:returntype", void 0),
          ],
          e.prototype,
          "clear",
          null
        ),
        e
      );
    })(),
    logMethodCall$1$1 = logMethodCallDecoratorCreator("MultiPlayer"),
    MultiPlayer = (function (e) {
      function t(t) {
        var o,
          A = e.call(this, mergeKernelConfig(t)) || this;
        return (
          (A._needHideVideoNode = null),
          (A._videonodeEventMap =
            (((o = {})[VIDEO_NODE_EVENT.STATE_CHANGE] =
              A.onCurVideoNodeStateChange.bind(A)),
            o)),
          A
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t, "canPlayType", {
          get: function () {
            return videoTool$1.supportVideoFormat();
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "supportPreload", {
          get: function () {
            return videoTool$1.supportSameTimePlay();
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "kernelName", {
          get: function () {
            return exports.KERNEL_NAME.ORIGIN;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.seek = function (t) {
          return !this.getLevelSwitching() && e.prototype.seek.call(this, t);
        }),
        (t.prototype.createVideoNodes = function (t) {
          e.prototype.createVideoNodes.call(this, t);
          for (var o = 0; o < this._vnList.length; o++) {
            var A = this._vnList[o];
            0 === o ? (this._firstVideoNode = A) : this.visibleVideoNode(A, !1);
          }
        }),
        (t.prototype.videonodeEventHandler = function (t) {
          this._videonodeEventMap[t.type] && this._videonodeEventMap[t.type](t),
            e.prototype.videonodeEventHandler.call(this, t);
        }),
        (t.prototype.onCurVideoNodeStateChange = function (e) {
          if (
            e.data.new === exports.VIDEO_STATE.PLAYING &&
            (this.switchVideoNode(),
            !this.currentVideoInfo.extraVars.isStartPlay)
          ) {
            this.currentVideoInfo.extraVars.isStartPlay = !0;
            var t = this.currentVideoInfo ? this.currentVideoInfo.uid : null;
            this._logger.log("videoNodeStartPlay: uid[".concat(t, "]")),
              this.emit(exports.PLAY_EVENT.VIDEONODE_START_PLAY, {
                videoInfo: this.currentVideoInfo,
              });
          }
        }),
        (t.prototype.onVideoNodeStateChange = function (t) {
          return (
            !(
              this.getLevelSwitching() &&
              !VALID_STATE_IN_LEVEL_SWITCHING.includes(t.data.new)
            ) && e.prototype.onVideoNodeStateChange.call(this, t)
          );
        }),
        (t.prototype.pauseInner = function (t) {
          void 0 === t && (t = PAUSE_TYPE.INNER),
            this._prePlayNext
              ? this._logger.warn("pause when preplaynext, return!!")
              : e.prototype.pauseInner.call(this, t);
        }),
        (t.prototype.resumeInner = function () {
          this.getLevelSwitching()
            ? this._setLevelVideoNode.play()
            : e.prototype.resumeInner.call(this);
        }),
        (t.prototype.loadInner = function (t, o) {
          for (
            var A,
              i =
                (null === (A = this._vnList) || void 0 === A
                  ? void 0
                  : A.length) || 0,
              r = 0;
            r < i;
            r++
          )
            this.visibleVideoNode(this._vnList[r], !1);
          return e.prototype.loadInner.call(this, t, o);
        }),
        (t.prototype.playInner = function (e) {
          if (this.checkBeforePlay()) {
            this.playStartTime = e;
            var t = this._videoInfos[this._curUrlIdx],
              o = this.findPreloadIdxByVideoInfo(t);
            -1 !== o
              ? this.preloadToPlay(t, o)
              : t.error
              ? (this._logger.log("play(), got preload error"),
                this.stopInner(exports.END_STATE.ERROR, !0, t))
              : this.enterVideoNodePlay(t);
          }
        }),
        (t.prototype.visibleVideoNode = function (e, t) {
          var o;
          (null == e ? void 0 : e.videoElement) &&
            (this.setVideoElementState(e.videoElement, t),
            this._logger.log(
              ">>>visibleVideoNode<<<, value="
                .concat(t, "/uid=")
                .concat(
                  null === (o = e.currentVideoInfo) || void 0 === o
                    ? void 0
                    : o.uid
                )
            ));
        }),
        (t.prototype.setVideoElementState = function (e, t) {
          var o = t ? this._volume : 0;
          e.volume !== o && (e.volume = o);
          var A = this._volume <= 0 || !t;
          e.muted !== A && (e.muted = A),
            domTool$1.css(e, "zIndex", t ? "0" : "-1"),
            domTool$1.css(e, "visibility", t ? "inherit" : "hidden");
        }),
        (t.prototype.switchVideoNode = function () {
          if (
            this._needHideVideoNode &&
            this._curVideoNode !== this._needHideVideoNode
          ) {
            this._logger.log(">>>>>switchVideoNode<<<<<"),
              this.visibleVideoNode(this._curVideoNode, !0);
            var e = this._needHideVideoNode;
            this.visibleVideoNode(e, !1),
              e && e.stop(),
              (this._needHideVideoNode = null);
          }
        }),
        (t.prototype.playNextInner = function (t) {
          (this._needHideVideoNode = this._curVideoNode),
            (this._prePlayNext = !1),
            e.prototype.playNextInner.call(this, t);
        }),
        (t.prototype.appendAfter = function (e) {
          var t =
            !this._curVideoNode ||
            this._curVideoNode.state === exports.VIDEO_STATE.IDLE;
          this._played &&
            this._curUrlIdx + 1 === this._videoInfos.indexOf(e) &&
            t &&
            this.playNextInner();
        }),
        (t.prototype.preparePreloader = function (e, t) {
          this._logger.log("preparePreloader(), isFirstLoad=", e);
          var o = this.getIdleVideoNode();
          return o
            ? ((t.extraVars.preloadVideoNode = o),
              e && (this.setCurVideoNode(o), this.visibleVideoNode(o, !0)),
              new OrgPreLoader(this._config))
            : null;
        }),
        (t.prototype.getIdleVideoNode = function () {
          if (this._firstVideoNode) {
            var e = this._firstVideoNode;
            return (this._firstVideoNode = null), e;
          }
          for (var t = null, o = this._vnList.length, A = 0; A < o; A++)
            if (
              this._vnList[A].state === exports.VIDEO_STATE.IDLE &&
              this._vnList[A] !== this._curVideoNode
            ) {
              t = this._vnList.splice(A, 1)[0];
              break;
            }
          return t && this._vnList.push(t), t;
        }),
        (t.prototype.getLevelSwitching = function () {
          return !!this._setLevelVideoNode;
        }),
        (t.prototype.setLevelInner = function (e) {
          var t = this.decideSetLevelMode(null == e ? void 0 : e.setLevelMode);
          return (
            this._logger.log("setLevelMode=".concat(t)),
            t === SET_LEVEL_MODE.HARD || t === SET_LEVEL_MODE.SMOOTH
              ? this._curVideoNode.setLevel(t)
              : this.setLevelSoftMode()
          );
        }),
        (t.prototype.switchVideoNodeWhenSetLevelSucc = function (e) {
          this._logger.log(">>>>>switchLevelVideoNode<<<<<"),
            e === this._curVideoNode
              ? this.visibleVideoNode(this._curVideoNode, !0)
              : (this.visibleVideoNode(this._curVideoNode, !0),
                this.visibleVideoNode(e, !1),
                null == e || e.stop());
        }),
        (t.prototype.checkAccuratePlaytime = function (e, t) {
          var o,
            A,
            i = this._config.originKernelConfig.prePlayNextTime,
            r = Math.abs(t - e);
          if (i > 0 && r < i && !this._prePlayNext) {
            this._prePlayNext = !0;
            var n = this.findPreloadIdxByVideoInfo(this.nextVideoInfo);
            if (this.nextVideoInfo && -1 !== n) {
              var a =
                null ===
                  (A =
                    null === (o = this._preloaders[n]) || void 0 === o
                      ? void 0
                      : o.videoInfo) || void 0 === A
                  ? void 0
                  : A.extraVars.preloadVideoNode;
              a &&
                (this._logger.log(
                  "preplay next!! idx/state: "
                    .concat(a.idx, "/")
                    .concat(a.state)
                ),
                a.play());
            }
          }
          this.checkAutoPreloadNext(r);
        }),
        (t.prototype.stopInner = function (t, o, A) {
          void 0 === t && (t = exports.END_STATE.NORMAL),
            void 0 === o && (o = !1),
            void 0 === A && (A = null),
            (this._firstVideoNode = null),
            (this._prePlayNext = !1),
            (this.playStartTime = 0),
            this.clearSetLevelThings(!0),
            e.prototype.stopInner.call(this, t, o, A);
        }),
        (t.prototype.destroy = function () {
          (this._needHideVideoNode = null),
            (this._setLevelVideoNode = null),
            (this._firstVideoNode = null),
            (this.playStartTime = 0);
          var t = this.videoElements;
          e.prototype.destroy.call(this),
            t.forEach(function (e) {
              e instanceof HTMLVideoElement &&
                ((e.volume = 1),
                (e.muted = !1),
                domTool$1.css(e, { zIndex: "0", visibility: "inherit" }),
                (e.dataset.idx = "0"));
            });
        }),
        (t.prototype.checkBeforePlay = function () {
          return this.getLevelSwitching()
            ? (this._setLevelVideoNode.play(),
              this._logger.log("play(), setlevel"),
              !1)
            : !(
                this._videoInfos.length <= 0 ||
                !this._videoInfos[this._curUrlIdx]
              ) || (this._logger.warn("play(), !videoInfo"), !1);
        }),
        (t.prototype.emitStateChange = function (e, t) {
          this.emit(exports.PLAY_EVENT.STATE_CHANGE, {
            videoInfo: e,
            new: t,
            old: this._curVideoNode
              ? this._curVideoNode.state
              : exports.VIDEO_STATE.IDLE,
          });
        }),
        (t.prototype.preloadToPlay = function (e, t) {
          var o = this,
            A = 0;
          e.hasFirstPlaying &&
            (A = window.setTimeout(function () {
              o.emitStateChange(e, exports.VIDEO_STATE.BUFFERING);
            }, 200)),
            this._preloaders[t].promise
              .then(function () {
                clearTimeout(A),
                  o._logger.log(
                    "play(), preloadVideoNode succ, uid=".concat(e.uid)
                  ),
                  o.enterVideoNodePlay(e, t);
              })
              .catch(function (t) {
                o._logger.log(
                  "play(), preloadVideoNode error, uid=".concat(
                    e.uid,
                    "/error="
                  ),
                  t
                ),
                  t.code in ERROR_CODE &&
                    (clearTimeout(A),
                    (e.error = t),
                    o.stopInner(exports.END_STATE.ERROR, !0, e));
              });
        }),
        (t.prototype.enterVideoNodePlay = function (e, t) {
          var o, A, i;
          void 0 === t && (t = -1);
          var r = -1 !== t;
          this._logger.log("enterVideoNodePlay(), preloadSucc=".concat(r));
          var n =
            -1 !== t
              ? null ===
                  (A =
                    null === (o = this._preloaders[t]) || void 0 === o
                      ? void 0
                      : o.videoInfo) || void 0 === A
                ? void 0
                : A.extraVars.preloadVideoNode
              : null;
          (this.findIdleVideoNode(n), -1 !== t) &&
            this._preloaders.splice(t, 1)[0].clear(!0);
          this._needHideVideoNode
            ? this._needHideVideoNode === this._curVideoNode
              ? (this.visibleVideoNode(this._curVideoNode, !0),
                this._logger.log("visibleVideoNode, need==current"))
              : r && this.switchVideoNode()
            : (this.visibleVideoNode(this._curVideoNode, !0),
              this._logger.log("visibleVideoNode, null need")),
            this._curVideoNode.state !== exports.VIDEO_STATE.PLAYING &&
              this._curVideoNode.play(e, { startTime: this.playStartTime }),
            this.emit(exports.PLAY_EVENT.VIDEONODE_CHANGE, {
              videoInfo: this.currentVideoInfo,
            }),
            this._logger.log(
              "enterMultiPlay(), uid=".concat(
                null === (i = this.currentVideoInfo) || void 0 === i
                  ? void 0
                  : i.uid,
                "/"
              ) +
                "urlIdx="
                  .concat(this._curUrlIdx, "/state=")
                  .concat(this._curVideoNode.state)
            ),
            r &&
              (0 !== this._videoInfos.indexOf(this.currentVideoInfo) &&
                (this.emit(exports.PLAY_EVENT.DURATION_CHANGE, {
                  videoInfo: this.currentVideoInfo,
                }),
                this.emitStateChange(
                  this.currentVideoInfo,
                  this._curVideoNode.state
                )),
              this.currentVideoInfo.extraVars.isStartPlay ||
                ((this.currentVideoInfo.extraVars.isStartPlay = !0),
                this._logger.log(
                  "videoNodeStartPlay: uid[".concat(
                    this.currentVideoInfo.uid,
                    "]"
                  )
                ),
                this.emit(exports.PLAY_EVENT.VIDEONODE_START_PLAY, {
                  videoInfo: this.currentVideoInfo,
                })));
        }),
        (t.prototype.findIdleVideoNode = function (e) {
          var t,
            o = !1;
          if (
            ((t = e) || (t = this.getIdleVideoNode()),
            !t &&
              this._curVideoNode &&
              this._curVideoNode.state === exports.VIDEO_STATE.IDLE &&
              ((t = this._curVideoNode), (o = !0)),
            !t)
          )
            throw (
              (this._logger.warn("can not find idle videonode!"),
              new Error("can not find idle videonode!"))
            );
          this.setCurVideoNode(t, o);
        }),
        (t.prototype.setLevelSoftMode = function () {
          var e = this,
            t = new SimpleDefer$1(),
            o = this.currentVideoInfo;
          this._logger.log("setLevelInner(), uid: ".concat(o.uid)),
            this.pauseInner(),
            this.setPlayEvents(this._curVideoNode, !1),
            this.emit(exports.PLAY_EVENT.SETLEVEL_START, {
              videoInfo: o,
              mode: SET_LEVEL_MODE.SMOOTH,
            }),
            this.setLoading(!0);
          var A = this._curVideoNode.playtime,
            i = this.getIdleVideoNode();
          i
            ? this.visibleVideoNode(i, !1)
            : (this._curVideoNode.stop(), (i = this._curVideoNode)),
            (o.extraVars.isLoadstarted = !1),
            (this._setLevelVideoNode = i),
            (this._setLevelVideoNode.setLevelEvtMap = {});
          var r = this._curVideoNode;
          return (
            this.setCurVideoNode(i, !0),
            (i.setLevelEvtMap[VIDEO_NODE_EVENT.STATE_CHANGE] = function (A) {
              A.data.new === exports.VIDEO_STATE.PLAYING &&
                e.setLevelSoftModeHandler(o, t, r);
            }),
            (i.setLevelEvtMap[VIDEO_NODE_EVENT.ERROR] = function () {
              e.setLevelSoftModeHandler(o, t);
            }),
            i.on(
              VIDEO_NODE_EVENT.STATE_CHANGE,
              i.setLevelEvtMap[VIDEO_NODE_EVENT.STATE_CHANGE]
            ),
            i.on(
              VIDEO_NODE_EVENT.ERROR,
              i.setLevelEvtMap[VIDEO_NODE_EVENT.ERROR]
            ),
            i.play(o, { startTime: A }),
            t.promise
          );
        }),
        (t.prototype.clearSetLevelThings = function (e) {
          if (this.getLevelSwitching()) {
            var t = this._setLevelVideoNode;
            t.setLevelEvtMap &&
              (Object.keys(t.setLevelEvtMap).forEach(function (e) {
                t.off(e, t.setLevelEvtMap[e]);
              }),
              (t.setLevelEvtMap = null)),
              e || t.stop(),
              this.clearAllPreloadInner(),
              (this._setLevelVideoNode = null);
          }
        }),
        (t.prototype.setLevelSoftModeHandler = function (e, t, o) {
          var A;
          void 0 === o && (o = null);
          var i = !!o;
          this._logger.log(
            "setLevel succ>>>>>> ".concat(i, " uid: ").concat(e.uid)
          ),
            this.clearSetLevelThings(i),
            i
              ? (this.switchVideoNodeWhenSetLevelSucc(o), t.resolve())
              : (this.rollbackLevelVideoNode(),
                t.reject(
                  new Error(
                    "setLevel failed, ".concat(
                      null === (A = e.error) || void 0 === A
                        ? void 0
                        : A.message
                    )
                  )
                )),
            this.emit(exports.PLAY_EVENT.SETLEVEL_OVER, {
              videoInfo: e,
              fail: !i,
            }),
            this.setLoading(!1);
        }),
        (t.prototype.rollbackLevelVideoNode = function () {
          this._logger.log(">>>>>rollbackLevelVideoNode<<<<<"),
            this._urlBeforeSetLevel &&
              (Object.assign(
                this.currentVideoInfo.config,
                this._urlBeforeSetLevel
              ),
              this.currentVideoInfo.reset(),
              (this._urlBeforeSetLevel = null)),
            this.setPlayEvents(this._curVideoNode, !0),
            this.resumeInner();
        }),
        (t.isEnvSupport = !0),
        __decorate(
          [
            logMethodCall$1$1,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Number]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "playInner",
          null
        ),
        __decorate(
          [
            logMethodCall$1$1,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "switchVideoNode",
          null
        ),
        t
      );
    })(BasePlayer);
  function getEnvVals$2() {
    var e = "npm";
    try {
      e = "npm";
    } catch (e) {}
    var t = "";
    try {
      t = "1.28.0";
    } catch (e) {}
    var o = "";
    try {
      o = 1697609978131;
    } catch (e) {}
    var A = !1;
    try {
      A = !1;
    } catch (e) {}
    var i = !1;
    try {
      i = !1;
    } catch (e) {}
    return {
      CHANNEL: e,
      VERSION: i ? "".concat(t, "-beta") : t,
      BUILD_TIME: o,
      LOCAL_DEV: A,
      IS_BETA: i,
    };
  }
  var _a$1$2 = getEnvVals$2(),
    CHANNEL = _a$1$2.CHANNEL,
    BUILD_TIME$1 = _a$1$2.BUILD_TIME,
    VERSION$2 = _a$1$2.VERSION,
    LOCAL_DEV = _a$1$2.LOCAL_DEV,
    IS_BETA = _a$1$2.IS_BETA,
    BaseLivePlayer = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        __extends$1(t, e),
        (t.prototype.playInner = function (e) {
          var t = this._videoInfos[0];
          this.setPlayEvents(this._curVideoNode, !0),
            this._curVideoNode.play(t),
            this.emit(exports.PLAY_EVENT.VIDEONODE_CHANGE, { videoInfo: t });
        }),
        (t.prototype.resumeInner = function () {
          var e;
          this._played &&
            (null === (e = this._curVideoNode) || void 0 === e
              ? void 0
              : e.currentVideoInfo) &&
            this._curVideoNode.videoplay();
        }),
        (t.prototype.loadInner = function (t, o) {
          return (
            !!e.prototype.loadInner.call(this, t, o) &&
            (this.setCurVideoNode(this._vnList[0]),
            this._curVideoNode.load(this._videoInfos[0]),
            !0)
          );
        }),
        (t.prototype.appendAfter = function (e) {}),
        (t.prototype.checkAccuratePlaytime = function (e, t) {}),
        (t.prototype.preparePreloader = function (e, t) {
          return null;
        }),
        (t.prototype.getIdleVideoNode = function () {
          return this._vnList[0];
        }),
        (t.prototype.setLevelInner = function (e) {
          return this._curVideoNode.setLevel(e.setLevelMode);
        }),
        (t.prototype.playBlocked = function () {
          e.prototype.playBlocked.call(this), this.pause();
        }),
        Object.defineProperty(t.prototype, "supportPreload", {
          get: function () {
            return !1;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "supportPlaybackRate", {
          get: function () {
            return !1;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "nextVideoInfo", {
          get: function () {
            return this.currentVideoInfo;
          },
          enumerable: !1,
          configurable: !0,
        }),
        t
      );
    })(BasePlayer);
  [
    "seek",
    "hasAppended",
    "hasPreloaded",
    "playNext",
    "appendNext",
    "preloadNext",
    "clearAllPreload",
    "appendAfter",
    "checkPlayNext",
    "playNextInner",
    "checkAutoPreloadNext",
    "clearAllPreloadInner",
  ].forEach(function (e) {
    BaseLivePlayer.prototype[e] = function () {
      console.warn(
        "[thumbplayer] ".concat(e, "() is not support due to live stream")
      );
    };
  });
  var LivePlayer = (function (e) {
      function t(t) {
        return e.call(this, mergeKernelConfig(t)) || this;
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "kernelName", {
          get: function () {
            return exports.KERNEL_NAME.ORIGIN;
          },
          enumerable: !1,
          configurable: !0,
        }),
        t
      );
    })(BaseLivePlayer),
    OrgPlayer = (function () {
      function e(e) {
        return e.type === exports.PLAY_MODE.LIVE
          ? new LivePlayer(e)
          : new MultiPlayer(e);
      }
      return (
        Object.defineProperty(e, "canPlayType", {
          get: function () {
            return videoTool$1.supportVideoFormat();
          },
          enumerable: !1,
          configurable: !0,
        }),
        (e.isEnvSupport = !0),
        (e.VERSION = VERSION$2),
        (e.BUILD_TIME = BUILD_TIME$1),
        e
      );
    })(),
    defaultPlayerConfig = {
      type: exports.PLAY_MODE.VOD,
      interruptPlayNextMinTime: 1,
      backupUrlsMaxRetryCount: 5,
      maxPreloadTimeout: 3e4,
      maxBufferingTimeout: 3e4,
      maxStateStalledTime: 3e4,
      maxPlaytimeStalledTime: 1e4,
      isPlayList: !1,
      preloadType: exports.PRELOAD_TYPE.AUTO_LOAD,
      maxVideoNodeCount: 1,
      minFillBlackBorder: 10,
      minFragmentCountForSmoothLevelSwitching: 3,
      ignoreEndedWhenLive: !0,
      rptRate: 0.2,
    },
    ChannelMap;
  function createConfig(e) {
    var t, o, A;
    return __assign$1(
      __assign$1(
        __assign$1(
          { instanceId: commonTool$1.createGUID() },
          defaultPlayerConfig
        ),
        e
      ),
      {
        maxVideoNodeCount:
          null !==
            (A =
              null !== (t = e.maxVideoNodeCount) && void 0 !== t
                ? t
                : null === (o = e.originKernelConfig) || void 0 === o
                ? void 0
                : o.maxVideoNodeCount) && void 0 !== A
            ? A
            : defaultPlayerConfig.maxVideoNodeCount,
      }
    );
  }
  function convertVideoElementConfig(e) {
    var t = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        objectFit: "contain",
      },
      o = Object.keys(t),
      A = {
        playsinline: {
          playsinline: "isiPhoneShowPlaysinline",
          "webkit-playsinline": "isiPhoneShowPlaysinline",
        },
        airplay: { airplay: "allow", "x-webkit-airplay": "allow" },
        crossorigin: { crossOrigin: "anonymous" },
        "h5-page": { "x5-video-player-type": "h5-page" },
      },
      i = { playsinline: !0, "h5-page": !0 };
    Object.keys(e).forEach(function (t) {
      -1 === o.indexOf(t) && (i[t] = e[t]);
    });
    var r = Object.keys(i).reduce(function (e, t) {
        return (
          A[t] && "boolean" == typeof i[t]
            ? (e = __assign$1(__assign$1({}, e), i[t] ? A[t] : {}))
            : (e[t] = i[t]),
          e
        );
      }, {}),
      n = o.reduce(function (o, A) {
        var i;
        return (o[A] = null !== (i = e[A]) && void 0 !== i ? i : t[A]), o;
      }, {});
    return { attrOpts: r, cssOpts: n };
  }
  !(function (e) {
    (e[(e.npm = 0)] = "npm"), (e[(e.cdn = 1)] = "cdn");
  })(ChannelMap || (ChannelMap = {}));
  var ReferenceReport = (function () {
      function e() {
        (this.isCollected = !1),
          (this.attaid = "05700050920"),
          (this.token = "3619167286"),
          (this.timeout = 3e3),
          (this.rptRate = 1);
      }
      return (
        (e.getReporter = function () {
          return this.reporter || (this.reporter = new e()), this.reporter;
        }),
        (e.prototype.collectUsage = function (e, t, o) {
          if (
            (void 0 === e && (e = 0),
            void 0 === t && (t = CHANNEL),
            void 0 === o && (o = ""),
            !(
              this.isCollected ||
              ((this.isCollected = !0), Math.random() > this.rptRate)
            ))
          ) {
            var A = urlTool$1.getTopFrameUrl(),
              i = null == A ? void 0 : A.split("?")[0],
              r = urlTool$1.getDomainOfURL(A),
              n = {
                attaid: this.attaid,
                token: this.token,
                topUrl: "".concat(encodeURIComponent(A)),
                pageUrl: "".concat(encodeURIComponent(i)),
                domain: "".concat(encodeURIComponent(r)),
                channel: "".concat(ChannelMap[t] || 0),
                from: "".concat(e),
                version: VERSION$2,
                platform: o,
                kernel: Object.keys(KernelFactory$1.kernelMap).join("$"),
                _dc: "".concat(Math.random()),
              };
            this.send(n);
          }
        }),
        (e.prototype.send = function (e) {
          setTimeout(function () {
            new Image().src = "https://h.trace.qq.com/kv?".concat(
              urlTool$1.object2string(__assign$1({}, e), "&")
            );
          }, this.timeout);
        }),
        e
      );
    })(),
    logMethodCall$8 = logMethodCallDecoratorCreator("KernelProxy"),
    performanceCost$5 = performanceCostDecoratorCreator("KernelProxy"),
    loadKernelDeferMap = {},
    CONTAINER_DATASET_KEY = "tp",
    KernelProxy = (function (e) {
      function t(t) {
        var o = e.call(this) || this;
        return (
          (o.volumeInner = 1),
          (o.videoElementsInner = []),
          (o.addedEvts = []),
          (o.isDestroyed = !1),
          (o.playerConfig = createConfig(t)),
          (o.logger = new Logger(o.playerConfig.instanceId, "KernelProxy")),
          +lsTool.getData("dHAtbG9nLWxldmVs") > 0 && enable(),
          o.playerConfig.videoElements ||
            (o.playerConfig.videoElements = o.createVideoElements()),
          o.setPlayerContainer(),
          o.createVideoElementsContainer(),
          (o.kernelEvtFuncs = o.kernelEvtHandler.bind(o)),
          o.playerConfig.isPrivateDeployment ||
            ((ReferenceReport.getReporter().rptRate = o.playerConfig.rptRate),
            ReferenceReport.getReporter().collectUsage()),
          o
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "container", {
          get: function () {
            return this.containerEl;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "config", {
          get: function () {
            var e;
            return (
              (null === (e = this.kernel) || void 0 === e
                ? void 0
                : e.config) || this.playerConfig
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "useWorker", {
          get: function () {
            var e;
            return !!(null === (e = this.kernel) || void 0 === e
              ? void 0
              : e.useWorker);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "kernelName", {
          get: function () {
            var e;
            return null === (e = this.kernel) || void 0 === e
              ? void 0
              : e.kernelName;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoElements", {
          get: function () {
            var e;
            return (
              (null === (e = this.kernel) || void 0 === e
                ? void 0
                : e.videoElements) || []
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "currentVideoElement", {
          get: function () {
            var e;
            return null === (e = this.kernel) || void 0 === e
              ? void 0
              : e.currentVideoElement;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "supportPreload", {
          get: function () {
            var e;
            return !!(null === (e = this.kernel) || void 0 === e
              ? void 0
              : e.supportPreload);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "duration", {
          get: function () {
            var e;
            return (
              (null === (e = this.kernel) || void 0 === e
                ? void 0
                : e.duration) || 0
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "playtime", {
          get: function () {
            var e;
            return (
              (null === (e = this.kernel) || void 0 === e
                ? void 0
                : e.playtime) || 0
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoInfos", {
          get: function () {
            var e;
            return (
              (null === (e = this.kernel) || void 0 === e
                ? void 0
                : e.videoInfos) || []
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "preloadVideoInfos", {
          get: function () {
            var e;
            return null === (e = this.kernel) || void 0 === e
              ? void 0
              : e.preloadVideoInfos;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "currentVideoInfo", {
          get: function () {
            var e;
            return null === (e = this.kernel) || void 0 === e
              ? void 0
              : e.currentVideoInfo;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "currentVideoInfoIdx", {
          get: function () {
            var e;
            return (
              (null === (e = this.kernel) || void 0 === e
                ? void 0
                : e.currentVideoInfoIdx) || 0
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "totalVideoInfoCount", {
          get: function () {
            var e;
            return (
              (null === (e = this.kernel) || void 0 === e
                ? void 0
                : e.totalVideoInfoCount) || 0
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "supportPlaybackRate", {
          get: function () {
            var e;
            return !!(null === (e = this.kernel) || void 0 === e
              ? void 0
              : e.supportPlaybackRate);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "played", {
          get: function () {
            var e;
            return !!(null === (e = this.kernel) || void 0 === e
              ? void 0
              : e.played);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "state", {
          get: function () {
            var e;
            return (
              (null === (e = this.kernel) || void 0 === e ? void 0 : e.state) ||
              exports.VIDEO_STATE.IDLE
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoSize", {
          get: function () {
            var e;
            return (
              (null === (e = this.kernel) || void 0 === e
                ? void 0
                : e.videoSize) || { width: 0, height: 0 }
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoBuffered", {
          get: function () {
            var e;
            return (
              (null === (e = this.kernel) || void 0 === e
                ? void 0
                : e.videoBuffered) || []
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.captureVideo = function (e, t, o, A, i) {
          var r;
          return null === (r = this.kernel) || void 0 === r
            ? void 0
            : r.captureVideo(e, t, o, A, i);
        }),
        (t.prototype.log = function () {
          for (var e, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          null === (e = this.logger) || void 0 === e || e.log.apply(e, t);
        }),
        (t.prototype.warn = function () {
          for (var e, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          null === (e = this.logger) || void 0 === e || e.warn.apply(e, t);
        }),
        (t.prototype.error = function () {
          for (var e, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          null === (e = this.logger) || void 0 === e || e.error.apply(e, t);
        }),
        (t.prototype.hasAppended = function (e) {
          var t;
          return !!(null === (t = this.kernel) || void 0 === t
            ? void 0
            : t.hasAppended(e));
        }),
        (t.prototype.hasPreloaded = function (e) {
          var t;
          return !!(null === (t = this.kernel) || void 0 === t
            ? void 0
            : t.hasPreloaded(e));
        }),
        Object.defineProperty(t.prototype, "volume", {
          get: function () {
            var e;
            return (
              (null === (e = this.kernel) || void 0 === e
                ? void 0
                : e.volume) || this.volumeInner
            );
          },
          set: function (e) {
            (this.volumeInner = e),
              this.kernel
                ? (this.kernel.volume = e)
                : this.emit(exports.PLAY_EVENT.VOLUME_CHANGE, { volume: e });
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "volumeGain", {
          get: function () {
            return this.kernel ? this.kernel.volumeGain : 0;
          },
          set: function (e) {
            this.kernel && (this.kernel.volumeGain = e);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "audioEffect", {
          get: function () {
            return this.kernel
              ? this.kernel.audioEffect
              : AUDIO_EFFECT_NAME.DEFAULT;
          },
          set: function (e) {
            this.kernel && (this.kernel.audioEffect = e);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "playbackRate", {
          get: function () {
            var e;
            return (
              (null === (e = this.kernel) || void 0 === e
                ? void 0
                : e.playbackRate) || this.playbackRateInner
            );
          },
          set: function (e) {
            (this.playbackRateInner = e),
              this.kernel
                ? (this.kernel.playbackRate = e)
                : this.emit(exports.PLAY_EVENT.RATE_CHANGE, {
                    playbackRate: e,
                  });
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.resizeVideoElements = function (e) {
          var t;
          null === (t = this.kernel) ||
            void 0 === t ||
            t.resizeVideoElements(e);
        }),
        (t.prototype.resize = function (e) {
          var t;
          null === (t = this.kernel) || void 0 === t || t.resize(e);
        }),
        (t.prototype.seek = function (e) {
          var t;
          return null === (t = this.kernel) || void 0 === t
            ? void 0
            : t.seek(e);
        }),
        (t.prototype.play = function (e, t) {
          var o;
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (A) {
              switch (A.label) {
                case 0:
                  return (
                    this.logger.log("play(urlConfig, ", t, ")"),
                    [4, this.checkConfigBeforeLoad(e, t)]
                  );
                case 1:
                  return (
                    A.sent(),
                    [
                      2,
                      null === (o = this.kernel) || void 0 === o
                        ? void 0
                        : o.play(e, t),
                    ]
                  );
              }
            });
          });
        }),
        (t.prototype.load = function (e, t) {
          var o;
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (A) {
              switch (A.label) {
                case 0:
                  return [4, this.checkConfigBeforeLoad(e, t)];
                case 1:
                  return (
                    A.sent(),
                    [
                      2,
                      null === (o = this.kernel) || void 0 === o
                        ? void 0
                        : o.load(e, t),
                    ]
                  );
              }
            });
          });
        }),
        (t.prototype.playNext = function (e) {
          var t;
          null === (t = this.kernel) || void 0 === t || t.playNext(e);
        }),
        (t.prototype.pause = function (e) {
          var t;
          null === (t = this.kernel) || void 0 === t || t.pause(e);
        }),
        (t.prototype.stop = function (e) {
          var t;
          null === (t = this.kernel) || void 0 === t || t.stop(e);
        }),
        (t.prototype.appendNext = function (e) {
          var t;
          return !!(null === (t = this.kernel) || void 0 === t
            ? void 0
            : t.appendNext(e));
        }),
        (t.prototype.preloadNext = function () {
          for (var e, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          return null === (e = this.kernel) || void 0 === e
            ? void 0
            : e.preloadNext.apply(e, t);
        }),
        (t.prototype.clearAllPreload = function () {
          var e;
          null === (e = this.kernel) || void 0 === e || e.clearAllPreload();
        }),
        (t.prototype.triggerAutoplay = function () {
          var e,
            t = this;
          if (!this.kernel) {
            this.logger.log("triggerAutoplay(), start");
            var o = this.videoElementsInner.map(function (e) {
              return new AutoPlayPolicy(e, {
                instanceId: t.playerConfig.instanceId,
              }).userTrigger();
            });
            return Promise.all(o);
          }
          return null === (e = this.kernel) || void 0 === e
            ? void 0
            : e.triggerAutoplay();
        }),
        (t.prototype.setAudioTrack = function (e) {
          return this.kernel
            ? this.kernel.setAudioTrack(e)
            : Promise.reject(
                new Error(AUDIO_TRACK_ERROR_MSG.KERNEL_NOT_EXISTS)
              );
        }),
        (t.prototype.getAudioTrackList = function () {
          return this.currentVideoInfo ? this.currentVideoInfo.audioTracks : [];
        }),
        (t.prototype.getCurrentAudioTrack = function () {
          return this.currentVideoInfo
            ? this.currentVideoInfo.currentAudioTrack
            : NaN;
        }),
        (t.prototype.setLevel = function (e, t, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            var A, i, r, n, a;
            return __generator$1(this, function (s) {
              switch (s.label) {
                case 0:
                  return this.kernel
                    ? ((A =
                        "string" == typeof e
                          ? __assign$1(__assign$1({}, o), { url: e })
                          : e),
                      (i = this.currentVideoInfo),
                      [4, this.checkWhetherNeedToSwitchKernel(A, null, !1)])
                    : [
                        2,
                        Promise.reject(
                          compile(i18nConfig.core.ERROR_KERNEL_NOT_FOUND)
                        ),
                      ];
                case 1:
                  return (
                    (r = s.sent()),
                    (n = r.isKernelSwitched),
                    (null == (a = r.error) ? void 0 : a.message)
                      ? [2, Promise.reject(null == a ? void 0 : a.message)]
                      : n
                      ? [
                          2,
                          this.setLevelWhenKernelSwitched(
                            __assign$1(
                              __assign$1(__assign$1({}, A), { backupUrls: t }),
                              o
                            ),
                            i
                          ),
                        ]
                      : "string" == typeof e
                      ? [2, this.kernel.setLevel(e, t, o)]
                      : [2, this.kernel.setLevel(e)]
                  );
              }
            });
          });
        }),
        (t.prototype.on = function (t, o, A) {
          return e.prototype.on.call(this, t, o, A), this.proxyEvent(t), this;
        }),
        (t.prototype.once = function (t, o, A) {
          return (
            e.prototype.once.call(this, t, o, A), this.proxyEvent(t, !0), this
          );
        }),
        (t.prototype.destroy = function () {
          var e;
          this.unsetPlayerContainer(),
            this.videoElementsInner &&
              (this.videoElementsInner.forEach(function (e) {
                closeAudioSourceNode(e), videoTool$1.destroyElement(e);
              }),
              (this.videoElementsInner = null)),
            (null === (e = this.videoElementsContainer) || void 0 === e
              ? void 0
              : e.parentNode) && this.videoElementsContainer.remove(),
            this.destroyKernel(),
            this.removeAllListeners(),
            (this.kernelEvtFuncs = null),
            (this.playerConfig = null),
            (this.isDestroyed = !0);
        }),
        (t.prototype.checkWhetherNeedToSwitchKernel = function (e, t, o) {
          return (
            void 0 === o && (o = !0),
            __awaiter$1(this, void 0, void 0, function () {
              var A, i, r, n;
              return __generator$1(this, function (a) {
                switch (a.label) {
                  case 0:
                    return (
                      this.logger.log("check switch kernel"),
                      (A = e instanceof Array ? e[0] : e),
                      (i = (null == t ? void 0 : t.kernelName) || A.kernelName),
                      "string" !=
                      typeof (r = KernelFactory$1.selectKernel(
                        e,
                        i,
                        this.playerConfig.kernelPriority
                      ))
                        ? [2, { isKernelSwitched: !1, error: r }]
                        : (this.logger.log("kernel select:", r),
                          !r || KernelFactory$1.kernelMap[r]
                            ? [3, 2]
                            : [4, this.loadKernel(r)])
                    );
                  case 1:
                    a.sent(), (a.label = 2);
                  case 2:
                    return (
                      (n = KernelFactory$1.kernelMap[r]
                        ? r
                        : exports.KERNEL_NAME.ORIGIN),
                      this.kernel &&
                        this.kernel.kernelName !== n &&
                        (this.kernel.played &&
                          o &&
                          this.emit(exports.PLAY_EVENT.STOPED, {
                            videoInfo: this.kernel.currentVideoInfo,
                            endState: exports.END_STATE.INTERRUPT,
                          }),
                        this.destroyKernel()),
                      this.kernel ? [3, 4] : [4, this.createKernel(n)]
                    );
                  case 3:
                    return a.sent(), [2, { isKernelSwitched: !0 }];
                  case 4:
                    return [2, { isKernelSwitched: !1 }];
                }
              });
            })
          );
        }),
        (t.prototype.loadKernel = function (e, t) {
          return (
            void 0 === t && (t = 3),
            __awaiter$1(this, void 0, void 0, function () {
              var o, A, i, r, n;
              return __generator$1(this, function (a) {
                switch (a.label) {
                  case 0:
                    return this.config.isPrivateDeployment
                      ? [2, !1]
                      : (o = getKernelCdnPath(
                          e,
                          this.playerConfig.autoLoadKernelVerMap
                        ))
                      ? loadKernelDeferMap[e]
                        ? (this.logger.log(
                            "auto download kernel [".concat(
                              o,
                              "] has been started!"
                            )
                          ),
                          [4, loadKernelDeferMap[e].promise])
                        : [3, 2]
                      : [2, !1];
                  case 1:
                    return (
                      (A = a.sent()),
                      this.logger.log(
                        "auto download kernel [".concat(o, "] succ=").concat(A)
                      ),
                      [2, A]
                    );
                  case 2:
                    (loadKernelDeferMap[e] = new SimpleDefer$1()),
                      this.logger.log("auto download kernel [".concat(o, "]")),
                      (i = !1),
                      (r = {}),
                      this.playerConfig.crossOriginForScript &&
                        (r.crossOrigin =
                          this.playerConfig.crossOriginForScript),
                      (n = 0),
                      (a.label = 3);
                  case 3:
                    if (!(n < t)) return [3, 9];
                    a.label = 4;
                  case 4:
                    return (
                      a.trys.push([4, 6, , 7]),
                      [
                        4,
                        domTool$1.loadScript(
                          "".concat(CDN_PATH_PREFIX + o, "?max_age=86400"),
                          null,
                          1e4,
                          r
                        ),
                      ]
                    );
                  case 5:
                    return (
                      a.sent(),
                      this.isDestroyed
                        ? [2, new Promise(function () {})]
                        : (this.logger.log(
                            "auto download kernel [".concat(o, "] succ=true")
                          ),
                          (i = !0),
                          [3, 7])
                    );
                  case 6:
                    return (
                      a.sent(),
                      (i = !1),
                      this.logger.error(
                        "auto download kernel [".concat(o, "] failed")
                      ),
                      [3, 7]
                    );
                  case 7:
                    if (i) return [3, 9];
                    a.label = 8;
                  case 8:
                    return n++, [3, 3];
                  case 9:
                    return loadKernelDeferMap[e].resolve(i), [2, i];
                }
              });
            })
          );
        }),
        (t.prototype.createKernel = function (e) {
          (this.kernel = KernelFactory$1.createKernel(e, this.playerConfig)),
            void 0 !== this.volumeInner &&
              (this.kernel.volume = this.volumeInner),
            void 0 !== this.playbackRateInner &&
              (this.kernel.playbackRate = this.playbackRateInner),
            this.setKernelEvts(!0);
        }),
        (t.prototype.createVideoElements = function () {
          for (
            var e = this.playerConfig,
              t = e.instanceId,
              o = e.videoElementConfig,
              A = e.maxVideoNodeCount,
              i = convertVideoElementConfig(
                __assign$1(
                  __assign$1(
                    {
                      preload:
                        this.playerConfig.preloadType ===
                        exports.PRELOAD_TYPE.META_DATA
                          ? "metadata"
                          : "auto",
                    },
                    o
                  ),
                  { playerid: t }
                )
              ),
              r = 0;
            r < A;
            r++
          ) {
            var n = domTool$1.createVideoDom(i);
            this.videoElementsInner.push(n);
          }
          return this.videoElementsInner;
        }),
        (t.prototype.setPlayerContainer = function () {
          var e = this.playerConfig,
            t = e.container,
            o = e.instanceId,
            A = domTool$1.getElementFromConfig(t);
          if (!A) throw new Error("Container ".concat(t, " is not found."));
          if (A.dataset[CONTAINER_DATASET_KEY]) {
            var i = "Container ".concat(
              t,
              " is used by another player instance. Canceling initialization..."
            );
            throw (
              (this.logger.error("@setPlayerContainer(): ".concat(i)),
              new Error(i))
            );
          }
          (A.dataset[CONTAINER_DATASET_KEY] = o), (this.containerEl = A);
        }),
        (t.prototype.unsetPlayerContainer = function () {
          if (
            (delete this.container.dataset[CONTAINER_DATASET_KEY],
            this.container.isConnected)
          ) {
            var e = this.container.cloneNode();
            this.container.parentNode.replaceChild(e, this.container),
              (this.containerEl = e);
          }
          this.containerEl.innerHTML = "";
        }),
        (t.prototype.createVideoElementsContainer = function () {
          var e = this.container;
          (this.videoElementsContainer = domTool$1.createDom(
            '\n      <div class="'
              .concat(
                VIDEO_CONTAINER_CLASS,
                '" style="position:absolute;left:0;top:0;width:100%;height:100%;z-index:0;">\n      </div>\n    '
              )
              .trim()
          )),
            domTool$1.append(e, this.videoElementsContainer);
        }),
        (t.prototype.setKernelEvts = function (e) {
          var t = this;
          if (this.kernel) {
            e && this.setKernelEvts(!1);
            var o = e ? this.kernel.on : this.kernel.off;
            this.addedEvts.forEach(function (e) {
              o.apply(t.kernel, [e, t.kernelEvtFuncs]);
            });
          }
        }),
        (t.prototype.kernelEvtHandler = function (e) {
          this.setLevelWhenKernelSwitchedDefer
            ? this.checkSetLevelOverWhenKernelSwitched(e) &&
              (this.setLevelWhenKernelSwitchedDefer = null)
            : this.handlerInnerEvts(e) || this.emit(e.type, e.data);
        }),
        (t.prototype.setLevelWhenKernelSwitched = function (e, t) {
          return (
            this.emit(exports.PLAY_EVENT.SETLEVEL_START, {
              videoInfo: t,
              mode: SET_LEVEL_MODE.HARD,
            }),
            this.kernel.play(e, {
              startTime: (null == t ? void 0 : t.playtime) || 0,
            }),
            (this.setLevelWhenKernelSwitchedDefer = new SimpleDefer$1()),
            this.setLevelWhenKernelSwitchedDefer.promise
          );
        }),
        (t.prototype.checkSetLevelOverWhenKernelSwitched = function (e) {
          var t;
          return e.type === exports.PLAY_EVENT.STATE_CHANGE &&
            e.data.new === exports.VIDEO_STATE.PLAYING
            ? (this.setLevelWhenKernelSwitchedDefer.resolve(),
              this.emit(exports.PLAY_EVENT.SETLEVEL_OVER, {
                videoInfo: this.currentVideoInfo,
              }),
              !0)
            : e.type === exports.PLAY_EVENT.ERROR &&
                (this.setLevelWhenKernelSwitchedDefer.reject(
                  null === (t = e.data.videoInfo) || void 0 === t
                    ? void 0
                    : t.error
                ),
                this.emit(exports.PLAY_EVENT.SETLEVEL_OVER, {
                  videoInfo: this.currentVideoInfo,
                  fail: !0,
                }),
                !0);
        }),
        (t.prototype.proxyEvent = function (e, t) {
          void 0 === t && (t = !1),
            this.addedEvts.includes(e) ||
              (this.addedEvts.push(e),
              this.kernel &&
                (t
                  ? this.kernel.once(e, this.kernelEvtFuncs)
                  : this.kernel.on(e, this.kernelEvtFuncs)));
        }),
        (t.prototype.checkConfigBeforeLoad = function (e, t) {
          return __awaiter$1(this, void 0, void 0, function () {
            var o;
            return __generator$1(this, function (A) {
              switch (A.label) {
                case 0:
                  return e
                    ? [4, this.checkWhetherNeedToSwitchKernel(e, t)]
                    : [2];
                case 1:
                  if ((o = A.sent().error))
                    throw (
                      (this.emit(exports.PLAY_EVENT.ERROR, {
                        videoInfo: { error: o },
                      }),
                      o)
                    );
                  return [2];
              }
            });
          });
        }),
        (t.prototype.destroyKernel = function () {
          this.kernel &&
            (this.emit(exports.PLAY_EVENT.KERNEL_DESTROY, {
              kernelName: this.kernel.kernelName,
            }),
            this.setKernelEvts(!1),
            this.kernel.destroy(),
            (this.kernel = null));
        }),
        (t.prototype.handlerInnerEvts = function (e) {
          if (
            e.type === exports.PLAY_EVENT.ERROR &&
            this.kernel.kernelName === exports.KERNEL_NAME.DEMUX_2_FMP4
          ) {
            var t = e.data.videoInfo;
            if (t.config.autoFallbackKernel)
              return (
                this.logger.error(
                  "play err with "
                    .concat(exports.KERNEL_NAME.DEMUX_2_FMP4, ", fallback to ")
                    .concat(exports.KERNEL_NAME.ORIGIN)
                ),
                this.play(t.config, {
                  startTime: t.playtime,
                  kernelName: exports.KERNEL_NAME.ORIGIN,
                }),
                !0
              );
          }
          return !1;
        }),
        __decorate(
          [
            performanceCost$5,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "play",
          null
        ),
        __decorate(
          [
            logMethodCall$8,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "load",
          null
        ),
        __decorate(
          [
            logMethodCall$8,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "setAudioTrack",
          null
        ),
        __decorate(
          [
            logMethodCall$8,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Array, Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "setLevel",
          null
        ),
        __decorate(
          [
            logMethodCall$8,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "destroy",
          null
        ),
        __decorate(
          [
            logMethodCall$8,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "createKernel",
          null
        ),
        t
      );
    })(s$1$1),
    kernelAvailable = {
      isHlsjsAvailable: function (e) {
        return (
          !!e &&
          e.videoType === VIDEO_TYPE.HLS &&
          e.drmType !== DRM_TYPE$1.FAIRPLAY &&
          !(e.vcodec === CODEC.H265 && !videoTool$1.supportHevc()) &&
          !(e.vcodec === CODEC.AV1 && !videoTool$1.supportAV1()) &&
          videoTool$1.supportMSE()
        );
      },
      isFlvjsAvailable: function (e) {
        return (
          !(!e || uaTool$1.mobile) &&
          e.videoType === VIDEO_TYPE.FLV &&
          e.drmType === DRM_TYPE$1.NONE &&
          videoTool$1.supportMSE()
        );
      },
      isDemux2fmp4Available: function (e) {
        return (
          !!e &&
          (e.videoType === VIDEO_TYPE.MP4 || e.videoType === VIDEO_TYPE.MOV) &&
          (void 0 === e.vcodec || e.vcodec === CODEC.H264) &&
          videoTool$1.supportMSE() &&
          videoTool$1.supportFetchStream()
        );
      },
      isWebrtcplayerAvailable: function (e) {
        return (
          !!e &&
          e.videoType === VIDEO_TYPE.WEBRTC &&
          videoTool$1.isWebRTCSupported()
        );
      },
      isWasmplayerAvailble: function (e) {
        return !(!e || uaTool$1.mobile) && videoTool$1.isWasmKernelSupported();
      },
      isElectronPlayerAailble: function () {
        return /electron\//i.test(navigator.userAgent);
      },
    },
    _a$6,
    UrlParamKey$1;
  function createMetadata(e) {
    return {
      urlConfig: e,
      videoType: getUrlConfigVideoType(e),
      drmType: getDrmType(e),
      vcodec: null == e ? void 0 : e.vcodec,
    };
  }
  function getDrmType(e) {
    var t;
    if (null == e ? void 0 : e.chachaParam) return DRM_TYPE$1.CHACHA;
    var o =
      null === (t = null == e ? void 0 : e.drmConfig) || void 0 === t
        ? void 0
        : t.keySystem;
    return [KeySystems$2.FairPlay, KeySystems$2.FairPlayWebKit].includes(o)
      ? DRM_TYPE$1.FAIRPLAY
      : KeySystems$2.Widevine === o
      ? DRM_TYPE$1.WIDEVINE
      : DRM_TYPE$1.NONE;
  }
  !(function (e) {
    e.forceKernel = "__forceKernel";
  })(UrlParamKey$1 || (UrlParamKey$1 = {}));
  var KERNEL_NAME_BY_PRIORITY = [
      exports.KERNEL_NAME.HLS_JS,
      exports.KERNEL_NAME.FLV_JS,
      exports.KERNEL_NAME.WEBRTC,
      exports.KERNEL_NAME.ORIGIN,
    ],
    VIDEO_TYPE_2_AVAILABEL_MAP =
      ((_a$6 = {}),
      (_a$6[exports.KERNEL_NAME.HLS_JS] = kernelAvailable.isHlsjsAvailable),
      (_a$6[exports.KERNEL_NAME.FLV_JS] = kernelAvailable.isFlvjsAvailable),
      (_a$6[exports.KERNEL_NAME.WEBRTC] =
        kernelAvailable.isWebrtcplayerAvailable),
      (_a$6[exports.KERNEL_NAME.DEMUX_2_FMP4] =
        kernelAvailable.isDemux2fmp4Available),
      (_a$6[exports.KERNEL_NAME.ORIGIN] = function () {
        return !0;
      }),
      (_a$6[exports.KERNEL_NAME.WASM] = kernelAvailable.isWasmplayerAvailble),
      (_a$6[exports.KERNEL_NAME.ELECTRON] =
        kernelAvailable.isElectronPlayerAailble),
      _a$6);
  exports.KERNEL_NAME.FLV_JS,
    exports.KERNEL_NAME.HLS_JS,
    exports.KERNEL_NAME.WEBRTC;
  var KernelSelector = (function () {
      function e() {}
      return (
        (e.getSelector = function () {
          return this.selector || (this.selector = new e()), this.selector;
        }),
        (e.prototype.selectByURLConfig = function (e, t, o) {
          var A = createMetadata(e);
          return (
            this.selectKernelWithAssign(A, t) ||
            this.selectKernelInPresetMap(A, o)
          );
        }),
        (e.prototype.selectKernelWithAssign = function (e, t) {
          var o,
            A = t,
            i = urlTool$1.getUrlParamByKey(
              location.href,
              UrlParamKey$1.forceKernel
            );
          if (
            (i &&
              Object.keys(VIDEO_TYPE_2_AVAILABEL_MAP).includes(i) &&
              (A = i),
            t && e.videoType === VIDEO_TYPE.OTHER)
          )
            return t;
          if (!A) return null;
          if (
            null === (o = VIDEO_TYPE_2_AVAILABEL_MAP[A]) || void 0 === o
              ? void 0
              : o.call(VIDEO_TYPE_2_AVAILABEL_MAP, e)
          )
            return A;
          var r = this.suggestKernelNameByMetadata(e, KERNEL_NAME_BY_PRIORITY),
            n =
              "".concat(
                A !== exports.KERNEL_NAME.ORIGIN ? "".concat(A, "鍐呮牳") : "",
                "鏃犳硶鎾斁褰撳墠鏍煎紡"
              ) +
              "".concat(
                r && r !== exports.KERNEL_NAME.ORIGIN
                  ? "锛岃灏濊瘯浣跨敤".concat(r, "鍐呮牳鎾斁")
                  : ""
              );
          return { code: ERROR_CODE.MISSING_KERNEL, message: n };
        }),
        (e.prototype.selectKernelInPresetMap = function (e, t) {
          var o;
          if (t) {
            o = t;
            for (var A = 0; A < KERNEL_NAME_BY_PRIORITY.length; A++)
              -1 === t.indexOf(KERNEL_NAME_BY_PRIORITY[A]) &&
                o.push(KERNEL_NAME_BY_PRIORITY[A]);
          } else o = KERNEL_NAME_BY_PRIORITY;
          return this.suggestKernelNameByMetadata(e, o);
        }),
        (e.prototype.suggestKernelNameByMetadata = function (e, t) {
          var o;
          if (!e) return null;
          for (var A = 0; A < t.length; A++) {
            var i = t[A];
            if (
              null === (o = VIDEO_TYPE_2_AVAILABEL_MAP[i]) || void 0 === o
                ? void 0
                : o.call(VIDEO_TYPE_2_AVAILABEL_MAP, e)
            )
              return i;
          }
          return null;
        }),
        (e.prototype.isKernelSupportByUrlConfig = function (e, t) {
          var o = VIDEO_TYPE_2_AVAILABEL_MAP[e];
          return !!o && o(createMetadata(t));
        }),
        e
      );
    })(),
    KernelFactory = (function () {
      function e() {}
      return (
        (e.registerKernel = function (e, t) {
          var o, A, i;
          this.kernelMap[e]
            ? null === (A = (o = this.kernelMap[e]).unregister) ||
              void 0 === A ||
              A.call(o)
            : !this.kernelMap[e] &&
              t &&
              (null === (i = t.register) || void 0 === i || i.call(t)),
            (this.kernelMap[e] = t);
        }),
        (e.createKernel = function (t, o) {
          if (t) {
            var A = e.kernelMap[t];
            if (!A) throw new Error("Can't find [".concat(t, "] kernel"));
            if (A.isEnvSupport) {
              var i = new A(o);
              return (
                A.exportApis &&
                  commonTool$1.assignApiToPrototype(
                    i,
                    KernelProxy.prototype,
                    A.exportApis
                  ),
                i
              );
            }
            window.console.log(
              "Browser does not support kernelName[".concat(t, "]")
            );
          }
          return new e.kernelMap.origin(o);
        }),
        (e.create = function (e) {
          return new KernelProxy(e);
        }),
        (e.getKernelByName = function (t) {
          return e.kernelMap[t];
        }),
        (e.isKernelSupportByUrlConfig = function (e, t) {
          return KernelSelector.getSelector().isKernelSupportByUrlConfig(e, t);
        }),
        (e.selectKernel = function (e, t, o) {
          var A = e instanceof Array ? e[0] : e;
          return KernelSelector.getSelector().selectByURLConfig(A, t, o);
        }),
        (e.kernelMap = {}),
        e
      );
    })(),
    KernelFactory$1 = KernelFactory;
  function getKernelCdnPath(e, t) {
    var o;
    void 0 === t && (t = {});
    var A = IS_BETA ? "beta" : t[e] || VERSION$2,
      i = "core/".concat(A);
    return (((o = {})[exports.KERNEL_NAME.HLS_JS] = "".concat(
      i,
      "/txhlsjs-kernel.js"
    )),
    (o[exports.KERNEL_NAME.FLV_JS] = "".concat(i, "/flvjs-kernel.js")),
    (o[exports.KERNEL_NAME.DEMUX_2_FMP4] = "".concat(
      i,
      "/demux2fmp4-kernel.js"
    )),
    (o[exports.KERNEL_NAME.WASM] = "".concat(i, "/wasm-kernel.js")),
    (o[exports.KERNEL_NAME.WEBRTC] = "".concat(i, "/webrtc-kernel.js")),
    o)[e];
  }
  var ThumbPlayerCore = Object.freeze({
    __proto__: null,
    MultiPlayer: MultiPlayer,
    OrgPlayer: OrgPlayer,
    OrgVideoNode: OrgVideoNode,
    OrgPreloader: OrgPreLoader,
    originDefaultConfig: defaultOriginKernelConfig,
    VideoInfo: VideoInfo,
    BaseVideoNode: BaseVideoNode,
    BasePlayer: BasePlayer,
    BaseLivePlayer: BaseLivePlayer,
    defaultPlayerConfig: defaultPlayerConfig,
    get DrmKeySystems() {
      return KeySystems$2;
    },
    t: compile,
    compileI18n: compile,
    i18nTool: i18nTool,
    EvtEmitter: s$1$1,
    SimpleDefer: SimpleDefer$1,
    commonTool: commonTool$1,
    uaTool: uaTool$1,
    costTimeEmitter: costTimeEmitter,
    performanceCostDecoratorCreator: performanceCostDecoratorCreator,
    logMethodCallDecoratorCreator: logMethodCallDecoratorCreator,
    destroyProtectDecorator: destroyProtectDecorator,
    logMethodCallDecoratorCreater: logMethodCallDecoratorCreator,
    requireModule: requireModule,
    mountGlobal: mountGlobal,
    cookieTool: cookieTool$1,
    lsTool: lsTool,
    urlTool: urlTool$1,
    domTool: domTool$1,
    netTool: netTool,
    getEventEmitterBinder: getEventEmitterBinder,
    getEventTargetBinder: getEventTargetBinder,
    videoTool: videoTool$1,
    stringTool: stringTool,
    jsonTool: jsonTool$1,
    TaskLoop: TaskLoop,
    get LoopMode() {
      return LoopMode$1;
    },
    ResizeObserver: ResizeObserver,
    ResizeObserverPolyfilled: ResizeObserverPolyfilled,
    encodingTool: encodingTool,
    hashTool: hashTool,
    KernelFactory: KernelFactory$1,
    KernelProxy: KernelProxy,
    ReferenceReport: ReferenceReport,
    Logger: Logger,
    logTool: logTool,
    get LogMode() {
      return LogMode;
    },
    dumpLog: dumpLog,
    get AUDIO_EFFECT_NAME() {
      return AUDIO_EFFECT_NAME;
    },
    AUDIO_EFFECT_CNNAME: AUDIO_EFFECT_CNNAME,
    AUDIO_EFFECT_DISPLAYLIST: AUDIO_EFFECT_DISPLAYLIST,
    isAudioEffectEnvSupport: isEnvSupport,
    kernelEvtBus: kernelEvtBus,
    preloadEvtBus: preloadEvtBus,
    get SET_LEVEL_MODE() {
      return SET_LEVEL_MODE;
    },
    get PLAY_MODE() {
      return exports.PLAY_MODE;
    },
    CAN_PLAY_ALL: CAN_PLAY_ALL,
    VIDEO_CONTAINER_CLASS: VIDEO_CONTAINER_CLASS,
    get END_STATE() {
      return exports.END_STATE;
    },
    get VIDEO_READY_STATE() {
      return VIDEO_READY_STATE;
    },
    get VIDEO_EVTS() {
      return VIDEO_EVTS;
    },
    get VIDEO_STATE() {
      return exports.VIDEO_STATE;
    },
    get ERROR_CODE() {
      return ERROR_CODE;
    },
    get ERROR_MSG() {
      return ERROR_MSG;
    },
    get PLAY_EVENT() {
      return exports.PLAY_EVENT;
    },
    get PRELOAD_EVENT() {
      return PRELOAD_EVENT;
    },
    get VIDEO_NODE_EVENT() {
      return VIDEO_NODE_EVENT;
    },
    get PAUSE_TYPE() {
      return PAUSE_TYPE;
    },
    get PLAYER_LOG_LEVEL() {
      return PLAYER_LOG_LEVEL;
    },
    get PRELOAD_TYPE() {
      return exports.PRELOAD_TYPE;
    },
    get CODEC() {
      return CODEC;
    },
    get VIDEO_CODEC() {
      return exports.VIDEO_CODEC;
    },
    get AUDIO_CODEC() {
      return exports.AUDIO_CODEC;
    },
    get CONTAINER_FORMAT() {
      return exports.CONTAINER_FORMAT;
    },
    get VIDEO_ELEMENT_STATE() {
      return VIDEO_ELEMENT_STATE;
    },
    CDN_PATH_PREFIX: CDN_PATH_PREFIX,
    get CACHE_SIZE_KEY() {
      return CACHE_SIZE_KEY;
    },
    get DRM_TYPE() {
      return DRM_TYPE$1;
    },
    get VIDEO_TYPE() {
      return VIDEO_TYPE;
    },
    get KERNEL_NAME() {
      return exports.KERNEL_NAME;
    },
    defaultI18nConfig: defaultI18nConfig,
    i18nConfig: i18nConfig,
    get AUDIO_TRACK_ERROR_MSG() {
      return AUDIO_TRACK_ERROR_MSG;
    },
    commonErrorParse: commonErrorParse,
    getVideoError: getVideoError,
    CHANNEL: CHANNEL,
    BUILD_TIME: BUILD_TIME$1,
    VERSION: VERSION$2,
    LOCAL_DEV: LOCAL_DEV,
    IS_BETA: IS_BETA,
    ErrorTypeCodeMap: ErrorTypeCodeMap,
    get MediaElementNativeDetail() {
      return MediaElementNativeDetail;
    },
    PlayerError: PlayerError,
    ErrorBase: ErrorBase,
    get TpCoreError() {
      return BuiltInErrorType;
    },
  });
  KernelFactory$1.registerKernel(exports.KERNEL_NAME.ORIGIN, OrgPlayer),
    mountGlobal({
      globalName: "ThumbPlayerCore",
      target: ThumbPlayerCore,
      onDuplicate: function () {
        console.warn(
          "Possible duplicated ThumbPlayerCore detected. Avoid to import this package multiple times."
        );
      },
    });
  var ThumbPlayerCore$1 = Object.freeze({
      __proto__: null,
      get AUDIO_CODEC() {
        return exports.AUDIO_CODEC;
      },
      AUDIO_EFFECT_CNNAME: AUDIO_EFFECT_CNNAME,
      AUDIO_EFFECT_DISPLAYLIST: AUDIO_EFFECT_DISPLAYLIST,
      get AUDIO_EFFECT_NAME() {
        return AUDIO_EFFECT_NAME;
      },
      get AUDIO_TRACK_ERROR_MSG() {
        return AUDIO_TRACK_ERROR_MSG;
      },
      BUILD_TIME: BUILD_TIME$1,
      BaseLivePlayer: BaseLivePlayer,
      BasePlayer: BasePlayer,
      BaseVideoNode: BaseVideoNode,
      get CACHE_SIZE_KEY() {
        return CACHE_SIZE_KEY;
      },
      CAN_PLAY_ALL: CAN_PLAY_ALL,
      CDN_PATH_PREFIX: CDN_PATH_PREFIX,
      CHANNEL: CHANNEL,
      get CODEC() {
        return CODEC;
      },
      get CONTAINER_FORMAT() {
        return exports.CONTAINER_FORMAT;
      },
      get DRM_TYPE() {
        return DRM_TYPE$1;
      },
      get DrmKeySystems() {
        return KeySystems$2;
      },
      get END_STATE() {
        return exports.END_STATE;
      },
      get ERROR_CODE() {
        return ERROR_CODE;
      },
      get ERROR_MSG() {
        return ERROR_MSG;
      },
      ErrorBase: ErrorBase,
      ErrorTypeCodeMap: ErrorTypeCodeMap,
      EvtEmitter: s$1$1,
      IS_BETA: IS_BETA,
      get KERNEL_NAME() {
        return exports.KERNEL_NAME;
      },
      KernelFactory: KernelFactory$1,
      KernelProxy: KernelProxy,
      LOCAL_DEV: LOCAL_DEV,
      get LogMode() {
        return LogMode;
      },
      Logger: Logger,
      get LoopMode() {
        return LoopMode$1;
      },
      get MediaElementNativeDetail() {
        return MediaElementNativeDetail;
      },
      MultiPlayer: MultiPlayer,
      OrgPlayer: OrgPlayer,
      OrgPreloader: OrgPreLoader,
      OrgVideoNode: OrgVideoNode,
      get PAUSE_TYPE() {
        return PAUSE_TYPE;
      },
      get PLAYER_LOG_LEVEL() {
        return PLAYER_LOG_LEVEL;
      },
      get PLAY_EVENT() {
        return exports.PLAY_EVENT;
      },
      get PLAY_MODE() {
        return exports.PLAY_MODE;
      },
      get PRELOAD_EVENT() {
        return PRELOAD_EVENT;
      },
      get PRELOAD_TYPE() {
        return exports.PRELOAD_TYPE;
      },
      PlayerError: PlayerError,
      ReferenceReport: ReferenceReport,
      ResizeObserver: ResizeObserver,
      ResizeObserverPolyfilled: ResizeObserverPolyfilled,
      get SET_LEVEL_MODE() {
        return SET_LEVEL_MODE;
      },
      SimpleDefer: SimpleDefer$1,
      TaskLoop: TaskLoop,
      get TpCoreError() {
        return BuiltInErrorType;
      },
      VERSION: VERSION$2,
      get VIDEO_CODEC() {
        return exports.VIDEO_CODEC;
      },
      VIDEO_CONTAINER_CLASS: VIDEO_CONTAINER_CLASS,
      get VIDEO_ELEMENT_STATE() {
        return VIDEO_ELEMENT_STATE;
      },
      get VIDEO_EVTS() {
        return VIDEO_EVTS;
      },
      get VIDEO_NODE_EVENT() {
        return VIDEO_NODE_EVENT;
      },
      get VIDEO_READY_STATE() {
        return VIDEO_READY_STATE;
      },
      get VIDEO_STATE() {
        return exports.VIDEO_STATE;
      },
      get VIDEO_TYPE() {
        return VIDEO_TYPE;
      },
      VideoInfo: VideoInfo,
      clearLogCache: clearLogCache,
      commonErrorParse: commonErrorParse,
      commonTool: commonTool$1,
      compileI18n: compile,
      cookieTool: cookieTool$1,
      costTimeEmitter: costTimeEmitter,
      default: ThumbPlayerCore,
      defaultI18nConfig: defaultI18nConfig,
      defaultPlayerConfig: defaultPlayerConfig,
      destroyProtectDecorator: destroyProtectDecorator,
      domTool: domTool$1,
      dumpLog: dumpLog,
      encodingTool: encodingTool,
      getEventEmitterBinder: getEventEmitterBinder,
      getEventTargetBinder: getEventTargetBinder,
      getLogCache: getLogCache,
      getVideoError: getVideoError,
      hashTool: hashTool,
      i18nConfig: i18nConfig,
      i18nTool: i18nTool,
      isAudioEffectEnvSupport: isEnvSupport,
      jsonTool: jsonTool$1,
      kernelEvtBus: kernelEvtBus,
      logMethodCallDecoratorCreater: logMethodCallDecoratorCreator,
      logMethodCallDecoratorCreator: logMethodCallDecoratorCreator,
      logTool: logTool,
      lsTool: lsTool,
      mountGlobal: mountGlobal,
      netTool: netTool,
      originDefaultConfig: defaultOriginKernelConfig,
      performanceCostDecoratorCreator: performanceCostDecoratorCreator,
      preloadEvtBus: preloadEvtBus,
      requireModule: requireModule,
      stringTool: stringTool,
      t: compile,
      uaTool: uaTool$1,
      urlTool: urlTool$1,
      videoTool: videoTool$1,
    }),
    superPlayerI18nConfig = {
      TIPS_DEGRADE_TEXT_REASON: "姝ｅ湪缂撳啿涓�...",
      TIPS_DEGRADE_TEXT_NO_REASON: "閲嶆柊璇锋眰瑙嗛淇℃伅...",
      ERROR_PAGE_REPORT_SUCCESS: "鏃ュ織涓婃姤鎴愬姛",
      ERROR_PAGE_REPORT_FAILED: "鏃ュ織涓婃姤澶辫触 $0",
      DEFN_SWITCHING: "姝ｅ湪涓烘偍鍒囨崲娓呮櫚搴$0]",
      DEFN_SWITCH_FAILED: "鎶辨瓑锛屽垏鎹㈡竻鏅板害澶辫触~",
      DEFN_SWITCH_SUCCESS: "宸蹭负鎮ㄥ垏鎹㈠埌娓呮櫚搴$0]",
      AUDIO_SWITCHING: "姝ｅ湪涓烘偍鍒囨崲闊宠建[$0]",
      AUDIO_SWITCH_FAILED: "鎶辨瓑锛屽垏鎹㈤煶杞ㄥけ璐",
      AUDIO_SWITCH_SUCCESS: "宸蹭负鎮ㄥ垏鎹㈠埌闊宠建[$0]",
      LIVE_STREAM_END: "鐩存挱宸茬粨鏉�",
      ERROR_EMPTY_PARAM: "浼犲叆鐨勫弬鏁颁负绌�",
      ERROR_LOAD_PARAM_NOT_SUPPORT: "鐩存挱妯″紡涓嶆敮鎸乴oad()鎺ュ彛",
      ERROR_VID_NOT_SUPPORT: "鐩存挱妯″紡涓嶆敮鎸佷紶鍏id",
      ERROR_CNLID_NOT_SUPPORT: "鐐规挱妯″紡涓嶆敮鎸佷紶鍏nlid",
      ERROR_VID_INVALID: "vid鍙傛暟闈炴硶",
      PREVIEW_TIPS:
        '鍙瘯鐪� $0锛屽幓鑵捐瑙嗛瑙傜湅瀹屾暣鐗� <a target="_blank;" href="$1">绔嬪嵆鍓嶅線</a>',
    };
  defaultI18nConfig.superPlayer = superPlayerI18nConfig;
  var commonjsGlobal$2 =
      "undefined" != typeof globalThis
        ? globalThis
        : "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : "undefined" != typeof self
        ? self
        : {},
    sha256 = { exports: {} };
  (function (module) {
    (function () {
      var ERROR = "input is invalid type",
        WINDOW = "object" == typeof window,
        root = WINDOW ? window : {};
      root.JS_SHA256_NO_WINDOW && (WINDOW = !1);
      var WEB_WORKER = !WINDOW && "object" == typeof self,
        NODE_JS =
          !root.JS_SHA256_NO_NODE_JS &&
          "object" == typeof process &&
          process.versions &&
          process.versions.node;
      NODE_JS ? (root = commonjsGlobal$2) : WEB_WORKER && (root = self);
      var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && module.exports,
        ARRAY_BUFFER =
          !root.JS_SHA256_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
        HEX_CHARS = "0123456789abcdef".split(""),
        EXTRA = [-2147483648, 8388608, 32768, 128],
        SHIFT = [24, 16, 8, 0],
        K = [
          1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993,
          2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987,
          1925078388, 2162078206, 2614888103, 3248222580, 3835390401,
          4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692,
          1996064986, 2554220882, 2821834349, 2952996808, 3210313671,
          3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912,
          1294757372, 1396182291, 1695183700, 1986661051, 2177026350,
          2456956037, 2730485921, 2820302411, 3259730800, 3345764771,
          3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616,
          659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779,
          1955562222, 2024104815, 2227730452, 2361852424, 2428436474,
          2756734187, 3204031479, 3329325298,
        ],
        OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"],
        blocks = [];
      (!root.JS_SHA256_NO_NODE_JS && Array.isArray) ||
        (Array.isArray = function (e) {
          return "[object Array]" === Object.prototype.toString.call(e);
        }),
        !ARRAY_BUFFER ||
          (!root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView) ||
          (ArrayBuffer.isView = function (e) {
            return (
              "object" == typeof e &&
              e.buffer &&
              e.buffer.constructor === ArrayBuffer
            );
          });
      var createOutputMethod = function (e, t) {
          return function (o) {
            return new Sha256(t, !0).update(o)[e]();
          };
        },
        createMethod = function (e) {
          var t = createOutputMethod("hex", e);
          NODE_JS && (t = nodeWrap(t, e)),
            (t.create = function () {
              return new Sha256(e);
            }),
            (t.update = function (e) {
              return t.create().update(e);
            });
          for (var o = 0; o < OUTPUT_TYPES.length; ++o) {
            var A = OUTPUT_TYPES[o];
            t[A] = createOutputMethod(A, e);
          }
          return t;
        },
        nodeWrap = function (method, is224) {
          var crypto = eval("require('crypto')"),
            Buffer = eval("require('buffer').Buffer"),
            algorithm = is224 ? "sha224" : "sha256",
            nodeMethod = function (e) {
              if ("string" == typeof e)
                return crypto
                  .createHash(algorithm)
                  .update(e, "utf8")
                  .digest("hex");
              if (null == e) throw new Error(ERROR);
              return (
                e.constructor === ArrayBuffer && (e = new Uint8Array(e)),
                Array.isArray(e) ||
                ArrayBuffer.isView(e) ||
                e.constructor === Buffer
                  ? crypto
                      .createHash(algorithm)
                      .update(new Buffer(e))
                      .digest("hex")
                  : method(e)
              );
            };
          return nodeMethod;
        },
        createHmacOutputMethod = function (e, t) {
          return function (o, A) {
            return new HmacSha256(o, t, !0).update(A)[e]();
          };
        },
        createHmacMethod = function (e) {
          var t = createHmacOutputMethod("hex", e);
          (t.create = function (t) {
            return new HmacSha256(t, e);
          }),
            (t.update = function (e, o) {
              return t.create(e).update(o);
            });
          for (var o = 0; o < OUTPUT_TYPES.length; ++o) {
            var A = OUTPUT_TYPES[o];
            t[A] = createHmacOutputMethod(A, e);
          }
          return t;
        };
      function Sha256(e, t) {
        t
          ? ((blocks[0] =
              blocks[16] =
              blocks[1] =
              blocks[2] =
              blocks[3] =
              blocks[4] =
              blocks[5] =
              blocks[6] =
              blocks[7] =
              blocks[8] =
              blocks[9] =
              blocks[10] =
              blocks[11] =
              blocks[12] =
              blocks[13] =
              blocks[14] =
              blocks[15] =
                0),
            (this.blocks = blocks))
          : (this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
          e
            ? ((this.h0 = 3238371032),
              (this.h1 = 914150663),
              (this.h2 = 812702999),
              (this.h3 = 4144912697),
              (this.h4 = 4290775857),
              (this.h5 = 1750603025),
              (this.h6 = 1694076839),
              (this.h7 = 3204075428))
            : ((this.h0 = 1779033703),
              (this.h1 = 3144134277),
              (this.h2 = 1013904242),
              (this.h3 = 2773480762),
              (this.h4 = 1359893119),
              (this.h5 = 2600822924),
              (this.h6 = 528734635),
              (this.h7 = 1541459225)),
          (this.block = this.start = this.bytes = this.hBytes = 0),
          (this.finalized = this.hashed = !1),
          (this.first = !0),
          (this.is224 = e);
      }
      function HmacSha256(e, t, o) {
        var A,
          i = typeof e;
        if ("string" === i) {
          var r,
            n = [],
            a = e.length,
            s = 0;
          for (A = 0; A < a; ++A)
            (r = e.charCodeAt(A)) < 128
              ? (n[s++] = r)
              : r < 2048
              ? ((n[s++] = 192 | (r >> 6)), (n[s++] = 128 | (63 & r)))
              : r < 55296 || r >= 57344
              ? ((n[s++] = 224 | (r >> 12)),
                (n[s++] = 128 | ((r >> 6) & 63)),
                (n[s++] = 128 | (63 & r)))
              : ((r =
                  65536 + (((1023 & r) << 10) | (1023 & e.charCodeAt(++A)))),
                (n[s++] = 240 | (r >> 18)),
                (n[s++] = 128 | ((r >> 12) & 63)),
                (n[s++] = 128 | ((r >> 6) & 63)),
                (n[s++] = 128 | (63 & r)));
          e = n;
        } else {
          if ("object" !== i) throw new Error(ERROR);
          if (null === e) throw new Error(ERROR);
          if (ARRAY_BUFFER && e.constructor === ArrayBuffer)
            e = new Uint8Array(e);
          else if (
            !(Array.isArray(e) || (ARRAY_BUFFER && ArrayBuffer.isView(e)))
          )
            throw new Error(ERROR);
        }
        e.length > 64 && (e = new Sha256(t, !0).update(e).array());
        var g = [],
          l = [];
        for (A = 0; A < 64; ++A) {
          var E = e[A] || 0;
          (g[A] = 92 ^ E), (l[A] = 54 ^ E);
        }
        Sha256.call(this, t, o),
          this.update(l),
          (this.oKeyPad = g),
          (this.inner = !0),
          (this.sharedMemory = o);
      }
      (Sha256.prototype.update = function (e) {
        if (!this.finalized) {
          var t,
            o = typeof e;
          if ("string" !== o) {
            if ("object" !== o) throw new Error(ERROR);
            if (null === e) throw new Error(ERROR);
            if (ARRAY_BUFFER && e.constructor === ArrayBuffer)
              e = new Uint8Array(e);
            else if (
              !(Array.isArray(e) || (ARRAY_BUFFER && ArrayBuffer.isView(e)))
            )
              throw new Error(ERROR);
            t = !0;
          }
          for (var A, i, r = 0, n = e.length, a = this.blocks; r < n; ) {
            if (
              (this.hashed &&
                ((this.hashed = !1),
                (a[0] = this.block),
                (a[16] =
                  a[1] =
                  a[2] =
                  a[3] =
                  a[4] =
                  a[5] =
                  a[6] =
                  a[7] =
                  a[8] =
                  a[9] =
                  a[10] =
                  a[11] =
                  a[12] =
                  a[13] =
                  a[14] =
                  a[15] =
                    0)),
              t)
            )
              for (i = this.start; r < n && i < 64; ++r)
                a[i >> 2] |= e[r] << SHIFT[3 & i++];
            else
              for (i = this.start; r < n && i < 64; ++r)
                (A = e.charCodeAt(r)) < 128
                  ? (a[i >> 2] |= A << SHIFT[3 & i++])
                  : A < 2048
                  ? ((a[i >> 2] |= (192 | (A >> 6)) << SHIFT[3 & i++]),
                    (a[i >> 2] |= (128 | (63 & A)) << SHIFT[3 & i++]))
                  : A < 55296 || A >= 57344
                  ? ((a[i >> 2] |= (224 | (A >> 12)) << SHIFT[3 & i++]),
                    (a[i >> 2] |= (128 | ((A >> 6) & 63)) << SHIFT[3 & i++]),
                    (a[i >> 2] |= (128 | (63 & A)) << SHIFT[3 & i++]))
                  : ((A =
                      65536 +
                      (((1023 & A) << 10) | (1023 & e.charCodeAt(++r)))),
                    (a[i >> 2] |= (240 | (A >> 18)) << SHIFT[3 & i++]),
                    (a[i >> 2] |= (128 | ((A >> 12) & 63)) << SHIFT[3 & i++]),
                    (a[i >> 2] |= (128 | ((A >> 6) & 63)) << SHIFT[3 & i++]),
                    (a[i >> 2] |= (128 | (63 & A)) << SHIFT[3 & i++]));
            (this.lastByteIndex = i),
              (this.bytes += i - this.start),
              i >= 64
                ? ((this.block = a[16]),
                  (this.start = i - 64),
                  this.hash(),
                  (this.hashed = !0))
                : (this.start = i);
          }
          return (
            this.bytes > 4294967295 &&
              ((this.hBytes += (this.bytes / 4294967296) << 0),
              (this.bytes = this.bytes % 4294967296)),
            this
          );
        }
      }),
        (Sha256.prototype.finalize = function () {
          if (!this.finalized) {
            this.finalized = !0;
            var e = this.blocks,
              t = this.lastByteIndex;
            (e[16] = this.block),
              (e[t >> 2] |= EXTRA[3 & t]),
              (this.block = e[16]),
              t >= 56 &&
                (this.hashed || this.hash(),
                (e[0] = this.block),
                (e[16] =
                  e[1] =
                  e[2] =
                  e[3] =
                  e[4] =
                  e[5] =
                  e[6] =
                  e[7] =
                  e[8] =
                  e[9] =
                  e[10] =
                  e[11] =
                  e[12] =
                  e[13] =
                  e[14] =
                  e[15] =
                    0)),
              (e[14] = (this.hBytes << 3) | (this.bytes >>> 29)),
              (e[15] = this.bytes << 3),
              this.hash();
          }
        }),
        (Sha256.prototype.hash = function () {
          var e,
            t,
            o,
            A,
            i,
            r,
            n,
            a,
            s,
            g = this.h0,
            l = this.h1,
            E = this.h2,
            c = this.h3,
            u = this.h4,
            p = this.h5,
            d = this.h6,
            B = this.h7,
            h = this.blocks;
          for (e = 16; e < 64; ++e)
            (t =
              (((i = h[e - 15]) >>> 7) | (i << 25)) ^
              ((i >>> 18) | (i << 14)) ^
              (i >>> 3)),
              (o =
                (((i = h[e - 2]) >>> 17) | (i << 15)) ^
                ((i >>> 19) | (i << 13)) ^
                (i >>> 10)),
              (h[e] = (h[e - 16] + t + h[e - 7] + o) << 0);
          for (s = l & E, e = 0; e < 64; e += 4)
            this.first
              ? (this.is224
                  ? ((r = 300032),
                    (B = ((i = h[0] - 1413257819) - 150054599) << 0),
                    (c = (i + 24177077) << 0))
                  : ((r = 704751109),
                    (B = ((i = h[0] - 210244248) - 1521486534) << 0),
                    (c = (i + 143694565) << 0)),
                (this.first = !1))
              : ((t =
                  ((g >>> 2) | (g << 30)) ^
                  ((g >>> 13) | (g << 19)) ^
                  ((g >>> 22) | (g << 10))),
                (A = (r = g & l) ^ (g & E) ^ s),
                (B =
                  (c +
                    (i =
                      B +
                      (o =
                        ((u >>> 6) | (u << 26)) ^
                        ((u >>> 11) | (u << 21)) ^
                        ((u >>> 25) | (u << 7))) +
                      ((u & p) ^ (~u & d)) +
                      K[e] +
                      h[e])) <<
                  0),
                (c = (i + (t + A)) << 0)),
              (t =
                ((c >>> 2) | (c << 30)) ^
                ((c >>> 13) | (c << 19)) ^
                ((c >>> 22) | (c << 10))),
              (A = (n = c & g) ^ (c & l) ^ r),
              (d =
                (E +
                  (i =
                    d +
                    (o =
                      ((B >>> 6) | (B << 26)) ^
                      ((B >>> 11) | (B << 21)) ^
                      ((B >>> 25) | (B << 7))) +
                    ((B & u) ^ (~B & p)) +
                    K[e + 1] +
                    h[e + 1])) <<
                0),
              (t =
                (((E = (i + (t + A)) << 0) >>> 2) | (E << 30)) ^
                ((E >>> 13) | (E << 19)) ^
                ((E >>> 22) | (E << 10))),
              (A = (a = E & c) ^ (E & g) ^ n),
              (p =
                (l +
                  (i =
                    p +
                    (o =
                      ((d >>> 6) | (d << 26)) ^
                      ((d >>> 11) | (d << 21)) ^
                      ((d >>> 25) | (d << 7))) +
                    ((d & B) ^ (~d & u)) +
                    K[e + 2] +
                    h[e + 2])) <<
                0),
              (t =
                (((l = (i + (t + A)) << 0) >>> 2) | (l << 30)) ^
                ((l >>> 13) | (l << 19)) ^
                ((l >>> 22) | (l << 10))),
              (A = (s = l & E) ^ (l & c) ^ a),
              (u =
                (g +
                  (i =
                    u +
                    (o =
                      ((p >>> 6) | (p << 26)) ^
                      ((p >>> 11) | (p << 21)) ^
                      ((p >>> 25) | (p << 7))) +
                    ((p & d) ^ (~p & B)) +
                    K[e + 3] +
                    h[e + 3])) <<
                0),
              (g = (i + (t + A)) << 0);
          (this.h0 = (this.h0 + g) << 0),
            (this.h1 = (this.h1 + l) << 0),
            (this.h2 = (this.h2 + E) << 0),
            (this.h3 = (this.h3 + c) << 0),
            (this.h4 = (this.h4 + u) << 0),
            (this.h5 = (this.h5 + p) << 0),
            (this.h6 = (this.h6 + d) << 0),
            (this.h7 = (this.h7 + B) << 0);
        }),
        (Sha256.prototype.hex = function () {
          this.finalize();
          var e = this.h0,
            t = this.h1,
            o = this.h2,
            A = this.h3,
            i = this.h4,
            r = this.h5,
            n = this.h6,
            a = this.h7,
            s =
              HEX_CHARS[(e >> 28) & 15] +
              HEX_CHARS[(e >> 24) & 15] +
              HEX_CHARS[(e >> 20) & 15] +
              HEX_CHARS[(e >> 16) & 15] +
              HEX_CHARS[(e >> 12) & 15] +
              HEX_CHARS[(e >> 8) & 15] +
              HEX_CHARS[(e >> 4) & 15] +
              HEX_CHARS[15 & e] +
              HEX_CHARS[(t >> 28) & 15] +
              HEX_CHARS[(t >> 24) & 15] +
              HEX_CHARS[(t >> 20) & 15] +
              HEX_CHARS[(t >> 16) & 15] +
              HEX_CHARS[(t >> 12) & 15] +
              HEX_CHARS[(t >> 8) & 15] +
              HEX_CHARS[(t >> 4) & 15] +
              HEX_CHARS[15 & t] +
              HEX_CHARS[(o >> 28) & 15] +
              HEX_CHARS[(o >> 24) & 15] +
              HEX_CHARS[(o >> 20) & 15] +
              HEX_CHARS[(o >> 16) & 15] +
              HEX_CHARS[(o >> 12) & 15] +
              HEX_CHARS[(o >> 8) & 15] +
              HEX_CHARS[(o >> 4) & 15] +
              HEX_CHARS[15 & o] +
              HEX_CHARS[(A >> 28) & 15] +
              HEX_CHARS[(A >> 24) & 15] +
              HEX_CHARS[(A >> 20) & 15] +
              HEX_CHARS[(A >> 16) & 15] +
              HEX_CHARS[(A >> 12) & 15] +
              HEX_CHARS[(A >> 8) & 15] +
              HEX_CHARS[(A >> 4) & 15] +
              HEX_CHARS[15 & A] +
              HEX_CHARS[(i >> 28) & 15] +
              HEX_CHARS[(i >> 24) & 15] +
              HEX_CHARS[(i >> 20) & 15] +
              HEX_CHARS[(i >> 16) & 15] +
              HEX_CHARS[(i >> 12) & 15] +
              HEX_CHARS[(i >> 8) & 15] +
              HEX_CHARS[(i >> 4) & 15] +
              HEX_CHARS[15 & i] +
              HEX_CHARS[(r >> 28) & 15] +
              HEX_CHARS[(r >> 24) & 15] +
              HEX_CHARS[(r >> 20) & 15] +
              HEX_CHARS[(r >> 16) & 15] +
              HEX_CHARS[(r >> 12) & 15] +
              HEX_CHARS[(r >> 8) & 15] +
              HEX_CHARS[(r >> 4) & 15] +
              HEX_CHARS[15 & r] +
              HEX_CHARS[(n >> 28) & 15] +
              HEX_CHARS[(n >> 24) & 15] +
              HEX_CHARS[(n >> 20) & 15] +
              HEX_CHARS[(n >> 16) & 15] +
              HEX_CHARS[(n >> 12) & 15] +
              HEX_CHARS[(n >> 8) & 15] +
              HEX_CHARS[(n >> 4) & 15] +
              HEX_CHARS[15 & n];
          return (
            this.is224 ||
              (s +=
                HEX_CHARS[(a >> 28) & 15] +
                HEX_CHARS[(a >> 24) & 15] +
                HEX_CHARS[(a >> 20) & 15] +
                HEX_CHARS[(a >> 16) & 15] +
                HEX_CHARS[(a >> 12) & 15] +
                HEX_CHARS[(a >> 8) & 15] +
                HEX_CHARS[(a >> 4) & 15] +
                HEX_CHARS[15 & a]),
            s
          );
        }),
        (Sha256.prototype.toString = Sha256.prototype.hex),
        (Sha256.prototype.digest = function () {
          this.finalize();
          var e = this.h0,
            t = this.h1,
            o = this.h2,
            A = this.h3,
            i = this.h4,
            r = this.h5,
            n = this.h6,
            a = this.h7,
            s = [
              (e >> 24) & 255,
              (e >> 16) & 255,
              (e >> 8) & 255,
              255 & e,
              (t >> 24) & 255,
              (t >> 16) & 255,
              (t >> 8) & 255,
              255 & t,
              (o >> 24) & 255,
              (o >> 16) & 255,
              (o >> 8) & 255,
              255 & o,
              (A >> 24) & 255,
              (A >> 16) & 255,
              (A >> 8) & 255,
              255 & A,
              (i >> 24) & 255,
              (i >> 16) & 255,
              (i >> 8) & 255,
              255 & i,
              (r >> 24) & 255,
              (r >> 16) & 255,
              (r >> 8) & 255,
              255 & r,
              (n >> 24) & 255,
              (n >> 16) & 255,
              (n >> 8) & 255,
              255 & n,
            ];
          return (
            this.is224 ||
              s.push((a >> 24) & 255, (a >> 16) & 255, (a >> 8) & 255, 255 & a),
            s
          );
        }),
        (Sha256.prototype.array = Sha256.prototype.digest),
        (Sha256.prototype.arrayBuffer = function () {
          this.finalize();
          var e = new ArrayBuffer(this.is224 ? 28 : 32),
            t = new DataView(e);
          return (
            t.setUint32(0, this.h0),
            t.setUint32(4, this.h1),
            t.setUint32(8, this.h2),
            t.setUint32(12, this.h3),
            t.setUint32(16, this.h4),
            t.setUint32(20, this.h5),
            t.setUint32(24, this.h6),
            this.is224 || t.setUint32(28, this.h7),
            e
          );
        }),
        (HmacSha256.prototype = new Sha256()),
        (HmacSha256.prototype.finalize = function () {
          if ((Sha256.prototype.finalize.call(this), this.inner)) {
            this.inner = !1;
            var e = this.array();
            Sha256.call(this, this.is224, this.sharedMemory),
              this.update(this.oKeyPad),
              this.update(e),
              Sha256.prototype.finalize.call(this);
          }
        });
      var exports = createMethod();
      (exports.sha256 = exports),
        (exports.sha224 = createMethod(!0)),
        (exports.sha256.hmac = createHmacMethod()),
        (exports.sha224.hmac = createHmacMethod(!0)),
        COMMON_JS
          ? (module.exports = exports)
          : ((root.sha256 = exports.sha256), (root.sha224 = exports.sha224));
    })();
  })(sha256);
  var h5playerI18nConfig = {
    ERROR_GETINFO_PLUGIN_MISSING: "娌℃湁鎵惧埌鑾峰彇瑙嗛淇℃伅鎻掍欢",
    ERROR_GETINFO_INNER: "鑾峰彇瑙嗛淇℃伅鍐呴儴閿欒",
    ERROR_GETINFO_NET: "鏃犳硶鑾峰彇瑙嗛淇℃伅",
    ERROR_GETINFO_TIMEOUT: "鑾峰彇瑙嗛淇℃伅瓒呮椂",
    ERROR_GETINFO_PARSE: "瑙嗛淇℃伅鏃犳硶瑙ｆ瀽",
    ERROR_GETINFO_CODE: "鎾斁鍚庡彴杩斿洖閿欒",
    ERROR_UNOFFICIAL_PLUGIN_NEEDS_URL:
      "鎮ㄦ墍浼犲叆鐨勬彃浠朵笉鏄畼鏂规彃浠讹紝蹇呴』鎻愪緵 url",
    ERROR_PLAY_LIMIT_EMPTY_CONFIG: "閰嶇疆涓嶈兘涓虹┖",
    ERROR_PLAY_LIMIT_POINTS_BOTH_EMPTY:
      "startPoint / endPoint 閰嶇疆涓嶈兘鍚屾椂涓虹┖",
    ERROR_PLAY_LIMIT_START_TIME_BELOW_ZERO:
      "startPoint.value 鍊间笉鑳藉皬浜� 0",
    ERROR_PLAY_LIMIT_END_TIME_BELOW_START_TIME:
      "endPoint.value 鍊间笉鑳藉皬浜� startPoint.value",
    ERROR_URL_INVALID: "鍦板潃涓嶅悎娉�",
  };
  defaultI18nConfig.h5player = h5playerI18nConfig;
  var commonjsGlobal =
      "undefined" != typeof globalThis
        ? globalThis
        : "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : "undefined" != typeof self
        ? self
        : {},
    FUNC_ERROR_TEXT$1 = "Expected a function",
    NAN$1 = NaN,
    symbolTag$1 = "[object Symbol]",
    reTrim$1 = /^\s+|\s+$/g,
    reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i,
    reIsBinary$1 = /^0b[01]+$/i,
    reIsOctal$1 = /^0o[0-7]+$/i,
    freeParseInt$1 = parseInt,
    freeGlobal$1 =
      "object" == typeof commonjsGlobal &&
      commonjsGlobal &&
      commonjsGlobal.Object === Object &&
      commonjsGlobal,
    freeSelf$1 =
      "object" == typeof self && self && self.Object === Object && self,
    root$1 = freeGlobal$1 || freeSelf$1 || Function("return this")(),
    objectProto$1 = Object.prototype,
    objectToString$1 = objectProto$1.toString,
    nativeMax$1 = Math.max,
    nativeMin$1 = Math.min,
    now$1 = function () {
      return root$1.Date.now();
    };
  function debounce$1(e, t, o) {
    var A,
      i,
      r,
      n,
      a,
      s,
      g = 0,
      l = !1,
      E = !1,
      c = !0;
    if ("function" != typeof e) throw new TypeError(FUNC_ERROR_TEXT$1);
    function u(t) {
      var o = A,
        r = i;
      return (A = i = void 0), (g = t), (n = e.apply(r, o));
    }
    function p(e) {
      return (g = e), (a = setTimeout(B, t)), l ? u(e) : n;
    }
    function d(e) {
      var o = e - s;
      return void 0 === s || o >= t || o < 0 || (E && e - g >= r);
    }
    function B() {
      var e = now$1();
      if (d(e)) return h(e);
      a = setTimeout(
        B,
        (function (e) {
          var o = t - (e - s);
          return E ? nativeMin$1(o, r - (e - g)) : o;
        })(e)
      );
    }
    function h(e) {
      return (a = void 0), c && A ? u(e) : ((A = i = void 0), n);
    }
    function I() {
      var e = now$1(),
        o = d(e);
      if (((A = arguments), (i = this), (s = e), o)) {
        if (void 0 === a) return p(s);
        if (E) return (a = setTimeout(B, t)), u(s);
      }
      return void 0 === a && (a = setTimeout(B, t)), n;
    }
    return (
      (t = toNumber$1(t) || 0),
      isObject$1(o) &&
        ((l = !!o.leading),
        (r = (E = "maxWait" in o)
          ? nativeMax$1(toNumber$1(o.maxWait) || 0, t)
          : r),
        (c = "trailing" in o ? !!o.trailing : c)),
      (I.cancel = function () {
        void 0 !== a && clearTimeout(a), (g = 0), (A = s = i = a = void 0);
      }),
      (I.flush = function () {
        return void 0 === a ? n : h(now$1());
      }),
      I
    );
  }
  function throttle$1(e, t, o) {
    var A = !0,
      i = !0;
    if ("function" != typeof e) throw new TypeError(FUNC_ERROR_TEXT$1);
    return (
      isObject$1(o) &&
        ((A = "leading" in o ? !!o.leading : A),
        (i = "trailing" in o ? !!o.trailing : i)),
      debounce$1(e, t, { leading: A, maxWait: t, trailing: i })
    );
  }
  function isObject$1(e) {
    var t = typeof e;
    return !!e && ("object" == t || "function" == t);
  }
  function isObjectLike$1(e) {
    return !!e && "object" == typeof e;
  }
  function isSymbol$1(e) {
    return (
      "symbol" == typeof e ||
      (isObjectLike$1(e) && objectToString$1.call(e) == symbolTag$1)
    );
  }
  function toNumber$1(e) {
    if ("number" == typeof e) return e;
    if (isSymbol$1(e)) return NAN$1;
    if (isObject$1(e)) {
      var t = "function" == typeof e.valueOf ? e.valueOf() : e;
      e = isObject$1(t) ? t + "" : t;
    }
    if ("string" != typeof e) return 0 === e ? e : +e;
    e = e.replace(reTrim$1, "");
    var o = reIsBinary$1.test(e);
    return o || reIsOctal$1.test(e)
      ? freeParseInt$1(e.slice(2), o ? 2 : 8)
      : reIsBadHex$1.test(e)
      ? NAN$1
      : +e;
  }
  var lodash_throttle$1 = throttle$1,
    adPluginMap = {};
  function setAdPlugin(e, t) {
    adPluginMap[e] = t;
  }
  function getAdPlugin(e) {
    return adPluginMap[e];
  }
  function getAdReqParams(e, t) {
    var o = getAdPlugin(e);
    return o &&
      "function" == typeof o.getAdParams &&
      (null == t ? void 0 : t.adType) &&
      (null == t ? void 0 : t.vid)
      ? o.getAdParams(t)
      : {};
  }
  var AdPluginName = "__thumbplayer-ad",
    AD_TYPE;
  function isPreOrPostAd(e) {
    return -1 !== [exports.AD_TYPE.PRE, exports.AD_TYPE.POST].indexOf(e.adType);
  }
  (exports.AD_TYPE = void 0),
    (AD_TYPE = exports.AD_TYPE || (exports.AD_TYPE = {})),
    (AD_TYPE.PRE = "preAd"),
    (AD_TYPE.ZT = "ZT"),
    (AD_TYPE.POST = "postAd");
  var defaultH5PlayerConfig = {
      container: void 0,
      enableQAreporter: !0,
      maxRetryGetinfoTimes: 3,
      maxRetryGetinfoTimesInVodSession: 10,
      maxRetryGetinfoTimesInLiveSession: 30,
    },
    ErrorCode,
    ErrorMsg,
    H5_EXT_EVENT,
    H5_PLAY_EVENT;
  (exports.ErrorCode = void 0),
    (ErrorCode = exports.ErrorCode || (exports.ErrorCode = {})),
    (ErrorCode.SUC = "0"),
    (ErrorCode.UNKNOWN = "70040000"),
    (ErrorCode.AD_END_DEFAULT_FAIL = "70040002"),
    (ErrorCode.AD_REQ_INFO_DEFAULT_FAIL = "70040003"),
    (ErrorCode.GETINFO_PLUGIN_MISSING = "70040001"),
    (ErrorCode.GETINFO_NET = "70014001"),
    (ErrorCode.GETINFO_TIMEOUT = "70014003"),
    (ErrorCode.GETINFO_PARSE = "70014004"),
    (ErrorCode.GETINFO_INNER = "70014005"),
    (ErrorCode.GETINFO_SERVER_CODE_PREFIX = "70013"),
    (ErrorCode.GETINFO_LIVE_SERVER_CODE_PREFIX = "70023"),
    (ErrorCode.GETINFO_UNIFIED_LIVE_SERVER_CODE_PREFIX = "70033"),
    (ErrorCode.UNPAIED_1080P = "70013091.0"),
    (exports.ErrorMsg = void 0),
    (ErrorMsg = exports.ErrorMsg || (exports.ErrorMsg = {})),
    (ErrorMsg.GETINFO_PLUGIN_MISSING = "娌℃湁鎵惧埌鑾峰彇瑙嗛淇℃伅鎻掍欢"),
    (ErrorMsg.GETINFO_INNER = "鑾峰彇瑙嗛淇℃伅鍐呴儴閿欒"),
    (ErrorMsg.GETINFO_NET = "鏃犳硶鑾峰彇瑙嗛淇℃伅"),
    (ErrorMsg.GETINFO_TIMEOUT = "鑾峰彇瑙嗛淇℃伅瓒呮椂"),
    (ErrorMsg.GETINFO_PARSE = "瑙嗛淇℃伅鏃犳硶瑙ｆ瀽"),
    (ErrorMsg.GETINFO_CODE = "鎾斁鍚庡彴杩斿洖閿欒"),
    (exports.PLAY_EVENT_EXT = void 0),
    (H5_EXT_EVENT = exports.PLAY_EVENT_EXT || (exports.PLAY_EVENT_EXT = {})),
    (H5_EXT_EVENT.AD_COUNTDOWN_CHANGE = "AD_COUNTDOWN_CHANGE"),
    (H5_EXT_EVENT.SET_LOADING = "SET_LOADING"),
    (H5_EXT_EVENT.PROXY_HTTP_START = "PROXY_HTTP_START"),
    (H5_EXT_EVENT.PROXY_HTTP_END = "PROXY_HTTP_END"),
    (H5_EXT_EVENT.GETINFO_START = "GETINFO_START"),
    (H5_EXT_EVENT.GETINFO_OVER = "GETINFO_OVER"),
    (H5_EXT_EVENT.PRELOAD_GETINFO_OVER = "PRELOAD_GETINFO_OVER"),
    (H5_EXT_EVENT.VID_CHANGE = "VID_CHANGE"),
    (H5_EXT_EVENT.DESTROY = "DESTROY"),
    (H5_EXT_EVENT.DATASET_UPDATE = "data-set:update"),
    (H5_EXT_EVENT.DATASET_STATE_UPDATE = "data-set:stateUpdate"),
    (H5_EXT_EVENT.RETRY_PLAY = "retryPlay"),
    (H5_EXT_EVENT.DEGRADE_CODEC_PLAY = "degradeCodecPlay"),
    (H5_EXT_EVENT.AUTOPLAY_IN_MUTED = "autoplayInMuted"),
    (H5_EXT_EVENT.FLOW_NODE_PRELOAD = "FLOW_NODE_PRELOAD"),
    (H5_EXT_EVENT.FLOW_NODE_START = "FLOW_NODE_START"),
    (H5_EXT_EVENT.FLOW_NODE_END = "FLOW_NODE_END"),
    (H5_EXT_EVENT.FLOW_NODE_ABORT = "FLOW_NODE_ABORT"),
    (H5_EXT_EVENT.STATS_CHANGE = "STATS_CHANGE"),
    (H5_EXT_EVENT.SESSION_FIRST_PLAYING = "SESSION_FIRST_PLAYING"),
    (exports.H5_PLAY_EVENT = void 0),
    (H5_PLAY_EVENT = exports.H5_PLAY_EVENT || (exports.H5_PLAY_EVENT = {})),
    (H5_PLAY_EVENT.PLAY_SESSION_START = "PLAY_SESSION_START"),
    (H5_PLAY_EVENT.AD_REQ_INFO_START = "AD_REQ_INFO_START"),
    (H5_PLAY_EVENT.AD_REQ_INFO_END = "AD_REQ_INFO_END"),
    (H5_PLAY_EVENT.AD_REQ_ASSETS_START = "AD_REQ_ASSETS_START"),
    (H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED = "AD_AUTOPLAY_BLOCKED"),
    (H5_PLAY_EVENT.AD_PLAYING = "AD_PLAYING"),
    (H5_PLAY_EVENT.AD_VOLUME_CHANGE = "AD_VOLUME_CHANGE"),
    (H5_PLAY_EVENT.AD_ASSETS_LOADED = "AD_ASSETS_LOADED"),
    (H5_PLAY_EVENT.AD_PAUSE = "AD_PAUSE"),
    (H5_PLAY_EVENT.AD_RESUME = "AD_RESUME"),
    (H5_PLAY_EVENT.AD_END = "AD_END"),
    (H5_PLAY_EVENT.AD_TIME_UPDATE = "AD_TIME_UPDATE"),
    (H5_PLAY_EVENT.VIDEO_REQ_INFO_START = "VIDEO_REQ_INFO_START"),
    (H5_PLAY_EVENT.VIDEO_REQ_INFO_END = "VIDEO_REQ_INFO_END"),
    (H5_PLAY_EVENT.VIDEO_LOAD_START = "VIDEO_LOAD_START"),
    (H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS = "VIDEO_LOAD_PROGRESS"),
    (H5_PLAY_EVENT.VIDEO_DURATION_CHANGE = "VIDEO_DURATION_CHANGE"),
    (H5_PLAY_EVENT.VIDEO_METADATA_CHANGE = "VIDEO_METADATA_CHANGE"),
    (H5_PLAY_EVENT.VIDEO_TIMEUPDATE = "VIDEO_TIMEUPDATE"),
    (H5_PLAY_EVENT.VIDEO_VOLUME_CHANGE = "VIDEO_VOLUME_CHANGE"),
    (H5_PLAY_EVENT.VIDEO_RATE_CHANGE = "VIDEO_RATE_CHANGE"),
    (H5_PLAY_EVENT.VIDEO_CANPLAY = "VIDEO_CANPLAY"),
    (H5_PLAY_EVENT.VIDEO_PLAYING = "VIDEO_PLAYING"),
    (H5_PLAY_EVENT.VIDEO_AUTOPLAY_BLOCKED = "VIDEO_AUTOPLAY_BLOCKED"),
    (H5_PLAY_EVENT.VIDEO_PAUSE = "VIDEO_PAUSE"),
    (H5_PLAY_EVENT.VIDEO_BUFFERING = "VIDEO_BUFFERING"),
    (H5_PLAY_EVENT.VIDEO_SEEKING = "VIDEO_SEEKING"),
    (H5_PLAY_EVENT.VIDEO_SEEKED = "VIDEO_SEEKED"),
    (H5_PLAY_EVENT.VIDEO_SETLEVEL_START = "VIDEO_SETLEVEL_START"),
    (H5_PLAY_EVENT.VIDEO_SETLEVEL_END = "VIDEO_SETLEVEL_END"),
    (H5_PLAY_EVENT.VIDEO_RESIZE = "VIDEO_RESIZE"),
    (H5_PLAY_EVENT.VIDEO_END = "VIDEO_END"),
    (H5_PLAY_EVENT.PLAY_SESSION_END = "PLAY_SESSION_END");
  var pluginStorage = {},
    pluginExists = function (e) {
      return Object.prototype.hasOwnProperty.call(pluginStorage, e);
    },
    getPlugin = function (e) {
      return pluginExists(e) ? pluginStorage[e] : void 0;
    };
  function registerPlugin(e, t) {
    if ("string" != typeof e)
      throw new Error(
        'Illegal plugin name, "'
          .concat(e, '", must be a string, was ')
          .concat(typeof e, ".")
      );
    if ("function" != typeof t)
      throw new Error(
        'Illegal plugin for "'
          .concat(e, '", must be a function, was ')
          .concat(typeof t, ".")
      );
    if (!pluginExists(e)) return (pluginStorage[e] = t), t;
    console.warn(
      'A plugin named "'.concat(
        e,
        '" already exists. You may want to avoid re-registering plugins!'
      )
    );
  }
  function deregisterPlugin(e) {
    pluginExists(e) && delete pluginStorage[e];
  }
  function getPlugins(e) {
    var t;
    return (
      void 0 === e && (e = Object.keys(pluginStorage)),
      e.forEach(function (e) {
        var o = getPlugin(e);
        o && ((t = t || {})[e] = o);
      }),
      t
    );
  }
  var methodPrefix = "hook",
    playHooks = Object.values(exports.H5_PLAY_EVENT),
    Plugin = (function (e) {
      function t(o, A, i) {
        var r = this.constructor,
          n = e.call(this) || this;
        if (((n.player = o), (n.config = A), (n.hookMap = {}), r === t))
          throw new Error(
            "Plugin must be sub-classed; not directly instantiated."
          );
        n.logger_ = new Logger(o.config.instanceId, n.constructor.pluginName);
        var a = (i || {}).msg;
        return (n.msg = a), n.registerHook(), n;
      }
      return (
        __extends$1(t, e),
        (t.prototype.log = function () {
          for (var e, t, o = [], A = 0; A < arguments.length; A++)
            o[A] = arguments[A];
          null === (t = (e = this.logger_).log) ||
            void 0 === t ||
            t.call.apply(t, __spreadArray([e], o, !1));
        }),
        (t.prototype.warn = function () {
          for (var e, t, o = [], A = 0; A < arguments.length; A++)
            o[A] = arguments[A];
          null === (t = (e = this.logger_).warn) ||
            void 0 === t ||
            t.call.apply(t, __spreadArray([e], o, !1));
        }),
        (t.prototype.error = function () {
          for (var e, t, o = [], A = 0; A < arguments.length; A++)
            o[A] = arguments[A];
          null === (t = (e = this.logger_).error) ||
            void 0 === t ||
            t.call.apply(t, __spreadArray([e], o, !1));
        }),
        (t.prototype.debug = function () {
          for (var e, t, o = [], A = 0; A < arguments.length; A++)
            o[A] = arguments[A];
          null === (t = (e = this.logger_).debug) ||
            void 0 === t ||
            t.call.apply(t, __spreadArray([e], o, !1));
        }),
        (t.prototype.info = function () {
          for (var e, t, o = [], A = 0; A < arguments.length; A++)
            o[A] = arguments[A];
          null === (t = (e = this.logger_).info) ||
            void 0 === t ||
            t.call.apply(t, __spreadArray([e], o, !1));
        }),
        (t.prototype.hasPlugin = function (e) {
          return !!pluginExists(e);
        }),
        (t.prototype.destroy = function () {
          var e,
            t = this.player,
            o = this.name;
          (null === (e = t.plugins) || void 0 === e ? void 0 : e[o]) &&
            delete t.plugins[o],
            this.unRegisterHook(),
            (this.hookMap = null),
            (this.player = null),
            this.removeAllListeners();
        }),
        (t.prototype.hookPlaySessionStart = function (e) {}),
        (t.prototype.hookAdReqInfoStart = function (e) {}),
        (t.prototype.hookAdReqInfoEnd = function (e) {}),
        (t.prototype.hookAdReqAssetsStart = function (e) {}),
        (t.prototype.hookAdAutoplayBlocked = function (e) {}),
        (t.prototype.hookAdPlaying = function (e) {}),
        (t.prototype.hookAdVolumeChange = function (e) {}),
        (t.prototype.hookAdAssetsLoaded = function (e) {}),
        (t.prototype.hookAdPause = function (e) {}),
        (t.prototype.hookAdResume = function (e) {}),
        (t.prototype.hookAdEnd = function (e) {}),
        (t.prototype.hookAdTimeUpdate = function (e) {}),
        (t.prototype.hookVideoReqInfoStart = function (e) {}),
        (t.prototype.hookVideoReqInfoEnd = function (e) {}),
        (t.prototype.hookVideoLoadStart = function (e) {}),
        (t.prototype.hookVideoMetadataChange = function (e) {}),
        (t.prototype.hookVideoLoadProgress = function (e) {}),
        (t.prototype.hookVideoDurationChange = function (e) {}),
        (t.prototype.hookVideoTimeupdate = function (e) {}),
        (t.prototype.hookVideoVolumeChange = function (e) {}),
        (t.prototype.hookVideoResize = function (e) {}),
        (t.prototype.hookVideoRateChange = function (e) {}),
        (t.prototype.hookVideoCanplay = function (e) {}),
        (t.prototype.hookVideoPlaying = function (e) {}),
        (t.prototype.hookVideoAutoplayBlocked = function (e) {}),
        (t.prototype.hookVideoPause = function (e) {}),
        (t.prototype.hookVideoBuffering = function (e) {}),
        (t.prototype.hookVideoSeeking = function (e) {}),
        (t.prototype.hookVideoSeeked = function (e) {}),
        (t.prototype.hookVideoSetlevelStart = function (e) {}),
        (t.prototype.hookVideoSetlevelEnd = function (e) {}),
        (t.prototype.hookVideoEnd = function (e) {}),
        (t.prototype.hookPlaySessionEnd = function (e) {}),
        (t.prototype.registerHook = function () {
          var e = this;
          playHooks.forEach(function (t) {
            var o = getHookMethodName(t);
            (e.hookMap[t] = function (t) {
              var A;
              return null === (A = e[o]) || void 0 === A
                ? void 0
                : A.call(e, t.data);
            }),
              e.player.on(t, e.hookMap[t]);
          });
        }),
        (t.prototype.unRegisterHook = function () {
          var e = this;
          playHooks.forEach(function (t) {
            e.hookMap[t] && e.player.off(t, e.hookMap[t]);
          });
        }),
        (t.VERSION = ""),
        (t.pluginName = ""),
        t
      );
    })(s$1$1);
  function isFunctionPlugin(e) {
    var t = "string" == typeof e ? getPlugin(e) : e;
    return (
      "function" == typeof t &&
      !Object.prototype.isPrototypeOf.call(Plugin.prototype, t.prototype)
    );
  }
  function createPluginFactory(e, t) {
    for (var o = [], A = 2; A < arguments.length; A++) o[A - 2] = arguments[A];
    var i,
      r = o[0];
    if (isFunctionPlugin(t)) i = t.apply(r, o);
    else {
      var n = t;
      (n.prototype.name = e),
        (i = new (n.bind.apply(n, __spreadArray([void 0], o, !1)))());
    }
    return i && (r.plugins[e] = i), i;
  }
  function getHookMethodName(e) {
    return (
      methodPrefix +
      e
        .toLowerCase()
        .replace(/^[a-z]/, function (e) {
          return e.toUpperCase();
        })
        .replace(/_[a-z]/g, function (e) {
          return e[1].toUpperCase();
        })
    );
  }
  function isVideoId(e) {
    return "string" == typeof e || "number" == typeof e;
  }
  var DRM_TYPE = { NONE: 0, CHACHA: 3, FAIR_PLAY: 4, WIDEVINE: 5, ChinaDRM: 6 },
    DRM_VALUE = { NONE: 0, CHACHA: 8, FAIR_PLAY: 16, WIDEVINE: 32 },
    DATA_EVENTS,
    DATA_STATE,
    LOG_TYPE,
    BUFFER_REASON,
    PersistedUserSettings;
  (exports.DATA_EVENTS = void 0),
    (DATA_EVENTS = exports.DATA_EVENTS || (exports.DATA_EVENTS = {})),
    (DATA_EVENTS.UPDATE = "data-set:update"),
    (DATA_EVENTS.STATE_UPDATE = "data-set:stateUpdate"),
    (exports.DATA_STATE = void 0),
    (DATA_STATE = exports.DATA_STATE || (exports.DATA_STATE = {})),
    (DATA_STATE.INIT = "PLAYER:init"),
    (DATA_STATE.SESSION_START = "PLAYER:session_start"),
    (DATA_STATE.SESSION_END = "PLAYER:session_end"),
    (DATA_STATE.GET_INFO = "PLAYER:getinfo"),
    (DATA_STATE.GET_INFO_START = "PLAYER:getinfo_start"),
    (DATA_STATE.GET_INFO_END = "PLAYER:getinfo_end"),
    (DATA_STATE.SUBTITLE = "PLAYER:subtitle"),
    (DATA_STATE.SUBTITLE_START = "PLAYER:subtitle_start"),
    (DATA_STATE.SUBTITLE_END = "PLAYER:subtitle_end"),
    (DATA_STATE.LOAD_START = "PLAYER:load_start"),
    (DATA_STATE.LOAD_END = "PLAYER:load_end"),
    (DATA_STATE.LOAD = "PLAYER:load"),
    (DATA_STATE.BUFFER = "PLAYER:buffer"),
    (DATA_STATE.BUFFER_START = "PLAYER:buffer_start"),
    (DATA_STATE.BUFFER_END = "PLAYER:buffer_end"),
    (DATA_STATE.SEEK = "PLAYER:seek"),
    (DATA_STATE.SEEK_START = "PLAYER:seek_start"),
    (DATA_STATE.SEEK_END = "PLAYER:seek_end"),
    (DATA_STATE.USER_SEEK_START = "PLAYER:user_seek_start"),
    (DATA_STATE.USER_SEEK_END = "PLAYER:user_seek_end"),
    (DATA_STATE.END = "PLAYER:end"),
    (DATA_STATE.ERROR = "PLAYER:error"),
    (DATA_STATE.FATAL_ERROR = "PLAYER:fatal_error"),
    (DATA_STATE.FIRST_PLAY = "PLAYER:firstPlay"),
    (DATA_STATE.IDLE = "PLAYER:idle"),
    (DATA_STATE.PLAYING = "PLAYER:playing"),
    (DATA_STATE.SET_LEVEL = "PLAYER:setLevel"),
    (DATA_STATE.SET_LEVEL_START = "PLAYER:setLevel_start"),
    (DATA_STATE.SET_LEVEL_END = "PLAYER:setLevel_end"),
    (DATA_STATE.PAUSE = "PLAYER:pause"),
    (DATA_STATE.PAUSE_START = "PLAYER:pause_start"),
    (DATA_STATE.PAUSE_END = "PLAYER:pause_end"),
    (DATA_STATE.SET_RATE = "PLAYER:setRate"),
    (DATA_STATE.RETRY_BACKURL = "PLAYER:retryBackUrl"),
    (DATA_STATE.RETRY_PLAY = "PLAYER:retryPlay"),
    (DATA_STATE.AUTO_PLAY_BLOCKED = "PLAYER:autoplayBlocked"),
    (DATA_STATE.CODEC_DEGRADE = "PLAYER:codecDegrade"),
    (DATA_STATE.DT_OPEN = "PLAYER:dtOpen"),
    (exports.LOG_TYPE = void 0),
    (LOG_TYPE = exports.LOG_TYPE || (exports.LOG_TYPE = {})),
    (LOG_TYPE.USER_ACTION = "log:userAction"),
    (LOG_TYPE.PLUGIN_ACTION = "log:pluginAction"),
    (LOG_TYPE.CORE_EVENT = "log:coreEvent"),
    (LOG_TYPE.API_INVOKE = "log:apiInvoke"),
    (LOG_TYPE.UNCATEGORIZED = "log:uncategorized"),
    (exports.BUFFER_REASON = void 0),
    (BUFFER_REASON = exports.BUFFER_REASON || (exports.BUFFER_REASON = {})),
    (BUFFER_REASON[(BUFFER_REASON.NETWORK_UNSTABLE = 1400027)] =
      "NETWORK_UNSTABLE"),
    (BUFFER_REASON[(BUFFER_REASON.PARALLEL_DOWNLOAD = 1400028)] =
      "PARALLEL_DOWNLOAD"),
    (BUFFER_REASON[(BUFFER_REASON.CDN_NO_CONNECTION = 1400007)] =
      "CDN_NO_CONNECTION"),
    (BUFFER_REASON[(BUFFER_REASON.CDN_URL_SWITCH_SUCCESS = 1400029)] =
      "CDN_URL_SWITCH_SUCCESS"),
    (BUFFER_REASON[(BUFFER_REASON.CDN_SLOW = 1400030)] = "CDN_SLOW"),
    (BUFFER_REASON[(BUFFER_REASON.CDN_URL_SWITCH_UNSUCCESS = 1400031)] =
      "CDN_URL_SWITCH_UNSUCCESS"),
    (BUFFER_REASON[(BUFFER_REASON.CDN_TIMEOUT = 1400026)] = "CDN_TIMEOUT"),
    (BUFFER_REASON[(BUFFER_REASON.CDN_TIMEOUT_URL_SWITCH = 1400032)] =
      "CDN_TIMEOUT_URL_SWITCH"),
    (BUFFER_REASON[(BUFFER_REASON.BYTERATE_ERROR = 1400033)] =
      "BYTERATE_ERROR"),
    (BUFFER_REASON[(BUFFER_REASON.DOWNLOAD_TOO_SHORT = 1400034)] =
      "DOWNLOAD_TOO_SHORT"),
    (BUFFER_REASON[(BUFFER_REASON.P2P_UPLOAD_SLOW = 1400035)] =
      "P2P_UPLOAD_SLOW"),
    (BUFFER_REASON[(BUFFER_REASON.DEFAULT = 0)] = "DEFAULT"),
    (exports.LOCAL_KEY = void 0),
    (function (e) {
      (e.GUID = "thumbplayer-h5-guid"), (e.VOLUME = "thumbplayer-h5-volume");
    })(exports.LOCAL_KEY || (exports.LOCAL_KEY = {})),
    (exports.PersistedUserSettings = void 0),
    (PersistedUserSettings =
      exports.PersistedUserSettings || (exports.PersistedUserSettings = {})),
    (PersistedUserSettings.definition = "user-setting:definition"),
    (PersistedUserSettings.volume = "user-setting:volume"),
    (PersistedUserSettings.playbackRate = "user-setting:playbackRate"),
    (PersistedUserSettings.subtitle = "user-setting:subtitle"),
    (PersistedUserSettings.audioTrack = "user-setting:audioTrack");
  var DEFAULT_KEY = {
      loginid: "",
      loginex: "",
      logintype: "",
      hh_ip: "",
      hc_main_login: "",
      hc_vuserid: "",
      hc_openid: "",
      hc_appid: "",
      hc_access_token: "",
      hc_vuession: "",
      qimeiH38: "",
      vip: 0,
      codec: CODEC.H264,
      freetype: 0,
      videoCapability: "",
      mobile: 0,
      guid: "",
      ua: "",
      uip: "",
      device: "",
      resolution: "",
      osver: "",
      p2pver: "",
      appVer: "",
      playerver: "",
      playertype: 0,
      playercore: "",
      confid: "",
      downloadkit: 0,
      online: 1,
      p2p: 0,
      sstrength: 0,
      network: 0,
      testid: 0,
      curcore: "",
      curcorever: "",
      speed: 0,
      quic: 0,
      platform: "",
      flowid: "",
      vid: "",
      cid: "",
      columnId: "",
      livepid: "",
      interactid: "",
      url: "",
      referrer: "",
      topUrl: "",
      drm: 0,
      drmtype: 0,
      fmt: 0,
      cdnid: 0,
      dltype: "",
      rate: 0,
      clip: 0,
      status: 0,
      duration: 0,
      isPreload: 0,
      type: 0,
      cdnuip: "",
      cdnip: "",
      ptag: "",
      sdtfrom: "",
      authfrom: "",
      currentDefnList: [],
      currentDefn: "",
      currentAudioTrack: 0,
      currentAudioTrackList: [],
      currentSubtitle: "",
      currentSubtitleList: [],
      sessionBufferCount: 0,
      sessionRetryBackUrlCount: 0,
      sessionRetryPlayCount: 0,
      ckeytime: -1,
      ckeydg: 0,
      deved: 0,
      deviceScore: 0,
      TEE_screen: {},
    },
    COMMON_DATA_KEY = {},
    _a$1$1;
  Object.keys(DEFAULT_KEY).forEach(function (e) {
    return (COMMON_DATA_KEY[e] = e);
  });
  var FreezeKey = "thumbplayer-h5-dataset",
    KeySystemToDrmType =
      ((_a$1$1 = {}),
      (_a$1$1[KeySystems$2.Widevine] = DRM_TYPE.WIDEVINE),
      (_a$1$1[KeySystems$2.FairPlay] = DRM_TYPE.FAIR_PLAY),
      (_a$1$1[KeySystems$2.FairPlayWebKit] = DRM_TYPE.FAIR_PLAY),
      (_a$1$1.none = DRM_TYPE.NONE),
      _a$1$1),
    confIdMap = { default: 0, hlsProgressive: 1, hlsFragPrefetch: 2 },
    DataSet = (function (e) {
      function t(o, A, i) {
        var r = e.call(this, o, A, i) || this;
        return (
          (r.player = o),
          (r.isSeeking = !1),
          (r.isBuffering = !1),
          (r.isSettingLevel = !1),
          (r.isLoading = !1),
          (r.lastPlay = 0),
          (r.playDuration = 0),
          (r.prevPlayTimeS = 0),
          (r.sessionBufferCount = 0),
          (r.sessionRetryBackUrlCount = 0),
          (r.sessionRetryPlayCount = 0),
          (r.commonMapFreeze = {}),
          (r.stateMapFreeze = {}),
          (r.isLive = !1),
          (r.isAdPlaying = !1),
          (r.evtIdMap = {}),
          (r.writeCommon = function (e, o, A) {
            var i = r.commonMap[e];
            return (
              (r.commonMap[e] = o),
              t.canUseProxy ||
                r.emit(exports.DATA_EVENTS.UPDATE, {
                  key: e,
                  oldVal: i,
                  newVal: o,
                }),
              !!A && r.freeze("common", e, A)
            );
          }),
          (r.writeState = function (e, o, A) {
            var i = o.type || exports.LOG_TYPE.UNCATEGORIZED,
              n = r.stateMap[e],
              a = r.getStartEventData(e);
            return (
              (r.stateMap[e] = __assign$1(
                __assign$1(
                  __assign$1(
                    {},
                    i === exports.LOG_TYPE.CORE_EVENT ? r.stats : {}
                  ),
                  {
                    type: i,
                    ftime: +new Date(),
                    name: e,
                    eventId: r.generateEvtId(),
                  }
                ),
                o
              )),
              !t.canUseProxy &&
                r.commonMap[COMMON_DATA_KEY.flowid] &&
                r.emit(exports.DATA_EVENTS.STATE_UPDATE, {
                  key: e,
                  oldVal: n,
                  newVal: r.stateMap[e],
                  startEvent: a,
                }),
              !!A && r.freeze("state", e, A)
            );
          }),
          (r.onClose = function () {
            var e = +new Date();
            return {
              code: exports.ErrorCode.SUC,
              playDuration: r.playDuration,
              ftime: e,
            };
          }),
          (r.getStats = function () {
            return __assign$1(
              __assign$1({ playDuration: r.playDuration }, r.stats),
              r.visualStats
            );
          }),
          (r.generateFlowId = function () {
            return commonTool$1.createGUID(32);
          }),
          (r.generateEvtId = function () {
            return commonTool$1.createGUID(8);
          }),
          (r.getStartEventData = function (e) {
            var t;
            return (((t = {})[exports.DATA_STATE.SEEK_END] =
              r.stateMap[exports.DATA_STATE.SEEK_START]),
            (t[exports.DATA_STATE.BUFFER_END] =
              r.stateMap[exports.DATA_STATE.BUFFER_START]),
            (t[exports.DATA_STATE.LOAD_END] =
              r.stateMap[exports.DATA_STATE.LOAD_START]),
            (t[exports.DATA_STATE.SET_LEVEL_END] =
              r.stateMap[exports.DATA_STATE.SET_LEVEL_START]),
            (t[exports.DATA_STATE.PAUSE_END] =
              r.stateMap[exports.DATA_STATE.PAUSE_START]),
            (t[exports.DATA_STATE.GET_INFO_END] =
              r.stateMap[exports.DATA_STATE.GET_INFO_START]),
            t)[e];
          }),
          (r.resetState = function () {
            (r.isBuffering = !1), (r.isSeeking = !1), (r.isSettingLevel = !1);
          }),
          (r.finalCleanup = function (e, t) {
            var o,
              A,
              i = t.error,
              n = t.loadingUrl,
              a = t.config,
              s =
                null !==
                  (A =
                    null === (o = null == a ? void 0 : a.backupUrls) ||
                    void 0 === o
                      ? void 0
                      : o.findIndex(function (e) {
                          return e === n;
                        })) && void 0 !== A
                  ? A
                  : -1;
            r.isSeeking &&
              (r.writeState(exports.DATA_STATE.SEEK_END, {
                currentUrl: n,
                urlIndex: s,
                type: exports.LOG_TYPE.CORE_EVENT,
                ftime: e,
                error: i,
                code: (null == i ? void 0 : i.code) || exports.ErrorCode.SUC,
                name: exports.DATA_STATE.SEEK_END,
                eventId: r.evtIdMap[exports.DATA_STATE.SEEK_START],
              }),
              (r.isSeeking = !1)),
              r.isBuffering &&
                (r.writeState(exports.DATA_STATE.BUFFER_END, {
                  currentUrl: n,
                  urlIndex: s,
                  type: exports.LOG_TYPE.CORE_EVENT,
                  ftime: e,
                  code: (null == i ? void 0 : i.code) || exports.ErrorCode.SUC,
                  error: i,
                  name: exports.DATA_STATE.BUFFER_END,
                  eventId: r.evtIdMap[exports.DATA_STATE.BUFFER_START],
                }),
                (r.isBuffering = !1)),
              r.isSettingLevel &&
                ((r.isSettingLevel = !1),
                r.writeState(exports.DATA_STATE.SET_LEVEL_END, {
                  currentUrl: n,
                  urlIndex: s,
                  type: exports.LOG_TYPE.CORE_EVENT,
                  ftime: e,
                  code: (null == i ? void 0 : i.code) || exports.ErrorCode.SUC,
                  error: i,
                  name: exports.DATA_STATE.SET_LEVEL_END,
                  eventId: r.evtIdMap[exports.DATA_STATE.SET_LEVEL_START],
                })),
              r.isLoading &&
                ((r.isLoading = !1),
                r.writeState(exports.DATA_STATE.LOAD_END, {
                  type: exports.LOG_TYPE.CORE_EVENT,
                  currentUrl: n,
                  urlIndex: s,
                  ftime: e,
                  error: i,
                  code: (null == i ? void 0 : i.code) || exports.ErrorCode.SUC,
                  name: exports.DATA_STATE.LOAD_END,
                  eventId: r.evtIdMap[exports.DATA_STATE.LOAD_START],
                })),
              (r.isAdPlaying = !1);
          }),
          (r.onAutoplayBlocked = function () {
            r.writeState(exports.DATA_STATE.AUTO_PLAY_BLOCKED, {
              type: exports.LOG_TYPE.CORE_EVENT,
              name: exports.DATA_STATE.AUTO_PLAY_BLOCKED,
              eventId: r.generateEvtId(),
              ftime: +new Date(),
            });
          }),
          (r.onAdPlaying = function (e) {
            e.data.adType === exports.AD_TYPE.PRE && (r.isAdPlaying = !0);
          }),
          (r.onAdEnd = function (e) {
            e.data.adType === exports.AD_TYPE.PRE && (r.isAdPlaying = !1);
          }),
          (r.onRetryLoad = function (e) {
            var t = e.data,
              o = t.prevUrl,
              A = t.curUrl,
              i = t.error,
              n = void 0 === i ? {} : i;
            r.writeState(exports.DATA_STATE.RETRY_BACKURL, {
              type: exports.LOG_TYPE.CORE_EVENT,
              name: exports.DATA_STATE.RETRY_BACKURL,
              eventId: r.generateEvtId(),
              prevUrl: o,
              currentUrl: A,
              ftime: +new Date(),
              error: n,
              code: null == n ? void 0 : n.code,
            }),
              r.sessionRetryBackUrlCount++,
              r.writeCommon(
                COMMON_DATA_KEY.sessionRetryBackUrlCount,
                r.sessionRetryBackUrlCount
              );
          }),
          (r.onRetryPlay = function (e) {
            var t = e.data.retryTimes,
              o = void 0 === t ? 0 : t;
            r.writeState(exports.DATA_STATE.RETRY_PLAY, {
              type: exports.LOG_TYPE.CORE_EVENT,
              name: exports.DATA_STATE.RETRY_PLAY,
              eventId: r.generateEvtId(),
              ftime: +new Date(),
              ext: { retryTimes: o },
            }),
              r.sessionRetryPlayCount++,
              r.writeCommon(
                COMMON_DATA_KEY.sessionRetryPlayCount,
                r.sessionRetryPlayCount
              );
          }),
          (r.onBuffering = function (e) {
            if (!r.isBuffering) {
              r.isBuffering = !0;
              var t = r.generateEvtId();
              (r.evtIdMap[exports.DATA_STATE.BUFFER_START] = t),
                r.writeState(exports.DATA_STATE.BUFFER_START, {
                  type: exports.LOG_TYPE.CORE_EVENT,
                  name: exports.DATA_STATE.BUFFER_START,
                  eventId: t,
                  prevState: e.old,
                  ftime: +new Date(),
                }),
                r.sessionBufferCount++,
                r.writeCommon(
                  COMMON_DATA_KEY.sessionBufferCount,
                  r.sessionBufferCount
                );
            }
          }),
          (r.onLoadStart = function (e) {
            var t, o, A, i, n, a, s, g, l;
            r.resetState();
            var E =
                null === (t = e.videoInfo) || void 0 === t ? void 0 : t.config,
              c = +new Date();
            r.writeCommon(COMMON_DATA_KEY.curcore, r.player.kernelName);
            var u =
              null ===
                (o = KernelFactory$1.getKernelByName(r.player.kernelName)) ||
              void 0 === o
                ? void 0
                : o.VERSION;
            r.writeCommon(COMMON_DATA_KEY.curcorever, u),
              r.writeCommon(
                COMMON_DATA_KEY.drmtype,
                KeySystemToDrmType[
                  (null === (A = E.drmConfig) || void 0 === A
                    ? void 0
                    : A.keySystem) || "none"
                ]
              ),
              r.writeCommon(
                COMMON_DATA_KEY.playertype,
                r.player.kernelName === exports.KERNEL_NAME.ORIGIN ? "0" : "1"
              );
            var p =
              null ===
                (a =
                  null ===
                    (n =
                      null === (i = r.player.corePlayer) || void 0 === i
                        ? void 0
                        : i.kernel) || void 0 === n
                    ? void 0
                    : n.getP2P) || void 0 === a
                ? void 0
                : a.call(n);
            if (
              (r.writeCommon(
                COMMON_DATA_KEY.p2pver,
                null !==
                  (g =
                    null === (s = null == p ? void 0 : p.getVersion) ||
                    void 0 === s
                      ? void 0
                      : s.call(p)) && void 0 !== g
                  ? g
                  : 0
              ),
              r.writeCommon(COMMON_DATA_KEY.p2p, p ? "1" : "0"),
              r.player.kernelName === exports.KERNEL_NAME.HLS_JS && !p)
            ) {
              var d = +(null !== (l = r.player.config.enableP2P) && void 0 !== l
                  ? l
                  : 2),
                B = +!!r.player.currentVideoInfo.config.p2pConfig;
              r.writeCommon(COMMON_DATA_KEY.confid, "7003".concat(d).concat(B));
            }
            r.isLoading = !0;
            var h = r.generateEvtId();
            (r.evtIdMap[exports.DATA_STATE.LOAD_START] = h),
              r.writeState(exports.DATA_STATE.LOAD_START, {
                type: exports.LOG_TYPE.CORE_EVENT,
                eventId: h,
                name: exports.DATA_STATE.LOAD_START,
                ftime: c,
              });
          }),
          (r.onEnd = function () {
            r.writeState(exports.DATA_STATE.END, {
              type: exports.LOG_TYPE.CORE_EVENT,
              name: exports.DATA_STATE.END,
              eventId: r.generateEvtId(),
              ftime: +new Date(),
              ext: { playDuration: r.playDuration },
              code: exports.ErrorCode.SUC,
            });
          }),
          (r.onIdle = function () {}),
          (r.onSeeking = function (e) {
            var t,
              o,
              A = +new Date();
            r.isSeeking &&
              r.writeState(exports.DATA_STATE.SEEK_END, {
                type: exports.LOG_TYPE.CORE_EVENT,
                name: exports.DATA_STATE.SEEK_END,
                ftime: A,
                eventId: r.evtIdMap[exports.DATA_STATE.SEEK_START],
                ext: {
                  isUserSeek:
                    (null ===
                      (o =
                        null ===
                          (t = r.stateMap[exports.DATA_STATE.SEEK_START]) ||
                        void 0 === t
                          ? void 0
                          : t.ext) || void 0 === o
                      ? void 0
                      : o.isUserSeek) || !1,
                },
              }),
              r.isLive || r.resetState(),
              (r.isSeeking = !0);
            var i = r.generateEvtId();
            (r.evtIdMap[exports.DATA_STATE.SEEK_START] = i),
              r.writeState(exports.DATA_STATE.SEEK_START, {
                type: exports.LOG_TYPE.CORE_EVENT,
                ftime: A,
                name: exports.DATA_STATE.SEEK_START,
                eventId: i,
                ext: {
                  inBufferedRange: videoTool$1.checkTimeInBuffer(
                    e.seekingTime,
                    r.player.videoBuffered
                  ),
                  isUserSeek: e.isUserSeek,
                },
              });
          }),
          (r.onSeeked = function (e) {
            r.isSeeking &&
              ((r.isSeeking = !1),
              r.writeState(exports.DATA_STATE.SEEK_END, {
                type: exports.LOG_TYPE.CORE_EVENT,
                eventId: r.evtIdMap[exports.DATA_STATE.SEEK_START],
                ftime: +new Date(),
                name: exports.DATA_STATE.SEEK_END,
                ext: { isUserSeek: e.isUserSeek },
                code: exports.ErrorCode.SUC,
              }));
          }),
          (r.onPause = function (e) {
            var t = e.pauseType,
              o = r.generateEvtId();
            (r.evtIdMap[exports.DATA_STATE.PAUSE_START] = o),
              r.writeState(exports.DATA_STATE.PAUSE_START, {
                type: exports.LOG_TYPE.CORE_EVENT,
                ftime: +new Date(),
                name: exports.DATA_STATE.PAUSE_START,
                eventId: o,
                pauseType: t,
              });
          }),
          (r.onPlaying = function () {
            var e = +new Date();
            r.isBuffering &&
              (r.writeState(exports.DATA_STATE.BUFFER_END, {
                type: exports.LOG_TYPE.CORE_EVENT,
                name: exports.DATA_STATE.BUFFER_END,
                ftime: e,
                eventId: r.evtIdMap[exports.DATA_STATE.BUFFER_START],
              }),
              (r.isBuffering = !1)),
              (r.lastPlay = e),
              r.evtIdMap[exports.DATA_STATE.PAUSE_START] &&
                (r.writeState(exports.DATA_STATE.PAUSE_END, {
                  type: exports.LOG_TYPE.CORE_EVENT,
                  name: exports.DATA_STATE.PAUSE_END,
                  eventId: r.evtIdMap[exports.DATA_STATE.PAUSE_START],
                  ftime: e,
                  code: exports.ErrorCode.SUC,
                }),
                delete r.evtIdMap[exports.DATA_STATE.PAUSE_START]);
          }),
          (r.onCanPlay = function () {
            if (r.isLoading) {
              var e = +new Date();
              r.writeState(exports.DATA_STATE.LOAD_END, {
                type: exports.LOG_TYPE.CORE_EVENT,
                ftime: e,
                name: exports.DATA_STATE.LOAD_END,
                eventId: r.evtIdMap[exports.DATA_STATE.LOAD_START],
                code: exports.ErrorCode.SUC,
                ext: { isAdPlaying: r.isAdPlaying },
              }),
                (r.isLoading = !1);
            }
          }),
          (r.onCodecDegrade = function (e) {
            var t,
              o = +new Date();
            r.writeState(exports.DATA_STATE.CODEC_DEGRADE, {
              type: exports.LOG_TYPE.CORE_EVENT,
              ftime: o,
              name: exports.DATA_STATE.CODEC_DEGRADE,
              code:
                null !== (t = e.data.degradeReason) && void 0 !== t
                  ? t
                  : exports.ErrorCode.SUC,
            });
          }),
          (r.onSetLevelStart = function (e) {
            var t = +new Date();
            r.isSeeking &&
              ((r.isSeeking = !1),
              r.writeState(exports.DATA_STATE.SEEK_END, {
                type: exports.LOG_TYPE.CORE_EVENT,
                name: exports.DATA_STATE.SEEK_END,
                ftime: t,
                eventId: r.evtIdMap[exports.DATA_STATE.SEEK_START],
              })),
              r.resetState(),
              (r.isSettingLevel = !0);
            var o = r.generateEvtId();
            (r.evtIdMap[exports.DATA_STATE.SET_LEVEL_START] = o),
              r.writeState(exports.DATA_STATE.SET_LEVEL_START, {
                type: exports.LOG_TYPE.CORE_EVENT,
                ftime: t,
                eventId: o,
                name: exports.DATA_STATE.SET_LEVEL_START,
                ext: { defn: r.commonMap.currentDefn, mode: e.data.mode },
              });
          }),
          (r.onSetLevelEnd = function (e) {
            var t = e.data,
              o = ((void 0 === t ? {} : t).videoInfo || {}).error;
            (r.isSettingLevel = !1),
              r.writeCommon(COMMON_DATA_KEY.curcore, r.player.kernelName),
              r.writeState(exports.DATA_STATE.SET_LEVEL_END, {
                type: exports.LOG_TYPE.CORE_EVENT,
                name: exports.DATA_STATE.SET_LEVEL_END,
                ftime: +new Date(),
                eventId: r.evtIdMap[exports.DATA_STATE.SET_LEVEL_START],
                error: o,
                code: (null == o ? void 0 : o.code) || exports.ErrorCode.SUC,
              });
          }),
          (r.onError = function (e) {
            var t,
              o,
              A = (e.data || {}).videoInfo,
              i = A || {},
              n = i.error,
              a = i.state,
              s = i.currentFragSn,
              g = i.currentFragUrl,
              l = i.loadingUrl,
              E = i.config,
              c = +new Date();
            r.writeState(exports.DATA_STATE.ERROR, {
              currentUrl: l,
              urlIndex:
                null !==
                  (o =
                    null === (t = null == E ? void 0 : E.backupUrls) ||
                    void 0 === t
                      ? void 0
                      : t.findIndex(function (e) {
                          return e === l;
                        })) && void 0 !== o
                  ? o
                  : -1,
              type: exports.LOG_TYPE.CORE_EVENT,
              name: exports.DATA_STATE.ERROR,
              eventId: r.generateEvtId(),
              fragUrl: g,
              ext: { fragSn: s },
              code: n.code,
              error: n,
              ftime: c,
              prevState: a,
            }),
              r.finalCleanup(c, A);
          }),
          (r.onDurationChange = function (e) {
            var t = e.data,
              o = ((void 0 === t ? {} : t).videoInfo || {}).duration,
              A = void 0 === o ? 0 : o;
            r.commonMap.duration = A;
          }),
          (r.onFirstPlay = function () {
            var e = +new Date();
            r.writeState(exports.DATA_STATE.FIRST_PLAY, {
              type: exports.LOG_TYPE.CORE_EVENT,
              name: exports.DATA_STATE.FIRST_PLAY,
              ftime: e,
              eventId: r.generateEvtId(),
            });
          }),
          (r.onTimeChange = function () {
            var e = Math.floor(r.player.playtime);
            e &&
              e !== r.prevPlayTimeS &&
              ((r.prevPlayTimeS = e),
              r.playDuration || (r.playDuration = 0),
              (r.playDuration += 1));
          }),
          (r.onStateChange = function (e) {
            var t,
              o = e.data,
              A = o.new,
              i =
                (((t = {})[exports.VIDEO_STATE.BUFFERING] = r.onBuffering),
                (t[exports.VIDEO_STATE.LOAD_START] = r.onLoadStart),
                (t[exports.VIDEO_STATE.END] = r.onEnd),
                (t[exports.VIDEO_STATE.IDLE] = r.onIdle),
                (t[exports.VIDEO_STATE.SEEKING] = r.onSeeking),
                (t[exports.VIDEO_STATE.SEEKED] = r.onSeeked),
                (t[exports.VIDEO_STATE.PAUSE] = r.onPause),
                (t[exports.VIDEO_STATE.PLAYING] = r.onPlaying),
                (t[exports.VIDEO_STATE.CANPLAY] = r.onCanPlay),
                t);
            i[A] && i[A](o);
          }),
          (r.onRateChange = function () {
            r.writeState(exports.DATA_STATE.SET_RATE, {
              type: exports.LOG_TYPE.CORE_EVENT,
              name: exports.DATA_STATE.SET_RATE,
              eventId: r.generateEvtId(),
              ftime: +new Date(),
            });
          }),
          (r.onVideoReqInfoStart = function () {
            var e = r.generateEvtId();
            (r.evtIdMap[exports.DATA_STATE.GET_INFO_START] = e),
              r.writeState(exports.DATA_STATE.GET_INFO_START, {
                type: exports.LOG_TYPE.CORE_EVENT,
                name: exports.DATA_STATE.GET_INFO_START,
                eventId: e,
                ftime: +new Date(),
              });
          }),
          (r.onVideoReqInfoEnd = function (e) {
            var t = e.data,
              o = t.code,
              A = t.data,
              i = void 0 === A ? {} : A;
            (r.sessionRetryBackUrlCount = 0),
              r.evtIdMap[exports.DATA_STATE.GET_INFO_START] &&
                r.writeState(exports.DATA_STATE.GET_INFO_END, {
                  type: exports.LOG_TYPE.CORE_EVENT,
                  name: exports.DATA_STATE.GET_INFO_END,
                  code: o,
                  ext: {
                    reqBody: urlTool$1.object2string(i.reqParams || {}, "&"),
                    reqPath: i.reqPath || "",
                    retryCount: i.alreadyRetryCount || 0,
                  },
                  error: i.error || {},
                  eventId: r.evtIdMap[exports.DATA_STATE.GET_INFO_START],
                  ftime: +new Date(),
                });
          }),
          (r.onPlaySessionStart = function (e) {
            var t = e.data;
            r.writeCommon(COMMON_DATA_KEY.flowid, t.flowid),
              r.writeCommon(COMMON_DATA_KEY.isPreload, Number(t.isPreload)),
              r.writeCommon(
                COMMON_DATA_KEY.vid,
                isVideoId(t.playItem) ? t.playItem : ""
              ),
              r.emit(exports.DATA_EVENTS.STATE_UPDATE, {
                key: exports.DATA_STATE.INIT,
                oldVal: void 0,
                newVal: r.stateMap[exports.DATA_STATE.INIT],
                startEvent: void 0,
              }),
              r.writeState(exports.DATA_STATE.SESSION_START, {
                eventId: r.generateEvtId(),
                type: exports.LOG_TYPE.CORE_EVENT,
                name: exports.DATA_STATE.SESSION_START,
                ftime: +new Date(),
              });
          }),
          (r.onPlaySessionEnd = function (e) {
            var t = e.data.code,
              o =
                t === exports.ErrorCode.SUC
                  ? __assign$1({}, r.stateMap[exports.DATA_STATE.END])
                  : __assign$1({}, r.stateMap[exports.DATA_STATE.ERROR]);
            t !== exports.ErrorCode.SUC &&
              r.removeUserSetting([
                exports.PersistedUserSettings.definition,
                exports.PersistedUserSettings.audioTrack,
              ]),
              r.writeState(
                exports.DATA_STATE.SESSION_END,
                __assign$1(__assign$1({}, o), {
                  code: t,
                  eventId: r.generateEvtId(),
                  name: exports.DATA_STATE.SESSION_END,
                  type: exports.LOG_TYPE.CORE_EVENT,
                  ftime: +new Date(),
                })
              ),
              (r.playDuration = 0),
              (r.prevPlayTimeS = 0),
              (r.sessionBufferCount = 0),
              (r.sessionRetryBackUrlCount = 0),
              (r.sessionRetryPlayCount = 0);
          }),
          (r.getGUID = function () {
            var e = lsTool.getData(exports.LOCAL_KEY.GUID);
            if (e) return e;
            var t = commonTool$1.createGUID(32);
            return lsTool.setData(exports.LOCAL_KEY.GUID, t), t;
          }),
          (r.isTabFocused = function () {
            var e = ["hidden", "msHidden", "webkitHidden"].find(function (e) {
              return void 0 !== document[e];
            });
            return e ? (document[e] ? 0 : 1) : -1;
          }),
          (r.isPlayerInViewport = function () {
            var e = r.player.container;
            if (!e.offsetParent) return 0;
            var t = e.getBoundingClientRect(),
              o = window.innerHeight || document.documentElement.clientHeight,
              A = window.innerWidth || document.documentElement.clientWidth,
              i = t.top <= o && t.top + t.height >= 0,
              n = t.left <= A && t.left + t.width >= 0;
            return +(i && n);
          }),
          (r.commonMap = t.canUseProxy
            ? new Proxy(
                {},
                {
                  get: function (e, t, o) {
                    return Reflect.get(e, t, o);
                  },
                  set: function (e, t, o, A) {
                    if ("string" != typeof t) return !1;
                    if (r.commonMapFreeze[t]) return !1;
                    var i = Reflect.get(e, t, A),
                      n = Reflect.set(e, t, o, A);
                    return (
                      i !== o &&
                        r.emit(exports.DATA_EVENTS.UPDATE, {
                          key: t,
                          oldVal: i,
                          newVal: o,
                        }),
                      n
                    );
                  },
                }
              )
            : {}),
          (r.stateMap = t.canUseProxy
            ? new Proxy(
                {},
                {
                  get: function (e, t, o) {
                    return Reflect.get(e, t, o);
                  },
                  set: function (e, t, o, A) {
                    if ("string" != typeof t) return !1;
                    if (r.stateMapFreeze[t]) return !1;
                    var i = Reflect.get(e, t, A),
                      n = Reflect.set(e, t, o, A);
                    return (
                      r.commonMap[COMMON_DATA_KEY.flowid] &&
                        r.emit(exports.DATA_EVENTS.STATE_UPDATE, {
                          key: t,
                          oldVal: i,
                          newVal: o,
                          startEvent: r.getStartEventData(t),
                          startEventData: r.getStartEventData(t),
                        }),
                      n
                    );
                  },
                }
              )
            : {}),
          (r.isLive = r.player.config.type === exports.PLAY_MODE.LIVE),
          r.setEnv(),
          r.collectBaseInfo(),
          r.collectVideoCapability(),
          r.persistUserSetting(),
          r
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "stats", {
          get: function () {
            var e,
              t,
              o,
              A,
              i,
              r,
              n,
              a = this.player,
              s = a.playbackRate,
              g = a.volume,
              l = a.played,
              E = a.playtime,
              c = a.currentVideoInfo;
            return {
              volume: g,
              playbackRate: s,
              played: l,
              playtime: E,
              urlIndex:
                null !==
                  (o =
                    null ===
                      (t =
                        null === (e = null == c ? void 0 : c.config) ||
                        void 0 === e
                          ? void 0
                          : e.backupUrls) || void 0 === t
                      ? void 0
                      : t.findIndex(function (e) {
                          return e === c.loadingUrl;
                        })) && void 0 !== o
                  ? o
                  : -1,
              frameDroppedInPercentage:
                null !==
                  (i =
                    null === (A = null == c ? void 0 : c.qualityInfo) ||
                    void 0 === A
                      ? void 0
                      : A.frameDroppedInPercentage) && void 0 !== i
                  ? i
                  : -1,
              averageDecodeTimeInMs:
                null !==
                  (n =
                    null === (r = null == c ? void 0 : c.qualityInfo) ||
                    void 0 === r
                      ? void 0
                      : r.averageDecodeTimeInMs) && void 0 !== n
                  ? n
                  : -1,
              currentUrl: null == c ? void 0 : c.loadingUrl,
              paused: this.paused,
              fragUrl: null == c ? void 0 : c.currentFragUrl,
            };
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "visualStats", {
          get: function () {
            return {
              isTabFocused: this.isTabFocused(),
              isPlayerInViewport: this.isPlayerInViewport(),
            };
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "paused", {
          get: function () {
            var e, t;
            return null ===
              (t =
                null === (e = this.player) || void 0 === e
                  ? void 0
                  : e.currentVideoElement) || void 0 === t
              ? void 0
              : t.paused;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.defrost = function (e, t, o) {
          switch ((void 0 === o && (o = "secret"), e)) {
            case "state":
              return (
                this.stateMapFreeze[t] === o &&
                (delete this.stateMapFreeze[t], !0)
              );
            case "common":
              return (
                this.commonMapFreeze[t] === o &&
                (delete this.commonMapFreeze[t], !0)
              );
          }
        }),
        (t.prototype.freeze = function (e, t, o) {
          switch ((void 0 === o && (o = "secret"), e)) {
            case "state":
              return this.stateMapFreeze[t]
                ? (this.player.log("".concat(t, "宸查攣瀹�")), !1)
                : ((this.stateMapFreeze[t] = o), !0);
            case "common":
              return this.commonMapFreeze[t]
                ? (this.player.log("".concat(t, "宸查攣瀹�")), !1)
                : ((this.commonMapFreeze[t] = o), !0);
            default:
              return !1;
          }
        }),
        (t.prototype.setEnv = function () {
          var e = this;
          this.player.on(exports.PLAY_EVENT.STATE_CHANGE, this.onStateChange),
            this.player.on(exports.PLAY_EVENT.FIRST_PLAYING, this.onFirstPlay),
            this.player.on(exports.PLAY_EVENT.TIME_UPDATE, this.onTimeChange),
            this.player.on(
              exports.PLAY_EVENT.DURATION_CHANGE,
              this.onDurationChange
            ),
            this.player.on(exports.PLAY_EVENT.ERROR, this.onError),
            this.player.on(
              exports.PLAY_EVENT.SETLEVEL_START,
              this.onSetLevelStart
            ),
            this.player.on(
              exports.PLAY_EVENT.SETLEVEL_OVER,
              this.onSetLevelEnd
            ),
            this.player.on(exports.PLAY_EVENT.RATE_CHANGE, this.onRateChange),
            this.player.on(exports.PLAY_EVENT.RETRY_BACKURL, this.onRetryLoad),
            this.player.on(
              exports.PLAY_EVENT.AUTOPLAY_BLOCKED,
              this.onAutoplayBlocked
            ),
            this.player.on(exports.H5_PLAY_EVENT.AD_PLAYING, this.onAdPlaying),
            this.player.on(exports.H5_PLAY_EVENT.AD_END, this.onAdEnd),
            this.player.on(
              exports.H5_PLAY_EVENT.VIDEO_REQ_INFO_START,
              this.onVideoReqInfoStart
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.VIDEO_REQ_INFO_END,
              this.onVideoReqInfoEnd
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.PLAY_SESSION_START,
              this.onPlaySessionStart
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.PLAY_SESSION_END,
              this.onPlaySessionEnd
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.VIDEO_REQ_INFO_END,
              function (t) {
                var o = t.data;
                if (o.code !== exports.ErrorCode.SUC) {
                  var A = o.data,
                    i = ((null == A ? void 0 : A.error) || {}).code;
                  e.writeState(exports.DATA_STATE.ERROR, {
                    eventId: e.generateEvtId(),
                    type: exports.LOG_TYPE.CORE_EVENT,
                    name: exports.DATA_STATE.ERROR,
                    code: i,
                    ftime: +new Date(),
                  });
                }
              }
            ),
            this.msg.on(exports.PLAY_EVENT_EXT.RETRY_PLAY, this.onRetryPlay),
            this.msg.on(
              exports.PLAY_EVENT_EXT.DEGRADE_CODEC_PLAY,
              this.onCodecDegrade
            );
        }),
        (t.prototype.collectBaseInfo = function () {
          var e = uaTool$1.os,
            t = uaTool$1.mobile;
          this.writeCommon(COMMON_DATA_KEY.mobile, t ? 1 : 0, FreezeKey),
            this.writeCommon(COMMON_DATA_KEY.online, 1, FreezeKey),
            this.writeCommon(
              COMMON_DATA_KEY.resolution,
              ""
                .concat(screen.width, "*")
                .concat(screen.height, "*")
                .concat(window.devicePixelRatio || 1),
              FreezeKey
            ),
            this.writeCommon(
              COMMON_DATA_KEY.ua,
              navigator.userAgent.replace(/,/g, "\\,"),
              FreezeKey
            ),
            this.writeCommon(
              COMMON_DATA_KEY.osver,
              "".concat(e.osName, " ").concat(e.version),
              FreezeKey
            ),
            this.writeCommon(COMMON_DATA_KEY.playertype, 0),
            this.writeCommon(COMMON_DATA_KEY.confid, confIdMap.default),
            this.writeCommon(
              COMMON_DATA_KEY.playercore,
              Object.keys(KernelFactory$1.kernelMap).join(","),
              FreezeKey
            ),
            this.writeCommon(COMMON_DATA_KEY.playerver, VERSION$2),
            this.writeCommon(COMMON_DATA_KEY.speed, 0),
            this.writeCommon(COMMON_DATA_KEY.drm, 0),
            this.writeCommon(COMMON_DATA_KEY.url, location.href, FreezeKey),
            this.writeCommon(
              COMMON_DATA_KEY.topUrl,
              urlTool$1.getTopFrameUrl(),
              FreezeKey
            ),
            this.writeCommon(
              COMMON_DATA_KEY.referrer,
              document.referrer,
              FreezeKey
            ),
            this.writeCommon(COMMON_DATA_KEY.guid, this.getGUID());
        }),
        (t.prototype.collectVideoCapability = function () {
          try {
            var e = { concurrency: navigator.hardwareConcurrency },
              t = {
                av1: +videoTool$1.supportAV1(),
                hevc: +videoTool$1.supportHevc(),
                dolby: +videoTool$1.isDolbyVisionSupported(),
              },
              o = { hls: +videoTool$1.supportVideoFormat().includes("hls") },
              A = videoTool$1.isHDRSupported(),
              i = jsonTool$1
                .safelyStringify({
                  codec: t,
                  format: o,
                  hdr: A,
                  hw: e,
                  wasm: +videoTool$1.isWasmSupported(),
                  mse: +videoTool$1.supportMSE(),
                })
                .replace(/,/g, "\\,");
            this.writeCommon(COMMON_DATA_KEY.videoCapability, i),
              this.log("device capability info: ".concat(i));
          } catch (e) {}
        }),
        (t.prototype.persistUserSetting = function () {
          var e = this,
            o = {},
            A = this.player.config,
            i = A.disableUserSettingCache,
            r = A.type,
            n = function (e) {
              var t;
              return (
                (null === (t = null == i ? void 0 : i.indexOf) || void 0 === t
                  ? void 0
                  : t.call(i, e)) > -1
              );
            };
          t.SETTING_CONFIG.forEach(function (t) {
            var A = t.dsKey,
              i = t.lsKey,
              a = t.oldDsKey,
              s = "".concat(i, "_").concat(r);
            if (!(n(A) || (a && n(a)))) {
              o[A] = s;
              var g = lsTool.getData(s);
              g && A && e.writeCommon(A, g);
            }
          }),
            this.msg.on(exports.PLAY_EVENT_EXT.DATASET_UPDATE, function (e) {
              var t = e.data,
                A = t.newVal,
                i = t.key;
              o[i] && lsTool.setData(o[i], A);
            });
        }),
        (t.prototype.removeUserSetting = function (e) {
          var t = this;
          ("string" == typeof e ? [e] : e).forEach(function (e) {
            t.writeCommon(e, "");
          });
        }),
        (t.pluginName = "dataset"),
        (t.UserSettingKeyPrefix = "__thumbplayer_setting_"),
        (t.SETTING_CONFIG = [
          {
            oldDsKey: COMMON_DATA_KEY.currentDefn,
            dsKey: exports.PersistedUserSettings.definition,
            lsKey: "".concat(t.UserSettingKeyPrefix, "_definition"),
          },
          {
            oldDsKey: COMMON_DATA_KEY.currentSubtitle,
            dsKey: exports.PersistedUserSettings.subtitle,
            lsKey: "".concat(t.UserSettingKeyPrefix, "_subtitle"),
          },
          {
            oldDsKey: COMMON_DATA_KEY.currentAudioTrack,
            dsKey: exports.PersistedUserSettings.audioTrack,
            lsKey: "".concat(t.UserSettingKeyPrefix, "_audioTrack"),
          },
          {
            dsKey: exports.PersistedUserSettings.volume,
            lsKey: "".concat(t.UserSettingKeyPrefix, "_volume"),
          },
          {
            dsKey: exports.PersistedUserSettings.playbackRate,
            lsKey: "".concat(t.UserSettingKeyPrefix, "_playbackRate"),
          },
        ]),
        (t.canUseProxy = void 0 !== window.Proxy),
        t
      );
    })(Plugin);
  function proxyPlayEvent(e, t) {
    var o,
      A =
        (((o = {})[exports.PLAY_EVENT.DURATION_CHANGE] = {
          evt: exports.H5_PLAY_EVENT.VIDEO_DURATION_CHANGE,
          getParam: function (e) {
            return { duration: e.videoInfo.duration };
          },
        }),
        (o[exports.PLAY_EVENT.METADATA_CHANGE] = {
          evt: exports.H5_PLAY_EVENT.VIDEO_METADATA_CHANGE,
          getParam: function (e) {
            return {
              width: e.videoInfo.videoWidth,
              height: e.videoInfo.videoHeight,
            };
          },
        }),
        (o[exports.PLAY_EVENT.VIDEO_BUFFER_CHANGE] = {
          evt: exports.H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS,
          getParam: function () {
            return { bufferRange: e.videoBuffered };
          },
        }),
        (o[exports.PLAY_EVENT.TIME_UPDATE] = {
          evt: exports.H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
          getParam: function (e) {
            return { playtime: e.videoInfo.playtime };
          },
        }),
        (o[exports.PLAY_EVENT.VOLUME_CHANGE] = {
          evt: exports.H5_PLAY_EVENT.VIDEO_VOLUME_CHANGE,
          getParam: function () {
            return { volume: e.volume };
          },
        }),
        (o[exports.PLAY_EVENT.RATE_CHANGE] = {
          evt: exports.H5_PLAY_EVENT.VIDEO_RATE_CHANGE,
          getParam: function (e) {
            return { rate: e.playbackRate };
          },
        }),
        (o[exports.PLAY_EVENT.VIDEO_RESIZE] = {
          evt: exports.H5_PLAY_EVENT.VIDEO_RESIZE,
          getParam: function (e) {
            return {
              videoWidth: e.videoInfo.videoWidth,
              videoHeight: e.videoInfo.videoHeight,
            };
          },
        }),
        (o[exports.PLAY_EVENT.AUTOPLAY_BLOCKED] = {
          evt: exports.H5_PLAY_EVENT.VIDEO_AUTOPLAY_BLOCKED,
          getParam: function () {},
        }),
        (o[exports.PLAY_EVENT.SETLEVEL_OVER] = {
          evt: exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
          getParam: function (e) {
            var t,
              o,
              A,
              i =
                null !==
                  (A =
                    null ===
                      (o =
                        null === (t = e.videoInfo) || void 0 === t
                          ? void 0
                          : t.error) || void 0 === o
                      ? void 0
                      : o.code) && void 0 !== A
                  ? A
                  : exports.ErrorCode.UNKNOWN;
            return { code: e.fail ? i : exports.ErrorCode.SUC };
          },
        }),
        o);
    Object.keys(A).forEach(function (o) {
      t.on(o, function (t) {
        var i = A[o],
          r = i.evt,
          n = i.getParam;
        e.emit(r, n(t.data));
      });
    });
  }
  var adEvents = [
      exports.H5_PLAY_EVENT.AD_REQ_INFO_START,
      exports.H5_PLAY_EVENT.AD_REQ_INFO_END,
      exports.H5_PLAY_EVENT.AD_REQ_ASSETS_START,
      exports.H5_PLAY_EVENT.AD_ASSETS_LOADED,
      exports.H5_PLAY_EVENT.AD_END,
      exports.H5_PLAY_EVENT.AD_PLAYING,
      exports.H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED,
      exports.H5_PLAY_EVENT.AD_PAUSE,
      exports.H5_PLAY_EVENT.AD_RESUME,
      exports.H5_PLAY_EVENT.AD_TIME_UPDATE,
      exports.H5_PLAY_EVENT.AD_VOLUME_CHANGE,
    ],
    FullScreenMode;
  function proxyAdEvent(e) {
    var t = getAdPlugin(e.config.instanceId);
    t &&
      adEvents.forEach(function (o) {
        t.on(o, function (t) {
          var A = t.data;
          e.emit(o, A);
        });
      });
  }
  function requestFakeFullScreen(e, t) {
    void 0 === t && (t = !0),
      domTool$1.insertStyle(styleStr, styleTag),
      e.classList.toggle(FakeFullscreenClass, t);
  }
  function isFakeFullscreen(e) {
    return e.classList.contains(FakeFullscreenClass);
  }
  (exports.FullScreenMode = void 0),
    (FullScreenMode = exports.FullScreenMode || (exports.FullScreenMode = {})),
    (FullScreenMode.FAKE_FULLSCREEN = "fakeFullscreen"),
    (FullScreenMode.FULL_SCREEN = "fullscreen");
  var FakeFullscreenClass = "thumbplayer-fake-fullscreen",
    styleTag = "thumbplayer-fake-fullscreen-style",
    styleStr = "\n.".concat(
      FakeFullscreenClass,
      " {\n  position: fixed !important;\n  top: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  z-index: 9999 !important;\n}\n"
    );
  function requestElFullScreen(e, t) {
    if ((void 0 === t && (t = !0), !(e instanceof HTMLElement)))
      return Promise.reject("requestElFullScreen: container is not an element");
    var o = function (e) {
        var t;
        return null ===
          (t =
            e.requestFullscreen ||
            e.mozRequestFullScreen ||
            e.webkitRequestFullscreen ||
            e.webkitRequestFullScreen ||
            e.msRequestFullscreen) || void 0 === t
          ? void 0
          : t.bind(e);
      },
      A = function (e) {
        var t;
        return null ===
          (t =
            e.cancelFullScreen ||
            e.mozCancelFullScreen ||
            e.webkitCancelFullScreen ||
            e.exitFullscreen ||
            e.webkitExitFullscreen ||
            e.msExitFullscreen) || void 0 === t
          ? void 0
          : t.bind(e);
      },
      i = o(e) || o(document),
      r = A(e) || A(document),
      n = t ? i : r;
    try {
      return Promise.resolve(n());
    } catch (e) {
      return Promise.reject(e);
    }
  }
  function requestVideoFullScreen(e, t) {
    return (
      void 0 === t && (t = !0),
      __awaiter$1(this, void 0, void 0, function () {
        var o, A;
        return __generator$1(this, function (i) {
          if (!(e && e instanceof HTMLVideoElement))
            throw new Error(
              "videoRequestFullScreen: video is not an VideoElement"
            );
          if (
            ((o =
              e.requestFullscreen ||
              e.webkitEnterFullscreen ||
              e.webkitRequestFullScreen),
            !(A = t ? o : e.webkitExitFullscreen))
          )
            throw new Error("Video Fullscreen API is not supported.");
          return [2, A.call(e)];
        });
      })
    );
  }
  function isElFullScreen(e) {
    if (!e) return !1;
    var t = document;
    if (
      !(
        t.fullscreen ||
        t.mozFullScreen ||
        t.webkitIsFullScreen ||
        t.msFullscreenElement
      )
    )
      return !1;
    var o =
      t.fullscreenElement ||
      t.webkitFullscreenElement ||
      t.mozFullScreenElement ||
      t.msFullscreenElement;
    return o === e || o === document;
  }
  function isVideoFullScreen(e) {
    return (
      !!e &&
      (e.webkitDisplayingFullscreen ||
        "fullscreen" === e.webkitPresentationMode) &&
      !isEnterPipInApple(e)
    );
  }
  function isEnterPipInApple(e) {
    return (
      !(!uaTool$1.os.ios && !uaTool$1.browser.safari) &&
      (document.pictureInPictureEnabled ||
        document.pictureInPictureElement === e)
    );
  }
  var VIDEO_FULLSCREEN_TAG = "fullscreen_handler",
    fullscreenEvents = [
      "webkitfullscreenchange",
      "mozfullscreenchange",
      "fullscreenchange",
      "MSFullscreenChange",
    ],
    FullScreenLogics = (function () {
      function e(e, t) {
        var o = this;
        (this.player = e),
          (this.onVideoLoadStart = function () {
            o.player.videoElements.forEach(function (e) {
              e instanceof HTMLVideoElement &&
                !e.dataset[VIDEO_FULLSCREEN_TAG] &&
                o.bindVideoElFullscreenEvt(e, !0);
            });
          }),
          (this.onPlaySessionEnd = function () {
            uaTool$1.mobile &&
              o.fullscreenMode === exports.FullScreenMode.FULL_SCREEN &&
              o.requestFullScreen(!1, exports.FullScreenMode.FULL_SCREEN);
          }),
          (this.fullscreenChangeHandler = function () {
            var e = o.fullscreenMode;
            o.player.emit(exports.PLAY_EVENT.FULLSCREEN_CHANGE, {
              isEnter: e === exports.FullScreenMode.FULL_SCREEN,
              mode: exports.FullScreenMode.FULL_SCREEN,
            });
          }),
          (this.fullscreenChangeDesktop = function (e) {
            var t = e.type,
              A = o.lastTriggeredFullscreenEvt;
            (A && A !== t) ||
              ((o.lastTriggeredFullscreenEvt = t), o.fullscreenChangeHandler());
          }),
          (this.logger = new Logger(e.config.instanceId, "FullscreenLogics")),
          (this.container = t || e.container),
          this.listenFullScreenEvts(!0);
      }
      return (
        Object.defineProperty(e.prototype, "fullscreenMode", {
          get: function () {
            var e = this.container,
              t = this.player.currentVideoElement,
              o = this.player.config.videoElements;
            return isElFullScreen(e) ||
              isVideoFullScreen(t) ||
              (o[0] instanceof HTMLVideoElement && isVideoFullScreen(o[0]))
              ? exports.FullScreenMode.FULL_SCREEN
              : isFakeFullscreen(e)
              ? exports.FullScreenMode.FAKE_FULLSCREEN
              : null;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (e.prototype.requestFullScreen = function (e, t) {
          return (
            void 0 === e && (e = !0),
            __awaiter$1(this, void 0, void 0, function () {
              var o, A, i, r, n, a, s, g;
              return __generator$1(this, function (l) {
                switch (l.label) {
                  case 0:
                    if (
                      ((o = this.container),
                      (A = this.player),
                      (i = A.currentVideoElement),
                      (r = A.config),
                      (n = r.videoElements),
                      (a = this.fullscreenMode),
                      (s = this.getFullScreenMode(t)),
                      e && a)
                    ) {
                      if (a === s) return [2];
                      this.requestFullScreen(!1, a);
                    }
                    if ((!e && !a) || (!e && a !== s)) return [2];
                    l.label = 1;
                  case 1:
                    if (
                      (l.trys.push([1, 7, , 8]),
                      s === exports.FullScreenMode.FAKE_FULLSCREEN)
                    )
                      return (
                        requestFakeFullScreen(o, e),
                        this.player.emit(exports.PLAY_EVENT.FULLSCREEN_CHANGE, {
                          isEnter: e,
                          mode: s,
                        }),
                        [2]
                      );
                    l.label = 2;
                  case 2:
                    return (
                      l.trys.push([2, 4, , 6]), [4, requestElFullScreen(o, e)]
                    );
                  case 3:
                    return l.sent(), [3, 6];
                  case 4:
                    return l.sent(), [4, requestVideoFullScreen(i || n[0], e)];
                  case 5:
                    return l.sent(), [3, 6];
                  case 6:
                    return [3, 8];
                  case 7:
                    throw (
                      ((g = l.sent()),
                      this.logger.error(
                        "@FullscreenLogics.requestFullScreen, isEnter="
                          .concat(e, ", mode=")
                          .concat(s, ", err=")
                          .concat(g)
                      ),
                      g)
                    );
                  case 8:
                    return [2];
                }
              });
            })
          );
        }),
        (e.prototype.destroy = function () {
          this.listenFullScreenEvts(!1);
        }),
        (e.prototype.getFullScreenMode = function (e) {
          return (
            e ||
            (!uaTool$1.mobile || uaTool$1.os.ios
              ? exports.FullScreenMode.FULL_SCREEN
              : exports.FullScreenMode.FAKE_FULLSCREEN)
          );
        }),
        (e.prototype.listenFullScreenEvts = function (e) {
          var t,
            o = this;
          void 0 === e && (e = !0);
          var A = e
              ? document.addEventListener.bind(document)
              : document.removeEventListener.bind(document),
            i = e
              ? this.player.on.bind(this.player)
              : this.player.off.bind(this.player);
          i(exports.H5_PLAY_EVENT.VIDEO_LOAD_START, this.onVideoLoadStart),
            i(exports.H5_PLAY_EVENT.PLAY_SESSION_END, this.onPlaySessionEnd),
            fullscreenEvents.forEach(function (e) {
              A(e, o.fullscreenChangeDesktop);
            }),
            e ||
              null === (t = this.player.videoElements) ||
              void 0 === t ||
              t.forEach(function (e) {
                e instanceof HTMLVideoElement &&
                  o.bindVideoElFullscreenEvt(e, !1);
              });
        }),
        (e.prototype.bindVideoElFullscreenEvt = function (e, t) {
          var o = t
            ? e.addEventListener.bind(e)
            : e.removeEventListener.bind(e);
          o("webkitendfullscreen", this.fullscreenChangeHandler),
            o("webkitbeginfullscreen", this.fullscreenChangeHandler),
            t
              ? (e.dataset[VIDEO_FULLSCREEN_TAG] = String(!0))
              : delete e.dataset[VIDEO_FULLSCREEN_TAG];
        }),
        e
      );
    })(),
    getinfoModuleMap = {},
    ReportSource;
  function createGetinfoModule(e, t, o) {
    var A = t.instanceId,
      i = getinfoModuleMap[A];
    return i || ((i = new e(t, o)), (getinfoModuleMap[A] = i)), i;
  }
  function destroyGetinfoModule(e) {
    var t;
    null === (t = getinfoModuleMap[e]) || void 0 === t || t.destroy(),
      delete getinfoModuleMap[e];
  }
  function getGetinfoModule(e) {
    return getinfoModuleMap[e];
  }
  function doGetinfo(e, t, o) {
    return __awaiter$1(this, void 0, void 0, function () {
      var A, i, r, n, a, s, g, l;
      return __generator$1(this, function (E) {
        switch (E.label) {
          case 0:
            return (A = getinfoModuleMap[e]) && t && t.vid
              ? ((r = (i = o || {}).adType),
                (n = i.emitGetinfoEvts),
                (a = t.vid),
                (s = t.adParam),
                (g = t.videoReqInfoParam),
                (l = t.flowid),
                [
                  4,
                  A.request(a, {
                    emitGetinfoEvts: n,
                    adParams: r
                      ? getAdReqParams(e, __assign$1({ adType: r, vid: a }, s))
                      : void 0,
                    vinfoParams: __assign$1(__assign$1({}, g), { flowid: l }),
                  }),
                ])
              : [2];
          case 1:
            return [2, E.sent()];
        }
      });
    });
  }
  function hasGetinfoModule(e) {
    return e in getinfoModuleMap;
  }
  !(function (e) {
    e.WHITE_LIST = "white";
  })(ReportSource || (ReportSource = {}));
  var DEFAULT_REPORT_OPTIONS = {
      downloadOnFailed: !1,
      reportSource: "API_CALL",
      onlyCurrent: !0,
    },
    BridgeMessageName;
  !(function (e) {
    (e.STORAGE_INIT_FAILED = "storageInitFailed"),
      (e.STORAGE_READY = "storageReady"),
      (e.REQUEST_STORE_LOG = "requestStoreLog"),
      (e.STORE_LOG_SUCCESS = "storeLogSuccess"),
      (e.STORE_LOG_FAILED = "storeLogFailed"),
      (e.REQUEST_REPORT_LOG = "requestReportLog"),
      (e.REPORT_LOG_SUCCESS = "reportLogSuccess"),
      (e.REPORT_LOG_FAILED = "reportLogFailed"),
      (e.REPORT_PROGRESS = "reportProgress"),
      (e.REQUEST_DOWNLOAD_LOG = "requestDownloadLog");
  })(BridgeMessageName || (BridgeMessageName = {}));
  var REMOTE_STORAGE_CLASS_NAME = "thumbplayer-remote-storage-bridge",
    DEFAULT_IFRAME_TIMEOUT = 1e4,
    REPORT_TIMEOUT = 3e4,
    MessageBridge = (function () {
      function e(e, t) {
        var o = this;
        (this.sender = e),
          (this.receiver = t),
          (this.callbackMap = {}),
          (this.hasDestroy = !1),
          (this.onReceiverMessage = function (e) {
            o.receiverMessageHandler(e);
          }),
          this.sender.addEventListener("message", this.onReceiverMessage);
      }
      return (
        (e.prototype.postMessage = function (e) {
          if (this.hasDestroy)
            throw new Error("Cannot exec postMessage after destroy");
          this.receiver.postMessage(e, "*");
        }),
        (e.prototype.on = function (e, t) {
          this.hasDestroy ||
            (this.callbackMap[e] || (this.callbackMap[e] = []),
            this.callbackMap[e].push(t));
        }),
        (e.prototype.off = function (e, t) {
          if (!this.hasDestroy) {
            var o = this.callbackMap[e];
            if (null == o ? void 0 : o.length) {
              var A = o.indexOf(t);
              -1 !== A && o.splice(A, 1);
            }
          }
        }),
        (e.prototype.destroy = function () {
          var e;
          (this.hasDestroy = !0),
            null === (e = this.sender) ||
              void 0 === e ||
              e.removeEventListener("message", this.onReceiverMessage),
            (this.sender = null),
            (this.receiver = null),
            (this.callbackMap = null);
        }),
        (e.prototype.receiverMessageHandler = function (e) {
          var t,
            o = this;
          if (this.isBridgeMessage(e.data) && !this.hasDestroy) {
            var A = e.data;
            null === (t = this.callbackMap[A.name]) ||
              void 0 === t ||
              t.forEach(function (e) {
                e(A, o.postMessage.bind(o));
              });
          }
        }),
        (e.prototype.isBridgeMessage = function (e) {
          return (
            "object" == typeof e &&
            "string" == typeof (null == e ? void 0 : e.name) &&
            "string" == typeof (null == e ? void 0 : e.instanceId)
          );
        }),
        e
      );
    })(),
    RemoteStorageBridge = (function (e) {
      function t(o, A, i) {
        void 0 === i && (i = DEFAULT_IFRAME_TIMEOUT);
        var r = e.call(this, self, t.getIframe(o, i).contentWindow) || this;
        return (r.instanceId = A), (r.timeout = i), (t.instanceCount += 1), r;
      }
      return (
        __extends$1(t, e),
        (t.getIframe = function (e, o) {
          if ((void 0 === o && (o = DEFAULT_IFRAME_TIMEOUT), t.iframeEl))
            return t.iframeEl;
          var A = document.createElement("iframe");
          return (
            (A.src = e),
            document.body.append(A),
            (A.style.display = "none"),
            A.classList.add(REMOTE_STORAGE_CLASS_NAME),
            (t.iframeEl = A),
            (t.rejectTimeout = window.setTimeout(function () {
              t.storageDefer.reject(new Error("IFrame wait timeout"));
            }, o)),
            A
          );
        }),
        (t.prototype.storeLogs = function (e) {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (o) {
              switch (o.label) {
                case 0:
                  return [4, t.storageDefer.promise];
                case 1:
                  return (
                    o.sent(),
                    [
                      4,
                      this.postMessagePromise({
                        message: {
                          name: BridgeMessageName.REQUEST_STORE_LOG,
                          instanceId: this.instanceId,
                          data: e,
                        },
                        resolveMessageName: BridgeMessageName.STORE_LOG_SUCCESS,
                        rejectMessageName: BridgeMessageName.STORE_LOG_FAILED,
                      }),
                    ]
                  );
                case 2:
                  return o.sent(), [2];
              }
            });
          });
        }),
        (t.prototype.report = function (e, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (A) {
              switch (A.label) {
                case 0:
                  return [4, t.storageDefer.promise];
                case 1:
                  return (
                    A.sent(),
                    [
                      4,
                      this.postMessagePromise({
                        message: {
                          name: BridgeMessageName.REQUEST_REPORT_LOG,
                          instanceId: this.instanceId,
                          data: e,
                        },
                        resolveMessageName:
                          BridgeMessageName.REPORT_LOG_SUCCESS,
                        rejectMessageName: BridgeMessageName.REPORT_LOG_FAILED,
                        progressMessageName: BridgeMessageName.REPORT_PROGRESS,
                        onProgress: o,
                        timeout: REPORT_TIMEOUT,
                      }),
                    ]
                  );
                case 2:
                  return A.sent(), [2];
              }
            });
          });
        }),
        (t.prototype.downloadLogs = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, t.storageDefer.promise];
                case 1:
                  return (
                    e.sent(),
                    this.postMessage({
                      instanceId: this.instanceId,
                      name: BridgeMessageName.REQUEST_DOWNLOAD_LOG,
                    }),
                    [2]
                  );
              }
            });
          });
        }),
        (t.prototype.postMessagePromise = function (e) {
          var t = this,
            o = e.message,
            A = e.resolveMessageName,
            i = e.rejectMessageName,
            r = e.progressMessageName,
            n = e.timeout,
            a = void 0 === n ? this.timeout : n,
            s = e.onProgress;
          return new Promise(function (e, n) {
            var g = o.instanceId,
              l = function () {
                return setTimeout(function () {
                  n(
                    new Error(
                      "PostMessage response timeout: "
                        .concat(o.name, " / ")
                        .concat(o.instanceId)
                    )
                  ),
                    c(!1);
                }, a);
              },
              E = l(),
              c = function (e) {
                void 0 === e && (e = !1);
                var o = e ? t.on.bind(t) : t.off.bind(t);
                o(r, u), o(i, p), o(A, d), e || clearTimeout(E);
              },
              u = function (e) {
                clearTimeout(E), (E = l()), null == s || s(e.data.progress);
              },
              p = function (e) {
                g === e.instanceId && (n(e.data), c(!1));
              },
              d = function (t) {
                g === t.instanceId && (e(t.data), c(!1));
              };
            c(!0), t.postMessage(o);
          });
        }),
        (t.prototype.destroy = function () {
          var o;
          (t.instanceCount -= 1),
            t.instanceCount <= 0 &&
              (clearTimeout(t.rejectTimeout),
              (t.rejectTimeout = null),
              null === (o = t.iframeEl) || void 0 === o || o.remove(),
              (t.iframeEl = null),
              (t.instanceCount = 0),
              (t.storageDefer = new SimpleDefer$1())),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.receiverMessageHandler = function (o) {
          if (this.isBridgeMessage(o.data))
            return o.data.name === BridgeMessageName.STORAGE_READY
              ? (t.storageDefer.resolve(), void clearTimeout(t.rejectTimeout))
              : void e.prototype.receiverMessageHandler.call(this, o);
        }),
        (t.storageDefer = new SimpleDefer$1()),
        (t.instanceCount = 0),
        t
      );
    })(MessageBridge),
    PageWatcher = (function (e) {
      function t() {
        var o = e.call(this) || this;
        return (
          (o.emitPageLeave = function () {
            "hidden" === document.visibilityState &&
              (Date.now() - o.pageLeaveTimeStamp <= t.THROTTLE_GAP ||
                ((o.pageLeaveTimeStamp = Date.now()),
                o.emit(PageWatcherEvent.PageLeave)));
          }),
          (o.emitPageUnload = function () {
            Date.now() - o.pageUnloadTimeStamp <= t.THROTTLE_GAP ||
              ((o.pageUnloadTimeStamp = Date.now()),
              o.emit(PageWatcherEvent.UNLOAD));
          }),
          o.setPageLeave(),
          o.setPageUnload(),
          o
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.setPageLeave = function () {
          window.addEventListener("pagehide", this.emitPageLeave),
            document.addEventListener("visibilitychange", this.emitPageLeave);
        }),
        (t.prototype.setPageUnload = function () {
          window.addEventListener("beforeunload", this.emitPageUnload),
            window.addEventListener("unload", this.emitPageUnload);
        }),
        (t.THROTTLE_GAP = 10),
        t
      );
    })(s$1$1),
    PageWatcherEvent;
  !(function (e) {
    (e.PageLeave = "pageLeave"), (e.UNLOAD = "unload");
  })(PageWatcherEvent || (PageWatcherEvent = {}));
  var singleton = new PageWatcher(),
    PageWatcher$1 = { instance: singleton, PageWatcherEvent: PageWatcherEvent },
    WHITE_LIST_URL =
      "https://v.qq.com/cache/wuji/object?appid=tenvideo_offline_log&schemaid=whiteListV2&schemakey=97c0ff59f25543e282072b75e4c287f7&otype=jsonp",
    cbIndex = 0;
  function fetchWhiteList(e) {
    var t = encodeURIComponent('platform=["'.concat(e, '"]&enable=true')),
      o = "".concat(WHITE_LIST_URL, "&filter=").concat(t);
    return (
      (cbIndex += 1),
      netTool.jsonp(o, { name: "offline_log" + (cbIndex % 200), timeout: 3e3 })
    );
  }
  function validateWhiteListItem(e, t) {
    var o = e.condEnc;
    return Object.keys(o).every(function (e) {
      var A = o[e];
      return Array.isArray(A)
        ? A.some(function (o) {
            return validateValue(o, t[e]);
          })
        : validateValue(A, t[e]);
    });
  }
  function isRegCondition(e) {
    return "object" == typeof e && "regStr" in e;
  }
  function validateValue(e, t) {
    try {
      if (isRegCondition(e)) {
        var o = e.flags,
          A = void 0 === o ? "i" : o,
          i = e.regStr;
        return new RegExp(i, A).test(String(t));
      }
      return "string" == typeof e && "string" == typeof t
        ? e === sha256.exports.sha256(t)
        : e === t;
    } catch (e) {
      return !1;
    }
  }
  var OfflineLogPlugin = (function (e) {
      function t(o, A, i) {
        var r = e.call(this, o, A, i) || this;
        return (
          (r.pageWatcher = PageWatcher$1.instance),
          (r.logInfoChange = {}),
          (r.isDestroy = !1),
          (r.onPageLeave = function () {
            r.storeLogs();
          }),
          (r.storeLogs = function (e) {
            return __awaiter$1(r, void 0, void 0, function () {
              var t, o, A, i, r;
              return __generator$1(this, function (n) {
                switch (n.label) {
                  case 0:
                    if (!(t = this.instanceId)) return [2];
                    if (
                      ((o = getLogCache(t)),
                      (A = { logs: o, info: this.logInfoChange, ext: e }),
                      (i =
                        e ||
                        A.logs.length ||
                        Boolean(Object.keys(this.logInfoChange).length)),
                      clearLogCache(t),
                      (this.logInfoChange = {}),
                      !i)
                    )
                      return [2];
                    n.label = 1;
                  case 1:
                    return (
                      n.trys.push([1, 3, , 4]),
                      [4, this.remoteStorage.storeLogs(A)]
                    );
                  case 2:
                    return n.sent(), [3, 4];
                  case 3:
                    return (
                      (r = n.sent()),
                      this.logger.error(
                        "Error occur when store offlineLog: ".concat(r)
                      ),
                      [3, 4]
                    );
                  case 4:
                    return [2];
                }
              });
            });
          }),
          (r.onPlayerError = function (e) {
            var t, o, A;
            (r.logInfoChange.code =
              null ===
                (A =
                  null ===
                    (o =
                      null === (t = e.data) || void 0 === t
                        ? void 0
                        : t.videoInfo) || void 0 === o
                    ? void 0
                    : o.error) || void 0 === A
                ? void 0
                : A.code),
              r.storeLogs();
          }),
          (r.config = __assign$1(
            __assign$1(__assign$1({}, DEFAULT_CONFIG$1), A || {}),
            r.player.config.offlineConfig
          )),
          (r.logger = new Logger(r.instanceId, t.pluginName)),
          (r.remoteStorage = new RemoteStorageBridge(
            r.config.iframePath || RECORDER_DEPLOY_URL,
            r.instanceId
          )),
          RemoteStorageBridge.storageDefer.promise
            .then(function () {
              r.isDestroy ||
                (r.downloadOnQuery(),
                r.setPollLogger(),
                r.setPageWatcher(),
                r.setPlayerEvt());
            })
            .catch(function (e) {
              r.logger.error("Error occur when init DB: ".concat(e));
            }),
          r.logEnvInfo(),
          r.checkWhiteList(),
          r
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t, "isEnvSupport", {
          get: function () {
            return "function" == typeof window.Proxy;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.destroy = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (t) {
              switch (t.label) {
                case 0:
                  return (
                    t.trys.push([0, 2, 3, 4]),
                    (this.isDestroy = !0),
                    this.setPollLogger(!1),
                    this.setPageWatcher(!1),
                    this.setPlayerEvt(!1),
                    [4, this.storeLogs({ clearContentCache: !0 })]
                  );
                case 1:
                case 2:
                  return t.sent(), [3, 4];
                case 3:
                  return (
                    this.remoteStorage.destroy(),
                    e.prototype.destroy.call(this),
                    [7]
                  );
                case 4:
                  return [2];
              }
            });
          });
        }),
        (t.prototype.report = function (e, t, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (A) {
              switch (A.label) {
                case 0:
                  if (!e) return [2];
                  A.label = 1;
                case 1:
                  return (
                    A.trys.push([1, 3, , 4]),
                    [
                      4,
                      this.remoteStorage.report(
                        {
                          downloadOnFailed: e,
                          reportSource: t,
                          onlyCurrent: !1,
                        },
                        o
                      ),
                    ]
                  );
                case 2:
                  return A.sent(), [2, { status: !0, msg: "" }];
                case 3:
                  return [2, { status: !1, msg: A.sent().message }];
                case 4:
                  return [2];
              }
            });
          });
        }),
        (t.prototype.reportLogs = function (e, t) {
          return this.remoteStorage.report(
            __assign$1(__assign$1({}, DEFAULT_REPORT_OPTIONS), e),
            t
          );
        }),
        (t.prototype.downloadLogs = function () {
          return this.remoteStorage.downloadLogs();
        }),
        (t.prototype.logEnvInfo = function () {
          try {
            this.logger.log("URL: ".concat(location.href)),
              this.logger.log("TOP URL: ".concat(urlTool$1.getTopFrameUrl())),
              this.logger.log(
                "Kernel List: ".concat(
                  Object.keys(KernelFactory$1.kernelMap).join(",")
                )
              ),
              this.logger.log(
                "PlayItem: ".concat(
                  jsonTool$1.safelyStringify(this.player.currentPlayItem)
                )
              );
          } catch (e) {}
        }),
        (t.prototype.downloadOnQuery = function () {
          var e = location.search.includes(DOWNLOAD_LOGS_QUERY);
          !t.hasDownloadOnInit &&
            e &&
            (this.downloadLogs(), (t.hasDownloadOnInit = !0));
        }),
        (t.prototype.checkWhiteList = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            var e, o, A;
            return __generator$1(this, function (i) {
              switch (i.label) {
                case 0:
                  if (((e = this.config.platform), t.whiteListLoadDefer))
                    return [2];
                  (t.whiteListLoadDefer = new SimpleDefer$1()), (i.label = 1);
                case 1:
                  return i.trys.push([1, 3, , 4]), [4, fetchWhiteList(e)];
                case 2:
                  return (
                    (o = i.sent().data),
                    (t.whiteList = o),
                    t.whiteListLoadDefer.resolve(),
                    [3, 4]
                  );
                case 3:
                  return (
                    (A = i.sent()),
                    t.whiteListLoadDefer.reject(),
                    this.logger.error(
                      "@OfflineLogPlugin.checkWhiteList(), err=".concat(A)
                    ),
                    [3, 4]
                  );
                case 4:
                  return [2];
              }
            });
          });
        }),
        (t.prototype.setPollLogger = function (e) {
          void 0 === e && (e = !0);
          var t = this.config.pollTime,
            o = void 0 === t ? 3e3 : t;
          clearInterval(this.pollTimer),
            e && (this.pollTimer = window.setInterval(this.storeLogs, o));
        }),
        (t.prototype.setPageWatcher = function (e) {
          void 0 === e && (e = !0);
          var t = this.pageWatcher,
            o = e ? t.on.bind(t) : t.off.bind(t);
          o(PageWatcher$1.PageWatcherEvent.PageLeave, this.onPageLeave),
            o(PageWatcher$1.PageWatcherEvent.UNLOAD, this.onPageLeave);
        }),
        (t.prototype.setPlayerEvt = function (e) {
          void 0 === e && (e = !0),
            (e
              ? this.player.on.bind(this.player)
              : this.player.off.bind(this.player))(
              exports.PLAY_EVENT.ERROR,
              this.onPlayerError
            );
        }),
        (t.prototype.hookVideoReqInfoEnd = function (e) {
          var t,
            o,
            A =
              null ===
                (o =
                  null === (t = e.data) || void 0 === t ? void 0 : t.error) ||
              void 0 === o
                ? void 0
                : o.code;
          A && (this.logInfoChange.code = A),
            (this.logInfoChange.videoName =
              this.player.dataset.commonMap.videoName),
            this.storeLogs();
        }),
        (t.prototype.hookPlaySessionStart = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (e) {
              switch (e.label) {
                case 0:
                  return (
                    (this.logInfoChange = this.collectLogInfo()),
                    this.logEnvInfo(),
                    [4, this.storeLogs()]
                  );
                case 1:
                  return e.sent(), this.triggerReportIfHit(0), [2];
              }
            });
          });
        }),
        (t.prototype.hookPlaySessionEnd = function (e) {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (t) {
              switch (t.label) {
                case 0:
                  return (
                    (this.logInfoChange.code = e.code),
                    [4, this.storeLogs({ clearInfoCache: !0 })]
                  );
                case 1:
                  return t.sent(), this.triggerReportIfHit(1, e.code), [2];
              }
            });
          });
        }),
        (t.prototype.triggerReportIfHit = function (e, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            var A, i, r;
            return __generator$1(this, function (n) {
              switch (n.label) {
                case 0:
                  if (uaTool$1.spider || !t.whiteListLoadDefer) return [2];
                  n.label = 1;
                case 1:
                  return (
                    n.trys.push([1, 3, , 4]), [4, t.whiteListLoadDefer.promise]
                  );
                case 2:
                  return n.sent(), this.isDestroy ? [2] : [3, 4];
                case 3:
                  return (
                    (A = n.sent()),
                    this.logger.error(
                      "@OfflineLogPlugin.triggerReportIfHitCustom(), err=".concat(
                        A
                      )
                    ),
                    [2]
                  );
                case 4:
                  return (
                    (i = this.player.dataset.commonMap),
                    (r = t.whiteList
                      .filter(function (t) {
                        return t.hook === e;
                      })
                      .find(function (e) {
                        return validateWhiteListItem(
                          e,
                          __assign$1(__assign$1({}, i), { code: o })
                        );
                      })) && Math.random() <= r.rate
                      ? [
                          2,
                          this.remoteStorage.report({
                            onlyCurrent: 0 === r.action,
                            downloadOnFailed: !1,
                            reportSource: r.reason || ReportSource.WHITE_LIST,
                          }),
                        ]
                      : [2]
                  );
              }
            });
          });
        }),
        (t.prototype.collectLogInfo = function () {
          var e = this.player.dataset.commonMap,
            t = e.guid,
            o = e.drm,
            A = e.videoName,
            i = e.vid,
            r = e.hc_vuserid,
            n = e.flowid,
            a = e.platform;
          return {
            code: "",
            drm: Boolean(o),
            startTime: Date.now(),
            endTime: Date.now(),
            guid: t,
            ua: navigator.userAgent,
            url: location.href,
            videoName: A,
            vid: i,
            platform: a,
            vuid: r,
            instanceId: this.instanceId,
            id: n,
          };
        }),
        Object.defineProperty(t.prototype, "instanceId", {
          get: function () {
            return this.player.config.instanceId;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.pluginName = "offlineLog"),
        (t.hasDownloadOnInit = !1),
        (t.whiteList = []),
        t
      );
    })(Plugin),
    DEFAULT_CONFIG$1 = { platform: "1", disable: !1, pollTime: 3e3 },
    RECORDER_DEPLOY_URL =
      "https://v.qq.com/thumbplayer-offline-log.html?max_age=3600",
    DOWNLOAD_LOGS_QUERY = "thumbplayer_download_logs=1",
    DEFAULT_PRIORITY = 0,
    DEFAULT_END_STATE = exports.END_STATE.NORMAL,
    DEFAULT_PLAYTIME_BOUNDARY = {
      startTime: 0,
      startPriority: DEFAULT_PRIORITY,
      endTime: 1 / 0,
      endPriority: DEFAULT_PRIORITY,
      endState: exports.END_STATE.NORMAL,
    },
    ruleValidator = {
      emptyConfigCheck: function (e) {
        if (!e)
          return compile(i18nConfig.h5player.ERROR_PLAY_LIMIT_EMPTY_CONFIG);
      },
      emptyStartAndEndCheck: function (e) {
        var t = e.startPoint,
          o = e.endPoint;
        if (!t && !o)
          return compile(
            i18nConfig.h5player.ERROR_PLAY_LIMIT_POINTS_BOTH_EMPTY
          );
      },
      startBelowZero: function (e) {
        var t = e.startPoint;
        if (t && t.value < 0)
          return compile(
            i18nConfig.h5player.ERROR_PLAY_LIMIT_START_TIME_BELOW_ZERO
          );
      },
      endBelowStart: function (e) {
        var t = e.startPoint,
          o = e.endPoint;
        if (t && o && t.value >= o.value)
          return compile(
            i18nConfig.h5player.ERROR_PLAY_LIMIT_END_TIME_BELOW_START_TIME
          );
      },
    },
    CONFIG_ID_START = 0,
    PlaytimeLimiterPlugin = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.configRules = ruleValidator),
          (t.nextId = CONFIG_ID_START),
          (t.limitConfigMap = {}),
          (t.isCanplayEmitted = !1),
          (t.canplaySeekPos = null),
          (t.hookVideoTimeupdate = function (e) {
            if (!(e.playtime < t.range.endTime)) {
              if (!t.isUsingNativeLoop)
                return (
                  t.player.corePlayer.stop(t.range.endState),
                  s$1$1.STOP_IMMEDIATE_PROPAGATION
                );
              t.player.seek(t.range.startTime);
            }
          }),
          (t.hookPlaySessionEnd = function () {
            (t.isCanplayEmitted = null), (t.canplaySeekPos = null);
          }),
          t
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "isUsingNativeLoop", {
          get: function () {
            var e = this.player.config,
              t = e.loop,
              o = e.loopMode;
            return t && o === exports.VideoLoopMode.native;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "range", {
          get: function () {
            return (
              this.limitRange ||
                (this.limitRange = this.mergePlaytimeLimitConfigs(
                  Object.values(this.limitConfigMap)
                )),
              __assign$1({}, this.limitRange)
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.addLimitConfig = function (e) {
          var t;
          if (!this.validatePlayTimeConfig(e)) return null;
          var o = null !== (t = e.id) && void 0 !== t ? t : this.generateID();
          return (
            (this.limitConfigMap[o] = __assign$1(__assign$1({}, e), {
              vidOrUrl: this.player.vid || this.player.url,
            })),
            this.onConfigChange(),
            o
          );
        }),
        (t.prototype.deleteLimitConfig = function (e) {
          delete this.limitConfigMap[e], this.onConfigChange();
        }),
        (t.prototype.clearAllConfig = function (e) {
          var t = this;
          Object.entries(this.limitConfigMap).forEach(function (o) {
            var A = o[0];
            o[1].vidOrUrl !== e && delete t.limitConfigMap[A];
          }),
            (this.limitRange = null);
        }),
        (t.prototype.getLimitConfig = function (e) {
          return this.limitConfigMap[e];
        }),
        (t.prototype.setLimitConfig = function (e, t) {
          return (
            !(!this.getLimitConfig(e) || !this.validatePlayTimeConfig(t)) &&
            ((this.limitConfigMap[e] = t), this.onConfigChange(), !0)
          );
        }),
        (t.prototype.generateID = function () {
          return this.nextId++;
        }),
        (t.prototype.validatePlayTimeConfig = function (e) {
          var t = this;
          return Object.values(this.configRules).every(function (o) {
            var A = o(e);
            return !A || (t.player.log(A), !1);
          });
        }),
        (t.prototype.mergePlaytimeLimitConfigs = function (e) {
          var t = this,
            o = __assign$1({}, DEFAULT_PLAYTIME_BOUNDARY);
          return (
            e.forEach(function (e) {
              var A = e.startPoint,
                i = e.endPoint;
              (o = t.mergeStartPoint(o, A)), (o = t.mergeEndPoint(o, i));
            }),
            o
          );
        }),
        (t.prototype.mergeStartPoint = function (e, t) {
          return this.shouldUpdateStartTime(e, t)
            ? __assign$1(__assign$1({}, e), {
                startTime: t.value,
                startPriority: t.priority || DEFAULT_PRIORITY,
              })
            : e;
        }),
        (t.prototype.shouldUpdateStartTime = function (e, t) {
          if (!t) return !1;
          var o = t.value,
            A = t.priority,
            i = void 0 === A ? DEFAULT_PRIORITY : A,
            r = e.startTime,
            n = e.startPriority;
          return o < e.endTime && (i > n || (i === n && o > r));
        }),
        (t.prototype.mergeEndPoint = function (e, t) {
          return this.shouldUpdateEndTime(e, t)
            ? __assign$1(__assign$1({}, e), {
                endTime: t.value,
                endPriority: t.priority || DEFAULT_PRIORITY,
                endState: t.endState || DEFAULT_END_STATE,
              })
            : e;
        }),
        (t.prototype.shouldUpdateEndTime = function (e, t) {
          if (!t) return !1;
          var o = t.value,
            A = t.priority,
            i = void 0 === A ? DEFAULT_PRIORITY : A,
            r = e.startTime,
            n = e.endPriority,
            a = e.endTime;
          return o > r && (i > n || (i === n && o < a));
        }),
        (t.prototype.onConfigChange = function () {
          if (
            ((this.limitRange = this.mergePlaytimeLimitConfigs(
              Object.values(this.limitConfigMap)
            )),
            !(this.player.playtime >= this.range.startTime))
          )
            return (
              this.seekPlayer(this.range.startTime),
              __assign$1({}, this.limitRange)
            );
        }),
        (t.prototype.hookVideoCanplay = function () {
          !this.isCanplayEmitted &&
            this.canplaySeekPos &&
            (this.player.seek(this.canplaySeekPos),
            (this.canplaySeekPos = null)),
            (this.isCanplayEmitted = !0);
        }),
        (t.prototype.seekPlayer = function (e) {
          this.isCanplayEmitted
            ? this.player.seek(this.canplaySeekPos)
            : (this.canplaySeekPos = e);
        }),
        (t.pluginName = "playtimeLimiter"),
        t
      );
    })(Plugin),
    report = function (e) {
      var t = e.data,
        o = void 0 === t ? {} : t,
        A = e.url,
        i = void 0 === A ? "" : A,
        r = e.forceImage,
        n = void 0 !== r && r,
        a = constructPayload(o);
      !n && a.length > MAX_LENGTH_OF_PAYLOAD
        ? netTool.xhr({
            method: "POST",
            url: i,
            withCredentials: !0,
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: a,
          })
        : (new Image().src = "".concat(i, "&").concat(a));
    },
    constructPayload = function (e) {
      void 0 === e && (e = {});
      var t = Object.keys(e).reduce(
        function (t, o) {
          var A;
          return (
            (t[o] = encodeURIComponent(
              null !== (A = e[o]) && void 0 !== A ? A : ""
            )),
            t
          );
        },
        { _dc: Math.random() }
      );
      return urlTool$1.object2string(t, "&");
    },
    MAX_LENGTH_OF_PAYLOAD = 2048,
    BaseReporter = (function (e) {
      function t(t, o, A) {
        var i = e.call(this, t, o, A) || this;
        return (
          (i.RELEASE_DELAY = 3e5),
          (i.reporter = report),
          (i.reportedEvt = {}),
          (i.FLOW_DATA_KEY = ""),
          (i.REPORT_URL = ""),
          (i.REPORT_KEY = ""),
          (i.config = o),
          i
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.saveToLS = function (e, t) {
          var o = this.getPrevData();
          (o[e] = { data: t, ts: Date.now() }),
            lsTool.setData(this.FLOW_DATA_KEY, JSON.stringify(o));
        }),
        (t.prototype.removeFromLS = function (e) {
          var t = this.getPrevData();
          delete t[e], lsTool.setData(this.FLOW_DATA_KEY, JSON.stringify(t));
        }),
        (t.prototype.reportPrev = function () {
          var e = this,
            t = this.getPrevData();
          Object.keys(t).forEach(function (o) {
            t[o].ts + e.RELEASE_DELAY < Date.now() &&
              (e.report(t[o].data), delete t[o]);
          }),
            lsTool.setData(this.FLOW_DATA_KEY, JSON.stringify(t));
        }),
        (t.prototype.report = function (e) {
          var t;
          if ((void 0 === e && (e = {}), !uaTool$1.spider)) {
            var o = __assign$1(__assign$1({}, this.reportHeader), e);
            if (
              (this.reporter({
                data: o,
                url: this.REPORT_URL,
                key: this.REPORT_KEY,
                forceImage: this.config.forceImage,
              }),
              "function" ==
                typeof (null === (t = this.config) || void 0 === t
                  ? void 0
                  : t.onAfterReport))
            )
              try {
                this.config.onAfterReport(o);
              } catch (e) {}
          }
        }),
        (t.prototype.handlePageHide = function (e) {
          if (
            (void 0 === e && (e = {}),
            !uaTool$1.spider && this.reporterForPageHide)
          ) {
            var t = __assign$1(__assign$1({}, this.reportHeader), e);
            this.reporterForPageHide({
              data: t,
              url: this.REPORT_URL,
              key: this.REPORT_KEY,
            });
          }
        }),
        (t.prototype.getPrevData = function () {
          var e,
            t = lsTool.getData(this.FLOW_DATA_KEY) || "{}";
          try {
            e = JSON.parse(t);
          } catch (t) {
            e = {};
          }
          return e;
        }),
        (t.prototype.getKvWithDefault = function (e, t) {
          return (0, this.player.getCommonKv)(e) || t;
        }),
        t
      );
    })(Plugin),
    VodQaReportBeaconAppKey = "0WEB0QEJW44KW5A5",
    LiveQaReportBeaconAppKey = "0WEB0CN7W9446C2I",
    VodQaReportCacheKey = "__thumbplayer_vod_qa_report__",
    BeaconSDKPath = "https://beacon.cdn.qq.com/sdk/4.5.16/beacon_web.min.js",
    RequestMaxRetry = 3,
    BeaconRequest = (function () {
      function e() {}
      return (
        (e.loadBeaconSDK = function () {
          var t = this;
          return "function" == typeof window.BeaconAction
            ? Promise.resolve()
            : (e.sdkLoadingDefer ||
                (e.sdkLoadingDefer = new Promise(function (e, o) {
                  return __awaiter$1(t, void 0, void 0, function () {
                    var t, A, i;
                    return __generator$1(this, function (r) {
                      switch (r.label) {
                        case 0:
                          (A = 0), (r.label = 1);
                        case 1:
                          if (!(A < RequestMaxRetry)) return [3, 6];
                          r.label = 2;
                        case 2:
                          return (
                            r.trys.push([2, 4, , 5]),
                            [4, domTool$1.loadScript(BeaconSDKPath)]
                          );
                        case 3:
                          return r.sent(), e(), [3, 6];
                        case 4:
                          return (i = r.sent()), (t = i), [3, 5];
                        case 5:
                          return A++, [3, 1];
                        case 6:
                          return o(t), [2];
                      }
                    });
                  });
                })),
              e.sdkLoadingDefer);
        }),
        (e.flushQueue = function (t) {
          e.queues[t] &&
            e.instances[t] &&
            (e.queues[t].forEach(function (t) {
              e.report(t);
            }),
            (e.queues[t] = []));
        }),
        (e.clear = function (t) {
          e.queues[t] = [];
        }),
        (e.report = function (t) {
          var o = t.data,
            A = t.key,
            i = e.instances[A],
            r = (o || {}).stepname;
          if (!i)
            return (
              e.queues[A].length >= MAX_QUEUE_SIZE && e.clear(A),
              void e.queues[A].push(t)
            );
          i.onDirectUserAction(r, o);
        }),
        (e.reportWhenPageHide = function (t) {
          var o = t.data,
            A = t.key,
            i = e.instances[A],
            r = (o || {}).stepname;
          i &&
            ("function" != typeof i.onSendBeacon
              ? i.onDirectUserAction(r, o)
              : i.onSendBeacon(r, o));
        }),
        (e.register = function (t, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            var A, i, r, n, a;
            return __generator$1(this, function (s) {
              switch (s.label) {
                case 0:
                  if (
                    ((A = t),
                    (i = !1),
                    "object" == typeof t &&
                      ((A = t.appKey), (i = !!t.isOversea)),
                    e.queues[A])
                  )
                    return [2];
                  (e.queues[A] = []),
                    o && (e.sdkLoadingDefer = o),
                    (s.label = 1);
                case 1:
                  return s.trys.push([1, 4, , 5]), [4, e.loadBeaconSDK()];
                case 2:
                  return (
                    s.sent(),
                    (e.sdkLoadingDefer = null),
                    [4, this.requireBeaconModule()]
                  );
                case 3:
                  return (
                    (r = s.sent()),
                    (n = new r({
                      needQueryConfig: !1,
                      appkey: A,
                      strictMode: !1,
                      isOversea: i,
                    })),
                    (e.instances[A] = n),
                    e.flushQueue(A),
                    [3, 5]
                  );
                case 4:
                  return (a = s.sent()), console.error(a), [3, 5];
                case 5:
                  return [2];
              }
            });
          });
        }),
        (e.requireBeaconModule = function () {
          return requireModule(BEACON_MODULE_NAME, BEACON_GLOBAL_NAME);
        }),
        (e.instances = {}),
        (e.queues = {}),
        e
      );
    })(),
    BEACON_MODULE_NAME = "BeaconAction",
    BEACON_GLOBAL_NAME = "BeaconAction",
    MAX_QUEUE_SIZE = 30,
    getQQFromCookie$1 = function () {
      var e = cookieTool$1.get("luin") || cookieTool$1.get("uin");
      return e && (e = e.replace(/\D/g, "").replace(/^0+/, "")), e;
    },
    BufferThresholds = 1200,
    PlatCode;
  !(function (e) {
    (e.Web = "web"), (e.H5 = "h5");
  })(PlatCode || (PlatCode = {}));
  var DEFAULT_KEYS$1$1 = {
      cdnuip: "",
      iqq: "",
      pvid: "",
      qqopen_id: COMMON_DATA_KEY.hc_openid,
      playno: COMMON_DATA_KEY.flowid,
      cdnid: COMMON_DATA_KEY.cdnid,
      guid: COMMON_DATA_KEY.guid,
      fplayerver: COMMON_DATA_KEY.playerver,
      dsip: "",
      sstrength: "",
      devtype: "",
      nettype: "",
      freetype: "",
      platform: COMMON_DATA_KEY.platform,
      vplatform: COMMON_DATA_KEY.platform,
      codec: COMMON_DATA_KEY.codec,
      device: COMMON_DATA_KEY.device,
      resolution: COMMON_DATA_KEY.resolution,
      osver: COMMON_DATA_KEY.osver,
      playertype: COMMON_DATA_KEY.playertype,
      appver: COMMON_DATA_KEY.appVer,
      use_p2p: COMMON_DATA_KEY.p2p,
      p2p_play: COMMON_DATA_KEY.p2p,
      p2pver: COMMON_DATA_KEY.p2pver,
      playtype: "",
      scenesid: COMMON_DATA_KEY.sid,
      sid: COMMON_DATA_KEY.vid,
      livepid: COMMON_DATA_KEY.livepid,
      contentid: COMMON_DATA_KEY.cid,
      drm: COMMON_DATA_KEY.drmtype,
      videocapability: COMMON_DATA_KEY.videoCapability,
      playtime: "",
      isuserpay: "",
      live_type: "",
      xserverip: "",
      durl: "",
      lookback: "",
      live_tag: "",
      extraInfo: "",
      spanId: "",
      tuid: "",
      ext1: "",
      ext2: "",
      ext3: "",
    },
    LiveQaReporterPlugin = (function (e) {
      function t(t, o, A) {
        var i = e.call(this, t, o, A) || this;
        (i.REPORT_KEY = LiveQaReportBeaconAppKey),
          (i.seq = 0),
          (i.lastPlayDuration = 0),
          (i.bufferHistory = []),
          (i.flowHeader = {
            cnntime: 0,
            maxspeed: 0,
            testspeed: 0,
            downspeed: 0,
            recnncount: 0,
            loadingtime: 0,
            blockcount: 0,
            blocktime: 0,
            errorcode: 0,
            geturltime: 0,
            fullecode: "",
            prdlength: 0,
            get_stream_data_duration: 0,
            get_sync_frame_duration: 0,
            live_delay: 0,
          }),
          (i.isSettingLevel = !1),
          (i.setEvtHandler = function () {
            i.msg.on(
              exports.PLAY_EVENT_EXT.DATASET_STATE_UPDATE,
              i.onStateChange
            ),
              i.player.on(exports.PLAY_EVENT.RETRY_BACKURL, i.onRetryUrl);
          }),
          (i.onRetryUrl = function () {
            i.flowHeader.recnncount = i.flowHeader.recnncount + 1;
          }),
          (i.onStateChange = function (e) {
            var t,
              o = e.data,
              A = o.key,
              r =
                (((t = {})[exports.DATA_STATE.LOAD_END] = i.onLoad),
                (t[exports.DATA_STATE.BUFFER_END] = i.onBuffer),
                (t[exports.DATA_STATE.GET_INFO_END] = i.onGetinfoEnd),
                (t[exports.DATA_STATE.SET_LEVEL_START] = i.onSetLevel),
                (t[exports.DATA_STATE.SESSION_START] = i.onSessionStart),
                (t[exports.DATA_STATE.SESSION_END] = i.onSessionEnd),
                (t[exports.DATA_STATE.CODEC_DEGRADE] = i.onCodecDegrade),
                t);
            r[A] && r[A](o);
          }),
          (i.onSessionStart = function () {
            i.resetLoopData(), (i.seq = 0);
          }),
          (i.onSessionEnd = function (e) {
            var t = e.newVal,
              o = (void 0 === t ? {} : t).code;
            i.onPeriod({ code: o }),
              (i.seq = 0),
              i.endPeriodReport(),
              (i.reportedEvt = {});
          }),
          (i.startPeriodReport = function () {
            i.endPeriodReport(), (i.period = setInterval(i.onPeriod, 6e4));
          }),
          (i.endPeriodReport = function () {
            i.period && (clearInterval(i.period), (i.period = null));
          }),
          (i.onSetLevel = function () {
            (i.isSettingLevel = !0), i.onPeriod(), i.endPeriodReport();
          }),
          (i.onBuffer = function (e) {
            var t = e.newVal,
              o = void 0 === t ? {} : t,
              A = e.startEvent,
              r = void 0 === A ? {} : A,
              n = o.ftime,
              a = r.ftime;
            n - a <= BufferThresholds ||
              i.bufferHistory.push({ stime: a, etime: n });
          }),
          (i.onGetinfoEnd = function (e) {
            var t = e.newVal,
              o = e.startEvent,
              A = t.ftime,
              r = o.ftime;
            i.flowHeader.geturltime = A - r;
          }),
          (i.onCodecDegrade = function (e) {
            var t = e.newVal,
              o = void 0 === t ? {} : t,
              A = o.ftime,
              r = o.code;
            i.report({
              step: 701,
              stepname: "codec_degrade",
              etime: A,
              code: r,
            });
          }),
          (i.onLoad = function (e) {
            if (!i.reportedEvt[205] || i.isSettingLevel) {
              (i.reportedEvt[205] = !0), (i.isSettingLevel = !1);
              var t = e.startEvent,
                o = void 0 === t ? {} : t,
                A = e.newVal,
                r = void 0 === A ? {} : A,
                n = r.code;
              n === exports.ErrorCode.SUC &&
                ((i.flowHeader.loadingtime = r.ftime - o.ftime),
                (i.flowHeader.errorcode = n),
                (i.flowHeader.fullecode = n),
                i.report({ step: 205, stepname: "live_loading", code: n }),
                i.startPeriodReport());
            }
          }),
          (i.onPeriod = function (e) {
            var t = (e || { code: exports.ErrorCode.SUC }).code,
              o = void 0 === t ? exports.ErrorCode.SUC : t,
              A = i.bufferHistory.reduce(
                function (e, t) {
                  return [e[0] + 1, e[1] + (t.etime - t.stime)];
                },
                [0, 0]
              ),
              r = A[0],
              n = A[1],
              a = i.player.dataset.getStats().playDuration;
            (i.flowHeader.blockcount = r),
              (i.flowHeader.blocktime = n),
              (i.flowHeader.prdlength = a - i.lastPlayDuration),
              (i.flowHeader.errorcode = o),
              (i.flowHeader.fullecode = o);
            var s = {
              step: o === exports.ErrorCode.SUC ? 263 : 150,
              stepname:
                o === exports.ErrorCode.SUC ? "live_period" : "live_error",
              code: o,
            };
            i.report(s), i.resetLoopData(), (i.lastPlayDuration = a);
          }),
          (i.resetLoopData = function () {
            (i.bufferHistory = []),
              (i.flowHeader = __assign$1(__assign$1({}, i.flowHeader), {
                blockcount: 0,
                blocktime: 0,
                errorcode: 0,
                loadingtime: 0,
                fullecode: "",
                prdlength: 0,
                recnncount: 0,
                downspeed: 0,
                live_delay: 0,
              }));
          });
        var r = t.config.liveQaReporterConfig;
        return (
          (i.config = {
            paramsKey: __assign$1(
              __assign$1({}, DEFAULT_KEYS$1$1),
              (null == r ? void 0 : r.paramsKey) || {}
            ),
            onAfterReport: null == r ? void 0 : r.onAfterReport,
            onBeforeReport: null == r ? void 0 : r.onBeforeReport,
          }),
          i.setEvtHandler(),
          BeaconRequest.register(
            {
              appKey: i.REPORT_KEY,
              isOversea: !!(null == r ? void 0 : r.isOversea),
            },
            null == r ? void 0 : r.externalBeaconDefer
          ),
          i.log(
            "live-qa-reporter registered to "
              .concat(i.REPORT_KEY, ", oversea: ")
              .concat(!!(null == r ? void 0 : r.isOversea))
          ),
          (i.reporter = BeaconRequest.report),
          i
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "reportHeader", {
          get: function () {
            var e,
              t,
              o = this.config.paramsKey,
              A = void 0 === o ? {} : o;
            return __assign$1(
              {
                videocapability: this.getKvWithDefault(A.videocapability, ""),
                cdnuip: this.getKvWithDefault(A.cdnuip, ""),
                iqq: this.getKvWithDefault(A.iqq, getQQFromCookie$1()),
                qqopen_id: this.getKvWithDefault(A.qqopen_id, ""),
                pvid: cookieTool$1.get("pgv_pvid") || "",
                playno: this.getKvWithDefault(A.playno, ""),
                cdnid: this.getKvWithDefault(A.cdnid, ""),
                guid: this.getKvWithDefault(A.guid, ""),
                fplayerver: this.getKvWithDefault(A.fplayerver, ""),
                dsip: this.getKvWithDefault(A.dsip, ""),
                sstrength: this.getKvWithDefault(A.sstrength, 0),
                devtype: this.getKvWithDefault(A.devtype, 0),
                nettype: this.getKvWithDefault(A.nettype, 100),
                codec: this.getKvWithDefault(A.codec, CODEC.H264),
                freetype: this.getKvWithDefault(A.freetype, 0),
                platform: this.getKvWithDefault(A.platform, ""),
                vplatform: this.getKvWithDefault(A.platform, ""),
                device: this.getKvWithDefault(A.device, ""),
                resolution: this.getKvWithDefault(A.resolution, ""),
                osver: this.getKvWithDefault(A.osver, ""),
                playertype: this.getKvWithDefault(A.playertype, 0),
                appver: this.getKvWithDefault(A.appver, ""),
                use_p2p: this.getKvWithDefault(A.use_p2p, 0),
                p2p_play: this.getKvWithDefault(A.p2p_play, 0),
                p2pver: this.getKvWithDefault(A.p2pver, ""),
                playtype: this.getKvWithDefault(A.playtype, 1),
                scenesid: this.getKvWithDefault(A.scenesid, 0),
                drm: this.getKvWithDefault(A.drm, 0),
                sid: this.getKvWithDefault(A.sid, 0),
                livepid: this.getKvWithDefault(A.livepid, 0),
                contentid: this.getKvWithDefault(A.contentid, 0),
                playtime: this.getKvWithDefault(A.playtime, 0),
                isuerpay: this.getKvWithDefault(A.isuserpay, 0),
                live_type: this.getKvWithDefault(A.live_type, 0),
                xserverip: this.getKvWithDefault(A.xserverip, ""),
                durl: this.getKvWithDefault(
                  A.durl,
                  (null ===
                    (t =
                      null === (e = this.player) || void 0 === e
                        ? void 0
                        : e.currentVideoInfo) || void 0 === t
                    ? void 0
                    : t.loadingUrl) || ""
                ),
                lookback: this.getKvWithDefault(A.lookback, 0),
                live_tag: this.getKvWithDefault(A.live_tag, 0),
                extraInfo: this.getKvWithDefault(A.extraInfo, ""),
                spanId: this.getKvWithDefault(A.spanId, ""),
                tuid: this.getKvWithDefault(A.tuid, ""),
                kernel: this.player.kernelName,
                plat_code: uaTool$1.mobile ? PlatCode.H5 : PlatCode.Web,
                domain: urlTool$1.getDomainOfURL(urlTool$1.getTopFrameUrl()),
                seq: this.seq,
                ext1: this.getKvWithDefault(A.ext1, ""),
                ext2: this.getKvWithDefault(A.ext2, ""),
                ext3: this.getKvWithDefault(A.ext3, ""),
              },
              this.flowHeader
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.destroy = function () {
          this.endPeriodReport(),
            BeaconRequest.clear(this.REPORT_KEY),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.report = function (t) {
          e.prototype.report.call(this, t), (this.seq = this.seq + 1);
        }),
        (t.pluginName = "live-qa-reporter"),
        t
      );
    })(BaseReporter),
    AdReportHelper = (function () {
      function e(e) {
        var t = this;
        (this.reportData = {}),
          (this.currentBufferHistory = []),
          (this.onStateChange = function (e) {
            var o,
              A = e.data,
              i = A.new,
              r = A.old,
              n =
                (((o = {})[exports.VIDEO_STATE.CANPLAY] = t.onCanPlay),
                (o[exports.VIDEO_STATE.BUFFERING] = t.onBuffering),
                (o[exports.VIDEO_STATE.END] = t.onEnd),
                o);
            n[i] && n[i](e.data.videoInfo, r);
          }),
          (this.onError = function (e) {
            var o,
              A,
              i = e.data.videoInfo;
            if (i) {
              var r = i.uid,
                n = i.error,
                a = t.reportData[r];
              a &&
                (a.load >= 0 &&
                  (t.emitToMainReporter(
                    {
                      code: n.code,
                      step: "30",
                      stime: a.load,
                      stepname: STEP_NAME.FIRST_LOAD,
                      etime: Date.now(),
                      url: i.loadingUrl,
                      urlIndex:
                        (null ===
                          (A =
                            null === (o = i.config) || void 0 === o
                              ? void 0
                              : o.backupUrls) || void 0 === A
                          ? void 0
                          : A.findIndex(function (e) {
                              return e === i.loadingUrl;
                            })) || -1,
                    },
                    a
                  ),
                  (a.load = -1)),
                t.emitToMainReporter(
                  {
                    step: "50",
                    playDuration: i.playtime,
                    code: n.code,
                    stepname: STEP_NAME.END,
                    tbcount: 0,
                    tbduration: 0,
                    scount: 0,
                    etime: Date.now(),
                    bcount: t.currentBufferHistory.length,
                    tduration: t.currentBufferHistory.reduce(function (e, t) {
                      return e + (t.etime - t.stime);
                    }, 0),
                  },
                  a
                ));
            }
          }),
          (this.onFirstPlaying = function (e) {
            var o = e.data.videoInfo;
            if (o) {
              var A = t.reportData[o.uid];
              if (A) {
                A.load >= 0 && t.reportFirstLoad(o, A);
                var i = Date.now(),
                  r = {
                    step: "32",
                    stepname: STEP_NAME.FIRST_RENDERING,
                    stime: i,
                    etime: i,
                    code: exports.ErrorCode.SUC,
                  };
                t.emitToMainReporter(r, A);
              } else;
            }
          }),
          (this.onVideoNodeChange = function (e) {
            var o = e.data.videoInfo;
            o &&
              !t.reportData[o.uid] &&
              (t.reportData[o.uid] = {
                seq: 0,
                flowidSuffix: "_ad".concat(t.getAdClipNumber()),
                load: Date.now(),
              });
          }),
          (this.reportFirstLoad = function (e, o) {
            var A,
              i,
              r,
              n,
              a =
                null !==
                  (i =
                    null === (A = t.adPlayer.currentVideoInfo) || void 0 === A
                      ? void 0
                      : A.cacheSize) && void 0 !== i
                  ? i
                  : 0,
              s = {
                step: "30",
                stepname: STEP_NAME.FIRST_LOAD,
                stime: o.load,
                etime: Date.now(),
                url: e.loadingUrl,
                urlIndex:
                  (null ===
                    (n =
                      null === (r = e.config) || void 0 === r
                        ? void 0
                        : r.backupUrls) || void 0 === n
                    ? void 0
                    : n.findIndex(function (t) {
                        return t === e.loadingUrl;
                      })) || -1,
                code: exports.ErrorCode.SUC,
                cachesize: a,
              };
            t.emitToMainReporter(s, o), (o.load = -1);
          }),
          (this.onCanPlay = function (e) {
            if (e) {
              var o = t.reportData[e.uid];
              if (o) {
                if (o.load >= 0) return void t.reportFirstLoad(e, o);
                if (o.buffer >= 0) {
                  var A = Date.now(),
                    i = o.buffer;
                  if (((o.buffer = -1), A - i <= 1200)) return;
                  t.currentBufferHistory.push({ stime: i, etime: Date.now() });
                  var r = {
                    step: "35",
                    stime: i,
                    stepname: STEP_NAME.BUFFERING,
                    etime: Date.now(),
                    ptime: t.adPlayer.playtime,
                    code: exports.ErrorCode.SUC,
                  };
                  return void t.emitToMainReporter(r, o);
                }
              }
            }
          }),
          (this.onEnd = function (e) {
            if (e) {
              var o = t.reportData[e.uid];
              if (o) {
                var A = {
                  step: "50",
                  playDuration: e.playtime,
                  code: exports.ErrorCode.SUC,
                  stepname: STEP_NAME.END,
                  tbcount: 0,
                  tbduration: 0,
                  scount: 0,
                  etime: Date.now(),
                  bcount: t.currentBufferHistory.length,
                  tduration: t.currentBufferHistory.reduce(function (e, t) {
                    return e + (t.etime - t.stime);
                  }, 0),
                };
                t.emitToMainReporter(A, o);
              }
            }
          }),
          (this.onBuffering = function (e) {
            if (e) {
              var o = t.reportData[e.uid];
              o && (o.buffer = Date.now());
            }
          }),
          (this.reporterPlugin = e);
      }
      return (
        (e.prototype.destroy = function () {
          this.unbindCoreEvents();
        }),
        (e.prototype.init = function (e, t) {
          this.adPlayer && this.unbindCoreEvents();
          var o = e.currentVideoInfo;
          o &&
            ((this.adPlayer = e),
            (this.adType = t),
            this.bindCoreEvents(),
            (this.reportData = {}),
            (this.reportData[o.uid] = {
              seq: 0,
              flowidSuffix: "ad".concat(this.getAdClipNumber()),
              load: Date.now(),
            }));
        }),
        (e.prototype.getAdClipNumber = function () {
          return Object.keys(this.reportData).length;
        }),
        (e.prototype.bindCoreEvents = function () {
          this.adPlayer.on(exports.PLAY_EVENT.STATE_CHANGE, this.onStateChange),
            this.adPlayer.on(exports.PLAY_EVENT.ERROR, this.onError),
            this.adPlayer.on(
              exports.PLAY_EVENT.VIDEONODE_FIRST_PLAYING,
              this.onFirstPlaying
            ),
            this.adPlayer.on(
              exports.PLAY_EVENT.VIDEONODE_CHANGE,
              this.onVideoNodeChange
            );
        }),
        (e.prototype.unbindCoreEvents = function () {
          this.adPlayer.off(
            exports.PLAY_EVENT.STATE_CHANGE,
            this.onStateChange
          ),
            this.adPlayer.off(exports.PLAY_EVENT.ERROR, this.onError),
            this.adPlayer.off(
              exports.PLAY_EVENT.VIDEONODE_FIRST_PLAYING,
              this.onFirstPlaying
            ),
            this.adPlayer.off(
              exports.PLAY_EVENT.VIDEONODE_CHANGE,
              this.onVideoNodeChange
            );
        }),
        (e.prototype.emitToMainReporter = function (e, t) {
          var o = __assign$1(__assign$1({ code: exports.ErrorCode.SUC }, e), {
            flowid: t.flowidSuffix,
            seq: t.seq,
            scenesid: SCENES_ID[this.adType] || SCENES_ID.otherAd,
            duration: this.adPlayer.duration,
            kernel: this.adPlayer.kernelName,
            vid: "",
            fmt: "",
            rate: "",
            cdnid: "",
            cdnip: "",
            drm: "",
            definition: "",
            dltype: "",
          });
          (t.seq += 1), this.reporterPlugin.emit("adReport", o);
        }),
        e
      );
    })(),
    STEP_NAME,
    SCENES_ID;
  !(function (e) {
    (e.INIT = "init_player"),
      (e.GETINFO = "get_cdn_url"),
      (e.FIRST_LOAD = "first_load"),
      (e.FIRST_RENDERING = "first_rendering"),
      (e.BUFFERING = "second_buffering"),
      (e.SEEKING = "user_seek"),
      (e.END = "play_done"),
      (e.CODEC_DEGRADE = "codec_degrade"),
      (e.DT_OPEN = "dt_open");
  })(STEP_NAME || (STEP_NAME = {})),
    (function (e) {
      (e[(e.preAd = 400)] = "preAd"),
        (e[(e.ZT = 401)] = "ZT"),
        (e[(e.postAd = 402)] = "postAd"),
        (e[(e.otherAd = 403)] = "otherAd"),
        (e[(e.video = 421)] = "video");
    })(SCENES_ID || (SCENES_ID = {}));
  var DEFAULT_KEYS$2 = {
      platform: COMMON_DATA_KEY.platform,
      vplatform: COMMON_DATA_KEY.platform,
      flowid: COMMON_DATA_KEY.flowid,
      uin: "",
      QQopenid: COMMON_DATA_KEY.hc_openid,
      WXopenid: COMMON_DATA_KEY.hc_openid,
      logintype: COMMON_DATA_KEY.hc_main_login,
      guid: COMMON_DATA_KEY.guid,
      uip: "",
      cdnuip: COMMON_DATA_KEY.cdnuip,
      codec: COMMON_DATA_KEY.codec,
      cdnip: COMMON_DATA_KEY.cdnip,
      online: COMMON_DATA_KEY.online,
      p2p: COMMON_DATA_KEY.p2p,
      sstrength: COMMON_DATA_KEY.sstrength,
      network: COMMON_DATA_KEY.network,
      speed: COMMON_DATA_KEY.speed,
      device: COMMON_DATA_KEY.device,
      resolution: COMMON_DATA_KEY.resolution,
      testid: COMMON_DATA_KEY.testid,
      osver: COMMON_DATA_KEY.osver,
      p2pver: COMMON_DATA_KEY.p2pver,
      appver: COMMON_DATA_KEY.appVer,
      playerver: COMMON_DATA_KEY.playerver,
      playertype: COMMON_DATA_KEY.playertype,
      confid: COMMON_DATA_KEY.confid,
      cdnid: COMMON_DATA_KEY.cdnid,
      drm: COMMON_DATA_KEY.drmtype,
      scenesid: "",
      playtype: "",
      dltype: COMMON_DATA_KEY.dltype,
      vid: COMMON_DATA_KEY.vid,
      definition: COMMON_DATA_KEY.currentDefn,
      fmt: COMMON_DATA_KEY.fmt,
      rate: COMMON_DATA_KEY.rate,
      videocapability: COMMON_DATA_KEY.videoCapability,
      ckeytime: COMMON_DATA_KEY.ckeytime,
      ckeydg: COMMON_DATA_KEY.ckeydg,
      isad: "",
      duration: "",
      kernel: "",
      ext1: "",
      ext2: "",
      ext3: "",
    },
    VodQaReporterPlugin = (function (e) {
      function t(t, o, A) {
        var i = e.call(this, t, o, A) || this;
        (i.REPORT_KEY = VodQaReportBeaconAppKey),
          (i.FLOW_DATA_KEY = VodQaReportCacheKey),
          (i.seq = 0),
          (i.bufferHistory = []),
          (i.seekHistory = []),
          (i.initData = { fmt: "", rate: "", cdnid: "" }),
          (i.bufferCount = 0),
          (i.seekCount = 0),
          (i.adReportHelperInitTimeoutId = 0),
          (i.setEvtHandler = function () {
            i.msg.on(
              exports.PLAY_EVENT_EXT.DATASET_STATE_UPDATE,
              i.onStateChange
            ),
              i.player.on(exports.PLAY_EVENT.SETLEVEL_OVER, function () {
                (i.bufferCount = 0), (i.seekCount = 0);
              }),
              window.addEventListener("pagehide", i.onPageHide);
          }),
          (i.onPageHide = function () {
            i.handlePageHide(i.collectFinalData());
          }),
          (i.onStateChange = function (e) {
            var t,
              o = e.data,
              A = o.key,
              r =
                (((t = {})[exports.DATA_STATE.INIT] = i.onPlayerInit),
                (t[exports.DATA_STATE.LOAD_END] = i.onLoad),
                (t[exports.DATA_STATE.BUFFER_END] = i.onBuffer),
                (t[exports.DATA_STATE.GET_INFO_END] = i.onGetinfoEnd),
                (t[exports.DATA_STATE.SEEK_END] = i.onSeek),
                (t[exports.DATA_STATE.SESSION_END] = i.onPlaySessionEnd),
                (t[exports.DATA_STATE.FIRST_PLAY] = i.onFirstPlay),
                (t[exports.DATA_STATE.SESSION_START] = i.reset),
                (t[exports.DATA_STATE.CODEC_DEGRADE] = i.onCodecDegrade),
                (t[exports.DATA_STATE.RETRY_BACKURL] = function () {
                  (i.bufferCount = 0), (i.seekCount = 0);
                }),
                (t[exports.DATA_STATE.DT_OPEN] = i.onDtOpen),
                t);
            r[A] && r[A](o);
          }),
          (i.onPlayerInit = function (e) {
            var t = e.newVal,
              o = t.ftime,
              A = t.ext,
              r = (void 0 === A ? {} : A).stime;
            i.report({
              stepname: STEP_NAME.INIT,
              step: "5",
              stime: r,
              etime: o,
              code: exports.ErrorCode.SUC,
            });
          }),
          (i.onGetinfoEnd = function (e) {
            var t = e.newVal,
              o = e.startEvent,
              A = t.ftime,
              r = t.code,
              n = o.ftime;
            i.report({
              stepname: STEP_NAME.GETINFO,
              step: "15",
              stime: n,
              etime: A,
              code: r,
            });
          }),
          (i.onLoad = function (e) {
            var t = e.newVal,
              o = void 0 === t ? {} : t,
              A = e.startEvent,
              r = void 0 === A ? {} : A,
              n = o,
              a = n.ftime,
              s = n.currentUrl,
              g = n.urlIndex,
              l = n.code,
              E = n.ext,
              c = (null == E ? void 0 : E.isAdPlaying) ? a : r.ftime;
            i.report({
              stepname: STEP_NAME.FIRST_LOAD,
              step: "30",
              stime: c,
              etime: a,
              url: s || "",
              urlindex: g + 1,
              fileopenedtime: 0,
              firstpacketreadtime: 0,
              ext1: i.player.getCommonKv(COMMON_DATA_KEY.isPreload) || 0,
              ext2: Number(null == E ? void 0 : E.isAdPlaying),
              code: l,
            });
          }),
          (i.onFirstPlay = function () {
            if (!i.reportedEvt[STEP_NAME.FIRST_RENDERING]) {
              i.reportedEvt[STEP_NAME.FIRST_RENDERING] = !0;
              var e = +new Date();
              i.report({
                step: "32",
                stepname: STEP_NAME.FIRST_RENDERING,
                stime: e,
                etime: e,
                code: exports.ErrorCode.SUC,
              });
            }
          }),
          (i.onBuffer = function (e) {
            var t = e.newVal,
              o = void 0 === t ? {} : t,
              A = e.startEvent,
              r = void 0 === A ? {} : A,
              n = o.ftime,
              a = o.playtime,
              s = o.currentUrl,
              g = o.code,
              l = r.ftime,
              E = r.prevState === exports.VIDEO_STATE.SEEKING ? 1 : 0,
              c = i.player.playbackRate > 1 ? 2 : 1;
            n - l <= BufferThresholds ||
              (i.bufferHistory.push({ stime: l, etime: n }),
              i.bufferCount < 20 &&
                (i.report({
                  step: "35",
                  stepname: STEP_NAME.BUFFERING,
                  ptime: a,
                  levent: E,
                  stime: l,
                  etime: n,
                  scene: c,
                  format: i.player.getCommonKv(i.config.paramsKey.fmt) || 0,
                  url: s || "",
                  reason: 0,
                  code: g,
                  vt: i.player.getCommonKv(i.config.paramsKey.cdnid) || 0,
                }),
                (i.bufferCount += 1)));
          }),
          (i.onSeek = function (e) {
            var t = e.newVal,
              o = void 0 === t ? {} : t,
              A = e.startEvent,
              r = void 0 === A ? {} : A,
              n = o.ftime,
              a = o.playtime,
              s = o.code,
              g = o.ext,
              l = void 0 === g ? {} : g,
              E = r.ftime,
              c = r.playtime;
            l.isUserSeek &&
              (i.seekHistory.push({ lstime: E, letime: n }),
              i.seekCount < 20 &&
                (i.report({
                  step: "40",
                  stepname: STEP_NAME.SEEKING,
                  lstime: E,
                  letime: n,
                  pstime: c,
                  petime: a,
                  format: i.player.getCommonKv(i.config.paramsKey.fmt) || 0,
                  code: s,
                }),
                (i.seekCount += 1)));
          }),
          (i.onPlaySessionEnd = function (e) {
            if (!i.reportedEvt[STEP_NAME.END]) {
              i.reportedEvt[STEP_NAME.END] = !0;
              var t = e.newVal,
                o = void 0 === t ? {} : t,
                A = o.ftime,
                r = o.code,
                n = i.player.dataset.getStats().playDuration,
                a = [
                  0 === r.indexOf(exports.ErrorCode.GETINFO_SERVER_CODE_PREFIX),
                  0 === r.indexOf("70014"),
                  0 === r.indexOf("7004"),
                  "70011112" === r,
                  "70011113" === r,
                ].some(function (e) {
                  return e;
                }),
                s = a ? exports.ErrorCode.SUC : r;
              i.report(
                __assign$1(
                  __assign$1(
                    {
                      step: "50",
                      stepname: STEP_NAME.END,
                      etime: A,
                      playduration: n,
                      code: s,
                    },
                    i.seekStat
                  ),
                  i.bufferStat
                )
              ),
                i.removeFromLS(i.player.getCommonKv(COMMON_DATA_KEY.flowid)),
                (i.seq = 0);
            }
          }),
          (i.onCodecDegrade = function (e) {
            var t = e.newVal,
              o = void 0 === t ? {} : t,
              A = o.ftime,
              r = o.code;
            i.report({
              step: "701",
              stepname: STEP_NAME.CODEC_DEGRADE,
              etime: A,
              code: r,
            });
          }),
          (i.onDtOpen = function (e) {
            var t = e.newVal,
              o = void 0 === t ? {} : t,
              A = o.ftime,
              r = o.code;
            i.report({
              step: "702",
              stepname: STEP_NAME.DT_OPEN,
              stime: A,
              etime: +new Date(),
              code: r,
            });
          }),
          (i.onInit = function () {
            i.reportPrev();
          }),
          (i.collectFinalData = function () {
            var e = +new Date();
            if (
              i.player.getCommonKv(COMMON_DATA_KEY.flowid) &&
              !i.reportedEvt[STEP_NAME.END]
            ) {
              var t = i.player.dataset.getStats().playDuration;
              return __assign$1(
                __assign$1(
                  {
                    step: "50",
                    stepname: STEP_NAME.END,
                    etime: e,
                    code: exports.ErrorCode.SUC,
                    playduration: t,
                  },
                  i.seekStat
                ),
                i.bufferStat
              );
            }
          }),
          (i.reset = function () {
            (i.reportedEvt = {}),
              (i.initData.fmt = ""),
              (i.initData.rate = ""),
              (i.initData.cdnid = ""),
              (i.bufferHistory = []),
              (i.seekHistory = []),
              (i.bufferCount = 0),
              (i.seekCount = 0);
          });
        var r = t.config.vodQaReporterConfig;
        return (
          (i.config = {
            paramsKey: __assign$1(
              __assign$1({}, DEFAULT_KEYS$2),
              (null == r ? void 0 : r.paramsKey) || {}
            ),
            onAfterReport: null == r ? void 0 : r.onAfterReport,
            onBeforeReport: null == r ? void 0 : r.onBeforeReport,
          }),
          i.setEvtHandler(),
          BeaconRequest.register(
            {
              appKey: i.REPORT_KEY,
              isOversea: !!(null == r ? void 0 : r.isOversea),
            },
            null == r ? void 0 : r.externalBeaconDefer
          ),
          i.log(
            "vod-qa-reporter registered to "
              .concat(i.REPORT_KEY, ", oversea: ")
              .concat(!!(null == r ? void 0 : r.isOversea))
          ),
          (i.reporter = BeaconRequest.report),
          (i.reporterForPageHide = BeaconRequest.reportWhenPageHide),
          i.onInit(),
          (i.adReportHelper = new AdReportHelper(i)),
          i.player.on(exports.H5_PLAY_EVENT.AD_REQ_ASSETS_START, function (e) {
            var o = e.data;
            i.adReportHelperInitTimeoutId = window.setTimeout(function () {
              var e,
                A = getAdPlugin(null == t ? void 0 : t.config.instanceId),
                r =
                  null === (e = null == A ? void 0 : A.getPlayerInstance) ||
                  void 0 === e
                    ? void 0
                    : e.call(A, o.adType);
              r && i.adReportHelper.init(r, o.adType);
            });
          }),
          i.on("adReport", function (t) {
            e.prototype.report.call(
              i,
              __assign$1(__assign$1({}, t.data), {
                flowid: ""
                  .concat(i.reportHeader.flowid, "_")
                  .concat(t.data.flowid),
                isad: 1,
              })
            );
          }),
          i
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "seekStat", {
          get: function () {
            var e = this.seekHistory.reduce(
              function (e, t) {
                var o = e[0],
                  A = e[1],
                  i = t.letime - t.lstime;
                return i > BufferThresholds ? [o + 1, A + i] : e;
              },
              [0, 0]
            );
            return {
              tbcount: e[0],
              tbduration: e[1],
              scount: this.seekHistory.length,
            };
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "bufferStat", {
          get: function () {
            return {
              tduration: this.bufferHistory.reduce(function (e, t) {
                return e + (t.etime - t.stime);
              }, 0),
              bcount: this.bufferHistory.length,
            };
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "reportHeader", {
          get: function () {
            var e,
              t = this,
              o = this.config.paramsKey,
              A = this.player.dataset.getStats(),
              i = A.averageDecodeTimeInMs,
              r = A.frameDroppedInPercentage;
            return (
              Object.entries(this.initData).forEach(function (e) {
                var A = e[0];
                e[1] || (t.initData[A] = t.getKvWithDefault(o[A], ""));
              }),
              {
                videocapability: this.getKvWithDefault(o.videocapability, ""),
                platform: this.getKvWithDefault(o.platform, ""),
                vplatform: this.getKvWithDefault(o.platform, ""),
                flowid: this.getKvWithDefault(o.flowid, ""),
                uin: this.getKvWithDefault(o.uin, getQQFromCookie$1()),
                QQopenid: this.getKvWithDefault(o.QQopenid, ""),
                WXopenid: this.getKvWithDefault(o.WXopenid, ""),
                logintype: this.getKvWithDefault(o.logintype, 0),
                guid: this.getKvWithDefault(o.guid, ""),
                uip: this.getKvWithDefault(o.uip, ""),
                cdnuip: this.getKvWithDefault(o.cdnuip, ""),
                cdnip: this.getKvWithDefault(o.cdnip, ""),
                online: this.getKvWithDefault(o.online, 1),
                p2p: this.getKvWithDefault(o.p2p, 0),
                sstrength: this.getKvWithDefault(o.sstrength, 0),
                network: this.getKvWithDefault(o.network, 0),
                speed: this.getKvWithDefault(o.speed, 0),
                device: this.getKvWithDefault(o.device, ""),
                resolution: this.getKvWithDefault(o.resolution, ""),
                testid: this.getKvWithDefault(o.testid, 0),
                codec: this.getKvWithDefault(o.codec, CODEC.H264),
                osver: this.getKvWithDefault(o.osver, ""),
                p2pver: this.getKvWithDefault(o.p2pver, ""),
                appver: this.getKvWithDefault(o.appver, ""),
                playerver: this.getKvWithDefault(o.playerver, ""),
                confid: this.getKvWithDefault(o.confid, 0),
                playertype: this.getKvWithDefault(o.playertype, 0),
                cdnid: this.initData.cdnid,
                scenesid: this.getKvWithDefault(o.scenesid, SCENES_ID.video),
                playtype: 0,
                dltype: this.getKvWithDefault(o.dltype, 0),
                vid: this.getKvWithDefault(o.vid, ""),
                fmt: this.initData.fmt,
                rate: this.initData.rate,
                drm: this.getKvWithDefault(o.drm, 0),
                definition: this.getKvWithDefault(o.definition, ""),
                duration: Math.round(
                  this.getKvWithDefault(o.duration, this.player.duration)
                ),
                seq: this.seq,
                kernel:
                  null !== (e = this.player.kernelName) && void 0 !== e
                    ? e
                    : "unknown",
                domain: urlTool$1.getDomainOfURL(urlTool$1.getTopFrameUrl()),
                isad: 0,
                ext1: this.getKvWithDefault(o.ext1, ""),
                ext2: this.getKvWithDefault(o.ext2, ""),
                ext3: this.getKvWithDefault(o.ext3, ""),
                ckeytime: this.getKvWithDefault(o.ckeytime, -1),
                ckeydg: this.getKvWithDefault(o.ckeydg, 0),
                framedrop: r,
                avgdecodecost: i,
                deved: this.getKvWithDefault(COMMON_DATA_KEY.deved, 0),
                vuid: this.getKvWithDefault(COMMON_DATA_KEY.hc_vuserid, ""),
                cid: this.getKvWithDefault(COMMON_DATA_KEY.cid, ""),
                ip: this.getKvWithDefault(COMMON_DATA_KEY.hh_ip, ""),
                devicescore: this.getKvWithDefault(
                  COMMON_DATA_KEY.deviceScore,
                  0
                ),
              }
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.destroy = function () {
          this.adReportHelperInitTimeoutId > 0 &&
            (window.clearTimeout(this.adReportHelperInitTimeoutId),
            (this.adReportHelperInitTimeoutId = 0)),
            window.removeEventListener("pagehide", this.onPageHide),
            BeaconRequest.clear(this.REPORT_KEY),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.report = function (t) {
          e.prototype.report.call(this, t), (this.seq = this.seq + 1);
        }),
        (t.pluginName = "vod-qa-reporter"),
        t
      );
    })(BaseReporter),
    OFFICIAL_PLUGIN = {
      VOD_FLOW_REPORTER: "vod-flow-reporter",
      LIVE_FLOW_REPORTER: "live-flow-reporter",
      GETINFO_LIVE: "getinfo-live",
      GETINFO_VOD: "getinfo-vod",
      GETINFO_TC: "getinfo-tc",
      BARRAGE: "barrage",
      MARKID: "markid",
      CONTEXT_MENU: "context-menu",
      WATERMARK: "ui-watermark",
      UI_PREVIEW: "ui-preview",
      UI_PREVIEW_LIST: "ui-preview-list",
      POLL_DURATION: "poll-duration",
      REPORTERS: "reporters",
      UI_ROLE_FILTER: "ui-role-filter",
      SETTING_BTN: "setting-btn",
      CTRLBAR: "ctrlbar",
      ERROR_PAGE: "error-page",
      FULLSCREEN_RATIO: "fullscreen-ratio",
      INFO_PANEL: "info-panel",
      LIVE_POLL: "live-poll",
      POSTER: "poster",
      SUBTITLE: "subtitle",
      TIPS: "tips",
      UI_LOADING: "ui-loading",
      VR: "vr",
      TVK_UTILS: "tvk-utils",
      UNMUTE_BTN: "unmute-btn",
    },
    PLUGIN_MAP = {
      "vod-flow-reporter": {
        cdnPath: "thumbplayer-plugin-atta-reporter",
        version: "1.4.104",
      },
      "live-flow-reporter": {
        cdnPath: "thumbplayer-plugin-atta-reporter",
        version: "1.4.104",
      },
      "getinfo-live": {
        pluginName: "__thumbplayer-video-request",
        version: "1.4.133",
      },
      "getinfo-vod": {
        pluginName: "__thumbplayer-video-request",
        version: "1.4.133",
      },
      "getinfo-tc": {
        pluginName: "__thumbplayer-video-request",
        version: "1.4.125",
      },
      barrage: { pluginName: "Barrage", version: "1.4.133" },
      markid: { pluginName: "ui-markid", version: "1.4.133" },
      "context-menu": {
        cdnPath: "thumbplayer-plugin-ui-contextmenu",
        version: "1.4.133",
      },
      "ui-preview-list": {
        cdnPath: "thumbplayer-plugin-ui-preview",
        version: "1.4.133",
      },
      "ui-preview": {
        cdnPath: "thumbplayer-plugin-ui-preview",
        version: "1.4.133",
      },
      "ui-watermark": {
        cdnPath: "thumbplayer-plugin-watermark",
        version: "1.4.133",
      },
      "poll-duration": { version: "1.4.133" },
      reporters: { version: "1.4.133" },
      "ui-role-filter": { version: "1.4.133" },
      "setting-btn": { version: "1.4.133" },
      ctrlbar: { version: "1.4.133" },
      "error-page": { version: "1.4.133" },
      "fullscreen-ratio": { version: "1.4.133" },
      "info-panel": { version: "1.4.133" },
      "live-poll": { version: "1.4.104" },
      poster: { version: "1.4.133" },
      subtitle: { version: "1.4.133" },
      tips: { version: "1.4.133" },
      "ui-loading": { version: "1.4.133" },
      vr: { version: "1.4.133" },
      "tvk-utils": { version: "1.4.133" },
      "unmute-btn": { version: "1.4.133" },
    },
    H5_PAUSE_TYPE,
    AUTO_PLAY_POLICY,
    PictureDirection,
    VideoLoopMode;
  (exports.H5_PAUSE_TYPE = void 0),
    (H5_PAUSE_TYPE = exports.H5_PAUSE_TYPE || (exports.H5_PAUSE_TYPE = {})),
    (H5_PAUSE_TYPE.USER_CLICK = "user-click"),
    (exports.AUTO_PLAY_POLICY = void 0),
    (AUTO_PLAY_POLICY =
      exports.AUTO_PLAY_POLICY || (exports.AUTO_PLAY_POLICY = {})),
    (AUTO_PLAY_POLICY.IN_MUTED = "autoPlayInMuted"),
    (AUTO_PLAY_POLICY.USER_GESTURE = "autoPlayRequireByUserGesture"),
    (exports.PictureDirection = void 0),
    (PictureDirection =
      exports.PictureDirection || (exports.PictureDirection = {})),
    (PictureDirection.NORMAL = "normal"),
    (PictureDirection.VERTICAL = "vertical"),
    (PictureDirection.HORIZON = "horizon"),
    (exports.VideoLoopMode = void 0),
    (VideoLoopMode = exports.VideoLoopMode || (exports.VideoLoopMode = {})),
    (VideoLoopMode.native = "native"),
    (VideoLoopMode.replay = "replay");
  var stepTimerFakeGlobalInstanceId = "-1",
    StepTimer = (function () {
      function e() {}
      return (
        (e.push = function (e, t, o, A) {
          void 0 === A && (A = stepTimerFakeGlobalInstanceId),
            (this.getRecordMap(A)[e] = { start: t, end: o, cost: o - t });
        }),
        (e.start = function (e, t) {
          void 0 === t && (t = stepTimerFakeGlobalInstanceId),
            (this.getRecordMap(t)[e] = {
              start: performance.now(),
              end: 0,
              cost: 0,
            });
        }),
        (e.end = function (e, t) {
          void 0 === t && (t = stepTimerFakeGlobalInstanceId);
          var o = this.recordMap[t];
          if (!(null == o ? void 0 : o[e])) return -1;
          var A = o[e];
          return (
            0 === A.end &&
              ((A.end = performance.now()),
              (A.cost = Math.round(A.end - A.start))),
            A.cost
          );
        }),
        (e.getCostMap = function (e, t) {
          var o = this;
          void 0 === t && (t = !1);
          var A = {};
          return (
            this.recordMap[e] &&
              (Object.keys(this.recordMap[e]).forEach(function (t) {
                var i = t.replace(/-/g, "_");
                A[i] = o.recordMap[e][t].cost;
              }),
              t && delete this.recordMap[e]),
            A
          );
        }),
        (e.getRecordMap = function (e) {
          var t = this.recordMap[e];
          return t || ((t = {}), (this.recordMap[e] = t)), t;
        }),
        (e.recordMap = {}),
        e
      );
    })(),
    StepKey;
  !(function (e) {
    (e.LOAD_AD_PLUGIN = "loadAdPlugin"),
      (e.CREATE_PLUGIN_PREFIX = "cp"),
      (e.SESSION_START_EVT = "startEvt"),
      (e.CREATE_FLOW_NODES = "createFlow"),
      (e.GETINFO = "infoReq"),
      (e.GETINFO_END = "infoEndEvt"),
      (e.PRE_AD_FLOW_NODE = "preAdFlow"),
      (e.AD_CDN_REQ = "adCdnReq"),
      (e.V_CDN_REQ = "cdnReq");
  })(StepKey || (StepKey = {}));
  var PluginablePlayer = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.plugins = {}),
          (t.pluginMsg = new s$1$1()),
          (t.playerApiProxy = {}),
          (t.pluginMsgProxy = {
            on: t.pluginMsg.on.bind(t.pluginMsg),
            off: t.pluginMsg.off.bind(t.pluginMsg),
            once: t.pluginMsg.once.bind(t.pluginMsg),
          }),
          (t._destroyed = !1),
          (t.loadPlugin = function (e) {
            var o = e.config,
              A = e.timeout,
              i = e.version,
              r = e.crossOrigin,
              n = e.globalName,
              a = e.pluginName,
              s = void 0 === a ? n : a,
              g = e.insName,
              l = e.url;
            if (!l && !PLUGIN_MAP[s])
              throw new Error(
                compile(i18nConfig.h5player.ERROR_UNOFFICIAL_PLUGIN_NEEDS_URL)
              );
            if (!l && PLUGIN_MAP[s]) {
              var E = i || PLUGIN_MAP[s].version,
                c = PLUGIN_MAP[s].cdnPath || "thumbplayer-plugin-".concat(s);
              (s = PLUGIN_MAP[s].pluginName || s),
                (l = "https://vm.gtimg.cn/thumbplayer/plugins/"
                  .concat(c, "/")
                  .concat(E, "/index.min.js"));
            }
            return (
              (g = g || s),
              s === AdPluginName && StepTimer.start(StepKey.LOAD_AD_PLUGIN),
              domTool$1
                .loadScript(l, void 0, A, { crossOrigin: r })
                .then(function () {
                  t._destroyed ||
                    (s === AdPluginName &&
                      StepTimer.end(StepKey.LOAD_AD_PLUGIN),
                    getPlugin(s) || registerPlugin(s, window[n]),
                    t.plugins[g] ||
                      t.createPlugin(
                        g,
                        __assign$1(__assign$1({}, o), { pluginName: s })
                      ));
                })
            );
          }),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.createPlugin = function (e, t) {
          void 0 === t && (t = {});
          var o = t.pluginName,
            A = void 0 === o ? e : o,
            i = getPlugin(A);
          if (!i) throw new Error("cannot find plugin: ".concat(A));
          this.triggerSetupEvent({ name: e, plugin: i, instance: null }, !0),
            createPluginFactory(e, i, this, t, {
              msg: this.pluginMsgProxy,
              api: this.playerApiProxy,
            }),
            A === AdPluginName &&
              (setAdPlugin(this.config.instanceId, this.plugins[AdPluginName]),
              delete this.plugins[AdPluginName]),
            this.triggerSetupEvent({ name: e, plugin: i, instance: null });
        }),
        (t.prototype.createPlugins = function (e) {
          var t = this;
          e.forEach(function (e) {
            try {
              "string" == typeof e
                ? t.createPlugin(e)
                : t.createPlugin.apply(t, e);
            } catch (e) {
              console.error(e);
            }
          });
        }),
        (t.prototype.destroy = function () {
          this.removeAllListeners(),
            this.pluginMsg.removeAllListeners(),
            (this._destroyed = !0);
        }),
        (t.prototype.triggerSetupEvent = function (e, t) {
          var o = this;
          void 0 === t && (t = !1);
          var A = "".concat(t ? "before" : "", "pluginsetup");
          setTimeout(function () {
            o.pluginMsg.emit("".concat(A, ":").concat(e.name), e);
          });
        }),
        (t.registerPlugin = registerPlugin),
        (t.deregisterPlugin = deregisterPlugin),
        (t.getPlugins = getPlugins),
        (t.getPlugin = getPlugin),
        (t.isFunctionPlugin = isFunctionPlugin),
        (t.pluginExists = pluginExists),
        (t.isBasicPlugin = isFunctionPlugin),
        t
      );
    })(s$1$1),
    FlowNodeReqInfo = (function () {
      function e(e) {
        (this.getinfoOutputCacheInner = void 0), (this.config = e);
      }
      return (
        Object.defineProperty(e.prototype, "getinfoOutputCache", {
          get: function () {
            return this.getinfoOutputCacheInner;
          },
          set: function (e) {
            (this.getinfoOutputCacheInner = e),
              (this.adInfoCacheInner = null == e ? void 0 : e.adInfo);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "adInfoCache", {
          get: function () {
            return this.adInfoCacheInner;
          },
          set: function (e) {
            this.adInfoCacheInner = e;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "startParam", {
          get: function () {
            return this.config.startParam;
          },
          set: function (e) {
            this.config.startParam = e;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "flowid", {
          get: function () {
            return this.config.flowid;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "instanceId", {
          get: function () {
            return this.config.instanceId;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "videoLoadParam", {
          get: function () {
            return this.config.startParam.videoLoadParam;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "videoReqInfoParam", {
          get: function () {
            return this.config.startParam.videoReqInfoParam;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "vid", {
          get: function () {
            return this.config.startParam.vid;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "adParam", {
          get: function () {
            return this.config.startParam.adParam;
          },
          enumerable: !1,
          configurable: !0,
        }),
        e
      );
    })(),
    RetryManager = (function () {
      function e(e) {
        var t,
          o = this;
        (this.player = e),
          (this.retryCheckers = []),
          (this.retryTimesInSession = 0),
          (this.onPlaySessionStartHandler = function () {
            (o.retryTimesInSession = 0),
              o.retryCheckers.forEach(function (e) {
                return e.onSessionStart();
              });
          }),
          (this.onVideoPlaying = function () {
            o.retryCheckers.forEach(function (e) {
              return e.onRetrySucc();
            });
          }),
          (this.checkerEvtHandler = function (e) {
            var t;
            if (o.player.canGetinfoRetry()) {
              var A = o.getHitChecker(e);
              if (A) {
                var i = A.outOfTimes,
                  r = void 0 !== i && i,
                  n = o.player.config,
                  a = n.type,
                  s = n.maxRetryGetinfoTimesInLiveSession,
                  g = n.maxRetryGetinfoTimesInVodSession;
                o.retryTimesInSession >=
                  (a === exports.PLAY_MODE.LIVE ? s : g) && (r = !0),
                  o.retryTimesInSession++,
                  o.logger.log(
                    "retry on "
                      .concat(e.type, ",\n    outOfTimes=")
                      .concat(r, ",\n    retryTimes=")
                      .concat(A.retryTimes, ", retryTimesInSession=")
                      .concat(o.retryTimesInSession, ",\n    playParam=")
                      .concat(
                        jsonTool$1.safelyStringify(A.updatePlayParam),
                        ",\n    error="
                      )
                      .concat(
                        null === (t = A.error) || void 0 === t ? void 0 : t.code
                      )
                  ),
                  o.player.startGetinfoRetry(A, r);
              }
            }
          }),
          this.player.getRetryCheckClasses().forEach(function (t) {
            o.retryCheckers.push(new t(e));
          }),
          (this.logger = new Logger(
            this.player.config.instanceId,
            "RetryManager"
          )),
          (this.evtMap =
            (((t = {})[exports.H5_PLAY_EVENT.PLAY_SESSION_START] =
              this.onPlaySessionStartHandler),
            (t[exports.H5_PLAY_EVENT.VIDEO_PLAYING] = this.onVideoPlaying),
            t)),
          this.setCheckEvents(!0),
          this.setPlayerEvents(!0);
      }
      return (
        (e.prototype.destroy = function () {
          this.setCheckEvents(!1),
            this.setPlayerEvents(!1),
            this.retryCheckers.forEach(function (e) {
              return e.destroy();
            }),
            (this.player = null),
            (this.retryCheckers = null);
        }),
        (e.prototype.getHitChecker = function (e) {
          for (var t = 0; t < this.retryCheckers.length; t++) {
            var o = this.retryCheckers[t];
            if (o.checkEvt === e.type) {
              var A = o.check(e);
              if (A) return this.logger.log("checker hit ".concat(o.name)), A;
            }
          }
          return null;
        }),
        (e.prototype.setCheckEvents = function (e) {
          var t = this;
          void 0 === e && (e = !0);
          for (
            var o = e ? this.player.on : this.player.off, A = [], i = 0;
            i < this.retryCheckers.length;
            i++
          )
            -1 === A.indexOf(this.retryCheckers[i].checkEvt) &&
              A.push(this.retryCheckers[i].checkEvt);
          A.forEach(function (e) {
            o.call(t.player, e, t.checkerEvtHandler);
          });
        }),
        (e.prototype.setPlayerEvents = function (e) {
          var t = this,
            o = e ? this.player.on : this.player.off;
          Object.keys(this.evtMap).forEach(function (e) {
            o.call(t.player, e, t.evtMap[e]);
          });
        }),
        e
      );
    })(),
    BaseCheck = (function () {
      function e(e) {
        (this.name = ""),
          (this.checkEvt = null),
          (this.retryTimes = 0),
          (this.player = e),
          (this.logger = new Logger(
            this.player.config.instanceId,
            "RetryChecker"
          ));
      }
      return (
        (e.prototype.destroy = function () {
          this.player = null;
        }),
        (e.prototype.onSessionStart = function () {
          this.retryTimes = 0;
        }),
        (e.prototype.onRetrySucc = function () {
          this.retryTimes = 0;
        }),
        (e.prototype.check = function (e) {
          return null;
        }),
        (e.prototype.getRetryConfig = function (e) {
          var t = e.playtime;
          return {
            error: e.error,
            updatePlayParam: {
              videoReqInfoParam: {},
              videoLoadParam: { startTime: t, kernelName: void 0 },
            },
            retryTimes: this.retryTimes,
          };
        }),
        e
      );
    })(),
    REC_PLAY_TIME_INIT_VALUE = -1,
    RetryNames$1 = { CheckNormalError: "CheckNormalError" },
    CheckNormalError = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.name = RetryNames$1.CheckNormalError),
          (t.checkEvt = exports.PLAY_EVENT.ERROR),
          (t.stateWhenErrorHappen = null),
          (t.playtimeWhenErrorHappen = REC_PLAY_TIME_INIT_VALUE),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.check = function (e) {
          var t = e.data.videoInfo.error,
            o = this.player.config.maxRetryGetinfoTimes;
          return t.type === BuiltInErrorType.Encryption || this.retryTimes >= o
            ? { outOfTimes: !0, error: t, retryTimes: this.retryTimes }
            : this.checkNormalErrorCode(e);
        }),
        (t.prototype.onRetrySucc = function () {
          e.prototype.onRetrySucc.call(this),
            (this.stateWhenErrorHappen = null),
            (this.playtimeWhenErrorHappen = REC_PLAY_TIME_INIT_VALUE);
        }),
        (t.prototype.updateRetryTimes = function () {
          this.retryTimes += 1;
        }),
        (t.prototype.checkNormalErrorCode = function (e) {
          var t,
            o = e.data.videoInfo,
            A = o.stateWhenErrorHappen,
            i = o.playtime;
          null === this.stateWhenErrorHappen && (this.stateWhenErrorHappen = A),
            this.playtimeWhenErrorHappen === REC_PLAY_TIME_INIT_VALUE &&
              (this.playtimeWhenErrorHappen = i),
            this.updateRetryTimes();
          var r = this.getRetryConfig(o);
          return (
            (r.stateWhenErrorHappen = this.stateWhenErrorHappen),
            this.playtimeWhenErrorHappen !== REC_PLAY_TIME_INIT_VALUE &&
              (null === (t = null == r ? void 0 : r.updatePlayParam) ||
              void 0 === t
                ? void 0
                : t.videoLoadParam) &&
              this.player.config.type === exports.PLAY_MODE.VOD &&
              (r.updatePlayParam.videoLoadParam.startTime =
                this.playtimeWhenErrorHappen),
            r
          );
        }),
        t
      );
    })(BaseCheck);
  function definePlugins(e) {
    return e.map(function (e) {
      return [e[0].pluginName, e[1]];
    });
  }
  function autobind(e) {
    return function (t, o, A) {
      var i = e;
      if (!i) {
        var r = "on".length,
          n = o.slice(r).toLowerCase(),
          a = Object.keys(exports.PLAY_EVENT).find(function (e) {
            return exports.PLAY_EVENT[e].toLowerCase() === n;
          });
        a
          ? (i = exports.PLAY_EVENT[a])
          : ((a = Object.keys(exports.H5_PLAY_EVENT).find(function (e) {
              return exports.H5_PLAY_EVENT[e].toLowerCase() === n;
            })),
            (i = exports.H5_PLAY_EVENT[a]));
      }
      var s = A.value;
      A.value = function () {
        for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
        i && this.player ? this.player.on(i, s.bind(this)) : s.apply(this, e);
      };
    };
  }
  var logApiInvoke = function (e, t, o) {
      var A = o.value;
      o.value = function () {
        for (var e = [], o = 0; o < arguments.length; o++) e[o] = arguments[o];
        var i = "";
        try {
          i = JSON.stringify(e);
        } catch (e) {
          i = "parse arg failed";
        }
        return (
          this.setStateKv(t, {
            type: exports.LOG_TYPE.API_INVOKE,
            ftime: Date.now(),
            ext: { from: "thumbplayer-h5", args: i },
          }),
          A.apply(this, e)
        );
      };
    },
    once = function (e, t, o) {
      var A = o.value;
      o.value = function () {
        for (var e = [], o = 0; o < arguments.length; o++) e[o] = arguments[o];
        if (!this["__hasRun".concat(t)])
          return (this["__hasRun".concat(t)] = !0), A.apply(this, e);
      };
    };
  function tryEmit(e, t) {
    try {
      e();
    } catch (e) {
      null == t || t.error(e);
    }
  }
  function getEnvVals$1() {
    var e = "";
    try {
      e = "1.28.0";
    } catch (e) {}
    var t = "";
    try {
      t = 1697609999408;
    } catch (e) {}
    var o = !1;
    try {
      o = !1;
    } catch (e) {}
    return {
      VERSION: o ? "".concat(e, "-beta") : e,
      BUILD_TIME: t,
      IS_BETA: o,
    };
  }
  var BaseFlowNode = (function (e) {
      function t(t) {
        var o = e.call(this) || this;
        return (o.config = t), (o.isDestroyedInner = !1), o;
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "flowid", {
          get: function () {
            return this.config.reqInfo.flowid;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "extEvtDispatcher", {
          get: function () {
            return this.config.extEvtDispatcher;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "instanceId", {
          get: function () {
            return this.config.reqInfo.instanceId;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "reqInfo", {
          get: function () {
            return this.config.reqInfo;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "isDestroyed", {
          get: function () {
            return this.isDestroyedInner;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.destroy = function () {
          (this.config = null),
            (this.isDestroyedInner = !0),
            this.removeAllListeners();
        }),
        (t.prototype.getName = function () {
          return "";
        }),
        (t.prototype.pause = function (e) {}),
        (t.prototype.resume = function () {}),
        (t.prototype.replay = function (e, t) {
          return Promise.reject(
            "replay not implemented! (".concat(this.getName(), ")")
          );
        }),
        (t.prototype.start = function () {
          return Promise.resolve();
        }),
        (t.prototype.preload = function (e) {
          return Promise.resolve();
        }),
        (t.prototype.retry = function (e, t) {}),
        (t.prototype.emitFlowEvt = function (e, t) {
          this.emit(e, __assign$1({ name: this.getName() }, t));
        }),
        t
      );
    })(s$1$1),
    FLOW_NODE_EVENT;
  (exports.FLOW_NODE_EVENT = void 0),
    (FLOW_NODE_EVENT =
      exports.FLOW_NODE_EVENT || (exports.FLOW_NODE_EVENT = {})),
    (FLOW_NODE_EVENT.PRELOAD_NEXT = "PRELOAD_NEXT"),
    (FLOW_NODE_EVENT.PRELOAD = "PRELOAD"),
    (FLOW_NODE_EVENT.START = "START"),
    (FLOW_NODE_EVENT.END = "END"),
    (FLOW_NODE_EVENT.ABORT = "ABORT"),
    (FLOW_NODE_EVENT.VIDEO_SETLEVEL_START = "VIDEO_SETLEVEL_START"),
    (FLOW_NODE_EVENT.VIDEO_SETLEVEL_END = "VIDEO_SETLEVEL_END"),
    (FLOW_NODE_EVENT.VIDEO_REQ_INFO_START = "VIDEO_REQ_INFO_START"),
    (FLOW_NODE_EVENT.VIDEO_REQ_INFO_END = "VIDEO_REQ_INFO_END"),
    (FLOW_NODE_EVENT.SESSION_FIRST_PLAYING = "SESSION_FIRST_PLAYING");
  var AdFlowNode = (function (e) {
      function t(t) {
        var o,
          A = this;
        return (
          ((A = e.call(this, t) || this).enableP2P = !1),
          (A.isFirstPlaying = !1),
          (A.onAdCountdown = function (e) {
            var t = e.data;
            t.adType !== exports.AD_TYPE.PRE ||
              !A.enableP2P ||
              t.countdown > 60 ||
              (A.preloadNext(!1),
              preloadEvtBus.emit(PRELOAD_EVENT.UPDATE, {
                instanceId: A.instanceId,
                remainTime: t.countdown,
              }));
          }),
          (A.onAdEnd = function (e) {
            var t,
              o = e.data;
            o.adType === exports.AD_TYPE.PRE &&
              (A.corePlayer.volume =
                null === (t = getAdPlugin(A.instanceId)) || void 0 === t
                  ? void 0
                  : t.getAdVolume()),
              A.isInValidAd(o) || A.endFlow();
          }),
          (A.onAdAssetsLoaded = function (e) {
            var t = e.data;
            A.isInValidAd(t) || A.preloadNext(!1);
          }),
          (A.onAdPlayBlocked = function (e) {
            var t = e.data;
            A.isInValidAd(t) || (A.isPreload = !0);
          }),
          (A.onAdPlaying = function () {
            A.onFirstPlaying();
          }),
          (A.onAdTimeUpdate = function () {
            A.onFirstPlaying();
          }),
          (A.logger = new Logger(A.instanceId, "AdFlowNode")),
          (A.adType = t.adType),
          (A.corePlayer = t.corePlayer),
          (A.enableP2P = t.enableP2P),
          null === (o = getAdPlugin(A.instanceId)) ||
            void 0 === o ||
            o.on(exports.H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, A.onAdPlayBlocked),
          A
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.getName = function () {
          return "AdFlowNode.".concat(this.adType);
        }),
        (t.prototype.start = function () {
          return (
            this.timeStart(StepKey.PRE_AD_FLOW_NODE),
            this.logger.log("".concat(this.getName(), " exec start")),
            this.emitFlowEvt(exports.FLOW_NODE_EVENT.START),
            this.checkCanPlayAd()
              ? ((this.isPreload = !1), this.bindAdEvents(), this.playAd())
              : (this.logger.log("".concat(this.getName(), " skip exec start")),
                void this.endFlow())
          );
        }),
        (t.prototype.preload = function () {
          var e;
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (t) {
              switch (t.label) {
                case 0:
                  if (
                    (this.logger.log(
                      "".concat(this.getName(), " exec preload")
                    ),
                    this.emitFlowEvt(exports.FLOW_NODE_EVENT.PRELOAD),
                    !this.checkCanPlayAd())
                  )
                    return (
                      this.logger.log(
                        "".concat(this.getName(), " skip exec preload")
                      ),
                      this.preloadNext(),
                      [2]
                    );
                  (this.isPreload = !0), this.bindAdEvents(), (t.label = 1);
                case 1:
                  return (
                    t.trys.push([1, 3, , 4]),
                    [
                      4,
                      null === (e = getAdPlugin(this.instanceId)) ||
                      void 0 === e
                        ? void 0
                        : e.loadAd(this.startParam),
                    ]
                  );
                case 2:
                  return !1 === t.sent() && this.preloadNext(), [3, 4];
                case 3:
                  return t.sent(), this.preloadNext(), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }),
        (t.prototype.pause = function () {
          var e;
          this.logger.log("".concat(this.getName(), " exec pause"));
          try {
            null === (e = getAdPlugin(this.instanceId)) ||
              void 0 === e ||
              e.pauseAd(this.adType);
          } catch (e) {
            this.logger.error("call adPlugin::pauseAd", e);
          }
        }),
        (t.prototype.resume = function () {
          var e;
          this.logger.log("".concat(this.getName(), " exec resume"));
          try {
            null === (e = getAdPlugin(this.instanceId)) ||
              void 0 === e ||
              e.resumeAd(this.adType);
          } catch (e) {
            this.logger.error("call adPlugin::resumeAd", e);
          }
        }),
        (t.prototype.destroy = function () {
          if (!this.isDestroyed) {
            var t = getAdPlugin(this.instanceId);
            t &&
              (t.off(
                exports.PLAY_EVENT_EXT.AD_COUNTDOWN_CHANGE,
                this.onAdCountdown
              ),
              t.off(exports.H5_PLAY_EVENT.AD_END, this.onAdEnd),
              t.off(exports.H5_PLAY_EVENT.AD_PLAYING, this.onAdPlaying),
              t.off(exports.H5_PLAY_EVENT.AD_TIME_UPDATE, this.onAdTimeUpdate),
              t.off(
                exports.H5_PLAY_EVENT.AD_ASSETS_LOADED,
                this.onAdAssetsLoaded
              ),
              t.off(
                exports.H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED,
                this.onAdPlayBlocked
              )),
              (this.corePlayer = null),
              e.prototype.destroy.call(this);
          }
        }),
        (t.prototype.checkCanPlayAd = function () {
          var e = this.instanceId,
            t = this.reqInfo,
            o = getAdPlugin(e);
          if (!o || !this.startParam) return !1;
          var A = !0;
          if (null == t ? void 0 : t.adInfoCache) {
            try {
              o.setAdInfo(t.adInfoCache);
            } catch (e) {
              this.logger.error("checkCanPlayAd, call adPlugin::setAdInfo", e),
                (A = !1);
            }
            t.adInfoCache = void 0;
          }
          return A;
        }),
        (t.prototype.bindAdEvents = function () {
          var e = getAdPlugin(this.instanceId);
          e &&
            (e.on(
              exports.PLAY_EVENT_EXT.AD_COUNTDOWN_CHANGE,
              this.onAdCountdown
            ),
            e.on(exports.H5_PLAY_EVENT.AD_PLAYING, this.onAdPlaying),
            e.on(exports.H5_PLAY_EVENT.AD_TIME_UPDATE, this.onAdTimeUpdate),
            e.on(exports.H5_PLAY_EVENT.AD_END, this.onAdEnd),
            e.on(
              exports.H5_PLAY_EVENT.AD_ASSETS_LOADED,
              this.onAdAssetsLoaded
            ));
        }),
        (t.prototype.playAd = function () {
          var e,
            t = this;
          return (
            this.timeStart(StepKey.AD_CDN_REQ),
            null === (e = getAdPlugin(this.instanceId)) || void 0 === e
              ? void 0
              : e.playAd(this.startParam).catch(function () {
                  return t.endFlow();
                })
          );
        }),
        Object.defineProperty(t.prototype, "startParam", {
          get: function () {
            return __assign$1(
              { adType: this.adType },
              this.reqInfo.startParam.adParam
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.preloadNext = function (e) {
          void 0 === e && (e = !0),
            this.emit(exports.FLOW_NODE_EVENT.PRELOAD_NEXT, {
              name: this.getName(),
              forceLoad: e,
            });
        }),
        (t.prototype.endFlow = function () {
          this.timeEnd(StepKey.PRE_AD_FLOW_NODE),
            this.emitFlowEvt(exports.FLOW_NODE_EVENT.END),
            this.destroy();
        }),
        (t.prototype.isInValidAd = function (e) {
          return e.adType !== this.adType;
        }),
        (t.prototype.timeStart = function (e) {
          this.adType === exports.AD_TYPE.PRE &&
            StepTimer.start(e, this.instanceId);
        }),
        (t.prototype.timeEnd = function (e) {
          this.adType === exports.AD_TYPE.PRE &&
            StepTimer.end(e, this.instanceId);
        }),
        (t.prototype.onFirstPlaying = function () {
          this.isFirstPlaying ||
            (this.adType === exports.AD_TYPE.PRE &&
              ((this.isFirstPlaying = !0),
              this.timeEnd(StepKey.AD_CDN_REQ),
              this.emit(exports.FLOW_NODE_EVENT.SESSION_FIRST_PLAYING, {
                name: this.getName(),
              })));
        }),
        __decorate(
          [
            once,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "bindAdEvents",
          null
        ),
        __decorate(
          [
            once,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "preloadNext",
          null
        ),
        t
      );
    })(BaseFlowNode),
    FlowManager = (function () {
      function e(e) {
        (this.config = e),
          (this.flowNodeList = []),
          (this.currentFlowNodeIndex = 0),
          (this.lastNodeList = []),
          (this.logger = new Logger(e.playerInstanceId, "FlowManager"));
      }
      return (
        Object.defineProperty(e.prototype, "onFlowEnd", {
          get: function () {
            return this.config.onFlowEnd || function () {};
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "onFlowEvts", {
          get: function () {
            return this.config.onFlowEvts || function () {};
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "currentFlowNode", {
          get: function () {
            return this.flowNodeList[this.currentFlowNodeIndex];
          },
          enumerable: !1,
          configurable: !0,
        }),
        (e.prototype.push = function () {
          for (var e, t = this, o = [], A = 0; A < arguments.length; A++)
            o[A] = arguments[A];
          o.forEach(function (e) {
            return t.bindNodeEvents(e);
          }),
            (e = this.flowNodeList).push.apply(e, o);
        }),
        (e.prototype.setLastNode = function (e) {
          this.lastNodeList.push(e);
        }),
        (e.prototype.clear = function () {
          this.flowNodeList.forEach(function (e) {
            return e.destroy();
          }),
            (this.flowNodeList = []),
            (this.lastNodeList = []),
            (this.currentFlowNodeIndex = 0);
        }),
        (e.prototype.bindNodeEvents = function (e) {
          var t,
            o = this,
            A =
              (((t = {})[exports.FLOW_NODE_EVENT.PRELOAD_NEXT] = function (t) {
                var A,
                  i = t.data;
                o.logger.log(
                  "".concat(
                    e.getName(),
                    " emited: FLOW_NODE_EVENT.PRELOAD_NEXT"
                  )
                ),
                  (o.config.disablePreload &&
                    !(null == i ? void 0 : i.forceLoad)) ||
                    null === (A = o.getNextNode(e)) ||
                    void 0 === A ||
                    A.preload(!!(null == i ? void 0 : i.forceLoad));
              }),
              (t[exports.FLOW_NODE_EVENT.END] = function (t) {
                var A = t.data;
                o.logger.log(
                  "".concat(e.getName(), " emited: FLOW_NODE_EVENT.END")
                ),
                  A.videoEndState && (o.videoEndState = A.videoEndState),
                  e.removeAllListeners();
                var i = o.getNextNode(e);
                if (!i) {
                  var r = e.getName();
                  return (
                    o.logger.log("no next node after ".concat(r, ", clear")),
                    o.clear(),
                    o.onFlowEnd({
                      code: exports.ErrorCode.SUC,
                      endState: o.videoEndState,
                      curFlowNodeName: r,
                    }),
                    void (o.videoEndState = "")
                  );
                }
                if (o.lastNodeList.includes(e)) {
                  r = e.getName();
                  return (
                    o.logger.log("lastNodeList includes ".concat(r, ", end")),
                    o.onFlowEnd({
                      code: exports.ErrorCode.SUC,
                      curFlowNodeName: r,
                    })
                  );
                }
                (o.currentFlowNodeIndex += 1),
                  o.logger.log(
                    "next node start, current index is ".concat(
                      o.currentFlowNodeIndex
                    )
                  ),
                  i.start();
              }),
              (t[exports.FLOW_NODE_EVENT.ABORT] = function (t) {
                var A = t.data,
                  i = e.getName();
                o.logger.log("".concat(i, " emited: FLOW_NODE_EVENT.ABORT")),
                  o.clear(),
                  o.onFlowEnd(
                    __assign$1(__assign$1({}, A), {
                      endState: A.endState || exports.END_STATE.ERROR,
                      curFlowNodeName: i,
                    })
                  );
              }),
              t);
          Object.keys(exports.FLOW_NODE_EVENT).forEach(function (t) {
            e.on(exports.FLOW_NODE_EVENT[t], function (e) {
              var t = e.type,
                i = e.data;
              o.onFlowEvts(t, i), A[t] && A[t]({ data: i });
            });
          });
        }),
        (e.prototype.getNextNode = function (e) {
          var t = this.flowNodeList.indexOf(e);
          if (-1 !== t) return this.flowNodeList[t + 1];
        }),
        e
      );
    })(),
    GetAdinfoFlowNode = (function (e) {
      function t(t) {
        var o = e.call(this, t) || this;
        return (
          (o.flowNodeConfig = t),
          (o.logger = new Logger(o.instanceId, "GetAdinfoFlowNode")),
          o
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.destroy = function () {
          e.prototype.destroy.call(this), (this.flowNodeConfig = null);
        }),
        (t.prototype.getName = function () {
          return "GetAdinfoFlowNode";
        }),
        (t.prototype.start = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            var e;
            return __generator$1(this, function (t) {
              switch (t.label) {
                case 0:
                  return (
                    this.emitFlowEvt(exports.FLOW_NODE_EVENT.START),
                    (this.isPreload = !1),
                    this.loadDefer ? [4, this.loadDefer] : [3, 2]
                  );
                case 1:
                case 3:
                  return t.sent(), [3, 5];
                case 2:
                  return (
                    t.trys.push([2, 4, , 5]),
                    [
                      4,
                      this.requestProxyHttpWithParams(
                        this.flowNodeConfig.adType
                      ),
                    ]
                  );
                case 4:
                  return (
                    (e = t.sent()),
                    this.logger.error(
                      ""
                        .concat(this.getName(), " start err=")
                        .concat(null == e ? void 0 : e.message)
                    ),
                    [3, 5]
                  );
                case 5:
                  return this.emitFlowEvt(exports.FLOW_NODE_EVENT.END), [2];
              }
            });
          });
        }),
        (t.prototype.pause = function () {}),
        (t.prototype.resume = function () {}),
        (t.prototype.preload = function () {
          var e = this;
          return (
            this.emitFlowEvt(exports.FLOW_NODE_EVENT.PRELOAD),
            (this.isPreload = !0),
            (this.loadDefer = this.requestProxyHttpWithParams(
              this.flowNodeConfig.adType
            )
              .then(function () {
                e.emitFlowEvt(exports.FLOW_NODE_EVENT.PRELOAD_NEXT);
              })
              .catch(function (t) {
                e.logger.error(
                  ""
                    .concat(e.getName(), " preload err=")
                    .concat(null == t ? void 0 : t.message)
                );
              })),
            this.loadDefer
          );
        }),
        (t.prototype.requestProxyHttpWithParams = function (e) {
          var t, o;
          return __awaiter$1(this, void 0, void 0, function () {
            var A;
            return __generator$1(this, function (i) {
              switch (i.label) {
                case 0:
                  return [
                    4,
                    null ===
                      (o = (t = this.flowNodeConfig).requestAdCallback) ||
                    void 0 === o
                      ? void 0
                      : o.call(t, e),
                  ];
                case 1:
                  return (
                    (A = i.sent()),
                    this.isDestroyed
                      ? [2, new Promise(function () {})]
                      : A
                      ? ((this.reqInfo.adInfoCache = A), [2])
                      : (this.logger.warn("no ad info"), [2])
                  );
              }
            });
          });
        }),
        t
      );
    })(BaseFlowNode),
    performanceCost$1$1 = performanceCostDecoratorCreator(
      "GetVideoInfoFlowNode"
    ),
    GetVideoInfoFlowNode = (function (e) {
      function t(t) {
        var o = e.call(this, t) || this;
        return (o.logger = new Logger(o.instanceId, "GetVideoInfoFlowNode")), o;
      }
      return (
        __extends$1(t, e),
        (t.prototype.destroy = function () {
          (this.logger = null),
            (this.loadDefer = null),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.getName = function () {
          return "GetVideoInfoFlowNode";
        }),
        (t.prototype.start = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (e) {
              switch (e.label) {
                case 0:
                  return (
                    this.emitFlowEvt(exports.FLOW_NODE_EVENT.START),
                    (this.isPreload = !1),
                    this.loadDefer ? [4, this.loadDefer] : [3, 2]
                  );
                case 1:
                  return e.sent(), [3, 4];
                case 2:
                  return [4, this.request()];
                case 3:
                  e.sent(), (e.label = 4);
                case 4:
                  return (
                    this.isDestroyed ||
                      this.emitFlowEvt(exports.FLOW_NODE_EVENT.END),
                    [2]
                  );
              }
            });
          });
        }),
        (t.prototype.pause = function () {}),
        (t.prototype.resume = function () {}),
        (t.prototype.preload = function () {
          var e = this;
          return (
            this.emitFlowEvt(exports.FLOW_NODE_EVENT.PRELOAD),
            (this.isPreload = !0),
            (this.loadDefer = this.request().then(function () {
              e.emitFlowEvt(exports.FLOW_NODE_EVENT.PRELOAD_NEXT, {
                forceLoad: !0,
              });
            })),
            this.loadDefer
          );
        }),
        (t.prototype.request = function () {
          var e = this;
          return this.requestProxyHttpWithParams(exports.AD_TYPE.PRE).catch(
            function (t) {
              if (!e.isDestroyed) {
                var o = t || {},
                  A = o.code,
                  i = void 0 === A ? exports.ErrorCode.GETINFO_INNER : A,
                  r = o.message,
                  n =
                    void 0 === r
                      ? compile(i18nConfig.h5player.ERROR_GETINFO_INNER)
                      : r,
                  a = o.stack,
                  s = void 0 === a ? "" : a;
                e.logger.error(
                  "浠ｇ爜寮傚父, code="
                    .concat(i, ", msg=")
                    .concat(n, ", stack=")
                    .concat(s)
                ),
                  e.emitFlowEvt(exports.FLOW_NODE_EVENT.ABORT, {
                    code: i,
                    message: n,
                    stack: s,
                  });
              }
            }
          );
        }),
        (t.prototype.requestProxyHttpWithParams = function (e) {
          var t;
          return __awaiter$1(this, void 0, void 0, function () {
            var o;
            return __generator$1(this, function (A) {
              switch (A.label) {
                case 0:
                  return this.reqInfo.getinfoOutputCache
                    ? (this.requestFromPreSessionGetinfoCache(
                        this.reqInfo.getinfoOutputCache
                      ),
                      [2])
                    : (this.emitFlowEvt(
                        exports.FLOW_NODE_EVENT.VIDEO_REQ_INFO_START
                      ),
                      StepTimer.start(StepKey.GETINFO, this.instanceId),
                      [
                        4,
                        doGetinfo(this.instanceId, this.reqInfo, {
                          adType: e,
                          emitGetinfoEvts: !0,
                        }),
                      ]);
                case 1:
                  if (((o = A.sent()), this.isDestroyed))
                    return [2, new Promise(function () {})];
                  if (
                    (StepTimer.end(StepKey.GETINFO, this.instanceId),
                    this.emitFlowEvt(
                      exports.FLOW_NODE_EVENT.VIDEO_REQ_INFO_END,
                      {
                        code:
                          (null === (t = null == o ? void 0 : o.error) ||
                          void 0 === t
                            ? void 0
                            : t.code) || exports.ErrorCode.SUC,
                        data: o,
                      }
                    ),
                    null == o ? void 0 : o.error)
                  )
                    throw (
                      (this.logger.warn(
                        "proxyhttp request error data: ",
                        JSON.stringify(o.error)
                      ),
                      o.error)
                    );
                  return (this.reqInfo.getinfoOutputCache = o), [2];
              }
            });
          });
        }),
        (t.prototype.requestFromPreSessionGetinfoCache = function (e) {
          var t;
          return __awaiter$1(this, void 0, void 0, function () {
            var o = this;
            return __generator$1(this, function (A) {
              switch (A.label) {
                case 0:
                  return (
                    this.emitFlowEvt(
                      exports.FLOW_NODE_EVENT.VIDEO_REQ_INFO_START
                    ),
                    tryEmit(function () {
                      return o.extEvtDispatcher.emit(
                        exports.PLAY_EVENT_EXT.GETINFO_START,
                        e.reqParams
                      );
                    }, this.logger),
                    [4, 0]
                  );
                case 1:
                  return (
                    A.sent(),
                    this.emitFlowEvt(
                      exports.FLOW_NODE_EVENT.VIDEO_REQ_INFO_END,
                      {
                        code:
                          (null === (t = null == e ? void 0 : e.error) ||
                          void 0 === t
                            ? void 0
                            : t.code) || exports.ErrorCode.SUC,
                        data: e,
                      }
                    ),
                    tryEmit(function () {
                      return o.extEvtDispatcher.emit(
                        exports.PLAY_EVENT_EXT.GETINFO_OVER,
                        e
                      );
                    }, this.logger),
                    [2]
                  );
              }
            });
          });
        }),
        __decorate(
          [
            performanceCost$1$1,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "requestProxyHttpWithParams",
          null
        ),
        __decorate(
          [
            performanceCost$1$1,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "requestFromPreSessionGetinfoCache",
          null
        ),
        t
      );
    })(BaseFlowNode),
    PreloadFlowNode = (function (e) {
      function t(t) {
        var o = e.call(this, t) || this;
        return (
          (o.flowNodeConfig = t),
          (o.logger = new Logger(o.instanceId, "PreloadFlowNode")),
          o
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.getName = function () {
          return "PreloadFlowNode";
        }),
        (t.prototype.start = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            var e,
              t,
              o,
              A,
              i,
              r,
              n,
              a,
              s = this;
            return __generator$1(this, function (g) {
              switch (g.label) {
                case 0:
                  return (
                    (e = this.flowNodeConfig),
                    (t = e.videoEndTime),
                    (o = e.corePlayer),
                    (A = e.playerConfig),
                    [4, this.getNextSessionVideoInfo()]
                  );
                case 1:
                  return g.sent()
                    ? this.flowNodeConfig.playerConfig.maxVideoNodeCount <= 1
                      ? [2]
                      : [4, this.loadAd()]
                    : [2];
                case 2:
                  return (
                    !1 !== g.sent() ||
                      ((i = this.reqInfo.getinfoOutputCache),
                      this.extEvtDispatcher.emit(
                        exports.PLAY_EVENT_EXT.PRELOAD_GETINFO_OVER,
                        i
                      ),
                      (r = i.kernelName),
                      (n = i.urlConfig),
                      (this.preloadKernel = r),
                      preloadEvtBus.emit(PRELOAD_EVENT.START, {
                        kernelName: r,
                        urlConfig: n,
                        instanceId: this.instanceId,
                        videoLoadParam: this.reqInfo.videoLoadParam,
                        playerConfig: A,
                      }),
                      this.logger.log("start; kernelName=".concat(r)),
                      (a = -1),
                      (this.preloadLoop = new TaskLoop(function () {
                        var e = t || o.duration,
                          A = Math.floor(Math.max(e - o.playtime, 0));
                        a !== A &&
                          ((a = A),
                          preloadEvtBus.emit(PRELOAD_EVENT.UPDATE, {
                            kernelName: r,
                            remainTime: A,
                          }),
                          s.logger.log(
                            "update; kernelName="
                              .concat(r, ", remainTime=")
                              .concat(A)
                          ),
                          A || s.preloadLoop.destroy());
                      }, LoopMode$1.Timer)),
                      this.preloadLoop.start(LOOP_INTERVAL)),
                    [2]
                  );
              }
            });
          });
        }),
        (t.prototype.loadAd = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            var e, t;
            return __generator$1(this, function (o) {
              if (
                ((e = this.config.reqInfo),
                !(t = getAdPlugin(this.instanceId)) || !e)
              )
                return [2, !1];
              if (e.adInfoCache)
                try {
                  t.setAdInfo(e.adInfoCache);
                } catch (e) {
                  this.logger.error("loadAd, call adPlugin::setAdInfo", e);
                }
              return [
                2,
                t
                  .loadAd(
                    __assign$1({ adType: exports.AD_TYPE.PRE }, e.adParam)
                  )
                  .catch(function () {
                    return !1;
                  }),
              ];
            });
          });
        }),
        (t.prototype.destroy = function () {
          var t;
          e.prototype.destroy.call(this),
            preloadEvtBus.emit(PRELOAD_EVENT.STOP, {
              kernelName: this.preloadKernel,
            }),
            this.logger.log("stop; kernelName=".concat(this.preloadKernel)),
            null === (t = this.preloadLoop) || void 0 === t || t.destroy(),
            (this.flowNodeConfig = null);
        }),
        (t.prototype.getNextSessionVideoInfo = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            var e;
            return __generator$1(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    doGetinfo(this.instanceId, this.reqInfo, {
                      adType: exports.AD_TYPE.PRE,
                      emitGetinfoEvts: !1,
                    }),
                  ];
                case 1:
                  return (
                    (e = t.sent()),
                    this.isDestroyed
                      ? [2, !1]
                      : !(null == e ? void 0 : e.urlConfig) || e.error
                      ? (this.logger.error("preload() error; urlConfig=", e),
                        [2, !1])
                      : ((this.reqInfo.getinfoOutputCache = e), [2, !0])
                  );
              }
            });
          });
        }),
        t
      );
    })(BaseFlowNode),
    LOOP_INTERVAL = 1e3,
    VideoFlowNode = (function (e) {
      function t(t) {
        var o,
          A,
          i = this;
        return (
          ((i = e.call(this, t) || this).flowNodeConfig = t),
          (i.isReplaying = !1),
          (i.onStateChange = function (e) {
            e.data.new === exports.VIDEO_STATE.PLAYING && (i.isReplaying = !1);
          }),
          (i.onVideoPlayBlocked = function () {
            return (i.isPreload = !0);
          }),
          (i.onVideoTimeUpdate = function () {
            var e;
            if (!i.isLive) {
              var t =
                null !== (e = i.startParam.postAdReqLeftTime) && void 0 !== e
                  ? e
                  : 10;
              Number.isNaN(t) ||
                (i.corePlayer.playtime + t >= i.corePlayer.duration &&
                  i.emitPreloadNext());
            }
          }),
          (i.onVideoStop = function (e) {
            var t,
              o = e.data;
            if (i.isReplaying) i.isReplaying = !1;
            else if (
              !(null === (t = o.videoInfo) || void 0 === t ? void 0 : t.error)
            ) {
              i.flowOverHandler();
              var A = o.isUserStop
                ? exports.FLOW_NODE_EVENT.ABORT
                : exports.FLOW_NODE_EVENT.END;
              i.emit(A, { videoEndState: o.endState, name: i.getName() });
            }
          }),
          (i.onVideoError = function (e) {
            var t,
              o = e.data;
            if (!i.startParam.vid) {
              var A =
                null === (t = null == o ? void 0 : o.videoInfo) || void 0 === t
                  ? void 0
                  : t.error;
              i.flowOverHandler(),
                i.emitFlowEvt(
                  exports.FLOW_NODE_EVENT.ABORT,
                  __assign$1(__assign$1({}, A), {
                    code:
                      (null == A ? void 0 : A.code) ||
                      exports.ErrorCode.UNKNOWN,
                  })
                );
            }
          }),
          (i.onVideoFirstPlaying = function () {
            StepTimer.end(StepKey.V_CDN_REQ, i.instanceId),
              i.emit(exports.FLOW_NODE_EVENT.SESSION_FIRST_PLAYING, {
                name: i.getName(),
              });
          }),
          (i.assignKernelNameByUser =
            null === (A = i.startParam.videoLoadParam) || void 0 === A
              ? void 0
              : A.kernelName),
          (i.logger = new Logger(i.instanceId, "VideoFlowNode")),
          (i.evtMap =
            (((o = {})[exports.PLAY_EVENT.FIRST_PLAYING] =
              i.onVideoFirstPlaying),
            (o[exports.PLAY_EVENT.TIME_UPDATE] = i.onVideoTimeUpdate),
            (o[exports.PLAY_EVENT.STOPED] = i.onVideoStop),
            (o[exports.PLAY_EVENT.ERROR] = i.onVideoError),
            (o[exports.PLAY_EVENT.STATE_CHANGE] = i.onStateChange),
            (o[exports.PLAY_EVENT.AUTOPLAY_BLOCKED] = i.onVideoPlayBlocked),
            o)),
          i.setPlayerEvents(!0),
          i
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "isLive", {
          get: function () {
            return this.corePlayer.config.type === exports.PLAY_MODE.LIVE;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.getName = function () {
          return "VideoFlowNode";
        }),
        (t.prototype.start = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            var e, t, o;
            return __generator$1(this, function (A) {
              switch (A.label) {
                case 0:
                  return (
                    this.logger.log("".concat(this.getName(), " exec start")),
                    this.emitFlowEvt(exports.FLOW_NODE_EVENT.START),
                    this.isPreload
                      ? (this.logger.log(
                          "".concat(this.getName(), " exec start on preloaded")
                        ),
                        this.loadDefer ? [4, this.loadDefer.promise] : [3, 2])
                      : [3, 3]
                  );
                case 1:
                  A.sent(), (A.label = 2);
                case 2:
                  return (
                    this.isLive && this.corePlayer.resize({ width: "100%" }),
                    this.corePlayer.play(),
                    [3, 5]
                  );
                case 3:
                  return [4, this.getVideoRsp()];
                case 4:
                  if (
                    ((e = A.sent()),
                    (t = e.urlConfig),
                    (o = e.kernelName),
                    this.isDestroyed)
                  )
                    return [2];
                  this.updateKernel(o),
                    "function" ==
                      typeof this.flowNodeConfig.videoLoadParamModifier &&
                      (this.startParam.videoLoadParam =
                        this.flowNodeConfig.videoLoadParamModifier(
                          this.startParam.videoLoadParam
                        )),
                    StepTimer.start(StepKey.V_CDN_REQ, this.instanceId),
                    this.corePlayer.play(t, this.startParam.videoLoadParam),
                    (A.label = 5);
                case 5:
                  return (
                    (this.isPreload = !1),
                    preloadEvtBus.emit(PRELOAD_EVENT.STOP, {
                      instanceId: this.corePlayer.config.instanceId,
                    }),
                    [2]
                  );
              }
            });
          });
        }),
        (t.prototype.preload = function (e) {
          return (
            void 0 === e && (e = !0),
            __awaiter$1(this, void 0, void 0, function () {
              var t, o, A;
              return __generator$1(this, function (i) {
                switch (i.label) {
                  case 0:
                    return (
                      this.logger.log(
                        "".concat(this.getName(), " exec preload")
                      ),
                      this.emitFlowEvt(exports.FLOW_NODE_EVENT.PRELOAD),
                      (this.isPreload = !0),
                      (this.loadDefer = new SimpleDefer$1()),
                      [4, this.getVideoRsp()]
                    );
                  case 1:
                    return (
                      (t = i.sent()),
                      (o = t.urlConfig),
                      (A = t.kernelName),
                      this.isDestroyed
                        ? [2]
                        : (this.updateKernel(A),
                          this.isLive
                            ? ((this.corePlayer.volume = 0),
                              [
                                4,
                                this.corePlayer.play(
                                  o,
                                  this.startParam.videoLoadParam
                                ),
                              ])
                            : [3, 3])
                    );
                  case 2:
                    return (
                      i.sent(),
                      this.corePlayer.resize({ width: 0 }),
                      this.loadDefer.resolve(),
                      [3, 5]
                    );
                  case 3:
                    return [
                      4,
                      this.corePlayer.load(
                        o,
                        __assign$1(
                          __assign$1({}, this.startParam.videoLoadParam),
                          { isPreload: !e }
                        )
                      ),
                    ];
                  case 4:
                    i.sent(), this.loadDefer.resolve(), (i.label = 5);
                  case 5:
                    return [2];
                }
              });
            })
          );
        }),
        (t.prototype.pause = function (e) {
          this.logger.log("".concat(this.getName(), " exec pause")),
            this.corePlayer.pause(e);
        }),
        (t.prototype.resume = function () {
          this.logger.log("".concat(this.getName(), " exec resume")),
            this.corePlayer.play();
        }),
        (t.prototype.setLevel = function (e, t) {
          var o, A, i;
          return (
            void 0 === t && (t = {}),
            __awaiter$1(this, void 0, void 0, function () {
              var r,
                n,
                a = this;
              return __generator$1(this, function (s) {
                switch (s.label) {
                  case 0:
                    return (
                      (r =
                        null === (o = this.corePlayer.currentVideoInfo) ||
                        void 0 === o
                          ? void 0
                          : o.config),
                      this.emitFlowEvt(
                        exports.FLOW_NODE_EVENT.VIDEO_SETLEVEL_START,
                        { level: e }
                      ),
                      [4, this.getLevelUrlConfig(e)]
                    );
                  case 1:
                    if (!(null == (n = s.sent()) ? void 0 : n.url))
                      throw new Error("setLevel url is empty");
                    return (
                      t.setLevelMode
                        ? (n.setLevelMode = t.setLevelMode)
                        : ((null == r ? void 0 : r.drmConfig) ||
                            n.drmConfig ||
                            n.chachaParam) &&
                          (n.setLevelMode = SET_LEVEL_MODE.HARD),
                      (null !== (A = n.setLevelMode) && void 0 !== A) ||
                        (n.setLevelMode = SET_LEVEL_MODE.HARD),
                      [
                        2,
                        null ===
                          (i = this.corePlayer.setLevel(
                            n.url,
                            n.backupUrls,
                            n
                          )) || void 0 === i
                          ? void 0
                          : i.catch(function (t) {
                              var o = t || {},
                                A = o.code,
                                i =
                                  void 0 === A ? exports.ErrorCode.UNKNOWN : A,
                                r = o.message;
                              throw (
                                (a.logger.error(
                                  "core setlevel err, code="
                                    .concat(i, ", msg=")
                                    .concat(r)
                                ),
                                a.emitFlowEvt(
                                  exports.FLOW_NODE_EVENT.VIDEO_SETLEVEL_END,
                                  { code: i, message: r, level: e }
                                ),
                                t)
                              );
                            }),
                      ]
                    );
                }
              });
            })
          );
        }),
        (t.prototype.updatePlayParam = function (e) {
          var t = __assign$1(
              __assign$1({}, this.startParam.videoReqInfoParam),
              null == e ? void 0 : e.videoReqInfoParam
            ),
            o = __assign$1(
              __assign$1({}, this.startParam.videoLoadParam),
              null == e ? void 0 : e.videoLoadParam
            );
          this.startParam = __assign$1(__assign$1({}, this.startParam), {
            videoReqInfoParam: t,
            videoLoadParam: o,
          });
        }),
        (t.prototype.replay = function (e, t, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            var A, i, r, n, a;
            return __generator$1(this, function (s) {
              switch (s.label) {
                case 0:
                  return (
                    this.updatePlayParam(t),
                    isVideoId(e)
                      ? (this.logger.log(
                          "replay(), start request video info: ",
                          this.startParam.videoReqInfoParam
                        ),
                        [
                          4,
                          doGetinfo(this.instanceId, this.reqInfo, {
                            emitGetinfoEvts: !0,
                          }),
                        ])
                      : (this.logger.log(
                          "replay(), start replay urlConfig: ",
                          e
                        ),
                        (this.isReplaying = !0),
                        [
                          2,
                          this.corePlayer.play(
                            e,
                            this.startParam.videoLoadParam
                          ),
                        ])
                  );
                case 1:
                  if (((A = s.sent()), this.isDestroyed)) return [2];
                  if (
                    ((r = (i = A || {}).error),
                    (n = i.urlConfig),
                    (a = i.kernelName),
                    r)
                  )
                    throw r;
                  return (
                    this.updateKernel(a),
                    (this.isReplaying = !0),
                    this.logger.log(
                      "do retry [getinfo], stateWhenErrorHappen=".concat(o)
                    ),
                    o === exports.VIDEO_STATE.PAUSE
                      ? [
                          2,
                          this.corePlayer.load(
                            n,
                            this.startParam.videoLoadParam
                          ),
                        ]
                      : [
                          2,
                          this.corePlayer.play(
                            n,
                            this.startParam.videoLoadParam
                          ),
                        ]
                  );
              }
            });
          });
        }),
        (t.prototype.retry = function (e, t) {
          var o = this,
            A = t || {},
            i = A.error,
            r = A.updatePlayParam,
            n = A.retryTimes,
            a = void 0 === n ? 0 : n,
            s = A.degradeReason,
            g = void 0 === s ? 0 : s;
          if (((this.reqInfo.getinfoOutputCache = void 0), e))
            return (
              this.flowOverHandler(),
              void this.emitFlowEvt(
                exports.FLOW_NODE_EVENT.ABORT,
                __assign$1(__assign$1({}, i), {
                  code:
                    (null == i ? void 0 : i.code) || exports.ErrorCode.UNKNOWN,
                })
              )
            );
          this.logger.log(
            "play retry, retryTimes=".concat(a, ", degradeReason=").concat(g)
          ),
            this.extEvtDispatcher.emit(exports.PLAY_EVENT_EXT.RETRY_PLAY, {
              retryTimes: a,
              degradeReason: g,
            }),
            0 !== g &&
              this.extEvtDispatcher.emit(
                exports.PLAY_EVENT_EXT.DEGRADE_CODEC_PLAY,
                { degradeReason: g }
              ),
            this.isPreload
              ? (this.updatePlayParam(r), this.preload(!0))
              : this.replay(
                  this.startParam.vid,
                  r,
                  null == t ? void 0 : t.stateWhenErrorHappen
                ).catch(function (e) {
                  o.logger.log(
                    "retry replay err="
                      .concat(null == e ? void 0 : e.code, ", ")
                      .concat(null == e ? void 0 : e.message)
                  ),
                    o.flowOverHandler(),
                    o.emitFlowEvt(
                      exports.FLOW_NODE_EVENT.ABORT,
                      __assign$1(__assign$1({}, e), {
                        code:
                          (null == e ? void 0 : e.code) ||
                          exports.ErrorCode.UNKNOWN,
                      })
                    );
                });
        }),
        (t.prototype.destroy = function () {
          this.setPlayerEvents(!1),
            (this.flowNodeConfig = null),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.emitPreloadNext = function () {
          this.emitFlowEvt(exports.FLOW_NODE_EVENT.PRELOAD_NEXT, {
            forceLoad: !0,
          });
        }),
        (t.prototype.updateKernel = function (e) {
          var t = e;
          (this.startParam.videoLoadParam = __assign$1(
            { kernelName: t },
            this.startParam.videoLoadParam
          )),
            this.assignKernelNameByUser &&
              (this.startParam.videoLoadParam.kernelName =
                this.assignKernelNameByUser);
        }),
        (t.prototype.getVideoRsp = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            var e, t, o, A, i, r, n, a, s, g;
            return __generator$1(this, function (l) {
              switch (l.label) {
                case 0:
                  if ((e = this.startParam.urlConfig))
                    return [2, { urlConfig: e }];
                  l.label = 1;
                case 1:
                  return (
                    l.trys.push([1, 4, , 5]),
                    (t = this.reqInfo.getinfoOutputCache),
                    (this.reqInfo.getinfoOutputCache = void 0),
                    t
                      ? [3, 3]
                      : [
                          4,
                          doGetinfo(this.instanceId, this.reqInfo, {
                            emitGetinfoEvts: !0,
                          }),
                        ]
                  );
                case 2:
                  (t = l.sent()), (l.label = 3);
                case 3:
                  if (((A = (o = t || {}).urlConfig), (i = o.error))) throw i;
                  if (!isUrlConfigValid(A))
                    throw {
                      message: compile(i18nConfig.h5player.ERROR_URL_INVALID),
                      code: exports.ErrorCode.GETINFO_PARSE,
                    };
                  return [2, t];
                case 4:
                  return (
                    (r = l.sent()),
                    (a = (n = r || {}).code),
                    (s = void 0 === a ? exports.ErrorCode.GETINFO_NET : a),
                    (g = n.message),
                    this.logger.error(
                      "getVideoRsp err, code=".concat(s, ", msg=").concat(g)
                    ),
                    this.flowOverHandler(),
                    this.emitFlowEvt(
                      exports.FLOW_NODE_EVENT.ABORT,
                      __assign$1(__assign$1({}, r), { code: s })
                    ),
                    [2, { urlConfig: null }]
                  );
                case 5:
                  return [2];
              }
            });
          });
        }),
        (t.prototype.setPlayerEvents = function (e) {
          var t = this;
          void 0 === e && (e = !0);
          var o = e ? this.corePlayer.on : this.corePlayer.off;
          Object.keys(this.evtMap).forEach(function (e) {
            o.call(t.corePlayer, e, t.evtMap[e]);
          });
        }),
        (t.prototype.flowOverHandler = function () {}),
        Object.defineProperty(t.prototype, "corePlayer", {
          get: function () {
            return this.flowNodeConfig.corePlayer;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "startParam", {
          get: function () {
            return this.reqInfo.startParam;
          },
          set: function (e) {
            this.reqInfo.startParam = e;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.getLevelUrlConfig = function (e) {
          var t, o;
          return __awaiter$1(this, void 0, void 0, function () {
            var A, i, r, n;
            return __generator$1(this, function (a) {
              switch (a.label) {
                case 0:
                  return isUrlConfig(e) ? ((A = e), [3, 4]) : [3, 1];
                case 1:
                  return "string" != typeof e
                    ? [3, 2]
                    : ((A = { url: e }), [3, 4]);
                case 2:
                  return (
                    (i = __assign$1(
                      __assign$1({}, this.startParam.videoReqInfoParam),
                      e
                    )),
                    (this.startParam = __assign$1(
                      __assign$1({}, this.startParam),
                      { videoReqInfoParam: i }
                    )),
                    [
                      4,
                      doGetinfo(this.instanceId, this.reqInfo, {
                        emitGetinfoEvts: !0,
                      }),
                    ]
                  );
                case 3:
                  if (!(r = a.sent()))
                    throw (
                      (this.logger.error("getLevelUrlConfig err, null data"),
                      new Error())
                    );
                  if (((A = r.urlConfig), r.error))
                    throw (
                      ((n =
                        null ===
                          (o =
                            null === (t = r.error.data) || void 0 === t
                              ? void 0
                              : t.params) || void 0 === o
                          ? void 0
                          : o.msg),
                      this.emitFlowEvt(
                        exports.FLOW_NODE_EVENT.VIDEO_SETLEVEL_END,
                        {
                          code: r.error.code || exports.ErrorCode.UNKNOWN,
                          message: n || r.error.message,
                          level: e,
                        }
                      ),
                      r.error)
                    );
                  a.label = 4;
                case 4:
                  return [2, A];
              }
            });
          });
        }),
        __decorate(
          [
            once,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "emitPreloadNext",
          null
        ),
        t
      );
    })(BaseFlowNode);
  function isUrlConfigValid(e) {
    return Array.isArray(e) ? e.every(isUrlConfig) : isUrlConfig(e);
  }
  function isUrlConfig(e) {
    return "string" == typeof (null == e ? void 0 : e.url);
  }
  var FlowPlayer = (function (e) {
      function t(t) {
        var o = e.call(this) || this;
        (o.isSettingLevel = !1),
          (o.isFirstPlaying = !0),
          (o.onFlowEnd = function (e) {
            var t,
              A = e.code,
              i = void 0 === A ? exports.ErrorCode.SUC : A,
              r = e.endState,
              n = void 0 === r ? exports.END_STATE.NORMAL : r,
              a = e.curFlowNodeName;
            if (
              (o.log(
                "onFlowEnd, code="
                  .concat(i, ", endState=")
                  .concat(n, ", curFlowNodeName=")
                  .concat(a)
              ),
              o.config.type === exports.PLAY_MODE.LIVE)
            )
              try {
                null === (t = getAdPlugin(o.config.instanceId)) ||
                  void 0 === t ||
                  t.stopAd();
              } catch (e) {
                o.logger.error("onFlowEnd, call adPlugin::stopAd", e);
              }
            o.emit(exports.PLAY_EVENT.SET_LOADING, { show: !1 }),
              o.emit(
                exports.H5_PLAY_EVENT.PLAY_SESSION_END,
                __assign$1(__assign$1({}, e), {
                  endState: n,
                  code: i,
                  curFlowNodeName: a,
                })
              );
          }),
          (o.onFlowEvts = function (e, t) {
            var A,
              i =
                (((A = {})[exports.FLOW_NODE_EVENT.PRELOAD] =
                  exports.PLAY_EVENT_EXT.FLOW_NODE_PRELOAD),
                (A[exports.FLOW_NODE_EVENT.START] =
                  exports.PLAY_EVENT_EXT.FLOW_NODE_START),
                (A[exports.FLOW_NODE_EVENT.END] =
                  exports.PLAY_EVENT_EXT.FLOW_NODE_END),
                (A[exports.FLOW_NODE_EVENT.ABORT] =
                  exports.PLAY_EVENT_EXT.FLOW_NODE_ABORT),
                (A[exports.FLOW_NODE_EVENT.SESSION_FIRST_PLAYING] =
                  exports.PLAY_EVENT_EXT.SESSION_FIRST_PLAYING),
                A);
            i[e] && o.pluginMsg.emit(i[e], t), t.name;
            var r = __rest(t, ["name"]);
            "GetVideoInfoFlowNode" === (null == t ? void 0 : t.name)
              ? e === exports.FLOW_NODE_EVENT.VIDEO_REQ_INFO_START
                ? tryEmit(function () {
                    return o.emit(exports.H5_PLAY_EVENT.VIDEO_REQ_INFO_START);
                  }, o.logger)
                : e === exports.FLOW_NODE_EVENT.VIDEO_REQ_INFO_END &&
                  (o.timeStart(StepKey.GETINFO_END),
                  tryEmit(function () {
                    return o.emit(exports.H5_PLAY_EVENT.VIDEO_REQ_INFO_END, r);
                  }, o.logger),
                  o.timeEnd(StepKey.GETINFO_END))
              : "VideoFlowNode" === (null == t ? void 0 : t.name) &&
                (e === exports.FLOW_NODE_EVENT.VIDEO_SETLEVEL_START
                  ? tryEmit(function () {
                      return o.emit(
                        exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_START,
                        r
                      );
                    }, o.logger)
                  : e === exports.FLOW_NODE_EVENT.VIDEO_SETLEVEL_END &&
                    tryEmit(function () {
                      return o.emit(
                        exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
                        r
                      );
                    }, o.logger));
          });
        var A = t.useSingleVideoElement,
          i = void 0 === A ? uaTool$1.mobile : A;
        return (
          (o.corePlayer = new KernelProxy(
            __assign$1(__assign$1({}, t), {
              maxVideoNodeCount: i
                ? 1
                : null == t
                ? void 0
                : t.maxVideoNodeCount,
              createVideoNodeWhenLoad: i,
            })
          )),
          (o.logger = new Logger(o.config.instanceId, "FlowPlayer")),
          (o.flowManager = new FlowManager({
            playerInstanceId: o.config.instanceId,
            onFlowEnd: o.onFlowEnd,
            onFlowEvts: o.onFlowEvts,
            disablePreload: i,
          })),
          (o.retryManager = new RetryManager(o)),
          o.proxyAllPlayEvent(),
          o.proxyStateChange(),
          o.proxyVideoStopped(),
          proxyPlayEvent(o, o.corePlayer),
          o.on(exports.H5_PLAY_EVENT.PLAY_SESSION_START, function () {
            o.isSettingLevel = !1;
          }),
          o
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "container", {
          get: function () {
            return this.corePlayer.container;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "instanceId", {
          get: function () {
            return this.config.instanceId;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.timeStart = function (e) {
          StepTimer.start(e, this.instanceId);
        }),
        (t.prototype.timeEnd = function (e) {
          this._destroyed || StepTimer.end(e, this.instanceId);
        }),
        Object.defineProperty(t.prototype, "videoElementsContainer", {
          get: function () {
            return this.corePlayer.videoElementsContainer;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.load = function (e, t) {
          var o;
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (A) {
              return e
                ? (this.createFlowNodes(e, t),
                  [
                    2,
                    null === (o = this.flowManager.currentFlowNode) ||
                    void 0 === o
                      ? void 0
                      : o.preload(),
                  ])
                : [2, this.corePlayer.load()];
            });
          });
        }),
        (t.prototype.play = function (e, t) {
          var o;
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (A) {
              return e
                ? (this.createFlowNodes(e, t),
                  this.emit(exports.PLAY_EVENT.SET_LOADING, { show: !0 }),
                  [
                    2,
                    null === (o = this.flowManager.currentFlowNode) ||
                    void 0 === o
                      ? void 0
                      : o.start(),
                  ])
                : [2, this.resumePlay()];
            });
          });
        }),
        (t.prototype.preload = function (e, t, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (A) {
              return (
                this.log("preload()", e, t),
                this.endPreload(),
                (this.nextReqInfo = new FlowNodeReqInfo({
                  flowid: commonTool$1.createGUID(),
                  startParam: this.getStartParam(e, t),
                  instanceId: this.config.instanceId,
                })),
                (this.nextFlowManager = new FlowManager({
                  playerInstanceId: this.config.instanceId,
                })),
                this.nextFlowManager.push(
                  new PreloadFlowNode({
                    corePlayer: this.corePlayer,
                    extEvtDispatcher: this.pluginMsg,
                    reqInfo: this.nextReqInfo,
                    playerConfig: this.config,
                    videoEndTime: o,
                  })
                ),
                this.nextFlowManager.currentFlowNode.start(),
                [2]
              );
            });
          });
        }),
        (t.prototype.setAudioTrack = function (e) {
          return this.corePlayer.setAudioTrack(e);
        }),
        (t.prototype.getAudioTrackList = function () {
          return this.currentVideoInfo ? this.currentVideoInfo.audioTracks : [];
        }),
        (t.prototype.getCurrentAudioTrack = function () {
          return this.currentVideoInfo
            ? this.currentVideoInfo.currentAudioTrack
            : NaN;
        }),
        (t.prototype.updateReqInfo = function (e) {
          if (e && this.curReqInfo) {
            var t = e.videoReqInfoParam,
              o = e.videoLoadParam;
            o && Object.assign(this.curReqInfo.videoLoadParam, o),
              t && Object.assign(this.curReqInfo.videoReqInfoParam, t);
          }
        }),
        (t.prototype.setLevel = function (e, t) {
          return (
            void 0 === t && (t = {}),
            __awaiter$1(this, void 0, void 0, function () {
              return __generator$1(this, function (o) {
                switch (o.label) {
                  case 0:
                    if (!this.checkCanSetLevel())
                      throw new Error("setLevel can't start");
                    (this.isSettingLevel = !0), (o.label = 1);
                  case 1:
                    return (
                      o.trys.push([1, 3, 4, 5]),
                      [4, this.videoNode.setLevel(e, t)]
                    );
                  case 2:
                    return o.sent(), [3, 5];
                  case 3:
                    throw o.sent();
                  case 4:
                    return (this.isSettingLevel = !1), [7];
                  case 5:
                    return [2];
                }
              });
            })
          );
        }),
        (t.prototype.preloadVid = function (e) {
          throw new Error("Method not implemented.");
        }),
        (t.prototype.pause = function (e) {
          var t = this.flowManager.currentFlowNode;
          return t ? t.pause(e) : this.corePlayer.pause(e);
        }),
        (t.prototype.seek = function (e) {
          return this.corePlayer.seek(e);
        }),
        (t.prototype.stop = function (e) {
          var t, o, A, i;
          if (this.flowManager.currentFlowNode) {
            var r = this.flowManager.currentFlowNode.getName();
            this.log(
              "stop(), endState=".concat(e, ", curFlowNodeName=").concat(r)
            ),
              this.flowManager.clear(),
              this.endPreload();
            try {
              null ===
                (o = getAdPlugin(
                  null === (t = this.config) || void 0 === t
                    ? void 0
                    : t.instanceId
                )) ||
                void 0 === o ||
                o.stopAd();
            } catch (e) {
              this.logger.error("stop, call adPlugin::stopAd", e);
            }
            null ===
              (i = getGetinfoModule(
                null === (A = this.config) || void 0 === A
                  ? void 0
                  : A.instanceId
              )) ||
              void 0 === i ||
              i.abort(),
              this.corePlayer.stop(e),
              this.emit(exports.PLAY_EVENT.SET_LOADING, { show: !1 }),
              this.emit(exports.H5_PLAY_EVENT.PLAY_SESSION_END, {
                curFlowNodeName: r,
                code: exports.ErrorCode.SUC,
                endState: e || exports.END_STATE.INTERRUPT,
              });
          }
        }),
        (t.prototype.startGetinfoRetry = function (e, t) {
          return !!this.videoNode && (this.videoNode.retry(t, e), !0);
        }),
        (t.prototype.canGetinfoRetry = function () {
          return !0;
        }),
        (t.prototype.getRetryCheckClasses = function () {
          return [CheckNormalError];
        }),
        (t.prototype.destroy = function () {
          e.prototype.destroy.call(this), this.corePlayer.destroy();
        }),
        (t.prototype.checkCanSetLevel = function () {
          return this.videoNode && !this.isSettingLevel;
        }),
        (t.prototype.checkUsePreloadCache = function (e) {
          var t;
          return (
            !!(null === (t = this.nextReqInfo) || void 0 === t
              ? void 0
              : t.vid) && e.vid === this.nextReqInfo.vid
          );
        }),
        (t.prototype.loadPostAd = function () {
          this.videoNode &&
            this.flowManager.currentFlowNode === this.videoNode &&
            this.videoNode.emitPreloadNext();
        }),
        (t.prototype.nodeBeforePreAd = function (e) {
          return e.vid
            ? new GetVideoInfoFlowNode({
                reqInfo: e,
                extEvtDispatcher: this.pluginMsg,
              })
            : null;
        }),
        (t.prototype.nodeBeforePostAd = function (e) {
          return this.config.type !== exports.PLAY_MODE.LIVE && e.vid
            ? new GetAdinfoFlowNode({
                reqInfo: e,
                adType: exports.AD_TYPE.POST,
                requestAdCallback: this.requestAdCallback.bind(this),
              })
            : null;
        }),
        (t.prototype.requestAdCallback = function (e, t) {
          return null;
        }),
        Object.defineProperty(t.prototype, "videoNode", {
          get: function () {
            return this.flowManager.flowNodeList.find(function (e) {
              return e instanceof VideoFlowNode;
            });
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.proxyAllPlayEvent = function () {
          var e = this;
          Object.keys(exports.PLAY_EVENT).forEach(function (t) {
            e.corePlayer.on(exports.PLAY_EVENT[t], function (o) {
              var A = o.data;
              return e.emit(exports.PLAY_EVENT[t], A);
            });
          });
        }),
        (t.prototype.proxyStateChange = function () {
          var e,
            t = this,
            o =
              (((e = {})[exports.VIDEO_STATE.LOAD_START] =
                exports.H5_PLAY_EVENT.VIDEO_LOAD_START),
              (e[exports.VIDEO_STATE.CANPLAY] =
                exports.H5_PLAY_EVENT.VIDEO_CANPLAY),
              (e[exports.VIDEO_STATE.BUFFERING] =
                exports.H5_PLAY_EVENT.VIDEO_BUFFERING),
              (e[exports.VIDEO_STATE.SEEKING] =
                exports.H5_PLAY_EVENT.VIDEO_SEEKING),
              (e[exports.VIDEO_STATE.SEEKED] =
                exports.H5_PLAY_EVENT.VIDEO_SEEKED),
              e);
          this.corePlayer.on(exports.PLAY_EVENT.STATE_CHANGE, function (e) {
            var A = e.data,
              i = A.new;
            if (o[i]) return t.emit(o[i], {});
            (i !== exports.VIDEO_STATE.PLAYING &&
              i !== exports.VIDEO_STATE.PAUSE) ||
              t.proxyPlayPause(i, A);
          });
        }),
        (t.prototype.proxyVideoStopped = function () {
          var e = this;
          this.corePlayer.on(exports.PLAY_EVENT.STOPED, function (t) {
            var o,
              A = t.data,
              i =
                null === (o = null == A ? void 0 : A.videoInfo) || void 0 === o
                  ? void 0
                  : o.error,
              r = __assign$1(__assign$1({}, A), {
                code: (null == i ? void 0 : i.code) || exports.ErrorCode.SUC,
              });
            e.emit(exports.H5_PLAY_EVENT.VIDEO_END, r);
          });
        }),
        (t.prototype.proxyPlayPause = function (e, t) {
          if (e === exports.VIDEO_STATE.PLAYING) {
            var o = this.isFirstPlaying;
            (this.isFirstPlaying = !1),
              this.emit(exports.H5_PLAY_EVENT.VIDEO_PLAYING, { isFirst: o });
          } else
            e === exports.VIDEO_STATE.PAUSE &&
              this.emit(exports.H5_PLAY_EVENT.VIDEO_PAUSE, {
                pauseType: t.pauseType,
              });
        }),
        (t.prototype.resumePlay = function () {
          var e = this.flowManager.currentFlowNode;
          e ? (e.isPreload ? e.start() : e.resume()) : this.corePlayer.play();
        }),
        (t.prototype.getStartParam = function (e, t) {
          var o = __assign$1({}, t);
          return isVideoId(e) ? (o.vid = e) : (o.urlConfig = e), o;
        }),
        (t.prototype.createFlowNodes = function (e, t) {
          var o, A, i;
          this.flowManager.currentFlowNode &&
            (this.log("loadItem(), stop because of currentFlowNode is running"),
            this.stop()),
            this.endPreload();
          var r = this.getStartParam(e, t),
            n = this.checkUsePreloadCache(r),
            a = this.config,
            s = a.instanceId,
            g = a.enableP2P;
          (this.curReqInfo = n
            ? this.nextReqInfo
            : new FlowNodeReqInfo({
                flowid: commonTool$1.createGUID(),
                startParam: r,
                instanceId: s,
              })),
            (this.nextReqInfo = null),
            (this.curReqInfo.startParam = r);
          var l = this.curReqInfo.flowid;
          if (
            (this.resetWhenSessionStart(),
            this.timeStart(StepKey.SESSION_START_EVT),
            this.emit(exports.H5_PLAY_EVENT.PLAY_SESSION_START, {
              flowid: l,
              playItem: e,
              isPreload: n,
            }),
            !this._destroyed)
          ) {
            this.timeEnd(StepKey.SESSION_START_EVT);
            var E =
              null === (A = (o = this.config).prerequisiteCheck) || void 0 === A
                ? void 0
                : A.call(o, e);
            if (E)
              this.emit(exports.H5_PLAY_EVENT.PLAY_SESSION_END, {
                endState: exports.END_STATE.ERROR,
                code: E.code,
                message: E.message,
              });
            else {
              this.timeStart(StepKey.CREATE_FLOW_NODES);
              var c = this.nodeBeforePreAd(this.curReqInfo);
              if (c) {
                this.flowManager.push(c);
                var u = new AdFlowNode({
                  enableP2P: g,
                  adType: exports.AD_TYPE.PRE,
                  reqInfo: this.curReqInfo,
                  corePlayer: this.corePlayer,
                });
                this.flowManager.push(u);
              }
              var p = new VideoFlowNode({
                corePlayer: this.corePlayer,
                reqInfo: this.curReqInfo,
                extEvtDispatcher: this.pluginMsg,
                videoLoadParamModifier: this.videoLoadParamModifier,
              });
              this.flowManager.push(p);
              var d = this.nodeBeforePostAd(this.curReqInfo);
              if (d) {
                this.flowManager.push(d);
                var B = new AdFlowNode({
                  reqInfo: this.curReqInfo,
                  adType: exports.AD_TYPE.POST,
                  corePlayer: this.corePlayer,
                });
                this.flowManager.push(B), this.flowManager.setLastNode(B);
              }
              this.log(
                "loadItem(), flowNodeList=".concat(
                  null === (i = this.flowManager.flowNodeList) || void 0 === i
                    ? void 0
                    : i.map(function (e) {
                        return e.getName();
                      })
                )
              ),
                this.timeEnd(StepKey.CREATE_FLOW_NODES);
            }
          }
        }),
        (t.prototype.resetWhenSessionStart = function () {
          this.isFirstPlaying = !0;
        }),
        (t.prototype.endPreload = function () {
          var e;
          null === (e = this.nextFlowManager) || void 0 === e || e.clear(),
            (this.nextFlowManager = null);
        }),
        Object.defineProperty(t.prototype, "config", {
          get: function () {
            return this.corePlayer.config;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "useWorker", {
          get: function () {
            return this.corePlayer.useWorker;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "kernelName", {
          get: function () {
            return this.corePlayer.kernelName;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoElements", {
          get: function () {
            return this.corePlayer.videoElements;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "currentVideoElement", {
          get: function () {
            return this.corePlayer.currentVideoElement;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "supportPreload", {
          get: function () {
            return this.corePlayer.supportPreload;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "duration", {
          get: function () {
            return this.corePlayer.duration;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "playtime", {
          get: function () {
            return this.corePlayer.playtime;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoInfos", {
          get: function () {
            return this.corePlayer.videoInfos;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "preloadVideoInfos", {
          get: function () {
            return this.corePlayer.preloadVideoInfos;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "currentVideoInfo", {
          get: function () {
            return this.corePlayer.currentVideoInfo;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "currentVideoInfoIdx", {
          get: function () {
            return this.corePlayer.currentVideoInfoIdx;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "totalVideoInfoCount", {
          get: function () {
            return this.corePlayer.totalVideoInfoCount;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "supportPlaybackRate", {
          get: function () {
            return this.corePlayer.supportPlaybackRate;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "played", {
          get: function () {
            return this.corePlayer.played;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "state", {
          get: function () {
            return this.corePlayer.state;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoSize", {
          get: function () {
            return this.corePlayer.videoSize;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "videoBuffered", {
          get: function () {
            return this.corePlayer.videoBuffered;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.log = function () {
          for (var e, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          return (e = this.logger).log.apply(e, t);
        }),
        (t.prototype.hasAppended = function (e) {
          return this.corePlayer.hasAppended(e);
        }),
        (t.prototype.hasPreloaded = function (e) {
          return this.corePlayer.hasPreloaded(e);
        }),
        Object.defineProperty(t.prototype, "volume", {
          get: function () {
            return this.corePlayer.volume;
          },
          set: function (e) {
            this.corePlayer.volume = e;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "volumeGain", {
          get: function () {
            return this.corePlayer.volumeGain;
          },
          set: function (e) {
            this.corePlayer.volumeGain = e;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "audioEffect", {
          get: function () {
            return this.corePlayer.audioEffect;
          },
          set: function (e) {
            this.corePlayer.audioEffect = e;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "playbackRate", {
          get: function () {
            return this.corePlayer.playbackRate;
          },
          set: function (e) {
            this.corePlayer.playbackRate = e;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.resizeVideoElements = function (e) {
          return this.corePlayer.resizeVideoElements(e);
        }),
        (t.prototype.resize = function (e) {
          return this.corePlayer.resize(e);
        }),
        (t.prototype.playNext = function (e) {
          return this.corePlayer.playNext(e);
        }),
        (t.prototype.captureVideo = function (e, t, o, A, i) {
          return this.corePlayer.captureVideo(e, t, o, A, i);
        }),
        (t.prototype.appendNext = function (e) {
          return this.corePlayer.appendNext(e);
        }),
        (t.prototype.preloadNext = function () {
          for (var e, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          return (e = this.corePlayer).preloadNext.apply(e, t);
        }),
        (t.prototype.clearAllPreload = function () {
          return this.corePlayer.clearAllPreload();
        }),
        (t.prototype.triggerAutoplay = function () {
          return this.corePlayer.triggerAutoplay();
        }),
        t
      );
    })(PluginablePlayer),
    StatsCollector = (function () {
      function e(e) {
        var t = this;
        (this.player = e),
          (this.stats = {}),
          (this.handlerCollectEvt = function (e) {
            var o = e.type,
              A = e.target,
              i = [];
            t.collectors.forEach(function (t) {
              var r;
              null === (r = t.listeners) ||
                void 0 === r ||
                r.forEach(function (t) {
                  t.event === o && t.dispatcher === A && i.push(t.cb(e));
                });
            }),
              t.updateInfos(i);
          }),
          this.initCollects(),
          this.setCollectEvts(!0);
      }
      return (
        (e.prototype.destroy = function () {
          this.setCollectEvts(!1),
            (this.collectors.length = 0),
            (this.stats = {});
        }),
        (e.prototype.getStats = function () {
          return (
            this.updateInfos(
              this.collectors.map(function (e) {
                var t;
                return null === (t = e.updater) || void 0 === t
                  ? void 0
                  : t.call(e);
              })
            ),
            this.stats
          );
        }),
        (e.prototype.initCollects = function () {
          var e,
            t = this,
            o =
              (((e = {})[exports.STATS_NAME.VID] = this.createVidCollect),
              (e[exports.STATS_NAME.FLOW_ID] = this.createFlowidCollect),
              (e[exports.STATS_NAME.GUID] = this.createGuidCollect),
              (e[exports.STATS_NAME.KERNEL_NAME] =
                this.createKernelNameCollect),
              (e[exports.STATS_NAME.CDN_INFO] = this.createCdnCollect),
              (e[exports.STATS_NAME.PLAYER_SIZE] =
                this.createResolutionCollect),
              (e[exports.STATS_NAME.FRAME_RATE] = this.createFrameRateCollect),
              (e[exports.STATS_NAME.BUFFER_HEALTH] =
                this.createBufferHealthCollect),
              (e[exports.STATS_NAME.BUFFER_RANGE] =
                this.createBufferRangeCollect),
              (e[exports.STATS_NAME.NET] = this.createNetCollect),
              (e[exports.STATS_NAME.VIDEO_SIZE] = this.createVideoSizeCollect),
              (e[exports.STATS_NAME.CODEC] = this.createCodecCollect),
              e);
          this.collectors = Object.keys(o).map(function (e) {
            return o[e].apply(t, [e]);
          });
        }),
        (e.prototype.setCollectEvts = function (e) {
          var t = this,
            o = {},
            A = {};
          this.collectors.forEach(function (e) {
            var i;
            null === (i = e.listeners) ||
              void 0 === i ||
              i.forEach(function (e) {
                e.dispatcher === t.player
                  ? (o[e.event] = e.dispatcher)
                  : e.dispatcher === t.player.pluginMsg &&
                    (A[e.event] = e.dispatcher);
              });
          }),
            [o, A].forEach(function (o) {
              Object.keys(o).forEach(function (A) {
                e
                  ? o[A].on(A, t.handlerCollectEvt)
                  : o[A].off(A, t.handlerCollectEvt);
              });
            });
        }),
        (e.prototype.updateInfos = function (e) {
          var t = this,
            o = e.filter(function (e) {
              return e && t.stats[e.key] !== e.value;
            });
          o.length <= 0 ||
            (o.forEach(function (e) {
              return (t.stats[e.key] = e.value);
            }),
            this.player.pluginMsg.emit(exports.PLAY_EVENT_EXT.STATS_CHANGE, o));
        }),
        (e.prototype.getUpdateInfo = function (e, t) {
          return { key: e, value: t };
        }),
        (e.prototype.createVidCollect = function (e) {
          var t = this,
            o = function () {
              var o = t.player,
                A = o.getCommonKv(COMMON_DATA_KEY.vid);
              if (!A) return t.getUpdateInfo(e, "");
              var i = "-";
              return (
                A &&
                  (i =
                    o.config.type === exports.PLAY_MODE.LIVE
                      ? ""
                          .concat(A, "-")
                          .concat(
                            o.getCommonKv(COMMON_DATA_KEY.livepid) || 0
                          ) || "-"
                      : A || "-"),
                t.getUpdateInfo(e, i)
              );
            };
          return {
            key: e,
            updater: o,
            listeners: [
              {
                dispatcher: this.player.pluginMsg,
                event: exports.PLAY_EVENT_EXT.DATASET_UPDATE,
                cb: function (e) {
                  if (e.data.key === COMMON_DATA_KEY.vid) return o();
                },
              },
            ],
          };
        }),
        (e.prototype.createFlowidCollect = function (e) {
          var t = this,
            o = function () {
              return t.getUpdateInfo(
                e,
                t.player.getCommonKv(COMMON_DATA_KEY.flowid)
              );
            };
          return {
            key: e,
            updater: o,
            listeners: [
              {
                dispatcher: this.player.pluginMsg,
                event: exports.PLAY_EVENT_EXT.DATASET_UPDATE,
                cb: function (e) {
                  if (e.data.key === COMMON_DATA_KEY.flowid) return o();
                },
              },
            ],
          };
        }),
        (e.prototype.createGuidCollect = function (e) {
          var t = this;
          return {
            key: e,
            updater: function () {
              return t.getUpdateInfo(
                e,
                t.player.getCommonKv(COMMON_DATA_KEY.guid)
              );
            },
          };
        }),
        (e.prototype.createKernelNameCollect = function (e) {
          var t = this,
            o = function () {
              var o,
                A,
                i,
                r,
                n,
                a =
                  null !==
                    (i = urlTool$1.getFileExtension(
                      null ===
                        (A =
                          null === (o = t.player) || void 0 === o
                            ? void 0
                            : o.currentVideoInfo) || void 0 === A
                        ? void 0
                        : A.loadingUrl
                    )) && void 0 !== i
                    ? i
                    : "-",
                s =
                  null !==
                    (r = t.player.getCommonKv(COMMON_DATA_KEY.curcore)) &&
                  void 0 !== r
                    ? r
                    : "-",
                g =
                  null !==
                    (n = t.player.getCommonKv(COMMON_DATA_KEY.curcorever)) &&
                  void 0 !== n
                    ? n
                    : VERSION$2,
                l = t.player.getCommonKv(COMMON_DATA_KEY.p2pver),
                E = l ? "-p2p-".concat(l) : "";
              return t.getUpdateInfo(
                e,
                "".concat(a, "/").concat(s, " (").concat(g).concat(E, ")")
              );
            };
          return {
            key: e,
            updater: o,
            listeners: [
              {
                dispatcher: this.player.pluginMsg,
                event: exports.PLAY_EVENT_EXT.DATASET_UPDATE,
                cb: function (e) {
                  if (
                    [
                      COMMON_DATA_KEY.curcorever,
                      COMMON_DATA_KEY.curcore,
                      COMMON_DATA_KEY.p2pver,
                    ].indexOf(e.data.key) > -1
                  )
                    return o();
                },
              },
            ],
          };
        }),
        (e.prototype.createCdnCollect = function (e) {
          var t = this,
            o = function () {
              var o;
              return t.player.getCommonKv(COMMON_DATA_KEY.vid)
                ? t.getUpdateInfo(
                    e,
                    urlTool$1.getDomainOfURL(
                      (null === (o = t.player.currentVideoInfo) || void 0 === o
                        ? void 0
                        : o.loadingUrl) || ""
                    )
                  )
                : t.getUpdateInfo(e, "");
            };
          return {
            key: e,
            listeners: [
              {
                event: exports.H5_PLAY_EVENT.VIDEO_LOAD_START,
                dispatcher: this.player,
                cb: o,
              },
              {
                event: exports.PLAY_EVENT.RETRY_BACKURL,
                dispatcher: this.player,
                cb: o,
              },
              {
                event: exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
                dispatcher: this.player,
                cb: o,
              },
            ],
          };
        }),
        (e.prototype.createResolutionCollect = function (e) {
          var t = this;
          return {
            key: e,
            updater: function () {
              var o,
                A,
                i = t.player,
                r = i.container,
                n = i.getCommonKv,
                a = "".concat(r.clientWidth, "*").concat(r.clientHeight),
                s = n(COMMON_DATA_KEY.resolution),
                g =
                  null !==
                    (A =
                      null === (o = window.screen) || void 0 === o
                        ? void 0
                        : o.isExtended) &&
                  void 0 !== A &&
                  A;
              return t.getUpdateInfo(
                e,
                "".concat(a, " / ").concat(s, " (ext:").concat(g, ")")
              );
            },
          };
        }),
        (e.prototype.createFrameRateCollect = function (e) {
          var t = this,
            o = function () {
              var o,
                A,
                i =
                  (null ===
                    (A =
                      null === (o = t.player) || void 0 === o
                        ? void 0
                        : o.currentVideoInfo) || void 0 === A
                    ? void 0
                    : A.qualityInfo) || {},
                r = i.totalVideoFrames,
                n = void 0 === r ? 0 : r,
                a = i.droppedVideoFrames,
                s = void 0 === a ? 0 : a,
                g = (s / n) * 100;
              return t.getUpdateInfo(
                e,
                ""
                  .concat(s, "/")
                  .concat(n, "; ")
                  .concat(isNaN(g) ? 0 : g.toFixed(2), "%")
              );
            };
          return {
            key: e,
            updater: o,
            listeners: [
              {
                event: exports.H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
                dispatcher: this.player,
                cb: o,
              },
            ],
          };
        }),
        (e.prototype.createBufferHealthCollect = function (e) {
          var t = this,
            o = function () {
              var o = t.player,
                A = o.videoBuffered,
                i = o.playtime,
                r = A.find(function (e) {
                  return e.start <= i && e.end >= i;
                });
              if (!r) return t.getUpdateInfo(e, "");
              var n = r.end - i;
              return t.getUpdateInfo(
                e,
                isNaN(n) ? "-" : "".concat(n.toFixed(2), "s")
              );
            };
          return {
            key: e,
            updater: o,
            listeners: [
              {
                event: exports.H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
                dispatcher: this.player,
                cb: o,
              },
              {
                event: exports.H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS,
                dispatcher: this.player,
                cb: o,
              },
            ],
          };
        }),
        (e.prototype.createBufferRangeCollect = function (e) {
          var t = this,
            o = function () {
              var o = t.player.videoBuffered
                .map(function (e) {
                  return ""
                    .concat(e.start.toFixed(3), "-")
                    .concat(e.end.toFixed(3));
                })
                .join(",");
              return t.getUpdateInfo(e, o);
            };
          return {
            key: e,
            updater: o,
            listeners: [
              {
                event: exports.H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS,
                dispatcher: this.player,
                cb: o,
              },
            ],
          };
        }),
        (e.prototype.createNetCollect = function (e) {
          var t = this,
            o = function () {
              var o = t.player.currentVideoInfo;
              if (!(null == o ? void 0 : o.performance))
                return t.getUpdateInfo(e, "");
              var A = o.performance,
                i = A.speed,
                r = void 0 === i ? 0 : i,
                n = A.p2pStats,
                a = void 0 === n ? "" : n;
              return t.getUpdateInfo(e, "".concat(r, " KB/s ").concat(a));
            };
          return {
            key: e,
            updater: o,
            listeners: [
              {
                event: exports.H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
                dispatcher: this.player,
                cb: o,
              },
            ],
          };
        }),
        (e.prototype.createVideoSizeCollect = function (e) {
          var t = this,
            o = function () {
              var o,
                A,
                i =
                  null !==
                    (A =
                      null === (o = t.player) || void 0 === o
                        ? void 0
                        : o.currentVideoInfo) && void 0 !== A
                    ? A
                    : {},
                r = i.videoHeight,
                n = void 0 === r ? 0 : r,
                a = i.videoWidth,
                s = void 0 === a ? 0 : a;
              return t.getUpdateInfo(e, "".concat(s, "*").concat(n));
            };
          return {
            key: e,
            updater: o,
            listeners: [
              {
                event: exports.PLAY_EVENT.METADATA_CHANGE,
                dispatcher: this.player,
                cb: o,
              },
              {
                event: exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
                dispatcher: this.player,
                cb: o,
              },
            ],
          };
        }),
        (e.prototype.createCodecCollect = function (e) {
          var t = this,
            o = function () {
              var o = t.player.currentVideoInfo;
              if (!o) return t.getUpdateInfo(e, "");
              var A = o.codecs,
                i = void 0 === A ? { video: "", audio: "" } : A,
                r = i.video,
                n = i.audio,
                a = r && n ? "".concat(r, " / ").concat(n) : "",
                s = "(".concat(
                  t.player.getCommonKv(COMMON_DATA_KEY.codec) || "-",
                  ")"
                );
              return t.getUpdateInfo(e, "".concat(a, " ").concat(s).trim());
            };
          return {
            key: e,
            updater: o,
            listeners: [
              {
                event: exports.PLAY_EVENT.METADATA_CHANGE,
                dispatcher: this.player,
                cb: o,
              },
            ],
          };
        }),
        e
      );
    })(),
    STATS_NAME,
    _a$4;
  (exports.STATS_NAME = void 0),
    (STATS_NAME = exports.STATS_NAME || (exports.STATS_NAME = {})),
    (STATS_NAME.VID = "vid"),
    (STATS_NAME.FLOW_ID = "flowid"),
    (STATS_NAME.GUID = "guid"),
    (STATS_NAME.KERNEL_NAME = "kernelName"),
    (STATS_NAME.CDN_INFO = "cdnInfo"),
    (STATS_NAME.PLAYER_SIZE = "playerSize"),
    (STATS_NAME.FRAME_RATE = "frameRate"),
    (STATS_NAME.BUFFER_HEALTH = "bufferHealth"),
    (STATS_NAME.BUFFER_RANGE = "bufferRange"),
    (STATS_NAME.NET = "net"),
    (STATS_NAME.VIDEO_SIZE = "videoSize"),
    (STATS_NAME.CODEC = "codec");
  var logMethodCall$1 = logMethodCallDecoratorCreator("H5Player"),
    performanceCost$4 = performanceCostDecoratorCreator("H5Player"),
    rotateTransformValue =
      ((_a$4 = {}),
      (_a$4[exports.PictureDirection.VERTICAL] = "rotateX(180deg)"),
      (_a$4[exports.PictureDirection.HORIZON] = "rotateY(180deg)"),
      (_a$4[exports.PictureDirection.NORMAL] = "none"),
      _a$4);
  function collectUsage() {
    var e = "npm";
    try {
      e = "npm";
    } catch (e) {}
    ReferenceReport.getReporter().collectUsage(1, e);
  }
  var H5Player = (function (e) {
      function t(t) {
        var o,
          A,
          i,
          r = this;
        t.isPrivateDeployment || collectUsage(),
          ((r =
            e.call(
              this,
              __assign$1(
                __assign$1(__assign$1({}, defaultH5PlayerConfig), t.coreConfig),
                t
              )
            ) || this).plugins = {}),
          (r.interactMod = null),
          (r.getCommonKv = function (e) {
            return r.dataset.commonMap[e];
          }),
          (r.getStateKv = function (e) {
            return r.dataset.stateMap[e];
          }),
          (r.mutedVolume = 1),
          (r.hasMutePlayed = !1),
          (r.mixin = function (e) {
            var t = "function" == typeof e ? e() : e;
            Object.keys(t).forEach(function (e) {
              if (e in r)
                throw new Error(
                  "cannot override existing player method: ".concat(e)
                );
              var o = t[e];
              "function" == typeof o
                ? (r[e] = o)
                : console.error("mixin ".concat(o, " is not a function"));
            });
          }),
          (r.mouseMoveHandler = lodash_throttle$1(function () {
            r.setMouseState(!1),
              clearTimeout(r.mouseMoveTimer),
              (r.mouseMoveTimer = setTimeout(
                r.setMouseState,
                AUTO_HIDE_MOUSE_DELAY
              ));
          }, HIDE_MOUSE_THROTTLE)),
          (r.setMouseState = function (e) {
            var t = null != e ? e : r.shouldHideMouse();
            r.container.style.cursor = t ? "none" : "auto";
          }),
          r.log("new H5Player(), input config=", t);
        var n = Date.now(),
          a = t.plugins,
          s = t.mixins;
        (r.fullscreenLogics = new FullScreenLogics(
          r,
          r.config.fullscreenContainer
        )),
          (r.statsCollector = new StatsCollector(r));
        return (
          r.setMaxListeners(100),
          r.createClickMask(),
          r.createInnerPlugins(),
          a instanceof Array && r.createPlugins(a),
          r.initGetinfoModule(r.config),
          s instanceof Array && s.forEach(r.mixin),
          r.initPlayerResizeObserver(),
          r.initPluginApis(),
          r.forwardPluginEvents(),
          r.initContainerStyle(),
          r.setupEventFlagData(),
          r.setupLoopPlay(),
          r.setupMouseAutoHide(),
          r.checkAutoPlayInMute(),
          r.applyStyleOnVideoNodeChange(),
          r.on(exports.H5_PLAY_EVENT.PLAY_SESSION_START, function () {
            r.hasMutePlayed = !1;
          }),
          r.setStateKv(exports.DATA_STATE.INIT, {
            type: exports.LOG_TYPE.CORE_EVENT,
            ftime: Date.now(),
            ext: { stime: n },
          }),
          r.setCommonKv(COMMON_DATA_KEY.TEE_screen, {
            width:
              null !==
                (o =
                  null === screen || void 0 === screen
                    ? void 0
                    : screen.width) && void 0 !== o
                ? o
                : -1,
            height:
              null !==
                (A =
                  null === screen || void 0 === screen
                    ? void 0
                    : screen.height) && void 0 !== A
                ? A
                : -1,
            dpr:
              null !== (i = window.devicePixelRatio) && void 0 !== i ? i : -1,
          }),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.registerSavedCommonKey = function (e) {
          DataSet.SETTING_CONFIG[e]
            ? console.warn("key ".concat(e, " already registered"))
            : DataSet.SETTING_CONFIG.push({
                dsKey: e,
                lsKey: "__thumbplayer_custom_".concat(e, "__"),
              });
        }),
        (t.prototype.load = function (t, o) {
          return t
            ? (this.cacheLoadParam(t, o),
              this.corePlayer.load(),
              e.prototype.load.call(this, t, this.getParamWithStartTime(t, o)))
            : e.prototype.load.call(this);
        }),
        (t.prototype.play = function (t, o) {
          return t
            ? (this.cacheLoadParam(t, o),
              this.corePlayer.load(),
              e.prototype.play.call(this, t, this.getParamWithStartTime(t, o)))
            : e.prototype.play.call(this);
        }),
        (t.prototype.createPlugin = function (t, o) {
          void 0 === o && (o = {}),
            this.timeStart(
              "".concat(StepKey.CREATE_PLUGIN_PREFIX, "_").concat(t)
            ),
            e.prototype.createPlugin.call(this, t, o);
          var A = o.pluginName;
          (void 0 === A ? t : A) === AdPluginName && proxyAdEvent(this),
            this.timeEnd(
              "".concat(StepKey.CREATE_PLUGIN_PREFIX, "_").concat(t)
            );
        }),
        (t.prototype.replay = function () {
          var e,
            t,
            o = this.vid,
            A = this.playUrl;
          if (
            (null ===
              (t =
                null === (e = this.loadParam) || void 0 === e
                  ? void 0
                  : e.videoLoadParam) ||
              void 0 === t ||
              delete t.startTime,
            o)
          )
            return this.play(o, this.loadParam);
          if (A) {
            var i = A.lastIndexOf("#");
            return (
              i > 0 && (A = A.slice(0, i)),
              this.play({ url: A }, this.loadParam)
            );
          }
          this.log("Current player has no available vid or url to replay");
        }),
        (t.prototype.pause = function (t) {
          return e.prototype.pause.call(this, t);
        }),
        (t.prototype.seek = function (t) {
          var o = this.timeRange,
            A = o.startTime,
            i = o.endTime,
            r = Math.min(i, Math.max(A, t));
          return e.prototype.seek.call(this, r);
        }),
        (t.prototype.setPictureImage = function (e) {
          void 0 === e && (e = exports.PictureDirection.NORMAL),
            (this.pictureDirection = e),
            this.isPlayingAd
              ? this.setAdVideoStyle({ transform: rotateTransformValue[e] })
              : this.setVideoStyle({ transform: rotateTransformValue[e] }),
            e === exports.PictureDirection.NORMAL && (this.rotateDegree = 0);
        }),
        (t.prototype.setRotate = function (e) {
          "number" != typeof e ||
            Number.isNaN(e) ||
            ((this.rotateDegree = e),
            this.isPlayingAd
              ? this.setAdVideoStyle({ transform: "rotate(".concat(e, "deg)") })
              : this.setVideoStyle({ transform: "rotate(".concat(e, "deg)") }));
        }),
        (t.prototype.getRotate = function () {
          return this.rotateDegree;
        }),
        (t.prototype.requestFullScreen = function (e, t) {
          var o, A, i;
          return (
            void 0 === e && (e = !0),
            __awaiter$1(this, void 0, void 0, function () {
              return __generator$1(this, function (r) {
                return (
                  e &&
                    this.setCommonKv(COMMON_DATA_KEY.TEE_screen, {
                      width:
                        null !==
                          (o =
                            null === screen || void 0 === screen
                              ? void 0
                              : screen.width) && void 0 !== o
                          ? o
                          : -1,
                      height:
                        null !==
                          (A =
                            null === screen || void 0 === screen
                              ? void 0
                              : screen.height) && void 0 !== A
                          ? A
                          : -1,
                      dpr:
                        null !== (i = window.devicePixelRatio) && void 0 !== i
                          ? i
                          : -1,
                    }),
                  [2, this.fullscreenLogics.requestFullScreen(e, t)]
                );
              });
            })
          );
        }),
        Object.defineProperty(t.prototype, "fullscreenMode", {
          get: function () {
            return this.fullscreenLogics.fullscreenMode;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "volume", {
          get: function () {
            return this.corePlayer.volume;
          },
          set: function (e) {
            var t;
            this.corePlayer.volume = e;
            try {
              null === (t = getAdPlugin(this.config.instanceId)) ||
                void 0 === t ||
                t.setAdVolume(e);
            } catch (e) {
              this.logger.error("call adPlugin::setAdVolume", e);
            }
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "timeRange", {
          get: function () {
            return this.playtimeLimiter.range;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.destroy = function () {
          var t,
            o,
            A,
            i,
            r,
            n = this;
          try {
            this.stop(), this.pluginMsg.emit(exports.PLAY_EVENT_EXT.DESTROY);
          } catch (e) {
            this.log(e);
          }
          this.plugins &&
            (Object.keys(this.plugins).forEach(function (e) {
              var t, o;
              null ===
                (o =
                  null === (t = n.plugins[e]) || void 0 === t
                    ? void 0
                    : t.destroy) ||
                void 0 === o ||
                o.call(t);
            }),
            delete this.plugins),
            destroyGetinfoModule(
              null === (t = this.config) || void 0 === t ? void 0 : t.instanceId
            ),
            setAdPlugin(
              null === (o = this.config) || void 0 === o
                ? void 0
                : o.instanceId,
              null
            ),
            null === (A = this.containerResizeObserver) ||
              void 0 === A ||
              A.disconnect(),
            (this.containerResizeObserver = null),
            this.fullscreenLogics.destroy(),
            null === (i = this.statsCollector) || void 0 === i || i.destroy(),
            (this.statsCollector = null),
            null === (r = this.interactMod) || void 0 === r || r.remove(),
            (this.interactMod = null),
            this.setupMouseAutoHide(!1),
            clearTimeout(this.mouseMoveTimer),
            "none" === this.container.style.cursor &&
              (this.container.style.cursor = "auto"),
            e.prototype.destroy.call(this);
        }),
        Object.defineProperty(t.prototype, "offlineLogPlugin", {
          get: function () {
            return this.plugins[OfflineLogPlugin.pluginName];
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "pluginInstances", {
          get: function () {
            return this.plugins;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "player", {
          get: function () {
            return this;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, PlaytimeLimiterPlugin.pluginName, {
          get: function () {
            return this.plugins[PlaytimeLimiterPlugin.pluginName];
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, DataSet.pluginName, {
          get: function () {
            return this.plugins[DataSet.pluginName];
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, OfflineLogPlugin.pluginName, {
          get: function () {
            return this.plugins[OfflineLogPlugin.pluginName];
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "vid", {
          get: function () {
            return isVideoId(this.currentPlayItem)
              ? this.currentPlayItem
              : null;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.canGetinfoRetry = function () {
          return !!this.player.vid;
        }),
        Object.defineProperty(t.prototype, "url", {
          get: function () {
            var e;
            return null === (e = this.currentVideoInfo) || void 0 === e
              ? void 0
              : e.loadingUrl;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "paused", {
          get: function () {
            return this.state === exports.VIDEO_STATE.PAUSE;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "muted", {
          get: function () {
            return 0 === this.volume;
          },
          set: function (e) {
            e
              ? ((this.mutedVolume = this.volume), (this.volume = 0))
              : this.muted && (this.volume = this.mutedVolume);
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.setStateKv = function (e, t, o) {
          this.dataset.writeState(e, t, o);
        }),
        (t.prototype.setCommonKv = function (e, t, o) {
          var A = this;
          "string" == typeof e
            ? this.dataset.writeCommon(e, t, o)
            : Object.keys(e).forEach(function (o) {
                return A.dataset.writeCommon(o, e[o], t);
              });
        }),
        (t.prototype.getStats = function () {
          return this.statsCollector.getStats();
        }),
        Object.defineProperty(t.prototype, "videoReqParam", {
          get: function () {
            var e;
            return null === (e = this.loadParam) || void 0 === e
              ? void 0
              : e.videoReqInfoParam;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.shouldHideMouse = function () {
          return (
            null !== this.fullscreenMode &&
            this.state === exports.VIDEO_STATE.PLAYING
          );
        }),
        (t.prototype.selectGetinfoModule = function (e) {
          return null == e ? void 0 : e.getinfoModule;
        }),
        (t.prototype.getParamWithStartTime = function (e, t) {
          var o;
          void 0 === t && (t = {});
          var A = this.playtimeLimiter;
          if (!e) return t;
          if (
            null === (o = t.videoLoadParam) || void 0 === o
              ? void 0
              : o.startTime
          )
            return t;
          if ("string" == typeof e || "number" == typeof e) A.clearAllConfig(e);
          else {
            if (Array.isArray(e)) return t;
            A.clearAllConfig(e.url);
          }
          return (
            t.playTimeLimit && A.addLimitConfig(t.playTimeLimit),
            __assign$1(__assign$1({}, t), {
              videoLoadParam: __assign$1(__assign$1({}, t.videoLoadParam), {
                startTime: this.timeRange.startTime,
              }),
            })
          );
        }),
        (t.prototype.createClickMask = function () {
          var e = this,
            t = this.config,
            o = t.enableInteractMod,
            A = void 0 === o || o,
            i = t.type;
          if (A && i !== exports.PLAY_MODE.LIVE) {
            var r = document.createElement("div");
            r.classList.add("thumbplayer-user-mod"),
              domTool$1.css(r, {
                width: "100%",
                height: "100%",
                position: "absolute",
                "z-index": 1,
              }),
              domTool$1.append(this.container, r),
              r.addEventListener("click", function () {
                [
                  exports.VIDEO_STATE.PAUSE,
                  exports.VIDEO_STATE.CANPLAY,
                ].includes(e.state)
                  ? e.play()
                  : [
                      exports.VIDEO_STATE.PLAYING,
                      exports.VIDEO_STATE.BUFFERING,
                    ].includes(e.state) &&
                    e.pause(exports.H5_PAUSE_TYPE.USER_CLICK);
              }),
              (this.interactMod = r);
          }
        }),
        (t.prototype.initContainerStyle = function () {
          var e = this.container;
          (e.style.outline = "0 none"),
            (e.style.overflow = "hidden"),
            (e.style.backgroundColor = "#000"),
            "static" === getComputedStyle(e).position &&
              (e.style.position = "relative");
        }),
        (t.prototype.forwardPluginEvents = function () {
          var e = this;
          this[DataSet.pluginName].on(
            exports.DATA_EVENTS.STATE_UPDATE,
            function (t) {
              var o = t.data;
              e.pluginMsg.emit(exports.PLAY_EVENT_EXT.DATASET_STATE_UPDATE, o);
            }
          ),
            this[DataSet.pluginName].on(
              exports.DATA_EVENTS.UPDATE,
              function (t) {
                var o = t.data;
                e.pluginMsg.emit(exports.PLAY_EVENT_EXT.DATASET_UPDATE, o);
              }
            ),
            this.on(exports.PLAY_EVENT.SET_LOADING, function (t) {
              var o = t.data;
              e.pluginMsg.emit(exports.PLAY_EVENT_EXT.SET_LOADING, {
                value: o.show,
              });
            });
        }),
        (t.prototype.createInnerPlugins = function () {
          var e;
          this.createPlugin(DataSet.pluginName),
            !OfflineLogPlugin.isEnvSupport ||
              (null === (e = this.config.offlineConfig) || void 0 === e
                ? void 0
                : e.disable) ||
              this.config.isPrivateDeployment ||
              this.createPlugin(OfflineLogPlugin.pluginName),
            this.createPlugin(PlaytimeLimiterPlugin.pluginName),
            this.config.enableQAreporter &&
              !this.config.isPrivateDeployment &&
              this.createPlugin(
                this.config.type === exports.PLAY_MODE.LIVE
                  ? LiveQaReporterPlugin.pluginName
                  : VodQaReporterPlugin.pluginName
              );
        }),
        (t.prototype.cacheLoadParam = function (e, t) {
          e &&
            (isVideoId(e) &&
              this.pluginMsg.emit(exports.PLAY_EVENT_EXT.VID_CHANGE, {
                oldVal: this.vid,
                newVal: e,
              }),
            (this.currentPlayItem = e),
            t && Object.keys(t).length && (this.loadParam = t));
        }),
        (t.prototype.setupEventFlagData = function () {
          var e = this;
          this.on(exports.H5_PLAY_EVENT.AD_PLAYING, function () {
            return (e.isPlayingAd = !0);
          }),
            this.on(exports.H5_PLAY_EVENT.AD_END, function () {
              return (e.isPlayingAd = !1);
            });
        }),
        (t.prototype.setupLoopPlay = function () {
          var e = this;
          this.on(exports.H5_PLAY_EVENT.PLAY_SESSION_END, function (t) {
            var o,
              A = t.data,
              i =
                null !== (o = e.config.loopMode) && void 0 !== o
                  ? o
                  : exports.VideoLoopMode.replay,
              r = A.endState === exports.END_STATE.NORMAL;
            e.config.loop &&
              r &&
              i === exports.VideoLoopMode.replay &&
              e.replay();
          }),
            this.on(exports.H5_PLAY_EVENT.VIDEO_PLAYING, function (t) {
              if (t.data.isFirst && e.config.loop) {
                var o = e.currentVideoElement;
                if (o instanceof HTMLVideoElement) {
                  var A = e.config.loopMode;
                  isUrlConfig(e.currentPlayItem) &&
                    e.corePlayer.kernelName === exports.KERNEL_NAME.ORIGIN &&
                    (A = exports.VideoLoopMode.native),
                    (o.loop = A === exports.VideoLoopMode.native);
                }
              }
            });
        }),
        Object.defineProperty(t.prototype, "playUrl", {
          get: function () {
            var e = this.currentPlayItem;
            if (!isVideoId(e) && !Array.isArray(e))
              return null == e ? void 0 : e.url;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.checkAutoPlayInMute = function () {
          var e = this;
          if (
            this.config.autoPlayInMute ||
            this.config.autoPlayPolicy === exports.AUTO_PLAY_POLICY.IN_MUTED
          ) {
            var t = function () {
              var t;
              if (!e.hasMutePlayed) {
                (e.hasMutePlayed = !0), (e.muted = !0);
                try {
                  null === (t = getAdPlugin(e.config.instanceId)) ||
                    void 0 === t ||
                    t.setAdVolume(0);
                } catch (t) {
                  e.logger.error("call adPlugin::setAdVolume", t);
                }
                e.play(),
                  e.pluginMsg.emit(exports.PLAY_EVENT_EXT.AUTOPLAY_IN_MUTED, {
                    muted: !0,
                  });
              }
            };
            this.on(exports.H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, function () {
              return setTimeout(t);
            }),
              this.on(exports.H5_PLAY_EVENT.VIDEO_AUTOPLAY_BLOCKED, t);
          }
        }),
        (t.prototype.setupMouseAutoHide = function (e) {
          void 0 === e && (e = !0);
          var t = (this.config || {}).autoHideMouse;
          (void 0 === t || t) &&
            getEventTargetBinder(this.container, e)(
              "mousemove",
              this.mouseMoveHandler
            );
        }),
        (t.prototype.initPlayerResizeObserver = function () {
          var e = this;
          (this.containerResizeObserver = new ResizeObserver(function () {
            var t = e.container,
              o = t.clientWidth,
              A = t.clientHeight;
            e.emit(exports.PLAY_EVENT.CONTAINER_RESIZE, {
              width: o,
              height: A,
            });
          })),
            this.containerResizeObserver.observe(this.container);
        }),
        (t.prototype.setVideoStyle = function (e) {
          domTool$1.css(this.corePlayer.currentVideoElement, e);
        }),
        (t.prototype.setAdVideoStyle = function (e) {
          var t,
            o,
            A,
            i =
              null ===
                (A =
                  null ===
                    (o = getAdPlugin(
                      null === (t = this.config) || void 0 === t
                        ? void 0
                        : t.instanceId
                    )) || void 0 === o
                    ? void 0
                    : o.videoAdPlayer) || void 0 === A
                ? void 0
                : A.videoElements;
          i &&
            i.forEach(function (t) {
              return domTool$1.css(t, e);
            });
        }),
        (t.prototype.applyStyleOnVideoNodeChange = function () {
          var e = this,
            t = function () {
              if (void 0 !== e.pictureDirection || void 0 !== e.rotateDegree)
                return (
                  rotateTransformValue[e.pictureDirection] ||
                  "rotate(".concat(e.rotateDegree, "deg)")
                );
            };
          this.corePlayer.on(exports.PLAY_EVENT.VIDEONODE_CHANGE, function () {
            var o = t();
            o && e.setVideoStyle({ transform: o });
          }),
            this.on(exports.H5_PLAY_EVENT.AD_REQ_ASSETS_START, function (o) {
              if (isPreOrPostAd(o.data)) {
                var A = t();
                A && e.setAdVideoStyle({ transform: A });
              }
            }),
            this.on(exports.H5_PLAY_EVENT.AD_END, function (o) {
              isPreOrPostAd(o.data) &&
                t() &&
                e.setAdVideoStyle({ transform: "none" });
            });
        }),
        (t.prototype.initPluginApis = function () {
          var e = this;
          this.playerApiProxy.replayInCurFlowNode = function (t, o) {
            var A;
            return (
              e.log("replayInCurFlowNode(), vid=".concat(t, ", param="), o),
              null === (A = e.flowManager.currentFlowNode) || void 0 === A
                ? void 0
                : A.replay(t, o)
            );
          };
        }),
        (t.prototype.initGetinfoModule = function (e) {
          var t = this.selectGetinfoModule(e);
          return t
            ? createGetinfoModule(t, e, {
                getCommonKv: this.getCommonKv.bind(this),
                pluginMsg: this.pluginMsg,
              })
            : null;
        }),
        (t.registerKernel = KernelFactory$1.registerKernel),
        (t.KernelFactory = KernelFactory$1),
        __decorate(
          [
            logMethodCall$1,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "load",
          null
        ),
        __decorate(
          [
            logMethodCall$1,
            performanceCost$4,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "play",
          null
        ),
        __decorate(
          [
            logMethodCall$1,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "replay",
          null
        ),
        __decorate(
          [
            logMethodCall$1,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "pause",
          null
        ),
        __decorate(
          [
            logMethodCall$1,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Number]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "seek",
          null
        ),
        t
      );
    })(FlowPlayer),
    AUTO_HIDE_MOUSE_DELAY = 5e3,
    HIDE_MOUSE_THROTTLE = 300;
  function createH5Player(e) {
    return new H5Player(e);
  }
  H5Player.registerPlugin(DataSet.pluginName, DataSet),
    H5Player.registerPlugin(
      PlaytimeLimiterPlugin.pluginName,
      PlaytimeLimiterPlugin
    ),
    H5Player.registerPlugin(OfflineLogPlugin.pluginName, OfflineLogPlugin),
    H5Player.registerPlugin(
      VodQaReporterPlugin.pluginName,
      VodQaReporterPlugin
    ),
    H5Player.registerPlugin(
      LiveQaReporterPlugin.pluginName,
      LiveQaReporterPlugin
    );
  var envVals$1 = getEnvVals$1(),
    ThumbPlayerH5 = Object.freeze({
      __proto__: null,
      createH5Player: createH5Player,
      H5Player: H5Player,
      envVals: envVals$1,
      BaseReporter: BaseReporter,
      kernelEvtBus: kernelEvtBus,
      preloadEvtBus: preloadEvtBus,
      EvtEmitter: s$1$1,
      PLAY_EVENT: exports.PLAY_EVENT,
      VIDEO_STATE: exports.VIDEO_STATE,
      KERNEL_NAME: exports.KERNEL_NAME,
      PLAY_MODE: exports.PLAY_MODE,
      END_STATE: exports.END_STATE,
      PRELOAD_TYPE: exports.PRELOAD_TYPE,
      VIDEO_CODEC: exports.VIDEO_CODEC,
      CONTAINER_FORMAT: exports.CONTAINER_FORMAT,
      AUDIO_CODEC: exports.AUDIO_CODEC,
      i18nConfig: i18nConfig,
      t: compile,
      get ErrorCode() {
        return exports.ErrorCode;
      },
      get ErrorMsg() {
        return exports.ErrorMsg;
      },
      get FullScreenMode() {
        return exports.FullScreenMode;
      },
      get STATS_NAME() {
        return exports.STATS_NAME;
      },
      getAdPlugin: getAdPlugin,
      getAdReqParams: getAdReqParams,
      adEvents: adEvents,
      BaseFlowNode: BaseFlowNode,
      get FLOW_NODE_EVENT() {
        return exports.FLOW_NODE_EVENT;
      },
      BeaconRequest: BeaconRequest,
      ImageRequest: report,
      definePlugins: definePlugins,
      autobind: autobind,
      logApiInvoke: logApiInvoke,
      once: once,
      tryEmit: tryEmit,
      getEnvVals: getEnvVals$1,
      get H5_EXT_EVENT() {
        return exports.PLAY_EVENT_EXT;
      },
      get H5_PLAY_EVENT() {
        return exports.H5_PLAY_EVENT;
      },
      Plugin: Plugin,
      isFunctionPlugin: isFunctionPlugin,
      createPluginFactory: createPluginFactory,
      getHookMethodName: getHookMethodName,
      registerPlugin: registerPlugin,
      deregisterPlugin: deregisterPlugin,
      getPlugin: getPlugin,
      getPlugins: getPlugins,
      pluginExists: pluginExists,
      AdPluginName: AdPluginName,
      get AD_TYPE() {
        return exports.AD_TYPE;
      },
      isPreOrPostAd: isPreOrPostAd,
      isVideoId: isVideoId,
      DRM_TYPE: DRM_TYPE,
      DRM_VALUE: DRM_VALUE,
      OFFICIAL_PLUGIN: OFFICIAL_PLUGIN,
      PLUGIN_MAP: PLUGIN_MAP,
      get H5_PAUSE_TYPE() {
        return exports.H5_PAUSE_TYPE;
      },
      get AUTO_PLAY_POLICY() {
        return exports.AUTO_PLAY_POLICY;
      },
      get PictureDirection() {
        return exports.PictureDirection;
      },
      get VideoLoopMode() {
        return exports.VideoLoopMode;
      },
      get DATA_EVENTS() {
        return exports.DATA_EVENTS;
      },
      get DATA_STATE() {
        return exports.DATA_STATE;
      },
      get LOG_TYPE() {
        return exports.LOG_TYPE;
      },
      get BUFFER_REASON() {
        return exports.BUFFER_REASON;
      },
      get LOCAL_KEY() {
        return exports.LOCAL_KEY;
      },
      get PersistedUserSettings() {
        return exports.PersistedUserSettings;
      },
      DEFAULT_KEY: DEFAULT_KEY,
      COMMON_DATA_KEY: COMMON_DATA_KEY,
      stepTimerFakeGlobalInstanceId: stepTimerFakeGlobalInstanceId,
      StepTimer: StepTimer,
    }),
    VideoReqInfoPluginName = "__thumbplayer-video-request";
  mountGlobal({
    globalName: "ThumbPlayerH5",
    target: ThumbPlayerH5,
    onDuplicate: function () {
      console.warn(
        "Possible duplicated ThumbPlayerH5 detected. Avoid to import this package multiple times."
      );
    },
  });
  var ThumbPlayerH5$1 = Object.freeze({
      __proto__: null,
      get AD_TYPE() {
        return exports.AD_TYPE;
      },
      get AUTO_PLAY_POLICY() {
        return exports.AUTO_PLAY_POLICY;
      },
      AdPluginName: AdPluginName,
      get BUFFER_REASON() {
        return exports.BUFFER_REASON;
      },
      BaseCheck: BaseCheck,
      BaseFlowNode: BaseFlowNode,
      BaseReporter: BaseReporter,
      BeaconRequest: BeaconRequest,
      COMMON_DATA_KEY: COMMON_DATA_KEY,
      CheckNormalError: CheckNormalError,
      get DATA_EVENTS() {
        return exports.DATA_EVENTS;
      },
      get DATA_STATE() {
        return exports.DATA_STATE;
      },
      DEFAULT_KEY: DEFAULT_KEY,
      DRM_TYPE: DRM_TYPE,
      DRM_VALUE: DRM_VALUE,
      get ErrorCode() {
        return exports.ErrorCode;
      },
      get ErrorMsg() {
        return exports.ErrorMsg;
      },
      get FLOW_NODE_EVENT() {
        return exports.FLOW_NODE_EVENT;
      },
      get FullScreenMode() {
        return exports.FullScreenMode;
      },
      H5Player: H5Player,
      get H5_EXT_EVENT() {
        return exports.PLAY_EVENT_EXT;
      },
      get H5_PAUSE_TYPE() {
        return exports.H5_PAUSE_TYPE;
      },
      get H5_PLAY_EVENT() {
        return exports.H5_PLAY_EVENT;
      },
      ImageRequest: report,
      get LOCAL_KEY() {
        return exports.LOCAL_KEY;
      },
      get LOG_TYPE() {
        return exports.LOG_TYPE;
      },
      OFFICIAL_PLUGIN: OFFICIAL_PLUGIN,
      PLUGIN_MAP: PLUGIN_MAP,
      get PersistedUserSettings() {
        return exports.PersistedUserSettings;
      },
      get PictureDirection() {
        return exports.PictureDirection;
      },
      Plugin: Plugin,
      get STATS_NAME() {
        return exports.STATS_NAME;
      },
      StepTimer: StepTimer,
      get VideoLoopMode() {
        return exports.VideoLoopMode;
      },
      VideoReqInfoPluginName: VideoReqInfoPluginName,
      adEvents: adEvents,
      autobind: autobind,
      createGetinfoModule: createGetinfoModule,
      createH5Player: createH5Player,
      createPluginFactory: createPluginFactory,
      default: ThumbPlayerH5,
      definePlugins: definePlugins,
      deregisterPlugin: deregisterPlugin,
      destroyGetinfoModule: destroyGetinfoModule,
      doGetinfo: doGetinfo,
      envVals: envVals$1,
      getAdPlugin: getAdPlugin,
      getAdReqParams: getAdReqParams,
      getEnvVals: getEnvVals$1,
      getGetinfoModule: getGetinfoModule,
      getHookMethodName: getHookMethodName,
      getPlugin: getPlugin,
      getPlugins: getPlugins,
      hasGetinfoModule: hasGetinfoModule,
      isFunctionPlugin: isFunctionPlugin,
      isPreOrPostAd: isPreOrPostAd,
      isVideoId: isVideoId,
      logApiInvoke: logApiInvoke,
      once: once,
      pluginExists: pluginExists,
      registerPlugin: registerPlugin,
      stepTimerFakeGlobalInstanceId: stepTimerFakeGlobalInstanceId,
      tryEmit: tryEmit,
      get AUDIO_CODEC() {
        return exports.AUDIO_CODEC;
      },
      get CONTAINER_FORMAT() {
        return exports.CONTAINER_FORMAT;
      },
      get END_STATE() {
        return exports.END_STATE;
      },
      EvtEmitter: s$1$1,
      get KERNEL_NAME() {
        return exports.KERNEL_NAME;
      },
      get PLAY_EVENT() {
        return exports.PLAY_EVENT;
      },
      get PLAY_MODE() {
        return exports.PLAY_MODE;
      },
      get PRELOAD_TYPE() {
        return exports.PRELOAD_TYPE;
      },
      get VIDEO_CODEC() {
        return exports.VIDEO_CODEC;
      },
      get VIDEO_STATE() {
        return exports.VIDEO_STATE;
      },
      i18nConfig: i18nConfig,
      kernelEvtBus: kernelEvtBus,
      preloadEvtBus: preloadEvtBus,
      t: compile,
    }),
    CGI =
      "https://zbpbaccess.video.qq.com/trpc.ten_video_live.trpc_live_poll.LiveDetailService/pollLiveInfo",
    Poller = (function () {
      function e() {
        var e = this;
        (this.pollInterval = 3e4),
          (this.timeout = 5e3),
          (this.maxRetryTimes = -1),
          (this.loadInfo = function () {
            if (e.reqData) {
              var t = {
                url: CGI + "?" + urlTool$1.object2string(e.reqData, "&"),
              };
              return (
                -1 !== e.timeout && (t.timeout = e.timeout),
                netTool
                  .xhr(t)
                  .then(e.onCGIComplete)
                  .catch(function (t) {
                    throw (e.onCGIError(t), t);
                  })
              );
            }
          }),
          (this.onCGIComplete = function (t) {
            var o, A;
            e.clearTimer(), (e.errorRetryTimes = 0);
            try {
              A = JSON.parse(null == t ? void 0 : t.data).data;
            } catch (t) {
              e.onCGIError(t);
            }
            if (0 === (null == A ? void 0 : A.err_code)) {
              var i = Number(A.interval);
              !isNaN(i) && i > 0 && (e.pollInterval = 1e3 * i),
                (e.pollTimerID = window.setTimeout(e.loadInfo, e.pollInterval)),
                null === (o = e.onCallback) ||
                  void 0 === o ||
                  o.call(e, null, A);
            } else e.onCGIError(A);
          });
      }
      return (
        (e.prototype.start = function (e, t) {
          return (
            void 0 === e && (e = {}),
            (this.reqData = e),
            (this.errorRetryTimes = 0),
            (this.onCallback = t),
            this.loadInfo()
          );
        }),
        (e.prototype.dispose = function () {
          this.clearTimer(), (this.reqData = null), (this.onCallback = null);
        }),
        (e.prototype.onCGIError = function (e) {
          var t;
          this.clearTimer(),
            (this.errorRetryTimes += 1),
            -1 === this.maxRetryTimes ||
            this.errorRetryTimes <= this.maxRetryTimes
              ? (this.pollTimerID = window.setTimeout(
                  this.loadInfo,
                  this.pollInterval
                ))
              : null === (t = this.onCallback) ||
                void 0 === t ||
                t.call(this, e, null);
        }),
        (e.prototype.clearTimer = function () {
          this.pollTimerID > 0 &&
            (clearTimeout(this.pollTimerID), (this.pollTimerID = 0));
        }),
        e
      );
    })(),
    LIVE_STATUS;
  !(function (e) {
    (e[(e.READY = 3)] = "READY"),
      (e[(e.PLAYING = 1)] = "PLAYING"),
      (e[(e.OVER = 2)] = "OVER");
  })(LIVE_STATUS || (LIVE_STATUS = {}));
  var LIVE_EVENTS = { statusChange: "statusChange" },
    LivepollPlugin = (function (e) {
      function t(t, o) {
        var A = e.call(this, t) || this;
        (A.status = LIVE_STATUS.READY),
          (A.poller = new Poller()),
          (A.destory = function () {
            return A.poller.dispose();
          }),
          (A.handlerLivePollData = function (e, t) {
            if (!e && t) {
              var o = Number(t.play_status);
              o !== A.status &&
                (A.emit(LIVE_EVENTS.statusChange, {
                  old: A.status,
                  new: o,
                  raw: t,
                }),
                o === LIVE_STATUS.OVER && (A.player.stop(), A.destory())),
                (A.status = o);
            }
          }),
          (A.config = __assign$1(__assign$1({}, t.config.livepollConfig), o));
        var i = A.config,
          r = i.livepid,
          n = i.autolisten,
          a = void 0 === n || n,
          s = i.timeout,
          g = void 0 === s ? 5e3 : s;
        return (
          (A.poller.timeout = g),
          r && (A.livepid = r),
          a &&
            (t.addListener(exports.PLAY_EVENT.FIRST_PLAYING, function () {
              return A.request();
            }),
            t.addListener(exports.PLAY_EVENT.STOPED, A.destory)),
          A
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.request = function (e) {
          if (
            ((null == e ? void 0 : e.livepid) && (this.livepid = e.livepid),
            this.poller.dispose(),
            this.livepid)
          )
            return this.poller.start(
              { pid: this.livepid },
              this.handlerLivePollData
            );
        }),
        (t.pluginName = "live-poll"),
        t
      );
    })(Plugin);
  function styleInject$5(e, t) {
    void 0 === t && (t = {});
    var o = t.insertAt;
    if (e && "undefined" != typeof document) {
      var A = document.head || document.getElementsByTagName("head")[0],
        i = document.createElement("style");
      (i.type = "text/css"),
        "top" === o && A.firstChild
          ? A.insertBefore(i, A.firstChild)
          : A.appendChild(i),
        i.styleSheet
          ? (i.styleSheet.cssText = e)
          : i.appendChild(document.createTextNode(e));
    }
  }
  H5Player.registerPlugin(LivepollPlugin.pluginName, LivepollPlugin);
  var css_248z$6 =
    "@-webkit-keyframes txp_loading{0%{background-position:0 0}to{background-position:0 -600px}}@keyframes txp_loading{0%{background-position:0 0}to{background-position:0 -600px}}.txp_overlay_loading{position:absolute;left:0;top:0;width:100%;height:100%;z-index:5;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;pointer-events:none}.txp_overlay_loading.txp_none,.txp_overlay_loading .txp_none{display:none}.txp_overlay_loading .txp_icon_loading{display:block;width:54px;height:20px;margin:0 auto 10px;background:url(https://vm.gtimg.cn/tencentvideo/txp/style/img/loading.png) 0 0 no-repeat;background-size:54px 600px;-webkit-animation:txp_loading 1s steps(30) infinite;animation:txp_loading 1s steps(30) infinite}.txp_overlay_loading .txp_icon_loading.mobile{-webkit-transform:scale(.5);transform:scale(.5);margin:0 auto}";
  styleInject$5(css_248z$6);
  var hideClass$1 = "txp_none",
    htmlStr =
      '<div class="txp_overlay_loading ' +
      hideClass$1 +
      '">\n<div class="txp_text" data-role="txp-ui-continue-play"></div>\n<div class="txp_icon_loading" data-role="txp-ui-loading"></div>\n</div>',
    UILoadingPlugin = (function (e) {
      function t(t, o, A) {
        var i = e.call(this, t, o, A) || this;
        return (
          (i.show = function (e) {
            void 0 === e && (e = ""),
              (i.$continuePlay.innerHTML = e),
              i.$el.classList.remove(hideClass$1);
          }),
          (i.hide = function () {
            i.$el.classList.add(hideClass$1);
          }),
          i.insertDOM(),
          t.on(exports.PLAY_EVENT.SET_LOADING, function (e) {
            var t = e.data.show;
            i.player.setStateKv("ui-loading:" + (t ? "show" : "hide"), {
              type: exports.LOG_TYPE.PLUGIN_ACTION,
            }),
              t ? i.show() : i.hide();
          }),
          i
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.prependElement = function (e) {
          var t;
          null === (t = this.$el) ||
            void 0 === t ||
            t.insertAdjacentElement("afterbegin", e);
        }),
        (t.prototype.insertDOM = function () {
          var e,
            t = this.player.container;
          t.insertAdjacentHTML("beforeend", htmlStr),
            (this.$el = t.querySelector(".txp_overlay_loading")),
            (this.$continuePlay = t.querySelector(
              '[data-role="txp-ui-continue-play"]'
            )),
            (this.$loading = t.querySelector('[data-role="txp-ui-loading"]')),
            (null === (e = this.config) || void 0 === e
              ? void 0
              : e.useMobileStyle) && this.$loading.classList.add("mobile");
        }),
        (t.pluginName = "ui-loading"),
        t
      );
    })(Plugin);
  H5Player.registerPlugin(UILoadingPlugin.pluginName, UILoadingPlugin);
  var tvkI18nConfig = {
      POLL_DURATION_WILL_SWITCH:
        "鎭枩瑙ｉ攣鏂板姛鑳斤紝鏈棰戠◢鍚庡皢涓轰綘鎵╁厖涓哄畬鏁寸増锛�",
      POLL_DURATION_SWITCH_SUCCESS: "杩涘害鏉℃姠鏁戞垚鍔燂紒",
      GETINFO_MISSING_PARAM: "缂哄皯蹇呰鎾斁鍙傛暟 ($0)",
      DEFN_ABR_LABEL: "鑷姩",
      DEVICE_SCORE_NOT_PASS: "褰撳墠璁惧涓嶆敮鎸佹挱鏀�",
      PROXY_HTTP_PARSE_ERROR: "鎾斁鍚庡彴杩斿洖閿欒鐮侊紙$0锛�",
    },
    DRM_REQUEST_VALUE,
    HEVC_LV_VALUE,
    REQ_VOD_STREAM_TYPE,
    LOGIN_METHOD,
    COOKIE_NAME;
  function getRefer() {
    var e = "";
    try {
      (e = removeUrlParams(document.location.href)),
        isInIframe() && (e = removeUrlParams(document.referrer || ""));
    } catch (e) {}
    return e;
  }
  function removeUrlParams(e) {
    if ("string" == typeof e) {
      var t = document.createElement("a");
      return (
        (t.href = e),
        "".concat(t.protocol, "//").concat(t.host).concat(t.pathname)
      );
    }
  }
  function getEhost() {
    var e = "";
    try {
      (e = location.href.replace(location.search, "")),
        isInIframe() && (e = removeUrlParams(top.location.href || ""));
    } catch (e) {}
    return e;
  }
  function isInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return !0;
    }
  }
  function getSpHttps() {
    return "https:" === location.protocol ? 1 : 0;
  }
  function getTimeStampStr(e) {
    var t = e || 10,
      o = (+new Date()).toString();
    return o.length > t
      ? o.substring(0, t)
      : "00000000000".concat(o).slice(-1 * t);
  }
  (exports.CKEY_VRE = void 0),
    (exports.PAID_FORMAT = void 0),
    (defaultI18nConfig.tvk = tvkI18nConfig),
    (function (e) {
      (e[(e.NONE = 0)] = "NONE"),
        (e[(e.FAIRPLAY = 16)] = "FAIRPLAY"),
        (e[(e.WIDEVINE = 32)] = "WIDEVINE"),
        (e[(e.CHACHA20 = 8)] = "CHACHA20");
    })(DRM_REQUEST_VALUE || (DRM_REQUEST_VALUE = {})),
    (function (e) {
      (e[(e.NOT_SPT = 0)] = "NOT_SPT"),
        (e[(e.SD = 11)] = "SD"),
        (e[(e.HD = 16)] = "HD"),
        (e[(e.SHD = 21)] = "SHD"),
        (e[(e.FHD = 26)] = "FHD"),
        (e[(e.UHD = 28)] = "UHD"),
        (e[(e.UHD_ONLY = 31)] = "UHD_ONLY");
    })(HEVC_LV_VALUE || (HEVC_LV_VALUE = {})),
    (function (e) {
      (e[(e.MP4 = 1)] = "MP4"),
        (e[(e.HLS = 3)] = "HLS"),
        (e[(e.DIR_HLS = 8)] = "DIR_HLS");
    })(REQ_VOD_STREAM_TYPE || (REQ_VOD_STREAM_TYPE = {})),
    (function (e) {
      (e.CKEY_8 = "8.5"), (e.CKEY_9 = "9.1");
    })(exports.CKEY_VRE || (exports.CKEY_VRE = {})),
    (function (e) {
      (e.FHD = "fhd"),
        (e.UHD = "uhd"),
        (e.DOLBY = "dolby"),
        (e.HDR10 = "hdr10"),
        (e.SFR_HDR = "sfr_hdr");
    })(exports.PAID_FORMAT || (exports.PAID_FORMAT = {})),
    (function (e) {
      (e.QQ = "qq"), (e.WX = "wx");
    })(LOGIN_METHOD || (LOGIN_METHOD = {})),
    (function (e) {
      (e.MAIN_LOGIN = "main_login"),
        (e.GUID = "video_guid"),
        (e.OPENID = "openid"),
        (e.APPID = "appid"),
        (e.VUSERID = "vuserid"),
        (e.ACCESS_TOKEN = "access_token"),
        (e.VUSESSION = "vusession");
    })(COOKIE_NAME || (COOKIE_NAME = {}));
  var VQQ_COOKIE_PREFIX = "vqq_";
  function getTxVodBrowserDefaultReqParams() {
    return {
      charge: 0,
      otype: "json",
      defnpayver: 0,
      spau: 1,
      spaudio: 1,
      spwm: 1,
      sphls: 1,
      host: location.host,
      refer: getRefer(),
      ehost: getEhost(),
      sphttps: getSpHttps(),
      encryptVer: "",
      cKey: "",
      clip: 4,
      guid: "",
      flowid: "",
      platform: "",
      sdtfrom: "",
      appVer: "1.0.0.0",
      unid: "",
      auth_from: "",
      auth_ext: "",
      vid: "",
      defn: "",
      fhdswitch: 0,
      dtype: REQ_VOD_STREAM_TYPE.HLS,
      spsrt: 2,
      tm: "",
      lang_code: 0,
      logintoken: "",
    };
  }
  var extendStatics = function (e, t) {
    return (
      (extendStatics =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (e, t) {
            e.__proto__ = t;
          }) ||
        function (e, t) {
          for (var o in t)
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }),
      extendStatics(e, t)
    );
  };
  function __extends(e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError(
        "Class extends value " + String(t) + " is not a constructor or null"
      );
    function o() {
      this.constructor = e;
    }
    extendStatics(e, t),
      (e.prototype =
        null === t ? Object.create(t) : ((o.prototype = t.prototype), new o()));
  }
  var __assign = function () {
    return (
      (__assign =
        Object.assign ||
        function (e) {
          for (var t, o = 1, A = arguments.length; o < A; o++)
            for (var i in (t = arguments[o]))
              Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          return e;
        }),
      __assign.apply(this, arguments)
    );
  };
  function __awaiter(e, t, o, A) {
    return new (o || (o = Promise))(function (i, r) {
      function n(e) {
        try {
          s(A.next(e));
        } catch (e) {
          r(e);
        }
      }
      function a(e) {
        try {
          s(A.throw(e));
        } catch (e) {
          r(e);
        }
      }
      function s(e) {
        var t;
        e.done
          ? i(e.value)
          : ((t = e.value),
            t instanceof o
              ? t
              : new o(function (e) {
                  e(t);
                })).then(n, a);
      }
      s((A = A.apply(e, t || [])).next());
    });
  }
  function __generator(e, t) {
    var o,
      A,
      i,
      r,
      n = {
        label: 0,
        sent: function () {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: [],
      };
    return (
      (r = { next: a(0), throw: a(1), return: a(2) }),
      "function" == typeof Symbol &&
        (r[Symbol.iterator] = function () {
          return this;
        }),
      r
    );
    function a(a) {
      return function (s) {
        return (function (a) {
          if (o) throw new TypeError("Generator is already executing.");
          for (; r && ((r = 0), a[0] && (n = 0)), n; )
            try {
              if (
                ((o = 1),
                A &&
                  (i =
                    2 & a[0]
                      ? A.return
                      : a[0]
                      ? A.throw || ((i = A.return) && i.call(A), 0)
                      : A.next) &&
                  !(i = i.call(A, a[1])).done)
              )
                return i;
              switch (((A = 0), i && (a = [2 & a[0], i.value]), a[0])) {
                case 0:
                case 1:
                  i = a;
                  break;
                case 4:
                  return n.label++, { value: a[1], done: !1 };
                case 5:
                  n.label++, (A = a[1]), (a = [0]);
                  continue;
                case 7:
                  (a = n.ops.pop()), n.trys.pop();
                  continue;
                default:
                  if (
                    !(
                      (i = (i = n.trys).length > 0 && i[i.length - 1]) ||
                      (6 !== a[0] && 2 !== a[0])
                    )
                  ) {
                    n = 0;
                    continue;
                  }
                  if (3 === a[0] && (!i || (a[1] > i[0] && a[1] < i[3]))) {
                    n.label = a[1];
                    break;
                  }
                  if (6 === a[0] && n.label < i[1]) {
                    (n.label = i[1]), (i = a);
                    break;
                  }
                  if (i && n.label < i[2]) {
                    (n.label = i[2]), n.ops.push(a);
                    break;
                  }
                  i[2] && n.ops.pop(), n.trys.pop();
                  continue;
              }
              a = t.call(e, n);
            } catch (e) {
              (a = [6, e]), (A = 0);
            } finally {
              o = i = 0;
            }
          if (5 & a[0]) throw a[1];
          return { value: a[0] ? a[1] : void 0, done: !0 };
        })([a, s]);
      };
    }
  }
  var commonjsGlobal$1 =
      "undefined" != typeof globalThis
        ? globalThis
        : "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : "undefined" != typeof self
        ? self
        : {},
    lodash_merge = { exports: {} };
  !(function (e, t) {
    var o = "__lodash_hash_undefined__",
      A = 9007199254740991,
      i = "[object Arguments]",
      r = "[object Function]",
      n = "[object Object]",
      a = /^\[object .+?Constructor\]$/,
      s = /^(?:0|[1-9]\d*)$/,
      g = {};
    (g["[object Float32Array]"] =
      g["[object Float64Array]"] =
      g["[object Int8Array]"] =
      g["[object Int16Array]"] =
      g["[object Int32Array]"] =
      g["[object Uint8Array]"] =
      g["[object Uint8ClampedArray]"] =
      g["[object Uint16Array]"] =
      g["[object Uint32Array]"] =
        !0),
      (g[i] =
        g["[object Array]"] =
        g["[object ArrayBuffer]"] =
        g["[object Boolean]"] =
        g["[object DataView]"] =
        g["[object Date]"] =
        g["[object Error]"] =
        g[r] =
        g["[object Map]"] =
        g["[object Number]"] =
        g[n] =
        g["[object RegExp]"] =
        g["[object Set]"] =
        g["[object String]"] =
        g["[object WeakMap]"] =
          !1);
    var l =
        "object" == typeof commonjsGlobal$1 &&
        commonjsGlobal$1 &&
        commonjsGlobal$1.Object === Object &&
        commonjsGlobal$1,
      E = "object" == typeof self && self && self.Object === Object && self,
      c = l || E || Function("return this")(),
      u = t && !t.nodeType && t,
      p = u && e && !e.nodeType && e,
      d = p && p.exports === u,
      B = d && l.process,
      h = (function () {
        try {
          return (
            (p && p.require && p.require("util").types) ||
            (B && B.binding && B.binding("util"))
          );
        } catch (e) {}
      })(),
      I = h && h.isTypedArray;
    function C(e, t, o) {
      switch (o.length) {
        case 0:
          return e.call(t);
        case 1:
          return e.call(t, o[0]);
        case 2:
          return e.call(t, o[0], o[1]);
        case 3:
          return e.call(t, o[0], o[1], o[2]);
      }
      return e.apply(t, o);
    }
    var _,
      f,
      y,
      m = Array.prototype,
      v = Function.prototype,
      Q = Object.prototype,
      T = c["__core-js_shared__"],
      S = v.toString,
      D = Q.hasOwnProperty,
      R = (_ = /[^.]+$/.exec((T && T.keys && T.keys.IE_PROTO) || ""))
        ? "Symbol(src)_1." + _
        : "",
      O = Q.toString,
      F = S.call(Object),
      N = RegExp(
        "^" +
          S.call(D)
            .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              "$1.*?"
            ) +
          "$"
      ),
      w = d ? c.Buffer : void 0,
      L = c.Symbol,
      P = c.Uint8Array,
      M =
        (w && w.allocUnsafe,
        (f = Object.getPrototypeOf),
        (y = Object),
        function (e) {
          return f(y(e));
        }),
      Y = Object.create,
      b = Q.propertyIsEnumerable,
      k = m.splice,
      x = L ? L.toStringTag : void 0,
      U = (function () {
        try {
          var e = ae(Object, "defineProperty");
          return e({}, "", {}), e;
        } catch (e) {}
      })(),
      K = w ? w.isBuffer : void 0,
      G = Math.max,
      H = Date.now,
      V = ae(c, "Map"),
      q = ae(Object, "create"),
      J = (function () {
        function e() {}
        return function (t) {
          if (!Ce(t)) return {};
          if (Y) return Y(t);
          e.prototype = t;
          var o = new e();
          return (e.prototype = void 0), o;
        };
      })();
    function j(e) {
      var t = -1,
        o = null == e ? 0 : e.length;
      for (this.clear(); ++t < o; ) {
        var A = e[t];
        this.set(A[0], A[1]);
      }
    }
    function W(e) {
      var t = -1,
        o = null == e ? 0 : e.length;
      for (this.clear(); ++t < o; ) {
        var A = e[t];
        this.set(A[0], A[1]);
      }
    }
    function $(e) {
      var t = -1,
        o = null == e ? 0 : e.length;
      for (this.clear(); ++t < o; ) {
        var A = e[t];
        this.set(A[0], A[1]);
      }
    }
    function z(e) {
      var t = (this.__data__ = new W(e));
      this.size = t.size;
    }
    function Z(e, t, o) {
      ((void 0 !== o && !ce(e[t], o)) || (void 0 === o && !(t in e))) &&
        te(e, t, o);
    }
    function X(e, t, o) {
      var A = e[t];
      (D.call(e, t) && ce(A, o) && (void 0 !== o || t in e)) || te(e, t, o);
    }
    function ee(e, t) {
      for (var o = e.length; o--; ) if (ce(e[o][0], t)) return o;
      return -1;
    }
    function te(e, t, o) {
      "__proto__" == t && U
        ? U(e, t, { configurable: !0, enumerable: !0, value: o, writable: !0 })
        : (e[t] = o);
    }
    function oe(e) {
      return null == e
        ? void 0 === e
          ? "[object Undefined]"
          : "[object Null]"
        : x && x in Object(e)
        ? (function (e) {
            var t = D.call(e, x),
              o = e[x];
            try {
              e[x] = void 0;
              var A = !0;
            } catch (e) {}
            var i = O.call(e);
            return A && (t ? (e[x] = o) : delete e[x]), i;
          })(e)
        : (function (e) {
            return O.call(e);
          })(e);
    }
    function Ae(e) {
      return _e(e) && oe(e) == i;
    }
    function ie(e, t, o, A, i) {
      e !== t &&
        (function (e, t, o) {
          for (var A = -1, i = Object(e), r = o(e), n = r.length; n--; ) {
            var a = r[++A];
            if (!1 === t(i[a], a)) break;
          }
        })(
          t,
          function (r, a) {
            if ((i || (i = new z()), Ce(r)))
              !(function (e, t, o, A, i, r, a) {
                var s = le(e, o),
                  g = le(t, o),
                  l = a.get(g);
                if (l) Z(e, o, l);
                else {
                  var E,
                    c,
                    u,
                    p,
                    d,
                    B = r ? r(s, g, o + "", e, t, a) : void 0,
                    h = void 0 === B;
                  if (h) {
                    var I = pe(g),
                      C = !I && Be(g),
                      _ = !I && !C && fe(g);
                    (B = g),
                      I || C || _
                        ? pe(s)
                          ? (B = s)
                          : _e((d = s)) && de(d)
                          ? (B = (function (e, t) {
                              var o = -1,
                                A = e.length;
                              for (t || (t = Array(A)); ++o < A; ) t[o] = e[o];
                              return t;
                            })(s))
                          : C
                          ? ((h = !1),
                            (B = (function (e, t) {
                              return e.slice();
                            })(g)))
                          : _
                          ? ((h = !1),
                            (p = new (u = (E = g).buffer).constructor(
                              u.byteLength
                            )),
                            new P(p).set(new P(u)),
                            (c = p),
                            (B = new E.constructor(c, E.byteOffset, E.length)))
                          : (B = [])
                        : (function (e) {
                            if (!_e(e) || oe(e) != n) return !1;
                            var t = M(e);
                            if (null === t) return !0;
                            var o = D.call(t, "constructor") && t.constructor;
                            return (
                              "function" == typeof o &&
                              o instanceof o &&
                              S.call(o) == F
                            );
                          })(g) || ue(g)
                        ? ((B = s),
                          ue(s)
                            ? (B = (function (e) {
                                return (function (e, t, o, A) {
                                  var i = !o;
                                  o || (o = {});
                                  for (var r = -1, n = t.length; ++r < n; ) {
                                    var a = t[r],
                                      s = void 0;
                                    void 0 === s && (s = e[a]),
                                      i ? te(o, a, s) : X(o, a, s);
                                  }
                                  return o;
                                })(e, ye(e));
                              })(s))
                            : (Ce(s) && !he(s)) ||
                              (B = (function (e) {
                                return "function" != typeof e.constructor ||
                                  ge(e)
                                  ? {}
                                  : J(M(e));
                              })(g)))
                        : (h = !1);
                  }
                  h && (a.set(g, B), i(B, g, A, r, a), a.delete(g)), Z(e, o, B);
                }
              })(e, t, a, o, ie, A, i);
            else {
              var s = A ? A(le(e, a), r, a + "", e, t, i) : void 0;
              void 0 === s && (s = r), Z(e, a, s);
            }
          },
          ye
        );
    }
    (j.prototype.clear = function () {
      (this.__data__ = q ? q(null) : {}), (this.size = 0);
    }),
      (j.prototype.delete = function (e) {
        var t = this.has(e) && delete this.__data__[e];
        return (this.size -= t ? 1 : 0), t;
      }),
      (j.prototype.get = function (e) {
        var t = this.__data__;
        if (q) {
          var A = t[e];
          return A === o ? void 0 : A;
        }
        return D.call(t, e) ? t[e] : void 0;
      }),
      (j.prototype.has = function (e) {
        var t = this.__data__;
        return q ? void 0 !== t[e] : D.call(t, e);
      }),
      (j.prototype.set = function (e, t) {
        var A = this.__data__;
        return (
          (this.size += this.has(e) ? 0 : 1),
          (A[e] = q && void 0 === t ? o : t),
          this
        );
      }),
      (W.prototype.clear = function () {
        (this.__data__ = []), (this.size = 0);
      }),
      (W.prototype.delete = function (e) {
        var t = this.__data__,
          o = ee(t, e);
        return !(
          o < 0 ||
          (o == t.length - 1 ? t.pop() : k.call(t, o, 1), --this.size, 0)
        );
      }),
      (W.prototype.get = function (e) {
        var t = this.__data__,
          o = ee(t, e);
        return o < 0 ? void 0 : t[o][1];
      }),
      (W.prototype.has = function (e) {
        return ee(this.__data__, e) > -1;
      }),
      (W.prototype.set = function (e, t) {
        var o = this.__data__,
          A = ee(o, e);
        return A < 0 ? (++this.size, o.push([e, t])) : (o[A][1] = t), this;
      }),
      ($.prototype.clear = function () {
        (this.size = 0),
          (this.__data__ = {
            hash: new j(),
            map: new (V || W)(),
            string: new j(),
          });
      }),
      ($.prototype.delete = function (e) {
        var t = ne(this, e).delete(e);
        return (this.size -= t ? 1 : 0), t;
      }),
      ($.prototype.get = function (e) {
        return ne(this, e).get(e);
      }),
      ($.prototype.has = function (e) {
        return ne(this, e).has(e);
      }),
      ($.prototype.set = function (e, t) {
        var o = ne(this, e),
          A = o.size;
        return o.set(e, t), (this.size += o.size == A ? 0 : 1), this;
      }),
      (z.prototype.clear = function () {
        (this.__data__ = new W()), (this.size = 0);
      }),
      (z.prototype.delete = function (e) {
        var t = this.__data__,
          o = t.delete(e);
        return (this.size = t.size), o;
      }),
      (z.prototype.get = function (e) {
        return this.__data__.get(e);
      }),
      (z.prototype.has = function (e) {
        return this.__data__.has(e);
      }),
      (z.prototype.set = function (e, t) {
        var o = this.__data__;
        if (o instanceof W) {
          var A = o.__data__;
          if (!V || A.length < 199)
            return A.push([e, t]), (this.size = ++o.size), this;
          o = this.__data__ = new $(A);
        }
        return o.set(e, t), (this.size = o.size), this;
      });
    var re = U
      ? function (e, t) {
          return U(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value:
              ((o = t),
              function () {
                return o;
              }),
            writable: !0,
          });
          var o;
        }
      : Qe;
    function ne(e, t) {
      var o,
        A,
        i = e.__data__;
      return (
        "string" == (A = typeof (o = t)) ||
        "number" == A ||
        "symbol" == A ||
        "boolean" == A
          ? "__proto__" !== o
          : null === o
      )
        ? i["string" == typeof t ? "string" : "hash"]
        : i.map;
    }
    function ae(e, t) {
      var o = (function (e, t) {
        return null == e ? void 0 : e[t];
      })(e, t);
      return (function (e) {
        return (
          !(
            !Ce(e) ||
            (function (e) {
              return !!R && R in e;
            })(e)
          ) &&
          (he(e) ? N : a).test(
            (function (e) {
              if (null != e) {
                try {
                  return S.call(e);
                } catch (e) {}
                try {
                  return e + "";
                } catch (e) {}
              }
              return "";
            })(e)
          )
        );
      })(o)
        ? o
        : void 0;
    }
    function se(e, t) {
      var o = typeof e;
      return (
        !!(t = null == t ? A : t) &&
        ("number" == o || ("symbol" != o && s.test(e))) &&
        e > -1 &&
        e % 1 == 0 &&
        e < t
      );
    }
    function ge(e) {
      var t = e && e.constructor;
      return e === (("function" == typeof t && t.prototype) || Q);
    }
    function le(e, t) {
      if (
        ("constructor" !== t || "function" != typeof e[t]) &&
        "__proto__" != t
      )
        return e[t];
    }
    var Ee = (function (e) {
      var t = 0,
        o = 0;
      return function () {
        var A = H(),
          i = 16 - (A - o);
        if (((o = A), i > 0)) {
          if (++t >= 800) return arguments[0];
        } else t = 0;
        return e.apply(void 0, arguments);
      };
    })(re);
    function ce(e, t) {
      return e === t || (e != e && t != t);
    }
    var ue = Ae(
        (function () {
          return arguments;
        })()
      )
        ? Ae
        : function (e) {
            return _e(e) && D.call(e, "callee") && !b.call(e, "callee");
          },
      pe = Array.isArray;
    function de(e) {
      return null != e && Ie(e.length) && !he(e);
    }
    var Be =
      K ||
      function () {
        return !1;
      };
    function he(e) {
      if (!Ce(e)) return !1;
      var t = oe(e);
      return (
        t == r ||
        "[object GeneratorFunction]" == t ||
        "[object AsyncFunction]" == t ||
        "[object Proxy]" == t
      );
    }
    function Ie(e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= A;
    }
    function Ce(e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    }
    function _e(e) {
      return null != e && "object" == typeof e;
    }
    var fe = I
      ? (function (e) {
          return function (t) {
            return e(t);
          };
        })(I)
      : function (e) {
          return _e(e) && Ie(e.length) && !!g[oe(e)];
        };
    function ye(e) {
      return de(e)
        ? (function (e, t) {
            var o = pe(e),
              A = !o && ue(e),
              i = !o && !A && Be(e),
              r = !o && !A && !i && fe(e),
              n = o || A || i || r,
              a = n
                ? (function (e, t) {
                    for (var o = -1, A = Array(e); ++o < e; ) A[o] = t(o);
                    return A;
                  })(e.length, String)
                : [],
              s = a.length;
            for (var g in e)
              (n &&
                ("length" == g ||
                  (i && ("offset" == g || "parent" == g)) ||
                  (r &&
                    ("buffer" == g ||
                      "byteLength" == g ||
                      "byteOffset" == g)) ||
                  se(g, s))) ||
                a.push(g);
            return a;
          })(e)
        : (function (e) {
            if (!Ce(e))
              return (function (e) {
                var t = [];
                if (null != e) for (var o in Object(e)) t.push(o);
                return t;
              })(e);
            var t = ge(e),
              o = [];
            for (var A in e)
              ("constructor" != A || (!t && D.call(e, A))) && o.push(A);
            return o;
          })(e);
    }
    var me,
      ve =
        ((me = function (e, t, o) {
          ie(e, t, o);
        }),
        (function (e, t) {
          return Ee(
            (function (e, t, o) {
              return (
                (t = G(void 0 === t ? e.length - 1 : t, 0)),
                function () {
                  for (
                    var A = arguments,
                      i = -1,
                      r = G(A.length - t, 0),
                      n = Array(r);
                    ++i < r;

                  )
                    n[i] = A[t + i];
                  i = -1;
                  for (var a = Array(t + 1); ++i < t; ) a[i] = A[i];
                  return (a[t] = o(n)), C(e, this, a);
                }
              );
            })(e, void 0, Qe),
            e + ""
          );
        })(function (e, t) {
          var o = -1,
            A = t.length,
            i = A > 1 ? t[A - 1] : void 0,
            r = A > 2 ? t[2] : void 0;
          for (
            i = me.length > 3 && "function" == typeof i ? (A--, i) : void 0,
              r &&
                (function (e, t, o) {
                  if (!Ce(o)) return !1;
                  var A = typeof t;
                  return (
                    !!("number" == A
                      ? de(o) && se(t, o.length)
                      : "string" == A && (t in o)) && ce(o[t], e)
                  );
                })(t[0], t[1], r) &&
                ((i = A < 3 ? void 0 : i), (A = 1)),
              e = Object(e);
            ++o < A;

          ) {
            var n = t[o];
            n && me(e, n, o);
          }
          return e;
        }));
    function Qe(e) {
      return e;
    }
    e.exports = ve;
  })(lodash_merge, lodash_merge.exports);
  var merge = lodash_merge.exports,
    e$1 = function () {
      return (e$1 =
        Object.assign ||
        function (e) {
          for (var t, o = 1, A = arguments.length; o < A; o++)
            for (var i in (t = arguments[o]))
              Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          return e;
        }).apply(this, arguments);
    },
    t$1 = (function () {
      function e() {}
      return (
        (e.setDefault = function (t) {
          e.defaultOptions = e$1(e$1({}, e.defaultOptions), t);
        }),
        (e.getCookie = function (t) {
          var o = void 0,
            A = document.cookie ? document.cookie.split("; ") : [],
            i = {};
          return (
            A.some(function (A) {
              var r = A.split("="),
                n = r[0],
                a = r.slice(1),
                s = e.decode(n),
                g = e.parseValue(a.join("="));
              return s === t ? ((o = g), !0) : ((i[s] = g), !1);
            }),
            void 0 === t ? i : o
          );
        }),
        (e.setCookie = function (t, o, A) {
          return void 0 === A && (A = {}), e.set(t, o, A);
        }),
        (e.clearCookie = function (t, o, A) {
          void 0 === o && (o = ""),
            void 0 === A && (A = ""),
            e.setCookie(t, "", { domain: o, path: A, expires: -1 });
        }),
        (e.clearAllCookies = function (t, o) {
          void 0 === t && (t = ""), void 0 === o && (o = "");
          var A = document.cookie ? document.cookie.split("; ") : [],
            i = { domain: t, path: o, expires: -1 };
          A.forEach(function (t) {
            var o = t.split("=")[0];
            e.set(o, "", i, !0);
          });
        }),
        (e.set = function (t, o, A, i) {
          void 0 === i && (i = !1);
          var r = e$1(e$1({}, e.defaultOptions), A),
            n = r.domain,
            a = r.path,
            s = r.secure,
            g = r.expires,
            l = r.sameSite,
            E = new Date(Date.now() + 24 * g * 60 * 60 * 1e3),
            c = [
              (i ? t : e.encode(t)) + "=" + e.stringifyValue(o),
              "; expires=" + E.toUTCString(),
              a ? "; path=" + a : "",
              n ? "; domain=" + n : "",
              l ? "; SameSite=" + l : "",
              s ? "; Secure" : "",
            ].join("");
          return (document.cookie = c), c;
        }),
        (e.encode = function (t) {
          return e.raw ? t : encodeURIComponent(t);
        }),
        (e.decode = function (t) {
          return e.raw ? t : decodeURIComponent(t);
        }),
        (e.stringifyValue = function (t) {
          return e.encode(e.json ? JSON.stringify(t) : String(t));
        }),
        (e.parseValue = function (t) {
          if (e.raw) return t;
          var o = t;
          0 === o.indexOf('"') &&
            (o = o.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
          try {
            return (
              (o = decodeURIComponent(o.replace(/\+/g, " "))),
              e.json ? JSON.parse(o) : o
            );
          } catch (t) {}
        }),
        (e.raw = !1),
        (e.json = !1),
        (e.defaultOptions = {
          domain: "",
          path: "/",
          expires: 365,
          secure: !0,
          sameSite: "",
        }),
        e
      );
    })(),
    n$2 = function (e, t) {
      var o = "" + e;
      return !o || o.length >= t
        ? o
        : "" + Array(t + 1 - o.length).join("0") + e;
    },
    i$2 =
      /\[([^\]]+)]|(Y|y){1,4}|M{1,4}|D{1,2}|d{1,2}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
    o$1;
  function r$2(e, t) {
    void 0 === t && (t = "yyyy-MM-DD HH:mm:ss");
    var o = new Date(e);
    if (isNaN(o.getTime())) return o.toString();
    var A = t,
      i = "" + o.getFullYear(),
      r = i.slice(-2),
      n = o.getHours(),
      a = "" + (n % 12 || 12),
      s = "" + (o.getMonth() + 1),
      g = "" + o.getDate(),
      l = "" + o.getDay(),
      E = "" + o.getMinutes(),
      c = "" + o.getSeconds(),
      u = "" + o.getMilliseconds(),
      p = 15 * Math.round(o.getTimezoneOffset() / 15),
      d = Math.abs(p),
      B = n$2(Math.floor(d / 60), 2),
      h = n$2(d % 60, 2),
      I = p <= 0 ? "+" : "-",
      C = "" + I + B + ":" + h,
      _ = "" + I + B + h,
      f = {
        YY: r,
        YYYY: i,
        yy: r,
        yyyy: i,
        M: s,
        MM: n$2(s, 2),
        D: g,
        DD: n$2(g, 2),
        d: l,
        dd: n$2(g, 2),
        H: "" + n,
        HH: n$2(n, 2),
        h: n$2(a, 1),
        hh: n$2(a, 2),
        a: n < 12 ? "am" : "pm",
        A: n < 12 ? "AM" : "PM",
        m: E,
        mm: n$2(E, 2),
        s: c,
        ss: n$2(c, 2),
        SSS: n$2(u, 3),
        Z: C,
        ZZ: _,
      };
    return A.replace(i$2, function (e, t) {
      return t || f[e] || e;
    });
  }
  function v$1(e) {
    try {
      return decodeURIComponent(e.replace(/\+/g, " "));
    } catch (e) {
      return null;
    }
  }
  function h$1(e) {
    var t = e.split("#"),
      o = t[0],
      A = t[1],
      i = void 0 === A ? "" : A,
      r = o.split("?"),
      n = r[0],
      a = r[1],
      s = void 0 === a ? "" : a,
      g = v$1(i),
      l = Object.create(null);
    return (
      s.split("&").forEach(function (e) {
        var t = e.split("="),
          o = t[0],
          A = t[1],
          i = void 0 === A ? "" : A,
          r = v$1(o),
          n = v$1(i);
        null === r ||
          null === n ||
          ("" === r && "" === n) ||
          l[r] ||
          (l[r] = n);
      }),
      { url: n, query: l, hash: g }
    );
  }
  function y$1(e, t) {
    var o;
    if (!t || !document.querySelectorAll("style[data-tag=" + t + "]").length) {
      var A = document.createElement("style");
      (A.textContent = e.trim()),
        t && (A.dataset.tag = t),
        null === (o = document.getElementsByTagName("head")[0]) ||
          void 0 === o ||
          o.appendChild(A);
    }
  }
  function x$1(e, t) {
    return new Promise(function (o, A) {
      if (t && document.querySelectorAll("script[data-tag=" + t + "]").length)
        return o();
      var i = document.createElement("script"),
        r = e$1({ type: "text/javascript", charset: "utf-8" }, e);
      Object.keys(r).forEach(function (e) {
        return S$1(i, e, r[e]);
      }),
        t && (i.dataset.tag = t),
        (i.onload = function () {
          return o();
        }),
        (i.onreadystatechange = function () {
          var e = i.readyState;
          ["complete", "loaded"].includes(e) &&
            ((i.onreadystatechange = null), o());
        }),
        (i.onerror = A),
        document.body.appendChild(i);
    });
  }
  function S$1(e, t, o) {
    if (e) return void 0 === o ? e.getAttribute(t) : e.setAttribute(t, o);
  }
  function M$1(e, t) {
    return (
      !!(null == e ? void 0 : e.className) &&
      -1 !== e.getAttribute("class").split(" ").indexOf(t)
    );
  }
  function q$1(e, t) {
    if (e && !M$1(e, t)) {
      var o = (e.className + " " + t).trim();
      e.setAttribute("class", o);
    }
  }
  function _$1(e, t) {
    if (e) {
      var o = e.className.split(" "),
        A = o.indexOf(t);
      -1 !== A && (o.splice(A, 1), (e.className = o.join(" ")));
    }
  }
  function E$1(e, t, o) {
    if (e && t)
      if ("string" != typeof t || void 0 === o) {
        if ("string" == typeof t && void 0 === o)
          return (e.currentStyle ? e.currentStyle : getComputedStyle(e, null))[
            t
          ];
        "object" == typeof t &&
          Object.keys(t).forEach(function (o) {
            return E$1(e, o, t[o]);
          });
      } else {
        var A =
          /width|height|left|right|top|bottom|padding|margin/i.test(t) &&
          "number" == typeof o;
        e.style[t] = A ? o + "px" : o;
      }
  }
  function O$1(e) {
    E$1(e, { display: "none" });
  }
  function k$1(e, t) {
    void 0 === t && (t = "block"), E$1(e, { display: t });
  }
  function j$1(e, t) {
    if (e) return void 0 === t ? e.innerText : void (e.innerText = t);
  }
  function C$1(e, t) {
    if (e) return void 0 === t ? e.innerHTML : void (e.innerHTML = t);
  }
  !(function (e) {
    (e[(e.equal = 0)] = "equal"),
      (e[(e.low = -1)] = "low"),
      (e[(e.high = 1)] = "high");
  })(o$1 || (o$1 = {}));
  var A$1 =
    /^v?(?:\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+))?(?:-[\da-z-]+(?:\.[\da-z-]+)*)?(?:\+[\da-z-]+(?:\.[\da-z-]+)*)?)?)?$/i;
  function P$1(e) {
    var t,
      o = e.replace(/^v/, "").replace(/\+.*$/, ""),
      A = -1 === (t = o).indexOf("-") ? t.length : t.indexOf("-"),
      i = o.substring(0, A).split(".");
    return i.push(o.substring(A + 1)), i;
  }
  function N$1(e) {
    return isNaN(Number(e)) ? e : Number(e);
  }
  function D$1(e) {
    if ("string" != typeof e)
      throw new TypeError("Invalid argument expected string");
    if (!A$1.test(e))
      throw new Error(
        "Invalid argument not valid semver ('" + e + "' received)"
      );
  }
  function T$1(e, t) {
    [e, t].forEach(D$1);
    for (
      var o = P$1(e), A = P$1(t), i = 0;
      i < Math.max(o.length - 1, A.length - 1);
      i++
    ) {
      var r = parseInt(o[i] || "0", 10),
        n = parseInt(A[i] || "0", 10);
      if (r > n) return o$1.high;
      if (n > r) return o$1.low;
    }
    var a = o[o.length - 1],
      s = A[A.length - 1];
    if (a && s) {
      var g = a.split(".").map(N$1),
        l = s.split(".").map(N$1);
      for (i = 0; i < Math.max(g.length, l.length); i++) {
        if (
          void 0 === g[i] ||
          ("string" == typeof l[i] && "number" == typeof g[i])
        )
          return -1;
        if (
          void 0 === l[i] ||
          ("string" == typeof g[i] && "number" == typeof l[i])
        )
          return 1;
        if (g[i] > l[i]) return o$1.high;
        if (l[i] > g[i]) return o$1.low;
      }
    } else if (a || s) return a ? o$1.low : o$1.high;
    return o$1.equal;
  }
  var B$1 = /</g,
    I$1 = />/g,
    H$1 = /"/g,
    Q$1 = /'/g,
    R$1 = /&/g;
  function V$1(e) {
    return e
      ? ("" + e)
          .replace(R$1, "&amp;")
          .replace(B$1, "&lt;")
          .replace(I$1, "&gt;")
          .replace(H$1, "&quot;")
          .replace(Q$1, "&#39;")
      : "";
  }
  var commonTool = {
      merge: merge,
      supportES6: function () {
        try {
          eval("var foo = (x)=>x+1");
        } catch (e) {
          return !1;
        }
        return !0;
      },
      isObject: function (e) {
        return "object" == typeof e && e.constructor === Object;
      },
      createGUID: function (e) {
        void 0 === e && (e = 32);
        for (var t = e || 32, o = "", A = 1; A <= t; A++)
          o += Math.floor(16 * Math.random()).toString(16);
        return o;
      },
      xss: V$1,
      removeDiscontinuityTimeRangesFromPlayTime: function (e, t) {
        var o = commonTool.findDiscontinuityTimeRangeAtPlaytime(e, t);
        if (o) return o.start;
        var A = e;
        return (
          t.forEach(function (t) {
            t.end < e && (A -= t.end - t.start);
          }),
          A
        );
      },
      findDiscontinuityTimeRangeAtPlaytime: function (e, t) {
        return commonTool.mergeTimeRanges(t).find(function (t) {
          return e >= t.start && e <= t.end;
        });
      },
      mergeTimeRanges: function (e) {
        var t = -1,
          o = -1,
          A = [];
        return (
          e.forEach(function (e) {
            var i = e.start,
              r = e.end;
            i <= o || (o >= 0 && A.push({ start: t, end: o }), (t = i)),
              (o = r);
          }),
          t >= 0 && o >= 0 && A.push({ start: t, end: o }),
          A
        );
      },
      compareVersion: T$1,
      formatPlayTime: function (e) {
        var t = e;
        if (
          ("string" == typeof t && (t = parseInt(t, 10)),
          "number" != typeof t || Number.isNaN(t))
        )
          return "00:00";
        var o = function (e) {
            return e < 10 ? "0".concat(e) : e;
          },
          A = Math.floor(t / 3600),
          i = Math.floor((t - 3600 * A) / 60),
          r = Math.floor(t - 3600 * A - 60 * i);
        return 0 === A ? [o(i), o(r)].join(":") : [A, o(i), o(r)].join(":");
      },
      dateFormat: function (e, t) {
        return (
          void 0 === t && (t = Date.now()), r$2(t, e || "yyyy-MM-dd hh:mm:ss")
        );
      },
      base64ToArrayBuffer: function (e) {
        for (
          var t = window.atob(e), o = t.length, A = new Uint8Array(o), i = 0;
          i < o;
          i++
        )
          A[i] = t.charCodeAt(i);
        return A;
      },
      isPageHidden: function () {
        var e = ["hidden", "msHidden", "webkitHidden"].find(function (e) {
          return void 0 !== document[e];
        });
        return e ? (document[e] ? 1 : 0) : -1;
      },
      setTimeoutByRAF: function (e, t) {
        var o =
            window.requestAnimationFrame || window.webkitRequestAnimationFrame,
          A = +new Date();
        !(function i() {
          +new Date() - A > t ? e() : o(i);
        })();
      },
      assignApiToPrototype: function (e, t, o) {
        for (
          var A = Object.getPrototypeOf(e),
            i = Object.getOwnPropertyNames(t),
            r = 0,
            n = o.length;
          r < n;
          r++
        ) {
          var a = o[r];
          -1 !== i.indexOf(a) ||
            "function" != typeof A[a] ||
            (t[a] = A[a].bind(e));
        }
      },
    },
    cookieTool = {
      set: function (e, t, o, A, i) {
        var r = { domain: o, path: A };
        return i && (r.expires = i), t$1.setCookie(e, t, r), !0;
      },
      get: function (e) {
        return t$1.getCookie(e) || "";
      },
      del: t$1.clearCookie,
    },
    r$1;
  function t$2(e, t, o, A) {
    return new (o || (o = Promise))(function (i, r) {
      function n(e) {
        try {
          s(A.next(e));
        } catch (e) {
          r(e);
        }
      }
      function a(e) {
        try {
          s(A.throw(e));
        } catch (e) {
          r(e);
        }
      }
      function s(e) {
        var t;
        e.done
          ? i(e.value)
          : ((t = e.value),
            t instanceof o
              ? t
              : new o(function (e) {
                  e(t);
                })).then(n, a);
      }
      s((A = A.apply(e, t || [])).next());
    });
  }
  function e$2(e, t) {
    var o,
      A,
      i,
      r,
      n = {
        label: 0,
        sent: function () {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: [],
      };
    return (
      (r = { next: a(0), throw: a(1), return: a(2) }),
      "function" == typeof Symbol &&
        (r[Symbol.iterator] = function () {
          return this;
        }),
      r
    );
    function a(r) {
      return function (a) {
        return (function (r) {
          if (o) throw new TypeError("Generator is already executing.");
          for (; n; )
            try {
              if (
                ((o = 1),
                A &&
                  (i =
                    2 & r[0]
                      ? A.return
                      : r[0]
                      ? A.throw || ((i = A.return) && i.call(A), 0)
                      : A.next) &&
                  !(i = i.call(A, r[1])).done)
              )
                return i;
              switch (((A = 0), i && (r = [2 & r[0], i.value]), r[0])) {
                case 0:
                case 1:
                  i = r;
                  break;
                case 4:
                  return n.label++, { value: r[1], done: !1 };
                case 5:
                  n.label++, (A = r[1]), (r = [0]);
                  continue;
                case 7:
                  (r = n.ops.pop()), n.trys.pop();
                  continue;
                default:
                  if (
                    !(
                      (i = (i = n.trys).length > 0 && i[i.length - 1]) ||
                      (6 !== r[0] && 2 !== r[0])
                    )
                  ) {
                    n = 0;
                    continue;
                  }
                  if (3 === r[0] && (!i || (r[1] > i[0] && r[1] < i[3]))) {
                    n.label = r[1];
                    break;
                  }
                  if (6 === r[0] && n.label < i[1]) {
                    (n.label = i[1]), (i = r);
                    break;
                  }
                  if (i && n.label < i[2]) {
                    (n.label = i[2]), n.ops.push(r);
                    break;
                  }
                  i[2] && n.ops.pop(), n.trys.pop();
                  continue;
              }
              r = t.call(e, n);
            } catch (e) {
              (r = [6, e]), (A = 0);
            } finally {
              o = i = 0;
            }
          if (5 & r[0]) throw r[1];
          return { value: r[0] ? r[1] : void 0, done: !0 };
        })([r, a]);
      };
    }
  }
  function n$1(e, t, o) {
    if (o || 2 === arguments.length)
      for (var A, i = 0, r = t.length; i < r; i++)
        (!A && i in t) ||
          (A || (A = Array.prototype.slice.call(t, 0, i)), (A[i] = t[i]));
    return e.concat(A || Array.prototype.slice.call(t));
  }
  !(function (e) {
    (e[(e.sync = 1)] = "sync"), (e[(e.async = 0)] = "async");
  })(r$1 || (r$1 = {}));
  var i$1$1 = (function () {
      function e() {
        (this._hasPriority = !1), (this._array = []);
      }
      return (
        (e.prototype.insert = function (e, t) {
          if (
            (void 0 === t && (t = !1),
            0 !== e.priority && (this._hasPriority = !0),
            !this._hasPriority)
          )
            return t
              ? (this._array.unshift(e), 0)
              : (this._array.push(e), this._array.length - 1);
          var o = this._array.findIndex(function (o) {
            return o.priority === e.priority ? t : o.priority < e.priority;
          });
          return -1 === o
            ? (this._array.push(e), this._array.length - 1)
            : (this._array.splice(o, 0, e), o);
        }),
        (e.prototype.clone = function () {
          return n$1([], this._array, !0);
        }),
        (e.prototype.getListener = function (e) {
          return this._array[e];
        }),
        (e.prototype.getListeners = function () {
          return this._array.map(function (e) {
            return e.listener;
          });
        }),
        (e.prototype.remove = function (e) {
          var t = this._array.findIndex(function (t) {
            return t.listener === e;
          });
          -1 !== t &&
            ((this._array[t].isRemove = !0), this._array.splice(t, 1));
        }),
        (e.prototype.findIdx = function (e) {
          return this._array.findIndex(function (t) {
            return t.listener === e;
          });
        }),
        (e.prototype.size = function () {
          return this._array.length;
        }),
        e
      );
    })(),
    s$1 = (function () {
      function e(e) {
        void 0 === e && (e = {}),
          (this._events = Object.create(null)),
          (this._cacheEvents = Object.create(null));
        var t = e.maxListeners,
          o = void 0 === t ? 10 : t,
          A = e.replayType,
          i = void 0 === A ? r$1.sync : A,
          r = e.isCache,
          n = void 0 !== r && r;
        (this._isCache = n), (this._replayType = i), (this._maxListeners = o);
      }
      return (
        (e.prototype.setCacheStatus = function (e) {
          this._isCache = e;
        }),
        (e.prototype.setReplayType = function (e) {
          this._replayType = e;
        }),
        (e.prototype.getCacheStatus = function () {
          return this._isCache;
        }),
        (e.prototype.clearCache = function () {
          (this._isCache = !1), (this._cacheEvents = Object.create(null));
        }),
        (e.prototype.setMaxListeners = function (e) {
          return (this._maxListeners = e), this;
        }),
        (e.prototype.getMaxListeners = function () {
          return this._maxListeners;
        }),
        (e.prototype.emit = function (e) {
          for (var t = [], o = 1; o < arguments.length; o++)
            t[o - 1] = arguments[o];
          return this._emit.apply(this, n$1([!1, e], t, !1));
        }),
        (e.prototype.asyncEmit = function (e) {
          for (var t = [], o = 1; o < arguments.length; o++)
            t[o - 1] = arguments[o];
          return this._emit.apply(this, n$1([!0, e], t, !1));
        }),
        (e.prototype.addListener = function (e, t) {
          return this._addListener(e, { listener: t, priority: 0, isOnce: !1 });
        }),
        (e.prototype.on = function (e, t, o) {
          return (
            void 0 === o && (o = 0),
            this._addListener(e, { listener: t, priority: o, isOnce: !1 })
          );
        }),
        (e.prototype.listeners = function (e) {
          var t = this._events[e];
          return t ? t.getListeners() : [];
        }),
        (e.prototype.prependListener = function (e, t) {
          return this._addListener(
            e,
            { listener: t, priority: 0, isOnce: !1 },
            !0
          );
        }),
        (e.prototype.once = function (e, t, o) {
          return (
            void 0 === o && (o = 0),
            this._addListener(e, { listener: t, priority: o, isOnce: !0 })
          );
        }),
        (e.prototype.removeListener = function (e, t) {
          var o = this._events[e];
          return o ? (o.remove(t), this) : this;
        }),
        (e.prototype.off = function (e, t) {
          return this.removeListener(e, t);
        }),
        (e.prototype.removeAllListeners = function (e) {
          return void 0 === e
            ? ((this._events = Object.create(null)), this)
            : (this._events[e] && delete this._events[e], this);
        }),
        (e.prototype.listenerCount = function (e) {
          var t;
          return (
            (null === (t = this._events[e]) || void 0 === t
              ? void 0
              : t.size()) || 0
          );
        }),
        (e.prototype.eventNames = function () {
          return Object.getOwnPropertyNames(this._events);
        }),
        (e.prototype._emit = function (t, o) {
          var A = this;
          void 0 === t && (t = !1);
          for (var i = [], r = 2; r < arguments.length; r++)
            i[r - 2] = arguments[r];
          var n = [{ type: o, target: this, data: 1 === i.length ? i[0] : i }],
            a = this._events[o],
            s = { stopIndex: -1, onceCount: 0, emitData: n };
          if ((this._addCacheEvent(o, s, t), !a))
            return !!t && Promise.resolve(!1);
          var g = Promise.resolve();
          return (
            a.clone().some(function (o, i) {
              return (
                (o.isOnce || o.isRemove) && (s.onceCount += 1),
                !o.isRemove &&
                  (t
                    ? ((g = g.then(function () {
                        return t$2(A, void 0, void 0, function () {
                          return e$2(this, function (t) {
                            switch (t.label) {
                              case 0:
                                return s.stopIndex >= 0 || o.isRemove
                                  ? [2]
                                  : (o.isOnce && a.remove(o.listener),
                                    [4, o.listener.apply(this, n)]);
                              case 1:
                                return (
                                  t.sent() === e.STOP_IMMEDIATE_PROPAGATION &&
                                    (s.stopIndex = Math.max(
                                      i - s.onceCount,
                                      0
                                    )),
                                  [2]
                                );
                            }
                          });
                        });
                      })),
                      !1)
                    : (o.isOnce && a.remove(o.listener),
                      o.listener.apply(A, n) === e.STOP_IMMEDIATE_PROPAGATION &&
                        ((s.stopIndex = Math.max(i - s.onceCount, 0)), !0)))
              );
            }),
            !t ||
              g.then(function () {
                return !0;
              })
          );
        }),
        (e.prototype._addCacheEvent = function (e, t, o) {
          if (this._isCache) {
            var A = o ? Promise.resolve(t) : t;
            this._cacheEvents[e]
              ? this._cacheEvents[e].push(A)
              : (this._cacheEvents[e] = [A]);
          }
        }),
        (e.prototype._replayCacheEvent = function (t, o, A, i) {
          var r = this,
            n = i || this._cacheEvents[t];
          if (this._isCache && n) {
            var a = o.isOnce ? 1 : 0;
            n.some(function (i, s) {
              return i instanceof Promise
                ? ((n[s] = i.then(function (i) {
                    return t$2(r, void 0, void 0, function () {
                      var r;
                      return e$2(this, function (n) {
                        switch (n.label) {
                          case 0:
                            return i.stopIndex >= 0 && A > i.stopIndex
                              ? [2, i]
                              : [4, o.listener.apply(this, i.emitData)];
                          case 1:
                            return (
                              (r = n.sent()),
                              o.isOnce && this.off(t, o.listener),
                              r === e.STOP_IMMEDIATE_PROPAGATION
                                ? (i.stopIndex = Math.max(A - a, 0))
                                : i.stopIndex >= 0 &&
                                  A <= i.stopIndex &&
                                  (i.stopIndex = i.stopIndex - a + 1),
                              [2, i]
                            );
                        }
                      });
                    });
                  })),
                  o.isOnce)
                : ((i.stopIndex >= 0 && A > i.stopIndex) ||
                    (o.isOnce && r.off(t, o.listener),
                    o.listener.apply(r, i.emitData) ===
                    e.STOP_IMMEDIATE_PROPAGATION
                      ? (i.stopIndex = Math.max(A - a, 0))
                      : i.stopIndex >= 0 &&
                        A <= i.stopIndex &&
                        (i.stopIndex = i.stopIndex - a + 1)),
                  o.isOnce);
            });
          }
        }),
        (e.prototype._addListener = function (e, t, o) {
          var A = this;
          void 0 === o && (o = !1),
            this._events[e] || (this._events[e] = new i$1$1());
          var i = this._events[e].insert(t, o);
          if (
            (this._maxListeners > 0 &&
              this._events[e].size() === this._maxListeners &&
              console.warn(
                "Possible EventEmitter memory leak detected. "
                  .concat(this._events[e].size(), " ")
                  .concat(String(e), " listeners ") +
                  "added. Use emitter.setMaxListeners() to increase limit"
              ),
            this._replayType === r$1.async)
          ) {
            var r = this._cacheEvents[e]
              ? n$1([], this._cacheEvents[e], !0)
              : null;
            if (!r) return this;
            setTimeout(function () {
              var o = A._events[e].findIdx(t.listener);
              -1 !== o && A._replayCacheEvent(e, t, o, r);
            });
          } else this._replayCacheEvent(e, t, i);
          return this;
        }),
        (e.STOP_IMMEDIATE_PROPAGATION =
          "EventEmitter.STOP_IMMEDIATE_PROPAGATION"),
        e
      );
    })();
  new s$1();
  var SimpleDefer = function () {
      var e = this;
      (this.state = "pending"),
        (this.promise = new Promise(function (t, o) {
          (e.resolve = function (o) {
            (e.state = "fulfilled"), t(o);
          }),
            (e.reject = function (t) {
              (e.state = "rejected"), o(t);
            });
        }));
    },
    TimeoutDefer = (function (e) {
      function t(t) {
        var o = e.call(this) || this;
        return (
          t.timeoutMS > 0 &&
            setTimeout(function () {
              return o.reject();
            }, t.timeoutMS),
          o
        );
      }
      return __extends(t, e), t;
    })(SimpleDefer),
    domTool = {
      insertStyle: y$1,
      loadScript: function (e, t, o, A) {
        var i = new TimeoutDefer({ timeoutMS: o });
        return (
          x$1(__assign(__assign({}, A), { src: e }), t)
            .then(i.resolve)
            .catch(i.reject),
          i.promise
        );
      },
      attr: S$1,
      removeAttr: function (e, t) {
        e && t && ("src" === t ? delete e.src : e.removeAttribute(t));
      },
      css: E$1,
      append: function (e, t) {
        e && e.appendChild(t);
      },
      prepend: function (e, t) {
        e.children[0] ? e.insertBefore(t, e.children[0]) : e.appendChild(t);
      },
      addClass: q$1,
      removeClass: _$1,
      hasClass: M$1,
      hide: O$1,
      show: k$1,
      text: j$1,
      html: C$1,
      creatDom: function (e) {
        return this.createDom(e);
      },
      createDom: function (e) {
        var t = document.createElement("div");
        return (t.innerHTML = e), t.firstChild;
      },
      getDomSize: function (e) {
        if (!e) return { width: 0, height: 0 };
        var t = e.currentStyle
          ? e.currentStyle
          : window.getComputedStyle(e, null);
        return { width: parseFloat(t.width), height: parseFloat(t.height) };
      },
      createVideoDom: function (e) {
        var t = e || {},
          o = t.attrOpts,
          A = void 0 === o ? {} : o,
          i = t.cssOpts,
          r = void 0 === i ? {} : i,
          n = document.createElement("video");
        return (
          Object.keys(A).forEach(function (e) {
            n.setAttribute(e, A[e]);
          }),
          E$1(n, r),
          n
        );
      },
      getElementFromConfig: function (e) {
        return "string" == typeof e ? document.querySelector(e) : e;
      },
    },
    jsonTool = {
      safelyStringify: function (e, t, o) {
        try {
          return JSON.stringify(e, t, o);
        } catch (e) {
          return "{}";
        }
      },
    },
    mobileDevReg = /android|iPod|ipad|iPhone|mobile/i;
  function uaMatch(e) {
    var t, o, A;
    if ("object" != typeof window && !e) return this;
    (e = (e = e || navigator.userAgent).toLowerCase()),
      (this.browser = {}),
      (this.os = {}),
      (this.mobile = !1),
      (this.spider =
        /(googlebot|bingbot|yandex|twitterbot|facebookexternalhit|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest\/0\.|pinterestbot|slackbot|vkShare|W3C_Validator|whatsapp|petalbot|applebot|mpcrawler|spider)/i.test(
          e
        )),
      (this.headless = /headless/i.test(e)),
      mobileDevReg.test(e) && (this.mobile = !0);
    for (
      var i,
        r,
        n = {
          android_1: /android[\s\/]([\d\.]+)/i,
          android_2: /android/i,
          android_3: /MIDP-/i,
          ipod_1: /iPod\stouch;\sCPU\siPhone\sos\s([\d_]+)/i,
          ipod_100: /iPod.*os\s?([\d_\.]+)/i,
          iphone: /iPhone;\sCPU\siPhone\sos\s([\d_]+)/i,
          iphone_100: /iPhone.*os\s?([\d_\.]+)/i,
          ipad_1: /ipad;\scpu\sos\s([\d_]+)/i,
          ipad_2: /ipad([\d]+)?/i,
          windows: /windows\snt\s([\d\.]+)/i,
          mac: /Macintosh.*mac\sos\sx\s([\d_\.]+)/i,
          linux: /Linux/i,
        },
        a = Object.keys(n),
        s = 0,
        g = a.length;
      s < g;
      s++
    ) {
      var l = a[s];
      if ((i = n[l].exec(e))) {
        (r = l.replace(/_\d+/, "")),
          (this.os[r] = !0),
          (this.os.osName = r),
          i[1] && (this.os.version = i[1].replace(/_/g, "."));
        break;
      }
    }
    (this.os.iphone || this.os.ipad || this.os.ipod) && (this.os.ios = !0);
    var E,
      c,
      u = {
        wechat: /MicroMessenger\/([\d\.]+)/i,
        ipadqq: /IPadQQ\/([\d\.]+)/i,
        mqq: /qq\/([\d\.]+)/i,
        qzone: /QZONEJSSDK\/([\d\.]+)/i,
        mqqbrowser: /mqqbrowser\/([\d\.]+)/i,
        qqbrowser: /[^m]QQBrowser\/([\d\.]+)/i,
        x5: /tbs\/(\d+)/i,
        xweb: /xweb\/(\d+)/i,
        uc: /UCBrowser\/([\d\.]+)/i,
        edg: /Edg\/([\d\.]+)/i,
        safari_1: /Version\/(([\d\.]+))\sSafari\/[\d\.]+/i,
        safari_2: /Safari\/([\d\.]+)/i,
        chrome_1: /CriOS\/([\d\.]+)/i,
        chrome_2: /Chrome\/([\d\.]+)/i,
        firefox: /Firefox\/([\d\.]+)/i,
        ie_1: /MSIE\s([\d\.]+)/i,
        ie_2: /(trident\/\d\.\d)/i,
        ie_3: /Edge\/(\d+\.\d+)/i,
        weibo: /weibo__([\d\.]+)/i,
        qqnews: /qqnews\/([\d\.]+)/i,
        qqlive_1: /QQLiveBrowser\/([\d\.]+)/i,
        qqlive_2: /QQLiveHDBrowser\/([\d\.]+)/i,
        kuaibao: /qnreading\/([\d\.]+)/i,
        liebao: /LieBaoFast\/([\d\.]+)/i,
        douban: /com\.douban\.frodo\/([\d\.]+)/i,
        miuibrowser: /MiuiBrowser/i,
        baidu: /baiduboxapp/i,
        browser360: /360browser/i,
        oppobrowser: /OppoBrowser/i,
        qqdownloader: /qqdownloader\/([\d\.]+)/i,
      },
      p = Object.keys(u),
      d = 0;
    for (g = p.length; d < g; d++) {
      var B = p[d];
      if ((E = u[B].exec(e))) {
        if (((c = B.replace(/_\d+/, "")), this.browser[c])) return this;
        (this.browser[c] = { version: E[1] }),
          (this.browser.browserName = c),
          (this.browser.version = E[1]);
      }
    }
    return (
      this.os.android && this.browser.safari && (this.browser.safari = null),
      this.browser.chrome &&
        this.browser.safari &&
        (this.browser.safari = null),
      (null ===
        (A =
          null ===
            (o = null === (t = this.browser) || void 0 === t ? void 0 : t.ie) ||
          void 0 === o
            ? void 0
            : o.version) || void 0 === A
        ? void 0
        : A.indexOf("trident")) > -1 &&
        (this.browser.ie.version.indexOf("6.0") > -1
          ? (this.browser.ie.version = "10")
          : this.browser.ie.version.indexOf("5.0") > -1
          ? (this.browser.ie.version = "9")
          : this.browser.ie.version.indexOf("4.0") > -1
          ? (this.browser.ie.version = "8")
          : (this.browser.ie.version = "11")),
      this
    );
  }
  var uaTool = uaMatch.call({}),
    LoopMode;
  !(function (e) {
    (e[(e.Timer = 0)] = "Timer"), (e[(e.RAF = 1)] = "RAF");
  })(LoopMode || (LoopMode = {}));
  var urlTool = {
      object2string: function (e, t) {
        return void 0 === t && (t = "&"), this.convertUrlParam(e, t, !1);
      },
      convertUrlParam: function (e, t, o) {
        if ((void 0 === t && (t = "&"), void 0 === o && (o = !0), !e))
          return "";
        var A = Object.keys(e);
        if (A.length <= 0) return "";
        var i = [];
        return (
          A.forEach(function (t) {
            var A;
            (A = o
              ? ""
                  .concat(encodeURIComponent(t), "=")
                  .concat(encodeURIComponent(e[t]))
              : "".concat(t, "=").concat(e[t])),
              i.push(A);
          }),
          i.join(t)
        );
      },
      getRootDomain: function () {
        var e = window.location.hostname || window.location.host,
          t = window.location.host.split(".");
        return t.length > 1 && (e = t.slice(t.length - 2).join(".")), e;
      },
      getTopFrameUrl: function () {
        var e = "";
        if (window.top !== window)
          try {
            e = window.top.location.href;
          } catch (t) {
            e = document.referrer;
          }
        else e = window.location.href;
        return e;
      },
      isInFrame: function () {
        var e = !1;
        try {
          e = window.self !== window.top;
        } catch (e) {
          return !0;
        }
        return e;
      },
      getDomainOfURL: function (e) {
        if (null == e || "" === e) return "";
        try {
          return new URL(e).hostname;
        } catch (e) {
          return "";
        }
      },
      getUrlParamByKey: function (e, t) {
        return h$1(e || location.href).query[t] || "";
      },
      getUrlParams: function (e) {
        return h$1(e || location.href).query;
      },
      updateUrlParam: function (e, t, o) {
        var A = e,
          i = this.getUrlParamByKey(A, t),
          r = "".concat(t, "=").concat(o);
        return i
          ? A.replace("".concat(t, "=").concat(i), r)
          : A + (-1 !== A.indexOf("?") ? "&" : "?") + r;
      },
      getFileName: function (e) {
        if (!e) return null;
        var t = e,
          o = t.indexOf("?");
        o > 0 && (t = t.slice(0, o));
        var A = t.lastIndexOf("/");
        A > 0 && (t = t.slice(A + 1, t.length));
        var i = t.lastIndexOf("#");
        return i > 0 && (t = t.slice(0, i)), t;
      },
      getFileExtension: function (e) {
        if (!e) return null;
        if (this.isWebRTCLink(e)) return "webrtc";
        var t = urlTool.getFileName(e);
        if (t) {
          var o = t.split(".");
          if (o && o.length > 1) return o[o.length - 1];
        }
        return null;
      },
      isWebRTCLink: function (e) {
        return /^webrtc:\/\//.test(e);
      },
    },
    wasmDetectionCache = null,
    KeySystems,
    HDR_CAPABILITY;
  function getSupportedKeySystemConfig(e) {
    switch (e) {
      case KeySystems.FairPlayWebKit:
        return null;
      case KeySystems.Widevine:
        return {
          initDataTypes: ["cenc"],
          audioCapabilities: [
            {
              contentType: 'audio/mp4; codecs="mp4a.40.2"',
              robustness: "SW_SECURE_CRYPTO",
            },
          ],
          videoCapabilities: [
            {
              contentType: 'video/mp4; codecs="avc1.42E01E"',
              robustness: "SW_SECURE_CRYPTO",
            },
          ],
        };
      case KeySystems.FairPlay:
        return {
          initDataTypes: ["skd", "cenc"],
          videoCapabilities: [
            { contentType: "application/vnd.apple.mpegurl", robustness: "" },
          ],
        };
      case KeySystems.PlayReady:
      case KeySystems.PlayReadyHardware:
        return {
          initDataTypes: ["keyids", "cenc"],
          audioCapabilities: [{ contentType: 'audio/mp4; codecs="mp4a.40.2"' }],
          videoCapabilities: [
            { contentType: 'video/mp4; codecs="avc1.42E01E"' },
          ],
        };
      default:
        return null;
    }
  }
  !(function (e) {
    (e.FairPlayWebKit = "com.apple.fps.1_0"),
      (e.Widevine = "com.widevine.alpha"),
      (e.FairPlay = "com.apple.fps"),
      (e.Chacha = "com.tencent.chacha"),
      (e.PlayReady = "com.microsoft.playready"),
      (e.PlayReadyHardware = "com.microsoft.playready.hardware");
  })(KeySystems || (KeySystems = {})),
    (function (e) {
      (e[(e.NOT_SUPPORTED = 0)] = "NOT_SUPPORTED"),
        (e[(e.WCG_DISPLAY_BUT_NO_HDR = 1)] = "WCG_DISPLAY_BUT_NO_HDR"),
        (e[(e.SUPPORTED = 2)] = "SUPPORTED");
    })(HDR_CAPABILITY || (HDR_CAPABILITY = {}));
  var videoTool = {
      getBuffered: function (e) {
        for (var t = [], o = e.buffered.length, A = 0; A < o; A++)
          t.push({ start: e.buffered.start(A), end: e.buffered.end(A) });
        return t;
      },
      checkTimeInBuffer: function (e, t) {
        for (var o = !1, A = t.length, i = 0; i < A; i++) {
          var r = t[i].start,
            n = t[i].end;
          if (e >= r && e <= n) {
            o = !0;
            break;
          }
        }
        return o;
      },
      clear: function (e) {
        e &&
          (e instanceof HTMLVideoElement
            ? (e.removeAttribute("src"), (e.srcObject = null))
            : ((e.srcConfig = null), (e.src = null)),
          e.load());
      },
      destroyElement: function (e) {
        var t;
        e &&
          (null === (t = e.destroy) || void 0 === t || t.call(e),
          videoTool.clear(e),
          videoTool.removeElement(e, null));
      },
      captureVideo: function (e, t) {
        var o = t.dx,
          A = t.dy,
          i = t.dw,
          r = t.dh,
          n = e.videoWidth,
          a = e.videoHeight,
          s = document.createElement("canvas");
        (s.width = n), (s.height = a);
        var g = s.getContext("2d");
        return (
          g.drawImage(e, 0, 0, n, a),
          {
            captureHeight: r,
            captureWidth: i,
            captureX: o,
            captureY: A,
            playtime: e.currentTime,
            data: g.getImageData(o, A, i, r),
          }
        );
      },
      resizeElement: function (e, t) {
        var o;
        if (t && e)
          if (e instanceof HTMLElement) domTool.css(e, t);
          else {
            var A = t.width,
              i = t.height;
            "number" == typeof A &&
              "number" == typeof i &&
              (null === (o = e.resize) || void 0 === o || o.call(e, A, i));
          }
      },
      appendElement: function (e, t) {
        var o;
        e instanceof HTMLElement
          ? domTool.append(t, e)
          : null === (o = e.appendToParent) || void 0 === o || o.call(e, t);
      },
      removeElement: function (e, t) {
        var o;
        e instanceof HTMLElement
          ? (null == e ? void 0 : e.parentNode) && e.remove()
          : null === (o = e.removeFromParent) || void 0 === o || o.call(e, t);
      },
      setElementFitType: function (e, t) {
        e && e instanceof HTMLElement && domTool.css(e, { "object-fit": t });
      },
      getDefaultMaxBufferTime: function () {
        var e = navigator.connection;
        return e && "wifi" === e.type ? 180 : e && "4g" === e.type ? 120 : 180;
      },
      isAutoPlayBlockedMessage: function (e) {
        return e && /interact|not allowed|user gesture/.test(e);
      },
      supportSameTimePlay: function () {
        return !(
          (uaTool.browser.x5 &&
            -1 !==
              ["45031", "45032"].indexOf(
                "".concat(uaTool.browser.x5.version)
              )) ||
          (uaTool.browser.mqqbrowser &&
            !(
              uaTool.browser.qqlive ||
              uaTool.browser.wechat ||
              uaTool.browser.mqq
            )) ||
          (uaTool.os.ios &&
            uaTool.os.version &&
            commonTool.compareVersion(uaTool.os.version, "11.0") < 0)
        );
      },
      cannotDetectAutoPlayBlock: function () {
        return (
          uaTool.browser.chrome &&
          commonTool.compareVersion(uaTool.browser.chrome.version, "66.0") < 0
        );
      },
      supportMediaFragmentsURISpec: function (e) {
        return void 0 !== e
          ? !!e
          : !(
              -1 !== window.navigator.userAgent.indexOf("jsdom") ||
              (uaTool.mobile && !uaTool.os.ios)
            );
      },
      getVideoPlaybackQuality: function (e) {
        var t = 0,
          o = 0;
        if (null == e ? void 0 : e.getVideoPlaybackQuality) {
          var A = e.getVideoPlaybackQuality();
          (o = A.droppedVideoFrames || 0), (t = A.totalVideoFrames || 0);
        } else
          e &&
            e.webkitDecodedFrameCount &&
            ((t = e.webkitDecodedFrameCount), (o = e.webkitDroppedFrameCount));
        return { totalVideoFrames: t, droppedVideoFrames: o };
      },
      supportMSE: function () {
        var e = videoTool.getMediaSource();
        if (!e) return !1;
        var t = window.SourceBuffer || window.WebKitSourceBuffer,
          o =
            e &&
            "function" == typeof e.isTypeSupported &&
            e.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'),
          A =
            !t ||
            (t.prototype &&
              "function" == typeof t.prototype.appendBuffer &&
              "function" == typeof t.prototype.remove);
        return !!o && !!A;
      },
      supportVideoFormat: function () {
        var e = document.createElement("video"),
          t = {
            mp4: "video/mp4",
            mov: "video/mp4",
            hls: "application/x-mpegURL",
            avi: "video/x-msvideo",
            mpeg: "video/mpeg",
            webm: "video/webm",
            ogg: "video/ogg",
          },
          o = [];
        return (
          Object.keys(t).forEach(function (A) {
            var i = t[A],
              r = e.canPlayType(i);
            -1 !== ["maybe", "probably"].indexOf(r) && o.push(A);
          }),
          o
        );
      },
      supportAV1: function () {
        return videoTool.isMediaSourceTypeSupported(
          "video/mp4;codecs=av01.0.12M.08"
        );
      },
      supportHevc: function () {
        return videoTool.isMediaSourceTypeSupported(
          'video/mp4;codecs="hvc1.1.6.L120.90"'
        );
      },
      supportHEVCMain10: function () {
        return videoTool.isMediaSourceTypeSupported(
          'video/mp4;codecs="hvc1.2.4.L120.90"'
        );
      },
      isVideoCanPlayType: function (e) {
        return document.createElement("video").canPlayType(e);
      },
      isMediaSourceTypeSupported: function (e) {
        var t;
        try {
          return null === (t = videoTool.getMediaSource()) || void 0 === t
            ? void 0
            : t.isTypeSupported(e);
        } catch (e) {
          return !1;
        }
      },
      isMediaCapabilitiesTypeSupported: function (e) {
        return __awaiter(this, void 0, void 0, function () {
          var t, o, A, i, r, n, a, s, g, l, E, c;
          return __generator(this, function (u) {
            switch (u.label) {
              case 0:
                (t = e.type),
                  (o = e.mimeType),
                  (A = e.resolution),
                  (i = void 0 === A ? "860x480" : A),
                  (r = e.bitrate),
                  (n = void 0 === r ? 800 : r),
                  (a = e.framerate),
                  (s = void 0 === a ? 30 : a),
                  (u.label = 1);
              case 1:
                switch (
                  (u.trys.push([1, 3, , 4]), (g = { type: "media-source" }), t)
                ) {
                  case "audio":
                    g.audio = { contentType: o };
                    break;
                  case "audio-spatial":
                    g.audio = { contentType: o, spatialRendering: !0 };
                    break;
                  case "video":
                    (l = i.toLowerCase().split("x")),
                      (E = l[0]),
                      (c = l[1]),
                      (g.video = {
                        contentType: o,
                        bitrate: n,
                        framerate: s,
                        height: +E,
                        width: +c,
                      });
                }
                return [4, navigator.mediaCapabilities.decodingInfo(g)];
              case 2:
                return [2, u.sent().supported];
              case 3:
                return u.sent(), [2, !1];
              case 4:
                return [2];
            }
          });
        });
      },
      isHDRSupported: function () {
        try {
          return window.matchMedia("(dynamic-range: high)").matches
            ? HDR_CAPABILITY.SUPPORTED
            : window.matchMedia("(color-gamut: p3)").matches
            ? HDR_CAPABILITY.WCG_DISPLAY_BUT_NO_HDR
            : HDR_CAPABILITY.NOT_SUPPORTED;
        } catch (e) {
          return HDR_CAPABILITY.NOT_SUPPORTED;
        }
      },
      isDolbyVisionSupported: function () {
        return videoTool.isMediaSourceTypeSupported('video/mp4; codecs="dvhe"');
      },
      isDolbyAtomsSupported: function () {
        return videoTool.isMediaSourceTypeSupported('audio/mp4; codecs="ec-3"');
      },
      getMediaSource: function () {
        if ("undefined" != typeof window)
          return window.MediaSource || window.WebKitMediaSource;
      },
      isEncryptionSupported: function (e, t) {
        return __awaiter(this, void 0, void 0, function () {
          var o, A;
          return __generator(this, function (i) {
            switch (i.label) {
              case 0:
                if (
                  ((o = t || getSupportedKeySystemConfig(e)),
                  (A = [window.MediaKeys, window.WebKitMediaKeys].some(
                    function (e) {
                      return e;
                    }
                  )),
                  !A)
                )
                  return [2, !1];
                if (void 0 === window.navigator.requestMediaKeySystemAccess)
                  return [2, !1];
                i.label = 1;
              case 1:
                return (
                  i.trys.push([1, 3, , 4]),
                  [4, window.navigator.requestMediaKeySystemAccess(e, [o])]
                );
              case 2:
                return [2, !!i.sent()];
              case 3:
                return i.sent(), [2, !1];
              case 4:
                return [2];
            }
          });
        });
      },
      supportWidevine: function () {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            return [2, videoTool.isEncryptionSupported(KeySystems.Widevine)];
          });
        });
      },
      supportFairplay: function () {
        var e = KeySystems.FairPlayWebKit;
        return (
          !!window.WebKitMediaKeys &&
          window.WebKitMediaKeys.isTypeSupported(e, "video/mp4")
        );
      },
      supportWebGL: function () {
        var e,
          t = document.createElement("canvas");
        try {
          e = t.getContext("webgl");
        } catch (e) {
          return !1;
        }
        return !!e;
      },
      isWebRTCSupported: function () {
        var e = Boolean(uaTool.os.ios),
          t = Boolean(uaTool.browser.uc),
          o = Boolean(uaTool.browser.safari);
        return !(
          t ||
          (e &&
            o &&
            commonTool.compareVersion(uaTool.os.version, "11.1.2") < 0) ||
          (!("RTCPeerConnection" in window) &&
            !("webkitRTCPeerConnection" in window))
        );
      },
      isPositionBuffered: function (e, t) {
        for (
          var o = e.buffered, A = t || e.currentTime, i = 0;
          i < o.length;
          i++
        )
          if (A >= o.start(i) && A <= o.end(i)) return !0;
        return !1;
      },
      getNextBufferedStart: function (e, t) {
        for (
          var o = e.buffered, A = t || e.currentTime, i = 0;
          i < o.length;
          i++
        )
          if (o.start(i) > A) return o.start(i);
        return -1;
      },
      getLastBufferedEnd: function (e, t) {
        for (
          var o = e.buffered, A = t || e.currentTime, i = o.length - 1;
          i >= 0;
          i--
        )
          if (o.end(i) < A) return o.end(i);
        return -1;
      },
      isHardwareAccelerated: function () {
        try {
          var e = document.createElement("canvas"),
            t = {
              alpha: !0,
              antialias: !1,
              depth: !0,
              failIfMajorPerformanceCaveat: !0,
              stencil: !0,
            };
          return !(
            !e.getContext("webgl", t) && !e.getContext("experimental-webgl", t)
          );
        } catch (e) {
          return !1;
        }
      },
      collectGPUInfo: function () {
        try {
          var e = document.createElement("canvas").getContext("webgl"),
            t =
              null == e ? void 0 : e.getExtension("WEBGL_debug_renderer_info");
          return t
            ? {
                vendor:
                  (null == e
                    ? void 0
                    : e.getParameter(t.UNMASKED_VENDOR_WEBGL)) || "",
                renderer:
                  (null == e
                    ? void 0
                    : e.getParameter(t.UNMASKED_RENDERER_WEBGL)) || "",
              }
            : null;
        } catch (e) {
          return null;
        }
      },
      isWasmSupported: function () {
        if (null !== wasmDetectionCache) return wasmDetectionCache;
        if (!window.WebAssembly) return (wasmDetectionCache = !1), !1;
        try {
          var e = Uint8Array.from([0, 97, 115, 109, 1, 0, 0, 0]),
            t = new WebAssembly.Module(e),
            o = new WebAssembly.Instance(t);
          wasmDetectionCache = o instanceof WebAssembly.Instance;
        } catch (e) {
          wasmDetectionCache = !1;
        } finally {
          return wasmDetectionCache;
        }
      },
      isWasmKernelSupported: function () {
        return (
          this.isWasmSupported() &&
          !!window.customElements &&
          commonTool.supportES6() &&
          videoTool.supportWebGL()
        );
      },
      supportFetchStream: function () {
        if (
          window.fetch &&
          window.AbortController &&
          window.ReadableStream &&
          window.Request
        )
          try {
            return new window.ReadableStream({}), !0;
          } catch (e) {}
        return !1;
      },
    },
    localDRMCache = DRM_REQUEST_VALUE.NONE,
    LIVE_STREAM_TYPE;
  function getDrmParam(e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, o;
      return __generator(this, function (A) {
        switch (A.label) {
          case 0:
            return void 0 !== e
              ? [2, e]
              : localDRMCache
              ? [2, localDRMCache]
              : ((t = DRM_REQUEST_VALUE.NONE),
                uaTool.mobile
                  ? [2, t]
                  : (window.WebAssembly && (t |= DRM_REQUEST_VALUE.CHACHA20),
                    (o =
                      uaTool.browser.chrome &&
                      commonTool.compareVersion(
                        uaTool.browser.chrome.version,
                        "89.0"
                      ) > 0)
                      ? [4, videoTool.supportWidevine()]
                      : [3, 2]));
          case 1:
            (o = A.sent()), (A.label = 2);
          case 2:
            return (
              o
                ? ((t |= DRM_REQUEST_VALUE.WIDEVINE), (localDRMCache = t))
                : uaTool.browser.safari &&
                  videoTool.supportFairplay() &&
                  ((t |= DRM_REQUEST_VALUE.FAIRPLAY), (localDRMCache = t)),
              [2, t]
            );
        }
      });
    });
  }
  function getPaidFormatParam(e) {
    var t = { spsfrhdr: 0, spvideo: 0, spaudio: 0, defnpayver: 0 };
    return (
      e.indexOf(exports.PAID_FORMAT.FHD) > -1 && (t.defnpayver |= 1),
      e.indexOf(exports.PAID_FORMAT.UHD) > -1 && (t.defnpayver |= 2),
      videoTool.supportHevc() &&
        videoTool.isHDRSupported() === HDR_CAPABILITY.SUPPORTED &&
        (e.indexOf(exports.PAID_FORMAT.HDR10) > -1 &&
          ((t.spvideo |= 1028), (t.defnpayver |= 4)),
        e.indexOf(exports.PAID_FORMAT.SFR_HDR) > -1 &&
          ((t.spvideo |= 1028),
          (t.spaudio |= 64),
          (t.spsfrhdr = 100),
          (t.defnpayver |= 4)),
        e.indexOf(exports.PAID_FORMAT.DOLBY) > -1 &&
          videoTool.isDolbyAtomsSupported() &&
          videoTool.isDolbyVisionSupported() &&
          ((t.spaudio |= 4), (t.spvideo |= 16), (t.defnpayver |= 4))),
      t
    );
  }
  function getPaidFormatParamForLive(e) {
    var t = { spvideo: 0 };
    return (
      videoTool.supportHevc() &&
        videoTool.isHDRSupported() === HDR_CAPABILITY.SUPPORTED &&
        e.indexOf(exports.PAID_FORMAT.HDR10) > -1 &&
        (t.spvideo |= 4),
      t
    );
  }
  function getLogintoken() {
    var e = getUserCookies();
    return {
      logintoken: Object.keys(e).length > 0 ? jsonTool.safelyStringify(e) : "",
    };
  }
  function getUserCookies(e) {
    var t,
      o,
      A,
      i,
      r,
      n,
      a,
      s = cookieTool.get(COOKIE_NAME.MAIN_LOGIN);
    if (!s) return {};
    var g = s === LOGIN_METHOD.QQ,
      l =
        (((t = {})[COOKIE_NAME.ACCESS_TOKEN] =
          null !== (o = getCookieWithPrefix(COOKIE_NAME.ACCESS_TOKEN, g)) &&
          void 0 !== o
            ? o
            : ""),
        (t[COOKIE_NAME.APPID] =
          null !== (A = getCookieWithPrefix(COOKIE_NAME.APPID, g)) &&
          void 0 !== A
            ? A
            : ""),
        (t[COOKIE_NAME.VUSESSION] =
          null !== (i = getCookieWithPrefix(COOKIE_NAME.VUSESSION, g)) &&
          void 0 !== i
            ? i
            : ""),
        (t[COOKIE_NAME.OPENID] =
          null !== (r = getCookieWithPrefix(COOKIE_NAME.OPENID, g)) &&
          void 0 !== r
            ? r
            : ""),
        (t[COOKIE_NAME.VUSERID] =
          null !== (n = getCookieWithPrefix(COOKIE_NAME.VUSERID, g)) &&
          void 0 !== n
            ? n
            : ""),
        (t[COOKIE_NAME.GUID] =
          null !== (a = cookieTool.get(COOKIE_NAME.GUID)) && void 0 !== a
            ? a
            : ""),
        (t[COOKIE_NAME.MAIN_LOGIN] = s),
        t);
    return validateCookie(l)
      ? e
        ? Object.keys(e).reduce(function (t, o) {
            return (t[e[o]] = l[o]), t;
          }, {})
        : l
      : {};
  }
  function getCookieWithPrefix(e, t) {
    return (
      void 0 === t && (t = !1),
      cookieTool.get(t ? "".concat(VQQ_COOKIE_PREFIX).concat(e) : e)
    );
  }
  function validateCookie(e) {
    return (
      !!e[COOKIE_NAME.MAIN_LOGIN] &&
      !!(
        e[COOKIE_NAME.MAIN_LOGIN] !== LOGIN_METHOD.QQ ||
        (e[COOKIE_NAME.VUSERID] && e[COOKIE_NAME.ACCESS_TOKEN])
      )
    );
  }
  function getSptAdSegParam(e) {
    return void 0 === e && (e = !1), e ? { spadseg: 3 } : { spadseg: 2 };
  }
  function getDtypeParam() {
    return videoTool.supportMSE() ||
      videoTool.supportVideoFormat().includes("hls")
      ? { dtype: REQ_VOD_STREAM_TYPE.HLS }
      : { dtype: REQ_VOD_STREAM_TYPE.MP4 };
  }
  function getM3u8Param() {
    var e = { spm3u8tag: 67, spmasterm3u8: 3, sphls: 1 };
    return !uaTool.mobile && videoTool.supportMSE() && (e.sphls = 2), e;
  }
  function getHevcLevelParam(e) {
    var t = e.hevcGPUBlackList,
      o = void 0 === t ? {} : t,
      A = e.supportedPaidFormat,
      i = e.isSupportedWasmHevcOnTx,
      r = e.isForceDisableHevc,
      n = Object.keys(o),
      a = videoTool.collectGPUInfo(),
      s = !1;
    return (
      n.forEach(function (e) {
        a &&
          checkBrowserCondition(e) &&
          o[e].some(function (e) {
            return a.renderer.match(new RegExp(e, "i"));
          }) &&
          (s = !0);
      }),
      r || s
        ? null
        : !videoTool.supportHevc() ||
          (uaTool.mobile && !shouldEnableHEVCOnMobile())
        ? i
          ? { hevclv: HEVC_LV_VALUE.HD }
          : null
        : -1 !== A.indexOf(exports.PAID_FORMAT.UHD)
        ? { hevclv: HEVC_LV_VALUE.UHD }
        : { hevclv: HEVC_LV_VALUE.FHD }
    );
  }
  function getSptAv1Param() {
    var e = uaTool.browser.edg && uaTool.browser.chrome;
    return videoTool.supportAV1()
      ? e && !videoTool.isHardwareAccelerated()
        ? null
        : { spav1: 15 }
      : null;
  }
  function shouldEnableHEVCOnMobile() {
    var e = uaTool.browser;
    return ["xweb", "x5"].some(function (t) {
      return e[t];
    });
  }
  function checkBrowserCondition(e) {
    var t = e.startsWith("!"),
      o = (t ? e.slice(1) : e).match(/^(\w+)(?:([=<>])(\d+))?/);
    if (!o || !uaTool.browser[o[1]]) return !1;
    if (!o[2] || !o[3]) return !!uaTool.browser[o[1]];
    try {
      var A = commonTool.compareVersion(uaTool.browser[o[1]].version, o[3]),
        i = !1;
      switch (o[2]) {
        case "<":
          i = A < 0;
          break;
        case ">":
          i = A > 0;
          break;
        case "=":
          i = 0 === A;
          break;
        default:
          return i;
      }
      return t ? !i : i;
    } catch (e) {
      return !1;
    }
  }
  function getTxLiveBrowserDefaultReqParams() {
    return {
      flowid: "",
      cmd: 2,
      roomid: "",
      anchorid: 0,
      pid: "",
      chid: "",
      defn: "auto",
      ufps: "auto",
      playbacktime: 0,
      ckey: "",
      appver: "1.0.0.0",
      encrypt_ver: "",
      uin: "",
      country_code: 0,
      lang_code: 0,
      guid: "",
      appid: 0,
      platform: "",
      playbackdrm: 0,
      format_support:
        videoTool.supportMSE() && !uaTool.mobile
          ? LIVE_STREAM_TYPE.FLV | LIVE_STREAM_TYPE.HLS
          : LIVE_STREAM_TYPE.HLS,
      caplv: 0,
      hevclv: 0,
      net_type: 0,
      bandwidth: 0,
      sphttps: getSpHttps(),
      unicomtype: 0,
      unicom: "",
      telcom: "",
      cmcc: "",
      toushe: 0,
      from_platform: 0,
      tm: "",
      scene: "",
      spaudio: 0,
      spvideo: 0,
      atmos: 0,
      sdclive_info: "",
      cnlid: "",
      host: location.host,
      sdtfrom: "",
    };
  }
  !(function (e) {
    (e[(e.AUTO = 0)] = "AUTO"),
      (e[(e.FLV = 1)] = "FLV"),
      (e[(e.HLS = 2)] = "HLS"),
      (e[(e.RTMP = 4)] = "RTMP"),
      (e[(e.DASH = 8)] = "DASH"),
      (e[(e.WEB_RTC = 16)] = "WEB_RTC"),
      (e[(e.T_RTC = 32)] = "T_RTC");
  })(LIVE_STREAM_TYPE || (LIVE_STREAM_TYPE = {}));
  var Qvsec = {};
  (Qvsec.ha = (function (e) {
    for (var t = [], o = 0; o < 64; )
      t[o] = 0 | (4294967296 * Math.abs(Math.sin(++o)));
    function A(e, t) {
      return (((e >> 1) + (t >> 1)) << 1) + (1 & e) + (1 & t);
    }
    return function (e) {
      for (
        var o,
          i,
          r,
          n,
          a = [],
          s = unescape(encodeURI(e)),
          g = s.length,
          l = [(o = 1732584193), (i = -271733879), ~o, ~i],
          E = 0;
        E <= g;

      )
        a[E >> 2] |= (s.charCodeAt(E) || 128) << ((E++ % 4) * 8);
      for (a[(e = 16 * ((g + 8) >> 6) + 14)] = 8 * g, E = 0; E < e; E += 16) {
        for (g = l, n = 0; n < 64; )
          g = [
            (r = g[3]),
            A(
              (o = g[1]),
              ((r = A(
                A(
                  g[0],
                  [
                    (o & (i = g[2])) | (~o & r),
                    (r & o) | (~r & i),
                    o ^ i ^ r,
                    i ^ (o | ~r),
                  ][(g = n >> 4)]
                ),
                A(t[n], a[([n, 5 * n + 1, 3 * n + 5, 7 * n][g] % 16) + E])
              )) <<
                (g = [
                  7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21,
                ][4 * g + (n++ % 4)])) |
                (r >>> (32 - g))
            ),
            o,
            i,
          ];
        for (n = 4; n; ) l[--n] = A(l[n], g[n]);
      }
      for (e = ""; n < 32; )
        e += ((l[n >> 3] >> (4 * (1 ^ (7 & n++)))) & 15).toString(16);
      return e;
    };
  })()),
    (Qvsec.stringToHex = function (e) {
      for (
        var t = "",
          o = new Array(
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f"
          ),
          A = 0;
        A < e.length;
        A++
      )
        t += o[e.charCodeAt(A) >> 4] + o[15 & e.charCodeAt(A)];
      return t;
    }),
    (Qvsec.hexToString = function (e) {
      for (var t = "", o = "0x" == e.substr(0, 2) ? 2 : 0; o < e.length; o += 2)
        t += String.fromCharCode(parseInt(e.substr(o, 2), 16));
      return t;
    }),
    (Qvsec._Seed = "#$#@#*ad"),
    (Qvsec.tempcalc = function (e, t) {
      for (var o = "", A = 0; A < e.length; A++)
        o += String.fromCharCode(e.charCodeAt(A) ^ t.charCodeAt(A % 4));
      return o;
    }),
    (Qvsec.u1 = function (e, t) {
      for (var o = "", A = t; A < e.length; A += 2) o += e.charAt(A);
      return o;
    }),
    (Qvsec._urlStr =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="),
    (Qvsec.urlenc = function (e, t, o) {
      for (var A, i, r, n, a, s, g, l = "", E = 0; E < e.length; )
        (A = e.charCodeAt(E++)),
          (i = e.charCodeAt(E++)),
          (r = e.charCodeAt(E++)),
          15 == E && ((l = "".concat(l, "A")), (l += t), (l += o)),
          (n = A >> 2),
          (a = ((3 & A) << 4) | (i >> 4)),
          (s = ((15 & i) << 2) | (r >> 6)),
          (g = 63 & r),
          isNaN(i) ? (s = g = 64) : isNaN(r) && (g = 64),
          (l =
            l +
            Qvsec._urlStr.charAt(n) +
            Qvsec._urlStr.charAt(a) +
            Qvsec._urlStr.charAt(s) +
            Qvsec._urlStr.charAt(g));
      return l;
    }),
    (Qvsec.$xx = function (e, t, o, A, i, r) {
      var n = "123456";
      if (r.length < 3) return "err";
      if ("7." != r.substr(0, 2)) return "err";
      var a = r.substr(2);
      return (
        "1" == a && (n = "06fc1464"),
        "2" == a && (n = "4244ce1b"),
        "3" == a && (n = "77de31c5"),
        "4" == a && (n = "e0149fa2"),
        "5" == a && (n = "60394ced"),
        "6" == a && (n = "2da639f0"),
        "7" == a && (n = "c2f0cf9f"),
        (i = i || parseInt(+new Date() / 1e3)),
        Qvsec.ha("".concat(n + t + i, "*#06#").concat(e))
      );
    });
  var Zu = Z1;
  !(function (e, t) {
    for (var o = Z1, A = Z0(); ; )
      try {
        if (
          581243 ==
          parseInt(o(508)) / 1 +
            (-parseInt(o(510)) / 2) * (-parseInt(o(632)) / 3) +
            parseInt(o(517)) / 4 +
            (-parseInt(o(593)) / 5) * (-parseInt(o(641)) / 6) +
            parseInt(o(502)) / 7 +
            -parseInt(o(583)) / 8 +
            -parseInt(o(511)) / 9
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var t,
    r,
    e,
    n,
    o,
    i$3,
    s = function (e, t) {
      return (s =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (e, t) {
            e[Z1(536) + "__"] = t;
          }) ||
        function (e, t) {
          var o = Z1;
          for (var A in t)
            Object[o(589) + "pe"][o(585) + o(561)][o(624)](t, A) &&
              (e[A] = t[A]);
        })(e, t);
    };
  function c(e, t) {
    var o = Z1;
    if ("function" != typeof t && null !== t)
      throw new TypeError(
        "Class e" +
          o(594) +
          "value " +
          String(t) +
          o(579) +
          " a constructor" +
          o(602) +
          "l"
      );
    function A() {
      var t = o;
      this[t(552) + t(555)] = e;
    }
    s(e, t),
      (e[o(589) + "pe"] =
        null === t ? Object.create(t) : ((A.prototype = t.prototype), new A()));
  }
  "function" == typeof SuppressedError && SuppressedError,
    (null === (t = Zu(634) + "ed" != typeof globalThis ? globalThis : void 0) ||
    void 0 === t
      ? void 0
      : t[Zu(515)]) ||
      (null === (r = Zu(634) + "ed" != typeof global ? global : void 0) ||
      void 0 === r
        ? void 0
        : r.crypto) ||
      (null === (e = Zu(634) + "ed" != typeof window ? window : void 0) ||
      void 0 === e
        ? void 0
        : e[Zu(515)]) ||
      (null === (n = Zu(634) + "ed" != typeof self ? self : void 0) ||
      void 0 === n
        ? void 0
        : n.crypto) ||
      null ===
        (i$3 =
          null === (o = Zu(634) + "ed" != typeof frames ? frames : void 0) ||
          void 0 === o
            ? void 0
            : o[0]) ||
      void 0 === i$3 ||
      i$3[Zu(515)];
  for (
    var a$e = function (e) {
        for (
          var t = [],
            o = function (e) {
              var t = e,
                o = 987654321,
                A = 4294967295;
              return function () {
                var e =
                  (((o = (36969 * (65535 & o) + (o >> 16)) & A) << 16) +
                    (t = (18e3 * (65535 & t) + (t >> 16)) & A)) &
                  A;
                return (
                  (e /= 4294967296), (e += 0.5) * (Math.random() > 0.5 ? 1 : -1)
                );
              };
            },
            A = 0,
            i = void 0;
          A < e;
          A += 4
        ) {
          var r = o(4294967296 * (i || Math.random()));
          (i = 987654071 * r()), t.push((4294967296 * r()) | 0);
        }
        return new p(t, e);
      },
      u = (function () {
        var e = Zu;
        function t() {}
        return (
          (t.create = function () {
            for (var e = Z1, t = [], o = 0; o < arguments[e(548)]; o++)
              t[o] = arguments[o];
            return new (this.bind.apply(
              this,
              (function (t, o, A) {
                var i = e;
                if (A || 2 === arguments[i(548)])
                  for (var r, n = 0, a = o[i(548)]; n < a; n++)
                    (!r && (n in o)) ||
                      (r || (r = Array[i(589) + "pe"][i(570)][i(624)](o, 0, n)),
                      (r[n] = o[n]));
                return t[i(532)](r || Array[i(589) + "pe"][i(570)][i(624)](o));
              })([void 0], t, !1)
            ))();
          }),
          (t[e(589) + "pe"][e(604)] = function (t) {
            return Object[e(623)](this, t);
          }),
          (t[e(589) + "pe"][e(523)] = function () {
            var t = e,
              o = new this[t(552) + t(555)]();
            return Object[t(623)](o, this), o;
          }),
          t
        );
      })(),
      p = (function (e) {
        var t = Zu;
        function o(t, o) {
          var A = Z1;
          void 0 === t && (t = []), void 0 === o && (o = 4 * t.length);
          var i = e[A(624)](this) || this,
            r = t;
          if (
            (r instanceof ArrayBuffer && (r = new Uint8Array(r)),
            ArrayBuffer[A(595)](r) &&
              (r = new Uint8Array(
                r[A(633)],
                r[A(545) + A(509)],
                r[A(527) + A(505)]
              )),
            r instanceof Uint8Array)
          ) {
            for (var n = r[A(527) + "gth"], a = [], s = 0; s < n; s += 1)
              a[s >>> 2] |= r[s] << (24 - (s % 4) * 8);
            (i[A(562)] = a), (i[A(612) + "s"] = n);
          } else (i.words = t), (i.sigBytes = o);
          return i;
        }
        return (
          c(o, e),
          (o.prototype[t(597) + "g"] = function (e) {
            return void 0 === e && (e = f), e[t(567) + "fy"](this);
          }),
          (o.prototype[t(532)] = function (e) {
            var o = t,
              A = this[o(562)],
              i = e[o(562)],
              r = this[o(612) + "s"],
              n = e[o(612) + "s"];
            if ((this[o(520)](), r % 4))
              for (var a = 0; a < n; a += 1) {
                var s = (i[a >>> 2] >>> (24 - (a % 4) * 8)) & 255;
                A[(r + a) >>> 2] |= s << (24 - ((r + a) % 4) * 8);
              }
            else for (a = 0; a < n; a += 4) A[(r + a) >>> 2] = i[a >>> 2];
            return (this[o(612) + "s"] += n), this;
          }),
          (o[t(589) + "pe"].clamp = function () {
            var e = t,
              o = this.words,
              A = this[e(612) + "s"];
            (o[A >>> 2] &= 4294967295 << (32 - (A % 4) * 8)),
              (o[e(548)] = Math[e(549)](A / 4));
          }),
          (o[t(589) + "pe"][t(523)] = function () {
            var o = t,
              A = e[o(589) + "pe"][o(523)][o(624)](this);
            return (A[o(562)] = this[o(562)][o(570)](0)), A;
          }),
          (o[t(563)] = a$e),
          o
        );
      })(u),
      f = {
        stringify: function (e) {
          for (
            var t = Zu, o = e.words, A = e[t(612) + "s"], i = [], r = 0;
            r < A;
            r += 1
          ) {
            var n = (o[r >>> 2] >>> (24 - (r % 4) * 8)) & 255;
            i[t(621)]((n >>> 4)[t(597) + "g"](16)),
              i.push((15 & n)[t(597) + "g"](16));
          }
          return i[t(524)]("");
        },
        parse: function (e) {
          for (var t = Zu, o = e[t(548)], A = [], i = 0; i < o; i += 2)
            A[i >>> 3] |= parseInt(e[t(636)](i, 2), 16) << (24 - (i % 8) * 4);
          return new p(A, o / 2);
        },
      },
      h = function (e) {
        for (var t = e[Zu(548)], o = [], A = 0; A < t; A += 1)
          o[A >>> 2] |= (255 & e.charCodeAt(A)) << (24 - (A % 4) * 8);
        return new p(o, t);
      },
      l = function (e) {
        return h(unescape(encodeURIComponent(e)));
      },
      v = (function (e) {
        var t = Zu;
        function o() {
          var t = Z1,
            o = e[t(624)](this) || this;
          return (o[t(559) + t(601)] = 0), o;
        }
        return (
          c(o, e),
          (o.prototype.reset = function () {
            var e = Z1;
            (this[e(626)] = new p()), (this[e(582) + e(580)] = 0);
          }),
          (o[t(589) + "pe"][t(534)] = function (e) {
            var o = t,
              A = e;
            o(544) == typeof A && (A = l(A)),
              this[o(626)][o(532)](A),
              (this[o(582) + o(580)] += A.sigBytes);
          }),
          (o[t(589) + "pe"][t(625) + "s"] = function (e) {
            var o,
              A = t,
              i = this[A(626)],
              r = this[A(525) + "ze"],
              n = i.words,
              a = i[A(612) + "s"],
              s = a / (4 * r),
              g =
                (s = e
                  ? Math[A(549)](s)
                  : Math[A(645)]((0 | s) - this[A(559) + A(601)], 0)) * r,
              l = Math[A(647)](4 * g, a);
            if (g) {
              for (var E = 0; E < g; E += r) this[A(553) + "essBlock"](n, E);
              (o = n[A(504)](0, g)), (i[A(612) + "s"] -= l);
            }
            return new p(o, l);
          }),
          (o.prototype.clone = function () {
            var o = t,
              A = e[o(589) + "pe"].clone[o(624)](this);
            return (A[o(626)] = this[o(626)].clone()), A;
          }),
          o
        );
      })(u),
      y = (function (e) {
        var t = Zu;
        function o(t) {
          var o = Z1,
            A = e.call(this) || this;
          return (
            (A[o(525) + "ze"] = 16),
            (A[o(615)] = Object[o(623)](new u(), t)),
            A[o(642)](),
            A
          );
        }
        return (
          c(o, e),
          (o[t(513) + t(571)] = function (e) {
            return function (t, o) {
              var A = Z1;
              return new e(o)[A(644) + "e"](t);
            };
          }),
          (o.prototype.reset = function () {
            var o = t;
            e[o(589) + "pe"][o(642)].call(this), this[o(568) + "t"]();
          }),
          (o[t(589) + "pe"][t(605)] = function (e) {
            var o = t;
            return this._append(e), this[o(625) + "s"](), this;
          }),
          (o[t(589) + "pe"].finalize = function (e) {
            var o = t;
            return e && this[o(534)](e), this[o(587) + o(610)]();
          }),
          o
        );
      })(v),
      d = [],
      _ = 0;
    _ < 64;
    _ += 1
  )
    d[_] = (4294967296 * Math.abs(Math[Zu(539)](_ + 1))) | 0;
  var g = function (e, t, o, A, i, r, n) {
      var a = e + ((t & o) | (~t & A)) + i + n;
      return ((a << r) | (a >>> (32 - r))) + t;
    },
    w$1 = function (e, t, o, A, i, r, n) {
      var a = e + ((t & A) | (o & ~A)) + i + n;
      return ((a << r) | (a >>> (32 - r))) + t;
    },
    B = function (e, t, o, A, i, r, n) {
      var a = e + (t ^ o ^ A) + i + n;
      return ((a << r) | (a >>> (32 - r))) + t;
    },
    m = function (e, t, o, A, i, r, n) {
      var a = e + (o ^ (t | ~A)) + i + n;
      return ((a << r) | (a >>> (32 - r))) + t;
    },
    k = (function (e) {
      var t = Zu;
      function o() {
        var t = Z1;
        return (null !== e && e[t(556)](this, arguments)) || this;
      }
      return (
        c(o, e),
        (o[t(589) + "pe"][t(568) + "t"] = function () {
          this[t(537)] = new p([1732584193, 4023233417, 2562383102, 271733878]);
        }),
        (o.prototype[t(553) + t(530) + "k"] = function (e, o) {
          for (var A = t, i = e, r = 0; r < 16; r += 1) {
            var n = o + r,
              a = e[n];
            i[n] =
              (16711935 & ((a << 8) | (a >>> 24))) |
              (4278255360 & ((a << 24) | (a >>> 8)));
          }
          var s = this[A(537)][A(562)],
            l = i[o + 0],
            E = i[o + 1],
            c = i[o + 2],
            u = i[o + 3],
            p = i[o + 4],
            h = i[o + 5],
            I = i[o + 6],
            C = i[o + 7],
            _ = i[o + 8],
            f = i[o + 9],
            y = i[o + 10],
            v = i[o + 11],
            Q = i[o + 12],
            T = i[o + 13],
            S = i[o + 14],
            D = i[o + 15],
            R = s[0],
            O = s[1],
            F = s[2],
            N = s[3];
          (R = g(R, O, F, N, l, 7, d[0])),
            (N = g(N, R, O, F, E, 12, d[1])),
            (F = g(F, N, R, O, c, 17, d[2])),
            (O = g(O, F, N, R, u, 22, d[3])),
            (R = g(R, O, F, N, p, 7, d[4])),
            (N = g(N, R, O, F, h, 12, d[5])),
            (F = g(F, N, R, O, I, 17, d[6])),
            (O = g(O, F, N, R, C, 22, d[7])),
            (R = g(R, O, F, N, _, 7, d[8])),
            (N = g(N, R, O, F, f, 12, d[9])),
            (F = g(F, N, R, O, y, 17, d[10])),
            (O = g(O, F, N, R, v, 22, d[11])),
            (R = g(R, O, F, N, Q, 7, d[12])),
            (N = g(N, R, O, F, T, 12, d[13])),
            (F = g(F, N, R, O, S, 17, d[14])),
            (O = g(O, F, N, R, D, 22, d[15])),
            (R = w$1(R, O, F, N, E, 5, d[16])),
            (N = w$1(N, R, O, F, I, 9, d[17])),
            (F = w$1(F, N, R, O, v, 14, d[18])),
            (O = w$1(O, F, N, R, l, 20, d[19])),
            (R = w$1(R, O, F, N, h, 5, d[20])),
            (N = w$1(N, R, O, F, y, 9, d[21])),
            (F = w$1(F, N, R, O, D, 14, d[22])),
            (O = w$1(O, F, N, R, p, 20, d[23])),
            (R = w$1(R, O, F, N, f, 5, d[24])),
            (N = w$1(N, R, O, F, S, 9, d[25])),
            (F = w$1(F, N, R, O, u, 14, d[26])),
            (O = w$1(O, F, N, R, _, 20, d[27])),
            (R = w$1(R, O, F, N, T, 5, d[28])),
            (N = w$1(N, R, O, F, c, 9, d[29])),
            (F = w$1(F, N, R, O, C, 14, d[30])),
            (O = w$1(O, F, N, R, Q, 20, d[31])),
            (R = B(R, O, F, N, h, 4, d[32])),
            (N = B(N, R, O, F, _, 11, d[33])),
            (F = B(F, N, R, O, v, 16, d[34])),
            (O = B(O, F, N, R, S, 23, d[35])),
            (R = B(R, O, F, N, E, 4, d[36])),
            (N = B(N, R, O, F, p, 11, d[37])),
            (F = B(F, N, R, O, C, 16, d[38])),
            (O = B(O, F, N, R, y, 23, d[39])),
            (R = B(R, O, F, N, T, 4, d[40])),
            (N = B(N, R, O, F, l, 11, d[41])),
            (F = B(F, N, R, O, u, 16, d[42])),
            (O = B(O, F, N, R, I, 23, d[43])),
            (R = B(R, O, F, N, f, 4, d[44])),
            (N = B(N, R, O, F, Q, 11, d[45])),
            (F = B(F, N, R, O, D, 16, d[46])),
            (O = B(O, F, N, R, c, 23, d[47])),
            (R = m(R, O, F, N, l, 6, d[48])),
            (N = m(N, R, O, F, C, 10, d[49])),
            (F = m(F, N, R, O, S, 15, d[50])),
            (O = m(O, F, N, R, h, 21, d[51])),
            (R = m(R, O, F, N, Q, 6, d[52])),
            (N = m(N, R, O, F, u, 10, d[53])),
            (F = m(F, N, R, O, y, 15, d[54])),
            (O = m(O, F, N, R, E, 21, d[55])),
            (R = m(R, O, F, N, _, 6, d[56])),
            (N = m(N, R, O, F, D, 10, d[57])),
            (F = m(F, N, R, O, I, 15, d[58])),
            (O = m(O, F, N, R, T, 21, d[59])),
            (R = m(R, O, F, N, p, 6, d[60])),
            (N = m(N, R, O, F, v, 10, d[61])),
            (F = m(F, N, R, O, c, 15, d[62])),
            (O = m(O, F, N, R, f, 21, d[63])),
            (s[0] = (s[0] + R) | 0),
            (s[1] = (s[1] + O) | 0),
            (s[2] = (s[2] + F) | 0),
            (s[3] = (s[3] + N) | 0);
        }),
        (o.prototype[t(587) + t(610)] = function () {
          var e = t,
            o = this[e(626)],
            A = o[e(562)],
            i = 8 * this[e(582) + e(580)],
            r = 8 * o.sigBytes;
          A[r >>> 5] |= 128 << (24 - (r % 32));
          var n = Math[e(618)](i / 4294967296),
            a = i;
          (A[15 + (((r + 64) >>> 9) << 4)] =
            (16711935 & ((n << 8) | (n >>> 24))) |
            (4278255360 & ((n << 24) | (n >>> 8)))),
            (A[14 + (((r + 64) >>> 9) << 4)] =
              (16711935 & ((a << 8) | (a >>> 24))) |
              (4278255360 & ((a << 24) | (a >>> 8)))),
            (o.sigBytes = 4 * (A[e(548)] + 1)),
            this[e(625) + "s"]();
          for (var s = this[e(537)], g = s[e(562)], l = 0; l < 4; l += 1) {
            var E = g[l];
            g[l] =
              (16711935 & ((E << 8) | (E >>> 24))) |
              (4278255360 & ((E << 24) | (E >>> 8)));
          }
          return s;
        }),
        (o[t(589) + "pe"].clone = function () {
          var o = t,
            A = e[o(589) + "pe"][o(523)][o(624)](this);
          return (A[o(537)] = this[o(537)].clone()), A;
        }),
        o
      );
    })(y),
    b$e = y[Zu(513) + Zu(571)](k),
    S = {
      stringify: function (e) {
        var t = Zu,
          o = e[t(562)],
          A = e[t(612) + "s"],
          i = this[t(640)];
        e.clamp();
        for (var r = [], n = 0; n < A; n += 3)
          for (
            var a =
                (((o[n >>> 2] >>> (24 - (n % 4) * 8)) & 255) << 16) |
                (((o[(n + 1) >>> 2] >>> (24 - ((n + 1) % 4) * 8)) & 255) << 8) |
                ((o[(n + 2) >>> 2] >>> (24 - ((n + 2) % 4) * 8)) & 255),
              s = 0;
            s < 4 && n + 0.75 * s < A;
            s += 1
          )
            r[t(621)](i.charAt((a >>> (6 * (3 - s))) & 63));
        var g = i.charAt(64);
        if (g) for (; r[t(548)] % 4; ) r[t(621)](g);
        return r.join("");
      },
      parse: function (e) {
        var t = Zu,
          o = e[t(548)],
          A = this._map,
          i = this[t(535) + "eMap"];
        if (!i) {
          (this[t(535) + t(499)] = []), (i = this["_revers" + t(499)]);
          for (var r = 0; r < A[t(548)]; r += 1) i[A[t(588) + t(578)](r)] = r;
        }
        var n = A.charAt(64);
        if (n) {
          var a = e.indexOf(n);
          -1 !== a && (o = a);
        }
        return (function (e, o, A) {
          for (var i = t, r = [], n = 0, a = 0; a < o; a += 1)
            if (a % 4) {
              var s =
                (A[e.charCodeAt(a - 1)] << ((a % 4) * 2)) |
                (A[e[i(588) + i(578)](a)] >>> (6 - (a % 4) * 2));
              (r[n >>> 2] |= s << (24 - (n % 4) * 8)), (n += 1);
            }
          return p[i(541)](r, n);
        })(e, o, i);
      },
      _map:
        Zu(630) +
        Zu(629) +
        Zu(554) +
        Zu(500) +
        "cdefghi" +
        Zu(501) +
        "qrstuvwxyz0123" +
        Zu(565) +
        "/=",
    },
    O = (function (e) {
      var t = Zu;
      function o(t, o, A) {
        var i = Z1,
          r = e[i(624)](this) || this;
        return (
          (r[i(615)] = Object.assign(new u(), A)),
          (r._xformMode = t),
          (r[i(519)] = o),
          r[i(642)](),
          r
        );
      }
      return (
        c(o, e),
        (o["createE" + t(506) + "r"] = function (e, o) {
          var A = t;
          return this[A(541)](this[A(617) + A(564) + "E"], e, o);
        }),
        (o[t(577) + t(607) + "r"] = function (e, t) {
          return this.create(this._DEC_XFORM_MODE, e, t);
        }),
        (o[t(513) + "Helper"] = function (e) {
          var t = function (e) {
            return R;
          };
          return {
            encrypt: function (o, A, i) {
              var r = Z1;
              return t()[r(538)](e, o, A, i);
            },
            decrypt: function (o, A, i) {
              var r = Z1;
              return t()[r(603)](e, o, A, i);
            },
          };
        }),
        (o[t(589) + "pe"][t(642)] = function () {
          var o = t;
          e.prototype[o(642)][o(624)](this), this[o(568) + "t"]();
        }),
        (o[t(589) + "pe"][t(503)] = function (e) {
          var o = t;
          return this[o(534)](e), this[o(625) + "s"]();
        }),
        (o[t(589) + "pe"][t(644) + "e"] = function (e) {
          var o = t;
          return e && this[o(534)](e), this[o(587) + o(610)]();
        }),
        o
      );
    })(v);
  function M$2(e, t, o) {
    var A,
      i = Zu,
      r = e,
      n = this[i(531)];
    n ? ((A = n), (this._iv = void 0)) : (A = this["_prevBl" + i(529)]);
    for (var a = 0; a < o; a += 1) r[t + a] ^= A[a];
  }
  (O[Zu(617) + Zu(564) + "E"] = 1),
    (O[Zu(543) + Zu(564) + "E"] = 2),
    (O.keySize = 4),
    (O.ivSize = 4);
  var A = (function (e) {
    function t() {
      return (null !== e && e.apply(this, arguments)) || this;
    }
    return c(t, e), t;
  })(
    (function (e) {
      var t = Zu;
      function o(t, o) {
        var A = Z1,
          i = e[A(624)](this) || this;
        return (i._cipher = t), (i[A(531)] = o), i;
      }
      return (
        c(o, e),
        (o[t(497) + t(506) + "r"] = function (e, o) {
          var A = t;
          return this[A(619) + "or"][A(541)](e, o);
        }),
        (o.createDecryptor = function (e, o) {
          return this[t(596) + "or"].create(e, o);
        }),
        o
      );
    })(u)
  );
  (A.Encryptor = (function (e) {
    var t = Zu;
    function o() {
      var t = Z1;
      return (null !== e && e[t(556)](this, arguments)) || this;
    }
    return (
      c(o, e),
      (o[t(589) + "pe"][t(503) + t(600)] = function (e, o) {
        var A = t,
          i = this._cipher,
          r = i[A(525) + "ze"];
        M$2.call(this, e, o, r),
          i[A(538) + A(600)](e, o),
          (this[A(512) + A(529)] = e[A(570)](o, o + r));
      }),
      o
    );
  })(A)),
    (A[Zu(596) + "or"] = (function (e) {
      var t = Zu;
      function o() {
        var t = Z1;
        return (null !== e && e[t(556)](this, arguments)) || this;
      }
      return (
        c(o, e),
        (o.prototype[t(503) + "Block"] = function (e, o) {
          var A = t,
            i = this[A(590)],
            r = i[A(525) + "ze"],
            n = e[A(570)](o, o + r);
          i[A(603) + A(600)](e, o),
            M$2[A(624)](this, e, o, r),
            (this["_prevBl" + A(529)] = n);
        }),
        o
      );
    })(A));
  var z = {
      pad: function (e, t) {
        for (
          var o = Zu,
            A = 4 * t,
            i = A - (e[o(612) + "s"] % A),
            r = (i << 24) | (i << 16) | (i << 8) | i,
            n = [],
            a = 0;
          a < i;
          a += 4
        )
          n[o(621)](r);
        var s = p[o(541)](n, i);
        e.concat(s);
      },
      unpad: function (e) {
        var t = e,
          o = 255 & t[Zu(562)][(t.sigBytes - 1) >>> 2];
        t.sigBytes -= o;
      },
    },
    E = (function (e) {
      var t = Zu;
      function o(t, o, i) {
        var r = Z1,
          n =
            e[r(624)](this, t, o, Object[r(623)]({ mode: A, padding: z }, i)) ||
            this;
        return (n[r(525) + "ze"] = 4), n;
      }
      return (
        c(o, e),
        (o.prototype[t(642)] = function () {
          var o,
            A = t;
          e[A(589) + "pe"][A(642)][A(624)](this);
          var i = this.cfg,
            r = i.iv,
            n = i[A(599)];
          this["_xformM" + A(622)] ===
          this["constru" + A(555)][A(617) + A(564) + "E"]
            ? (o = n[A(497) + A(506) + "r"])
            : ((o = n[A(577) + A(607) + "r"]), (this[A(559) + "ferSize"] = 1)),
            (this._mode = o.call(n, this, null == r ? void 0 : r.words)),
            (this._mode[A(498) + "or"] = o);
        }),
        (o[t(589) + "pe"][t(553) + t(530) + "k"] = function (e, o) {
          var A = t;
          this[A(533)][A(503) + A(600)](e, o);
        }),
        (o[t(589) + "pe"][t(587) + t(610)] = function () {
          var e,
            o = t,
            A = this[o(615)][o(569)];
          return (
            this[o(591) + o(622)] ===
            this[o(552) + "ctor"]["_ENC_XF" + o(564) + "E"]
              ? (A[o(627)](this[o(626)], this[o(525) + "ze"]),
                (e = this[o(625) + "s"](!0)))
              : ((e = this[o(625) + "s"](!0)), A[o(631)](e)),
            e
          );
        }),
        o
      );
    })(O),
    C = (function (e) {
      var t = Zu;
      function o(t) {
        var o = Z1,
          A = e.call(this) || this;
        return A[o(604)](t), A;
      }
      return (
        c(o, e),
        (o[t(589) + "pe"][t(597) + "g"] = function (e) {
          var o = t;
          return (e || this[o(573) + "er"])[o(567) + "fy"](this);
        }),
        o
      );
    })(u),
    D = {
      stringify: function (e) {
        var t = Zu,
          o = e[t(516) + "ext"],
          A = e[t(557)];
        return (
          A ? p.create([1398893684, 1701076831])[t(532)](A)[t(532)](o) : o
        )[t(597) + "g"](S);
      },
      parse: function (e) {
        var t,
          o = Zu,
          A = S.parse(e),
          i = A.words;
        return (
          1398893684 === i[0] &&
            1701076831 === i[1] &&
            ((t = p[o(541)](i.slice(2, 4))),
            i[o(504)](0, 4),
            (A[o(612) + "s"] -= 16)),
          C[o(541)]({ ciphertext: A, salt: t })
        );
      },
    },
    R = (function (e) {
      var t = Zu;
      function o() {
        var t = Z1;
        return (null !== e && e[t(556)](this, arguments)) || this;
      }
      return (
        c(o, e),
        (o[t(538)] = function (e, o, A, i) {
          var r = t,
            n = Object.assign(new u(), this[r(615)], i),
            a = e[r(497) + "ncryptor"](A, n),
            s = a[r(644) + "e"](o),
            g = a[r(615)];
          return C[r(541)]({
            ciphertext: s,
            key: A,
            iv: g.iv,
            algorithm: e,
            mode: g[r(599)],
            padding: g[r(569)],
            blockSize: a.blockSize,
            formatter: n.format,
          });
        }),
        (o[t(603)] = function (e, o, A, i) {
          var r = t,
            n = o,
            a = Object[r(623)](new u(), this[r(615)], i);
          return (
            (n = this[r(584)](n, a[r(576)])),
            e[r(577) + r(607) + "r"](A, a)[r(644) + "e"](n[r(516) + r(643)])
          );
        }),
        (o[t(584)] = function (e, o) {
          var A = t;
          return A(544) == typeof e ? o[A(522)](e, this) : e;
        }),
        o
      );
    })(u);
  R[Zu(615)] = Object[Zu(623)](new u(), { format: D });
  var j = [],
    x = [],
    F = [],
    N = [],
    P = [],
    X = [],
    H = [],
    I = [],
    J$1 = [],
    U = [];
  for (_ = 0; _ < 256; _ += 1) U[_] = _ < 128 ? _ << 1 : (_ << 1) ^ 283;
  var V = 0,
    T = 0;
  for (_ = 0; _ < 256; _ += 1) {
    var K = T ^ (T << 1) ^ (T << 2) ^ (T << 3) ^ (T << 4);
    (K = (K >>> 8) ^ (255 & K) ^ 99), (j[V] = K);
    var L = U[V],
      q = U[L],
      G = U[q],
      Q = (257 * U[K]) ^ (16843008 * K);
    (x[V] = (Q << 24) | (Q >>> 8)),
      (F[V] = (Q << 16) | (Q >>> 16)),
      (N[V] = (Q << 8) | (Q >>> 24)),
      (P[V] = Q),
      (Q = (16843009 * G) ^ (65537 * q) ^ (257 * L) ^ (16843008 * V)),
      (X[K] = (Q << 24) | (Q >>> 8)),
      (H[K] = (Q << 16) | (Q >>> 16)),
      (I[K] = (Q << 8) | (Q >>> 24)),
      (J$1[K] = Q),
      V ? ((V = L ^ U[U[U[G ^ L]]]), (T ^= U[U[T]])) : (V = T = 1);
  }
  var W = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54],
    Y = (function (e) {
      var t = Zu;
      function o() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        c(o, e),
        (o[t(589) + "pe"][t(568) + "t"] = function () {
          var e,
            o = t;
          if (!this._nRounds || this[o(614) + o(638)] !== this[o(519)]) {
            this[o(614) + o(638)] = this[o(519)];
            var A = this[o(614) + o(638)],
              i = A[o(562)],
              r = A[o(612) + "s"] / 4;
            this._nRounds = r + 6;
            var n = 4 * (this[o(547) + "s"] + 1);
            this._keySchedule = [];
            for (var a = this[o(646) + o(592)], s = 0; s < n; s += 1)
              s < r
                ? (a[s] = i[s])
                : ((e = a[s - 1]),
                  s % r
                    ? r > 6 &&
                      s % r == 4 &&
                      (e =
                        (j[e >>> 24] << 24) |
                        (j[(e >>> 16) & 255] << 16) |
                        (j[(e >>> 8) & 255] << 8) |
                        j[255 & e])
                    : ((e =
                        (j[(e = (e << 8) | (e >>> 24)) >>> 24] << 24) |
                        (j[(e >>> 16) & 255] << 16) |
                        (j[(e >>> 8) & 255] << 8) |
                        j[255 & e]),
                      (e ^= W[(s / r) | 0] << 24)),
                  (a[s] = a[s - r] ^ e));
            this[o(628) + "Schedule"] = [];
            for (var g = this[o(628) + o(521) + "e"], l = 0; l < n; l += 1)
              (s = n - l),
                (e = l % 4 ? a[s] : a[s - 4]),
                (g[l] =
                  l < 4 || s <= 4
                    ? e
                    : X[j[e >>> 24]] ^
                      H[j[(e >>> 16) & 255]] ^
                      I[j[(e >>> 8) & 255]] ^
                      J$1[j[255 & e]]);
          }
        }),
        (o[t(589) + "pe"]["encrypt" + t(600)] = function (e, o) {
          var A = t;
          this[A(518) + A(637)](e, o, this[A(646) + A(592)], x, F, N, P, j);
        }),
        (o.prototype[t(518) + t(637)] = function (e, o, A, i, r, n, a, s) {
          for (
            var g = e,
              l = this[t(547) + "s"],
              E = g[o] ^ A[0],
              c = g[o + 1] ^ A[1],
              u = g[o + 2] ^ A[2],
              p = g[o + 3] ^ A[3],
              d = 4,
              B = 1;
            B < l;
            B += 1
          ) {
            var h =
              i[E >>> 24] ^
              r[(c >>> 16) & 255] ^
              n[(u >>> 8) & 255] ^
              a[255 & p] ^
              A[d];
            d += 1;
            var I =
              i[c >>> 24] ^
              r[(u >>> 16) & 255] ^
              n[(p >>> 8) & 255] ^
              a[255 & E] ^
              A[d];
            d += 1;
            var C =
              i[u >>> 24] ^
              r[(p >>> 16) & 255] ^
              n[(E >>> 8) & 255] ^
              a[255 & c] ^
              A[d];
            d += 1;
            var _ =
              i[p >>> 24] ^
              r[(E >>> 16) & 255] ^
              n[(c >>> 8) & 255] ^
              a[255 & u] ^
              A[d];
            (d += 1), (E = h), (c = I), (u = C), (p = _);
          }
          var f =
            ((s[E >>> 24] << 24) |
              (s[(c >>> 16) & 255] << 16) |
              (s[(u >>> 8) & 255] << 8) |
              s[255 & p]) ^
            A[d];
          d += 1;
          var y =
            ((s[c >>> 24] << 24) |
              (s[(u >>> 16) & 255] << 16) |
              (s[(p >>> 8) & 255] << 8) |
              s[255 & E]) ^
            A[d];
          d += 1;
          var m =
            ((s[u >>> 24] << 24) |
              (s[(p >>> 16) & 255] << 16) |
              (s[(E >>> 8) & 255] << 8) |
              s[255 & c]) ^
            A[d];
          d += 1;
          var v =
            ((s[p >>> 24] << 24) |
              (s[(E >>> 16) & 255] << 16) |
              (s[(c >>> 8) & 255] << 8) |
              s[255 & u]) ^
            A[d];
          (d += 1), (g[o] = f), (g[o + 1] = y), (g[o + 2] = m), (g[o + 3] = v);
        }),
        o
      );
    })(E);
  function Z0() {
    var e = [
      "zgvJCNLWDa",
      "BwL4sw4",
      "DxbKyxrL",
      "Dg9vChbLCG",
      "zwnYExb0BW",
      "mZm1ma",
      "q0zbqZiXnG",
      "BgL6zq",
      "ms4WlJe",
      "C2LNqNL0zq",
      "y2HHCKf0",
      "x2TLEvbYAq",
      "y2zN",
      "uvjtvfzxwa",
      "x0voq19yrG",
      "zMXVB3i",
      "rw5JCNLWDa",
      "EhOWmti0nG",
      "ChvZAa",
      "B2rL",
      "yxnZAwDU",
      "y2fSBa",
      "x3bYB2nLCW",
      "x2rHDge",
      "CgfK",
      "x2LUDKTLEq",
      "seLks0XntG",
      "qujdrevgrW",
      "Dw5Wywq",
      "ndy0nZy2v05fAxn2",
      "yNvMzMvY",
      "Dw5KzwzPBG",
      "z3vPza",
      "C3vIC3rY",
      "DejSB2nR",
      "B3jszxnLDa",
      "ls0Wmq",
      "x21HCa",
      "mtu2v01bueTf",
      "CMvZzxq",
      "zxH0",
      "zMLUywXPEG",
      "Bwf4",
      "x2TLEvnJAa",
      "BwLU",
      "y3jLyxrLrq",
      "x19JCMvHDa",
      "zu1HCa",
      "vLDywvPHyG",
      "AMTSBw5VCa",
      "mtK5nJyXmenlBerOua",
      "ChjVy2vZCW",
      "C3bSAwnL",
      "z3rO",
      "BMnYExb0BW",
      "BM9Uy2u",
      "ody3ntu1Aw1JtwLi",
      "C2v0",
      "ngLJEfvODa",
      "mtu3ntGZndnwuLPJwLy",
      "x3bYzxzcBa",
      "x2nYzwf0zq",
      "ndqZnZCZqq",
      "y3j5ChrV",
      "y2LWAgvYDa",
      "nde2odG5nND1DuztyW",
      "x2rVq3j5Ca",
      "x2TLEq",
      "y2XHBxa",
      "u2nOzwr1Ba",
      "CgfYC2u",
      "y2XVBMu",
      "AM9PBG",
      "yMXVy2TtAq",
      "yNvZsLnptG",
      "yNL0zuXLBG",
      "mKe1que2ma",
      "B2nR",
      "zxnZqMXVyW",
      "x2L2",
      "y29Uy2f0",
      "x21Vzgu",
      "x2fWCgvUza",
      "x3jLDMvYCW",
      "x19WCM90BW",
      "x2HHC2G",
      "zw5JCNLWDa",
      "C2LU",
      "nJaXmZu3nq",
      "y3jLyxrL",
      "C2vJsLnptG",
      "x0rfq19yrG",
      "C3rYAw5N",
      "yNL0zu9MzG",
      "qujdruzhsa",
      "x25sB3vUza",
      "BgvUz3rO",
      "y2vPBa",
      "DMLK",
      "C3vIC3rYAq",
      "y29UC3rYDq",
      "x2rVuhjVyW",
      "t1bruLnuvq",
      "y3rVCG",
      "yxbWBhK",
      "C2fSDa",
      "CMfUza",
      "x21PBKj1zG",
      "mtC4que2qW",
      "CM9Wzxj0Eq",
      "D29Yzhm",
      "CMfUzg9T",
      "t1jnx01pra",
      "ndu2nZG5kW",
      "wvPHyMnLzG",
      "C3rYAw5NAq",
      "x2rVuMvZzq",
      "CgfKzgLUzW",
      "C2XPy2u",
      "sgvSCgvY",
      "nKm0rq",
      "zM9YBwf0Da",
      "C2rRvMvY",
      "Adm4",
      "zM9YBwf0",
      "y3jLyxrLra",
      "zuf0",
      "igLZig5VDa",
      "ExrLCW",
      "ChfYC3v2DW",
      "x25eyxrHqG",
      "nJGXndqYnevYvKPQtG",
      "x3bHCNnL",
      "AgfZt3DUua",
      "z2LQA2XTBG",
      "x2rVrMLUyq",
      "y2HHCKnVza",
      "ChjVDg90Eq",
      "x2nPCgHLCG",
      "x3HMB3jTtq",
      "zwr1Bgu",
      "mtmWnJaWvKXdrhfd",
      "EhrLBMrZia",
      "AxnwAwv3",
      "rgvJCNLWDa",
      "Dg9tDhjPBG",
      "CgXHDgzVCG",
      "Bw9Kzq",
      "qMXVy2S",
      "zMvYu2L6zq",
      "ig9Yig51Ba",
    ];
    return (Z0 = function () {
      return e;
    })();
  }
  function Z1(e, t) {
    var o = Z0();
    return (
      (Z1 = function (t, A) {
        var i = o[(t -= 497)];
        if (void 0 === Z1.FikNlj) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (Z1.kyqcpm = r), (e = arguments), (Z1.FikNlj = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = Z1.kyqcpm(i)), (e[a] = i)), i;
      }),
      Z1(e, t)
    );
  }
  Y.keySize = 8;
  var Z = E[Zu(513) + Zu(571)](Y);
  function $(e) {
    var t = Zu,
      o = (function (e) {
        var t = Z1;
        void 0 === e && (e = 32);
        for (
          var o =
              t(546) +
              "IJKLNOP" +
              t(616) +
              t(566) +
              t(586) +
              t(581) +
              t(620) +
              "79",
            A = "",
            i = 0;
          i < e;
          i += 1
        )
          A += o[t(613)](Math[t(618)](Math[t(563)]() * o[t(548)]));
        return A;
      })(11),
      i = e[t(550)],
      r = e.ts,
      n = e.appVer,
      a = e[t(635)],
      s = e[t(598) + "m"],
      g = e.h38,
      l = void 0 === g ? "" : g,
      E = e[t(542)],
      c = void 0 === E ? "" : E,
      u = e[t(526)],
      p = void 0 === u ? "" : u,
      d = {};
    (d.vid = i),
      (d[t(574)] = t(611)),
      (d[t(507)] = o),
      (d[t(558)] = b$e(""[t(532)](o, "1234"))
        [t(597) + "g"]()
        [t(551) + "ng"](0, 8)),
      (d.appVer = n),
      (d[t(635)] = a),
      (d.platform = s),
      (d.ts = r),
      (d[t(575)] = l),
      (d.sj = c),
      (d.bj = p),
      (d.os = JSON[t(567) + "fy"]({}));
    var B = {};
    (B.iv = f[t(522)](t(609) + "FAA2D39" + t(540) + "D4055C6" + t(608))),
      (B.mode = A),
      (B[t(569)] = z);
    var h = Z.encrypt(
      JSON[t(567) + "fy"](d),
      f[t(522)](t(528) + t(560) + "8DA662E" + t(514) + t(572)),
      B
    );
    return t(639).concat(h[t(516) + "ext"][t(597) + "g"]()[t(606) + "Case"]());
  }
  function getCkey7(e) {
    var t = e.svrtick,
      o = e.platform,
      A = e.ckeyid,
      i = e.sdtfrom,
      r = new Date().getDay(),
      n = "7.".concat(0 === r ? 7 : r),
      a = t > 0 ? "".concat(1e3 * t).substring(0, 10) : getTimeStampStr();
    return { tm: a, cKey: Qvsec.$xx(o, A, i, 1, a, n), encryptVer: n };
  }
  function getCkey8(e) {
    var t = e.vid,
      o = e.updateTimeStamp,
      A = e.appVer,
      i = e.guid,
      r = e.platform,
      n = e.h38,
      a = "".concat(o) || getTimeStampStr();
    return {
      tm: a,
      cKey: $({ vid: t, ts: a, appVer: A, guid: i, platform: r, h38: n }),
      encryptVer: exports.CKEY_VRE.CKEY_8,
    };
  }
  var LC_AD_COOKIE_PREFIX = "lcad_",
    PROXY_HTTP_REQ_BUID;
  function readCookieAndConvert2AdParam() {
    var e = document.cookie ? document.cookie.split("; ") : [],
      t = {};
    return (
      e.forEach(function (e) {
        var o = e.split("="),
          A = o[0],
          i = o[1];
        0 === A.indexOf(LC_AD_COOKIE_PREFIX) &&
          (t[A.slice(LC_AD_COOKIE_PREFIX.length)] = { value: i });
      }),
      !t || Object.keys(t).length <= 0 ? "" : convertCookie2AdParam(t)
    );
  }
  function convertCookie2AdParam(e) {
    if (!e) return "";
    var t = Object.keys(e);
    return t.length <= 0
      ? ""
      : t
          .map(function (t) {
            return "".concat(t, "=").concat(e[t].value);
          })
          .join("; ");
  }
  function parseAdParamAndWrite2Cookie(e) {
    var t = adParam2Cookie(e);
    t &&
      Object.keys(t).forEach(function (e) {
        var o = t[e];
        try {
          document.cookie = ""
            .concat(e, "=")
            .concat(o.value, "; domain=.v.qq.com; path=/; expires=")
            .concat(o.expires);
        } catch (e) {}
      });
  }
  function adParam2Cookie(e) {
    if (e) {
      var t = [];
      try {
        t = JSON.parse(e);
      } catch (e) {}
      if (t && t instanceof Array && !(t.length <= 0)) {
        var o = {};
        return (
          t.forEach(function (e) {
            Object.assign(o, parseServerCookie(e));
          }),
          o
        );
      }
    }
  }
  function parseServerCookie(e) {
    for (
      var t = e ? e.split("; ") : [], o = {}, A = { value: "" }, i = 0;
      i < t.length;
      i++
    ) {
      var r = t[i].split("="),
        n = r[0],
        a = r[1];
      0 === i
        ? ((o["".concat(LC_AD_COOKIE_PREFIX).concat(n)] = A), (A.value = a))
        : "Expires" === n && (A.expires = a);
    }
    return o;
  }
  function getProxyHttpReqParams(e, t) {
    var o = t ? urlTool.convertUrlParam(t) : void 0,
      A = void 0,
      i = void 0;
    if (null == e ? void 0 : e.adparam) {
      if (((A = urlTool.convertUrlParam(e.adparam)), e.sspAdParam))
        try {
          i = JSON.stringify(e.sspAdParam);
        } catch (e) {}
    } else A = e ? urlTool.convertUrlParam(e) : void 0;
    var r = i ? { sspAdParam: i, adparam: A } : { adparam: A },
      n = readCookieAndConvert2AdParam(),
      a = n ? { lcAdCookie: n } : void 0;
    return A && o
      ? __assign(
          __assign({ buid: PROXY_HTTP_REQ_BUID.vinfoad, vinfoparam: o }, r),
          a
        )
      : A
      ? __assign(__assign({ buid: PROXY_HTTP_REQ_BUID.onlyad }, r), a)
      : o
      ? __assign({ buid: PROXY_HTTP_REQ_BUID.onlyvinfo, vinfoparam: o }, a)
      : void 0;
  }
  function compose(e) {
    return function (t, o) {
      var A = -1;
      return (function i(r) {
        if (r <= A)
          return Promise.reject(new Error("next() called multiple times"));
        A = r;
        var n = e[r];
        if ((r === e.length && (n = o), !n)) return Promise.resolve(null);
        try {
          return Promise.resolve(n(t, i.bind(null, r + 1)));
        } catch (e) {
          return Promise.reject(e);
        }
      })(0);
    };
  }
  !(function (e) {
    (e.onlyvinfo = "onlyvinfo"), (e.onlyad = "onlyad"), (e.vinfoad = "vinfoad");
  })(PROXY_HTTP_REQ_BUID || (PROXY_HTTP_REQ_BUID = {}));
  var JsonpRequestor = (function () {
      function e(e) {
        this._jsonpPrefix = e;
      }
      return (
        (e.prototype.start = function (t, o, A) {
          return (
            void 0 === A && (A = e.timeout),
            netTool.jsonp(t, {
              query: o,
              timeout: A,
              charset: "utf-8",
              name: ""
                .concat(this._jsonpPrefix)
                .concat(Math.floor(1e6 * Math.random())),
            })
          );
        }),
        (e.timeout = 6e3),
        e
      );
    })(),
    TVK_ERROR_TYPE = 17,
    TVK_REFRESH_URL_PARAM = "tvk_refreshed",
    TVKError = function (e) {
      return new ErrorBase("tvk", e);
    },
    TvkStepKey,
    OfficialPlatform,
    DRM_CODE_FROM_VINFO;
  function getRequestParamForDRM(e, t) {
    return __awaiter$1(this, void 0, void 0, function () {
      var o;
      return __generator$1(this, function (A) {
        switch (A.label) {
          case 0:
            return (
              StepTimer.start(TvkStepKey.UPDATE_DRM, t), [4, getDrmParam(e)]
            );
          case 1:
            return (
              (o = A.sent()), StepTimer.end(TvkStepKey.UPDATE_DRM, t), [2, o]
            );
        }
      });
    });
  }
  (ErrorTypeCodeMap.tvk = TVK_ERROR_TYPE),
    (function (e) {
      (e.UPDATE_K = "uk"),
        (e.UPDATE_DRM = "udrm"),
        (e.PROXY_REQ = "proxyReq"),
        (e.RES_MODIFY = "resMfy"),
        (e.RES_PARSE = "resParse");
    })(TvkStepKey || (TvkStepKey = {})),
    (function (e) {
      (e.vodVQQ = "10201"), (e.vodDefault = "70201"), (e.liveVQQ = "10201");
    })(OfficialPlatform || (OfficialPlatform = {})),
    (function (e) {
      (e[(e.NONE = 0)] = "NONE"),
        (e[(e.FAIRPLAY = 4)] = "FAIRPLAY"),
        (e[(e.WIDEVINE = 5)] = "WIDEVINE"),
        (e[(e.CHACHA20 = 3)] = "CHACHA20");
    })(DRM_CODE_FROM_VINFO || (DRM_CODE_FROM_VINFO = {}));
  var w = b$d;
  function b$d(e, t) {
    var o = a$d();
    return (
      (b$d = function (t, A) {
        var i = o[(t -= 265)];
        if (void 0 === b$d.SmZDBX) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b$d.AanIpk = r), (e = arguments), (b$d.SmZDBX = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b$d.AanIpk(i)), (e[a] = i)), i;
      }),
      b$d(e, t)
    );
  }
  !(function (e, t) {
    for (var o = b$d, A = a$d(); ; )
      try {
        if (
          419819 ==
          (-parseInt(o(278)) / 1) * (parseInt(o(286)) / 2) +
            -parseInt(o(267)) / 3 +
            parseInt(o(296)) / 4 +
            (-parseInt(o(289)) / 5) * (-parseInt(o(268)) / 6) +
            (-parseInt(o(265)) / 7) * (-parseInt(o(282)) / 8) +
            -parseInt(o(272)) / 9 +
            (-parseInt(o(295)) / 10) * (-parseInt(o(303)) / 11)
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var performanceCost$2 = performanceCostDecoratorCreator(w(300)),
    UpdateReqParams = (function () {
      var e = w;
      function t(e) {
        this[b$d(302)] = e;
      }
      return (
        Object[e(285)](t[e(275)], e(269), {
          get: function () {
            var t,
              o = e;
            return null === (t = this[o(302)]) || void 0 === t
              ? void 0
              : t[o(269)];
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t[e(275)][e(274)] = function (e) {
          return (
            void 0 === e && (e = ""),
            __awaiter$1(this, void 0, void 0, function () {
              var t, o, A, i, r, n, a, s, g, l, E, c, u, p, d, B;
              return __generator$1(this, function (h) {
                var I = b$d;
                switch (h[I(273)]) {
                  case 0:
                    return (
                      StepTimer[I(306)](TvkStepKey[I(266)], this[I(269)]),
                      (t = this[I(302)][I(279)]),
                      (o = this[I(302)][I(305)][I(309)]),
                      (A = void 0 === o ? "" : o),
                      (i = t[I(290)]),
                      (r = void 0 === i ? "" : i),
                      (n = t[I(276)]),
                      (a = void 0 === n ? "" : n),
                      (s = t[I(281)]),
                      (g = void 0 === s ? "" : s),
                      (l = t[I(280)]),
                      (E = void 0 === l ? "" : l),
                      (c = performance[I(293)]()),
                      (u = getCkey8({
                        vid: r,
                        updateTimeStamp: e,
                        platform: E,
                        guid: g,
                        appVer: a,
                        h38: A,
                      })),
                      (p = u.tm),
                      (d = u[I(304)]),
                      (B = u[I(308)]),
                      (t.tm = p),
                      (t[I(304)] = d),
                      (t[I(308)] = B),
                      (this[I(302)][I(297)] = performance[I(293)]() - c),
                      [4, this[I(287)]()]
                    );
                  case 1:
                    return (
                      h[I(270)](),
                      StepTimer[I(299)](TvkStepKey[I(266)], this[I(269)]),
                      [2, t]
                    );
                }
              });
            })
          );
        }),
        (t[e(275)][e(287)] = function () {
          var e, t;
          return __awaiter$1(this, void 0, void 0, function () {
            var o;
            return __generator$1(this, function (A) {
              var i = b$d;
              switch (A[i(273)]) {
                case 0:
                  return (
                    A[i(294)][i(298)]([0, 2, , 3]),
                    [
                      4,
                      null === (t = (e = this[i(302)][i(283)])[i(292)]) ||
                      void 0 === t
                        ? void 0
                        : t[i(288)](e, this[i(302)]),
                    ]
                  );
                case 1:
                  return A[i(270)](), [3, 3];
                case 2:
                  return (
                    (o = A[i(270)]()),
                    this[i(302)][i(271)][i(291)](i(277), o),
                    [3, 3]
                  );
                case 3:
                  return [2];
              }
            });
          });
        }),
        __decorate(
          [
            performanceCost$2,
            __metadata(e(301), Function),
            __metadata(e(307), [Object]),
            __metadata(e(284), Promise),
          ],
          t[e(275)],
          e(274),
          null
        ),
        __decorate(
          [
            performanceCost$2,
            __metadata(e(301), Function),
            __metadata(e(307), []),
            __metadata(e(284), Promise),
          ],
          t[e(275)],
          e(287),
          null
        ),
        t
      );
    })();
  function a$d() {
    var e = [
      "vxbKyxrLuMvXugfYyw1Z",
      "zgvZAwDUoNr5Cgu",
      "y3r4",
      "mteZm0LsquPOEG",
      "y0TLEq",
      "yNvZAw5LC3neyxrH",
      "C3rHCNq",
      "zgvZAwDUoNbHCMfTDhLWzxm",
      "zw5JCNLWDfzLCG",
      "Adm4",
      "mJu2ouTzAK1jEq",
      "vvbeqvrfx0S",
      "mJm4nZu3muDpz1rtuq",
      "mZe1ndC0v3DIv1Ll",
      "CgXHEwvYsw5ZDgfUy2vjza",
      "C2vUDa",
      "Bg9Nz2vY",
      "mtKZmdyWohrdtLDZuG",
      "BgfIzwW",
      "DxbKyxrL",
      "ChjVDg90ExbL",
      "yxbWvMvY",
      "y29UDgv4De1VzgLMAwvYigvYCM9YoG",
      "mwnYCND6wa",
      "CMvXugfYyw1Z",
      "CgXHDgzVCM0",
      "z3vPza",
      "mtyWndbWy0zeAg4",
      "y29UzMLN",
      "zgvZAwDUoNjLDhvYBNr5Cgu",
      "zgvMAw5LuhjVCgvYDhK",
      "mtuXotm5nhnjtu5SvG",
      "zxHLy0nVBNrLEhrnB2rPzMLLCG",
      "y2fSBa",
      "mtvNqwXIvMS",
      "DMLK",
      "zxjYB3i",
      "y29UDgv4De1VzgLMAwvY",
      "BM93",
      "Dhj5CW",
      "nJu2odbMtLrdr1O",
      "mJq3otiZnLjXC1jbua",
      "y0TLEunVC3ruAw1L",
      "ChvZAa",
      "zw5K",
    ];
    return (a$d = function () {
      return e;
    })();
  }
  function a$c() {
    var e = [
      "C2vUzcbWyxjHBq",
      "mtvMtfzOq0e",
      "ywXS",
      "BgfIzwW",
      "DxbKyxrL",
      "mJqWntK0mfj2yNLdvW",
      "mJKWotmYCgnYEw1M",
      "nwL3CLLzEq",
      "mZqWotyWmKXJB2zstG",
      "zhjT",
      "mZLYyNjQuwy",
      "Bg9Nz2vY",
      "CMvXugfYyw1Z",
      "mtftDerZBfe",
      "nZnquLnVANq",
      "Bg9N",
      "oduWmtKXmfLNue5ZCW",
      "C2vUDa",
      "mtzXBK90qu8",
      "mtG5ntC0n2rAugTbCq",
      "mZuXmK1RDLrtza",
      "ntGZmdq3owH6vwjUAG",
      "CgXHEwvYsw5ZDgfUy2vjza",
    ];
    return (a$c = function () {
      return e;
    })();
  }
  function b$c(e, t) {
    var o = a$c();
    return (
      (b$c = function (t, A) {
        var i = o[(t -= 405)];
        if (void 0 === b$c.tRQtNg) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b$c.EBmfud = r), (e = arguments), (b$c.tRQtNg = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b$c.EBmfud(i)), (e[a] = i)), i;
      }),
      b$c(e, t)
    );
  }
  !(function (e, t) {
    for (var o = b$c, A = a$c(); ; )
      try {
        if (
          431309 ==
          (-parseInt(o(425)) / 1) * (parseInt(o(408)) / 2) +
            (parseInt(o(412)) / 3) * (-parseInt(o(417)) / 4) +
            (parseInt(o(418)) / 5) * (parseInt(o(419)) / 6) +
            (-parseInt(o(407)) / 7) * (parseInt(o(406)) / 8) +
            parseInt(o(409)) / 9 +
            (parseInt(o(427)) / 10) * (parseInt(o(424)) / 11) +
            (parseInt(o(416)) / 12) * (-parseInt(o(421)) / 13)
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var prepareRequestMiddleWare = function (e, t) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var o, A, i, r;
      return __generator$1(this, function (n) {
        var a = b$c;
        switch (n[a(414)]) {
          case 0:
            return (
              (o = e[a(423)]),
              (A = void 0 === o ? {} : o),
              [
                4,
                Promise[a(413)]([
                  new UpdateReqParams(e)[a(415)](),
                  getRequestParamForDRM(A[a(420)], e[a(410)]),
                ]),
              ]
            );
          case 1:
            return (
              (i = n[a(405)]()),
              (r = i[1]),
              (A[a(420)] = r),
              e[a(422)][a(426)](a(411), e[a(423)]),
              [4, t()]
            );
          case 2:
            return n[a(405)](), [2];
        }
      });
    });
  };
  function b$b(e, t) {
    var o = a$b();
    return (
      (b$b = function (t, A) {
        var i = o[(t -= 153)];
        if (void 0 === b$b.LOWpUC) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b$b.rufwBH = r), (e = arguments), (b$b.LOWpUC = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b$b.rufwBH(i)), (e[a] = i)), i;
      }),
      b$b(e, t)
    );
  }
  function a$b() {
    var e = [
      "mteYmtC3mxPys2nSrG",
      "ofzTs3HSyG",
      "mtGYmdmXnhrvvxjLDW",
      "mtiWndaZmtb0vwHrq0q",
      "ndq4ndqWovLzwe9zuW",
      "mJu3odH4CvzIrhG",
      "nteWmdq4nLrrvhrdqW",
      "own3quP4vG",
      "mtu0nZDlDurNq3C",
      "mvnrCgvora",
      "mtC3mZe4neLPEfbfsq",
      "mtbUA0nNCxK",
    ];
    return (a$b = function () {
      return e;
    })();
  }
  !(function (e, t) {
    for (var o = b$b, A = a$b(); ; )
      try {
        if (
          782112 ==
          (parseInt(o(155)) / 1) * (parseInt(o(160)) / 2) +
            parseInt(o(162)) / 3 +
            (parseInt(o(156)) / 4) * (parseInt(o(157)) / 5) +
            -parseInt(o(164)) / 6 +
            (parseInt(o(158)) / 7) * (parseInt(o(159)) / 8) +
            (-parseInt(o(153)) / 9) * (-parseInt(o(161)) / 10) +
            (-parseInt(o(154)) / 11) * (parseInt(o(163)) / 12)
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var DEFAULT_GETINFO_CONFIG$1 = {
      path: "",
      retryCount: 3,
      test: 0,
      timeout: 6e3,
      ckeyVer: "",
      keepAdReqWithCustomPath: !1,
    },
    i$1 = b$a;
  !(function (e, t) {
    for (var o = b$a, A = a$a(); ; )
      try {
        if (
          119017 ==
          (-parseInt(o(293)) / 1) * (parseInt(o(279)) / 2) +
            (-parseInt(o(290)) / 3) * (-parseInt(o(265)) / 4) +
            (parseInt(o(309)) / 5) * (-parseInt(o(287)) / 6) +
            parseInt(o(260)) / 7 +
            -parseInt(o(261)) / 8 +
            parseInt(o(273)) / 9 +
            parseInt(o(303)) / 10
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var PATH = { COMMON: [i$1(295), i$1(304), i$1(269)], TEST: i$1(305) },
    VOD_GET_INFO_DATA_KEYS;
  !(function (e) {
    var t = i$1;
    (e[t(276)] = t(306)),
      (e[t(271)] = t(285)),
      (e[t(298)] = t(275)),
      (e[t(258)] = t(312)),
      (e[t(302)] = t(299)),
      (e[t(292)] = t(297)),
      (e[t(262)] = t(311)),
      (e[t(294)] = t(313)),
      (e[t(257)] = t(281)),
      (e[t(283)] = t(259)),
      (e[t(307)] = t(270));
  })(VOD_GET_INFO_DATA_KEYS || (VOD_GET_INFO_DATA_KEYS = {}));
  var URL_EXPIRE_TIME = 72e5;
  function a$a() {
    var e = [
      "DM9KlwDLDgLUzM86y2DPBMfTzq",
      "DM9KlwDLDgLUzM86DMLWvg9Rzw4",
      "DM9KlwDLDgLUzM86y2TLExrPBwu",
      "rg9SyNLwAxnPB24",
      "y2TLEwrN",
      "DMLWvg9Rzw4",
      "DM9KlwDLDgLUzM86DNvYBa",
      "nZKWndeYteLOBvvZ",
      "mty0ntuZnLzwDMfhCG",
      "y2DPBMfTzq",
      "vLzdke8YnJyP",
      "u0zsnfHFserskdeYmezquYK",
      "otq2nZzitwDhtue",
      "u0zsx0HeuIG2mezquYK",
      "u0zsm1HFserskdKWrLbtkq",
      "u0rs",
      "Ahr0Chm6lY9HDI52AwrLBY5XCs5JB20Vz2v0DMLUzM8",
      "DM9KlwDLDgLUzM86CgfYC2vdB3n0vgLTzq",
      "DMLKzw9dAgfYz2vK",
      "sdi2na",
      "nte4ntK4vhnku3rX",
      "vdi2nq",
      "DM9KlwDLDgLUzM86DxnLCLbHEvr5Cgu",
      "DMLKzw9uExbL",
      "u0zsx1rjrv9wmIG2mezquYK",
      "u0zsm1HFveLfx1yYkdKWrLbtkq",
      "mJC4nZi2qK96zKXm",
      "u0rskW",
      "DM9KlwDLDgLUzM86y2TLEwrN",
      "qvztmW",
      "DNvYBa",
      "su1HEa",
      "DM9KlwDLDgLUzM86DMLKzw9dAgfYz2vK",
      "sdi2nq",
      "ndyZmMrIve5wAq",
      "tM9UzsHbDwrPBYbpBMX5kq",
      "vKfwmq",
      "mJfpuhfgs2y",
      "tZi2na",
      "y2TLEvzLCNnPB24",
      "mwvgt29OvW",
      "y2TLExrPBwu",
      "Ahr0Chm6lY9Onxz2nI52AwrLBY5XCs5JB20Vz2v0DMLUzM8",
      "sersmta",
      "DM9KlwDLDgLUzM86y2TLEvzLCNnPB24",
      "DxnLCLbHEvr5Cgu",
      "DM9KlwDLDgLUzM86y2TLEq",
      "veLfx1yY",
      "qvyX",
      "y2TLEq",
      "mJi2nJy3mePlB0PezG",
      "Ahr0Chm6lY9IA2G1DNyUDMLKzw8UCxeUy29Tl2DLDhzPBMzV",
      "Ahr0Chm6lY90zxn0DNyUDMLKzw8UCxeUy29Tl2DLDgG1Aw5MBZ8",
      "DM9KlwDLDgLUzM86DMLKzw9uExbL",
      "CgfYC2vdB3n0vgLTzq",
      "q1vwqs1irfi",
      "nJqWrgnsrfjN",
      "u0zsnfHFveLfx1yYkdeYmezquYK",
    ];
    return (a$a = function () {
      return e;
    })();
  }
  function b$a(e, t) {
    var o = a$a();
    return (
      (b$a = function (t, A) {
        var i = o[(t -= 257)];
        if (void 0 === b$a.XfnhgJ) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b$a.dMVSuu = r), (e = arguments), (b$a.XfnhgJ = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b$a.dMVSuu(i)), (e[a] = i)), i;
      }),
      b$a(e, t)
    );
  }
  var VideoType$1 = {
    1: i$1(272),
    2: i$1(286),
    3: i$1(296),
    4: i$1(314),
    5: i$1(288),
    6: i$1(280),
    7: i$1(268),
    8: i$1(274),
    9: i$1(284),
    10: i$1(266),
    11: i$1(264),
    12: i$1(267),
    13: i$1(282),
    14: i$1(301),
    15: i$1(300),
    16: i$1(277),
    17: i$1(278),
    18: i$1(310),
    19: i$1(308),
    20: i$1(263),
    21: i$1(291),
    26: i$1(289),
  };
  function a$9() {
    var e = [
      "nZy5nte1t29cwMDJ",
      "mtC1mdiZmuHzve5sAW",
      "CMvZrgf0yq",
      "rvjst1jFr0vusu5gt19usu1ft1vu",
      "mZu4nta0CvD1t1nW",
      "y29Kzq",
      "mJKWmJvUvvHizwS",
      "ihjLCxvLC3qGzxjYlcbTC2C9",
      "zw5KvgLTzq",
      "mJiWELPHuM5q",
      "CMvXugfYyw1Z",
      "C3rHCNq",
      "DgHYB3C",
      "r0vusu5gt19orvq",
      "y29UzMLN",
      "q09ntu9o",
      "ywXYzwfKEvjLDhj5q291BNq",
      "mtC1mKH5tKXKDG",
      "rvjst1jFr0vusu5gt19orvq",
      "vevtva",
      "BwvZC2fNzq",
      "zxHLBq",
      "m0H2t2f0BW",
      "DxbKyxrL",
      "mZblseDqwuq",
      "muDYDgfNua",
      "DgLTzw91Da",
      "y2fJAgu",
      "ANnVBNaGDgLTzw91Da",
      "CMvXugf0Aa",
      "C3rYAw5N",
      "Dhj5CW",
      "DgvZDa",
      "C2vUzcbZDgfYDa",
      "DgHLia",
      "Bg9Nz2vY",
      "y3vYvgLTzq",
      "AdvWBgf5zxi",
      "y29Uy2f0",
      "r0vusu5gt19usu1ft1vu",
      "mJGYnhfRD1fcDq",
      "CgXHEwvYsw5ZDgfUy2vjza",
      "ChvZAa",
      "BgfIzwW",
      "mJyYnda0ohLfruzlsG",
      "CMvXDwvZDgLUzY4UlG",
      "CMvXDwvZDg9Y",
      "ntyZodq5uNL2Eu9i",
      "BgvUz3rO",
      "uKvtx01preLgwq",
      "CMv0CNLdB3vUDa",
      "C2vUDa",
      "C2vUzcbVDMvY",
      "mJi0mdGXrfnwwMfU",
      "y2fSBa",
      "Cgf0Aa",
      "zw5K",
      "CMvZCg9UC2vnB2rPzMLLCG",
      "Bg9N",
    ];
    return (a$9 = function () {
      return e;
    })();
  }
  function b$9(e, t) {
    var o = a$9();
    return (
      (b$9 = function (t, A) {
        var i = o[(t -= 350)];
        if (void 0 === b$9.uxPxLZ) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b$9.bDAZYq = r), (e = arguments), (b$9.uxPxLZ = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b$9.bDAZYq(i)), (e[a] = i)), i;
      }),
      b$9(e, t)
    );
  }
  function getRequestUrl$1(e, t) {
    var o = b$9,
      A = e[o(390)],
      i = e[o(354)];
    if (A) return PATH[o(377)];
    var r = i || PATH[o(373)];
    return typeof r === o(388) ? r : r[t % r[o(406)]];
  }
  !(function (e, t) {
    for (var o = b$9, A = a$9(); ; )
      try {
        if (
          646501 ==
          (-parseInt(o(383)) / 1) * (-parseInt(o(362)) / 2) +
            (-parseInt(o(380)) / 3) * (parseInt(o(402)) / 4) +
            -parseInt(o(358)) / 5 +
            (-parseInt(o(382)) / 6) * (parseInt(o(359)) / 7) +
            (parseInt(o(398)) / 8) * (parseInt(o(364)) / 9) +
            (-parseInt(o(367)) / 10) * (parseInt(o(405)) / 11) +
            (parseInt(o(375)) / 12) * (parseInt(o(352)) / 13)
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var sendRequestMiddleWare$1 = function (e, t) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var o, A, i, r, n, a, s, g, l, E, c, u, p, d, B, h, I, C, _, f, y, m;
      return __generator$1(this, function (v) {
        var Q = b$9;
        switch (v[Q(401)]) {
          case 0:
            e[Q(393)][Q(357)](Q(391)),
              (o = e[Q(404)]),
              (A = e[Q(372)]),
              (i = A[Q(408)]),
              (r = void 0 === i ? 3 : i),
              (n = A[Q(384)]),
              (a = void 0 === n ? DEFAULT_GETINFO_CONFIG$1[Q(384)] : n),
              (s = null),
              (g = 0),
              (l = !1),
              (v[Q(401)] = 1);
          case 1:
            if (!(g <= r)) return [3, 12];
            e[Q(393)][Q(357)](Q(403)), (e[Q(374)] = g), (v[Q(401)] = 2);
          case 2:
            return (
              v[Q(389)][Q(400)]([2, 9, , 11]),
              (s = null),
              (e[Q(387)] = getRequestUrl$1(A, g)),
              (c = e[Q(360)]) ? [3, 4] : [4, o[Q(369)](e[Q(387)], e[Q(368)], a)]
            );
          case 3:
            (c = v[Q(350)]()), (v[Q(401)] = 4);
          case 4:
            return (
              (E = c),
              StepTimer[Q(369)](TvkStepKey[Q(407)], e[Q(399)]),
              (u = e),
              [
                4,
                null === (y = A[Q(356)]) || void 0 === y
                  ? void 0
                  : y[Q(353)](A, E),
              ]
            );
          case 5:
            return (
              (u[Q(360)] = null !== (m = v[Q(350)]()) && void 0 !== m ? m : E),
              StepTimer[Q(355)](TvkStepKey[Q(407)], e[Q(399)]),
              e[Q(360)]
                ? 85 != +e[Q(360)].em || -3 != +e[Q(360)][Q(379)] || l
                  ? [3, 7]
                  : ((p = e[Q(360)][Q(394)]),
                    (e[Q(360)] = void 0),
                    [4, new UpdateReqParams(e)[Q(381)](p)])
                : [3, 8]
            );
          case 6:
            return v[Q(350)](), (l = !0), [3, 1];
          case 7:
            return [3, 12];
          case 8:
            return [3, 11];
          case 9:
            return (
              (d = v[Q(350)]()),
              (B = null == d ? void 0 : d[Q(378)]),
              (h = null == d ? void 0 : d[Q(363)]),
              e[Q(393)][Q(357)](Q(392)[Q(396)](g, Q(365))[Q(396)](B)),
              B === Q(386)
                ? (s = {
                    code: exports.ErrorCode[Q(397)],
                    message: compile(i18nConfig[Q(395)][Q(361)]),
                  })
                : h && (s = { code: h, message: B }),
              (e[Q(360)] = void 0),
              [4, new UpdateReqParams(e)[Q(381)]()]
            );
          case 10:
            return v[Q(350)](), [3, 11];
          case 11:
            return (g += 1), [3, 1];
          case 12:
            if (((e[Q(366)] = +new Date()), !e[Q(360)]))
              return (
                e[Q(370)](
                  (null == s ? void 0 : s[Q(363)]) || exports.ErrorCode[Q(371)],
                  (null == s ? void 0 : s[Q(378)]) ||
                    compile(i18nConfig[Q(395)][Q(376)])
                ),
                [2]
              );
            try {
              (I = e[Q(360)]),
                (C = I.fl),
                (_ = I.vl),
                (f = __rest(I, ["fl", "vl"])),
                e[Q(393)][Q(385)](Q(351), f),
                e[Q(393)][Q(385)](Q(351), C),
                e[Q(393)][Q(385)](Q(351), _);
            } catch (e) {}
            return [4, t()];
          case 13:
            return v[Q(350)](), [2];
        }
      });
    });
  };
  function a$8() {
    var e = [
      "ChjLDMLLDW",
      "mtu4mtG0y1rTEvDv",
      "rvjst1jFr0vusu5gt19dt0rf",
      "C2vUDa",
      "mtqXnZjQBuflvey",
      "y29Uy2f0",
      "CMvZrgf0yq",
      "rvjst1jFr0vusu5gt19qqvjtrq",
      "r0vusu5gt19qqvjtrq",
      "mZKZrMXlqMnL",
      "ndK2nZGYngPpEvrLCG",
      "C2XPy2u",
      "mtq1ogXvzgPOAG",
      "DgHYB3C",
      "AdvWBgf5zxi",
      "mtmYnZLXrwDHqvC",
      "mZy2mJa5EK1MqK9A",
      "BgfIzwW",
      "zxHLBq",
      "Dw5KzwzPBMvK",
      "mdaW",
      "mZi2mJGZmhrIywrbua",
      "nJKWmdyWnLrsq2L4qW",
      "BxnN",
      "r0vusu5gt19trvjwrvjFq09erv9quKvgsvG",
    ];
    return (a$8 = function () {
      return e;
    })();
  }
  function b$8(e, t) {
    var o = a$8();
    return (
      (b$8 = function (t, A) {
        var i = o[(t -= 314)];
        if (void 0 === b$8.ppMJGt) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b$8.SJaLmI = r), (e = arguments), (b$8.ppMJGt = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b$8.SJaLmI(i)), (e[a] = i)), i;
      }),
      b$8(e, t)
    );
  }
  !(function (e, t) {
    for (var o = b$8, A = a$8(); ; )
      try {
        if (
          451191 ==
          -parseInt(o(323)) / 1 +
            parseInt(o(333)) / 2 +
            (-parseInt(o(316)) / 3) * (-parseInt(o(336)) / 4) +
            -parseInt(o(328)) / 5 +
            (-parseInt(o(319)) / 6) * (parseInt(o(322)) / 7) +
            parseInt(o(317)) / 8 +
            parseInt(o(329)) / 9
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var checkResponseMiddleWare$1 = function (e, t) {
      return __awaiter$1(void 0, void 0, void 0, function () {
        var o, A, i, r, n, a, s;
        return __generator$1(this, function (g) {
          var l = b$8;
          switch (g[l(324)]) {
            case 0:
              return (
                (o = e[l(338)]),
                (i =
                  typeof (A = void 0 === o ? {} : o).em === l(326) ? 0 : +A.em),
                (r = +A[l(325)]),
                (n = ((null === (s = A.vl) || void 0 === s ? void 0 : s.vi) ||
                  [])[0]),
                0 === i &&
                  n &&
                  (8 === n.st || (!isNaN(r) && 0 !== r)) &&
                  0 == +A[l(332)] &&
                  (i = 83),
                0 !== i
                  ? ((a = ""
                      [l(337)](exports.ErrorCode[l(331)])
                      [l(337)](l(327)[l(337)](i)[l(318)](-3))
                      [l(337)](isNaN(r) ? "" : "."[l(337)](r))),
                    e[l(320)](
                      a,
                      A[l(330)] || compile(i18nConfig[l(321)][l(334)])
                    ),
                    [2])
                  : "o" === A.s && n
                  ? [4, t()]
                  : (e[l(320)](
                      exports.ErrorCode[l(315)],
                      compile(i18nConfig[l(321)][l(314)])
                    ),
                    [2])
              );
            case 1:
              return g[l(335)](), [2];
          }
        });
      });
    },
    AdInfoOpType;
  function commonSelectKernel(e) {
    var t = e.codec,
      o = e.dltype,
      A = e.drm,
      i = void 0;
    return (
      t === CODEC.H265
        ? videoTool$1.supportHevc()
          ? 1 === o
            ? (i = exports.KERNEL_NAME.ORIGIN)
            : (3 !== o && 8 !== o) || (i = exports.KERNEL_NAME.HLS_JS)
          : (i = exports.KERNEL_NAME.WASM)
        : 1 === o
        ? (i = exports.KERNEL_NAME.ORIGIN)
        : 8 === o && (i = exports.KERNEL_NAME.HLS_JS),
      A === DRM_CODE_FROM_VINFO.WIDEVINE
        ? (i = exports.KERNEL_NAME.HLS_JS)
        : A === DRM_CODE_FROM_VINFO.FAIRPLAY
        ? (i = exports.KERNEL_NAME.ORIGIN)
        : A === DRM_CODE_FROM_VINFO.CHACHA20 &&
          t === CODEC.H264 &&
          (i = exports.KERNEL_NAME.HLS_JS),
      i
    );
  }
  function b$7(e, t) {
    var o = a$7();
    return (
      (b$7 = function (t, A) {
        var i = o[(t -= 359)];
        if (void 0 === b$7.TFAqLx) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b$7.MPAmmZ = r), (e = arguments), (b$7.TFAqLx = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b$7.MPAmmZ(i)), (e[a] = i)), i;
      }),
      b$7(e, t)
    );
  }
  function getHlsUrls(e) {
    var t = b$7;
    return e.vl.vi[0].ul.ui[t(390)](function (e) {
      var o,
        A = t;
      return e[A(409)] &&
        (null === (o = e[A(395)]) || void 0 === o ? void 0 : o.pt)
        ? { url: e[A(409)] + e[A(395)].pt, vt: e.vt }
        : { url: e[A(409)], vt: e.vt };
    });
  }
  function getM3U8Proxy(e) {
    var t,
      o,
      A = b$7,
      i = e[A(399)];
    return [
      {
        url:
          null !==
            (o = null === (t = i[A(382)]) || void 0 === t ? void 0 : t[0]) &&
          void 0 !== o
            ? o
            : A(406)[A(379)](i[A(373)], A(411)),
        vt: e.vl.vi[0].ul.ui[0].vt,
      },
    ];
  }
  function getMp4Url(e, t, o, A, i, r) {
    for (var n, a, s = b$7, g = [], l = e.ui[s(362)], E = 0; E < l; E++)
      (a = { url: "", vt: 0 }),
        (n = e.ui[E])[s(409)] &&
          (n[s(409)] &&
          -1 === n[s(409)][s(367)](""[s(379)](t, s(394))) &&
          -1 === n[s(409)][s(367)](""[s(379)](t, s(369)))
            ? (a[s(409)] = n[s(409)] + o)
            : (a[s(409)] = n[s(409)]),
          n.vt && (a.vt = parseInt(n.vt, 10)),
          -1 === a[s(409)][s(367)](s(407)) &&
            (a[s(409)][s(367)]("?") > -1
              ? (a[s(409)] += s(414)[s(379)](i))
              : (a[s(409)] += s(417)[s(379)](i)),
            (a[s(409)] += s(380)[s(379)](r, s(419))[s(379)](A))),
          g[s(420)](a));
    return g;
  }
  function getUrls(e, t, o) {
    var A,
      i,
      r,
      n,
      a,
      s,
      g,
      l,
      E = b$7;
    if (
      !(
        e &&
        (null ===
          (r =
            null ===
              (i = null === (A = e.vl) || void 0 === A ? void 0 : A.vi[0].ul) ||
            void 0 === i
              ? void 0
              : i.ui) || void 0 === r
          ? void 0
          : r[E(362)]) > 0
      )
    )
      return { urls: [], setLevelMode: SET_LEVEL_MODE[E(385)] };
    var c = e[E(374)],
      u = (null === (n = e.vl) || void 0 === n ? void 0 : n.vi)[0],
      p = u.fn,
      d = u[E(370)],
      B = u[E(373)];
    if (3 === c || 8 === c) {
      if (e[E(399)])
        return { urls: getM3U8Proxy(e), setLevelMode: SET_LEVEL_MODE[E(385)] };
      var h = getHlsUrls(e),
        I = !1;
      if (8 === c) {
        var C = e.vl.vi[0].ul[E(416)];
        C &&
          !(C[E(367)](E(403)) > 0 || C[E(367)](E(421)) > 0) &&
          ((I = !0),
          h[E(393)]({ url: E(406)[E(379)](B, E(411)), vt: h[0].vt }));
      }
      return {
        urls: h,
        setLevelMode: I ? SET_LEVEL_MODE[E(385)] : SET_LEVEL_MODE[E(365)],
      };
    }
    if (1 === c) {
      var _ =
          (null === (s = null === (a = u.cl) || void 0 === a ? void 0 : a.ci) ||
          void 0 === s
            ? void 0
            : s[E(362)]) || 0,
        f =
          u[E(370)] &&
          u.fn &&
          (null === (l = null === (g = u.ul) || void 0 === g ? void 0 : g.ui) ||
          void 0 === l
            ? void 0
            : l[E(362)]) > 0;
      if (_ <= 0 && f)
        return {
          urls: getMp4Url(u.ul, u[E(405)], p, d, t, o),
          setLevelMode: SET_LEVEL_MODE[E(385)],
        };
    }
    return { urls: [], setLevelMode: SET_LEVEL_MODE[E(385)] };
  }
  function getAudioTrackInfo(e) {
    var t,
      o,
      A,
      i = b$7,
      r = [];
    if (!e) return r;
    var n = e.al,
      a = e.vl,
      s = !1;
    null === (t = null == n ? void 0 : n.ai) ||
      void 0 === t ||
      t[i(401)](function (e) {
        var t = i,
          o = e[t(373)],
          A = e.sl,
          n = e[t(408)],
          a = e.ul,
          g = e[t(396)];
        A && (s = !0),
          r[t(420)]({
            id: o,
            selected: !!A,
            url: a.ui[0][t(409)],
            name: n,
            displayName: g,
          });
      });
    var g =
      null ===
        (A =
          null === (o = null == a ? void 0 : a.vi) || void 0 === o
            ? void 0
            : o[0]) || void 0 === A
        ? void 0
        : A.ai;
    if (g) {
      var l = g[i(408)],
        E = g[i(396)];
      r[i(420)]({ id: -1, selected: !s, url: "", name: l, displayName: E });
    }
    return r;
  }
  function getDrm(e) {
    var t,
      o = b$7,
      A = ((null === (t = null == e ? void 0 : e.fl) || void 0 === t
        ? void 0
        : t.fi) || [])[o(418)](function (e) {
        return 1 == +e.sl;
      });
    return A ? +A[o(363)] : 0;
  }
  function getPreview(e) {
    var t,
      o,
      A = b$7;
    if (!e) return { duration: 0, start: 0 };
    var i = (null === (t = e.vl) || void 0 === t ? void 0 : t.vi)[0],
      r = +e.em,
      n = +e[A(398)],
      a = +e[A(372)],
      s = +(null !== (o = e[A(377)]) && void 0 !== o ? o : 0);
    return isNaN(r) || 0 !== r || 0 === a
      ? { duration: 0, start: 0 }
      : n > 0 || 8 == +i.st
      ? { duration: a, start: s }
      : { duration: 0, start: 0 };
  }
  function parseCodecInfo$1(e) {
    var t,
      o,
      A,
      i = b$7,
      r = CODEC[i(389)],
      n = ((null === (t = null == e ? void 0 : e.vl) || void 0 === t
        ? void 0
        : t.vi) || [])[0],
      a =
        null ===
          (A =
            null === (o = null == e ? void 0 : e.fl) || void 0 === o
              ? void 0
              : o.fi) || void 0 === A
          ? void 0
          : A[i(418)](function (e) {
              return 1 === e.sl;
            }),
      s = null == a ? void 0 : a[i(364)];
    return (
      n && 1 === n[i(415)] && (r = CODEC[i(371)]),
      { vtypeKey: s, vtype: VideoType$1[s] || i(410), codec: r }
    );
  }
  function selectKernel$1(e, t) {
    var o,
      A,
      i = b$7,
      r = (e || {})[i(374)],
      n =
        null ===
          (A =
            null === (o = null == e ? void 0 : e.fl) || void 0 === o
              ? void 0
              : o.fi) || void 0 === A
          ? void 0
          : A[i(418)](function (e) {
              return 1 === e.sl;
            });
    return commonSelectKernel({
      codec: (t || {})[i(397)],
      dltype: r,
      drm: null == n ? void 0 : n[i(363)],
    });
  }
  function parseGetinfoHlsAdRanges$1(e) {
    var t,
      o,
      A = b$7,
      i = [];
    if (!(null == e ? void 0 : e[A(360)])) return i;
    try {
      null ===
        (o =
          null === (t = JSON[A(375)](e[A(360)])) || void 0 === t
            ? void 0
            : t[A(402)]) ||
        void 0 === o ||
        o[A(401)](function (e) {
          var t = A;
          +e[t(384)] === AdInfoOpType[t(413)] &&
            i[t(420)]({
              start: e[t(381)] / 1e3,
              end: e[t(388)] / 1e3,
              type: +e[t(384)],
            });
        });
    } catch (e) {}
    return (
      i[A(387)](function (e, t) {
        var o = A;
        return e[o(392)] - t[o(392)];
      }),
      i
    );
  }
  function a$7() {
    var e = [
      "C2r0zNjVBq",
      "DhjHy2S",
      "DxjS",
      "Dw5RBM93BG",
      "lM0ZDtG",
      "mJm3mJK0nfHRD0XZAG",
      "ueHmuW",
      "jNnKDgzYB209",
      "Agv2yW",
      "Btn1oa",
      "p3nKDgzYB209",
      "zMLUza",
      "jNzRzxK9",
      "ChvZAa",
      "rvHulvGTvefsr0vurfvsqvrjt046",
      "mtqYotK0mZbTtND0rg4",
      "mJmXy1PgALrT",
      "ywrWAw5MBW",
      "owjHuMjpAW",
      "BgvUz3rO",
      "zhjT",
      "DMLKzw8",
      "u01pt1ri",
      "ntK4mefzz3PRAW",
      "Aw5KzxHpzG",
      "ndyWnZjXBfrOq2G",
      "lM1Wna",
      "zNzRzxK",
      "sdi2nq",
      "ChjLDMLLDW",
      "A2v5Awq",
      "zgX0ExbL",
      "CgfYC2u",
      "odC0ntiWywTtvNnh",
      "C3rHCNrWCMv2Awv3",
      "ody0odfvD2z4BLK",
      "y29Uy2f0",
      "jMD1Awq9",
      "ywrFDgLTzv9IzwDPBG",
      "BwfZDgvYDxjS",
      "BgfZDeLUzgv4t2y",
      "B3b0ExbL",
      "sefsra",
      "mtK3Dfb3uuvy",
      "C29YDa",
      "ywrFDgLTzv9LBMq",
      "sdi2na",
      "BwfW",
      "C3vIC3rYAw5N",
      "C3rHCNq",
      "Dw5ZAgLMDa",
      "lMzSDG",
      "AgXZ",
      "BMfTzq",
      "y29Kzwm",
      "zxHLBq",
      "CgXHEq",
      "C3vIC3rY",
      "zM9YrwfJAa",
      "yxnZzxrPzf9PBMzV",
      "i0vyveLorJO",
      "odmWotuYAxDrDvjP",
      "Bg5R",
      "A2v5Awq6lY8",
    ];
    return (a$7 = function () {
      return e;
    })();
  }
  !(function (e, t) {
    for (var o = b$7, A = a$7(); ; )
      try {
        if (
          342199 ==
          (parseInt(o(386)) / 1) * (-parseInt(o(366)) / 2) +
            -parseInt(o(378)) / 3 +
            -parseInt(o(412)) / 4 +
            parseInt(o(376)) / 5 +
            parseInt(o(404)) / 6 +
            (-parseInt(o(359)) / 7) * (parseInt(o(368)) / 8) +
            (parseInt(o(361)) / 9) * (parseInt(o(422)) / 10)
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })(),
    (function (e) {
      var t = b$7;
      e[(e[t(413)] = 2)] = t(413);
    })(AdInfoOpType || (AdInfoOpType = {}));
  var J = b$6;
  function a$6() {
    var e = [
      "z3vPza",
      "C2r0zNjVBq",
      "BM93",
      "CMvXugfYyw1Z",
      "C3rHCNq",
      "zgvMAw5PDgLVBKXPC3q",
      "DNr5Cgu",
      "C2v0tgv2zwXnB2rL",
      "mJq2oda0wxnjrNDK",
      "nduZmJa4EvH1u1ri",
      "ow16BvblAq",
      "zxH0CMfqBgf5q29UzMLN",
      "DxjSCW",
      "CMv2zxjZzq",
      "C2zS",
      "CgfYC2veyxrH",
      "mte2mJiZnMzXBLj0vq",
      "mJi0nda0mfDJCg9ZvG",
      "DNr5CgvlzxK",
      "CMvZrgf0yq",
      "zhvYyxrPB24",
      "mZi0mdGYq1z0u0Xn",
      "CgXHEwvYsw5ZDgfUy2vjza",
      "zgvZAwDUoNjLDhvYBNr5Cgu",
      "odu4otHiELLvEMG",
      "y3r4",
      "ChjVDg90ExbL",
      "ndyZoty1y0PyuNfb",
      "zgvMAw5LuhjVCgvYDhK",
      "zgvZAwDUoNbHCMfTDhLWzxm",
      "ugfYC2vszxnWB25Zzq",
      "C2vUDa",
      "CgfYC2vdB3n0vgLTzq",
      "zgvZAwDUoNr5Cgu",
      "zw5K",
      "y29Kzwm",
      "uKvtx1bbuLnf",
      "BgfIzwW",
    ];
    return (a$6 = function () {
      return e;
    })();
  }
  function b$6(e, t) {
    var o = a$6();
    return (
      (b$6 = function (t, A) {
        var i = o[(t -= 210)];
        if (void 0 === b$6.BkZdvS) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b$6.MHMZrR = r), (e = arguments), (b$6.BkZdvS = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b$6.MHMZrR(i)), (e[a] = i)), i;
      }),
      b$6(e, t)
    );
  }
  !(function (e, t) {
    for (var o = b$6, A = a$6(); ; )
      try {
        if (
          197956 ==
          parseInt(o(224)) / 1 +
            (parseInt(o(227)) / 2) * (parseInt(o(213)) / 3) +
            parseInt(o(211)) / 4 +
            parseInt(o(230)) / 5 +
            -parseInt(o(219)) / 6 +
            parseInt(o(212)) / 7 +
            -parseInt(o(220)) / 8
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var performanceCost$1 = performanceCostDecoratorCreator(J(233)),
    ParseResponse = (function () {
      var e = J;
      function t(e) {
        this[b$6(228)] = e;
      }
      return (
        Object[e(231)](t[e(229)], e(225), {
          get: function () {
            var t,
              o = e;
            return null === (t = this[o(228)]) || void 0 === t
              ? void 0
              : t[o(225)];
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t[e(229)][e(245)] = function () {
          var t,
            o,
            A,
            i,
            r,
            n,
            a,
            s = e;
          StepTimer[s(245)](TvkStepKey[s(239)], this[s(225)]);
          var g = performance[s(243)](),
            l = this[s(228)],
            E = l[s(222)],
            c = void 0 === E ? {} : E,
            u = l[s(244)],
            p = void 0 === u ? {} : u,
            d = (null === (t = c.vl) || void 0 === t ? void 0 : t.vi)[0],
            B = d.td,
            h = d.ti,
            I = d.vh,
            C = d.vw,
            _ = d.br,
            f = d.fs,
            y = getUrls(c, p[s(242)], p[s(241)]),
            m = y[s(215)],
            v = y[s(210)],
            Q = parseCodecInfo$1(c),
            T = Q[s(238)],
            S = Q[s(247)],
            D = Q[s(221)],
            R = getDrm(c),
            O = getPreview(c),
            F = O[s(223)],
            N = O[s(245)];
          (null !== (o = (a = this[s(228)])[s(214)]) && void 0 !== o) ||
            (a[s(214)] = {}),
            (this[s(228)][s(214)][s(210)] = v),
            (this[s(228)][s(218)] = {
              drmType: R,
              codec: T,
              vtype: S,
              vtypeKey: D,
              preview: F,
              previewRemainCount: 0,
              vitem: d,
              duration: B,
              title: h,
              byteRate: _,
              videoHeight: I,
              videoWidth: C,
              fileSize: f,
              urls: m,
              definitionList:
                null === (A = c.fl) || void 0 === A ? void 0 : A.fi,
              subtitleList:
                null === (i = c[s(217)]) || void 0 === i ? void 0 : i.fi,
              watermarkList: d.wl,
              previewList: d.pl
                ? null === (r = d.pl[0]) || void 0 === r
                  ? void 0
                  : r.pd
                : [],
              additionalTrackInfo: {
                subtitleTrack: [],
                altAudioTrack: getAudioTrackInfo(c),
              },
              supplementaryInfo: {
                contentInfo: {
                  ad: parseGetinfoHlsAdRanges$1(d.ad),
                  preview: F,
                  previewStartPosition: N,
                },
              },
            }),
            null === (n = this[s(228)][s(218)][s(246)]) ||
              void 0 === n ||
              n[s(216)](),
            (this[s(228)][s(235)] = performance[s(243)]() - g),
            StepTimer[s(237)](TvkStepKey[s(239)], this[s(225)]);
        }),
        __decorate(
          [
            performanceCost$1,
            __metadata(e(236), Function),
            __metadata(e(232), []),
            __metadata(e(226), void 0),
          ],
          t[e(229)],
          e(245),
          null
        ),
        t
      );
    })(),
    parseResponseMiddleWare$1 = function (e, t) {
      return __awaiter$1(void 0, void 0, void 0, function () {
        return __generator$1(this, function (o) {
          var A = b$6;
          switch (o[A(240)]) {
            case 0:
              return new ParseResponse(e)[A(245)](), [4, t()];
            case 1:
              return o[A(234)](), [2];
          }
        });
      });
    },
    M = b$5;
  function b$5(e, t) {
    var o = a$5();
    return (
      (b$5 = function (t, A) {
        var i = o[(t -= 322)];
        if (void 0 === b$5.wtckLh) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b$5.cnzkWH = r), (e = arguments), (b$5.wtckLh = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b$5.cnzkWH(i)), (e[a] = i)), i;
      }),
      b$5(e, t)
    );
  }
  !(function (e, t) {
    for (var o = b$5, A = a$5(); ; )
      try {
        if (
          609761 ==
          parseInt(o(454)) / 1 +
            (parseInt(o(413)) / 2) * (parseInt(o(345)) / 3) +
            (parseInt(o(414)) / 4) * (parseInt(o(434)) / 5) +
            -parseInt(o(396)) / 6 +
            (parseInt(o(325)) / 7) * (-parseInt(o(343)) / 8) +
            parseInt(o(383)) / 9 +
            parseInt(o(348)) / 10
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var performanceCost$3 = performanceCostDecoratorCreator(M(395)),
    VodGetinfoReq = (function () {
      var e = M;
      function t(e, t) {
        var o = b$5;
        (this[o(400)] = !1),
          (this[o(341)] = 0),
          (this[o(417)] = {}),
          (this[o(455)] =
            (null == t ? void 0 : t[o(455)]) ||
            function () {
              return "";
            }),
          (this[o(415)] = e),
          (this[o(419)] = new Logger(e[o(460)], o(375)));
      }
      return (
        Object[e(452)](t[e(410)], e(344), {
          get: function () {
            var t = e;
            return __assign$1(
              __assign$1({}, DEFAULT_GETINFO_CONFIG$1),
              this[t(415)][t(428)]
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object[e(452)](t[e(410)], e(425), {
          get: function () {
            var t,
              o = e;
            return null === (t = this[o(415)]) || void 0 === t
              ? void 0
              : t[o(460)];
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t[e(410)][e(331)] = function (t, o) {
          var A = e,
            i = this,
            r = this[A(447)](t, o);
          return compose([this[A(344)][A(421)] || prepareRequestMiddleWare])(r)
            [A(324)](function () {
              return i[A(429)](r, !0);
            })
            [A(444)](function (e) {
              return i[A(431)](r, e);
            });
        }),
        (t[e(410)][e(401)] = function (e, t, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (A) {
              var i = b$5;
              return (
                t ? this[i(437)](e, t, o) : (this[i(417)][e] = void 0), [2]
              );
            });
          });
        }),
        (t[e(410)][e(437)] = function (e, t, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            var A,
              i,
              r,
              n,
              a = this;
            return __generator$1(this, function (s) {
              var g = b$5;
              return (
                o
                  ? ((this[g(341)] += 1), (o[g(341)] = this[g(341)]), (A = o))
                  : (A = this[g(447)](e)),
                (A[g(376)] = t),
                (i = this[g(344)][g(408)] || sendRequestMiddleWare$1),
                (r = this[g(344)][g(355)] || checkResponseMiddleWare$1),
                (n = this[g(344)][g(459)] || parseResponseMiddleWare$1),
                (this[g(417)][e] = compose([i, r, n])(A)
                  [g(324)](function () {
                    return a[g(429)](A);
                  })
                  [g(444)](function (e) {
                    return a[g(431)](A, e);
                  })),
                [2]
              );
            });
          });
        }),
        (t[e(410)][e(458)] = function (e, t, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (e) {
              return [2];
            });
          });
        }),
        (t[e(410)][e(366)] = function (e, t, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            var A,
              i,
              r,
              n,
              a,
              s,
              g,
              l,
              E = this;
            return __generator$1(this, function (c) {
              var u = b$5;
              switch (c[u(420)]) {
                case 0:
                  return (
                    (A = e),
                    (this[u(400)] = !1),
                    this[u(417)][A] ? [4, this[u(417)][A]] : [3, 2]
                  );
                case 1:
                  return (
                    (i = c[u(406)]()),
                    (this[u(417)][A] = void 0),
                    [2, Promise[u(436)](i)]
                  );
                case 2:
                  return (
                    (r = this[u(447)](A, t)),
                    (n = this[u(416)](r[u(330)]))
                      ? ((r[u(373)] = {
                          code: exports.ErrorCode[u(358)],
                          message: compile(i18nConfig[u(351)][u(354)], n),
                        }),
                        [2, Promise[u(436)](this[u(356)](r))])
                      : ((a = this[u(344)][u(421)] || prepareRequestMiddleWare),
                        (s = this[u(344)][u(408)] || sendRequestMiddleWare$1),
                        (g = this[u(344)][u(355)] || checkResponseMiddleWare$1),
                        (l = this[u(344)][u(459)] || parseResponseMiddleWare$1),
                        [
                          2,
                          compose(
                            (null == o ? void 0 : o[u(384)]) ? o : [a, s, g, l]
                          )(r)
                            [u(324)](function () {
                              return E[u(429)](r);
                            })
                            [u(444)](function (e) {
                              return E[u(431)](r, e);
                            }),
                        ])
                  );
              }
            });
          });
        }),
        (t[e(410)][e(369)] = function () {
          this[e(400)] = !0;
        }),
        (t[e(410)][e(449)] = function () {
          var t = e;
          this[t(369)](), (this[t(417)] = null), (this[t(455)] = null);
        }),
        (t[e(410)][e(416)] = function (t) {
          var o = e;
          return [o(438), o(350), o(443), o(342), o(441)][o(405)](function (e) {
            return !t[e];
          });
        }),
        (t[e(410)][e(447)] = function (t, o) {
          var A = e;
          (this[A(400)] = !1), (this[A(341)] += 1);
          var i = this[A(339)]();
          return Object[A(442)](i[A(330)], o, { vid: t }), i;
        }),
        (t[e(410)][e(429)] = function (e, t) {
          return __awaiter$1(this, void 0, void 0, function () {
            var o;
            return __generator$1(this, function (A) {
              var i = b$5;
              return this[i(400)] || this[i(341)] !== e[i(341)]
                ? ((this[i(417)][e[i(438)]] = void 0),
                  [2, new Promise(function () {})])
                : (e[i(346)],
                  e[i(376)],
                  e[i(330)],
                  (o = __rest(e, [i(346), i(376), i(330)])),
                  this[i(419)][i(360)](i(402), o),
                  t ? [2, e] : [2, this[i(356)](e)]);
            });
          });
        }),
        (t[e(410)][e(431)] = function (e, t) {
          return __awaiter$1(this, void 0, void 0, function () {
            var o, A, i, r;
            return __generator$1(this, function (n) {
              var a = b$5;
              return this[a(400)] || this[a(341)] !== e[a(341)]
                ? ((this[a(417)][e[a(438)]] = void 0),
                  [2, new Promise(function () {})])
                : ((A = (o = t || {})[a(411)]),
                  (i = o[a(377)]),
                  (r = o[a(336)]),
                  !A &&
                    ((A = exports.ErrorCode[a(358)]),
                    (i = ""
                      [a(388)](compile(i18nConfig[a(394)][a(337)]), a(323))
                      [a(388)](t, ")")),
                    (r = r || ""),
                    this[a(419)][a(373)](
                      a(389)[a(388)](A, a(387))[a(388)](i, a(381))[a(388)](r)
                    )),
                  (e[a(373)] = { code: A, message: i, stack: r }),
                  [2, this[a(356)](e)]);
            });
          });
        }),
        (t[e(410)][e(338)] = function () {
          var t = e;
          return __assign$1(__assign$1({}, getTxVodBrowserDefaultReqParams()), {
            appVer: this[t(455)](COMMON_DATA_KEY[t(327)]),
            platform: this[t(455)](COMMON_DATA_KEY[t(350)]),
            sdtfrom: this[t(455)](COMMON_DATA_KEY[t(443)]),
            flowid: this[t(455)](COMMON_DATA_KEY[t(342)]),
            guid: this[t(455)](COMMON_DATA_KEY[t(441)]),
          });
        }),
        (t[e(410)][e(339)] = function () {
          var t = e;
          return {
            businessData: { h38: this[t(455)](COMMON_DATA_KEY[t(393)]) },
            startTime: +new Date(),
            endTime: 0,
            alreadyRetryCount: 0,
            config: this[t(344)],
            reqParams: this[t(338)](),
            reqPath: void 0,
            resData: void 0,
            requestor: new JsonpRequestor(t(340)),
            parseData: void 0,
            error: void 0,
            throw: function (e, o) {
              var A = t,
                i = new Error(A(404));
              throw ((i[A(411)] = e), (i[A(377)] = o), i);
            },
            extraPlayConfig: { setLevelMode: SET_LEVEL_MODE[t(333)] },
            seq: this[t(341)],
            urlConfig: void 0,
            logger: this[t(419)],
            playerInstanceId: this[t(415)][t(460)],
          };
        }),
        (t[e(410)][e(356)] = function (t) {
          var o,
            A,
            i,
            r,
            n,
            a,
            s,
            g,
            l,
            E,
            c,
            u,
            p,
            d,
            B = e,
            h = t[B(330)],
            I = t[B(376)],
            C = t[B(346)],
            _ = __assign$1({}, t),
            f = void 0,
            y = selectKernel$1(I, C);
          if (I && C) {
            var m = C[B(372)],
              v = C[B(374)],
              Q = C[B(322)],
              T =
                null == C
                  ? void 0
                  : C[B(379)][B(432)](function (e) {
                      return e[B(329)];
                    }),
              S = T[0],
              D = T[B(461)](1),
              R =
                (null ===
                  (A =
                    null === (o = null == C ? void 0 : C[B(424)]) ||
                    void 0 === o
                      ? void 0
                      : o[B(430)]) || void 0 === A
                  ? void 0
                  : A[B(359)]("|")) || [],
              O = R[0],
              F = R[1],
              N =
                I[B(390)] >= 0 &&
                (null ===
                  (n =
                    null ===
                      (r =
                        null === (i = I.vl) || void 0 === i ? void 0 : i.vi) ||
                    void 0 === r
                      ? void 0
                      : r[0]) || void 0 === n
                  ? void 0
                  : n[B(368)]),
              w = I[B(386)];
            (f = {
              url: S,
              backupUrls: D,
              m3u8: null == C ? void 0 : C[B(379)][B(412)],
              p2pConfig: N
                ? this[B(435)]({
                    keyId: B(397)[B(388)](N),
                    useP2P: 2 === I[B(390)],
                    flowId: h[B(342)],
                    downloadMode: w,
                    encoding: v,
                  })
                : void 0,
              drmConfig: O
                ? this[B(427)]({
                    drmType: Q,
                    licenseUrl: O,
                    certificateUrl: F,
                    vid:
                      null === (a = null == C ? void 0 : C[B(424)]) ||
                      void 0 === a
                        ? void 0
                        : a[B(438)],
                  })
                : void 0,
              chachaParam:
                Q === DRM_TYPE[B(326)]
                  ? {
                      linkvid:
                        null === (s = null == C ? void 0 : C[B(424)]) ||
                        void 0 === s
                          ? void 0
                          : s[B(371)],
                      base:
                        null === (g = null == C ? void 0 : C[B(424)]) ||
                        void 0 === g
                          ? void 0
                          : g[B(362)],
                      appVer: h[B(327)],
                      tm: null == I ? void 0 : I.tm,
                      platform: h[B(350)],
                    }
                  : null,
              defaultAudioTrack:
                null ===
                  (c =
                    null ===
                      (E =
                        null === (l = null == C ? void 0 : C[B(361)]) ||
                        void 0 === l
                          ? void 0
                          : l[B(457)]) || void 0 === E
                      ? void 0
                      : E[B(405)](function (e) {
                          return e[B(456)];
                        })) || void 0 === c
                  ? void 0
                  : c[B(450)],
              drmType: Q,
              kernelName: y,
              vcodec: m,
              setLevelMode:
                null === (u = _[B(365)]) || void 0 === u ? void 0 : u[B(335)],
              expireTimeStamp: +new Date() + URL_EXPIRE_TIME,
            }),
              uaTool$1[B(433)][B(353)] &&
                (f[B(403)] = this[B(392)](
                  N,
                  null ===
                    (d =
                      null === (p = C[B(382)]) || void 0 === p
                        ? void 0
                        : p[B(418)]) || void 0 === d
                    ? void 0
                    : d.ad
                ));
          }
          return __assign$1(__assign$1({}, _), { kernelName: y, urlConfig: f });
        }),
        (t[e(410)][e(392)] = function (t, o) {
          var A = e,
            i = commonTool$1[A(378)](null != o ? o : []),
            r = 0;
          return i[A(432)](function (e, o) {
            var i = A,
              n = e[i(422)],
              a = e[i(328)],
              s = {
                startTime: n - r,
                endTime: a - r,
                url: i(446)[i(388)](t, i(370))[i(388)](o, i(380)),
              };
            return (r += a - n), s;
          });
        }),
        (t[e(410)][e(427)] = function (t) {
          var o,
            A,
            i = e,
            r = t[i(322)],
            n = t[i(453)],
            a = t[i(439)],
            s = t[i(438)],
            g = this[i(455)],
            l =
              (((o = {})[DRM_TYPE[i(332)]] = KeySystems$2[i(440)]),
              (o[DRM_TYPE[i(448)]] = KeySystems$2[i(451)]),
              o),
            E = {
              enableChromeM113Workaround: !0,
              licenseUrl: n,
              certificate: {},
              keySystem: l[r],
              licenseRequestSetup: function (e) {
                var t = i;
                if (((e[t(357)] = t(426)), r === DRM_TYPE[t(332)])) {
                  var o = {
                      guid: g(COMMON_DATA_KEY[t(441)]),
                      fmt: g(COMMON_DATA_KEY[t(407)]),
                      vid: s,
                    },
                    A = Object[t(352)](o)
                      [t(432)](function (e) {
                        var A = t;
                        return ""[A(388)](e, "=")[A(388)](o[e]);
                      })
                      [t(385)]("&");
                  return (e[t(334)] = ""[t(388)](e[t(334)], "&")[t(388)](A)), e;
                }
                return e;
              },
              licenseResponseSetup: function (e) {
                var t = i,
                  o = e[t(411)],
                  A = e[t(430)],
                  r = e[t(445)];
                if (0 === o) return stringTool[t(399)](A);
                throw { code: o, message: r };
              },
            };
          return (
            r === DRM_TYPE[i(332)] && (E[i(364)] = (((A = {})[l[r]] = a), A)), E
          );
        }),
        (t[e(410)][e(435)] = function (t) {
          return __assign$1({ playerInfo: this[e(367)]() }, t);
        }),
        (t[e(410)][e(367)] = function () {
          var t = e,
            o = this[t(455)],
            A = {
              platform: o(COMMON_DATA_KEY[t(350)]) || "",
              osVer: o(COMMON_DATA_KEY[t(363)]) || "",
              broVer: o(COMMON_DATA_KEY.ua) || "",
              playerVer: o(COMMON_DATA_KEY[t(409)]) || "",
              guid: o(COMMON_DATA_KEY[t(441)]) || "",
              qq: "",
              wx: "",
              vip: !1,
            },
            i = o(COMMON_DATA_KEY[t(347)]);
          return (
            "qq" === i
              ? (A.qq = o(COMMON_DATA_KEY[t(391)]))
              : "wx" === i && (A.wx = o(COMMON_DATA_KEY[t(391)])),
            A
          );
        }),
        __decorate(
          [
            performanceCost$3,
            __metadata(e(398), Function),
            __metadata(e(423), [Object, Object]),
            __metadata(e(349), Promise),
          ],
          t[e(410)],
          e(331),
          null
        ),
        __decorate(
          [
            performanceCost$3,
            __metadata(e(398), Function),
            __metadata(e(423), [Object, Object, Array]),
            __metadata(e(349), Promise),
          ],
          t[e(410)],
          e(366),
          null
        ),
        __decorate(
          [
            performanceCost$3,
            __metadata(e(398), Function),
            __metadata(e(423), [Object, Boolean]),
            __metadata(e(349), Promise),
          ],
          t[e(410)],
          e(429),
          null
        ),
        __decorate(
          [
            performanceCost$3,
            __metadata(e(398), Function),
            __metadata(e(423), []),
            __metadata(e(349), Object),
          ],
          t[e(410)],
          e(339),
          null
        ),
        __decorate(
          [
            performanceCost$3,
            __metadata(e(398), Function),
            __metadata(e(423), [Object]),
            __metadata(e(349), Object),
          ],
          t[e(410)],
          e(356),
          null
        ),
        t
      );
    })();
  function a$5() {
    var e = [
      "AgnFDNvZzxjPza",
      "ChjLCgfYzuLUC2vYDgfIBgvtDhjLyw1Z",
      "CwLTzwLimZG",
      "AdvWBgf5zxi",
      "vM9Kr2v0Aw5MB1jLCq",
      "mZu4nty4nez1sMzQDW",
      "AgXZlG",
      "zgvZAwDUoNr5Cgu",
      "yMfZzty0vg9vAw50oefYCMf5",
      "ywjVCNrLza",
      "C2v0vMLKzw9jBMzV",
      "D21Zigv4zwmGC3vJyW",
      "Aw5Zzxj0ywjSzvn0CMvHBxm",
      "z2v0Aw5MBYbLCNi",
      "zMLUza",
      "C2vUDa",
      "zM10",
      "C2vUzfjLCxvLC3rnAwrKBgvxyxjL",
      "CgXHEwvYDMvY",
      "ChjVDg90ExbL",
      "y29Kzq",
      "Btn1oa",
      "mJjrExHAtw4",
      "ogTeD1vtqq",
      "CgXHEwvYq29UzMLN",
      "DMfSAwrHDgvszxfqyxjHBxm",
      "y2fJAgvKuMvZDwX0",
      "y29UDgvUDeLUzM8",
      "Bg9Nz2vY",
      "BgfIzwW",
      "ChjLCgfYzvjLCxvLC3rnAwrKBgvxyxjL",
      "C3rHCNq",
      "zgvZAwDUoNbHCMfTDhLWzxm",
      "DML0zw0",
      "CgXHEwvYsw5ZDgfUy2vjza",
      "ANnVBG",
      "ChjLCgfYzurstunVBMzPzW",
      "z2v0Aw5MB0nVBMzPzW",
      "B25nAwrKBgv3yxjLrxHLy3v0zvn1y2nLC3m",
      "y2TJ",
      "B25nAwrKBgv3yxjLrxHLy3v0Aw9UrMfPBa",
      "BwfW",
      "yNjVD3nLCG",
      "mJuZodaZnvb4vhb0uG",
      "ChjLCgfYzvaYuenVBMzPzW",
      "CMvZB2X2zq",
      "CgfYC2vfEhrLCM5HBfzPzgvVsw5MBW",
      "DMLK",
      "y2vYDgLMAwnHDgvvCMW",
      "rMfPCLbSyxLxzwjlAxq",
      "z3vPza",
      "yxnZAwDU",
      "C2r0zNjVBq",
      "y2f0y2G",
      "BxnN",
      "A2v5Awq6lY8",
      "ChjLCgfYzq",
      "v0LervzjtKu",
      "zgvZDhjVEq",
      "BMfTzq",
      "v2LKzxzPBMu",
      "zgvMAw5LuhjVCgvYDhK",
      "BgLJzw5ZzvvYBa",
      "nte1og5XEu13qG",
      "z2v0q29TBw9Us3y",
      "C2vSzwn0zwq",
      "ywX0qxvKAw9uCMfJAW",
      "CgfYC2vwAwrLB0LUzM8",
      "CgfYC2vszxnWB25Zzu1PzgrSzvDHCMu",
      "Aw5ZDgfUy2vjza",
      "C2XPy2u",
      "zhjTvhLWzq",
      "lcbLCNiGka",
      "DgHLBG",
      "n21eBxjhDW",
      "q0Hbq0Hb",
      "yxbWvMvY",
      "zw5K",
      "DxjS",
      "CMvXugfYyw1Z",
      "z2v0uMvXugfYyw1Z",
      "rKfjuL9qtefz",
      "sefsra",
      "yM9KEq",
      "C2v0tgv2zwXnB2rL",
      "C3rHy2S",
      "rvjst1jFr0vusu5gt19jtK5fuG",
      "y29SBgvJDejHC2vszxf1zxn0ugfYyw0",
      "y3jLyxrLqMfZzunVBNrLEhq",
      "z2v0Aw5MB19JywXSyMfJA18",
      "C2vX",
      "zMXVD2LK",
      "odqZmZm2oezLueDQsW",
      "y29UzMLN",
      "mta5mtK0C3HUuuLQ",
      "CgfYC2veyxrH",
      "AgnFBwfPBL9SB2DPBG",
      "nZi5mZK3menRyM9PAG",
      "zgvZAwDUoNjLDhvYBNr5Cgu",
      "CgXHDgzVCM0",
      "DhzR",
      "A2v5CW",
      "C2fMyxjP",
      "r0vusu5gt19nsvntsu5hx1bbuKfn",
      "y2HLy2TszxnWB25Zzu1PzgrSzvDHCMu",
      "zM9YBwf0t3v0Chv0rgf0yq",
      "CMvZCg9UC2vuExbL",
      "r0vusu5gt19jtK5fuG",
      "C3bSAxq",
      "Bg9N",
      "ywrKAxrPB25HBfrYywnRsw5MBW",
      "yMfZzq",
      "B3n2zxi",
      "y2vYDgLMAwnHDgu",
      "zxH0CMfqBgf5q29UzMLN",
      "CMvXDwvZDa",
      "z2v0ugXHEwvYsw5MBW",
      "A2v5Awq",
      "ywjVCNq",
      "lMfKlG",
      "Bg5R",
      "y29Kzwm",
      "zxjYB3i",
      "DNr5CgvlzxK",
      "uMvXvM9K",
      "CMvZrgf0yq",
      "BwvZC2fNzq",
      "BwvYz2vuAw1LuMfUz2vZ",
      "DxjSCW",
      "lM0ZDtG",
      "lcbZDgfJAZ0",
      "C3vWCgXLBwvUDgfYEuLUzM8",
      "mtaWmJu5muTgrM1vEq",
      "BgvUz3rO",
      "AM9PBG",
      "zg93BMXVywrTB2rL",
      "lcbTC2C9",
      "y29Uy2f0",
      "z2v0Aw5MBYdLHOxPG6JPLjNOR68SignVzgu9",
      "zNaYCa",
    ];
    return (a$5 = function () {
      return e;
    })();
  }
  function b$4(e, t) {
    var o = a$4();
    return (
      (b$4 = function (t, A) {
        var i = o[(t -= 100)];
        if (void 0 === b$4.DrUxVy) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b$4.UcWVnm = r), (e = arguments), (b$4.DrUxVy = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b$4.UcWVnm(i)), (e[a] = i)), i;
      }),
      b$4(e, t)
    );
  }
  function a$4() {
    var e = [
      "mtu2nde0m2XpzMjIyG",
      "mtC1odiXz3D6wLby",
      "mtaZoty4oxjSz2LqBq",
      "nMXhExDcAW",
      "mtm4mdm0mhLdB0zSzG",
      "mti4vgHIr2XU",
      "mJeZoti0uvHgzxf6",
      "nJuZotq5wxfowLzt",
      "otq5mZuWu1nYvMLj",
    ];
    return (a$4 = function () {
      return e;
    })();
  }
  !(function (e, t) {
    for (var o = b$4, A = a$4(); ; )
      try {
        if (
          268594 ==
          -parseInt(o(107)) / 1 +
            parseInt(o(103)) / 2 +
            -parseInt(o(106)) / 3 +
            -parseInt(o(101)) / 4 +
            (-parseInt(o(105)) / 5) * (-parseInt(o(100)) / 6) +
            -parseInt(o(108)) / 7 +
            (-parseInt(o(102)) / 8) * (-parseInt(o(104)) / 9)
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var ZB_CGI_ARR = [
      "https://infozb6.video.qq.com/cgi-bin/getliveinfo?",
      "https://bkinfozb6.video.qq.com/cgi-bin/getliveinfo?",
    ],
    ZB_CGI_TEST = "https://test.zb.video.qq.com/cgi-bin/getliveinfo?",
    LIVE_GET_INFO_DATA_KEYS;
  !(function (e) {
    (e.playtime = "live-getinfo:playtime"),
      (e.livesid = "live-getinfo:livesid"),
      (e.isuserpay = "live-getinfo:isuserpay"),
      (e.cpay = "live-getinfo:cpay"),
      (e.pay_type = "live-getinfo:pay_type"),
      (e.restpreviewcnt = "live-getinfo:resetpreviewcnt");
  })(LIVE_GET_INFO_DATA_KEYS || (LIVE_GET_INFO_DATA_KEYS = {}));
  var NECESSARY_REQ_PARAMS = ["flowid", "guid"],
    VideoType = {
      1: "H264",
      2: "H265",
      4: "SDR",
      22: "DolbyVisionTs",
      23: "DolbyVisionFmp4",
    },
    XhrRequestor = (function () {
      function e() {}
      return (
        (e.prototype.start = function (e, t, o) {
          var A = "".concat(e).concat(urlTool$1.object2string(t, "&"));
          return netTool.xhr({
            url: A,
            timeout: o,
            method: "GET",
            withCredentials: !0,
            responseType: "json",
          });
        }),
        e
      );
    })(),
    DEFAULT_GETINFO_CONFIG = { retryCount: 3, test: 0, timeout: 6e3 };
  function getPayActionData(e) {
    void 0 === e && (e = {});
    var t = e.errmsg || compile(i18nConfig.h5player.ERROR_GETINFO_CODE);
    return 1 === e.iretdetailcode
      ? {
          name: "execVIPRight",
          params: { msg: t, type: "backplay", refer: 113 },
        }
      : { name: "showPayTips", params: { msg: t, cmd: 3 } };
  }
  function getErrorData(e) {
    void 0 === e && (e = {});
    var t = compile(i18nConfig.h5player.ERROR_GETINFO_CODE),
      o = e.retcode,
      A = e.errmsg,
      i = void 0 === A ? t : A;
    switch (+o) {
      case 5:
      case 16:
      case 18:
      case 51:
      case 52:
      case 67:
      case 97:
      default:
        return { name: "setErrorView", params: { msg: i } };
      case 7:
        return {
          name: "setErrorView",
          params: { msg: i, hideRefresh: !0, hideCode: !0 },
        };
      case 8:
        return {
          name: "setErrorView",
          params: { msg: i, hideRefresh: !0, hideCode: !0, isOver: !0 },
        };
      case 46:
        return { name: "showPayTips", params: { msg: i } };
      case 25:
      case 30:
      case 45:
        return getPayActionData(e);
    }
  }
  function parseUrls(e, t) {
    if (!t) return [];
    var o = t.urls;
    return (void 0 === o ? [] : o).map(function (e) {
      return { url: e };
    });
  }
  function parseDefnList(e, t) {
    return t
      ? t
          .map(function (t) {
            return {
              id: t.sid,
              name: t.defn,
              cname: "".concat(t.defn_name, " ").concat(t.defn_rate),
              framerate: t.fps,
              sname: t.defn_name,
              resolution: t.defn_rate,
              sl: t.defn === e ? 1 : 0,
              lmt: t.vip || 0,
            };
          })
          .reverse()
      : [];
  }
  function parseBrandLogo(e) {
    return { wi: e ? [e] : [] };
  }
  function parseCodecInfo(e) {
    var t,
      o = CODEC.H264,
      A =
        null === (t = null == e ? void 0 : e.codec_param) || void 0 === t
          ? void 0
          : t.vcode;
    return (
      2 === A && (o = CODEC.H265),
      { vtype: VideoType[A] || "unknown", vtypeKey: A, codec: o }
    );
  }
  function selectKernel(e) {
    var t,
      o,
      A =
        null === (t = null == e ? void 0 : e.crypt_param) || void 0 === t
          ? void 0
          : t.drmtype;
    return (null === (o = null == e ? void 0 : e.codec_param) || void 0 === o
      ? void 0
      : o.stream) === LIVE_STREAM_TYPE.FLV
      ? exports.KERNEL_NAME.FLV_JS
      : commonSelectKernel({
          codec: parseCodecInfo(e).codec,
          dltype: 3,
          drm: A,
        });
  }
  var checkResponseMiddleWare = function (e, t) {
      return __awaiter$1(void 0, void 0, void 0, function () {
        var o, A, i, r, n;
        return __generator$1(this, function (a) {
          switch (a.label) {
            case 0:
              return (
                (o = e.resData),
                (A = o.retcode),
                (i = o.errmsg),
                (r =
                  void 0 === i
                    ? compile(i18nConfig.h5player.ERROR_GETINFO_CODE)
                    : i),
                void 0 === A
                  ? (e.throw(
                      exports.ErrorCode.GETINFO_PARSE,
                      compile(i18nConfig.h5player.ERROR_GETINFO_PARSE),
                      getErrorData(e.resData)
                    ),
                    [2])
                  : 0 !== A
                  ? ((n = ""
                      .concat(exports.ErrorCode.GETINFO_LIVE_SERVER_CODE_PREFIX)
                      .concat("000".concat(A).slice(-3))),
                    e.throw(n, r, getErrorData(e.resData)),
                    [2])
                  : [4, t()]
              );
            case 1:
              return a.sent(), [2];
          }
        });
      });
    },
    parseResponseMiddleWare = function (e, t) {
      return __awaiter$1(void 0, void 0, void 0, function () {
        var o, A, i, r, n, a, s, g, l, E, c, u, p, d, B, h, I;
        return __generator$1(this, function (C) {
          switch (C.label) {
            case 0:
              return (
                (o = e.resData),
                (i = (A = void 0 === o ? {} : o).suggest_defn),
                (r = A.format_list),
                (n = A.play_list),
                (a = A.preview_info),
                (s = A.brandlogo),
                (g =
                  null == n
                    ? void 0
                    : n.find(function (e) {
                        return e.defn === i;
                      }))
                  ? (A.playback && (A.playback.svrtick = A.svrtick),
                    (l = parseCodecInfo(g)),
                    (E = l.codec),
                    (c = l.vtype),
                    (u = l.vtypeKey),
                    (p =
                      (null === (B = g.crypt_param) || void 0 === B
                        ? void 0
                        : B.drmtype) || 0),
                    (d = {
                      protectionWatermark:
                        1 ===
                        (null === (h = A.float_mark) || void 0 === h
                          ? void 0
                          : h.fwflag)
                          ? A.float_mark.uin
                          : "",
                      preview: +(null !==
                        (I = null == a ? void 0 : a.playtime) && void 0 !== I
                        ? I
                        : 0),
                    }),
                    (e.parseData = {
                      drmType: p,
                      codec: E,
                      vtype: c,
                      vtypeKey: u,
                      vitem: g,
                      preview: a ? +a.playtime : 0,
                      previewRemainCount: a ? +a.restpreviewcnt : 0,
                      urls: parseUrls(i, g),
                      definitionList: parseDefnList(i, r),
                      watermarkList: parseBrandLogo(s),
                      supplementaryInfo: {
                        contentInfo: d,
                        previewList: [],
                        watermarkList: [],
                        definitionList: [],
                        posterList: [],
                      },
                    }),
                    [4, t()])
                  : (e.throw(
                      exports.ErrorCode.GETINFO_PARSE,
                      compile(i18nConfig.h5player.ERROR_GETINFO_PARSE)
                    ),
                    [2])
              );
            case 1:
              return C.sent(), [2];
          }
        });
      });
    };
  function updateCkey(e, t) {
    var o = e.roomid,
      A = e.chid,
      i = e.cnlid,
      r = getCkey7({
        platform: e.platform,
        ckeyid: o ? A : i,
        sdtfrom: e.sdtfrom,
        svrtick: null == t ? void 0 : t.svrtick,
      }),
      n = r.tm,
      a = r.cKey,
      s = r.encryptVer;
    return (e.tm = n), (e.ckey = a), (e.encrypt_ver = s), e;
  }
  function updateDrm(e) {
    return __awaiter$1(this, void 0, void 0, function () {
      var t;
      return __generator$1(this, function (o) {
        switch (o.label) {
          case 0:
            return [4, getRequestParamForDRM(e.livedrm)];
          case 1:
            return (t = o.sent()), (e.livedrm = t), (e.playbackdrm = t), [2];
        }
      });
    });
  }
  var perpareRequestMiddleWare = function (e, t) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var o, A;
      return __generator$1(this, function (i) {
        switch (i.label) {
          case 0:
            return (
              (o = e.reqParams),
              updateCkey((A = void 0 === o ? {} : o), e.resData),
              [4, updateDrm(A)]
            );
          case 1:
            return i.sent(), e.logger.log("send param", e.reqParams), [4, t()];
          case 2:
            return i.sent(), [2];
        }
      });
    });
  };
  function getRequestUrl(e, t) {
    var o = e.test,
      A = e.path;
    return o ? ZB_CGI_TEST : A || ZB_CGI_ARR[t % ZB_CGI_ARR.length];
  }
  var sendRequestMiddleWare = function (e, t) {
      return __awaiter$1(void 0, void 0, void 0, function () {
        var o, A, i, r, n, a, s, g, l, E, c;
        return __generator$1(this, function (u) {
          switch (u.label) {
            case 0:
              e.logger.log("send start"),
                (o = e.requestor),
                (A = e.reqParams),
                (i = void 0 === A ? {} : A),
                (r = e.config),
                (n = r.retryCount),
                (a = r.timeout),
                (s = void 0 === a ? DEFAULT_GETINFO_CONFIG.timeout : a),
                (g = null),
                (l = 0),
                (u.label = 1);
            case 1:
              if (!(l < n + 1)) return [3, 7];
              e.logger.log("retry... count is: ", l), (u.label = 2);
            case 2:
              return (
                u.trys.push([2, 4, , 5]),
                (g = null),
                (e.reqPath = getRequestUrl(r, l)),
                [4, o.start(e.reqPath, i, s)]
              );
            case 3:
              return (E = u.sent()), (e.resData = E.data), [3, 5];
            case 4:
              return (
                (c = u.sent()),
                (e.resData = void 0),
                e.logger.log("the ".concat(l, " retry err:"), c),
                "xhrTimeoutError" === (null == c ? void 0 : c.error) &&
                  (g = {
                    code: exports.ErrorCode.GETINFO_TIMEOUT,
                    message: compile(i18nConfig.h5player.ERROR_GETINFO_TIMEOUT),
                  }),
                [3, 5]
              );
            case 5:
              if (
                ((e.endTime = +new Date()),
                (e.alreadyRetryCount = l),
                e.resData)
              ) {
                if (32 !== e.resData.retcode) return [3, 7];
                updateCkey(i, e.resData);
              }
              u.label = 6;
            case 6:
              return l++, [3, 1];
            case 7:
              return (
                (e.endTime = +new Date()),
                e.resData
                  ? (e.logger.cache("send over", e.resData), [4, t()])
                  : (e.throw(
                      (null == g ? void 0 : g.code) ||
                        exports.ErrorCode.GETINFO_NET,
                      (null == g ? void 0 : g.message) ||
                        compile(i18nConfig.h5player.ERROR_GETINFO_NET)
                    ),
                    [2])
              );
            case 8:
              return u.sent(), [2];
          }
        });
      });
    },
    UnifiedLiveGetInfo = (function () {
      function e(e, t) {
        (this.aborted = !1),
          (this.seq = 0),
          (this.getCommonKv =
            (null == t ? void 0 : t.getCommonKv) ||
            function () {
              return "";
            }),
          (this.config = __assign$1(
            __assign$1({}, DEFAULT_GETINFO_CONFIG),
            e.getinfoLiveConfig || {}
          )),
          (this.logger = new Logger(e.instanceId, "UnifiedLiveGetInfo"));
      }
      return (
        (e.prototype.request = function (e, t) {
          var o = this,
            A = __assign$1(__assign$1({}, this.collectBaseRequestParam()), t),
            i = this.handlerIds(e, A);
          (A = __assign$1(__assign$1({}, A), i)),
            (this.aborted = !1),
            (this.seq += 1);
          var r = {
              startTime: +new Date(),
              endTime: 0,
              alreadyRetryCount: 0,
              config: this.config,
              reqParams: A,
              reqPath: void 0,
              resData: void 0,
              requestor: new XhrRequestor(),
              parseData: void 0,
              error: void 0,
              throw: function (e, t, o) {
                var A = new Error("getinfo err");
                throw ((A.code = e), (A.message = t), (A.data = o), A);
              },
              seq: this.seq,
              urlConfig: void 0,
              logger: this.logger,
            },
            n = NECESSARY_REQ_PARAMS.find(function (e) {
              return !A[e];
            });
          if (n)
            return (
              (r.error = {
                code: exports.ErrorCode.GETINFO_INNER,
                message: compile(i18nConfig.tvk.GETINFO_MISSING_PARAM, n),
              }),
              Promise.resolve(this.formatOutputData(r))
            );
          var a =
              this.config.prepareRequestMiddleWare || perpareRequestMiddleWare,
            s = this.config.sendRequestMiddleWare || sendRequestMiddleWare,
            g = this.config.checkResponseMiddleWare || checkResponseMiddleWare,
            l = this.config.parseResponseMiddleWare || parseResponseMiddleWare;
          this.middlewares = [a, s, g, l];
          var E = compose(this.middlewares),
            c = new Promise(function () {});
          return E(r)
            .then(function () {
              if (o.aborted || o.seq !== r.seq) return c;
              r.parseData, r.resData, r.reqParams;
              var e = __rest(r, ["parseData", "resData", "reqParams"]);
              return o.logger.log("wms exec succ", e), o.formatOutputData(r);
            })
            .catch(function (e) {
              if (o.aborted || o.seq !== r.seq) return c;
              var t = e || {},
                A = t.code,
                i = t.message,
                n = t.stack;
              return (
                A ||
                  ((A = exports.ErrorCode.GETINFO_INNER),
                  (i = ""
                    .concat(
                      compile(i18nConfig.h5player.ERROR_GETINFO_INNER),
                      ", err ("
                    )
                    .concat(e, ")")),
                  (n = n || ""),
                  o.logger.error(
                    "getinfo 鍐呴儴閿欒, code="
                      .concat(A, ", msg=")
                      .concat(i, ", stack=")
                      .concat(n)
                  )),
                (r.error = { code: A, message: i, data: e.data, stack: n }),
                o.formatOutputData(r)
              );
            });
        }),
        (e.prototype.abort = function () {
          this.aborted = !0;
        }),
        (e.prototype.destroy = function () {
          this.abort(), (this.middlewares = null), (this.getCommonKv = null);
        }),
        (e.prototype.formatOutputData = function (e) {
          var t,
            o = e.resData,
            A = e.parseData,
            i = __assign$1({}, e);
          if (
            (["requestor", "player", "throw"].forEach(function (e) {
              delete i[e];
            }),
            !o || !A)
          )
            return __assign$1({}, i);
          var r = A.vitem,
            n = A.urls,
            a = A.codec,
            s = A.vtypeKey,
            g = A.drmType,
            l = r.crypt_param,
            E = selectKernel(r),
            c = n.map(function (e) {
              return e.url;
            }),
            u = c[0],
            p = c.slice(1),
            d =
              (null === (t = null == l ? void 0 : l.drmckc) || void 0 === t
                ? void 0
                : t.split("|")) || [],
            B = d[0],
            h = d[1],
            I = {
              url: u,
              backupUrls: p,
              headers: null == o ? void 0 : o.trans_headers,
              drmConfig: B
                ? this.prepareDRMConfig({
                    drmType: g,
                    licenseUrl: B,
                    certificateUrl: h,
                  })
                : void 0,
              chachaParam:
                g === DRM_TYPE.CHACHA
                  ? {
                      cnlid: null == o ? void 0 : o.chid,
                      baseKey: l.deckey,
                      randoms: l.randoms,
                    }
                  : null,
              p2pConfig:
                g === DRM_TYPE.NONE
                  ? this.prepareP2PConfig({
                      keyId: r.sid,
                      useP2P: !!r.usep2p,
                      downloadMode: 0,
                      encoding: s,
                    })
                  : void 0,
              drmType: g,
              vcodec: a,
            };
          return __assign$1(__assign$1({}, i), { kernelName: E, urlConfig: I });
        }),
        (e.prototype.handlerIds = function (e, t) {
          var o,
            A = t.roomid,
            i = t.livepid,
            r = void 0 === i ? "" : i,
            n = t.anchorid;
          return (
            A
              ? ((o = {
                  pid: r,
                  chid: e,
                  roomid: A,
                  anchorid: void 0 === n ? "" : n,
                }),
                delete t.cnlid)
              : (o = { pid: r, cnlid: e }),
            delete t.livepid,
            o
          );
        }),
        (e.prototype.prepareDRMConfig = function (e) {
          var t,
            o,
            A = e.drmType,
            i = e.licenseUrl,
            r = e.certificateUrl,
            n = this.getCommonKv,
            a =
              (((t = {})[DRM_TYPE.FAIR_PLAY] = KeySystems$2.FairPlayWebKit),
              (t[DRM_TYPE.WIDEVINE] = KeySystems$2.Widevine),
              t),
            s = {
              enableChromeM113Workaround: !0,
              licenseUrl: i,
              certificate: {},
              keySystem: a[A],
              licenseRequestSetup: function (e) {
                if (A === DRM_TYPE.FAIR_PLAY) {
                  e.responseType = "text";
                  var t = { guid: n(COMMON_DATA_KEY.guid) },
                    o = Object.keys(t)
                      .map(function (e) {
                        return "".concat(e, "=").concat(t[e]);
                      })
                      .join("&");
                  return (e.body = "".concat(e.body, "&").concat(o)), e;
                }
                return e;
              },
              licenseResponseSetup: function (e) {
                return A === DRM_TYPE.FAIR_PLAY
                  ? stringTool.base64ToUint8Array(e)
                  : e;
              },
            };
          return (
            A === DRM_TYPE.FAIR_PLAY &&
              (s.certificate = (((o = {})[a[A]] = r), o)),
            s
          );
        }),
        (e.prototype.prepareP2PConfig = function (e) {
          return __assign$1(
            {
              flowId: this.getCommonKv(COMMON_DATA_KEY.flowid),
              playerInfo: this.getPlayerInfo(),
            },
            e
          );
        }),
        (e.prototype.getPlayerInfo = function () {
          var e = {
              platform: this.getCommonKv(COMMON_DATA_KEY.platform) || "",
              osVer: this.getCommonKv(COMMON_DATA_KEY.osver) || "",
              broVer: this.getCommonKv(COMMON_DATA_KEY.ua) || "",
              playerVer: this.getCommonKv(COMMON_DATA_KEY.playerver) || "",
              guid: this.getCommonKv(COMMON_DATA_KEY.guid) || "",
              qq: "",
              wx: "",
              vip: !1,
            },
            t = this.getCommonKv(COMMON_DATA_KEY.hc_main_login);
          return (
            "qq" === t
              ? (e.qq = this.getCommonKv(COMMON_DATA_KEY.hc_vuserid))
              : "wx" === t &&
                (e.wx = this.getCommonKv(COMMON_DATA_KEY.hc_vuserid)),
            e
          );
        }),
        (e.prototype.collectBaseRequestParam = function () {
          return __assign$1(
            __assign$1({}, getTxLiveBrowserDefaultReqParams()),
            {
              appver: this.getCommonKv(COMMON_DATA_KEY.appVer),
              platform: this.getCommonKv(COMMON_DATA_KEY.platform),
              sdtfrom: this.getCommonKv(COMMON_DATA_KEY.sdtfrom),
              flowid: this.getCommonKv(COMMON_DATA_KEY.flowid),
              guid: this.getCommonKv(COMMON_DATA_KEY.guid),
            }
          );
        }),
        e
      );
    })(),
    Controller = (function () {
      function e(e, t) {
        (this.player = e), (this.tvk = t), (this.config = t.config);
      }
      return (
        (e.prototype.destroy = function () {
          (this.player = null), (this.tvk = null);
        }),
        (e.prototype.log = function () {
          for (var e, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          (e = this.tvk.logger).log.apply(
            e,
            __spreadArray(["[".concat(this.constructor.moduleName, "]")], t, !1)
          );
        }),
        (e.prototype.warn = function () {
          for (var e, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          (e = this.tvk.logger).warn.apply(
            e,
            __spreadArray(["[".concat(this.constructor.moduleName, "]")], t, !1)
          );
        }),
        (e.prototype.error = function () {
          for (var e, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          (e = this.tvk.logger).error.apply(
            e,
            __spreadArray(["[".concat(this.constructor.moduleName, "]")], t, !1)
          );
        }),
        (e.moduleName = "base-controller"),
        e
      );
    })(),
    AudioTrackController = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.audioTrackInfoFromServer = []),
          (t.drmType = void 0),
          (t.onGetInfoOver = function (e) {
            var o,
              A,
              i = e.data,
              r = i.parseData,
              n = i.error,
              a = i.resData,
              s = i.urlConfig;
            !n && r && s
              ? ((t.drmType =
                  null === (o = s.drmConfig) || void 0 === o
                    ? void 0
                    : o.keySystem),
                (t.audioTrackInfoFromServer =
                  null === (A = null == r ? void 0 : r.additionalTrackInfo) ||
                  void 0 === A
                    ? void 0
                    : A.altAudioTrack))
              : t.log("no parsed info found from getvinfo", n, a);
          }),
          (t.onVideoSetLevelOver = function () {
            if (t.player.currentVideoInfo) {
              var e = t.player.currentVideoInfo.currentAudioTrack;
              t.configureDataSet(null, e);
            }
          }),
          (t.onHlsManifestParsed = function (e) {
            var o = e.data,
              A = o.playerInstanceId,
              i = o.audioTracks,
              r = void 0 === i ? [] : i;
            A === t.player.config.instanceId &&
              0 !== r.length &&
              (t.drmType === KeySystems$2.Widevine && (r[0].default = !0),
              t.configureDataSet(t.updateAudioTrackInfo(r), null));
          }),
          (t.onVideoCanPlay = function () {
            if (t.player.currentVideoInfo) {
              var e = t.player.currentVideoInfo.currentAudioTrack;
              t.configureDataSet(null, e);
            }
          }),
          (t.updateAudioTrackInfo = function (e) {
            var o, A, i;
            if (!e.length || !t.audioTrackInfoFromServer) return null;
            var r = t.audioTrackInfoFromServer.find(function (e) {
                return -1 === e.id;
              }),
              n = r
                ? {
                    value: r.id,
                    btnLabel: null !== (o = r.name) && void 0 !== o ? o : "",
                    label:
                      null !== (A = r.displayName) && void 0 !== A ? A : "",
                    payload:
                      null !== (i = r.displayName) && void 0 !== i ? i : "",
                  }
                : null,
              a = e
                .map(function (e) {
                  var o,
                    A,
                    i,
                    r = t.audioTrackInfoFromServer.find(function (t) {
                      return t.name === e.name || t.name === e.lang;
                    });
                  return r
                    ? {
                        value: e.id,
                        btnLabel:
                          null !== (o = r.name) && void 0 !== o ? o : "",
                        label:
                          null !== (A = r.displayName) && void 0 !== A ? A : "",
                        payload:
                          null !== (i = r.displayName) && void 0 !== i ? i : "",
                      }
                    : null;
                })
                .concat(n)
                .filter(function (e) {
                  return !!e;
                });
            return (
              (t.player.currentVideoInfo.audioTracks = a.map(function (e) {
                return { name: e.btnLabel, id: e.value };
              })),
              a
            );
          }),
          (t.onAudioTrackSwitching = function (e) {
            t.configureDataSet(null, e.data.id);
          }),
          (t.onAudioTrackSwitched = function (e) {
            e.data.fail || t.configureDataSet(null, e.data.id);
          }),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.init = function () {
          this.setupPlayerEventListeners(), this.log("init success");
        }),
        (t.prototype.destroy = function () {
          this.removePlayerEventListeners(),
            (this.audioTrackInfoFromServer = void 0),
            (this.drmType = void 0),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.configureDataSet = function (e, t) {
          e &&
            (this.log("setting audioTrack options to player", e),
            this.player.setCommonKv(COMMON_DATA_KEY.currentAudioTrackList, e)),
            "number" == typeof t &&
              (this.log("setting current audioTrack to player", t),
              this.player.setCommonKv(COMMON_DATA_KEY.currentAudioTrack, t));
        }),
        (t.prototype.setupPlayerEventListeners = function () {
          this.player.pluginMsg.on(
            exports.PLAY_EVENT_EXT.GETINFO_OVER,
            this.onGetInfoOver
          ),
            this.player.on(
              exports.PLAY_EVENT.SET_AUDIO_TRACK_START,
              this.onAudioTrackSwitching
            ),
            this.player.on(
              exports.PLAY_EVENT.SET_AUDIO_TRACK_OVER,
              this.onAudioTrackSwitched
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.VIDEO_CANPLAY,
              this.onVideoCanPlay
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
              this.onVideoSetLevelOver
            ),
            kernelEvtBus.on("hlsManifestParsed", this.onHlsManifestParsed);
        }),
        (t.prototype.removePlayerEventListeners = function () {
          this.player.pluginMsg.off(
            exports.PLAY_EVENT_EXT.GETINFO_OVER,
            this.onGetInfoOver
          ),
            this.player.off(
              exports.PLAY_EVENT.SET_AUDIO_TRACK_START,
              this.onAudioTrackSwitching
            ),
            this.player.off(
              exports.PLAY_EVENT.SET_AUDIO_TRACK_OVER,
              this.onAudioTrackSwitched
            ),
            this.player.off(
              exports.H5_PLAY_EVENT.VIDEO_CANPLAY,
              this.onVideoCanPlay
            ),
            this.player.off(
              exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
              this.onVideoSetLevelOver
            ),
            kernelEvtBus.off("hlsManifestParsed", this.onHlsManifestParsed);
        }),
        (t.moduleName = "audio-track-controller"),
        t
      );
    })(Controller),
    _a$2;
  function builtDefinitionOption(e, t, o) {
    var A = { prefix: "", suffix: "", content: "" };
    return (
      (null == o ? void 0 : o.prefix) &&
        (A.prefix = "function" == typeof o.prefix ? o.prefix(e) : void 0),
      (null == o ? void 0 : o.suffix) &&
        (A.suffix = "function" == typeof o.suffix ? o.suffix(e) : void 0),
      (null == o ? void 0 : o.content) &&
        (A.content = "function" == typeof o.content ? o.content(e) : void 0),
      t ? builtRegularOption(e, !0, A) : buildVodDefinitionOption(e, A)
    );
  }
  function buildVodDefinitionOption(e, t) {
    var o = e.name;
    return o === exports.PAID_FORMAT.HDR10 ||
      o === exports.PAID_FORMAT.SFR_HDR ||
      o === exports.PAID_FORMAT.DOLBY
      ? builtSpecialOption(e, o, t)
      : builtRegularOption(e, !1, t);
  }
  function builtSpecialOption(e, t, o) {
    var A,
      i = e.name,
      r = e.resolution,
      n = e.lmt,
      a = e.sname,
      s = constructVODToken(e)[0],
      g = void 0 === s ? "" : s,
      l = o.suffix || (n ? vipIcon : void 0),
      E =
        o.prefix ||
        constructIconContainer(SpecialResolutionPrefixIcons[t], {
          width: "30px",
        }),
      c =
        (((A = {})[exports.PAID_FORMAT.DOLBY] = r),
        (A[exports.PAID_FORMAT.HDR10] = constructHDRBtnLabel(
          a.substring(0, 2)
        )),
        (A[exports.PAID_FORMAT.SFR_HDR] = r),
        A);
    return {
      label: constructDesktopOptionTemplate(g, E, l),
      btnLabel: c[t],
      value: i,
      payload: r,
    };
  }
  function builtRegularOption(e, t, o) {
    var A = e.name,
      i = e.lmt,
      r = t ? constructLiveToken(e) : constructVODToken(e),
      n = r[0],
      a = void 0 === n ? "" : n,
      s = r[1],
      g = void 0 === s ? "" : s,
      l = o.suffix || (i ? vipIcon : void 0),
      E =
        o.content ||
        (t ? formatLiveContentString : formatVODContentString)(a, g);
    return {
      label: uaTool$1.mobile
        ? constructMobileOptionTemplate(g, a)
        : constructDesktopOptionTemplate(E, o.prefix, l),
      btnLabel: g,
      value: A,
      payload: "".concat(a, " ").concat(g),
    };
  }
  function constructLiveToken(e) {
    var t = e.cname,
      o = e.framerate;
    if (!(null == t ? void 0 : t.length)) return ["", ""];
    var A = t.split(" "),
      i = A[0],
      r = void 0 === i ? "" : i,
      n = A[1],
      a = void 0 === n ? "" : n,
      s = liveFramerateLookupTable.find(function (e) {
        return o >= e[0];
      });
    return [r, "".concat(a).concat(s ? "/".concat(s[1], "甯�") : "")];
  }
  function constructVODToken(e) {
    var t = e.cname;
    if (!(null == t ? void 0 : t.length)) return ["", ""];
    var o = t.match(/(.*);\((.*)\)/);
    return o && o.length >= 3 ? [o[1], o[2]] : ["", t];
  }
  function formatLiveContentString(e, t) {
    return "".concat(t, " ").concat(e);
  }
  function formatVODContentString(e, t) {
    return "".concat(e, " ").concat(t);
  }
  function constructDesktopOptionTemplate(e, t, o) {
    var A = createFlexDiv({ alignItems: "center" });
    t && A.insertAdjacentHTML("afterbegin", t);
    var i = createFlexDiv();
    return (
      (i.innerHTML = e),
      A.appendChild(i),
      o && A.insertAdjacentHTML("beforeend", o),
      A.outerHTML
    );
  }
  function constructMobileOptionTemplate(e, t) {
    return "<div>".concat(t, "<div><div>").concat(e, "</div>");
  }
  function constructHDRBtnLabel(e) {
    var t = createFlexDiv({ alignItems: "center", width: "100%" });
    t.textContent = e;
    var o = createFlexDiv({ transform: "scale(0.8)" });
    return (
      (o.innerHTML = hdrOptionIcon),
      t.insertAdjacentElement("beforeend", o),
      t.outerHTML
    );
  }
  function constructIconContainer(e, t) {
    var o = document.createElement("div");
    return (
      (o.className = "tp-defn-option-icon-container"),
      t &&
        Object.entries(t).forEach(function (e) {
          var t = e[0],
            A = e[1];
          o.style[t] = A;
        }),
      (o.innerHTML = e),
      o.outerHTML
    );
  }
  function createFlexDiv(e) {
    var t = document.createElement("div");
    return (
      (t.style.display = "flex"),
      e &&
        Object.keys(e).forEach(function (o) {
          t.style[o] = e[o];
        }),
      t
    );
  }
  var liveFramerateLookupTable = [
      [55, 60],
      [45, 50],
    ],
    dolbyOptionIcon =
      '<svg class="tp-dolby-prefix-icon" width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n <path fill-rule="evenodd" clip-rule="evenodd" d="M0.714233 1.14282C0.714233 0.590537 1.16195 0.142822 1.71423 0.142822H20.2857C20.8379 0.142822 21.2857 0.590537 21.2857 1.14282V12.8571C21.2857 13.4094 20.8379 13.8571 20.2857 13.8571H1.71423C1.16195 13.8571 0.714233 13.4094 0.714233 12.8571V1.14282ZM2.42852 1.85711H4.99995C7.84027 1.85711 10.1428 4.15965 10.1428 6.99997C10.1428 9.84028 7.84027 12.1428 4.99995 12.1428H2.42852V1.85711ZM16.9999 1.85711C14.1596 1.85711 11.8571 4.15965 11.8571 6.99997C11.8571 9.84028 14.1596 12.1428 16.9999 12.1428H19.5714V1.85711H16.9999Z" fill="currentColor"/>\n </svg>',
    hdrOptionIcon =
      '<svg class="tp-hdr-prefix-icon" width="12" height="14" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n <path d="M0 14.4449L0.02931 12.2882L8.90291 1.4655H0.271117V0H12L0 14.4449Z" fill="currentColor"/>\n <path d="M11.8315 15.7615H0.102661L11.7925 1.72937L11.7778 4.04974L3.19975 14.296H11.8315V15.7615Z" fill="currentColor"/>\n <path d="M11.9 12.0219H8.03349L11.9 7.40312V5.12915L4.9364 13.4874H11.9V12.0219Z" fill="currentColor"/>\n </svg>',
    vipIcon =
      '<div style="margin-left: 6px; padding: 0 2px;transform: scale(0.8);border: 1px solid #fc3f4c;border-radius: 2px;color: #fc3f4c;font-size: 12px;letter-spacing: 1px;line-height: 14px;text-align: center;">VIP</div>',
    SpecialResolutionPrefixIcons =
      ((_a$2 = {}),
      (_a$2[exports.PAID_FORMAT.DOLBY] = dolbyOptionIcon),
      (_a$2[exports.PAID_FORMAT.HDR10] = hdrOptionIcon),
      (_a$2[exports.PAID_FORMAT.SFR_HDR] = hdrOptionIcon),
      _a$2),
    DefinitionController = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.useKernelLevel = !0),
          (t.onVideoPlaying = function (e) {
            var o = e.data.isFirst,
              A = t.player.currentVideoInfo || {},
              i = A.levels,
              r = A.currentLevel,
              n = A.isAutoLevel;
            if (o && t.useKernelLevel && (null == i ? void 0 : i.length) && r) {
              var a = i
                .sort(function (e, t) {
                  return t.bitrate - e.bitrate;
                })
                .map(function (e) {
                  return t.parseKernelLevel(e);
                });
              t.isEnableAbrLevel() &&
                a.length > 1 &&
                a.push(
                  __assign$1(__assign$1({}, ABR_LEVEL), { url: i[0].url })
                ),
                t.configureDataSet(a, String(n ? ABR_LEVEL.value : r.id));
            }
          }),
          (t.onGetInfoOver = function (e) {
            var o,
              A = e.data,
              i = A.parseData,
              r = A.error;
            if (!r && i) {
              var n = i.definitionList;
              if (n) {
                var a = [],
                  s =
                    (null ===
                      (o = n.find(function (e) {
                        return 1 === e.sl;
                      })) || void 0 === o
                      ? void 0
                      : o.name) || null;
                n.forEach(function (e) {
                  if (t.shouldExecuteUHDHijack(e.name))
                    a.push(t.builtUHDClientOption(e));
                  else {
                    var o = builtDefinitionOption(
                      e,
                      t.player.config.type === exports.PLAY_MODE.LIVE,
                      t.config.definitionOptionDecorator
                    );
                    a.push(o);
                  }
                }),
                  (t.useKernelLevel = !1),
                  t.configureDataSet(a, s);
              } else t.log("no definitionList found from getvinfo", n);
            } else t.log("no parsed info found from getvinfo", r, i);
          }),
          (t.onCtrlbarSetLevel = function (e) {
            var o = ((null == e ? void 0 : e.data) || {}).value;
            if (t.shouldExecuteUHDHijack(o))
              return (
                t.log(
                  "intercept uhd level switch in no hevc support environment, call native client"
                ),
                t.tvk.emit("tvkRequireClient", { detail: "notSupportUHD" }),
                s$1$1.STOP_IMMEDIATE_PROPAGATION
              );
          }),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.init = function () {
          (this.ctrlbarPlugin = this.player.plugins[OFFICIAL_PLUGIN.CTRLBAR]),
            this.setupPlayerEventListeners(),
            this.log("init success");
        }),
        (t.prototype.destroy = function () {
          this.removePlayerEventListeners(), e.prototype.destroy.call(this);
        }),
        (t.prototype.configureDataSet = function (e, t) {
          e &&
            (this.log("setting definition options to player", e),
            this.player.setCommonKv(COMMON_DATA_KEY.currentDefnList, e)),
            t &&
              (this.log("setting current definition to player", t),
              this.player.setCommonKv(COMMON_DATA_KEY.currentDefn, t));
        }),
        (t.prototype.parseKernelLevel = function (e) {
          var t = e.label,
            o = e.value,
            A = e.url;
          return {
            value: o,
            label: t,
            payload: t,
            btnLabel: t,
            url: e.masterUrl || A,
          };
        }),
        (t.prototype.isEnableAbrLevel = function () {
          return (
            this.player.kernelName === exports.KERNEL_NAME.HLS_JS &&
            this.player.config.hlsjsKernelConfig.enableAbrLevel
          );
        }),
        (t.prototype.setupPlayerEventListeners = function () {
          var e;
          this.player.pluginMsg.on(
            exports.PLAY_EVENT_EXT.GETINFO_OVER,
            this.onGetInfoOver
          ),
            null === (e = this.ctrlbarPlugin) ||
              void 0 === e ||
              e.on(
                ctrlbarEventName,
                this.onCtrlbarSetLevel,
                Number.MAX_SAFE_INTEGER
              ),
            this.player.on(
              exports.H5_PLAY_EVENT.VIDEO_PLAYING,
              this.onVideoPlaying
            );
        }),
        (t.prototype.removePlayerEventListeners = function () {
          var e;
          this.player.pluginMsg.off(
            exports.PLAY_EVENT_EXT.GETINFO_OVER,
            this.onGetInfoOver
          ),
            null === (e = this.ctrlbarPlugin) ||
              void 0 === e ||
              e.off(ctrlbarEventName, this.onCtrlbarSetLevel);
        }),
        (t.prototype.builtUHDClientOption = function (e) {
          return builtDefinitionOption(
            e,
            !1,
            __assign$1(__assign$1({}, this.config.definitionOptionDecorator), {
              content: function (e) {
                return "瀹㈡埛绔� ".concat(e.resolution);
              },
            })
          );
        }),
        (t.prototype.shouldExecuteUHDHijack = function (e) {
          return (
            e === exports.PAID_FORMAT.UHD &&
            this.config.showUHDClientGuide &&
            !videoTool$1.supportHevc()
          );
        }),
        (t.moduleName = "definition-controller"),
        t
      );
    })(Controller),
    ctrlbarEventName = "ctrl:set-level",
    ABR_LABEL = compile(i18nConfig.tvk.DEFN_ABR_LABEL),
    ABR_LEVEL = {
      value: "abr",
      btnLabel: ABR_LABEL,
      label: ABR_LABEL,
      payload: ABR_LABEL,
    },
    defaultTVKConfig = {
      scoreMaskForBlocking: 0,
      scoreMaskForReporting: 0,
      debug: !1,
      enableTEE: !1,
      definitionController: DefinitionController,
      audioTrackController: AudioTrackController,
    },
    DISCONTINUE_REGEX = /#EXT-X-DISCONTINUITY/;
  function rebuildM3U8(e, t) {
    if (!t || 0 === t.length) return [e, []];
    for (
      var o = [], A = e.split(/[\r\n]/), i = 0, r = !1, n = [];
      i < A.length;

    ) {
      if (DISCONTINUE_REGEX.test(A[i])) {
        if (r) {
          n.push(i), o.push(n), (n = []), (r = !1), (i += 1);
          continue;
        }
        n.push(i), (r = !0);
      }
      i += 1;
    }
    var a = mergeM3U8(
      t
        .slice()
        .sort(function (e, t) {
          return e.start - t.start;
        })
        .map(function (e, t) {
          return __assign$1(__assign$1({}, e), {
            m3u8: o[t] ? A.slice(o[t][0], o[t][1] + 1).join("\n") : "",
          });
        })
    );
    return [
      A.filter(function (e, t) {
        return !o.some(function (e) {
          return t >= e[0] && t <= e[1];
        });
      }).join("\n"),
      a,
    ];
  }
  function mergeM3U8(e) {
    var t = [],
      o = e[0].start,
      A = -1,
      i = e[0].m3u8;
    return (
      e.forEach(function (e) {
        var r = e.start,
          n = e.end,
          a = e.m3u8;
        if (r <= A) return (A = n), void (i = "".concat(i, "\n").concat(a));
        A >= 0 &&
          t.push({
            start: o,
            end: A,
            m3u8: "".concat(M3U8_HEADER).concat(i, "\n").concat(M3U8_FOOTER),
          }),
          (o = r),
          (A = n),
          (i = a);
      }),
      t.push({
        start: o,
        end: A,
        m3u8: "".concat(M3U8_HEADER).concat(i, "\n").concat(M3U8_FOOTER),
      }),
      t
    );
  }
  var M3U8_HEADER =
      "#EXTM3U\n#EXT-X-VERSION:3\n#EXT-X-MEDIA-SEQUENCE:0\n#EXT-X-PLAYLIST-TYPE:VOD\n",
    M3U8_FOOTER = "#EXT-X-ENDLIST\n",
    NetworkController = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.onGetInfoOver = function (e) {
            var o = e.data;
            t.player.config.type !== exports.PLAY_MODE.VOD
              ? t.handleLiveLatencyChaseBehavior(o)
              : t.handleVodUrlConfig(o);
          }),
          (t.handleLiveLatencyChaseBehavior = function (e) {
            var o = e.resData;
            if (null == o ? void 0 : o.fast_forward) {
              var A = o.fast_forward,
                i = A.speed,
                r = A.start_fast_foward,
                n = A.stop_fast_foward;
              t.player.config.latencyConfig = {
                expectedLatency: r,
                minLatency: n,
                syncSpeed: i,
              };
            }
          }),
          (t.onPlaySessionEnd = function () {
            t.resetContext();
          }),
          (t.onHlsManifestParsed = function (e) {
            var o = e.data,
              A = o.playerInstanceId,
              i = o.audioTracks,
              r = void 0 === i ? [] : i,
              n = o.levels,
              a = void 0 === n ? [] : n;
            A === t.player.config.instanceId &&
              (r.forEach(function (e) {
                var o = findKeyid(e);
                o && (t.context.keyid[e.url] = o);
              }),
              a.forEach(function (e) {
                var o = findKeyid(e);
                o && (t.context.keyid[e.url] = o);
              }));
          }),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.init = function () {
          this.resetContext(),
            this.configHlsjsKernel({ pProxy: this.lookupCache.bind(this) }),
            this.setupEventListeners();
        }),
        (t.prototype.destroy = function () {
          this.removeEventListeners(),
            this.resetContext(),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.setupEventListeners = function () {
          this.player.pluginMsg.on(
            exports.PLAY_EVENT_EXT.GETINFO_OVER,
            this.onGetInfoOver
          ),
            this.player.pluginMsg.on(
              exports.PLAY_EVENT_EXT.PRELOAD_GETINFO_OVER,
              this.onGetInfoOver
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.PLAY_SESSION_END,
              this.onPlaySessionEnd
            ),
            kernelEvtBus.on("hlsManifestParsed", this.onHlsManifestParsed);
        }),
        (t.prototype.removeEventListeners = function () {
          this.player.pluginMsg.off(
            exports.PLAY_EVENT_EXT.GETINFO_OVER,
            this.onGetInfoOver
          ),
            this.player.pluginMsg.off(
              exports.PLAY_EVENT_EXT.PRELOAD_GETINFO_OVER,
              this.onGetInfoOver
            ),
            this.player.off(
              exports.H5_PLAY_EVENT.PLAY_SESSION_END,
              this.onPlaySessionEnd
            ),
            kernelEvtBus.off("hlsManifestParsed", this.onHlsManifestParsed);
        }),
        (t.prototype.resetContext = function () {
          this.log("reset context"), (this.context = { m3u8: {}, keyid: {} });
        }),
        (t.prototype.configHlsjsKernel = function (e) {
          void 0 === e && (e = {});
          var t = Object.assign({}, this.player.config.hlsjsKernelConfig, e);
          this.player.config.hlsjsKernelConfig = t;
        }),
        (t.prototype.handleVodUrlConfig = function (e) {
          var t,
            o,
            A,
            i,
            r = this,
            n = e.resData,
            a = e.parseData,
            s = e.urlConfig;
          if (0 === (null == n ? void 0 : n.em)) {
            var g = [];
            if (n.play) {
              var l = n.play,
                E = l.master,
                c = l.keyid,
                u = l.audiolist,
                p = void 0 === u ? [] : u,
                d = l.videolist,
                B = void 0 === d ? [] : d,
                h = l.masterurl,
                I = void 0 === h ? [] : h;
              return (
                c && E && (this.context.m3u8[c] = E),
                c &&
                  I.forEach(function (e) {
                    r.context.keyid[e] = c;
                  }),
                B.forEach(function (e) {
                  r.context.m3u8[e.keyid] = e.m3u8;
                }),
                p.forEach(function (e) {
                  r.context.m3u8[e.keyid] = e.m3u8;
                }),
                n.vl.vi[0].ul.ui.forEach(function (e) {
                  var t, o;
                  (r.context.keyid[e.url] = "".concat(
                    null !==
                      (o =
                        null === (t = B[0]) || void 0 === t
                          ? void 0
                          : t.keyid) && void 0 !== o
                      ? o
                      : ""
                  )),
                    g.push(e.url);
                }),
                void this.configHlsjsKernel({ externalRedundantUrls: g })
              );
            }
            if (8 === n.dltype) {
              var C = n.vl.vi[0].ul.m3u8,
                _ = n.vl.vi[0].keyid;
              if (uaTool$1.browser.safari) {
                var f = rebuildM3U8(
                    C,
                    null ===
                      (o =
                        null ===
                          (t = null == a ? void 0 : a.supplementaryInfo) ||
                        void 0 === t
                          ? void 0
                          : t.contentInfo) || void 0 === o
                      ? void 0
                      : o.ad
                  ),
                  y = f[0],
                  m = f[1];
                (this.context.m3u8[_] = y),
                  m.forEach(function (e, t) {
                    var o = "".concat(_, ".ad.").concat(t);
                    r.context.m3u8[o] = e.m3u8;
                  });
              } else this.context.m3u8[_] = C;
              var v = !1;
              return (
                null === (A = null == a ? void 0 : a.urls) ||
                  void 0 === A ||
                  A.forEach(function (e) {
                    KEYID_LOOKUP_REGEX.test(e.url) && (v = !0),
                      g.push(e.url),
                      5 !== a.drmType && (r.context.keyid[e.url] = _);
                  }),
                v &&
                  (null === (i = null == s ? void 0 : s.backupUrls) ||
                  void 0 === i
                    ? void 0
                    : i.length) &&
                  (s.backupUrls = []),
                void this.configHlsjsKernel({ externalRedundantUrls: g })
              );
            }
          }
        }),
        (t.prototype.lookupCache = function (e) {
          this.log("proxy download", e, this.context);
          var t = this.getKeyIdFromUrl(e);
          return t
            ? this.lookupByKeyId(t)
            : (this.log("no keyid found for url", e), null);
        }),
        (t.prototype.getKeyIdFromUrl = function (e) {
          for (var t; null !== (t = KEYID_LOOKUP_REGEX.exec(e)); ) return t[1];
          return this.context.keyid[e];
        }),
        (t.prototype.lookupByKeyId = function (e) {
          var t = this.context.m3u8[e];
          return t
            ? (this.log("m3u8 found for keyid, network request skipped", e), t)
            : (this.log("no m3u8 found for keyid", e), null);
        }),
        (t.moduleName = "network-controller"),
        t
      );
    })(Controller),
    KEYID_LOOKUP_REGEX = /keyid:\/\/([0-9a-zA-Z.]+).m3u8/,
    TXV_KEYID_TAGNAME = "EXT-QQHLS-STREAM-KEYID";
  function findKeyid(e) {
    var t,
      o = e.tags;
    return o
      ? null ===
          (t = o.find(function (e) {
            return e[0] === TXV_KEYID_TAGNAME;
          })) || void 0 === t
        ? void 0
        : t[1]
      : null;
  }
  var getQQFromCookie = function () {
      var e = cookieTool$1.get("luin") || cookieTool$1.get("uin");
      return e && (e = e.replace(/\D/g, "").replace(/^0+/, "")), e;
    },
    getPtag = function () {
      var e,
        t = document.location.toString().toLowerCase();
      if (
        (e = ["ptag", "adtag", "pgv_ref"].find(function (e) {
          return urlTool$1.getUrlParamByKey(t, e);
        }))
      )
        return e;
      try {
        e = sessionStorage.getItem("ptag");
      } catch (e) {}
      if (e) return e;
      var o = urlTool$1.getDomainOfURL(document.referrer);
      return (
        ["v.qq.com", "film.qq.com", "m.v.qq.com"].includes(o) ||
          (e = o.replace(/\./g, "_")),
        e || cookieTool$1.get("ptag")
      );
    },
    LoginType;
  function stringifyAndReplaceCommaInParams(e) {
    return jsonTool$1.safelyStringify(e).replace(/,/g, "\\,");
  }
  function safelyConvertToNumber(e, t) {
    return (
      void 0 === t && (t = !1),
      isNaN(e) || !isFinite(e) ? 0 : t ? Math.round(+e) : +e
    );
  }
  !(function (e) {
    (e[(e.none = 0)] = "none"), (e[(e.wx = 3)] = "wx"), (e[(e.qq = 1)] = "qq");
  })(LoginType || (LoginType = {}));
  var whichBoss$1 = function () {
      return uaTool$1.mobile
        ? { id: MOBILE_ATTAID$1, token: MOBILE_ATTA_TOKEN$1 }
        : { id: DESKTOP_ATTAID$1, token: DESKTOP_ATTA_TOKEN$1 };
    },
    DESKTOP_ATTAID$1 = "zae00003007",
    DESKTOP_ATTA_TOKEN$1 = "2345779398",
    MOBILE_ATTAID$1 = "zbb00003101",
    MOBILE_ATTA_TOKEN$1 = "3917576196",
    DEFAULT_KEYS$1 = {
      iQQ: "",
      sid: COMMON_DATA_KEY.vid,
      pid: COMMON_DATA_KEY.livepid,
      playno: COMMON_DATA_KEY.flowid,
      guid: COMMON_DATA_KEY.guid,
      ctime: "",
      sdtfrom: COMMON_DATA_KEY.sdtfrom,
      surl: "",
      sref: "",
      flashver: "",
      fplayerver: COMMON_DATA_KEY.playerver,
      P2PVer: "",
      vurl: "",
      tpay: "",
      cpay: "",
      ptag: "",
      adid: "",
      playtime: "",
      error_code: "",
      drm: COMMON_DATA_KEY.drmtype,
      rest_preview_cnt: "",
      hc_main_login: COMMON_DATA_KEY.hc_main_login,
      hc_openid: COMMON_DATA_KEY.hc_openid,
      hc_vuserid: COMMON_DATA_KEY.hc_vuserid,
      hc_appid: COMMON_DATA_KEY.hc_appid,
      extrainfo: "",
      platform: COMMON_DATA_KEY.platform,
    },
    LiveFlowReporterPlugin = (function (e) {
      function t(t, o, A) {
        var i = e.call(this, t, o, A) || this;
        (i.FLOW_DATA_KEY = ""),
          (i.step5Timer = null),
          (i.started = !1),
          (i.setEvtHandler = function () {
            i.msg.on(
              exports.PLAY_EVENT_EXT.DATASET_STATE_UPDATE,
              i.onStateChange
            );
          }),
          (i.onStateChange = function (e) {
            var t,
              o = e.data,
              A = o.key,
              r =
                (((t = {})[exports.DATA_STATE.LOAD_END] = i.step6),
                (t[exports.DATA_STATE.SET_LEVEL_START] = i.step8),
                (t[exports.DATA_STATE.GET_INFO_END] = i.step4),
                (t[exports.DATA_STATE.SESSION_END] = i.onEnd),
                (t[exports.DATA_STATE.SESSION_START] = i.start),
                t);
            r[A] && r[A](o);
          }),
          (i.start = function () {
            (i.started = !0), i.step3();
          }),
          (i.step3 = function () {
            i.report({ step: "3", val: 0, val1: 0, val2: 0 }),
              (i.step5Timer = setInterval(function () {
                i.step5();
              }, 6e4));
          }),
          (i.step4 = function (e) {
            var t = e.newVal,
              o = void 0 === t ? {} : t,
              A = e.startEvent,
              r = void 0 === A ? {} : A,
              n = { val: o.ftime - r.ftime, val1: 0, val2: 0 };
            i.reportedEvt.step4 ||
              ((i.reportedEvt.step4 = !0),
              i.report(__assign$1({ step: "4" }, n))),
              i.report(__assign$1({ step: "1100" }, n));
          }),
          (i.step5 = function () {
            i.report({ step: "5", val: 6e4, val1: 0, val2: 0 });
          }),
          (i.step6 = function (e) {
            var t = e.newVal,
              o = void 0 === t ? {} : t,
              A = e.startEvent,
              r = void 0 === A ? {} : A,
              n = {
                step: "6",
                val: o.ftime - r.ftime,
                val1: i.reportedEvt.step7 ? 1 : 0,
                val2: 0,
              };
            i.report(n);
          }),
          (i.step7 = function () {
            i.report({ step: "7", val: 0, val1: 0, val2: 0 });
          }),
          (i.step8 = function () {
            i.report({ step: "8", val: 0, val1: 0, val2: 0 });
          }),
          (i.onEnd = function () {
            i.step5Timer &&
              (clearInterval(i.step5Timer), (i.step5Timer = null)),
              (i.reportedEvt = {});
          });
        var r = t.config.liveFlowReporterConfig,
          n = whichBoss$1(),
          a = n.id,
          s = n.token,
          g = r || {},
          l = g.id,
          E = g.token,
          c = g.devicePlatform,
          u = g.serviceURL,
          p = g.paramsKey,
          d = g.forceImage,
          B = g.onBeforeReport;
        return (
          (i.REPORT_URL = null != u ? u : "https://h.trace.qq.com/bosskv?"),
          (i.config = {
            paramsKey: __assign$1(__assign$1({}, DEFAULT_KEYS$1), p || {}),
            onBeforeReport: B,
            forceImage: d,
            id: null != l ? l : a,
            token: null != E ? E : s,
            devicePlatform:
              null != c ? c : uaTool$1.mobile ? "mobile" : "desktop",
          }),
          i.setEvtHandler(),
          i
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "reportHeader", {
          get: function () {
            var e,
              t = this.config.paramsKey,
              o = void 0 === t ? {} : t,
              A = this.player.getCommonKv;
            return {
              attaid: this.config.id,
              token: this.config.token,
              iQQ: A(o.iQQ) || getQQFromCookie(),
              sid: A(o.sid) || "",
              pid: A(o.pid) || "",
              playno: A(o.playno),
              guid: A(o.guid) || "",
              ctime: commonTool$1.dateFormat(void 0, void 0),
              sdtfrom: A(o.sdtfrom) || "",
              surl: A(o.surl) || location.href,
              sref: A(o.sref) || document.referrer,
              flashver: A(o.flashver) || "",
              fplayerver: A(o.fplayerver) || "",
              P2PVer: A(o.P2PVer) || "",
              vurl:
                A(o.vurl) ||
                (null === (e = this.player.currentVideoInfo) || void 0 === e
                  ? void 0
                  : e.loadingUrl),
              tpay: A(o.tpay) || 0,
              cpay: A(o.cpay) || 0,
              ptag: A(o.ptag) || "",
              adid: A(o.adid) || "",
              playtime: A(o.playtime) || 0,
              error_code: A(o.error_code) || 0,
              rest_preview_cnt: A(o.rest_preview_cnt) || -1,
              hc_main_login: A(o.hc_main_login) || "",
              hc_openid: A(o.hc_openid) || "",
              hc_vuserid: A(o.hc_vuserid) || "",
              hc_appid: A(o.hc_appid) || "",
              extrainfo: A(o.extrainfo) || "",
              platform: A(o.platform) || "",
              playertype: 1,
              drm: A(o.drm) || 0,
              kernel: this.player.kernelName,
            };
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.destroy = function () {
          e.prototype.destroy.call(this),
            this.step5Timer &&
              (clearInterval(this.step5Timer), (this.step5Timer = null));
        }),
        (t.prototype.reportAd = function () {
          this.step7();
        }),
        (t.prototype.report = function (t) {
          this.started && e.prototype.report.call(this, t);
        }),
        (t.pluginName = "live-flow-reporter"),
        t
      );
    })(BaseReporter),
    LiveFlyReportKeyMapping = {
      progid: "",
      playno: COMMON_DATA_KEY.flowid,
      guid: COMMON_DATA_KEY.guid,
      sip: "",
      iqq: "",
      hh_ua: COMMON_DATA_KEY.ua,
      cdn: "",
      sdtfrom: COMMON_DATA_KEY.sdtfrom,
      loadingtime: "",
      blocktime: "",
      blockcount: "",
      prdlength: "",
      platform: COMMON_DATA_KEY.platform,
      errorcode: "",
      dsip: "",
      durl: "",
      firstreport: "",
      sUrl: COMMON_DATA_KEY.url,
      sRef: COMMON_DATA_KEY.referrer,
      fplayerver: COMMON_DATA_KEY.playerver,
      livepid: COMMON_DATA_KEY.livepid,
      viewid: "",
      seq: "",
      cmd: "",
      fullecode: "",
      live_type: "",
      geturltime: "",
      playtime: "",
      ispay: "",
      isuserpay: "",
      switch: "",
      lookback: "",
      nettype: "",
      freetype: "",
      https: "",
      downspeed: "",
      vip_type: "",
      playertype: "",
      pvid: "",
      login_type: "",
      open_id: COMMON_DATA_KEY.hc_openid,
      live_delay: "",
      use_p2p: COMMON_DATA_KEY.p2p,
      p2p_play: "",
      p2pver: COMMON_DATA_KEY.p2pver,
    },
    APP_KEY = "0AND0F8T5N4N7QT0",
    OVERSEA_APP_KEY = "0DOU0M38AT4C4UVD",
    LiveFlyReporterPlugin = (function (e) {
      function t(t, o, A) {
        var i,
          r,
          n = e.call(this, t, o, A) || this;
        (n.periodTickTimer = 0),
          (n.currentPeriodStartTime = 0),
          (n.isInPlayback = 0),
          (n.lastSid = 0),
          (n.loadCost = 0),
          (n.redirectCost = 0),
          (n.bufferCount = 0),
          (n.redirectStartTime = 0),
          (n.bufferDuration = 0),
          (n.reported = !1),
          (n.delay = 0),
          (n.seq = 0),
          (n.errCode = exports.ErrorCode.SUC),
          (n.keyMapping = __assign$1(
            __assign$1({}, LiveFlyReportKeyMapping),
            null === (i = t.config.liveFlyReporterConfig) || void 0 === i
              ? void 0
              : i.paramsKey
          ));
        var a =
            null === (r = t.config.liveFlyReporterConfig) || void 0 === r
              ? void 0
              : r.isOversea,
          s = { appKey: a ? OVERSEA_APP_KEY : APP_KEY, isOversea: a };
        return (
          (n.REPORT_KEY = s.appKey),
          n.bindEventHandlers(),
          BeaconRequest.register(s),
          (n.reporter = BeaconRequest.report),
          (n.cachedVideoInfo = createVideoInfo()),
          n
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "reportHeader", {
          get: function () {
            var e = this,
              t = e.player,
              o = e.keyMapping,
              A = e.cachedVideoInfo,
              i = t.currentVideoInfo,
              r = (null == i ? void 0 : i.loadingUrl) || "",
              n = this.getAuthInfo(),
              a = n.pvid,
              s = n.loginType;
            return {
              progid: A.liveSid || 0,
              playno: t.getCommonKv(o.playno) || "",
              guid: t.getCommonKv(o.guid) || "",
              sip: A.clientIp || "0.0.0.0",
              iqq: t.getCommonKv(o.iqq) || 0,
              hh_ua: t.getCommonKv(o.hh_ua) || "",
              cdn: A.cdnName || "",
              sdtfrom: t.getCommonKv(o.sdtfrom) || 0,
              loadingtime: this.loadCost,
              blocktime: this.bufferDuration,
              blockcount: this.bufferCount,
              prdlength: 0,
              platform: t.getCommonKv(o.platform),
              errorcode: this.errCode,
              dsip: "0.0.0.0",
              durl: r,
              firstreport: +!this.reported,
              sUrl: t.getCommonKv(o.sUrl) || "",
              sRef: t.getCommonKv(o.sRef) || "",
              fplayerver: t.getCommonKv(o.fplayerver) || "0.0.0",
              livepid: A.livePid || 0,
              viewid: A.liveChid || 0,
              seq: this.seq,
              cmd: 0,
              fullecode: this.errCode,
              live_type: A.liveType,
              geturltime: this.redirectCost,
              playtime: A.previewLength || -1,
              ispay: A.ispay || 0,
              isuserpay: A.isuserpay || 0,
              switch: "",
              lookback: this.isInPlayback,
              nettype: 0,
              freetype: 0,
              https: +(0 === r.indexOf("https://")),
              downspeed: 0,
              vip_type: t.getCommonKv(o.vip_type) || 0,
              playertype: t.getCommonKv(o.playertype) || 0,
              pvid: a || 0,
              login_type: s,
              open_id: t.getCommonKv(o.open_id) || "",
              live_delay: this.delay,
              use_p2p: t.getCommonKv(o.use_p2p) || 0,
              p2p_play: 0,
              p2pver: t.getCommonKv(o.p2pver) || "",
            };
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.destroy = function () {
          this.clearTick(),
            this.clearSessionData(),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.report = function (t) {
          var o;
          (null === (o = this.cachedVideoInfo) || void 0 === o
            ? void 0
            : o.liveSid) &&
            (uaTool$1.spider ||
              (e.prototype.report.call(
                this,
                __assign$1(__assign$1({}, t), { stepname: REPORT_EVENT_ID$1 })
              ),
              (this.seq += 1),
              (this.reported = !0)));
        }),
        (t.prototype.getAuthInfo = function () {
          var e = this.player;
          return {
            pvid: cookieTool$1.get("pgv_pvid"),
            loginType:
              LoginType[e.getCommonKv(COMMON_DATA_KEY.hc_main_login) || "none"],
          };
        }),
        (t.prototype.getVideoInfo = function (e) {
          var t,
            o = e.data.resData,
            A = 0;
          1 === o.stream && (A |= 16), 2 === o.vcode && (A |= 4);
          var i = o.play_list;
          if (null == i ? void 0 : i[0]) {
            var r = i[0],
              n = r.urls[0];
            this.cachedVideoInfo = {
              liveChid: o.chid,
              livePid: o.pid,
              liveSid: r.sid,
              cdnName: urlTool$1.getUrlParamByKey(n, "cdn"),
              liveType: A,
              ispay: o.pay_type,
              isuserpay: o.isuserpay,
              previewLength:
                null === (t = o.preview_info) || void 0 === t
                  ? void 0
                  : t.playtime,
              clientIp: o.client_ip,
            };
          } else
            this.cachedVideoInfo = {
              liveChid: o.livechid,
              liveSid: o.livesid,
              livePid: o.livepid,
              ispay: o.ispay,
              isuserpay: o.isuserpay,
              previewLength: o.playtime,
              cdnName: o.cdn_name,
              liveType: A,
              clientIp: "0.0.0.0",
            };
          this.redirectCost = Date.now() - this.redirectStartTime;
        }),
        (t.prototype.bindEventHandlers = function () {
          var e = this;
          this.msg.on(exports.PLAY_EVENT_EXT.GETINFO_START, function () {
            e.redirectStartTime = Date.now();
          }),
            this.msg.on(
              exports.PLAY_EVENT_EXT.GETINFO_OVER,
              this.getVideoInfo.bind(this)
            ),
            this.msg.on(
              exports.PLAY_EVENT_EXT.DATASET_STATE_UPDATE,
              this.onDataSetStateUpdate.bind(this)
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.PLAY_SESSION_END,
              this.onSessionEnded.bind(this)
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_START,
              this.onSetLevelStart.bind(this)
            );
        }),
        (t.prototype.onDataSetStateUpdate = function (e) {
          var t,
            o =
              (((t = {})[exports.DATA_STATE.BUFFER_END] = this.onBufferEnd),
              (t[exports.DATA_STATE.LOAD_END] = this.onLoaded),
              (t[exports.DATA_STATE.SET_LEVEL_END] = this.onSetLevelEnd),
              t);
          o[e.data.key] && o[e.data.key].call(this, e);
        }),
        (t.prototype.onLoaded = function (e) {
          var t = e.data,
            o = t.newVal,
            A = t.startEvent,
            i = o.ftime,
            r = o.code,
            n = o.currentUrl,
            a = A.ftime;
          (this.loadCost = i - a),
            (this.errCode = r),
            this.report({
              cmd: r === exports.ErrorCode.SUC ? CMD.load : CMD.error,
              cdn: urlTool$1.getUrlParamByKey(n, "cdn"),
              durl: n,
            }),
            this.startTick();
        }),
        (t.prototype.onBufferEnd = function (e) {
          var t = e.data,
            o = t.newVal,
            A = t.startEvent,
            i = o.ftime,
            r = A.ftime;
          (this.bufferDuration += i - r), (this.bufferCount += 1);
        }),
        (t.prototype.onSetLevelStart = function () {
          (this.lastSid = this.cachedVideoInfo.liveSid), this.tickImmediate();
        }),
        (t.prototype.onSetLevelEnd = function (e) {
          var t = e.data,
            o = t.newVal,
            A = t.startEvent,
            i = o.ftime,
            r = o.code,
            n = A.ftime;
          r === exports.ErrorCode.SUC &&
            ((this.loadCost = i - n),
            this.report({ cmd: CMD.load, switch: this.lastSid }),
            this.startTick());
        }),
        (t.prototype.onSessionEnded = function (e) {
          var t,
            o = e.data.code;
          (this.errCode = o),
            this.tickImmediate({
              durl:
                null === (t = this.player.currentVideoInfo) || void 0 === t
                  ? void 0
                  : t.loadingUrl,
            }),
            this.clearSessionData();
        }),
        (t.prototype.tick = function (e) {
          var t = this,
            o = t.errCode,
            A = t.player,
            i = t.currentPeriodStartTime;
          A.currentVideoInfo &&
            (this.delay = A.currentVideoInfo.currentDelay || 0),
            this.report(
              __assign$1(
                {
                  cmd: o === exports.ErrorCode.SUC ? CMD.period : CMD.error,
                  fullecode: o,
                  prdlength: Date.now() - i,
                },
                e
              )
            ),
            this.onTickEnd();
        }),
        (t.prototype.clearTick = function () {
          this.periodTickTimer &&
            (window.clearInterval(this.periodTickTimer),
            (this.periodTickTimer = null));
        }),
        (t.prototype.onTickEnd = function () {
          (this.bufferCount = 0),
            (this.bufferDuration = 0),
            (this.currentPeriodStartTime = Date.now());
        }),
        (t.prototype.tickImmediate = function (e) {
          this.clearTick(), this.tick(e);
        }),
        (t.prototype.startTick = function () {
          this.periodTickTimer ||
            ((this.currentPeriodStartTime = Date.now()),
            (this.periodTickTimer = window.setInterval(
              this.tick.bind(this),
              PeriodInterval
            )));
        }),
        (t.prototype.clearSessionData = function () {
          (this.redirectCost = 0),
            (this.redirectStartTime = 0),
            (this.currentPeriodStartTime = 0),
            (this.cachedVideoInfo = createVideoInfo()),
            (this.loadCost = 0),
            (this.reported = !1),
            (this.seq = 0),
            (this.delay = 0),
            (this.errCode = exports.ErrorCode.SUC);
        }),
        (t.pluginName = "live-fly-reporter"),
        t
      );
    })(BaseReporter),
    CMD;
  !(function (e) {
    (e[(e.load = 205)] = "load"),
      (e[(e.error = 150)] = "error"),
      (e[(e.period = 263)] = "period");
  })(CMD || (CMD = {}));
  var REPORT_EVENT_ID$1 = "boss_cmd_player_hit_tap_process",
    PeriodInterval = 6e4,
    createVideoInfo = function () {
      return {
        liveChid: 0,
        livePid: 0,
        liveSid: 0,
        liveType: 0,
        ispay: 0,
        isuserpay: 0,
        previewLength: 0,
        cdnName: "",
        clientIp: "0.0.0.0",
      };
    },
    _a$1;
  function stringToLittleEndianWords(e) {
    var t = 0,
      o = [];
    for (o[(e.length >> 2) - 1] = void 0, t = 0; t < o.length; t += 1) o[t] = 0;
    var A = 8 * e.length;
    for (t = 0; t < A; t += 8)
      o[t >> 5] |= (255 & e.charCodeAt(t / 8)) << t % 32;
    return o;
  }
  function littleEndianWordsToString(e) {
    for (var t = "", o = 32 * e.length, A = 0; A < o; A += 8)
      t += String.fromCharCode((e[A >> 5] >>> A % 32) & 255);
    return t;
  }
  function rawStringToHEX(e) {
    for (var t = "0123456789abcdef", o = "", A = 0; A < e.length; A += 1) {
      var i = e.charCodeAt(A);
      o += t.charAt((i >>> 4) & 15) + t.charAt(15 & i);
    }
    return o;
  }
  function md5(e) {
    var t = stringToLittleEndianWords(e),
      o = 8 * e.length;
    (t[o >> 5] |= 128 << o % 32), (t[14 + (((o + 64) >>> 9) << 4)] = o);
    for (
      var A = 1732584193,
        i = -271733879,
        r = -1732584194,
        n = 271733878,
        a = A,
        s = i,
        g = r,
        l = n,
        E = 0;
      E < t.length;
      E += 16
    )
      (a = A),
        (s = i),
        (g = r),
        (l = n),
        (A = ffOP(A, i, r, n, t[E], 7, -680876936)),
        (n = ffOP(n, A, i, r, t[E + 1], 12, -389564586)),
        (r = ffOP(r, n, A, i, t[E + 2], 17, 606105819)),
        (i = ffOP(i, r, n, A, t[E + 3], 22, -1044525330)),
        (A = ffOP(A, i, r, n, t[E + 4], 7, -176418897)),
        (n = ffOP(n, A, i, r, t[E + 5], 12, 1200080426)),
        (r = ffOP(r, n, A, i, t[E + 6], 17, -1473231341)),
        (i = ffOP(i, r, n, A, t[E + 7], 22, -45705983)),
        (A = ffOP(A, i, r, n, t[E + 8], 7, 1770035416)),
        (n = ffOP(n, A, i, r, t[E + 9], 12, -1958414417)),
        (r = ffOP(r, n, A, i, t[E + 10], 17, -42063)),
        (i = ffOP(i, r, n, A, t[E + 11], 22, -1990404162)),
        (A = ffOP(A, i, r, n, t[E + 12], 7, 1804603682)),
        (n = ffOP(n, A, i, r, t[E + 13], 12, -40341101)),
        (r = ffOP(r, n, A, i, t[E + 14], 17, -1502002290)),
        (A = ggOP(
          A,
          (i = ffOP(i, r, n, A, t[E + 15], 22, 1236535329)),
          r,
          n,
          t[E + 1],
          5,
          -165796510
        )),
        (n = ggOP(n, A, i, r, t[E + 6], 9, -1069501632)),
        (r = ggOP(r, n, A, i, t[E + 11], 14, 643717713)),
        (i = ggOP(i, r, n, A, t[E], 20, -373897302)),
        (A = ggOP(A, i, r, n, t[E + 5], 5, -701558691)),
        (n = ggOP(n, A, i, r, t[E + 10], 9, 38016083)),
        (r = ggOP(r, n, A, i, t[E + 15], 14, -660478335)),
        (i = ggOP(i, r, n, A, t[E + 4], 20, -405537848)),
        (A = ggOP(A, i, r, n, t[E + 9], 5, 568446438)),
        (n = ggOP(n, A, i, r, t[E + 14], 9, -1019803690)),
        (r = ggOP(r, n, A, i, t[E + 3], 14, -187363961)),
        (i = ggOP(i, r, n, A, t[E + 8], 20, 1163531501)),
        (A = ggOP(A, i, r, n, t[E + 13], 5, -1444681467)),
        (n = ggOP(n, A, i, r, t[E + 2], 9, -51403784)),
        (r = ggOP(r, n, A, i, t[E + 7], 14, 1735328473)),
        (A = hhOP(
          A,
          (i = ggOP(i, r, n, A, t[E + 12], 20, -1926607734)),
          r,
          n,
          t[E + 5],
          4,
          -378558
        )),
        (n = hhOP(n, A, i, r, t[E + 8], 11, -2022574463)),
        (r = hhOP(r, n, A, i, t[E + 11], 16, 1839030562)),
        (i = hhOP(i, r, n, A, t[E + 14], 23, -35309556)),
        (A = hhOP(A, i, r, n, t[E + 1], 4, -1530992060)),
        (n = hhOP(n, A, i, r, t[E + 4], 11, 1272893353)),
        (r = hhOP(r, n, A, i, t[E + 7], 16, -155497632)),
        (i = hhOP(i, r, n, A, t[E + 10], 23, -1094730640)),
        (A = hhOP(A, i, r, n, t[E + 13], 4, 681279174)),
        (n = hhOP(n, A, i, r, t[E], 11, -358537222)),
        (r = hhOP(r, n, A, i, t[E + 3], 16, -722521979)),
        (i = hhOP(i, r, n, A, t[E + 6], 23, 76029189)),
        (A = hhOP(A, i, r, n, t[E + 9], 4, -640364487)),
        (n = hhOP(n, A, i, r, t[E + 12], 11, -421815835)),
        (r = hhOP(r, n, A, i, t[E + 15], 16, 530742520)),
        (A = iiOP(
          A,
          (i = hhOP(i, r, n, A, t[E + 2], 23, -995338651)),
          r,
          n,
          t[E],
          6,
          -198630844
        )),
        (n = iiOP(n, A, i, r, t[E + 7], 10, 1126891415)),
        (r = iiOP(r, n, A, i, t[E + 14], 15, -1416354905)),
        (i = iiOP(i, r, n, A, t[E + 5], 21, -57434055)),
        (A = iiOP(A, i, r, n, t[E + 12], 6, 1700485571)),
        (n = iiOP(n, A, i, r, t[E + 3], 10, -1894986606)),
        (r = iiOP(r, n, A, i, t[E + 10], 15, -1051523)),
        (i = iiOP(i, r, n, A, t[E + 1], 21, -2054922799)),
        (A = iiOP(A, i, r, n, t[E + 8], 6, 1873313359)),
        (n = iiOP(n, A, i, r, t[E + 15], 10, -30611744)),
        (r = iiOP(r, n, A, i, t[E + 6], 15, -1560198380)),
        (i = iiOP(i, r, n, A, t[E + 13], 21, 1309151649)),
        (A = iiOP(A, i, r, n, t[E + 4], 6, -145523070)),
        (n = iiOP(n, A, i, r, t[E + 11], 10, -1120210379)),
        (r = iiOP(r, n, A, i, t[E + 2], 15, 718787259)),
        (i = iiOP(i, r, n, A, t[E + 9], 21, -343485551)),
        (A = safeAdd(A, a)),
        (i = safeAdd(i, s)),
        (r = safeAdd(r, g)),
        (n = safeAdd(n, l));
    return rawStringToHEX(littleEndianWordsToString([A, i, r, n]));
  }
  function cmnOP(e, t, o, A, i, r) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(t, e), safeAdd(A, r)), i), o);
  }
  function ffOP(e, t, o, A, i, r, n) {
    return cmnOP((t & o) | (~t & A), e, t, i, r, n);
  }
  function ggOP(e, t, o, A, i, r, n) {
    return cmnOP((t & A) | (o & ~A), e, t, i, r, n);
  }
  function hhOP(e, t, o, A, i, r, n) {
    return cmnOP(t ^ o ^ A, e, t, i, r, n);
  }
  function iiOP(e, t, o, A, i, r, n) {
    return cmnOP(o ^ (t | ~A), e, t, i, r, n);
  }
  function safeAdd(e, t) {
    var o = (65535 & e) + (65535 & t);
    return (((e >> 16) + (t >> 16) + (o >> 16)) << 16) | (65535 & o);
  }
  function bitRotateLeft(e, t) {
    return (e << t) | (e >>> (32 - t));
  }
  var msUnit = 0.001,
    step8Map = ((_a$1 = { 12e4: 3e4, 12e5: 6e4 }), (_a$1[1 / 0] = 3e5), _a$1),
    DEFAULT_KEYS = {
      uin: "",
      vid: COMMON_DATA_KEY.vid,
      coverid: COMMON_DATA_KEY.cid,
      pid: COMMON_DATA_KEY.flowid,
      guid: COMMON_DATA_KEY.guid,
      cmid: COMMON_DATA_KEY.guid,
      unid: "",
      vt: COMMON_DATA_KEY.cdnid,
      type: "",
      bi: COMMON_DATA_KEY.duration,
      bt: "",
      version: COMMON_DATA_KEY.playerver,
      platform: COMMON_DATA_KEY.platform,
      format: COMMON_DATA_KEY.fmt,
      defn: COMMON_DATA_KEY.currentDefn,
      ptag: "",
      isvip: COMMON_DATA_KEY.vip,
      tpid: "",
      pversion: "",
      hc_uin: "",
      hc_main_login: COMMON_DATA_KEY.hc_main_login,
      hc_vuserid: COMMON_DATA_KEY.hc_vuserid,
      hc_openid: COMMON_DATA_KEY.hc_openid,
      hc_appid: COMMON_DATA_KEY.hc_appid,
      hc_access_token: COMMON_DATA_KEY.hc_access_token,
      hc_pvid: "",
      hc_ssid: "",
      hc_qq: "",
      ua: COMMON_DATA_KEY.ua,
      hh_ua: COMMON_DATA_KEY.ua,
      ckey: "",
      ckeyVer: "",
      iformat: COMMON_DATA_KEY.fmt,
      hh_ref: COMMON_DATA_KEY.topUrl,
      vurl: "",
      v_idx: "",
      rcd_info: "",
      extrainfo: "",
      bucket_id: COMMON_DATA_KEY.testid,
      drm: COMMON_DATA_KEY.drm,
      pay_type: "",
      pcplatform: "",
      drmtype: COMMON_DATA_KEY.drmtype,
      insert_duration_ms: "",
      insert_flowid: "",
      vip_token: "",
      common_rcd_info: "",
      common_ext_info: "",
      common_json_info: "",
      qimei36: "",
      format_ua: "",
      triggerplay: "",
      tpay: "",
      cpay: "",
      dltype: COMMON_DATA_KEY.dltype,
      cginame: "",
      vtype: "",
      p2pVer: COMMON_DATA_KEY.p2pver,
      playertype: COMMON_DATA_KEY.playertype,
      start_play_position: "",
      end_play_position: "",
      is_auto_play: "",
      randoms: "",
    },
    VodFlowReporterPlugin = (function (e) {
      function t(t, o, A) {
        var i = e.call(this, t, o, A) || this;
        (i.FLOW_DATA_KEY = "__thumbplayer_vod_flow_report__"),
          (i.UNSAFE_KEY = ["hh_ref", "vurl"]),
          (i.startPlayTime = 0),
          (i.actualPlayTime = 0),
          (i.lastPlayTimeStamp = 0),
          (i.saveInterval = 0),
          (i.lastStep8PlayTime = 0),
          (i.lastStep9PlayTime = 0),
          (i.step8Seq = 0),
          (i.firstLoadCost = 0),
          (i.playStartPosition = 0),
          (i.playEndPosition = 0),
          (i.setEvtHandler = function () {
            i.msg.on(
              exports.PLAY_EVENT_EXT.DATASET_STATE_UPDATE,
              i.onDataStateChange
            ),
              i.player.on(exports.H5_PLAY_EVENT.VIDEO_PLAYING, i.onFirstPlay),
              i.player.on(exports.H5_PLAY_EVENT.AD_PLAYING, i.onAdPlaying),
              i.player.on(
                exports.H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
                i.onVideoTimeUpdate
              ),
              i.player.on(exports.PLAY_EVENT.STATE_CHANGE, i.onCoreStateChange),
              document.addEventListener(
                "visibilitychange",
                i.onVisibilityChange
              );
          }),
          (i.onVisibilityChange = function () {
            "hidden" === document.visibilityState
              ? i.saveData()
              : i.player &&
                i.removeFromLS(i.player.getCommonKv(COMMON_DATA_KEY.flowid));
          }),
          (i.stopSaveData = function () {
            i.saveInterval &&
              (window.clearInterval(i.saveInterval), (i.saveInterval = 0));
          }),
          (i.onAdPlaying = function () {
            i.step7();
          }),
          (i.onFirstPlay = function (e) {
            e.data.isFirst &&
              (i.lastPlayTimeStamp || (i.lastPlayTimeStamp = Date.now()),
              i.reportFirstPlaying());
          }),
          (i.reportFirstPlaying = function () {
            if (!i.reportedEvt.step6) {
              (i.reportedEvt.step6 = !0),
                (i.playStartPosition = i.player.playtime),
                (i.startPlayTime = Date.now());
              var e = {
                step: "6",
                val: safelyConvertToNumber(i.firstLoadCost),
                val1: i.reportedEvt.step7 ? 0 : 1,
                val2: 1,
                bi: 0,
                bt: safelyConvertToNumber(
                  i.player.getCommonKv(COMMON_DATA_KEY.duration),
                  !0
                ),
              };
              i.report(e);
            }
          }),
          (i.onCoreStateChange = function (e) {
            var t = e.data,
              o = t.new,
              A = t.old,
              r = Date.now();
            switch (o) {
              case exports.VIDEO_STATE.PLAYING:
                (A !== exports.VIDEO_STATE.PAUSE &&
                  A !== exports.VIDEO_STATE.CANPLAY) ||
                  (i.lastPlayTimeStamp = r);
                break;
              case exports.VIDEO_STATE.IDLE:
              case exports.VIDEO_STATE.PAUSE:
                A === exports.VIDEO_STATE.PLAYING &&
                  i.lastPlayTimeStamp &&
                  (i.actualPlayTime += r - i.lastPlayTimeStamp);
            }
            o === exports.VIDEO_STATE.PAUSE && i.step9();
          }),
          (i.onVideoTimeUpdate = function () {
            i.step8(), (i.playEndPosition = i.player.playtime);
          }),
          (i.saveData = function () {
            var e = i.player.getCommonKv(COMMON_DATA_KEY.flowid);
            if (e && !i.reportedEvt.step5) {
              var t = Date.now(),
                o = {
                  step: "5",
                  val: safelyConvertToNumber(
                    i.startPlayTime ? t - i.startPlayTime : 0,
                    !0
                  ),
                  val1: 2,
                  bi: safelyConvertToNumber(i.actualPlayTime * msUnit, !0),
                  bt: safelyConvertToNumber(
                    i.player.getCommonKv(COMMON_DATA_KEY.duration),
                    !0
                  ),
                  heartbeat: t,
                };
              i.saveToLS(e, __assign$1(__assign$1({}, i.reportHeader), o));
            }
          }),
          (i.onDataStateChange = function (e) {
            var t,
              o = e.data,
              A = o.key,
              r =
                (((t = {})[exports.DATA_STATE.GET_INFO_END] = i.step4),
                (t[exports.DATA_STATE.SESSION_END] = i.step5),
                (t[exports.DATA_STATE.LOAD_END] = i.onLoaded),
                (t[exports.DATA_STATE.SESSION_START] = i.onSessionStart),
                t);
            r[A] && r[A](o);
          }),
          (i.onLoaded = function (e) {
            var t = e.startEvent,
              o = e.newVal;
            i.firstLoadCost = o.ftime - (null == t ? void 0 : t.ftime);
          }),
          (i.onSessionStart = function () {
            (i.actualPlayTime = 0),
              (i.firstLoadCost = 0),
              (i.lastPlayTimeStamp = 0),
              (i.startPlayTime = 0),
              (i.lastStep8PlayTime = 0),
              (i.lastStep9PlayTime = 0),
              (i.reportedEvt = {}),
              i.reportPrev(),
              i.step3(),
              i.stopSaveData(),
              (i.saveInterval = window.setInterval(i.saveData, 5e3));
          }),
          (i.step3 = function () {
            var e = {
              step: "3",
              val: 0 === i.player.currentVideoInfoIdx ? 1 : 2,
            };
            i.report(e);
          }),
          (i.step7 = function () {
            i.reportedEvt.step7 ||
              ((i.reportedEvt.step7 = !0),
              i.report({ step: "7", val: 0, val1: 0 }));
          }),
          (i.step4 = function () {
            if (!i.reportedEvt.step4) {
              i.reportedEvt.step4 = !0;
              var e = {
                step: "4",
                val: 1,
                val1: 1,
                bi: H5Player.pluginExists(AdPluginName) ? 2 : 1,
              };
              i.report(e);
            }
          }),
          (i.step5 = function (e) {
            if (!i.reportedEvt.step5) {
              i.reportedEvt.step5 = !0;
              var t = e.newVal.code,
                o = i.startPlayTime ? Date.now() - i.startPlayTime : 0,
                A = {
                  step: "5",
                  val: Math.round(o),
                  val1: t !== exports.ErrorCode.SUC ? 2 : 1,
                  val2: 1,
                  bi: safelyConvertToNumber(i.actualPlayTime * msUnit, !0),
                  bt: safelyConvertToNumber(
                    i.player.getCommonKv(COMMON_DATA_KEY.duration),
                    !0
                  ),
                };
              i.report(A),
                i.step8(!0),
                i.step9(!0),
                i.removeFromLS(i.player.getCommonKv(COMMON_DATA_KEY.flowid)),
                i.stopSaveData();
            }
          }),
          (i.step8 = function (e) {
            if ((void 0 === e && (e = !1), i.lastPlayTimeStamp)) {
              var t = Date.now(),
                o = t - i.lastPlayTimeStamp,
                A = e ? i.actualPlayTime : i.actualPlayTime + o,
                r = +Object.keys(step8Map).find(function (e) {
                  return A < +e;
                }),
                n = A - i.lastStep8PlayTime;
              if (e || n >= step8Map[r]) {
                var a = {
                  step: "8",
                  val: safelyConvertToNumber(t - i.startPlayTime),
                  val1: e ? 1 : 4,
                  bi: safelyConvertToNumber(A * msUnit, !0),
                  bt: safelyConvertToNumber(
                    i.player.getCommonKv(COMMON_DATA_KEY.duration),
                    !0
                  ),
                  insert_duration_ms: n,
                };
                (i.lastStep8PlayTime = A), (i.step8Seq += 1), i.report(a);
              }
            }
          }),
          (i.step9 = function (e) {
            if (
              (void 0 === e && (e = !1),
              i.lastPlayTimeStamp &&
                i.lastPlayTimeStamp !== i.lastStep9PlayTime)
            ) {
              var t = {
                step: "9",
                val: safelyConvertToNumber(Date.now() - i.lastPlayTimeStamp),
                val1: e ? 1 : 4,
                val2: 1,
                bt: safelyConvertToNumber(
                  i.player.getCommonKv(COMMON_DATA_KEY.duration),
                  !0
                ),
              };
              i.report(t), (i.lastStep9PlayTime = i.lastPlayTimeStamp);
            }
          });
        var r = t.config.vodFlowReporterConfig;
        (null == r ? void 0 : r.releaseDelay) &&
          (i.RELEASE_DELAY = r.releaseDelay);
        var n = whichBoss(),
          a = n.id,
          s = n.token,
          g = r || {},
          l = g.id,
          E = g.token,
          c = g.devicePlatform,
          u = g.serviceURL,
          p = g.paramsKey,
          d = g.onBeforeReport,
          B = g.forceImage;
        return (
          (i.REPORT_URL = null != u ? u : "https://h.trace.qq.com/bosskv?"),
          (i.config = {
            paramsKey: __assign$1(__assign$1({}, DEFAULT_KEYS), p || {}),
            onBeforeReport: d,
            forceImage: B,
            id: null != l ? l : a,
            token: null != E ? E : s,
            devicePlatform:
              null != c ? c : uaTool$1.mobile ? "mobile" : "desktop",
          }),
          i.setEvtHandler(),
          i.reportPrev(),
          i
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "reportHeader", {
          get: function () {
            var e,
              t,
              o,
              A = this.player,
              i = A.getCommonKv,
              r = A.dataset,
              n = A.currentVideoInfoIdx,
              a = A.videoSize,
              s = void 0 === a ? { width: 0, height: 0 } : a,
              g = s.width,
              l = s.height,
              E = this.config,
              c = E.paramsKey,
              u = E.devicePlatform,
              p = r.visualStats,
              d = p.isPlayerInViewport,
              B = p.isTabFocused,
              h = {
                uin: i(c.uin) || getQQFromCookie(),
                vid: i(c.vid) || "",
                coverid: i(c.coverid) || "",
                pid: i(c.pid) || "",
                guid: i(c.guid) || "",
                cmid: i(c.guid) || "",
                unid: i(c.unid) || "",
                vt: i(c.vt) || "",
                type: i(c.type) || "",
                bi: i(c.bi) || 0,
                bt: i(c.bt) || 0,
                val: 0,
                val1: 0,
                val2: 0,
                version: i(c.version) || "",
                platform: i(c.platform) || "",
                format: i(c.format) || "",
                defn: i(c.defn) || "",
                ptag: i(c.ptag) || getPtag(),
                isvip: i(c.isvip) || -1,
                tpid: i(c.tpid) || "",
                pversion: "thumbplayer",
                hc_uin: i(c.hc_uin) || getQQFromCookie(),
                hc_main_login: i(c.hc_main_login) || "",
                hc_vuserid: i(c.hc_vuserid) || "",
                hc_openid: i(c.hc_openid) || "",
                hc_appid: i(c.hc_appid) || "",
                hc_pvid: i(c.hc_pvid) || cookieTool$1.get("pgv_pvid"),
                hc_ssid: i(c.hc_ssid) || "",
                hc_qq: i(c.hc_qq) || "",
                hc_access_token: i(c.hc_access_token) || "",
                ua: i(c.ua) || "",
                hh_ua: i(c.hh_ua) || "",
                ckey: i(c.ckey) || "",
                iformat: i(c.iformat) || "",
                hh_ref: i(c.hh_ref) || "",
                rcd_info: i(c.rcd_info) || "",
                extrainfo: i(c.extrainfo) || "",
                bucket_id: i(c.bucket_id) || "",
                pay_type: i(c.pay_type) || 0,
                idx: n || 0,
                diagonal: Math.round(
                  Math.sqrt(Math.pow(g, 2) + Math.pow(l, 2))
                ),
                vurl:
                  (null === (e = this.player.currentVideoInfo) || void 0 === e
                    ? void 0
                    : e.loadingUrl) || i(c.vurl),
                v_idx: this.player.currentVideoInfoIdx || 0,
                ctime: commonTool$1.dateFormat(void 0, void 0),
                url: document.URL,
                ref_url: document.referrer,
                attaid: this.config.id,
                token: this.config.token,
                isfocustab: B,
                isvisible: d,
                format_ua: i(c.format_ua) || getFormatUA(),
                pcplatform: i(c.pcplatform) || "web",
                drm: i(c.drm) ? 1 : 0,
                insert_flowid: this.step8Seq,
                vip_token: i(c.vip_token) || 0,
                tpay: i(c.tpay) || 0,
                kernel: this.player.kernelName || "",
                drmtype: i(c.drmtype) || 0,
              };
            return (
              "mobile" === u &&
                ((h.common_rcd_info = i(c.common_rcd_info) || ""),
                (h.common_ext_info = i(c.common_ext_info) || ""),
                (h.common_json_info = i(c.common_json_info) || ""),
                (h.qimei36 = i(c.qimei36) || "")),
              ("desktop" !== u && "ott" !== u) ||
                ((h.triggerplay =
                  null !== (t = i(c.triggerplay)) && void 0 !== t ? t : 1),
                (h.cpay = i(c.cpay) || 0),
                (h.dltype = i(c.dltype) || 0),
                (h.cginame = i(c.cginame) || ""),
                (h.vtype = i(c.vtype) || ""),
                (h.ckeyVer = i(c.ckeyVer) || ""),
                (h.p2pVer = i(c.p2pVer) || ""),
                (h.playertype = i(c.playertype) || ""),
                (h.sdk_extrainfo = jsonTool$1.safelyStringify({
                  play_start_position: this.playStartPosition,
                  play_end_position: this.playEndPosition,
                  is_auto_play:
                    null !== (o = i(c.is_auto_play)) && void 0 !== o ? o : 1,
                  randoms: md5("" + h.guid + h.pid),
                }))),
              h
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.destroy = function () {
          this.stopSaveData(),
            document.removeEventListener(
              "visibilitychange",
              this.onVisibilityChange
            ),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.report = function (t) {
          if (this.player.getCommonKv(COMMON_DATA_KEY.vid))
            return "function" == typeof this.config.onBeforeReport
              ? e.prototype.report.call(this, this.config.onBeforeReport(t))
              : e.prototype.report.call(this, t);
        }),
        (t.pluginName = "vod-flow-reporter"),
        t
      );
    })(BaseReporter);
  function whichBoss() {
    return uaTool$1.mobile
      ? { id: MOBILE_ATTAID, token: MOBILE_ATTA_TOKEN }
      : { id: DESKTOP_ATTAID, token: DESKTOP_ATTA_TOKEN };
  }
  function getFormatUA() {
    var e = "other",
      t = uaTool$1.browser,
      o = uaTool$1.os;
    return (
      t.qqlive &&
        (o.iphone ? (e = "iphone_qqlive") : o.android && (e = "aphone_qqlive")),
      e
    );
  }
  var DESKTOP_ATTAID = "z4900004298",
    DESKTOP_ATTA_TOKEN = "4973349567",
    MOBILE_ATTAID = "z3000002865",
    MOBILE_ATTA_TOKEN = "4135796792",
    VodFlyReporterPlugin = (function (e) {
      function t(t, o, A) {
        var i,
          r,
          n,
          a,
          s = e.call(this, t, o, A) || this;
        (s.seq = 0),
          (s.getinfoStartTime = null),
          (s.getinfoEndTime = null),
          (s.bufferReportCached = []),
          (s.seekReportCached = []),
          (s.playEndPosition = 0),
          (s.playStartPosition = 0),
          (s.videoFirstFrameTime = 0),
          (s.lastFmtId = 0),
          (s.reported = {}),
          (s.playDuration = 0),
          (s.onPageHide = function () {
            s.player.state !== exports.VIDEO_STATE.IDLE &&
              s.handlePageHide({
                step: "50",
                data: stringifyAndReplaceCommaInParams(
                  __assign$1(__assign$1({}, s.prepareStep50Data()), {
                    reason: 2,
                    code: "0.0",
                  })
                ),
              });
          }),
          (s.onDataSetStateUpdate = function (e) {
            var t,
              o = e.data.key,
              A =
                (((t = {})[exports.DATA_STATE.LOAD_END] = s.step30),
                (t[exports.DATA_STATE.SET_LEVEL_END] = s.step45),
                (t[exports.DATA_STATE.BUFFER_END] = s.recordStep35),
                (t[exports.DATA_STATE.SEEK_END] = s.recordStep40),
                (t[exports.DATA_STATE.SUBTITLE_END] = s.step33),
                t);
            A[o] && A[o].call(s, e);
          }),
          (s.onGetinfoStart = function () {
            var e;
            (null !== (e = s.getinfoStartTime) && void 0 !== e) ||
              (s.getinfoStartTime = Date.now());
          }),
          (s.onGetinfoOver = function (e) {
            var t,
              o,
              A,
              i = e.data,
              r = i.parseData,
              n = i.resData,
              a = r || {},
              g = a.definitionList,
              l = void 0 === g ? [] : g,
              E = a.vitem,
              c = void 0 === E ? {} : E,
              u = c.fc,
              p = void 0 === u ? 0 : u,
              d = c.br,
              B = void 0 === d ? 0 : d,
              h = c.vst,
              I = void 0 === h ? 0 : h,
              C = c.type,
              _ = void 0 === C ? 0 : C,
              f =
                null !==
                  (o =
                    null ===
                      (t =
                        null == l
                          ? void 0
                          : l.find(function (e) {
                              return e.sl;
                            })) || void 0 === t
                      ? void 0
                      : t.id) && void 0 !== o
                  ? o
                  : -1;
            (s.videoInfoParams = {
              dltype: null == n ? void 0 : n.dltype,
              duration: null == r ? void 0 : r.duration,
              type: _,
              clip: p,
              status: I,
            }),
              s.firstLoadVideoInfoParam ||
                (s.firstLoadVideoInfoParam = { fmt: f, rate: B }),
              (s.rawGetinfoData = n),
              (null !== (A = s.getinfoEndTime) && void 0 !== A) ||
                (s.getinfoEndTime = Date.now());
          }),
          (s.onVideoSetLevelStart = function (e) {
            (s.lastFmtId = s.currentFmtId), s.reportStep35and40();
          }),
          (s.onVideoTimeUpdate = function () {
            (s.playEndPosition = s.player.playtime),
              (s.playDuration = Math.max(
                s.playDuration,
                s.player.dataset.getStats().playDuration
              ));
          }),
          (s.onVideoFirstPlaying = function (e) {
            e.data.isFirst && (s.videoFirstFrameTime = Date.now());
          }),
          (s.step50 = function (e) {
            if (!s.reported[50]) {
              s.reported[50] = !0;
              var t = e.data,
                o = t.code,
                A = t.endState;
              s.report({
                step: "50",
                data: stringifyAndReplaceCommaInParams(
                  __assign$1(__assign$1({}, s.prepareStep50Data()), {
                    reason: A === exports.END_STATE.NORMAL ? 0 : 1,
                    code: "0." + filterErrorCode(o),
                  })
                ),
              }),
                s.reportStep35and40(),
                s.cleanUp();
            }
          }),
          (s.keyMapping = __assign$1(
            __assign$1({}, defaultKeys),
            null === (i = t.config.vodFlyReporterConfig) || void 0 === i
              ? void 0
              : i.paramsKey
          )),
          (s.signer =
            null !==
              (n =
                null === (r = t.config.vodFlyReporterConfig) || void 0 === r
                  ? void 0
                  : r.signer) && void 0 !== n
              ? n
              : function () {
                  return __awaiter$1(s, void 0, void 0, function () {
                    return __generator$1(this, function (e) {
                      return [2, {}];
                    });
                  });
                });
        var g =
            null === (a = t.config.vodFlyReporterConfig) || void 0 === a
              ? void 0
              : a.isOversea,
          l = { appKey: g ? OVERSEA_APP_KEY : APP_KEY, isOversea: g };
        return (
          (s.REPORT_KEY = l.appKey),
          s.bindEventHandlers(),
          BeaconRequest.register(l),
          (s.reporterForPageHide = BeaconRequest.reportWhenPageHide),
          (s.reporter = BeaconRequest.report),
          s
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.destroy = function () {
          this.unbindEventHandlers(), e.prototype.destroy.call(this);
        }),
        Object.defineProperty(t.prototype, "reportHeader", {
          get: function () {
            var e = this,
              t = Object.keys(this.keyMapping).reduce(function (t, o) {
                return (
                  e.keyMapping[o] &&
                    (t[o] = e.player.getCommonKv(e.keyMapping[o]) || ""),
                  t
                );
              }, {});
            return __assign$1(
              __assign$1(
                __assign$1(__assign$1({}, t), this.videoInfoParams),
                this.firstLoadVideoInfoParam
              ),
              {
                downloadkit: +!!this.player.config.enableP2P,
                seq: this.seq,
                stepname: REPORT_EVENT_ID,
              }
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.report = function (e) {
          var t = this;
          if (
            this.player.getCommonKv(COMMON_DATA_KEY.vid) &&
            !uaTool$1.spider
          ) {
            var o = __assign$1(__assign$1({}, this.reportHeader), e);
            this.signer(o).then(function (e) {
              t.reporter({
                data: __assign$1(__assign$1({}, o), e),
                url: t.REPORT_URL,
                key: t.REPORT_KEY,
              }),
                (t.seq += 1);
            });
          }
        }),
        Object.defineProperty(t.prototype, "currentUrlInfo", {
          get: function () {
            var e, t, o;
            if (!this.player.currentVideoInfo || !this.rawGetinfoData)
              return [-1, null];
            var A =
                (null ===
                  (o =
                    null ===
                      (t =
                        null === (e = this.rawGetinfoData.vl) || void 0 === e
                          ? void 0
                          : e.vi[0]) || void 0 === t
                      ? void 0
                      : t.ul) || void 0 === o
                  ? void 0
                  : o.ui) || [],
              i = urlTool$1.getDomainOfURL(
                this.player.currentVideoInfo.loadingUrl
              ),
              r =
                null == A
                  ? void 0
                  : A.findIndex(function (e) {
                      return urlTool$1.getDomainOfURL(e.url) === i;
                    });
            return [r, A[r]];
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "currentFmtId", {
          get: function () {
            var e, t, o, A;
            return this.rawGetinfoData &&
              null !==
                (A =
                  null ===
                    (o =
                      null ===
                        (t =
                          null === (e = this.rawGetinfoData.fl) || void 0 === e
                            ? void 0
                            : e.fi) || void 0 === t
                        ? void 0
                        : t.find(function (e) {
                            return e.sl;
                          })) || void 0 === o
                    ? void 0
                    : o.id) &&
              void 0 !== A
              ? A
              : 0;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.bindEventHandlers = function () {
          this.msg.on(
            exports.PLAY_EVENT_EXT.DATASET_STATE_UPDATE,
            this.onDataSetStateUpdate
          ),
            this.msg.on(
              exports.PLAY_EVENT_EXT.GETINFO_OVER,
              this.onGetinfoOver
            ),
            this.msg.on(
              exports.PLAY_EVENT_EXT.GETINFO_START,
              this.onGetinfoStart
            ),
            this.player.on(exports.H5_PLAY_EVENT.PLAY_SESSION_END, this.step50),
            this.player.on(
              exports.H5_PLAY_EVENT.VIDEO_PLAYING,
              this.onVideoFirstPlaying
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
              this.onVideoTimeUpdate
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_START,
              this.onVideoSetLevelStart
            ),
            window.addEventListener("pagehide", this.onPageHide);
        }),
        (t.prototype.unbindEventHandlers = function () {
          this.msg.off(
            exports.PLAY_EVENT_EXT.DATASET_STATE_UPDATE,
            this.onDataSetStateUpdate
          ),
            this.msg.off(
              exports.PLAY_EVENT_EXT.GETINFO_OVER,
              this.onGetinfoOver
            ),
            this.msg.off(
              exports.PLAY_EVENT_EXT.GETINFO_START,
              this.onGetinfoStart
            ),
            this.player.off(
              exports.H5_PLAY_EVENT.PLAY_SESSION_END,
              this.step50
            ),
            this.player.off(
              exports.H5_PLAY_EVENT.VIDEO_PLAYING,
              this.onVideoFirstPlaying
            ),
            this.player.off(
              exports.H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
              this.onVideoTimeUpdate
            ),
            this.player.off(
              exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_START,
              this.onVideoSetLevelStart
            ),
            window.removeEventListener("pagehide", this.onPageHide);
        }),
        (t.prototype.step30 = function (e) {
          var t;
          if (!this.reported[30]) {
            this.reported[30] = !0;
            var o = e.data,
              A = o.newVal,
              i = o.startEvent,
              r = i.ftime,
              n = i.currentUrl,
              a = A.ftime,
              s = this.currentUrlInfo,
              g = s[0],
              l = s[1],
              E = null == l ? void 0 : l.vt;
            (this.playStartPosition = this.player.playtime),
              this.report({
                step: "30",
                data: stringifyAndReplaceCommaInParams({
                  stime: r,
                  etime: a,
                  pstime: this.playStartPosition,
                  vt: E,
                  urlindex: g,
                  reason: "",
                  code: "0." + (null !== (t = A.code) && void 0 !== t ? t : 0),
                  url: n,
                }),
              });
          }
        }),
        (t.prototype.step33 = function (e) {
          var t = e.data.newVal.ext;
          this.report({
            step: "33",
            data: stringifyAndReplaceCommaInParams(t),
          });
        }),
        (t.prototype.recordStep35 = function (e) {
          var t,
            o = e.data,
            A = o.newVal,
            i = o.startEvent,
            r = i.ftime,
            n = i.playbackRate,
            a = i.playtime,
            s = A.ftime,
            g = A.currentUrl,
            l = 1 !== n ? 2 : 1;
          this.bufferReportCached.push({
            stime: r,
            etime: s,
            ptime: a,
            format: this.currentFmtId,
            url: g,
            scene: l,
            reason: 0,
            code: "0." + (null !== (t = A.code) && void 0 !== t ? t : 0),
          });
        }),
        (t.prototype.recordStep40 = function (e) {
          var t,
            o = e.data,
            A = o.newVal,
            i = o.startEvent,
            r = i.ftime,
            n = i.playtime,
            a = A.ftime,
            s = A.playtime;
          this.seekReportCached.push({
            lstime: r,
            letime: a,
            pstime: n,
            petime: s,
            format: this.currentFmtId,
            code: "0." + (null !== (t = A.code) && void 0 !== t ? t : 0),
          });
        }),
        (t.prototype.step45 = function (e) {
          var t,
            o = e.data,
            A = o.newVal,
            i = o.startEvent,
            r = i.ftime,
            n = i.ext,
            a = i.playtime,
            s = A.ftime,
            g = A.playtime,
            l = A.currentUrl,
            E = n.mode,
            c = this.currentUrlInfo,
            u = c[0],
            p = c[1],
            d = null == p ? void 0 : p.vt;
          this.report({
            step: "45",
            data: stringifyAndReplaceCommaInParams({
              stime: E === SET_LEVEL_MODE.SMOOTH ? s : r,
              etime: s,
              pstime: a,
              petime: g,
              auto: 1,
              prefmt: this.lastFmtId,
              postftm: this.currentFmtId,
              url: l,
              vt: d,
              urlindex: u,
              code: "0." + (null !== (t = A.code) && void 0 !== t ? t : 0),
            }),
          });
        }),
        (t.prototype.reportStep35and40 = function () {
          var e = this.bufferReportCached,
            t = this.seekReportCached;
          if (e.length) {
            var o = e.reduce(
                function (e, t) {
                  return t.etime - t.stime <= STALLED_THRESHOLD
                    ? e
                    : [e[0] + 1, e[1] + (t.etime - t.stime)];
                },
                [0, 0]
              ),
              A = o[0],
              i = o[1];
            this.report({
              step: "35",
              data: stringifyAndReplaceCommaInParams({
                tcount: A,
                tduration: i,
                val: this.bufferReportCached.slice(0, BUFFER_REPORT_LIMIT),
              }),
            });
          }
          if (t.length) {
            var r = t.reduce(
                function (e, t) {
                  return t.letime - t.lstime <= STALLED_THRESHOLD
                    ? [e[0] + 1, e[1], e[2]]
                    : [e[0] + 1, e[1] + 1, e[2] + (t.letime - t.lstime)];
                },
                [0, 0, 0]
              ),
              n = ((A = r[0]), r[1]),
              a = r[2];
            this.report({
              step: "40",
              data: stringifyAndReplaceCommaInParams({
                tcount: A,
                tbcount: n,
                tbduration: a,
                val: this.seekReportCached.slice(0, SEEK_REPORT_LIMIT),
              }),
            });
          }
          (this.bufferReportCached = []), (this.seekReportCached = []);
        }),
        (t.prototype.prepareStep50Data = function () {
          return {
            etime: Date.now(),
            pstime: this.playStartPosition,
            petime: this.playEndPosition,
            vinfostime: this.getinfoStartTime,
            vinfoetime: this.getinfoEndTime,
            video1stframestime: this.videoFirstFrameTime,
            video1stframeetime: this.videoFirstFrameTime,
            hevclv: videoTool$1.supportHevc() ? 28 : 0,
            playduration: this.playDuration,
          };
        }),
        (t.prototype.cleanUp = function () {
          (this.bufferReportCached = []),
            (this.seekReportCached = []),
            (this.rawGetinfoData = null),
            (this.firstLoadVideoInfoParam = null),
            (this.videoInfoParams = null),
            (this.seq = 0),
            (this.getinfoStartTime = 0),
            (this.playEndPosition = 0),
            (this.playStartPosition = 0),
            (this.playDuration = 0),
            (this.getinfoStartTime = null),
            (this.getinfoEndTime = null),
            (this.videoFirstFrameTime = 0),
            (this.lastFmtId = 0),
            (this.reported = {});
        }),
        (t.pluginName = "vod-fly-reporter"),
        t
      );
    })(BaseReporter),
    defaultKeys = {
      stepname: "",
      seq: "",
      vuid: COMMON_DATA_KEY.hc_vuserid,
      guid: COMMON_DATA_KEY.guid,
      vip: "",
      online: "",
      p2p: COMMON_DATA_KEY.p2p,
      downloadkit: "",
      resolution: COMMON_DATA_KEY.resolution,
      testid: COMMON_DATA_KEY.testid,
      osver: COMMON_DATA_KEY.osver,
      playerver: COMMON_DATA_KEY.playerver,
      playertype: COMMON_DATA_KEY.playertype,
      uip: COMMON_DATA_KEY.uip,
      cdnip: COMMON_DATA_KEY.cdnip,
      cdnid: COMMON_DATA_KEY.cdnid,
      cdnuip: COMMON_DATA_KEY.uip,
      freetype: "",
      network: "",
      speed: "",
      device: COMMON_DATA_KEY.device,
      appver: COMMON_DATA_KEY.appVer,
      p2pver: COMMON_DATA_KEY.p2pver,
      flowid: COMMON_DATA_KEY.flowid,
      platform: COMMON_DATA_KEY.platform,
      vid: COMMON_DATA_KEY.vid,
      bizid: "",
      url: COMMON_DATA_KEY.url,
      refer: COMMON_DATA_KEY.referrer,
      cid: COMMON_DATA_KEY.cid,
      ua: COMMON_DATA_KEY.ua,
      ptag: COMMON_DATA_KEY.ptag,
      dltype: "",
      fmt: "",
      rate: "",
      clip: "",
      status: "",
      type: "",
      duration: "",
      ext: "",
      drm: "",
      purevid: "",
    },
    BUFFER_REPORT_LIMIT = 20,
    SEEK_REPORT_LIMIT = 20,
    STALLED_THRESHOLD = 1200,
    REPORT_EVENT_ID = "boss_cmd_player_quality_feitian",
    ErrorCodeWhiteList = [exports.ErrorCode.GETINFO_SERVER_CODE_PREFIX + "083"];
  function filterErrorCode(e) {
    return ErrorCodeWhiteList.find(function (t) {
      return e.startsWith(t);
    })
      ? exports.ErrorCode.SUC
      : e;
  }
  H5Player.registerPlugin(
    VodFlowReporterPlugin.pluginName,
    VodFlowReporterPlugin
  ),
    H5Player.registerPlugin(
      LiveFlowReporterPlugin.pluginName,
      LiveFlowReporterPlugin
    ),
    H5Player.registerPlugin(
      VodFlyReporterPlugin.pluginName,
      VodFlyReporterPlugin
    ),
    H5Player.registerPlugin(
      LiveFlyReporterPlugin.pluginName,
      LiveFlyReporterPlugin
    );
  var IS_QQ_DOMAIN = /.*\.?qq\.com/g.test(
      urlTool$1.getDomainOfURL(location.href)
    ),
    _a$3,
    reporterConfig =
      ((_a$3 = {}),
      (_a$3[exports.PLAY_MODE.VOD] = [
        VodFlowReporterPlugin.pluginName,
        VodFlyReporterPlugin.pluginName,
      ]),
      (_a$3[exports.PLAY_MODE.LIVE] = [
        LiveFlowReporterPlugin.pluginName,
        LiveFlyReporterPlugin.pluginName,
      ]),
      _a$3);
  !(function (e) {
    __extends$1(function () {
      return (null !== e && e.apply(this, arguments)) || this;
    }, e);
  })(LiveFlowReporterPlugin);
  var ReporterController = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.onSessionStart = function () {
            t.player.setCommonKv(isAutoPlay, 1);
          }),
          (t.onPlayBtnClick = function (e) {
            var o;
            "play" ===
              (null === (o = e.data) || void 0 === o ? void 0 : o.status) &&
              t.player.setCommonKv(isAutoPlay, 0);
          }),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.init = function () {
          (this.ctrlbarPlugin = this.player.plugins[OFFICIAL_PLUGIN.CTRLBAR]),
            this.mergePlayerConfig(),
            this.installReporter(),
            this.setupEventListeners();
        }),
        (t.prototype.destroy = function () {
          this.removeEventListeners(), e.prototype.destroy.call(this);
        }),
        (t.prototype.setupEventListeners = function () {
          var e;
          this.player.on(
            exports.H5_PLAY_EVENT.PLAY_SESSION_START,
            this.onSessionStart
          ),
            null === (e = this.ctrlbarPlugin) ||
              void 0 === e ||
              e.on("ctrl:click-playbtn", this.onPlayBtnClick);
        }),
        (t.prototype.removeEventListeners = function () {
          var e;
          this.player.off(
            exports.H5_PLAY_EVENT.PLAY_SESSION_START,
            this.onSessionStart
          ),
            null === (e = this.ctrlbarPlugin) ||
              void 0 === e ||
              e.off("ctrl:click-playbtn", this.onPlayBtnClick);
        }),
        (t.prototype.mergePlayerConfig = function () {
          var e,
            t,
            o,
            A,
            i,
            r = {},
            n = this.player.config,
            a = n.type;
          a === exports.PLAY_MODE.VOD &&
            ((r.vodFlowReporterConfig = __assign$1(
              __assign$1(
                { forceImage: !IS_QQ_DOMAIN },
                null == n ? void 0 : n.vodFlowReporterConfig
              ),
              {
                paramsKey: __assign$1(
                  {
                    tpay: VOD_GET_INFO_DATA_KEYS.videoCharged,
                    vtype: VOD_GET_INFO_DATA_KEYS.videoType,
                    ckeyVer: VOD_GET_INFO_DATA_KEYS.ckeyVersion,
                    pay_type: VOD_GET_INFO_DATA_KEYS.userPayType,
                    vurl: VOD_GET_INFO_DATA_KEYS.vurl,
                    is_auto_play: isAutoPlay,
                  },
                  null === (e = null == n ? void 0 : n.vodFlowReporterConfig) ||
                    void 0 === e
                    ? void 0
                    : e.paramsKey
                ),
              }
            )),
            (r.vodFlyReporterConfig = __assign$1(
              __assign$1({}, null == n ? void 0 : n.vodFlyReporterConfig),
              {
                paramsKey: __assign$1(
                  { ext: "TEE_CONTEXT_DATA" },
                  null === (t = null == n ? void 0 : n.vodFlyReporterConfig) ||
                    void 0 === t
                    ? void 0
                    : t.paramsKey
                ),
              }
            ))),
            a === exports.PLAY_MODE.LIVE &&
              ((r.liveQaReporterConfig = __assign$1(
                __assign$1({}, null == n ? void 0 : n.liveQaReporterConfig),
                {
                  paramsKey: __assign$1(
                    {
                      sid: LIVE_GET_INFO_DATA_KEYS.livesid,
                      isuserpay: LIVE_GET_INFO_DATA_KEYS.isuserpay,
                      playtime: LIVE_GET_INFO_DATA_KEYS.playtime,
                    },
                    null ===
                      (o = null == n ? void 0 : n.liveQaReporterConfig) ||
                      void 0 === o
                      ? void 0
                      : o.paramsKey
                  ),
                }
              )),
              (r.liveFlowReporterConfig = __assign$1(
                __assign$1(
                  { forceImage: !IS_QQ_DOMAIN },
                  null == n ? void 0 : n.liveFlowReporterConfig
                ),
                {
                  paramsKey: __assign$1(
                    {
                      sid: LIVE_GET_INFO_DATA_KEYS.livesid,
                      cpay: LIVE_GET_INFO_DATA_KEYS.isuserpay,
                      tpay: LIVE_GET_INFO_DATA_KEYS.pay_type,
                      playtime: LIVE_GET_INFO_DATA_KEYS.playtime,
                      rest_preview_cnt: LIVE_GET_INFO_DATA_KEYS.restpreviewcnt,
                    },
                    null ===
                      (A = null == n ? void 0 : n.liveFlowReporterConfig) ||
                      void 0 === A
                      ? void 0
                      : A.paramsKey
                  ),
                }
              )),
              (r.liveFlyReporterConfig = __assign$1(
                __assign$1({}, null == n ? void 0 : n.liveFlyReporterConfig),
                {
                  paramsKey: __assign$1(
                    {},
                    null ===
                      (i = null == n ? void 0 : n.liveFlyReporterConfig) ||
                      void 0 === i
                      ? void 0
                      : i.paramsKey
                  ),
                }
              ))),
            Object.assign(this.player.config, r);
        }),
        (t.prototype.installReporter = function () {
          if (this.player.config.type) {
            var e = reporterConfig[this.player.config.type];
            this.checkIfReporterExist(e)
              ? this.warn(
                  "reporter already detected, skip install, probably due to <1.7.4 version of SuperPlayer"
                )
              : this.player.createPlugins(e);
          }
        }),
        (t.prototype.checkIfReporterExist = function (e) {
          var t = this;
          return e.some(function (e) {
            return !!t.player.plugins[e];
          });
        }),
        (t.moduleName = "reporter-controller"),
        t
      );
    })(Controller),
    isAutoPlay = "tvx_is_auto_play";
  function deviceCheck() {
    var e = 0,
      t = function (t) {
        e |= t();
      };
    return (
      t(function () {
        return videoTool$1.isVideoCanPlayType('video/mp4; codecs="avc1.42E01E"')
          ? 0
          : 1;
      }),
      t(function () {
        return navigator.webdriver ? 2 : 0;
      }),
      t(function () {
        return uaTool$1.spider ? 4 : 0;
      }),
      t(function () {
        return uaTool$1.headless ? 8 : 0;
      }),
      t(function () {
        return 0 === window.outerWidth && 0 === window.outerHeight ? 16 : 0;
      }),
      t(function () {
        return navigator.onLine ? 0 : 32;
      }),
      t(function () {
        var e;
        return (null === (e = navigator.plugins) || void 0 === e
          ? void 0
          : e.length) > 0
          ? 0
          : 64;
      }),
      t(function () {
        var e;
        return (null === (e = navigator.mimeTypes) || void 0 === e
          ? void 0
          : e.length) > 0
          ? 0
          : 128;
      }),
      t(function () {
        return uaTool$1.browser.chrome &&
          commonTool$1.compareVersion(uaTool$1.browser.chrome.version, "57") &&
          !videoTool$1.isWasmSupported()
          ? 256
          : 0;
      }),
      e
    );
  }
  var testScore = deviceCheck(),
    GuardController = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.onPlaySessionEnd = t.suspiciousDeviceHandlerFactory("report")),
          (t.blockSuspiciousDevice = function (e) {
            return (
              t.warn("device score not pass, block play"),
              TVKError({
                code: 1,
                fatal: !0,
                message: compile(tvkI18nConfig.DEVICE_SCORE_NOT_PASS),
                detail: testScore,
                debugMessage: "device score="
                  .concat(testScore, ";mask=")
                  .concat(e),
              })
            );
          }),
          (t.reportSuspiciousDevice = function (e) {
            var o;
            return (
              t.warn("device score not pass, upload log", e),
              null === (o = t.player.offlineLog) ||
                void 0 === o ||
                o.reportLogs({ reportSource: "tvk-device-score" }),
              null
            );
          }),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.init = function () {
          this.patchPlayerConfig(),
            this.setupEventListeners(),
            this.player.setCommonKv(COMMON_DATA_KEY.deviceScore, testScore);
        }),
        (t.prototype.destroy = function () {
          this.removeEventListeners();
        }),
        (t.prototype.setupEventListeners = function () {
          this.player.on(
            exports.H5_PLAY_EVENT.PLAY_SESSION_END,
            this.onPlaySessionEnd
          );
        }),
        (t.prototype.removeEventListeners = function () {
          this.player.off(
            exports.H5_PLAY_EVENT.PLAY_SESSION_END,
            this.onPlaySessionEnd
          );
        }),
        (t.prototype.patchPlayerConfig = function () {
          this.player.config.prerequisiteCheck =
            this.suspiciousDeviceHandlerFactory("block");
        }),
        (t.prototype.suspiciousDeviceHandlerFactory = function (e) {
          var t,
            o,
            A = this,
            i = this.tvk.config,
            r = i.scoreMaskForBlocking,
            n = i.scoreMaskForReporting,
            a =
              (((t = {}).block = this.blockSuspiciousDevice),
              (t.report = this.reportSuspiciousDevice),
              t),
            s = (((o = {}).block = r), (o.report = n), o);
          return function () {
            return (
              A.log(
                "check score for "
                  .concat(e, ", device score=")
                  .concat(testScore, ";mask=")
                  .concat(s[e])
              ),
              testScore & s[e] ? a[e](s[e]) : null
            );
          };
        }),
        (t.moduleName = "guard-controller"),
        t
      );
    })(Controller),
    moduleQimei = {};
  function a$3(e, t) {
    return null != t && "undefined" != typeof Symbol && t[Symbol.hasInstance]
      ? !!t[Symbol.hasInstance](e)
      : e instanceof t;
  }
  !(function () {
    function e(e, t, o) {
      try {
        return e();
      } catch (e) {
        return "function" == typeof o ? o(e) : t;
      }
    }
    "function" != typeof Object.assign &&
      (Object.assign = function (e) {
        if (null == e)
          throw new TypeError("Cannot convert undefined or null to object");
        for (var t = Object(e), o = 1; o < arguments.length; o++) {
          var A = arguments[o];
          if (null != A) for (var i in A) A.hasOwnProperty(i) && (t[i] = A[i]);
        }
        return t;
      });
    var t = function (t) {
        return e(function () {
          for (
            var e = "".concat(t, "="), o = document.cookie.split(";"), A = 0;
            A < o.length;
            A++
          ) {
            var i = o[A].trim();
            if (0 === i.indexOf(e)) return i.substring(e.length, i.length);
          }
          return "";
        }, "");
      },
      o = function (e, t) {
        var o = function (e, t) {
            (e = [e[0] >>> 16, 65535 & e[0], e[1] >>> 16, 65535 & e[1]]),
              (t = [t[0] >>> 16, 65535 & t[0], t[1] >>> 16, 65535 & t[1]]);
            var o = [0, 0, 0, 0];
            return (
              (o[3] += e[3] + t[3]),
              (o[2] += o[3] >>> 16),
              (o[3] &= 65535),
              (o[2] += e[2] + t[2]),
              (o[1] += o[2] >>> 16),
              (o[2] &= 65535),
              (o[1] += e[1] + t[1]),
              (o[0] += o[1] >>> 16),
              (o[1] &= 65535),
              (o[0] += e[0] + t[0]),
              (o[0] &= 65535),
              [(o[0] << 16) | o[1], (o[2] << 16) | o[3]]
            );
          },
          A = function (e, t) {
            (e = [e[0] >>> 16, 65535 & e[0], e[1] >>> 16, 65535 & e[1]]),
              (t = [t[0] >>> 16, 65535 & t[0], t[1] >>> 16, 65535 & t[1]]);
            var o = [0, 0, 0, 0];
            return (
              (o[3] += e[3] * t[3]),
              (o[2] += o[3] >>> 16),
              (o[3] &= 65535),
              (o[2] += e[2] * t[3]),
              (o[1] += o[2] >>> 16),
              (o[2] &= 65535),
              (o[2] += e[3] * t[2]),
              (o[1] += o[2] >>> 16),
              (o[2] &= 65535),
              (o[1] += e[1] * t[3]),
              (o[0] += o[1] >>> 16),
              (o[1] &= 65535),
              (o[1] += e[2] * t[2]),
              (o[0] += o[1] >>> 16),
              (o[1] &= 65535),
              (o[1] += e[3] * t[1]),
              (o[0] += o[1] >>> 16),
              (o[1] &= 65535),
              (o[0] += e[0] * t[3] + e[1] * t[2] + e[2] * t[1] + e[3] * t[0]),
              (o[0] &= 65535),
              [(o[0] << 16) | o[1], (o[2] << 16) | o[3]]
            );
          },
          i = function (e, t) {
            return 32 == (t %= 64)
              ? [e[1], e[0]]
              : t < 32
              ? [
                  (e[0] << t) | (e[1] >>> (32 - t)),
                  (e[1] << t) | (e[0] >>> (32 - t)),
                ]
              : ((t -= 32),
                [
                  (e[1] << t) | (e[0] >>> (32 - t)),
                  (e[0] << t) | (e[1] >>> (32 - t)),
                ]);
          },
          r = function (e, t) {
            return 0 == (t %= 64)
              ? e
              : t < 32
              ? [(e[0] << t) | (e[1] >>> (32 - t)), e[1] << t]
              : [e[1] << (t - 32), 0];
          },
          n = function (e, t) {
            return [e[0] ^ t[0], e[1] ^ t[1]];
          },
          a = function (e) {
            return (
              (e = n(e, [0, e[0] >>> 1])),
              (e = A(e, [4283543511, 3981806797])),
              (e = n(e, [0, e[0] >>> 1])),
              (e = A(e, [3301882366, 444984403])),
              n(e, [0, e[0] >>> 1])
            );
          };
        t = t || 0;
        for (
          var s = (e = e || "").length % 16,
            g = e.length - s,
            l = [0, t],
            E = [0, t],
            c = [0, 0],
            u = [0, 0],
            p = [2277735313, 289559509],
            d = [1291169091, 658871167],
            B = 0;
          B < g;
          B += 16
        )
          (c = [
            (255 & e.charCodeAt(B + 4)) |
              ((255 & e.charCodeAt(B + 5)) << 8) |
              ((255 & e.charCodeAt(B + 6)) << 16) |
              ((255 & e.charCodeAt(B + 7)) << 24),
            (255 & e.charCodeAt(B)) |
              ((255 & e.charCodeAt(B + 1)) << 8) |
              ((255 & e.charCodeAt(B + 2)) << 16) |
              ((255 & e.charCodeAt(B + 3)) << 24),
          ]),
            (u = [
              (255 & e.charCodeAt(B + 12)) |
                ((255 & e.charCodeAt(B + 13)) << 8) |
                ((255 & e.charCodeAt(B + 14)) << 16) |
                ((255 & e.charCodeAt(B + 15)) << 24),
              (255 & e.charCodeAt(B + 8)) |
                ((255 & e.charCodeAt(B + 9)) << 8) |
                ((255 & e.charCodeAt(B + 10)) << 16) |
                ((255 & e.charCodeAt(B + 11)) << 24),
            ]),
            (c = i((c = A(c, p)), 31)),
            (c = A(c, d)),
            (l = o((l = i((l = n(l, c)), 27)), E)),
            (l = o(A(l, [0, 5]), [0, 1390208809])),
            (u = i((u = A(u, d)), 33)),
            (u = A(u, p)),
            (E = o((E = i((E = n(E, u)), 31)), l)),
            (E = o(A(E, [0, 5]), [0, 944331445]));
        switch (((c = [0, 0]), (u = [0, 0]), s)) {
          case 15:
            u = n(u, r([0, e.charCodeAt(B + 14)], 48));
          case 14:
            u = n(u, r([0, e.charCodeAt(B + 13)], 40));
          case 13:
            u = n(u, r([0, e.charCodeAt(B + 12)], 32));
          case 12:
            u = n(u, r([0, e.charCodeAt(B + 11)], 24));
          case 11:
            u = n(u, r([0, e.charCodeAt(B + 10)], 16));
          case 10:
            u = n(u, r([0, e.charCodeAt(B + 9)], 8));
          case 9:
            (u = n(u, [0, e.charCodeAt(B + 8)])),
              (u = i((u = A(u, d)), 33)),
              (u = A(u, p)),
              (E = n(E, u));
          case 8:
            c = n(c, r([0, e.charCodeAt(B + 7)], 56));
          case 7:
            c = n(c, r([0, e.charCodeAt(B + 6)], 48));
          case 6:
            c = n(c, r([0, e.charCodeAt(B + 5)], 40));
          case 5:
            c = n(c, r([0, e.charCodeAt(B + 4)], 32));
          case 4:
            c = n(c, r([0, e.charCodeAt(B + 3)], 24));
          case 3:
            c = n(c, r([0, e.charCodeAt(B + 2)], 16));
          case 2:
            c = n(c, r([0, e.charCodeAt(B + 1)], 8));
          case 1:
            (c = n(c, [e.charCodeAt(B)])),
              (c = i((c = A(c, p)), 31)),
              (c = A(c, d)),
              (l = n(l, c));
        }
        return (
          (l = o((l = n(l, [0, e.length])), (E = n(E, [0, e.length])))),
          (E = o(E, l)),
          (l = o((l = a(l)), (E = a(E)))),
          (E = o(E, l)),
          "00000000".concat((l[0] >>> 0).toString(16)).slice(-8) +
            "00000000".concat((l[1] >>> 0).toString(16)).slice(-8) +
            "00000000".concat((E[0] >>> 0).toString(16)).slice(-8) +
            "00000000".concat((E[1] >>> 0).toString(16)).slice(-8)
        );
      };
    function A() {
      var t = { id: "", winding: !1, geometry: "" };
      return e(function () {
        var e = document.createElement("canvas");
        (e.width = 1), (e.height = 1);
        var A = e.getContext("2d");
        if (!A || !e.toDataURL) return t;
        (t.winding = (function (e) {
          return (
            e.rect(0, 0, 10, 10),
            e.rect(2, 2, 6, 6),
            !e.isPointInPath(5, 5, "evenodd")
          );
        })(A)),
          (e.width = 240),
          (e.height = 60),
          (A.textBaseline = "alphabetic"),
          (A.fillStyle = "#f60"),
          A.fillRect(100, 1, 62, 20),
          (A.fillStyle = "#069"),
          (A.font = '11pt "Times New Roman"'),
          (A.fillStyle = "rgba(102, 204, 0, 0.2)"),
          (A.font = "18pt Arial"),
          A.fillText("qimei", 4, 45);
        var i = e.toDataURL();
        if (i !== e.toDataURL()) return t;
        (t.id = o(i, 31)),
          (e.width = 122),
          (e.height = 110),
          (A.globalCompositeOperation = "multiply");
        for (
          var r = 0,
            n = [
              ["#f2f", 40, 40],
              ["#2ff", 80, 40],
              ["#ff2", 60, 80],
            ];
          r < n.length;
          r++
        ) {
          var a = n[r];
          (A.fillStyle = a[0]),
            A.beginPath(),
            A.arc(a[1], a[2], 40, 0, 2 * Math.PI, !0),
            A.closePath(),
            A.fill();
        }
        return (
          (A.fillStyle = "#f9c"),
          A.arc(60, 60, 60, 0, 2 * Math.PI, !0),
          A.arc(60, 60, 20, 0, 2 * Math.PI, !0),
          A.fill("evenodd"),
          (t.geometry = o(e.toDataURL(), 31)),
          t
        );
      }, t);
    }
    var i = function () {
        return e(function () {
          var e,
            t = navigator;
          return {
            cpuClass: t.cpuClass,
            deviceMemory: t.deviceMemory,
            hardwareConcurrency: t.hardwareConcurrency,
            networkType: null == (e = t.connection) ? void 0 : e.effectiveType,
            oscpu: t.oscpu,
            pdfViewerEnabled: t.pdfViewerEnabled,
            platform: t.platform,
            productSub: t.productSub,
            userAgent: t.userAgent,
            vendor: t.vendor,
            cookieEnabled: t.cookieEnabled,
          };
        }, {});
      },
      r = {},
      n = {
        getStorageItem: function (t) {
          return e(function () {
            return localStorage.getItem(t);
          });
        },
        setStorageItem: function (t, o) {
          e(function () {
            localStorage.setItem(t, null != o ? o : "");
          });
        },
        getSessionItem: function (t) {
          return e(function () {
            return sessionStorage.getItem(t);
          });
        },
        setSessionItem: function (t, o) {
          e(function () {
            sessionStorage.setItem(t, null != o ? o : "");
          });
        },
        getTimestamp: function () {
          return "".concat(Math.floor(new Date().getTime() / 1e3));
        },
        autoTry: e,
        getFeature: function () {
          return {
            canvas: A(),
            screen: e(function () {
              var e = [
                  Math.floor(window.screen.width * window.devicePixelRatio),
                  Math.floor(window.screen.height * window.devicePixelRatio),
                ]
                  .sort()
                  .reverse()
                  .join("x"),
                t = [
                  Math.floor(
                    window.screen.availWidth * window.devicePixelRatio
                  ),
                  Math.floor(
                    window.screen.availHeight * window.devicePixelRatio
                  ),
                ]
                  .sort()
                  .reverse()
                  .join("x");
              return {
                colorDepth: window.screen.colorDepth,
                resolution: e,
                availResolution: t,
              };
            }, {}),
            navigator: i(),
            indexedDB: e(function () {
              return !!window.indexedDB;
            }, !1),
            localStorage: e(function () {
              return !!window.localStorage;
            }, !1),
            sessionStorage: e(function () {
              return !!window.sessionStorage;
            }, !1),
            timezoneOffset: new Date().getTimezoneOffset(),
            webgl: e(function () {
              var e = (function () {
                var e = document.createElement("canvas"),
                  t = null;
                try {
                  t =
                    e.getContext("webgl") || e.getContext("experimental-webgl");
                } catch (e) {}
                return t || (t = null), t;
              })();
              if (!e) return null;
              var t = e.getExtension("WEBGL_debug_renderer_info"),
                o = [
                  e.getParameter(t.UNMASKED_VENDOR_WEBGL),
                  e.getParameter(t.UNMASKED_RENDERER_WEBGL),
                ].join("~"),
                A = e.getExtension("WEBGL_lose_context");
              return null != A && A.loseContext(), o;
            }),
          };
        },
        getLocalIP: function () {
          return new Promise(function (e) {
            (null == navigator ? void 0 : navigator.webkitGetUserMedia) ||
              (null == navigator ? void 0 : navigator.mozGetUserMedia) ||
              e("");
            var t =
              window.RTCPeerConnection ||
              window.mozRTCPeerConnection ||
              window.webkitRTCPeerConnection;
            if (t)
              try {
                var o = new t({ iceServers: [] });
                o
                  ? (o.createDataChannel("", { reliable: !1 }),
                    (o.onicecandidate = function (t) {
                      var o;
                      if (t.candidate) {
                        var A = t.candidate.candidate.match(
                          /([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(\d{1,3}\.){3}\d{1,3}/
                        );
                        e(null != (o = null == A ? void 0 : A[0]) ? o : "");
                      } else e("");
                    }),
                    o.createOffer().then(
                      function (e) {
                        o.setLocalDescription(e);
                      },
                      function () {
                        e("");
                      }
                    ))
                  : e("");
              } catch (t) {
                e("");
              }
            else e("");
          });
        },
        x64hash128: o,
        getNavigator: i,
        http: function (e) {
          return new Promise(function (t) {
            try {
              var o = new XMLHttpRequest(),
                A = !1,
                i = function () {
                  if (!A) {
                    A = !0;
                    try {
                      var e = (function (e) {
                        return e >= 200 && e < 300 ? 0 : 0 === e ? 600 : e;
                      })(o.status);
                      if (0 === e) {
                        var i = JSON.parse(o.responseText);
                        t(i);
                      } else
                        t({ code: e, msg: o.statusText, data: o.responseText });
                    } catch (e) {
                      t({ code: 600, msg: e.message, data: e });
                    }
                  }
                };
              (o.timeout = 1e4),
                o.open("POST", "https://snowflake.qq.com/ola/v2", !0),
                o.setRequestHeader("Content-Type", "application/json"),
                o.send(JSON.stringify(e)),
                (o.onload = function () {
                  i();
                }),
                (o.onloadend = function () {
                  i();
                }),
                (o.ontimeout = function () {
                  i();
                }),
                (o.onerror = function () {
                  i();
                }),
                (o.onabort = function () {
                  i();
                }),
                (o.onreadystatechange = function () {
                  4 === o.readyState && i();
                });
            } catch (e) {
              t({ code: 600, msg: e.message, data: e });
            }
          });
        },
        padStart: function (e, t, o) {
          if (e.length >= t || !o) return e;
          for (
            var A = t - e.length, i = "", r = 0;
            r < Math.ceil(A / o.length);
            r++
          )
            i += o;
          return (i = i.slice(0, A)) + e;
        },
        getURLParams: function (e) {
          var t = null == e ? void 0 : e.split("?")[1],
            o = {};
          return (
            null == t ||
              t.split("&").reduce(function (e, t) {
                var o = t.split("=");
                return (e[o[0]] = o[1]), e;
              }, o),
            o
          );
        },
        getCookieQ36: function () {
          return t("q36cookiekey");
        },
        getCookieUUID: function () {
          return t("qmuuk");
        },
        promiseSingleton: function (e, t, o) {
          return new Promise(function (A, i) {
            var n,
              a,
              s,
              g,
              l = null != o ? o : r;
            l[t] || (l[t] = e()),
              null ==
                (g =
                  null ==
                  (s =
                    null == (a = null == (n = l[t]) ? void 0 : n.then)
                      ? void 0
                      : a.call(n, function (e) {
                          delete l[t], A(e);
                        }))
                    ? void 0
                    : s.catch) ||
                g.call(s, function (e) {
                  delete l[t], i(e);
                });
          });
        },
      };
    moduleQimei.tools = n;
  })();
  var b$3 = function (e) {
      return e && "undefined" != typeof Symbol && e.constructor === Symbol
        ? "symbol"
        : typeof e;
    },
    __TENCENT_QIMEI_VM = (function () {
      var e = function (e, t, o) {
          for (var A = [], i = 0; i++ < t; ) A.push((e += o));
          return A;
        },
        t = function (e) {
          for (
            var t,
              o,
              A = String(e).replace(/[=]+$/, ""),
              r = A.length,
              n = 0,
              a = 0,
              s = [];
            a < r;
            a++
          )
            ~(o = i[A.charCodeAt(a)]) &&
              ((t = n % 4 ? 64 * t + o : o), n++ % 4) &&
              s.push(255 & (t >> ((-2 * n) & 6)));
          return s;
        },
        o = function (e) {
          return (e >> 1) ^ -(1 & e);
        },
        A = [],
        i = e(0, 43, 0)
          .concat([62, 0, 62, 0, 63])
          .concat(e(51, 10, 1))
          .concat(e(0, 8, 0))
          .concat(e(0, 25, 1))
          .concat([0, 0, 0, 0, 63, 0])
          .concat(e(25, 26, 1)),
        r = function (e) {
          for (
            var A = [], i = new Int8Array(t(e)), r = i.length, n = 0;
            r > n;

          ) {
            var a = i[n++],
              s = 127 & a;
            a >= 0 ||
              ((s |= (127 & (a = i[n++])) << 7),
              a >= 0 ||
                ((s |= (127 & (a = i[n++])) << 14),
                a >= 0 ||
                  ((s |= (127 & (a = i[n++])) << 21),
                  a >= 0 || (s |= (a = i[n++]) << 28)))),
              A.push(o(s));
          }
          return A;
        };
      return function (e, t) {
        var o = r(e),
          i = function (e, t, r, n, a) {
            return function s() {
              for (
                var g,
                  l,
                  E,
                  c = [r, n, t, this, arguments, s, o, 0],
                  u = void 0,
                  p = e,
                  d = [];
                ;

              )
                try {
                  for (;;)
                    switch (o[++p]) {
                      case 0:
                        c[o[++p]] = g;
                        break;
                      case 1:
                        (c[o[++p]] = c[o[++p]]),
                          (c[o[++p]] = c[o[++p]] < c[o[++p]]),
                          (p += c[o[++p]] ? o[++p] : o[(++p, ++p)]);
                        break;
                      case 2:
                        c[o[++p]] = delete c[o[++p]][c[o[++p]]];
                        break;
                      case 3:
                      case 58:
                        (c[o[++p]] = c[o[++p]] == c[o[++p]]),
                          (c[o[++p]] = !c[o[++p]]),
                          (p += c[o[++p]] ? o[++p] : o[(++p, ++p)]);
                        break;
                      case 4:
                        c[o[++p]] = new c[o[++p]](c[o[++p]]);
                        break;
                      case 5:
                        c[o[++p]] = c[o[++p]].call(c[o[++p]]);
                        break;
                      case 6:
                        c[o[++p]] = c[o[++p]].call(u, c[o[++p]], c[o[++p]]);
                        break;
                      case 7:
                        c[o[++p]] = c[o[++p]] < c[o[++p]];
                        break;
                      case 8:
                        (c[o[++p]] = c[o[++p]]),
                          (c[o[++p]] = null),
                          (c[o[++p]] = c[o[++p]] == c[o[++p]]);
                        break;
                      case 9:
                        c[o[++p]] = o[++p];
                        break;
                      case 10:
                        return c[o[++p]];
                      case 11:
                        c[o[++p]] = c[o[++p]] < o[++p];
                        break;
                      case 12:
                        for (l = [], E = o[++p]; E > 0; E--) l.push(c[o[++p]]);
                        c[o[++p]] = i(p + o[++p], l, r, n, a);
                        try {
                          Object.defineProperty(c[o[p - 1]], "length", {
                            value: o[++p],
                            configurable: !0,
                            writable: !1,
                            enumerable: !1,
                          });
                        } catch (e) {}
                        break;
                      case 13:
                      case 78:
                        c[o[++p]] = c[o[++p]] == c[o[++p]];
                        break;
                      case 14:
                        c[o[++p]] = {};
                        break;
                      case 15:
                        c[o[++p]] = c[o[++p]] ^ c[o[++p]];
                        break;
                      case 16:
                        c[o[++p]] = -c[o[++p]];
                        break;
                      case 17:
                        (c[o[++p]] = c[o[++p]][o[++p]]),
                          (c[o[++p]] = c[o[++p]][o[++p]]);
                        break;
                      case 18:
                        (c[o[++p]] = c[o[++p]][o[++p]]),
                          (c[o[++p]] = Array(o[++p])),
                          (c[o[++p]][o[++p]] = c[o[++p]]);
                        break;
                      case 19:
                        (c[o[++p]] = c[o[++p]][c[o[++p]]]),
                          (c[o[++p]] = c[o[++p]][o[++p]]);
                        break;
                      case 20:
                        for (
                          c[o[++p]] = c[o[++p]][c[o[++p]]], l = [], E = o[++p];
                          E > 0;
                          E--
                        )
                          l.push(c[o[++p]]);
                        c[o[++p]] = i(p + o[++p], l, r, n, a);
                        try {
                          Object.defineProperty(c[o[p - 1]], "length", {
                            value: o[++p],
                            configurable: !0,
                            writable: !1,
                            enumerable: !1,
                          });
                        } catch (e) {}
                        c[o[++p]] = c[o[++p]].call(c[o[++p]], c[o[++p]]);
                        break;
                      case 21:
                        (c[o[++p]] += String.fromCharCode(o[++p])),
                          (c[o[++p]][c[o[++p]]] = c[o[++p]]),
                          (c[o[++p]] = "");
                        break;
                      case 22:
                        throw c[o[++p]];
                      case 23:
                        c[o[++p]] = c[o[++p]].call(
                          c[o[++p]],
                          c[o[++p]],
                          c[o[++p]],
                          c[o[++p]]
                        );
                        break;
                      case 24:
                        c[o[++p]] = Array(o[++p]);
                        break;
                      case 25:
                        c[o[++p]] += String.fromCharCode(o[++p]);
                        break;
                      case 26:
                        c[o[++p]] = !1;
                        break;
                      case 27:
                        c[o[++p]] = c[o[++p]] <= o[++p];
                        break;
                      case 28:
                        (c[o[++p]] = c[o[++p]][c[o[++p]]]),
                          (c[o[++p]] = c[o[++p]].call(c[o[++p]]));
                        break;
                      case 29:
                        p += c[o[++p]] ? o[++p] : o[(++p, ++p)];
                        break;
                      case 30:
                        (c[o[++p]] = c[o[++p]][o[++p]]),
                          (c[o[++p]] = ""),
                          (c[o[++p]] += String.fromCharCode(o[++p]));
                        break;
                      case 31:
                        c[o[++p]] = c[o[++p]][c[o[++p]]];
                        break;
                      case 32:
                        c[o[++p]] = c[o[++p]] + o[++p];
                        break;
                      case 33:
                        c[o[++p]] = c[o[++p]].call(
                          c[o[++p]],
                          c[o[++p]],
                          c[o[++p]]
                        );
                        break;
                      case 34:
                        c[o[++p]] = c[o[++p]].call(u, c[o[++p]]);
                        break;
                      case 35:
                        (c[o[++p]] = c[o[++p]][o[++p]]),
                          (c[o[++p]] = {}),
                          (c[o[++p]] = "");
                        break;
                      case 36:
                        for (l = [], E = o[++p]; E > 0; E--) l.push(c[o[++p]]);
                        c[o[++p]] = c[o[++p]].apply(u, l);
                        break;
                      case 37:
                        (c[o[++p]] += String.fromCharCode(o[++p])),
                          (c[o[++p]] = c[o[++p]][o[++p]]);
                        break;
                      case 38:
                        for (
                          c[o[++p]][o[++p]] = c[o[++p]], l = [], E = o[++p];
                          E > 0;
                          E--
                        )
                          l.push(c[o[++p]]);
                        c[o[++p]] = i(p + o[++p], l, r, n, a);
                        try {
                          Object.defineProperty(c[o[p - 1]], "length", {
                            value: o[++p],
                            configurable: !0,
                            writable: !1,
                            enumerable: !1,
                          });
                        } catch (e) {}
                        break;
                      case 39:
                        c[o[++p]] = c[o[++p]] >> o[++p];
                        break;
                      case 40:
                        c[o[++p]][o[++p]] = c[o[++p]];
                        break;
                      case 41:
                        (c[o[++p]] = c[o[++p]]),
                          (c[o[++p]] = c[o[++p]] - 0),
                          (c[o[++p]] = ++c[o[++p]]);
                        break;
                      case 42:
                        p += o[++p];
                        break;
                      case 43:
                        c[o[++p]] = c[o[++p]] * c[o[++p]];
                        break;
                      case 44:
                        c[o[++p]] = c[o[++p]][o[++p]];
                        break;
                      case 45:
                        c[o[++p]] = null;
                        break;
                      case 46:
                        c[o[++p]] = !c[o[++p]];
                        break;
                      case 47:
                        return (c[o[++p]] = u), c[o[++p]];
                      case 48:
                        (l = c[o[++p]]),
                          (c[o[++p]] = !!l.length)
                            ? (c[o[++p]] = l.shift())
                            : ++p;
                        break;
                      case 49:
                        c[o[++p]] = b$3(c[o[++p]]);
                        break;
                      case 50:
                        c[o[++p]] = c[o[++p]].call(c[o[++p]], c[o[++p]]);
                        break;
                      case 51:
                        c[o[++p]] = u;
                        break;
                      case 52:
                        d.push(p + o[++p]);
                        break;
                      case 53:
                        d.pop();
                        break;
                      case 54:
                        c[o[++p]] = ~c[o[++p]];
                        break;
                      case 55:
                        c[o[++p]] = c[o[++p]] === o[++p];
                        break;
                      case 56:
                        c[o[++p]] = a$3(c[o[++p]], c[o[++p]]);
                        break;
                      case 57:
                        for (E in ((l = []), c[o[++p]])) l.push(E);
                        c[o[++p]] = l;
                        break;
                      case 59:
                        (c[o[++p]] = c[o[++p]][c[o[++p]]]),
                          (c[o[++p]] = c[o[++p]].call(c[o[++p]], c[o[++p]]));
                        break;
                      case 60:
                        (c[o[++p]] = c[o[++p]][o[++p]]),
                          (c[o[++p]] = c[o[++p]]);
                        break;
                      case 61:
                        (c[o[++p]] = ""),
                          (c[o[++p]] += String.fromCharCode(o[++p]));
                        break;
                      case 62:
                        c[o[++p]] = !0;
                        break;
                      case 63:
                        (c[o[++p]] += String.fromCharCode(o[++p])),
                          (c[o[++p]][o[++p]] = c[o[++p]]);
                        break;
                      case 64:
                        (c[o[++p]] = null),
                          (c[o[++p]] = c[o[++p]] == c[o[++p]]),
                          (p += c[o[++p]] ? o[++p] : o[(++p, ++p)]);
                        break;
                      case 65:
                        c[o[++p]] = c[o[++p]] | o[++p];
                        break;
                      case 66:
                        c[o[++p]] = c[o[++p]] > o[++p];
                        break;
                      case 67:
                        c[o[++p]] = c[o[++p]] - c[o[++p]];
                        break;
                      case 68:
                        c[o[++p]][c[o[++p]]] = c[o[++p]];
                        break;
                      case 69:
                        c[o[++p]] = c[o[++p]] % c[o[++p]];
                        break;
                      case 70:
                        c[o[++p]] = c[o[++p]] & o[++p];
                        break;
                      case 71:
                        c[o[++p]] = c[o[++p]] - 0;
                        break;
                      case 72:
                        (c[o[++p]] = c[o[++p]]),
                          d.push(p + o[++p]),
                          (c[o[++p]] = c[o[++p]][o[++p]]);
                        break;
                      case 73:
                        (c[o[++p]] += String.fromCharCode(o[++p])),
                          (c[o[++p]] = c[o[++p]][c[o[++p]]]);
                        break;
                      case 74:
                        for (l = [], E = o[++p]; E > 0; E--) l.push(c[o[++p]]);
                        c[o[++p]] = i(p + o[++p], l, r, n, a);
                        try {
                          Object.defineProperty(c[o[p - 1]], "length", {
                            value: o[++p],
                            configurable: !0,
                            writable: !1,
                            enumerable: !1,
                          });
                        } catch (e) {}
                        c[o[++p]][o[++p]] = c[o[++p]];
                        break;
                      case 75:
                        c[o[++p]] = c[o[++p]].call(u);
                        break;
                      case 76:
                        c[o[++p]] = c[o[++p]];
                        break;
                      case 77:
                        (c[o[++p]] = c[o[++p]][o[++p]]),
                          (c[o[++p]] = c[o[++p]].call(u)),
                          (c[o[++p]] = c[o[++p]]);
                        break;
                      case 79:
                        (c[o[++p]] = g),
                          (c[o[++p]] = c[o[++p]]),
                          d.push(p + o[++p]);
                        break;
                      case 80:
                        c[o[++p]] = c[o[++p]] >>> o[++p];
                        break;
                      case 81:
                        (c[o[++p]] = c[o[++p]][o[++p]]),
                          (c[o[++p]] = c[o[++p]][o[++p]]),
                          (c[o[++p]] = c[o[++p]][o[++p]]);
                        break;
                      case 82:
                        c[o[++p]] = "";
                        break;
                      case 83:
                        c[o[++p]] = c[o[++p]] in c[o[++p]];
                        break;
                      case 84:
                        c[o[++p]] = new c[o[++p]]();
                        break;
                      case 85:
                        (c[o[++p]] += String.fromCharCode(o[++p])),
                          (c[o[++p]] += String.fromCharCode(o[++p]));
                        break;
                      case 86:
                        c[o[++p]] = c[o[++p]] << o[++p];
                        break;
                      case 87:
                        (c[o[++p]] = Array(o[++p])),
                          (c[o[++p]] = Array(o[++p]));
                        break;
                      case 88:
                        c[o[++p]] = c[o[++p]] | c[o[++p]];
                        break;
                      case 89:
                        c[o[++p]] = c[o[++p]] >= o[++p];
                        break;
                      case 90:
                        c[o[++p]] = c[o[++p]] + c[o[++p]];
                        break;
                      case 91:
                        (c[o[++p]] = c[o[++p]][c[o[++p]]]),
                          (c[o[++p]] = c[o[++p]]);
                        break;
                      case 92:
                        (c[o[++p]] = Array(o[++p])),
                          (c[o[++p]][o[++p]] = c[o[++p]]),
                          (c[o[++p]] = c[o[++p]][o[++p]]);
                        break;
                      case 93:
                        c[o[++p]] = ++c[o[++p]];
                        break;
                      case 94:
                        c[o[++p]] = c[o[++p]].call(
                          u,
                          c[o[++p]],
                          c[o[++p]],
                          c[o[++p]]
                        );
                        break;
                      case 95:
                        (c[o[++p]] = c[o[++p]]),
                          (c[o[++p]] = c[o[++p]][o[++p]]);
                    }
                } catch (e) {
                  if (
                    (d.length > 0 && (A = []),
                    (g = e),
                    A.push(p),
                    0 === d.length)
                  )
                    throw a ? a(e, c, A) : e;
                  (p = d.pop()), A.pop();
                }
            };
          };
        return t ? void 0 : i;
      };
    })();
  __TENCENT_QIMEI_VM(
    "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",
    !1
  )(
    21900,
    [],
    {
      get Object() {
        return "undefined" == typeof Object ? void 0 : Object;
      },
      set Object(e) {
        Object = e;
      },
      get moduleQimei() {
        return void 0 === moduleQimei ? void 0 : moduleQimei;
      },
      set moduleQimei(e) {
        moduleQimei = e;
      },
      get Uint32Array() {
        return "undefined" == typeof Uint32Array ? void 0 : Uint32Array;
      },
      set Uint32Array(e) {
        Uint32Array = e;
      },
      get window() {
        return "undefined" == typeof window ? void 0 : window;
      },
      set window(e) {
        window = e;
      },
      get String() {
        return "undefined" == typeof String ? void 0 : String;
      },
      set String(e) {
        String = e;
      },
      get Symbol() {
        return "undefined" == typeof Symbol ? void 0 : Symbol;
      },
      set Symbol(e) {
        Symbol = e;
      },
      get undefined() {},
      set undefined(e) {},
      get TypeError() {
        return "undefined" == typeof TypeError ? void 0 : TypeError;
      },
      set TypeError(e) {
        TypeError = e;
      },
      get Number() {
        return "undefined" == typeof Number ? void 0 : Number;
      },
      set Number(e) {
        Number = e;
      },
      get JSON() {
        return "undefined" == typeof JSON ? void 0 : JSON;
      },
      set JSON(e) {
        JSON = e;
      },
      get parseInt() {
        return "undefined" == typeof parseInt ? void 0 : parseInt;
      },
      set parseInt(e) {
        parseInt = e;
      },
      get Date() {
        return "undefined" == typeof Date ? void 0 : Date;
      },
      set Date(e) {
        Date = e;
      },
      get Array() {
        return "undefined" == typeof Array ? void 0 : Array;
      },
      set Array(e) {
        Array = e;
      },
      get Math() {
        return "undefined" == typeof Math ? void 0 : Math;
      },
      set Math(e) {
        Math = e;
      },
      get Promise() {
        return "undefined" == typeof Promise ? void 0 : Promise;
      },
      set Promise(e) {
        Promise = e;
      },
      get navigator() {
        return "undefined" == typeof navigator ? void 0 : navigator;
      },
      set navigator(e) {
        navigator = e;
      },
      get RegExp() {
        return "undefined" == typeof RegExp ? void 0 : RegExp;
      },
      set RegExp(e) {
        RegExp = e;
      },
    },
    [!1, !0, void 0, null, 3988292384, 0.01],
    void 0
  )();
  var QimeiClient = moduleQimei.QimeiWebLite,
    index_min = { exports: {} };
  !(function (e, t, o) {
    var A = Object.assign(
      {
        exports: e,
        thumbplayerCore: t,
        thumbplayerH5: o,
        wb: "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",
      },
      window
    );
    function i(e, t) {
      return null != t && "undefined" != typeof Symbol && t[Symbol.hasInstance]
        ? !!t[Symbol.hasInstance](e)
        : e instanceof t;
    }
    function r(e) {
      return e && "undefined" != typeof Symbol && e.constructor === Symbol
        ? "symbol"
        : typeof e;
    }
    Object.setPrototypeOf(A, Object.create(window));
    var n = (function () {
      var e = function (e, t, o) {
          for (var A = [], i = 0; i++ < t; ) A.push((e += o));
          return A;
        },
        t = function (e) {
          for (
            var t,
              o,
              A = String(e).replace(/[=]+$/, ""),
              i = A.length,
              r = 0,
              a = 0,
              s = [];
            a < i;
            a++
          )
            ~(o = n[A.charCodeAt(a)]) &&
              ((t = r % 4 ? 64 * t + o : o), r++ % 4) &&
              s.push(255 & (t >> ((-2 * r) & 6)));
          return s;
        },
        o = function (e) {
          return (e >> 1) ^ -(1 & e);
        },
        A = [],
        n = e(0, 43, 0)
          .concat([62, 0, 62, 0, 63])
          .concat(e(51, 10, 1))
          .concat(e(0, 8, 0))
          .concat(e(0, 25, 1))
          .concat([0, 0, 0, 0, 63, 0])
          .concat(e(25, 26, 1)),
        a = function (e) {
          for (
            var A = [],
              i = "undefined" != typeof Int8Array ? new Int8Array(t(e)) : t(e),
              r = i.length,
              n = 0;
            r > n;

          ) {
            var a = i[n++],
              s = 127 & a;
            a >= 0 ||
              ((s |= (127 & (a = i[n++])) << 7),
              a >= 0 ||
                ((s |= (127 & (a = i[n++])) << 14),
                a >= 0 ||
                  ((s |= (127 & (a = i[n++])) << 21),
                  a >= 0 || (s |= (a = i[n++]) << 28)))),
              A.push(o(s));
          }
          return A;
        };
      return function (e, t) {
        var o = a(e),
          n = function (e, t, a, s, g) {
            return function l() {
              for (
                var E,
                  c,
                  u,
                  p = [a, s, t, this, arguments, l, o, 0],
                  d = void 0,
                  B = e,
                  h = [];
                ;

              )
                try {
                  for (;;)
                    switch (o[++B] ^ p[7]) {
                      case 0:
                        p[o[++B]] += String.fromCharCode(o[++B]);
                        break;
                      case 1:
                        p[o[++B]] = o[++B];
                        break;
                      case 2:
                        p[o[++B]] = ++p[o[++B]];
                        break;
                      case 3:
                        (p[o[++B]] = p[o[++B]][o[++B]]),
                          (p[o[++B]] = Array(o[++B])),
                          (p[o[++B]][o[++B]] = p[o[++B]]);
                        break;
                      case 4:
                        for (c = [], u = o[++B]; u > 0; u--) c.push(p[o[++B]]);
                        p[o[++B]] = p[o[++B]].apply(d, c);
                        break;
                      case 5:
                        p[o[++B]] = p[o[++B]] >= o[++B];
                        break;
                      case 6:
                        p[o[++B]] = r(p[o[++B]]);
                        break;
                      case 7:
                        p[o[++B]] = new p[o[++B]](p[o[++B]], p[o[++B]]);
                        break;
                      case 8:
                        p[o[++B]] = p[o[++B]] + o[++B];
                        break;
                      case 9:
                        p[o[++B]] = p[o[++B]] > o[++B];
                        break;
                      case 10:
                        p[o[++B]] = p[o[++B]] > p[o[++B]];
                        break;
                      case 11:
                        (p[o[++B]] = p[o[++B]][o[++B]]),
                          (p[o[++B]] = p[o[++B]][p[o[++B]]]);
                        break;
                      case 12:
                        p[o[++B]] = p[o[++B]] - p[o[++B]];
                        break;
                      case 13:
                        (p[o[++B]] += String.fromCharCode(o[++B])),
                          (p[o[++B]][o[++B]] = p[o[++B]]),
                          (p[o[++B]] += String.fromCharCode(o[++B]));
                        break;
                      case 14:
                        (p[o[++B]] = p[o[++B]][o[++B]]), (p[o[++B]] = o[++B]);
                        break;
                      case 15:
                        (p[o[++B]][o[++B]] = p[o[++B]]),
                          (p[o[++B]] = p[o[++B]] == p[o[++B]]),
                          (B += p[o[++B]] ? o[++B] : o[(++B, ++B)]);
                        break;
                      case 16:
                        (p[o[++B]] = o[++B]), (p[o[++B]][o[++B]] = p[o[++B]]);
                        break;
                      case 17:
                        p[o[++B]] = delete p[o[++B]][p[o[++B]]];
                        break;
                      case 18:
                        p[o[++B]] = E;
                        break;
                      case 19:
                        B += p[o[++B]] ? o[++B] : o[(++B, ++B)];
                        break;
                      case 20:
                        p[o[++B]] = +p[o[++B]];
                        break;
                      case 21:
                        for (c = [], u = o[++B]; u > 0; u--) c.push(p[o[++B]]);
                        p[o[++B]] = p[o[++B]].apply(p[o[++B]], c);
                        break;
                      case 22:
                        (p[o[++B]][o[++B]] = p[o[++B]]),
                          (p[o[++B]] = p[o[++B]][o[++B]]);
                        break;
                      case 23:
                        for (
                          p[o[++B]] = p[o[++B]][o[++B]], c = [], u = o[++B];
                          u > 0;
                          u--
                        )
                          c.push(p[o[++B]]);
                        p[o[++B]] = n(B + o[++B], c, a, s, g);
                        try {
                          Object.defineProperty(p[o[B - 1]], "length", {
                            value: o[++B],
                            configurable: !0,
                            writable: !1,
                            enumerable: !1,
                          });
                        } catch (e) {}
                        p[o[++B]] = p[o[++B]];
                        break;
                      case 24:
                        (p[o[++B]] = p[o[++B]][p[o[++B]]]), (p[o[++B]] = "");
                        break;
                      case 25:
                        p[o[++B]] = new p[o[++B]](p[o[++B]]);
                        break;
                      case 26:
                        p[o[++B]] = p[o[++B]].call(p[o[++B]]);
                        break;
                      case 27:
                        p[o[++B]] = p[o[++B]] / p[o[++B]];
                        break;
                      case 28:
                        h.push(B + o[++B]);
                        break;
                      case 29:
                        p[o[++B]] = {};
                        break;
                      case 30:
                        p[o[++B]] = !p[o[++B]];
                        break;
                      case 31:
                        p[o[++B]] = new p[o[++B]]();
                        break;
                      case 32:
                        p[o[++B]] = "";
                        break;
                      case 33:
                        (p[o[++B]] += String.fromCharCode(o[++B])),
                          (p[o[++B]] += String.fromCharCode(o[++B]));
                        break;
                      case 34:
                        (p[o[++B]] = p[o[++B]][p[o[++B]]]),
                          (p[o[++B]] = p[o[++B]][o[++B]]);
                        break;
                      case 35:
                        p[o[++B]] = p[o[++B]].call(p[o[++B]], p[o[++B]]);
                        break;
                      case 36:
                        p[o[++B]] = p[o[++B]].call(
                          p[o[++B]],
                          p[o[++B]],
                          p[o[++B]]
                        );
                        break;
                      case 37:
                        p[o[++B]] = i(p[o[++B]], p[o[++B]]);
                        break;
                      case 38:
                        (p[o[++B]] = ""),
                          (p[o[++B]] += String.fromCharCode(o[++B]));
                        break;
                      case 39:
                        p[o[++B]] = p[o[++B]] - o[++B];
                        break;
                      case 40:
                        h.pop();
                        break;
                      case 41:
                        (p[o[++B]] = Array(o[++B])),
                          (p[o[++B]] = Array(o[++B]));
                        break;
                      case 42:
                        p[o[++B]] = p[o[++B]] + p[o[++B]];
                        break;
                      case 43:
                        (p[o[++B]] = p[o[++B]][p[o[++B]]]),
                          (p[o[++B]] = p[o[++B]].call(d)),
                          (p[o[++B]][o[++B]] = p[o[++B]]);
                        break;
                      case 44:
                        p[o[++B]] = p[o[++B]] < p[o[++B]];
                        break;
                      case 45:
                        p[o[++B]] = p[o[++B]][p[o[++B]]];
                        break;
                      case 46:
                        p[o[++B]][p[o[++B]]] = p[o[++B]];
                        break;
                      case 47:
                        p[o[++B]] = p[o[++B]].call(d);
                        break;
                      case 48:
                        return p[o[++B]];
                      case 49:
                        (p[o[++B]] += String.fromCharCode(o[++B])),
                          (p[o[++B]][o[++B]] = p[o[++B]]);
                        break;
                      case 50:
                        for (u in ((c = []), p[o[++B]])) c.push(u);
                        p[o[++B]] = c;
                        break;
                      case 51:
                        p[o[++B]] = d;
                        break;
                      case 52:
                        p[o[++B]] = p[o[++B]] - 0;
                        break;
                      case 53:
                        (p[o[++B]][p[o[++B]]] = p[o[++B]]),
                          (p[o[++B]] = ""),
                          (p[o[++B]] += String.fromCharCode(o[++B]));
                        break;
                      case 54:
                        p[o[++B]] = p[o[++B]].call(
                          p[o[++B]],
                          p[o[++B]],
                          p[o[++B]],
                          p[o[++B]]
                        );
                        break;
                      case 55:
                        p[o[++B]] = p[o[++B]].call(d, p[o[++B]], p[o[++B]]);
                        break;
                      case 56:
                        throw p[o[++B]];
                      case 57:
                        p[o[++B]] = new p[o[++B]](
                          p[o[++B]],
                          p[o[++B]],
                          p[o[++B]]
                        );
                        break;
                      case 58:
                        (p[o[++B]] = p[o[++B]]),
                          (p[o[++B]][o[++B]] = p[o[++B]]);
                        break;
                      case 59:
                        p[o[++B]] = p[o[++B]] === o[++B];
                        break;
                      case 60:
                        (p[o[++B]] += String.fromCharCode(o[++B])),
                          (p[o[++B]] = o[++B]),
                          (p[o[++B]] += String.fromCharCode(o[++B]));
                        break;
                      case 61:
                        p[o[++B]] = p[o[++B]][o[++B]];
                        break;
                      case 62:
                        p[o[++B]] = p[o[++B]] % p[o[++B]];
                        break;
                      case 63:
                        p[o[++B]] = p[o[++B]].call(
                          d,
                          p[o[++B]],
                          p[o[++B]],
                          p[o[++B]]
                        );
                        break;
                      case 64:
                        (p[o[++B]] = p[o[++B]][o[++B]]),
                          (p[o[++B]] = p[o[++B]][o[++B]]);
                        break;
                      case 65:
                        p[o[++B]] = -p[o[++B]];
                        break;
                      case 66:
                        p[o[++B]][o[++B]] = p[o[++B]];
                        break;
                      case 67:
                        (p[o[++B]][o[++B]] = p[o[++B]]),
                          (p[o[++B]][o[++B]] = p[o[++B]]);
                        break;
                      case 68:
                        p[o[++B]] = p[o[++B]] ^ p[o[++B]];
                        break;
                      case 69:
                        p[o[++B]] = p[o[++B]].call(d, p[o[++B]]);
                        break;
                      case 70:
                        p[o[++B]] = p[o[++B]] & o[++B];
                        break;
                      case 71:
                        (p[o[++B]] = p[o[++B]][o[++B]]),
                          (p[o[++B]] = ""),
                          (p[o[++B]] += String.fromCharCode(o[++B]));
                        break;
                      case 72:
                        (p[o[++B]] += String.fromCharCode(o[++B])),
                          (p[o[++B]] = p[o[++B]][p[o[++B]]]);
                        break;
                      case 73:
                        p[o[++B]] = p[o[++B]] * p[o[++B]];
                        break;
                      case 74:
                        (p[o[++B]] = p[o[++B]][p[o[++B]]]),
                          (p[o[++B]] = ""),
                          (p[o[++B]] += String.fromCharCode(o[++B]));
                        break;
                      case 75:
                        (p[o[++B]] += String.fromCharCode(o[++B])),
                          (p[o[++B]] = o[++B]);
                        break;
                      case 76:
                        p[o[++B]] = Array(o[++B]);
                        break;
                      case 77:
                        for (c = [], u = o[++B]; u > 0; u--) c.push(p[o[++B]]);
                        p[o[++B]] = n(B + o[++B], c, a, s, g);
                        try {
                          Object.defineProperty(p[o[B - 1]], "length", {
                            value: o[++B],
                            configurable: !0,
                            writable: !1,
                            enumerable: !1,
                          });
                        } catch (e) {}
                        break;
                      case 78:
                        p[o[++B]] = null;
                        break;
                      case 79:
                        p[o[++B]] = p[o[++B]];
                        break;
                      case 80:
                      case 85:
                        p[o[++B]] = p[o[++B]] == p[o[++B]];
                        break;
                      case 81:
                        (c = p[o[++B]]),
                          (p[o[++B]] = !!c.length)
                            ? (p[o[++B]] = c.shift())
                            : ++B;
                        break;
                      case 82:
                        p[o[++B]] = p[o[++B]] in p[o[++B]];
                        break;
                      case 83:
                        (p[o[++B]] = p[o[++B]]),
                          (p[o[++B]][p[o[++B]]] = p[o[++B]]);
                        break;
                      case 84:
                        p[o[++B]] = p[o[++B]] | p[o[++B]];
                    }
                } catch (e) {
                  if (
                    (h.length > 0 && (A = []),
                    (E = e),
                    A.push(B),
                    0 === h.length)
                  )
                    throw g ? g(e, p, A) : e;
                  (B = h.pop()), A.pop();
                }
            };
          };
        return t ? n : undefined;
      };
    })();
    n(
      "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",
      !0
    )(41547, [], A, [void 0, null], void 0)(),
      Object.defineProperty(e, "__esModule", { value: !0 });
  })(index_min.exports, ThumbPlayerCore, ThumbPlayerH5);
  var BusinessController = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.installed = !1),
          (t.onVideoReqInfoEnd = function (e) {
            var o,
              A = e.data;
            if (t.installed) {
              var i =
                "1" ===
                urlTool$1.getUrlParamByKey(
                  location.href,
                  TVK_REFRESH_URL_PARAM
                );
              if (
                (null === (o = null == A ? void 0 : A.data) || void 0 === o
                  ? void 0
                  : o.resData) &&
                !i
              ) {
                var r = A.data.resData,
                  n = r.em,
                  a = r.exem;
                if (45 === n && 2 === a) {
                  var s = urlTool$1.updateUrlParam(
                    location.href,
                    TVK_REFRESH_URL_PARAM,
                    "1"
                  );
                  location.assign(s);
                }
              }
            }
          }),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.init = function () {
          this.initTEE(), this.initQimei(), this.bindEvents();
        }),
        (t.prototype.initTEE = function () {
          var e = this.config.enableTEE;
          try {
            var t = index_min.exports.TEE.supported();
            if (!e || !t)
              return (
                this.player.setCommonKv(
                  "TEE_CONTEXT_DATA",
                  jsonTool$1.safelyStringify({ tvk: { c: e, s: t } })
                ),
                void this.log(
                  "TEE is not enabled due to config="
                    .concat(e, ", supported=")
                    .concat(t)
                )
              );
            index_min.exports.TEE.install(this.player), (this.installed = !0);
          } catch (e) {
            this.log("TEE install failed: ".concat(e.message)),
              this.player.setCommonKv(
                "TEE_CONTEXT_DATA",
                jsonTool$1.safelyStringify({
                  tvk: { e: null == e ? void 0 : e.message },
                })
              );
          }
        }),
        (t.prototype.initQimei = function () {
          var e;
          this.qimeiClient = new QimeiClient({ appKey: "0WEB05IY85DVOASP" });
          var t = getUserCookies(),
            o = t[COOKIE_NAME.MAIN_LOGIN],
            A = t[COOKIE_NAME.OPENID];
          this.qimeiClient.setUserId({
            qqOpenID: o === LOGIN_METHOD.QQ ? A : "",
            wxOpenID: o === LOGIN_METHOD.WX ? A : "",
            guid:
              t[COOKIE_NAME.GUID] ||
              this.player.getCommonKv(COMMON_DATA_KEY.guid),
          }),
            this.player.setCommonKv(
              COMMON_DATA_KEY.qimeiH38,
              null === (e = this.qimeiClient.getLocalQimei36()) || void 0 === e
                ? void 0
                : e.h38
            );
        }),
        (t.prototype.bindEvents = function () {
          this.player.on(
            exports.H5_PLAY_EVENT.VIDEO_REQ_INFO_END,
            this.onVideoReqInfoEnd
          );
        }),
        (t.prototype.unbindEvents = function () {
          this.player.off(
            exports.H5_PLAY_EVENT.VIDEO_REQ_INFO_END,
            this.onVideoReqInfoEnd
          );
        }),
        (t.prototype.destroy = function () {
          this.installed && index_min.exports.TEE.uninstall(this.player),
            this.unbindEvents(),
            (this.qimeiClient = null),
            (this.installed = !1),
            e.prototype.destroy.call(this);
        }),
        (t.moduleName = "business-controller"),
        t
      );
    })(Controller),
    DecController = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        __extends$1(t, e),
        (t.prototype.init = function () {
          if (this.config.decScriptUrl) {
            if (!checkDecScriptUrlVaild(this.config.decScriptUrl))
              throw new Error("decScriptUrl must be vaild");
            var e = this.player.config;
            e.hlsjsKernelConfig = __assign$1(
              __assign$1({}, e.hlsjsKernelConfig),
              { decScriptUrl: this.config.decScriptUrl }
            );
          }
        }),
        (t.moduleName = "dec-controller"),
        t
      );
    })(Controller);
  function checkDecScriptUrlVaild(e) {
    var t = urlTool$1.getDomainOfURL(e);
    return !(!/woa\.com$/.test(t) && !/^blob:/.test(e));
  }
  var KvController = (function (e) {
    function t() {
      var t = (null !== e && e.apply(this, arguments)) || this;
      return (
        (t.onGetInfoOver = function (e) {
          var o = e.data;
          o &&
            (t.player.config.type === exports.PLAY_MODE.VOD
              ? t.updateVodKvs(o)
              : t.udpateLiveKvs(o));
        }),
        t
      );
    }
    return (
      __extends$1(t, e),
      (t.prototype.init = function () {
        this.setupEventListeners();
      }),
      (t.prototype.destroy = function () {
        this.removeEventListeners(), e.prototype.destroy.call(this);
      }),
      (t.prototype.setupEventListeners = function () {
        this.player.pluginMsg.on(
          exports.PLAY_EVENT_EXT.GETINFO_OVER,
          this.onGetInfoOver
        );
      }),
      (t.prototype.removeEventListeners = function () {
        this.player.pluginMsg.off(
          exports.PLAY_EVENT_EXT.GETINFO_OVER,
          this.onGetInfoOver
        );
      }),
      (t.prototype.updateVodKvs = function (e) {
        var t,
          o,
          A,
          i,
          r,
          n,
          a,
          s = e.reqParams,
          g = void 0 === s ? {} : s,
          l = e.parseData,
          E = void 0 === l ? {} : l,
          c = e.resData,
          u = void 0 === c ? {} : c,
          p = e.cKeyCostTime,
          d = void 0 === p ? -1 : p,
          B = e.cKeyDowngrade,
          h = void 0 !== B && B,
          I = E.vtype,
          C = E.drmType,
          _ = E.vitem,
          f = void 0 === _ ? {} : _,
          y = g.cKey,
          m = g.encryptVer;
        this.player.setCommonKv(
          (((t = {})[VOD_GET_INFO_DATA_KEYS.ckey] = y),
          (t[VOD_GET_INFO_DATA_KEYS.ckeyVersion] = m),
          (t[COMMON_DATA_KEY.codec] = I),
          (t[COMMON_DATA_KEY.uip] = u.ip),
          (t[COMMON_DATA_KEY.hh_ip] = u.ip),
          (t[VOD_GET_INFO_DATA_KEYS.vipToken] = getTokenValue(
            u.report || "",
            "vip_token"
          )),
          (t[VOD_GET_INFO_DATA_KEYS.videoCharged] = f.ch),
          (t[VOD_GET_INFO_DATA_KEYS.userPayType] = computePayType(f.st, f.ch)),
          (t[VOD_GET_INFO_DATA_KEYS.videoType] = f.videotype),
          (t[COMMON_DATA_KEY.status] = f.vst),
          (t[COMMON_DATA_KEY.type] = f.type),
          (t.videoName = E.title),
          (t.byteRate = E.byteRate),
          (t[COMMON_DATA_KEY.duration] = E.duration),
          (t.preview = E.preview),
          (t[COMMON_DATA_KEY.drm] = C),
          (t[COMMON_DATA_KEY.p2p] = u.fp2p ? 1 : 0),
          (t[COMMON_DATA_KEY.fmt] =
            null ===
              (A =
                null === (o = E.definitionList) || void 0 === o
                  ? void 0
                  : o.find(function (e) {
                      return e.sl;
                    })) || void 0 === A
              ? void 0
              : A.id),
          (t[COMMON_DATA_KEY.testid] = u.tstid),
          (t[COMMON_DATA_KEY.cdnid] =
            null ===
              (n =
                null ===
                  (r =
                    null === (i = null == f ? void 0 : f.ul) || void 0 === i
                      ? void 0
                      : i.ui) || void 0 === r
                  ? void 0
                  : r[0]) || void 0 === n
              ? void 0
              : n.vt),
          (t[COMMON_DATA_KEY.rate] = E.byteRate),
          (t[COMMON_DATA_KEY.dltype] = u.dltype),
          (t[COMMON_DATA_KEY.ckeytime] = d),
          (t[COMMON_DATA_KEY.ckeydg] = +h),
          (t[VOD_GET_INFO_DATA_KEYS.vurl] =
            null === (a = E.urls[0]) || void 0 === a ? void 0 : a.url),
          t)
        );
      }),
      (t.prototype.udpateLiveKvs = function (e) {
        var t,
          o,
          A = e.reqParams,
          i = void 0 === A ? {} : A,
          r = e.parseData,
          n = void 0 === r ? {} : r,
          a = e.resData,
          s = void 0 === a ? {} : a,
          g = n || {},
          l = g.vtype,
          E = g.drmType,
          c = g.vitem,
          u = void 0 === c ? {} : c,
          p = i.ckey,
          d = i.encrypt_ver;
        this.player.setCommonKv(
          (((t = {})[COMMON_DATA_KEY.livepid] = s.pid),
          (t[VOD_GET_INFO_DATA_KEYS.ckey] = p),
          (t[VOD_GET_INFO_DATA_KEYS.ckeyVersion] = d),
          (t[COMMON_DATA_KEY.codec] = l),
          (t.preview = n.preview),
          (t[COMMON_DATA_KEY.drm] = E),
          (t[LIVE_GET_INFO_DATA_KEYS.isuserpay] = s.isuserpay),
          (t[LIVE_GET_INFO_DATA_KEYS.livesid] = u.sid),
          (t[LIVE_GET_INFO_DATA_KEYS.playtime] = n.preview),
          (t[LIVE_GET_INFO_DATA_KEYS.pay_type] = s.pay_type),
          (t[LIVE_GET_INFO_DATA_KEYS.restpreviewcnt] =
            null === (o = s.preview_info) || void 0 === o
              ? void 0
              : o.restpreviewcnt),
          t)
        );
      }),
      (t.moduleName = "kv-controller"),
      t
    );
  })(Controller);
  function computePayType(e, t) {
    var o = 0;
    return (
      8 === e ? (o = 1) : 2 === e && (t > 0 ? (o = 2) : 0 === t && (o = 0)), o
    );
  }
  function getTokenValue(e, t) {
    var o = (e
      .split("$")
      .map(function (e) {
        return e.split("=");
      })
      .find(function (e) {
        return e[0] === t;
      }) || [])[1];
    return +(void 0 === o ? "0" : o);
  }
  var TVK = (function () {
      function e(e, t) {
        (this.controllers = []),
          (this.message = new s$1$1()),
          (this.destroyed = !1),
          (this.player = e),
          (this.config = this.prepareConfig(t)),
          (this.logger = new Logger(e.config.instanceId, "tvk")),
          this.initializeAllControllers(),
          this.initDebugMode();
      }
      return (
        (e.prototype.destroy = function () {
          this.controllers.forEach(function (e) {
            return e.destroy();
          }),
            (this.player = null),
            (this.controllers = null),
            (this.destroyed = !0);
        }),
        (e.prototype.initializeAllControllers = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            var e = this;
            return __generator$1(this, function (t) {
              return (
                [
                  BusinessController,
                  DecController,
                  KvController,
                  NetworkController,
                  ReporterController,
                  GuardController,
                  this.config.definitionController,
                  this.config.audioTrackController,
                ]
                  .map(function (t) {
                    return t ? new t(e.player, e) : null;
                  })
                  .filter(function (e) {
                    return null !== e;
                  })
                  .forEach(function (t) {
                    try {
                      e.initController(t);
                    } catch (o) {
                      e.initControllerFailed(t, o);
                    }
                  }),
                [2]
              );
            });
          });
        }),
        (e.prototype.initController = function (e) {
          this.checkDestroyed(e),
            this.logger.log("".concat(e.constructor.moduleName, " ready")),
            e.init(),
            this.controllers.push(e);
        }),
        (e.prototype.initControllerFailed = function (e, t) {
          this.logger.error(
            "".concat(e.constructor.moduleName, " failed, reason: ").concat(t)
          );
        }),
        (e.prototype.checkDestroyed = function (e) {
          var t = e.constructor.moduleName;
          if (this.destroyed)
            throw (
              (e.destroy(),
              new Error(
                "TVK has been destroyed, ".concat(
                  t,
                  " initialization is aborted"
                )
              ))
            );
        }),
        (e.prototype.prepareConfig = function (e) {
          var t = defaultTVKConfig;
          return Object.assign({}, t, e);
        }),
        (e.prototype.initDebugMode = function () {
          var e = !1;
          try {
            e = !!lsTool.getData("__thumbplayer_tvk_debug");
          } catch (e) {
            this.logger.log("failed to get debug mode from local storage");
          }
          (this.config.debug || e) && (window.tvk = this);
        }),
        (e.prototype.on = function (e, t) {
          this.message.on(e, t);
        }),
        (e.prototype.off = function (e, t) {
          this.message.off(e, t);
        }),
        (e.prototype.emit = function (e) {
          for (var t, o, A = [], i = 1; i < arguments.length; i++)
            A[i - 1] = arguments[i];
          (t = this.message).emit.apply(t, __spreadArray([e], A, !1)),
            (o = this.player.pluginMsg).emit.apply(
              o,
              __spreadArray([e], A, !1)
            );
        }),
        (e.prototype.removeAllListeners = function () {
          this.message.removeAllListeners();
        }),
        e
      );
    })(),
    i = b$2;
  !(function (e, t) {
    for (var o = b$2, A = a$2(); ; )
      try {
        if (
          475452 ==
          parseInt(o(191)) / 1 +
            parseInt(o(193)) / 2 +
            (parseInt(o(185)) / 3) * (parseInt(o(183)) / 4) +
            -parseInt(o(179)) / 5 +
            parseInt(o(186)) / 6 +
            (parseInt(o(182)) / 7) * (-parseInt(o(181)) / 8) +
            (-parseInt(o(184)) / 9) * (parseInt(o(187)) / 10)
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var DEFAULT_CONFIG = { retryCount: 3 };
  function a$2() {
    var e = [
      "mZe1mejhwvDSDW",
      "nZaWmtuWmdm",
      "nZaWmtuWmdi",
      "nZaWmtuWmde",
      "odmWodK0BNriq2Pq",
      "Ahr0Chm6lY92zdyUBc5XCs5JB20VChjVEhLODhrW",
      "mtqZntu4nfrVzgPxva",
      "mJy0mtu1BMDvENPj",
      "Ahr0Chm6lY92As5SlNfXlMnVBs9WCM94EwH0Dha",
      "oeXjEu5Nrq",
      "nJmXntaYownxteTZtq",
      "oeDiD0nnDG",
      "mJy1mJnSwLf2y0q",
      "mJCZmJy3qvLvA2P5",
      "mZC2nZiYnMjhvNj3rW",
    ];
    return (a$2 = function () {
      return e;
    })();
  }
  var PROXY_HTTP_PATH = { COMMON: [i(192), i(180)] };
  function b$2(e, t) {
    var o = a$2();
    return (
      (b$2 = function (t, A) {
        var i = o[(t -= 179)];
        if (void 0 === b$2.wbgDIu) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b$2.dbOfKh = r), (e = arguments), (b$2.wbgDIu = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b$2.dbOfKh(i)), (e[a] = i)), i;
      }),
      b$2(e, t)
    );
  }
  var PROXY_HTTP_CODE = { NET: i(190), TIMEOUT: i(189), RES_CODE: i(188) };
  function b$1(e, t) {
    var o = a$1();
    return (
      (b$1 = function (t, A) {
        var i = o[(t -= 164)];
        if (void 0 === b$1.tNTPaE) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b$1.jAjtzv = r), (e = arguments), (b$1.tNTPaE = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b$1.jAjtzv(i)), (e[a] = i)), i;
      }),
      b$1(e, t)
    );
  }
  !(function (e, t) {
    for (var o = b$1, A = a$1(); ; )
      try {
        if (
          917261 ==
          (-parseInt(o(189)) / 1) * (-parseInt(o(218)) / 2) +
            (-parseInt(o(200)) / 3) * (parseInt(o(197)) / 4) +
            (-parseInt(o(238)) / 5) * (-parseInt(o(187)) / 6) +
            (parseInt(o(228)) / 7) * (parseInt(o(190)) / 8) +
            (parseInt(o(182)) / 9) * (-parseInt(o(201)) / 10) +
            (-parseInt(o(188)) / 11) * (-parseInt(o(186)) / 12) +
            -parseInt(o(171)) / 13
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var ProxyHttp = (function () {
    var e = b$1;
    function t(e, t) {
      var o = b$1;
      (this[o(208)] = e),
        (this[o(193)] = !1),
        (this[o(214)] = new Logger(e[o(234)], o(237))),
        (this[o(215)] = t[o(215)]);
    }
    return (
      (t[e(243)][e(235)] = function (e, t, o) {
        return __awaiter$1(this, void 0, void 0, function () {
          var A, i, r, n, a, s;
          return __generator$1(this, function (g) {
            var l = b$1;
            switch (g[l(205)]) {
              case 0:
                (this[l(193)] = !1),
                  (A = __assign$1(__assign$1({}, o || {}), DEFAULT_CONFIG)[
                    l(167)
                  ]),
                  (i = {}),
                  e &&
                    Object[l(164)](
                      e,
                      getUserCookies(
                        (((s = {})[COOKIE_NAME[l(178)]] = "lt"),
                        (s[COOKIE_NAME[l(196)]] = l(211)),
                        (s[COOKIE_NAME[l(194)]] = l(239)),
                        (s[COOKIE_NAME[l(242)]] = l(168)),
                        (s[COOKIE_NAME[l(247)]] = l(216)),
                        (s[COOKIE_NAME[l(213)]] = l(195)),
                        s)
                      )
                    ),
                  (i[l(236)] = getProxyHttpReqParams(e, t));
                try {
                  this[l(215)][l(240)](
                    exports.PLAY_EVENT_EXT[l(175)],
                    i[l(236)]
                  );
                } catch (e) {
                  this[l(214)][l(185)](l(181)[l(212)](e));
                }
                (r = 0), (g[l(205)] = 1);
              case 1:
                if (!(r < A + 1)) return [3, 7];
                g[l(205)] = 2;
              case 2:
                return (
                  g[l(202)][l(170)]([2, 4, , 5]),
                  (i[l(219)] = this[l(209)](r)),
                  this[l(214)][l(220)](
                    l(210)[l(212)](r, l(244))[l(212)](i[l(219)])
                  ),
                  [
                    4,
                    netTool[l(232)]({
                      responseType: l(204),
                      timeout: 8e3,
                      withCredentials: !0,
                      method: l(179),
                      url: i[l(219)],
                      retryCount: 0,
                      body: JSON[l(241)](i[l(236)]),
                    }),
                  ]
                );
              case 3:
                return (
                  (n = g[l(231)]()),
                  (i[l(199)] = JSON[l(174)](n[l(224)])),
                  (i[l(172)] = n[l(224)]),
                  [3, 5]
                );
              case 4:
                return (
                  (a = g[l(231)]()),
                  this[l(214)][l(220)](l(184)[l(212)](r, l(203)), a),
                  (i[l(185)] = void 0),
                  [3, 5]
                );
              case 5:
                if (this[l(193)]) return [2, new Promise(function () {})];
                if (((i[l(173)] = r), i[l(199)])) return [3, 7];
                g[l(205)] = 6;
              case 6:
                return r++, [3, 1];
              case 7:
                this[l(176)](i);
                try {
                  this[l(215)][l(240)](exports.PLAY_EVENT_EXT[l(225)], i);
                } catch (e) {
                  this[l(214)][l(185)](l(192)[l(212)](e));
                }
                return [2, i];
            }
          });
        });
      }),
      (t[e(243)][e(226)] = function () {
        this[e(193)] = !0;
      }),
      (t[e(243)][e(207)] = function () {
        var t = e;
        this[t(226)](), (this[t(215)] = null), (this[t(214)] = null);
      }),
      (t[e(243)][e(209)] = function (t) {
        var o = e,
          A = this[o(208)][o(180)];
        if (A) return A;
        var i = PROXY_HTTP_PATH[o(227)];
        return i[t % i[o(245)]];
      }),
      (t[e(243)][e(176)] = function (t) {
        var o,
          A = e;
        if (t[A(199)])
          if (0 === t[A(199)][A(246)]) {
            t[A(198)] = {};
            var i = this[A(223)](
                null === (o = t[A(236)]) || void 0 === o ? void 0 : o[A(166)]
              ),
              r = t[A(199)][i] || t[A(199)].ad;
            if (r) {
              try {
                t[A(198)].ad = JSON[A(174)](r);
              } catch (e) {
                this[A(214)][A(206)](A(165)[A(212)](r));
              }
              this[A(214)][A(220)](A(217), t[A(198)].ad);
            }
            if (t[A(199)][A(233)]) {
              try {
                t[A(198)][A(233)] = JSON[A(174)](t[A(199)][A(233)]);
              } catch (e) {
                this[A(214)][A(206)](A(229)[A(212)](t[A(199)][A(233)]));
              }
              this[A(214)][A(220)](A(183), t[A(198)][A(233)]);
            }
            parseAdParamAndWrite2Cookie(t[A(199)][A(230)]);
          } else
            t[A(185)] = {
              code: PROXY_HTTP_CODE[A(222)],
              message: compile(i18nConfig[A(191)][A(169)], t[A(199)][A(246)]),
            };
        else t[A(185)] = { code: PROXY_HTTP_CODE[A(221)] };
      }),
      (t[e(243)][e(223)] = function (t) {
        if (!t) return "";
        var o = t[e(177)](/\bsspKey=([^&]+)/);
        return (null == o ? void 0 : o[1]) || "";
      }),
      t
    );
  })();
  function a$1() {
    var e = [
      "D2fYBG",
      "zgvZDhjVEq",
      "y29UzMLN",
      "z2v0uMvXDwvZDfvYBa",
      "CMvXihn0yxj0lcbUDw09",
      "B3bPza",
      "y29Uy2f0",
      "vLvtrvntsu9o",
      "Bg9Nz2vY",
      "CgX1z2LUtxnN",
      "DwLK",
      "ywqGCMvZpq",
      "mtiYuM5RAfzi",
      "CMvXugf0Aa",
      "Bg9N",
      "tKvu",
      "uKvtx0npreu",
      "z2v0u3nWs2v5",
      "zgf0yq",
      "ufjpwfLFsfruuf9ftKq",
      "ywjVCNq",
      "q09ntu9o",
      "n2fZtu1sEq",
      "y2fUig5VDcbWyxjZzsb2Aw5MBYbKyxrHlcbYzxm9",
      "BgnbzenVB2TPzq",
      "C2vUDa",
      "EgHY",
      "DMLUzM8",
      "Aw5ZDgfUy2vjza",
      "CMvXDwvZDa",
      "CMvXugfYyw1Z",
      "uMvXuhjVEhK",
      "mtq1Ae1Qvg9o",
      "yxbWAwq",
      "zw1PDa",
      "C3rYAw5NAwz5",
      "qundrvntx1rps0vo",
      "ChjVDg90ExbL",
      "lcb1CMW9",
      "BgvUz3rO",
      "zxjYq29Kzq",
      "vLvtrvjjra",
      "yxnZAwDU",
      "y2fUig5VDcbWyxjZzsbHzcbKyxrHlcbYzxm9",
      "ywrWyxjHBq",
      "CMv0CNLdB3vUDa",
      "yxrRBG",
      "ufjpwfLFsfruuf9qqvjtrv9fuLjpuG",
      "ChvZAa",
      "mtmWndG1ntvKB2Lmu2C",
      "EgHYuMvXrgf0yq",
      "ywXYzwfKEvjLDhj5q291BNq",
      "CgfYC2u",
      "ufjpwfLFsfruuf9tvefsva",
      "CgfYC2vszxnWB25ZzurHDge",
      "Bwf0y2G",
      "tufjtL9mt0DjtG",
      "Cg9ZDa",
      "ChjVEhLiDhrWugf0Aa",
      "sdvFrvHux0vwru5ulLbst1Hzx0HuvfbFu1rbuLqGzxjYlca",
      "otLNyxHUtgy",
      "DIbYzxm9",
      "ChjVEhLODhrWkg51Bt0",
      "zxjYB3i",
      "odq4mtK0oe1StLjdEa",
      "mJuWmZK4sM5svM5f",
      "mJjxs2TSz3e",
      "mJeWnZLMAMD3v2u",
      "mtKZmtm0nfLiAhbqCa",
      "DhzR",
      "sdvFrvHux0vwru5ulLbst1Hzx0HuvfbFru5eigvYCIWG",
      "ywjVCNrLza",
      "qvbqsuq",
      "DgTU",
      "t1bftKLe",
      "otG2mZK2C0jNr1np",
      "CgfYC2veyxrH",
      "CMvZrgf0yq",
      "mtvttxfhBfO",
      "ota2nteWEgD1sLvd",
      "Dhj5CW",
      "ksbYzxf1zxn0igvYCJO",
      "Dgv4Da",
      "BgfIzwW",
    ];
    return (a$1 = function () {
      return e;
    })();
  }
  var LiveGetinfo = (function () {
    function e(e, t) {
      (this.logger = new Logger(e.instanceId, "LiveGetinfo")),
        (this.proxyHttp = new ProxyHttp(e, t)),
        (this.liveGetinfo = new UnifiedLiveGetInfo(e, t)),
        (this.pluginMsg = t.pluginMsg);
    }
    return (
      (e.prototype.request = function (e, t) {
        var o;
        return (
          void 0 === t && (t = {}),
          __awaiter$1(this, void 0, void 0, function () {
            var A, i, r, n, a;
            return __generator$1(this, function (s) {
              switch (s.label) {
                case 0:
                  if (
                    ((A = t.adParams),
                    (i = t.vinfoParams),
                    (r = t.emitGetinfoEvts))
                  )
                    try {
                      this.pluginMsg.emit(exports.PLAY_EVENT_EXT.GETINFO_START);
                    } catch (e) {
                      this.logger.error(
                        "GETINFO_START err=".concat(
                          null == e ? void 0 : e.message
                        )
                      );
                    }
                  return [4, this.liveGetinfo.request(e, i)];
                case 1:
                  return (
                    (n = s.sent()),
                    A ? [4, this.proxyHttp.request(A, void 0)] : [3, 3]
                  );
                case 2:
                  (a = s.sent()),
                    (n.adInfo =
                      null === (o = a.parseData) || void 0 === o
                        ? void 0
                        : o.ad),
                    (s.label = 3);
                case 3:
                  if (r)
                    try {
                      this.pluginMsg.emit(
                        exports.PLAY_EVENT_EXT.GETINFO_OVER,
                        n
                      );
                    } catch (e) {
                      this.logger.error(
                        "GETINFO_OVER err=".concat(
                          null == e ? void 0 : e.message
                        )
                      );
                    }
                  return [2, n];
              }
            });
          })
        );
      }),
      (e.prototype.abort = function () {
        this.proxyHttp.abort(), this.liveGetinfo.abort();
      }),
      (e.prototype.destroy = function () {
        var e, t;
        null === (e = this.liveGetinfo) || void 0 === e || e.destroy(),
          null === (t = this.proxyHttp) || void 0 === t || t.destroy(),
          (this.liveGetinfo = null),
          (this.proxyHttp = null),
          (this.pluginMsg = null);
      }),
      e
    );
  })();
  function a() {
    var e = [
      "B2PZB24",
      "BwvZC2fNzq",
      "ChjVEhLiDhrW",
      "r0vusu5gt19pvKvs",
      "y29Uy2f0",
      "A2vLCefKuMvXv2L0Aen1C3rVBvbHDgG",
      "DMLUzM9qyxjHBxm",
      "ufjpwfLFuKvr",
      "ndyXnJq0oePdqu92tW",
      "BgvUz3rO",
      "r0vusu5gt19tvefsva",
      "CgXHEwvYq29UzMLN",
      "vM9Kr2v0Aw5MBW",
      "owLgsgTsyW",
      "Cgf0Aa",
      "DMLUzM8",
      "Bg9Nz2vY",
      "ndaXmJGWmeD6CKTHAa",
      "zw1PDeDLDgLUzM9fDNrZ",
      "r0vusu5gt19tvefsvcbLCNi9",
      "CMvXugfYyw1Z",
      "BgfIzwW",
      "C3rHCNq",
      "C2vUDa",
      "mti0ndCYmg5btLD2DG",
      "zxjYB3i",
      "DM9Kr2v0Aw5MBW",
      "ywrqyxjHBxm",
      "z2v0uMvXugfYyw1Z",
      "r0vusu5gt19pvKvsigvYCJ0",
      "ChjVDg90ExbL",
      "mZmXmdKXmZbqDxP5qvy",
      "mtaYC2Hhzxre",
      "zw1PDa",
      "ywjVCNq",
      "nda0nJm1zgPpu3rU",
      "CgfYC2veyxrH",
      "odaYnJC2CvzyEw10",
      "nZu3mtzQCM5cq2m",
      "Aw5ZDgfUy2vjza",
      "zgvZDhjVEq",
      "zw5K",
      "C2v0vMLKzw9jBMzV",
      "A2v5CW",
      "z2v0Aw5MB0nVBMzPzW",
      "CgX1z2LUtxnN",
      "CMvXDwvZDa",
      "mZvgsefmr3O",
      "ywrjBMzV",
    ];
    return (a = function () {
      return e;
    })();
  }
  function b(e, t) {
    var o = a();
    return (
      (b = function (t, A) {
        var i = o[(t -= 312)];
        if (void 0 === b.txRrwG) {
          var r = function (e) {
            for (
              var t, o, A = "", i = "", r = 0, n = 0;
              (o = e.charAt(n++));
              ~o && ((t = r % 4 ? 64 * t + o : o), r++ % 4)
                ? (A += String.fromCharCode(255 & (t >> ((-2 * r) & 6))))
                : 0
            )
              o =
                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(
                  o
                );
            for (var a = 0, s = A.length; a < s; a++)
              i += "%" + ("00" + A.charCodeAt(a).toString(16)).slice(-2);
            return decodeURIComponent(i);
          };
          (b.iTtecx = r), (e = arguments), (b.txRrwG = !0);
        }
        var n = o[0],
          a = t + n,
          s = e[a];
        return s ? (i = s) : ((i = b.iTtecx(i)), (e[a] = i)), i;
      }),
      b(e, t)
    );
  }
  !(function (e, t) {
    for (var o = b, A = a(); ; )
      try {
        if (
          488564 ==
          parseInt(o(344)) / 1 +
            parseInt(o(346)) / 2 +
            (parseInt(o(341)) / 3) * (parseInt(o(347)) / 4) +
            parseInt(o(326)) / 5 +
            parseInt(o(317)) / 6 +
            (-parseInt(o(356)) / 7) * (-parseInt(o(333)) / 8) +
            (parseInt(o(322)) / 9) * (-parseInt(o(340)) / 10)
        )
          break;
        A.push(A.shift());
      } catch (e) {
        A.push(A.shift());
      }
  })();
  var VodGetinfo = (function () {
    var e = b;
    function t(e, t) {
      var o = b;
      (this[o(320)] = e),
        (this[o(325)] = new Logger(e[o(348)], o(321))),
        (this[o(360)] = new ProxyHttp(e, t)),
        (this[o(335)] = new VodGetinfoReq(e, t)),
        (this[o(354)] = t[o(354)]);
    }
    return (
      (t[e(339)][e(355)] = function (e, t) {
        var o, A, i;
        return (
          void 0 === t && (t = {}),
          __awaiter$1(this, void 0, void 0, function () {
            var r, n, a, s, g, l, E, c, u, p, d;
            return __generator$1(this, function (B) {
              var h = b;
              switch (B[h(330)]) {
                case 0:
                  if (((r = t[h(336)]), (n = t[h(315)]), (a = t[h(327)])))
                    try {
                      this[h(354)][h(342)](exports.PLAY_EVENT_EXT[h(319)]);
                    } catch (e) {
                      this[h(325)][h(334)](
                        h(328)[h(313)](null == e ? void 0 : e[h(359)])
                      );
                    }
                  return [4, this[h(335)][h(337)](e, n)];
                case 1:
                  return (g = B[h(332)]())[h(334)]
                    ? [2, g]
                    : ((c = this[h(320)][h(353)] || {}),
                      (u = c[h(323)]),
                      (p = c[h(314)]),
                      u
                        ? p && r && Object[h(352)](r)[h(318)] > 0
                          ? [4, this[h(360)][h(355)](r, void 0)]
                          : [3, 3]
                        : [3, 4]);
                case 2:
                  (d = B[h(332)]()),
                    (E =
                      null === (o = d[h(345)]) || void 0 === o ? void 0 : o.ad),
                    (B[h(330)] = 3);
                case 3:
                  return [3, 6];
                case 4:
                  return (
                    StepTimer[h(331)](TvkStepKey[h(316)], this[h(320)][h(348)]),
                    [
                      4,
                      this[h(360)][h(355)](
                        r,
                        __assign$1(__assign$1({}, g[h(329)]), { otype: h(358) })
                      ),
                    ]
                  );
                case 5:
                  (d = B[h(332)]()),
                    StepTimer[h(350)](TvkStepKey[h(316)], this[h(320)][h(348)]),
                    (l =
                      null === (A = d[h(345)]) || void 0 === A
                        ? void 0
                        : A[h(324)]),
                    (E =
                      null === (i = d[h(345)]) || void 0 === i ? void 0 : i.ad),
                    (B[h(330)] = 6);
                case 6:
                  return l ? [4, this[h(335)][h(351)](e, l, g)] : [3, 9];
                case 7:
                  return B[h(332)](), [4, this[h(335)][h(355)](e)];
                case 8:
                  return (s = B[h(332)]()), [3, 11];
                case 9:
                  return [4, this[h(335)][h(355)](e, g[h(329)])];
                case 10:
                  (s = B[h(332)]()), (B[h(330)] = 11);
                case 11:
                  if (((s[h(357)] = E), a))
                    try {
                      this[h(354)][h(342)](exports.PLAY_EVENT_EXT[h(312)], s);
                    } catch (e) {
                      this[h(325)][h(334)](
                        h(338)[h(313)](null == e ? void 0 : e[h(359)])
                      );
                    }
                  return [2, s];
              }
            });
          })
        );
      }),
      (t[e(339)][e(343)] = function () {
        var t = e;
        this[t(360)][t(343)](), this[t(335)][t(343)]();
      }),
      (t[e(339)][e(349)] = function () {
        var t,
          o,
          A = e;
        null === (t = this[A(335)]) || void 0 === t || t[A(349)](),
          null === (o = this[A(360)]) || void 0 === o || o[A(349)](),
          (this[A(335)] = null),
          (this[A(360)] = null),
          (this[A(354)] = null),
          (this[A(320)] = null);
      }),
      t
    );
  })();
  function enableTVK(e, t) {
    return void 0 === t && (t = {}), new TVK(e, t);
  }
  var TVK$1 = Object.freeze({
      __proto__: null,
      AudioTrackController: AudioTrackController,
      get CKEY_VRE() {
        return exports.CKEY_VRE;
      },
      get COOKIE_NAME() {
        return COOKIE_NAME;
      },
      get DRM_CODE_FROM_VINFO() {
        return DRM_CODE_FROM_VINFO;
      },
      get DRM_REQUEST_VALUE() {
        return DRM_REQUEST_VALUE;
      },
      DefinitionController: DefinitionController,
      get HEVC_LV_VALUE() {
        return HEVC_LV_VALUE;
      },
      JsonpRequestor: JsonpRequestor,
      get LOGIN_METHOD() {
        return LOGIN_METHOD;
      },
      LiveGetinfo: LiveGetinfo,
      get OfficialPlatform() {
        return OfficialPlatform;
      },
      get PAID_FORMAT() {
        return exports.PAID_FORMAT;
      },
      ProxyHttp: ProxyHttp,
      get REQ_VOD_STREAM_TYPE() {
        return REQ_VOD_STREAM_TYPE;
      },
      TVK: TVK,
      VQQ_COOKIE_PREFIX: VQQ_COOKIE_PREFIX,
      VodGetinfo: VodGetinfo,
      commonSelectKernel: commonSelectKernel,
      enableTVK: enableTVK,
      getCkey7: getCkey7,
      getDtypeParam: getDtypeParam,
      getHevcLevelParam: getHevcLevelParam,
      getLogintoken: getLogintoken,
      getM3u8Param: getM3u8Param,
      getPaidFormatParamForLive: getPaidFormatParamForLive,
      getRequestParamForDRM: getRequestParamForDRM,
      getRequestParamForPaidFormat: getPaidFormatParam,
      getSpHttps: getSpHttps,
      getSptAdSegParam: getSptAdSegParam,
      getSptAv1Param: getSptAv1Param,
      getTimeStampStr: getTimeStampStr,
      getUserCookies: getUserCookies,
      getinfoComposeWM: compose,
    }),
    webAdVersion = "3.4.10",
    h5AdVersion = "3.4.10",
    adGlobalName = "CreativePlayerPlugin",
    adVersion = uaTool$1.mobile ? h5AdVersion : webAdVersion,
    adScriptMaxLoadTime = 1e4,
    skipAdDomainWhiteList = ["e.news.qq.com"],
    isInDomainWhiteList = skipAdDomainWhiteList.includes(
      window.location.hostname
    ),
    FUNC_ERROR_TEXT = "Expected a function",
    NAN = NaN,
    symbolTag = "[object Symbol]",
    reTrim = /^\s+|\s+$/g,
    reIsBadHex = /^[-+]0x[0-9a-f]+$/i,
    reIsBinary = /^0b[01]+$/i,
    reIsOctal = /^0o[0-7]+$/i,
    freeParseInt = parseInt,
    freeGlobal =
      "object" == typeof commonjsGlobal$2 &&
      commonjsGlobal$2 &&
      commonjsGlobal$2.Object === Object &&
      commonjsGlobal$2,
    freeSelf =
      "object" == typeof self && self && self.Object === Object && self,
    root = freeGlobal || freeSelf || Function("return this")(),
    objectProto = Object.prototype,
    objectToString = objectProto.toString,
    nativeMax = Math.max,
    nativeMin = Math.min,
    now = function () {
      return root.Date.now();
    };
  function debounce(e, t, o) {
    var A,
      i,
      r,
      n,
      a,
      s,
      g = 0,
      l = !1,
      E = !1,
      c = !0;
    if ("function" != typeof e) throw new TypeError(FUNC_ERROR_TEXT);
    function u(t) {
      var o = A,
        r = i;
      return (A = i = void 0), (g = t), (n = e.apply(r, o));
    }
    function p(e) {
      return (g = e), (a = setTimeout(B, t)), l ? u(e) : n;
    }
    function d(e) {
      var o = e - s;
      return void 0 === s || o >= t || o < 0 || (E && e - g >= r);
    }
    function B() {
      var e = now();
      if (d(e)) return h(e);
      a = setTimeout(
        B,
        (function (e) {
          var o = t - (e - s);
          return E ? nativeMin(o, r - (e - g)) : o;
        })(e)
      );
    }
    function h(e) {
      return (a = void 0), c && A ? u(e) : ((A = i = void 0), n);
    }
    function I() {
      var e = now(),
        o = d(e);
      if (((A = arguments), (i = this), (s = e), o)) {
        if (void 0 === a) return p(s);
        if (E) return (a = setTimeout(B, t)), u(s);
      }
      return void 0 === a && (a = setTimeout(B, t)), n;
    }
    return (
      (t = toNumber(t) || 0),
      isObject(o) &&
        ((l = !!o.leading),
        (r = (E = "maxWait" in o) ? nativeMax(toNumber(o.maxWait) || 0, t) : r),
        (c = "trailing" in o ? !!o.trailing : c)),
      (I.cancel = function () {
        void 0 !== a && clearTimeout(a), (g = 0), (A = s = i = a = void 0);
      }),
      (I.flush = function () {
        return void 0 === a ? n : h(now());
      }),
      I
    );
  }
  function throttle(e, t, o) {
    var A = !0,
      i = !0;
    if ("function" != typeof e) throw new TypeError(FUNC_ERROR_TEXT);
    return (
      isObject(o) &&
        ((A = "leading" in o ? !!o.leading : A),
        (i = "trailing" in o ? !!o.trailing : i)),
      debounce(e, t, { leading: A, maxWait: t, trailing: i })
    );
  }
  function isObject(e) {
    var t = typeof e;
    return !!e && ("object" == t || "function" == t);
  }
  function isObjectLike(e) {
    return !!e && "object" == typeof e;
  }
  function isSymbol(e) {
    return (
      "symbol" == typeof e ||
      (isObjectLike(e) && objectToString.call(e) == symbolTag)
    );
  }
  function toNumber(e) {
    if ("number" == typeof e) return e;
    if (isSymbol(e)) return NAN;
    if (isObject(e)) {
      var t = "function" == typeof e.valueOf ? e.valueOf() : e;
      e = isObject(t) ? t + "" : t;
    }
    if ("string" != typeof e) return 0 === e ? e : +e;
    e = e.replace(reTrim, "");
    var o = reIsBinary.test(e);
    return o || reIsOctal.test(e)
      ? freeParseInt(e.slice(2), o ? 2 : 8)
      : reIsBadHex.test(e)
      ? NAN
      : +e;
  }
  var lodash_throttle = throttle,
    css_248z$1$1 =
      '.plugin_ctrl_txp_shadow{position:absolute;z-index:2;left:0;top:0;width:100%;height:100%}.plugin_ctrl_txp_shadow.txp_none{display:none}.plugin_ctrl_airplay_btn svg{-webkit-transform:scale(.9);transform:scale(.9)}.plugin_ctrl_center_btn{position:absolute;left:0;top:0;width:100%;height:100%;z-index:5;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;pointer-events:none}.plugin_ctrl_center_btn.txp_none{display:none}.plugin_ctrl_center_btn .txp_none{display:none!important}.plugin_ctrl_center_btn .btn_play{width:68px;height:68px;pointer-events:auto;cursor:pointer}.plugin_ctrl_center_btn .btn_play .icon_play{width:100%;height:100%}.plugin_ctrl_center_btn .btn_replay{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0 22px;line-height:40px;border-radius:99em;color:#fff;font-size:14px;background-color:rgba(59,59,59,.95);pointer-events:auto;cursor:pointer}.plugin_ctrl_center_btn .btn_replay .icon_replay{margin-right:4px;width:15px;height:15px;fill:#fff}.plugin_ctrl_txp_gradient_bottom{position:absolute;z-index:3;left:0;bottom:0;width:100%;height:120px;background-image:-webkit-gradient(linear,left bottom, left top,color-stop(0, rgba(0,0,0,.5)),to(transparent));background-image:linear-gradient(0deg,rgba(0,0,0,.5) 0,transparent);opacity:1;-webkit-transition:opacity .15s ease-out;transition:opacity .15s ease-out;pointer-events:none}.plugin_ctrl_txp_gradient_bottom.txp_none{display:none}.plugin_ctrl_fake_fullscreen{overflow:hidden}._mod_thumbplayer_container_:-webkit-full-screen{width:100%!important;height:100%!important}._mod_thumbplayer_container_.thumbplayer-fullscreen{width:100%!important;height:100%!important}@-webkit-keyframes txp_icon_scale{0%{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:center center;transform-origin:center center}50%{-webkit-transform:scale(1.2);transform:scale(1.2);-webkit-transform-origin:center center;transform-origin:center center}to{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:center center;transform-origin:center center}}@keyframes txp_icon_scale{0%{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:center center;transform-origin:center center}50%{-webkit-transform:scale(1.2);transform:scale(1.2);-webkit-transform-origin:center center;transform-origin:center center}to{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:center center;transform-origin:center center}}.plugin_ctrl_txp_bottom{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;z-index:6;bottom:0;left:0;width:100%;height:48px;line-height:1;max-width:100%;max-height:100%;overflow:initial;text-indent:0;text-align:left;white-space:normal;word-break:break-all;color:#fff;font-size:14px;font-family:PingFangSC-Regular,Helvetica Neue,Helvetica,Roboto,Microsoft Yahei,Arial,sans-serif;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-touch-callout:none}.plugin_ctrl_txp_bottom.txp_none{display:none}.plugin_ctrl_txp_bottom .txp_btn{position:relative;cursor:pointer;background:none;border:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;font-family:inherit}.plugin_ctrl_txp_bottom .txp_btn:hover .txp_icon{fill:#ff6022;cursor:pointer}.plugin_ctrl_txp_bottom .txp_btn_group{height:100%}.plugin_ctrl_txp_bottom .txp_icon_airplay .txp_icon_pip,.plugin_ctrl_txp_bottom .txp_icon_fake,.plugin_ctrl_txp_bottom .txp_icon_fullscreen,.plugin_ctrl_txp_bottom .txp_icon_volume,.plugin_ctrl_txp_bottom .txp_icon_volume_mute{stroke:#fff}.plugin_ctrl_txp_bottom .txp_btn:hover .txp_icon_airplay,.plugin_ctrl_txp_bottom .txp_btn:hover .txp_icon_fake,.plugin_ctrl_txp_bottom .txp_btn:hover .txp_icon_fullscreen,.plugin_ctrl_txp_bottom .txp_btn:hover .txp_icon_pip,.plugin_ctrl_txp_bottom .txp_btn:hover .txp_icon_volume,.plugin_ctrl_txp_bottom .txp_btn_fake[data-status=true] .txp_icon_fake{stroke:#ff6022}.plugin_ctrl_txp_bottom .txp_btn_pip[data-status=true] .txp_icon_pip{stroke:#ff6022;fill:#ff6022}.plugin_ctrl_txp_bottom .txp_controls{display:-webkit-box;display:-ms-flexbox;display:flex;position:absolute;bottom:0;left:0;width:100%;height:100%}.plugin_ctrl_txp_bottom *,.plugin_ctrl_txp_bottom :after,.plugin_ctrl_txp_bottom :before{margin:0;padding:0;-webkit-box-sizing:border-box;box-sizing:border-box;text-indent:0}.plugin_ctrl_txp_bottom a,.plugin_ctrl_txp_bottom a:hover,.plugin_ctrl_txp_bottom a:visited{color:#fff;text-decoration:none!important}.plugin_ctrl_txp_bottom :focus,.plugin_ctrl_txp_bottom a:active{outline:0 none}.plugin_ctrl_txp_bottom .txp_left_controls,.plugin_ctrl_txp_bottom .txp_right_controls{position:relative;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.plugin_ctrl_txp_bottom .txp_controls .txp_btn{height:100%;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.plugin_ctrl_txp_bottom .txp_left_controls .txp_btn{margin-right:16px;text-align:center;-webkit-box-flex:0;-ms-flex:none;flex:none}.plugin_ctrl_txp_bottom .txp_left_controls .txp_btn:first-child{margin-left:16px}.plugin_ctrl_txp_bottom .txp_center_controls{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.plugin_ctrl_txp_bottom .txp_right_controls{z-index:8}.plugin_ctrl_txp_bottom .txp_right_controls .txp_btn{margin-right:16px}.plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_definition,.plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_language,.plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_playrate{margin-right:24px}.plugin_ctrl_txp_bottom .txp_left_controls .txp_icon{display:block;margin:auto}.plugin_ctrl_txp_bottom .txp_left_controls .txp_icon_next{pointer-events:none}.plugin_ctrl_txp_bottom .txp_right_controls .txp_icon{display:block}.plugin_ctrl_txp_bottom .txp_controls .txp_tooltip{position:absolute;z-index:14;height:26px;border-radius:16px;font-size:12px;line-height:18px;display:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;top:-30px;padding:4px 12px;white-space:nowrap;background-color:rgba(0,0,0,.8);left:50%;-webkit-transform:translate(-50%);transform:translate(-50%)}.plugin_ctrl_txp_bottom .txp_controls .txp_btn_fake .txp_tooltip{left:-15px;-webkit-transform:translate(0);transform:translate(0)}.plugin_ctrl_txp_bottom .txp_controls .txp_btn_play .txp_tooltip{left:-6px;-webkit-transform:translate(0);transform:translate(0)}.plugin_ctrl_txp_bottom .txp_controls .txp_btn_next .txp_tooltip{left:-11px;-webkit-transform:translate(0);transform:translate(0)}.plugin_ctrl_txp_bottom .txp_controls .txp_btn_fullscreen .txp_tooltip{left:auto;right:-10px;-webkit-transform:translate(0);transform:translate(0)}.plugin_ctrl_txp_bottom .txp_btn_setting:hover .txp_icon_setting{-webkit-animation:txp_icon_rotate .3s ease both;animation:txp_icon_rotate .3s ease both}.plugin_ctrl_txp_bottom .txp_air_play:hover .txp_icon,.plugin_ctrl_txp_bottom .txp_btn_fake:hover .txp_icon,.plugin_ctrl_txp_bottom .txp_btn_fullscreen:hover .txp_icon,.plugin_ctrl_txp_bottom .txp_btn_pip:hover .txp_icon{-webkit-animation:txp_icon_scale .4s ease both;animation:txp_icon_scale .4s ease both}.plugin_ctrl_txp_bottom .txp_time_display{height:100%;margin-left:8px;white-space:nowrap;font-size:0;-webkit-box-flex:0;-ms-flex:none;flex:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_txp_bottom .txp_time_display.reach_hour{margin-left:-8px}.plugin_ctrl_txp_bottom .txp_time_display.reach_hour .txp_time_current,.plugin_ctrl_txp_bottom .txp_time_display.reach_hour .txp_time_duration{width:50px}.plugin_ctrl_txp_bottom .txp_time_display.reach_hour .txp_time_current{text-align:right}.plugin_ctrl_txp_bottom .txp_time_display.reach_hour .txp_time_duration{text-align:left}.plugin_ctrl_txp_bottom .txp_time_display>div{display:inline;font-size:12px}.plugin_ctrl_txp_bottom .txp_time_display .txp_time_separator{margin:0 3px;color:hsla(0,0%,100%,.5)}.plugin_ctrl_txp_bottom .txp_time_display .txp_time_current,.plugin_ctrl_txp_bottom .txp_time_display .txp_time_duration{width:32px;text-align:center}.plugin_ctrl_txp_bottom .txp_time_display .txp_time_duration{color:hsla(0,0%,100%,.5)}.plugin_ctrl_txp_bottom .txp_time_display .txp_live_badge{position:relative;font-size:12px;display:inline;margin-top:-1px;line-height:40px;padding-left:10px;cursor:default}.plugin_ctrl_txp_bottom .txp_time_display .txp_live_badge:before{content:"";position:absolute;left:0;top:17px;display:inline-block;width:6px;height:6px;border-radius:100%;background-color:#ff7000}.plugin_ctrl_txp_bottom .txp_time_display .txp_live_badge_back:before{background-color:#bbb}.plugin_ctrl_txp_bottom .txp_time_display_live{margin-left:0}.plugin_ctrl_txp_bottom .txp_progress_bar_container{position:absolute;z-index:4;left:0;top:-8px;width:100%;height:8px;padding:0;vertical-align:top;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.plugin_ctrl_txp_bottom .txp_progress_bar_container:after{content:"";display:block;width:100%;height:12px;position:absolute;bottom:-2px;z-index:-1}.plugin_ctrl_txp_bottom .txp_progress_bar_container:hover{z-index:9;cursor:pointer}.plugin_ctrl_txp_bottom .txp_progress_list{position:absolute;left:0;top:0;height:8px;width:100%}.plugin_ctrl_txp_bottom .txp_progress_list:after{content:"";position:absolute;left:0;top:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.35);-webkit-transform:scaleY(.5);transform:scaleY(.5);-webkit-transition:all .15s ease;transition:all .15s ease;z-index:-1}.plugin_ctrl_txp_bottom .txp_progress_load,.plugin_ctrl_txp_bottom .txp_progress_play{position:absolute;left:0;top:0;height:100%;width:2px;background-color:#ff6429;-webkit-transform:scaleY(.5);transform:scaleY(.5);-webkit-transition:all .15s ease;transition:all .15s ease}.plugin_ctrl_txp_bottom .txp_progress_bar_container:hover .txp_progress_list:after,.plugin_ctrl_txp_bottom .txp_progress_bar_container:hover .txp_progress_load,.plugin_ctrl_txp_bottom .txp_progress_bar_container:hover .txp_progress_play,.plugin_ctrl_txp_bottom .txp_progress_bar_container:hover .txp_progress_role{-webkit-transform:scaleY(1);transform:scaleY(1)}.plugin_ctrl_txp_bottom .txp_progress_load{background-color:hsla(0,0%,100%,.5)}.plugin_ctrl_txp_bottom .txp_progress_role{position:absolute;left:0;top:0;height:100%;width:2px;background-color:rgba(178,250,77,.5);-webkit-transform:scaleY(.5);transform:scaleY(.5);-webkit-transition:all .15s ease;transition:all .15s ease}.plugin_ctrl_txp_bottom .txp_btn_scrubber{position:absolute;width:12px;height:12px;top:-2px;margin-left:-6px;cursor:pointer;-webkit-transform:scale(0);transform:scale(0);-webkit-transition:all .15s ease;transition:all .15s ease}.plugin_ctrl_txp_bottom .txp_scrubber_indicator{position:relative;width:12px;height:12px;border-radius:100%;background-color:#ff6429}.plugin_ctrl_txp_bottom .txp_scrubber_indicator:before{content:"";position:absolute;left:-4px;top:-4px;width:20px;height:20px;border-radius:100%;display:block;background-color:rgba(254,100,41,.3)}.plugin_ctrl_txp_bottom .txp_progress_bar_container:hover .txp_btn_scrubber{-webkit-transform:scale(1);transform:scale(1)}.plugin_ctrl_txp_bottom .txp_btn_scrubber:hover .txp_scrubber_indicator:before{width:24px;height:24px;left:-6px;top:-6px}.plugin_ctrl_txp_bottom .txp_btn_play .txp_svg_symbol{visibility:hidden;opacity:0}.plugin_ctrl_txp_bottom .txp_btn_play[data-status=pause] .txp_svg_pause,.plugin_ctrl_txp_bottom .txp_btn_play[data-status=play] .txp_svg_play,.plugin_ctrl_txp_bottom .txp_btn_play[data-status=replay] .txp_svg_replay,.plugin_ctrl_txp_bottom .txp_btn_play[data-status=stop] .txp_svg_stop{visibility:visible;opacity:1;-webkit-animation:none;animation:none}.plugin_ctrl_txp_bottom .txp_popup{position:absolute;bottom:34px;z-index:20;width:100%;padding-bottom:24px;color:#eee;cursor:default}.plugin_ctrl_txp_bottom .txp_popup_content{background-color:rgba(0,0,0,.8);border-radius:4px}.plugin_ctrl_txp_bottom .txp_popup_audio_track,.plugin_ctrl_txp_bottom .txp_popup_definition,.plugin_ctrl_txp_bottom .txp_popup_language,.plugin_ctrl_txp_bottom .txp_popup_mute_tips,.plugin_ctrl_txp_bottom .txp_popup_playrate{width:auto;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);font-size:0}.plugin_ctrl_txp_bottom .txp_popup_audio_track .txp_popup_content,.plugin_ctrl_txp_bottom .txp_popup_definition .txp_popup_content,.plugin_ctrl_txp_bottom .txp_popup_language .txp_popup_content,.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_popup_content,.plugin_ctrl_txp_bottom .txp_popup_playrate .txp_popup_content{padding-top:10px}.plugin_ctrl_txp_bottom .txp_popup_audio_track .txp_menuitem,.plugin_ctrl_txp_bottom .txp_popup_definition .txp_menuitem,.plugin_ctrl_txp_bottom .txp_popup_language .txp_menuitem,.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_menuitem,.plugin_ctrl_txp_bottom .txp_popup_playrate .txp_menuitem{min-width:104px;position:relative;padding:10px 22px;font-size:14px;text-align:center;cursor:pointer;white-space:nowrap;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_txp_bottom .txp_popup_audio_track .txp_menuitem:last-of-type,.plugin_ctrl_txp_bottom .txp_popup_definition .txp_menuitem:last-of-type,.plugin_ctrl_txp_bottom .txp_popup_language .txp_menuitem:last-of-type,.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_menuitem:last-of-type,.plugin_ctrl_txp_bottom .txp_popup_playrate .txp_menuitem:last-of-type{padding-bottom:20px}.plugin_ctrl_txp_bottom .txp_popup_audio_track .txp_menuitem:active,.plugin_ctrl_txp_bottom .txp_popup_audio_track .txp_menuitem:hover,.plugin_ctrl_txp_bottom .txp_popup_definition .txp_menuitem:active,.plugin_ctrl_txp_bottom .txp_popup_definition .txp_menuitem:hover,.plugin_ctrl_txp_bottom .txp_popup_language .txp_menuitem:active,.plugin_ctrl_txp_bottom .txp_popup_language .txp_menuitem:hover,.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_menuitem:active,.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_menuitem:hover,.plugin_ctrl_txp_bottom .txp_popup_playrate .txp_menuitem:active,.plugin_ctrl_txp_bottom .txp_popup_playrate .txp_menuitem:hover{color:#ff6429}.plugin_ctrl_txp_bottom .txp_popup_mute_tips{width:200px;-webkit-transform:translateX(-60%);transform:translateX(-60%)}.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_popup_content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:8px;font-size:13px}.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_popup_content .txp_text{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_popup_content svg{width:18px;height:18px;color:#fff;cursor:pointer}.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_popup_content svg:hover{color:#ff6429}.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_text_btn{color:#fe6429;cursor:pointer;-webkit-transition:color .3s;transition:color .3s}.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_text_btn:hover{color:#fe9b75}.plugin_ctrl_txp_bottom .txp_btn .txp_label{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;padding:1px 4px;cursor:pointer;color:#ececec;white-space:nowrap;border:2px solid #fff;border-radius:4px;font-weight:700}.plugin_ctrl_txp_bottom .txp_btn .txp_label:hover{color:#ff6022;border-color:#ff6022}.plugin_ctrl_txp_bottom .txp_btn_definition{position:relative;height:100%;white-space:nowrap;text-align:center;-webkit-box-flex:0;-ms-flex:none;flex:none}.plugin_ctrl_txp_bottom .txp_volume{position:relative;display:table-cell;width:44px;height:45px;vertical-align:top;color:#fff}.plugin_ctrl_txp_bottom .txp_volume_text{padding-top:8px}.plugin_ctrl_txp_bottom .txp_btn_volume .txp_svg_symbol{display:none}.plugin_ctrl_txp_bottom .txp_btn_volume[data-status=mute] .txp_svg_volume_mute,.plugin_ctrl_txp_bottom .txp_btn_volume[data-status=normal] .txp_svg_volume{display:block}.plugin_ctrl_txp_bottom .txp_popup_volume{width:42px;-webkit-transform:translate(-50%);transform:translate(-50%);left:50%}.plugin_ctrl_txp_bottom .txp_popup_volume .txp_popup_content{overflow:hidden}.plugin_ctrl_txp_bottom .txp_volume_range{position:relative;margin:10px 19px;width:4px;height:90px;background-color:hsla(0,0%,65.1%,.5);border-radius:2px;cursor:pointer}.plugin_ctrl_txp_bottom .txp_volume_range:after{content:"";display:block;width:42px;height:90px;position:absolute;left:-19px;top:0}.plugin_ctrl_txp_bottom .txp_volume_range_current{position:absolute;left:0;bottom:0;width:100%;height:50%;background-color:#ff6429;border-radius:2px;z-index:1}.plugin_ctrl_txp_bottom .txp_volume_handle{position:absolute;top:-4px;left:-2px;width:8px;height:8px;background-color:#fff;border-radius:100%;cursor:pointer}.plugin_ctrl_txp_bottom .txp_volume_handle:before{content:"";display:block;position:absolute;left:-3px;top:-3px;width:14px;height:14px;opacity:0;-webkit-transform:scale(0);transform:scale(0);background-color:hsla(0,0%,100%,.2);border-radius:7px}.plugin_ctrl_txp_bottom .txp_volume_handle:after{content:"";width:32px;height:32px;display:block;position:absolute;left:-12px;top:-12px;z-index:-1;opacity:.5;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAADAUExURQAAAP+ZAP+RAP9/AP+aAP9/AP+OCP//AP9/AP+qAP+QDf+SDP+TDv+TCv+RCP+ZAP+TC/+TCP+QC/+RCv+SCf+SCv+QCv+RCv+TCf+PD/+PCP+RDP+RCf+RCv+PCf+RB/+RCv+RCf6RCv+ZEf+RC/+RCf+RC/+RC/6RCv+OB/+QC/+RC/+RCv+TC/+QC/+SC/+RC/+RCv+RCv+RCv+RC/6RCv6RCv6RCv6SCv6SCv2QC/+RCv+SCv+RC/+RCv2RCn+uAUwAAABAdFJOUwAFBwYIBAsBAgMNExEYOAoWHit4JUtXYhoQHCg1MT4gRmmHD1SlsbaUIi5BIy1DUltIb2VygY+Jm6KYrHyYuqzDURAFAAAB/klEQVQ4y6WVWZeiMBSEhQZmDAgJO7LIIrivuNv2/P9/NTdRp7VlTmfO1BMP36kKl5ui1XrQD9DPm+hzq1lXqn3TlW3mKCXLApMsU7aBpHaUehMlJvGNsq+mzE6mlKEwGZSVX0yZnSBKBkJFoIGCAiFDEgVm+oUDO4Q0FeMOCGNVQ+hq+kAyDuwCFfuE9ECE+FgNwJSRz5yCNMCmdmiCQnsKqIaURxKCKVeone4onMWRDoriWTgiHbWg5D0cDAXRQGqH2GasJ/N0tUrniR6bNpDIEIW7JQtGGnDjKEmdhQtaOGkSjYHU0Gc4GEoowF17rE+c/tKrs6z2ln1noo/tLg6QdLdsyzTYH5nRxHG9bGOBNpnnOpPIHPk0XG5fQUFSNEzCOHHcem1t8/0+31rr2nWSOCRYU6glBekJVX8609O+t37Pd8PTabjL39deP9VnU7CkL85A0SjghGC4zKx8eDiW5fEwzK1sCZZwygKyGSiISgDJ0Xzhbba7Q/mrqs7lYbfdeIt5BNmBAhNiIByx0zMhuQbD47kaDKrzESxryDZ7dELP4MrNrP2prAYfH4OqvOytzF39H/h9NO/LcI/nZeCXS/PAuT8h91Lc1ow0rRl5XDPuxeW+CtyXi/u68hfAn0pRnitFeakU7pJ6rj0E+lvt8RcpfzX/Q9l/8/v4DS6tX+XyhPN2AAAAAElFTkSuQmCC);background-size:32px 32px;pointer-events:none}.plugin_ctrl_txp_bottom .txp_volume_handle:hover:before{opacity:1;-webkit-transform:scale(1);transform:scale(1)}.plugin_ctrl_txp_bottom .txp_volume_handle:hover:after{opacity:1}.plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_popup{width:24px}.plugin_ctrl_txp_bottom .txp_right_controls .txp_icon_popup{width:20px;height:20px;margin-top:0}.plugin_ctrl_txp_bottom .txp_btn_fake .txp_svg_symbol,.plugin_ctrl_txp_bottom .txp_btn_fullscreen .txp_svg_symbol{display:none}.plugin_ctrl_txp_bottom .txp_btn_fake[data-status=false] .txp_svg_fake,.plugin_ctrl_txp_bottom .txp_btn_fake[data-status=true] .txp_svg_fake_true,.plugin_ctrl_txp_bottom .txp_btn_fullscreen[data-status=false] .txp_svg_fullscreen,.plugin_ctrl_txp_bottom .txp_btn_fullscreen[data-status=true] .txp_svg_fullscreen_true{display:block}.plugin_ctrl_txp_bottom .txp_popup .txp_current{color:#ff6429}.plugin_ctrl_txp_bottom .txp_btn_loop .txp_svg_loop,.plugin_ctrl_txp_bottom .txp_btn_loop .txp_svg_loop_off{display:none}.plugin_ctrl_txp_bottom .txp_btn_loop[data-status=false] .txp_svg_loop_off,.plugin_ctrl_txp_bottom .txp_btn_loop[data-status=true] .txp_svg_loop,.plugin_ctrl_txp_bottom .txp_controls .txp_btn:hover .txp_tooltip{display:block}.plugin_ctrl_txp_bottom .txp_controls .txp_btn:visited .txp_tooltip{display:none}.plugin_ctrl_txp_bottom .txp_popup:hover{display:block}.plugin_ctrl_txp_bottom .txp_icon{position:relative;width:28px;height:28px;fill:#fff}.plugin_ctrl_txp_bottom .txp_icon:after,.plugin_ctrl_txp_bottom .txp_icon:before,.plugin_ctrl_txp_bottom .txp_icon_inner:after,.plugin_ctrl_txp_bottom .txp_icon_inner:before{content:"";position:absolute;-webkit-box-sizing:content-box;box-sizing:content-box}.plugin_ctrl_txp_bottom .txp_icon_inner{position:absolute;width:100%;height:100%}.plugin_ctrl_txp_bottom .txp_controls .txp_disabled{cursor:default;opacity:.5;pointer-events:none}.plugin_ctrl_txp_bottom .txp_gradient_top{display:none}.plugin_ctrl_txp_bottom .txp_btn_scrubber,.plugin_ctrl_txp_bottom .txp_progress_load,.plugin_ctrl_txp_bottom .txp_progress_play{-webkit-transition:-webkit-transform .15s ease;transition:-webkit-transform .15s ease;transition:transform .15s ease;transition:transform .15s ease, -webkit-transform .15s ease}.plugin_ctrl_txp_bottom .txp_none{display:none!important}.plugin_ctrl_txp_mode_fullscreen .txp_controls .txp_btn_fullscreen .txp_tooltip{left:auto;right:0;-webkit-transform:translate(0);transform:translate(0)}.plugin_ctrl_txp_mode_fullscreen .txp_controls .txp_btn_fake .txp_tooltip{left:-26px;-webkit-transform:translate(0);transform:translate(0)}.plugin_ctrl--large .plugin_ctrl_txp_gradient_bottom{height:100px}.plugin_ctrl--large .plugin_ctrl_txp_bottom{height:88px}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_popup{bottom:64px}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_left_controls .txp_btn,.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_right_controls .txp_btn{margin-right:24px}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_left_controls .txp_btn .txp_label,.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_right_controls .txp_btn .txp_label{height:26px;font-size:16px}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_left_controls .txp_icon,.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_right_controls .txp_icon{width:40px;height:40px}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_left_controls .txp_time_display{margin-left:0}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_left_controls .txp_btn:first-child{margin-left:32px}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_definition,.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_language,.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_playrate{margin-right:32px}.txp_interact_dot{position:absolute;top:2px;width:4px;height:4px;margin-left:-2px;border-radius:100%;background-color:#fff;-webkit-transition:all .1s;transition:all .1s}.txp_interact_dot:after{position:absolute;top:-4px;right:-4px;bottom:-4px;left:-4px;content:""}.txp_interact_dot:hover{-webkit-transform:scale(2);transform:scale(2);-webkit-box-shadow:0 0 2px #ffb821;box-shadow:0 0 2px #ffb821}.txp_hotpoint_tip{color:#fff;position:relative;width:200px;bottom:60px;font-size:12px;line-height:24px;height:50px;padding:0 6px;background-color:rgba(0,0,0,.9);display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;-webkit-line-clamp:2;word-wrap:break-word}.txp_hotpoint_tip .txp_hotpoint_tip_title{color:#bbb}.txp_hotpoint_tip .txp_hotpoint_tip_detail{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
    css_248z$5 =
      '.plugin_ctrl_txp_shadow{position:absolute;z-index:2;left:0;top:0;width:100%;height:100%}.plugin_ctrl_txp_shadow.txp_none{display:none}.plugin_ctrl_airplay_btn svg{-webkit-transform:scale(.9);transform:scale(.9)}.plugin_ctrl_center_btn{position:absolute;left:0;top:0;width:100%;height:100%;z-index:5;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;pointer-events:none}.plugin_ctrl_center_btn.txp_none{display:none}.plugin_ctrl_center_btn .txp_none{display:none!important}.plugin_ctrl_center_btn .btn_play{width:68px;height:68px;pointer-events:auto;cursor:pointer}.plugin_ctrl_center_btn .btn_play .icon_play{width:100%;height:100%}.plugin_ctrl_center_btn .btn_replay{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0 22px;line-height:40px;border-radius:99em;color:#fff;font-size:14px;background-color:rgba(59,59,59,.95);pointer-events:auto;cursor:pointer}.plugin_ctrl_center_btn .btn_replay .icon_replay{margin-right:4px;width:15px;height:15px;fill:#fff}.plugin_ctrl_txp_gradient_bottom{position:absolute;z-index:3;left:0;bottom:0;width:100%;height:120px;background-image:-webkit-gradient(linear,left bottom, left top,color-stop(0, rgba(0,0,0,.5)),to(transparent));background-image:linear-gradient(0deg,rgba(0,0,0,.5) 0,transparent);opacity:1;-webkit-transition:opacity .15s ease-out;transition:opacity .15s ease-out;pointer-events:none}.plugin_ctrl_txp_gradient_bottom.txp_none{display:none}.plugin_ctrl_fake_fullscreen{overflow:hidden}._mod_thumbplayer_container_:-webkit-full-screen{width:100%!important;height:100%!important}._mod_thumbplayer_container_.thumbplayer-fullscreen{width:100%!important;height:100%!important}.plugin_ctrl_mobile_txp_bottom{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;z-index:6;bottom:0;left:0;width:100%;height:40px;overflow:initial;line-height:1;max-width:100%;max-height:100%;color:#fff;font-size:14px;font-family:PingFangSC-Regular,Helvetica Neue,Helvetica,Roboto,sans-serif;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-touch-callout:none}.plugin_ctrl_mobile_txp_bottom.txp_none{display:none}.plugin_ctrl_mobile_txp_bottom .txp_disabled{opacity:.5;pointer-events:none}.plugin_ctrl_mobile_txp_bottom *,.plugin_ctrl_mobile_txp_bottom :after,.plugin_ctrl_mobile_txp_bottom :before{margin:0;padding:0;-webkit-box-sizing:border-box;box-sizing:border-box}.plugin_ctrl_mobile_txp_bottom a,.plugin_ctrl_mobile_txp_bottom a:hover,.plugin_ctrl_mobile_txp_bottom a:visited{color:#fff;text-decoration:none!important;pointer-events:auto}.plugin_ctrl_mobile_txp_bottom .txp_btn:active,.plugin_ctrl_mobile_txp_bottom .txp_btn:focus,.plugin_ctrl_mobile_txp_bottom a:focus{outline:0 none}.plugin_ctrl_mobile_txp_bottom .txp_icon{position:relative;display:inline-block;fill:#fff}.plugin_ctrl_mobile_txp_bottom .txp_icon:after,.plugin_ctrl_mobile_txp_bottom .txp_icon:before,.plugin_ctrl_mobile_txp_bottom .txp_icon_inner:after,.plugin_ctrl_mobile_txp_bottom .txp_icon_inner:before{content:"";position:absolute;-webkit-box-sizing:content-box;box-sizing:content-box}.plugin_ctrl_mobile_txp_bottom .txp_icon_inner{position:absolute;width:100%;height:100%}.plugin_ctrl_mobile_txp_bottom .txp_left_controls,.plugin_ctrl_mobile_txp_bottom .txp_right_controls{position:relative;float:left;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_mobile_txp_bottom .txp_left_controls{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.plugin_ctrl_mobile_txp_bottom .txp_right_controls{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.plugin_ctrl_mobile_txp_bottom .txp_btn{position:relative;cursor:pointer;background:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;font-family:PingFangSC-Regular,Helvetica Neue,Helvetica,Roboto,Microsoft Yahei,Arial,sans-serif;border:none;text-align:center;-webkit-box-flex:0;-ms-flex:none;flex:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_mobile_txp_bottom .txp_btn_play{width:50px;height:100%}.plugin_ctrl_mobile_txp_bottom .txp_btn_play .txp_icon_play{display:block;width:30px;height:30px;margin:auto;fill:#fff}.plugin_ctrl_mobile_txp_bottom .txp_btn_play use{display:none}.plugin_ctrl_mobile_txp_bottom .txp_btn_play.play_btn_pause .txp_svg_pause,.plugin_ctrl_mobile_txp_bottom .txp_btn_play.play_btn_play .txp_svg_play,.plugin_ctrl_mobile_txp_bottom .txp_btn_play.play_btn_replay .txp_svg_replay,.plugin_ctrl_mobile_txp_bottom .txp_btn_play.play_btn_stop .txp_svg_stop{display:block}.plugin_ctrl_mobile_txp_bottom .txp_time_display{height:100%;padding:0 8px 0 0;white-space:nowrap;font-size:0;-webkit-box-flex:0;-ms-flex:none;flex:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_mobile_txp_bottom .txp_time_display>div{display:inline;font-family:Segoe UI,Arial,sans-serif;font-size:10px}.plugin_ctrl_mobile_txp_bottom .txp_time_display .txp_time_separator{margin:0 1px}.plugin_ctrl_mobile_txp_bottom .txp_btn_airplay,.plugin_ctrl_mobile_txp_bottom .txp_btn_fullscreen{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:45px;height:100%;-webkit-box-flex:0;-ms-flex:none;flex:none}.plugin_ctrl_mobile_txp_bottom .txp_icon_airplay,.plugin_ctrl_mobile_txp_bottom .txp_icon_fullscreen{display:block;width:30px;height:30px;margin:auto}.plugin_ctrl_mobile_txp_bottom .txp_icon_fullscreen use{display:none}.plugin_ctrl_mobile_txp_bottom .txp_btn_fullscreen[data-status=false] .txp_svg_fullscreen,.plugin_ctrl_mobile_txp_bottom .txp_btn_fullscreen[data-status=true] .txp_svg_fullscreen_true{display:block}.plugin_ctrl_mobile_txp_bottom .txp_unfullscreen .txp_btn_value{background-position:right 0}.plugin_ctrl_mobile_txp_bottom .txp_btn_fullsize{width:45px;height:100%;-webkit-box-flex:0;-ms-flex:none;flex:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_mobile_txp_bottom .txp_btn_fullsize[data-status=false] .txp_svg_fullscreen,.plugin_ctrl_mobile_txp_bottom .txp_btn_fullsize[data-status=true] .txp_svg_fullscreen_true{display:block}.plugin_ctrl_mobile_txp_bottom .txp_unfullsize .txp_btn_value{background-position:right 0}.plugin_ctrl_mobile_txp_bottom .txp_progress_bar_container{position:relative;height:100%;margin:0 3px;vertical-align:top;-webkit-box-flex:1000;-ms-flex:1000;flex:1000}.plugin_ctrl_mobile_txp_bottom .txp_progress_list{position:absolute;left:0;top:19px;width:100%;height:2px;background-color:rgba(31,31,31,.9);-webkit-transform:translateZ(0);transform:translateZ(0)}.plugin_ctrl_mobile_txp_bottom .txp_progress_play{position:absolute;left:0;top:0;height:100%;width:2px;background-color:#fd9000}.plugin_ctrl_mobile_txp_bottom .txp_btn_scrubber{position:absolute;width:30px;height:40px;margin-left:-15px;-webkit-transform:translateZ(0);transform:translateZ(0)}.plugin_ctrl_mobile_txp_bottom .txp_scrubber_indicator{position:absolute;top:15px;left:10px;width:10px;height:10px;border-radius:99em;background-color:#ff7000}.plugin_ctrl_mobile_txp_bottom .txp_scrubber_indicator:before{content:"";position:absolute;left:-4px;top:-4px;width:18px;height:18px;background-color:#ff7000;opacity:.4;border-radius:99em}.plugin_ctrl_mobile_txp_bottom .txp_btn_definition,.plugin_ctrl_mobile_txp_bottom .txp_btn_playrate{position:relative;padding:0 8px;height:44px;color:#fff;white-space:nowrap;text-align:center;-webkit-box-flex:0;-ms-flex:none;flex:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_mobile_txp_bottom .txp_btn_definition .txp_label,.plugin_ctrl_mobile_txp_bottom .txp_btn_playrate .txp_label{margin:auto}.plugin_ctrl_mobile_txp_bottom .txp_btn .txp_tooltip{display:none!important}.plugin_ctrl_mobile_txp_bottom .txp_right_controls{min-width:15px}.plugin_ctrl_mobile_txp_bottom .txp_none{display:none}.plugin_ctrl_mobile_txp_bottom~video::-webkit-media-controls,.plugin_ctrl_mobile_txp_bottom~video::-webkit-media-controls-start-playback-button{display:none!important}.plugin_ctrl_mod_overlay_wrapper{position:static}.plugin_ctrl_mod_overlay_wrapper ol,.plugin_ctrl_mod_overlay_wrapper ul{list-style:none}.plugin_ctrl_mod_overlay_wrapper li{vertical-align:top}.plugin_ctrl_mod_overlay_wrapper *{-webkit-box-sizing:border-box;box-sizing:border-box}.plugin_ctrl_mod_overlay_wrapper .mod_overlay{position:absolute;background:rgba(0,0,0,.75);left:0;top:0;right:0;bottom:0;z-index:998;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;color:#fff}.plugin_ctrl_mod_overlay_wrapper .mod_overlay.overlay_flex{display:-webkit-box;display:-ms-flexbox;display:flex}.plugin_ctrl_mod_overlay_wrapper .mod_overlay.txp_none{display:none}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select{width:100%;text-align:center}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select .title{font-size:16px}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select ul{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;font-size:18px;font-weight:700;padding:0 12px}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select li{height:70px;margin-right:6px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:0 12px}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select li div:last-child{margin-top:6px;font-size:14px;font-weight:500}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select li.current{color:#ff6022}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select li.current span{position:relative}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select li.current span:after{content:"";width:100%;height:3px;background:#ff6022;position:absolute;bottom:-3px;left:0}.plugin_ctrl_mod_overlay_wrapper .txp_btn_playrate{position:relative;width:55px;height:44px;color:#fff;white-space:nowrap;text-align:center;-webkit-box-flex:0;-ms-flex:none;flex:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_txp_mode_fullscreen .plugin_ctrl_mobile_txp_bottom{padding-bottom:env(safe-area-inset-bottom)}';
  function adaptMobileAdPlugin(e, t) {
    uaTool$1.mobile &&
      (t.on(exports.H5_PLAY_EVENT.AD_PLAYING, function () {
        return e.hide(!0);
      }),
      t.on(exports.H5_PLAY_EVENT.AD_END, function () {
        return (e.el.style.display = "");
      }));
  }
  var Component = (function () {
      function e(e, t, o) {
        (this.player = e),
          (this.config = o),
          (this.CLICK_EVENT_NAME = "click"),
          (this.eventMap = {});
        var A = e.container;
        (this.el = A.querySelector(t)),
          (this.isMobile = null == o ? void 0 : o.isMobile),
          (this.isLive = "live" === this.config.mode),
          this.showEl();
      }
      return (
        (e.isEnabled = function (e) {
          return !0;
        }),
        Object.defineProperty(e.prototype, "playtime", {
          get: function () {
            var e = this.config.timeOffset,
              t = this.player.playtime;
            return e ? e(t, !1) : t;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (e.prototype.destroy = function () {
          var e;
          (null === (e = this.el) || void 0 === e ? void 0 : e.parentNode) &&
            this.el.remove(),
            this.setEvts(!0),
            (this.el = null),
            (this.player = null);
        }),
        (e.prototype.setEvts = function (e) {
          var t = this;
          void 0 === e && (e = !1);
          var o = e ? this.player.off : this.player.on;
          Object.keys(this.eventMap).forEach(function (e) {
            o.call(t.player, e, t.eventMap[e]);
          });
        }),
        (e.prototype.showEl = function (t) {
          void 0 === t && (t = this.el),
            t && t.classList.remove(e.hideClassName);
        }),
        (e.prototype.hideEl = function (t) {
          void 0 === t && (t = this.el), t && t.classList.add(e.hideClassName);
        }),
        (e.sel = ""),
        (e.disabledClassName = "txp_disabled"),
        (e.curClassName = "txp_current"),
        (e.hideClassName = "txp_none"),
        e
      );
    })(),
    hideCSS = "txp_none",
    disableCSS = "txp_disabled",
    shouldDisableState = [
      exports.VIDEO_STATE.END,
      exports.VIDEO_STATE.IDLE,
      exports.VIDEO_STATE.LOAD_START,
    ],
    AirPlayBtn = (function (e) {
      function t(o, A, i) {
        var r = e.call(this, o, t.sel, A) || this;
        (r.config = A),
          (r.ctrlbar = i),
          (r.handlePlayerCanPlay = function () {
            r.hideDependOnKernel(), r.setBtnState(!0);
          }),
          (r.handleSetLevelEnd = function () {
            r.hideDependOnKernel();
          }),
          (r.handlePlayerSessionEnd = function () {
            r.setBtnState(!1);
          }),
          (r.handleClick = function () {
            var e, t;
            null ===
              (t =
                null === (e = r.player.currentVideoElement) || void 0 === e
                  ? void 0
                  : e.webkitShowPlaybackTargetPicker) ||
              void 0 === t ||
              t.call(e);
          });
        var n = !shouldDisableState.includes(r.player.state);
        return (
          r.setupDOMEvents(),
          r.setupPlayerEvents(!0),
          r.show(),
          r.setBtnState(n),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          var t = e.isMobile,
            o = e.showAirplayOnIOS;
          return !(!uaTool$1.os.ios || !o) || (uaTool$1.browser.safari && !t);
        }),
        (t.prototype.show = function () {
          this.el.classList.remove(hideCSS);
        }),
        (t.prototype.hide = function () {
          this.el.classList.add(hideCSS);
        }),
        (t.prototype.setBtnState = function (e) {
          if (e) return this.el.classList.remove(disableCSS);
          this.el.classList.add(disableCSS);
        }),
        (t.prototype.destroy = function () {
          var e;
          this.setupPlayerEvents(!1),
            null === (e = this.el) || void 0 === e || e.remove();
        }),
        (t.prototype.setupPlayerEvents = function (e) {
          void 0 === e && (e = !0);
          var t = e
            ? this.player.on.bind(this.player)
            : this.player.off.bind(this.player);
          t(exports.H5_PLAY_EVENT.VIDEO_CANPLAY, this.handlePlayerCanPlay),
            t(
              exports.H5_PLAY_EVENT.PLAY_SESSION_END,
              this.handlePlayerSessionEnd
            ),
            t(exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_END, this.handleSetLevelEnd);
        }),
        (t.prototype.setupDOMEvents = function () {
          (this.el = this.player.container.querySelector(t.sel)),
            this.el.addEventListener("click", this.handleClick);
        }),
        (t.prototype.hideDependOnKernel = function () {
          this.player.kernelName !== exports.KERNEL_NAME.ORIGIN
            ? this.hide()
            : this.show();
        }),
        (t.sel = ".txp_btn_airplay"),
        (t.compName = "AirPlayBtn"),
        t
      );
    })(Component),
    HOTPOINT_EVENTS$1;
  !(function (e) {
    (e.HOT_MOUSE_OVER = "ctrl:hotpoint-mouseover"),
      (e.HOT_MOUSE_MOVE = "ctrl:hotpoint-mousemove"),
      (e.HOT_MOUSE_OUT = "ctrl:hotpoint-mouseout");
  })(HOTPOINT_EVENTS$1 || (HOTPOINT_EVENTS$1 = {}));
  var CtrlbarPluginName$2 = "ctrlbar",
    CTRL_EVENTS$1 = __assign$1(
      __assign$1(
        {
          FULLSCREEN_CHANGE: "windowFullscreenChange",
          FULLSCREEN_ERROR: "fullscreenError",
          FAKE_FULLSCREEN_CHANGE: "browserFullscreenChange",
          CLICK_PIPBTN: "ctrl:click-pipbtn",
          CLICK_NEXTBTN: "ctrl:click-nextbtn",
          CLICK_PLAYBTN: "ctrl:click-playbtn",
          CLICK_REPLAY: "ctrl:click-replay",
          CLICK_LOOP: "ctrl:click-loop",
          SET_LANGUAGE: "ctrl:set-language",
          SET_LEVEL: "ctrl:set-level",
          SET_AUDIO: "ctrl:set-audio",
          SET_PLAYRATE: "ctrl:set-playrate",
          SET_VOLUME: "ctrl:set-volume",
          TOGGLE_OVERLAY: "ctrl:toggle-overlay",
          MOUSE_DONW: "ctrl:progress-mousedown",
          MOUSE_DOWN: "ctrl:progress-mousedown",
          MOUSE_MOVE: "ctrl:progress-mousemove",
          MOUSE_UP: "ctrl:progress-mouseup",
          SHOW: "ctrl:show",
          HIDE: "ctrl:hide",
        },
        HOTPOINT_EVENTS$1
      ),
      {
        TEST_EVENT: "ctrl:inner-test-event",
        RESIZE: "ctrl:resize",
        SHOW_LEVELS: "ctrl:show-levels",
        HOVER_PROGRESS: "ctrl:hover-progress",
      }
    ),
    pcRootClassName = ".plugin_ctrl_txp_bottom",
    mobileRootClassName = ".plugin_ctrl_mobile_txp_bottom",
    getRootClassName = function (e) {
      return e ? mobileRootClassName : pcRootClassName;
    },
    shadowClassName = ".plugin_ctrl_txp_shadow",
    gradientClassName = ".plugin_ctrl_txp_gradient_bottom",
    containerClassName = "_mod_thumbplayer_container_",
    largeSizeClassName = "plugin_ctrl--large",
    bodyOverflowClassName = "plugin_ctrl_fake_fullscreen";
  (exports.CTRL_SIZE = void 0),
    (function (e) {
      (e.LARGE = "large"), (e.NORMAL = "normal");
    })(exports.CTRL_SIZE || (exports.CTRL_SIZE = {})),
    (exports.PlayBtnStatus = void 0),
    (function (e) {
      (e.PAUSE = "pause"),
        (e.PLAY = "play"),
        (e.REPLAY = "replay"),
        (e.STOP = "stop");
    })(exports.PlayBtnStatus || (exports.PlayBtnStatus = {}));
  var Popup = (function (e) {
      function t(t, o, A) {
        var i = e.call(this, t, o.selector, o) || this;
        return (
          (i.ctrlbar = A),
          i.hideEl(),
          (i.popup = i.isMobile
            ? i.player.container.querySelector(o.modSelector)
            : i.el.querySelector(".txp_popup")),
          i.el
            ? ((i.label = i.el.querySelector(".txp_label")),
              i.isMobile
                ? i.label.addEventListener(i.CLICK_EVENT_NAME, function () {
                    !i.popup.classList.contains(Component.hideClassName)
                      ? i.hideEl(i.popup)
                      : (i.showEl(i.popup),
                        i.popup.classList.add("overlay_flex")),
                      i.ctrlbar.emit(CTRL_EVENTS$1.TOGGLE_OVERLAY, !0),
                      i.hideEl(i.ctrlbar.el);
                  })
                : (i.label.addEventListener("mouseover", function () {
                    return i.showEl(i.popup);
                  }),
                  i.el.addEventListener("mouseleave", function () {
                    i.hideEl(i.popup);
                  })),
              i.initItemClick(),
              i)
            : i
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "curClass", {
          get: function () {
            return this.isMobile ? "current" : Component.curClassName;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "selected", {
          get: function () {
            return this.selectedValue;
          },
          set: function (e) {
            var t,
              o =
                null === (t = this.popupOptions) || void 0 === t
                  ? void 0
                  : t.find(function (t) {
                      return String(t.value) === String(e);
                    });
            if (((this.selectedValue = e), !o))
              return (this.label.textContent = ""), void this.hideEl();
            this.showEl(), this.setCurrent(o);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "popupOptions", {
          get: function () {
            return this.allValue;
          },
          set: function (e) {
            var t = this,
              o = e.find(function (e) {
                return String(e.value) === String(t.selectedValue);
              });
            o
              ? (this.setCurrent(o), this.showEl())
              : (this.label.textContent = ""),
              (this.allValue = e);
            var A = this.isMobile ? "li" : "div",
              i = /(<([^>]+)>)/;
            this.popup.querySelector(
              this.isMobile ? ".select_list" : ".txp_popup_content"
            ).innerHTML = e
              .map(function (e) {
                return (
                  "<" +
                  A +
                  ' \n      class="txp_menuitem ' +
                  (e.value === t.selected ? t.curClass : "") +
                  '" \n      data-label="' +
                  (i.test(e.label) ? "" : e.label) +
                  '"\n      data-value="' +
                  e.value +
                  '" \n      data-payload="' +
                  (e.payload || "") +
                  '">' +
                  e.label +
                  "</" +
                  A +
                  ">"
                );
              })
              .join("");
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.setCurrent = function (e) {
          var t,
            o = this;
          (this.label.innerHTML =
            null !== (t = null == e ? void 0 : e.btnLabel) && void 0 !== t
              ? t
              : null == e
              ? void 0
              : e.label),
            this.popup.querySelectorAll(".txp_menuitem").forEach(function (t) {
              t.getAttribute("data-value") === String(e.value)
                ? t.classList.add(o.curClass)
                : t.classList.remove(o.curClass);
            });
        }),
        (t.prototype.hookPlaySessionEnd = function () {
          this.el && this.el.classList.add(Component.disabledClassName);
        }),
        (t.prototype.hookFlowNodeStart = function (e) {
          "VideoFlowNode" === e.data.name &&
            this.el.classList.remove(Component.disabledClassName);
        }),
        (t.prototype.initItemClick = function () {
          var e = this;
          this.popup.addEventListener(this.CLICK_EVENT_NAME, function (t) {
            var o, A;
            e.player.setStateKv(
              "ctrlbar:" + e.popupName + ":" + e.CLICK_EVENT_NAME,
              { type: exports.LOG_TYPE.USER_ACTION }
            );
            for (
              var i = t.target;
              i &&
              !(null === (o = i.classList) || void 0 === o
                ? void 0
                : o.contains("txp_menuitem"));

            )
              i = i.parentNode;
            e.isMobile &&
              (e.hideEl(e.popup),
              e.popup.classList.remove("overlay_flex"),
              e.ctrlbar.emit(CTRL_EVENTS$1.TOGGLE_OVERLAY, !1));
            var r = null == i ? void 0 : i.dataset;
            (null == r ? void 0 : r.value) &&
              r.value !== String(e.selected) &&
              (null === (A = e.onSelect) || void 0 === A || A.call(e, r),
              e.config.hidePopupOnClick && e.hideEl(e.popup));
          });
        }),
        (t.compName = "popup"),
        t
      );
    })(Component),
    AudioTrackPopup = (function (e) {
      function t(o, A, i) {
        var r =
          e.call(
            this,
            o,
            __assign$1(__assign$1({}, A), { selector: t.popupSelector }),
            i
          ) || this;
        return (
          (r.popupName = "audiotrack"),
          (r.onSelect = function (e) {
            r.ctrlbar.emit(CTRL_EVENTS$1.SET_AUDIO, e);
          }),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          return !(e.isMobile || e.disableAudioTrack);
        }),
        (t.compName = "AudioTrackPopup"),
        (t.popupSelector = ".txp_right_controls .txp_btn_audio_track"),
        t
      );
    })(Popup);
  function onBtnClickPlay(e, t) {
    t.isInRequest
      ? e.triggerAutoplay().then(function () {
          return e.play();
        })
      : e.play();
  }
  var CenterBtn = (function (e) {
      function t(o, A, i) {
        var r = e.call(this, o, t.sel, A) || this;
        return (
          (r.config = A),
          (r.ctrlbar = i),
          r.prepareDOM(),
          r.initDOMEvents(),
          r.initPlayerEvents(),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          var t = e.showCenterPlayBtn,
            o = e.showCenterReplayBtn;
          return t || o;
        }),
        (t.prototype.initDOMEvents = function () {
          var e = this;
          this.playBtn.addEventListener("click", function () {
            e.hideEl(e.playBtn), onBtnClickPlay(e.player, e.ctrlbar);
          }),
            this.replayBtn.addEventListener("click", function () {
              e.hideEl(e.replayBtn), e.player.replay();
            });
        }),
        (t.prototype.initPlayerEvents = function () {
          var e = this,
            t = this.player,
            o = function () {
              e.config.showCenterPlayBtn && e.showEl(e.playBtn);
            };
          o(),
            t.on(exports.H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, function (e) {
              e.data.adType === exports.AD_TYPE.PRE && o();
            }),
            t.on(exports.H5_PLAY_EVENT.AD_PAUSE, function () {
              e.showEl(e.playBtn);
            }),
            t.on(exports.H5_PLAY_EVENT.AD_RESUME, function () {
              e.hideEl(e.playBtn);
            }),
            t.on(exports.H5_PLAY_EVENT.VIDEO_AUTOPLAY_BLOCKED, o),
            t.on(exports.H5_PLAY_EVENT.AD_PLAYING, function () {
              return e.hideEl(e.playBtn);
            }),
            t.on(exports.H5_PLAY_EVENT.VIDEO_PLAYING, function () {
              e.hideEl(e.playBtn);
            }),
            t.on(exports.H5_PLAY_EVENT.PLAY_SESSION_END, function (t) {
              var o = t.data;
              e.hideEl(e.playBtn),
                e.config.showCenterReplayBtn &&
                  o.endState === exports.END_STATE.NORMAL &&
                  e.showEl(e.replayBtn);
            }),
            t.on(exports.H5_PLAY_EVENT.PLAY_SESSION_START, function () {
              e.hideEl(e.replayBtn);
            });
        }),
        (t.prototype.prepareDOM = function () {
          var e =
            '<div class="' +
            t.sel.slice(1) +
            '">\n      <div class="btn_play ' +
            Component.hideClassName +
            '">\n        <svg class="icon_play" viewBox="0 0 100 100">\n          <circle cx="50" cy="50" r="50" style="fill:#222;fill-opacity:0.75"></circle>\n          <path\n            transform="translate(36, 33)"\n            d="M0.6,2C0.6,2,0,3.5,0,16.9C0,30.3,0.6,32,0.6,32c0,1.5,1.6,2.5,2.9,1.8c0,0,3-0.5,15.2-6.6c12.2-6.1,14.2-8.4,14.2-8.4c1.5-0.7,1.5-2.8,0-3.6c0,0-3.3-3.1-14.2-8.6C7.9,1.1,3.5,0.2,3.5,0.2C2.1-0.5,0.6,0.5,0.6,2z"\n            style="fill:#fff;"\n          />\n        </svg>\n      </div>\n\n      <div class="btn_replay ' +
            Component.hideClassName +
            '">\n        <svg class="icon_replay" viewBox="0 0 30 30">\n          <use xlink:href="#txp_svg_replay"></use>\n        </svg>\n        <div>閲嶆柊鎾斁</div>\n      </div>\n    </div>';
          this.ctrlbar.el.insertAdjacentHTML("beforebegin", e),
            (this.el = this.player.container.querySelector(t.sel)),
            (this.playBtn = this.el.querySelector(".btn_play")),
            (this.replayBtn = this.el.querySelector(".btn_replay"));
        }),
        (t.sel = ".plugin_ctrl_center_btn"),
        (t.compName = "CenterBtn"),
        t
      );
    })(Component),
    DefinitionPopup = (function (e) {
      function t(o, A, i) {
        var r =
          e.call(
            this,
            o,
            __assign$1(__assign$1({}, A), {
              selector: t.popupSelector,
              modSelector: t.modSelector,
            }),
            i
          ) || this;
        return (
          (r.popupName = "definition"),
          (r.onSelect = function (e) {
            r.ctrlbar.emit(CTRL_EVENTS$1.SET_LEVEL, e);
          }),
          (r.onShowLevel = function () {
            r.ctrlbar.emit(CTRL_EVENTS$1.SHOW_LEVELS);
          }),
          r.label.addEventListener("mouseover", r.onShowLevel),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function () {
          return !0;
        }),
        (t.compName = "DefinitionPopup"),
        (t.popupSelector = ".txp_right_controls .txp_btn_definition"),
        (t.modSelector = ".mod_overlay.definition"),
        t
      );
    })(Popup),
    FakeFullscreen = (function (e) {
      function t(o, A, i) {
        var r = e.call(this, o, t.sel, A) || this;
        return (
          (r.ctrlbar = i),
          (r.tip = r.el.querySelector(".txp_tooltip")),
          r.el.classList.remove(Component.hideClassName),
          r.setupDOMEvents(),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          var t = e.disableFakeFullscreen,
            o = e.useH5FakeFullscreen,
            A = e.isMobile;
          return A && void 0 !== o
            ? !!o
            : void 0 !== t
            ? !t
            : !(!uaTool$1.os.android && A);
        }),
        Object.defineProperty(t.prototype, "isFullScreen", {
          get: function () {
            return (
              this.player.fullscreenMode ===
              exports.FullScreenMode.FAKE_FULLSCREEN
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.setTipStatus = function (e) {
          (this.el.dataset.status = String(e)),
            this.isMobile ||
              (this.tip.innerText = e ? "閫€鍑虹綉椤靛叏灞�" : "缃戦〉鍏ㄥ睆");
        }),
        (t.prototype.requestFullScreen = function (e) {
          void 0 === e && (e = "enter");
          var t = "enter" === e;
          this.player.requestFullScreen(
            t,
            exports.FullScreenMode.FAKE_FULLSCREEN
          );
        }),
        (t.prototype.setupDOMEvents = function () {
          var e = this;
          this.el.addEventListener(this.CLICK_EVENT_NAME, function () {
            e.player.setStateKv(
              "ctrlbar:" + t.compName + ":" + e.CLICK_EVENT_NAME,
              { type: exports.LOG_TYPE.USER_ACTION }
            ),
              e.requestFullScreen(e.isFullScreen ? "exit" : "enter");
          }),
            this.isMobile ||
              (this.el.addEventListener("mouseover", function () {
                e.showEl(e.tip);
              }),
              this.el.addEventListener("mouseout", function () {
                e.hideEl(e.tip);
              })),
            this.player.on(exports.PLAY_EVENT.FULLSCREEN_CHANGE, function (o) {
              var A = o.data,
                i = A.mode,
                r = A.isEnter;
              if (i === exports.FullScreenMode.FAKE_FULLSCREEN) {
                var n =
                  e.player.config.fullscreenContainer || e.player.container;
                e.setTipStatus(r),
                  n.classList.toggle(t.fullscreenClassName, r),
                  e.ctrlbar.emit(CTRL_EVENTS$1.FAKE_FULLSCREEN_CHANGE, r);
              }
            });
        }),
        (t.sel = ".txp_right_controls .txp_btn_fake"),
        (t.fullscreenClassName = "plugin_ctrl_txp_mode_fullscreen"),
        (t.compName = "FakeFullscreen"),
        t
      );
    })(Component),
    fullscreenClassName = "thumbplayer-fullscreen",
    Fullscreen = (function (e) {
      function t(o, A, i) {
        var r = e.call(this, o, t.sel, A) || this;
        return (
          (r.ctrlbar = i),
          (r.onFullscreenChange = function (e) {
            var t = e.data,
              o = t.mode,
              A = t.isEnter;
            o === exports.FullScreenMode.FULL_SCREEN &&
              (r.setDOMStatus(
                A ? FullscreenStatus.Exit : FullscreenStatus.Enter
              ),
              r.ctrlbar.emit(CTRL_EVENTS$1.FULLSCREEN_CHANGE, A),
              (
                r.player.config.fullscreenContainer || r.player.container
              ).classList.toggle(fullscreenClassName, A));
          }),
          (r.onPlaySessionEnd = function () {
            uaTool$1.os.ios && r.el.classList.add(Component.disabledClassName);
          }),
          (r.onPlaySessionStart = function () {
            r.el.classList.remove(Component.disabledClassName);
          }),
          (r.tip = r.el.querySelector(".txp_tooltip")),
          r.setupDOMEvents(),
          r.isMobile || r.listenDblclick(),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          var t = e.isMobile,
            o = e.useH5FakeFullscreen;
          return t && void 0 !== o ? !o : !(!uaTool$1.os.ios && t);
        }),
        Object.defineProperty(t.prototype, "isFullScreen", {
          get: function () {
            return (
              this.player.fullscreenMode === exports.FullScreenMode.FULL_SCREEN
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.setDOMStatus = function (e) {
          (this.el.dataset.status = e),
            this.isMobile ||
              (this.tip.innerText =
                e === FullscreenStatus.Exit ? "閫€鍑哄叏灞�" : "鍏ㄥ睆");
        }),
        (t.prototype.requestFullScreen = function (e) {
          var t = this;
          return (
            void 0 === e && (e = "enter"),
            this.player
              .requestFullScreen(
                "enter" === e,
                exports.FullScreenMode.FULL_SCREEN
              )
              .catch(function (e) {
                t.ctrlbar.emit(CTRL_EVENTS$1.FULLSCREEN_ERROR, e);
              })
          );
        }),
        (t.prototype.listenDblclick = function () {
          var e = this;
          this.player.container
            .querySelector(shadowClassName)
            .addEventListener("dblclick", function () {
              var t;
              (
                null === (t = e.ctrlbar.instances.FakeFullscreen) ||
                void 0 === t
                  ? void 0
                  : t.isFullScreen
              )
                ? e.ctrlbar.instances.FakeFullscreen.requestFullScreen("exit")
                : e.requestFullScreen(e.isFullScreen ? "exit" : "enter");
            });
        }),
        (t.prototype.setupDOMEvents = function () {
          var e = this;
          this.el.addEventListener("click", function () {
            e.el.classList.contains(Component.disabledClassName) ||
              (e.player.setStateKv("ctrlbar:" + t.compName + ":click", {
                type: exports.LOG_TYPE.USER_ACTION,
                message: "fullscreen=" + e.isFullScreen,
              }),
              e.requestFullScreen(e.isFullScreen ? "exit" : "enter"));
          }),
            this.isMobile ||
              (this.el.addEventListener("mouseover", function () {
                return e.showEl(e.tip);
              }),
              this.el.addEventListener("mouseout", function () {
                return e.hideEl(e.tip);
              })),
            this.player.on(
              exports.PLAY_EVENT.FULLSCREEN_CHANGE,
              this.onFullscreenChange
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.PLAY_SESSION_END,
              this.onPlaySessionEnd
            ),
            this.player.on(
              exports.H5_PLAY_EVENT.PLAY_SESSION_START,
              this.onPlaySessionStart
            );
        }),
        (t.sel = ".txp_right_controls .txp_btn_fullscreen"),
        (t.compName = "Fullscreen"),
        t
      );
    })(Component),
    FullscreenStatus,
    HOTPOINT_TIP_TYPE;
  !(function (e) {
    (e.Enter = "false"), (e.Exit = "true");
  })(FullscreenStatus || (FullscreenStatus = {})),
    (function (e) {
      (e.DEFAULT = "default"),
        (e.WITH_PREVIEW = "with-preview"),
        (e.NONE = "none");
    })(HOTPOINT_TIP_TYPE || (HOTPOINT_TIP_TYPE = {}));
  var THROTTLE_WAIT = 16.6,
    mouseEvtMap = {
      mouseover: HOTPOINT_EVENTS$1.HOT_MOUSE_OVER,
      mousemove: HOTPOINT_EVENTS$1.HOT_MOUSE_MOVE,
      mouseout: HOTPOINT_EVENTS$1.HOT_MOUSE_OUT,
    },
    HotPoint = (function (e) {
      function t(o, A, i) {
        var r,
          n = e.call(this, o, t.sel, A) || this;
        return (
          (n.ctrlbar = i),
          (n.hotPointMap = {}),
          (n.isReady = !1),
          (n.onVideoCanPlay = function () {
            n.isReady || ((n.isReady = !0), n.renderDom());
          }),
          (n.onPlaySessionEnd = function () {
            (n.isReady = !1),
              n.tipEl.classList.add(t.hideClassName),
              n.clearHotPoints();
          }),
          n.config.hotPointTipType ||
            (n.config.hotPointTipType = HOTPOINT_TIP_TYPE.DEFAULT),
          (n.mouseEvtHandler = n.mouseEvtHandler.bind(n)),
          (n.mouseEvtFuncMap = {
            mouseover: n.onMouseOver.bind(n),
            mousemove: lodash_throttle(n.onMouseMove.bind(n), THROTTLE_WAIT, {
              trailing: !1,
            }),
            mouseout: n.onMouseOut.bind(n),
          }),
          (n.eventMap =
            (((r = {})[exports.H5_PLAY_EVENT.VIDEO_CANPLAY] = n.onVideoCanPlay),
            (r[exports.H5_PLAY_EVENT.PLAY_SESSION_END] = n.onPlaySessionEnd),
            r)),
          n.config.hotPointTipType === HOTPOINT_TIP_TYPE.DEFAULT &&
            n.setupTip(),
          n.setEvts(!1),
          (n.logger = new Logger(n.player.config.instanceId, "Ctrl:HotPoints")),
          n
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          return !e.isMobile;
        }),
        (t.prototype.clearHotPoints = function () {
          Object.values(this.hotPointMap).forEach(function (e) {
            var t = e.el;
            t instanceof HTMLElement && t.remove();
          }),
            (this.hotPointMap = {});
        }),
        (t.prototype.addHotPoints = function (e) {
          var t = this;
          if (null == e ? void 0 : e.length) {
            var o = e.map(function (e) {
              var o = __assign$1({}, e);
              return (
                (o.uuid = commonTool$1.createGUID()),
                (t.hotPointMap[o.uuid] = o),
                o
              );
            });
            return this.isReady && this.renderDom(), o;
          }
        }),
        (t.prototype.deleteHotPoints = function (e) {
          var t = this;
          e.forEach(function (e) {
            var o,
              A = t.hotPointMap[e];
            A &&
              (null === (o = A.el) || void 0 === o || o.remove(),
              delete t.hotPointMap[e]);
          });
        }),
        (t.prototype.setEvts = function (t) {
          var o = this;
          void 0 === t && (t = !1);
          var A = t ? this.el.removeEventListener : this.el.addEventListener;
          Object.keys(mouseEvtMap).forEach(function (e) {
            A.call(o.el, e, o.mouseEvtHandler, !1);
          }),
            e.prototype.setEvts.call(this, t);
        }),
        (t.prototype.isValidHotPoint = function (e) {
          return e.timing <= this.player.duration;
        }),
        (t.prototype.renderDom = function () {
          var e = this;
          Object.entries(this.hotPointMap).forEach(function (t) {
            var o = t[0],
              A = t[1];
            if (!(A.el instanceof HTMLElement)) {
              var i = e.createPointElement(A);
              i &&
                (e.el.insertAdjacentElement("beforeend", i),
                (e.hotPointMap[o] = __assign$1(__assign$1({}, A), { el: i })));
            }
          });
        }),
        (t.prototype.createPointElement = function (e) {
          if (this.isValidHotPoint(e)) {
            var o = document.createElement("div"),
              A = (e.timing / this.ctrlbar.duration) * 100;
            return (
              o.classList.add(t.defaultPointClass),
              (o.style.left = A + "%"),
              (o.dataset.info = JSON.stringify(e)),
              o
            );
          }
          this.logger.warn("ctrlbar: hotpoint 鍏ュ€奸潪娉曪紝宸插拷鐣�", e);
        }),
        (t.prototype.setupTip = function () {
          var e;
          this.config.hotPointCustomTipEl
            ? (e = this.config.hotPointCustomTipEl)
            : (e = document.createElement("div")).classList.add(
                t.defaultTipClass
              ),
            e.classList.add(t.hideClassName),
            this.el.insertAdjacentElement("beforeend", e),
            (this.tipEl = e);
        }),
        Object.defineProperty(t.prototype, "offsetLeft", {
          get: function () {
            return this.player.container.getBoundingClientRect().left;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.mouseEvtHandler = function (e) {
          var t = e.target.dataset;
          if (t.info) {
            var o = this.config.hotPointTipType,
              A = JSON.parse(t.info);
            o === HOTPOINT_TIP_TYPE.DEFAULT &&
              this.mouseEvtFuncMap[e.type]({ point: A, mouseEvent: e }),
              this.ctrlbar.emit(mouseEvtMap[e.type], {
                point: A,
                mouseEvent: e,
                hotPointTipType: o,
              });
          }
        }),
        (t.prototype.onMouseOver = function (e) {
          var o = e.point;
          this.tipEl &&
            o.text &&
            ((this.tipEl.textContent = o.text),
            this.tipEl.classList.remove(t.hideClassName));
        }),
        (t.prototype.onMouseMove = function (e) {
          if (this.tipEl) {
            var t = e.mouseEvent,
              o = this.player.container,
              A = this.tipEl.getBoundingClientRect().width,
              i = t.clientX - this.offsetLeft - A / 2;
            i < 0 && (i = 0),
              i > o.clientWidth - A && (i = o.clientWidth - A),
              (this.tipEl.style.transform = "translateX(" + i + "px)");
          }
        }),
        (t.prototype.onMouseOut = function () {
          this.tipEl && this.tipEl.classList.add(t.hideClassName);
        }),
        (t.sel = ".txp_hotpoint"),
        (t.compName = "HotPoint"),
        (t.defaultPointClass = "txp_interact_dot"),
        (t.defaultTipClass = "txp_hotpoint_tip"),
        t
      );
    })(Component),
    LanguagePopup = (function (e) {
      function t(o, A, i) {
        var r =
          e.call(
            this,
            o,
            __assign$1(__assign$1({}, A), {
              selector: t.popupSelector,
              modSelector: t.modSelector,
            }),
            i
          ) || this;
        return (
          (r.popupName = "language"),
          (r.onSelect = function (e) {
            r.ctrlbar.emit(CTRL_EVENTS$1.SET_LANGUAGE, e);
          }),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          return !(e.isMobile || e.disableLang);
        }),
        (t.compName = "LanguagePopup"),
        (t.modSelector = ".mod_overlay.language"),
        (t.popupSelector = ".txp_right_controls .txp_btn_language"),
        t
      );
    })(Popup),
    Progress = (function (e) {
      function t(o, A, i) {
        var r,
          n = e.call(this, o, t.sel, A) || this;
        (n.ctrlbar = i),
          (n.isMouseDown = !1),
          (n.maxPercent = 1),
          (n.isActive = !0),
          (n.shouldHideHoverTime = !1),
          (n.onMouseMove = function (e) {
            if ((e.preventDefault(), n.isMouseDown)) {
              var t = Math.min(n.getPercentByClientX(e), n.maxPercent);
              n.updateProgress(t),
                n.ctrlbar.emit(CTRL_EVENTS$1.MOUSE_MOVE, t),
                e.preventDefault();
            }
          }),
          (n.onMouseUp = function (e) {
            if (
              (e.preventDefault(),
              document.removeEventListener("touchmove", n.onMouseMove),
              document.removeEventListener("mousemove", n.onMouseMove),
              document.removeEventListener("touchend", n.onMouseUp),
              document.removeEventListener("mouseup", n.onMouseUp),
              n.isMouseDown)
            ) {
              n.player.setStateKv(
                "ctrlbar:" +
                  t.compName +
                  ":" +
                  (n.isMobile ? "touchend" : "mouseup"),
                { type: exports.LOG_TYPE.USER_ACTION, eventId: n.evtId }
              ),
                (n.isMouseDown = !1);
              var o = parseFloat(n.progressPlayed.style.width) / 100;
              n.doSeek(o), n.ctrlbar.emit(CTRL_EVENTS$1.MOUSE_UP, o);
            }
          }),
          (n.onMouseDown = function (e) {
            if (
              (e.preventDefault(),
              document.addEventListener("touchend", n.onMouseUp),
              document.addEventListener("mouseup", n.onMouseUp),
              document.addEventListener("touchmove", n.onMouseMove, {
                passive: !1,
              }),
              document.addEventListener("mousemove", n.onMouseMove, {
                passive: !1,
              }),
              (n.evtId = n.player.dataset.generateEvtId()),
              n.player.setStateKv(
                "ctrlbar:" +
                  t.compName +
                  ":" +
                  (n.isMobile ? "touchstart" : "mousedown"),
                { type: exports.LOG_TYPE.USER_ACTION, eventId: n.evtId }
              ),
              n.player.state !== exports.VIDEO_STATE.IDLE)
            ) {
              n.beforeSeek(), (n.isMouseDown = !0);
              var o = Math.min(n.getPercentByClientX(e), n.maxPercent);
              n.updateProgress(o), n.ctrlbar.emit(CTRL_EVENTS$1.MOUSE_DOWN, o);
            }
          }),
          (n.eventMap =
            (((r = {})[exports.PLAY_EVENT.TIME_UPDATE] =
              n.onTimeUpdate.bind(n)),
            (r[exports.PLAY_EVENT.STATE_CHANGE] = n.onStateChange.bind(n)),
            (r[exports.PLAY_EVENT.VIDEO_BUFFER_CHANGE] = function () {
              return n.updateBufferedBar();
            }),
            r)),
          n.setEvts(),
          (n.progressLoaded = n.el.querySelector(".txp_progress_load")),
          (n.progressPlayed = n.el.querySelector(".txp_progress_play")),
          (n.scrubber = n.el.querySelector(".txp_btn_scrubber")),
          (n.tooltip = n.el.querySelector(".txp_tooltip"));
        return (
          (n.tooltipPosLimit =
            (45 / n.player.container.clientWidth / 2) * 100 + 0.5),
          n.isMobile && n.el.appendChild(n.scrubber),
          n.el.addEventListener("touchstart", n.onMouseDown),
          n.el.addEventListener("mousedown", n.onMouseDown),
          n.isMobile ||
            (n.setTooltipOnHover(),
            n.el.addEventListener("mouseover", function () {
              i.emit(CTRL_EVENTS$1.HOVER_PROGRESS);
            })),
          n.listenReqInfoEnd(),
          n
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "offsetLeft", {
          get: function () {
            return this.el.getBoundingClientRect().left;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "bufferedTime", {
          get: function () {
            var e = this,
              t = this.player.videoBuffered,
              o = t.length;
            if (1 === o) return t[0].end;
            var A = 0;
            return (
              t.forEach(function (i, r) {
                var n = i.start,
                  a = i.end,
                  s = e.playtime;
                if (s >= n && s <= a)
                  if (o > r + 1)
                    for (var g = r + 1; g < o; g++) {
                      var l = t[g].start - t[g - 1].end;
                      if (!(0 <= l && l <= 0.2)) {
                        A = t[g - 1].end;
                        break;
                      }
                      A = t[g].end;
                    }
                  else A = i.end;
              }),
              A
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.destroy = function () {
          this.el.removeEventListener("touchstart", this.onMouseDown),
            this.el.removeEventListener("mousedown", this.onMouseDown),
            document.removeEventListener("touchmove", this.onMouseMove),
            document.removeEventListener("mousemove", this.onMouseMove),
            document.removeEventListener("touchend", this.onMouseUp),
            document.removeEventListener("mouseup", this.onMouseUp),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.setActive = function (e) {
          this.isActive !== e &&
            ((this.isActive = e),
            this.setEvts(!this.isActive),
            this.isActive ? this.showEl() : this.hideEl());
        }),
        (t.prototype.setTooltip = function (e) {
          var t = this.tooltip,
            o = this.tooltipPosLimit;
          t.innerText = commonTool$1.formatPlayTime(e * this.ctrlbar.duration);
          var A = Math.max(o, Math.min(100 * e, 100 - o));
          t.style.left = A + "%";
        }),
        (t.prototype.updateBufferedBar = function (e) {
          if ((void 0 === e && (e = this.bufferedTime), 0 !== e)) {
            if (this.ctrlbar.duration && "number" == typeof e) {
              var t = Math.min(
                Math.round((100 * e) / this.ctrlbar.duration),
                100 * this.maxPercent
              );
              t >= 99 && (t = 100), (this.progressLoaded.style.width = t + "%");
            }
          } else this.progressLoaded.style.width = "0";
        }),
        (t.prototype.updateProgress = function (e) {
          if (!Number.isNaN(e)) {
            var t = 100 * e;
            (this.progressPlayed.style.width = t + "%"),
              (this.scrubber.style.left = t + "%");
          }
        }),
        (t.prototype.getPercentByClientX = function (e) {
          var t = ("touches" in e ? e.touches[0] : e).clientX - this.offsetLeft;
          Math.abs(t - this.el.clientWidth) <= 1 && (t = this.el.clientWidth);
          var o = t / this.el.clientWidth;
          return (o = Math.max(0, Math.min(1, o)));
        }),
        (t.prototype.onTimeUpdate = function () {
          if (!this.isMouseDown) {
            var e = this.playtime / this.ctrlbar.duration;
            this.updateProgress(e), this.updateBufferedBar();
          }
        }),
        (t.prototype.onStateChange = function (e) {
          var t = e.data;
          -1 !==
            [exports.VIDEO_STATE.IDLE, exports.VIDEO_STATE.END].indexOf(
              t.new
            ) && (this.updateProgress(0), this.updateBufferedBar(0));
        }),
        (t.prototype.setTooltipOnHover = function () {
          var e = this;
          this.el.addEventListener("mouseover", function (t) {
            if (
              !(
                e.config.hideHoverTime ||
                (void 0 === e.config.hideHoverTime && e.shouldHideHoverTime)
              )
            ) {
              var o = e.getPercentByClientX(t);
              e.setTooltip(o),
                e.showEl(e.tooltip),
                (e.tooltip.style.display = "flex");
            }
          }),
            this.el.addEventListener("mouseout", function () {
              return e.hideEl(e.tooltip);
            }),
            this.el.addEventListener("mousemove", function (t) {
              var o = e.getPercentByClientX(t);
              e.setTooltip(o);
            });
        }),
        (t.prototype.beforeSeek = function () {
          var e = this;
          this.pauseTimer = window.setTimeout(function () {
            return e.player.pause();
          }, 300);
        }),
        (t.prototype.doSeek = function (e) {
          var t = this.config.timeOffset,
            o = e * this.ctrlbar.duration;
          this.player.seek(t ? t(o, !0) : o),
            this.pauseTimer &&
              (window.clearTimeout(this.pauseTimer), (this.pauseTimer = null)),
            this.player.state !== exports.VIDEO_STATE.PAUSE ||
              this.player.config.remainPauseStateAfterSeek ||
              this.player.play();
        }),
        (t.prototype.listenReqInfoEnd = function () {
          var e = this;
          this.player.pluginMsg.on(
            exports.PLAY_EVENT_EXT.GETINFO_OVER,
            function (t) {
              var o,
                A,
                i,
                r = t.data,
                n = e.player.plugins,
                a = n["ui-preview"] || n["ui-preview-list"],
                s =
                  (null === (o = r.parseData) || void 0 === o
                    ? void 0
                    : o.preview) > 0;
              e.shouldHideHoverTime = !(
                !a ||
                s ||
                !(null ===
                  (i =
                    null === (A = r.parseData) || void 0 === A
                      ? void 0
                      : A.previewList) || void 0 === i
                  ? void 0
                  : i.length)
              );
            }
          );
        }),
        (t.sel = ".txp_progress_bar_container"),
        (t.compName = "Progress"),
        t
      );
    })(Component),
    TIME_UPDATE_GAP_MS = 200,
    PLAY_BACK_STATE;
  !(function (e) {
    (e.IDLE = "idle"),
      (e.BACK_PLAYING = "backPlaying"),
      (e.LIVE_PLAYING = "livePlaying");
  })(PLAY_BACK_STATE || (PLAY_BACK_STATE = {}));
  var LiveProgress = (function (e) {
      function t(t, o, A, i) {
        var r = e.call(this, t, o, A) || this;
        return (
          (r.ctrlbar = A),
          (r.timeupdateTimerID = 0),
          (r.playbackStateInner = PLAY_BACK_STATE.IDLE),
          (r.maxBackDurationOverflow = !1),
          (r.curBackDurationMS = 0),
          (r.liveStateTimeStr = ""),
          (r.isSwitchBackOp = !1),
          (r.playerApiForPlugins = null == i ? void 0 : i.api),
          (r.logger = new Logger(r.player.config.instanceId, "LiveProgress")),
          r.addReturnLiveBtn(),
          r.addLiveTimeDisplay(),
          r.setActive(!1),
          r.addPlayerEvts(),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          return !e.isMobile;
        }),
        (t.prototype.destroy = function () {
          var t, o;
          (null === (t = this.liveTimeDisplayDom) || void 0 === t
            ? void 0
            : t.parentNode) &&
            (this.liveTimeDisplayDom.remove(),
            (this.liveTimeDisplayDom = null)),
            (null === (o = this.returnLiveBtn) || void 0 === o
              ? void 0
              : o.parentNode) &&
              (this.returnLiveBtn.remove(), (this.returnLiveBtn = null)),
            (this.playerApiForPlugins = null),
            this.setTimeupdateTimer(!1),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.setActive = function (t) {
          e.prototype.setActive.call(this, t),
            (this.liveTimeDisplayDom.style.display = t ? "flex" : "none"),
            this.hideEl(this.returnLiveBtn);
        }),
        (t.prototype.setTooltip = function (e) {
          var t = this.tooltip,
            o = this.tooltipPosLimit,
            A = Math.max(o, Math.min(100 * e, 100 - o)),
            i = this.getTimeTip(e);
          (t.style.left = A + "%"), (t.innerText = i);
        }),
        (t.prototype.updateBufferedBar = function (e) {}),
        (t.prototype.onTimeUpdate = function () {}),
        (t.prototype.onStateChange = function () {}),
        (t.prototype.beforeSeek = function () {}),
        (t.prototype.doSeek = function (e) {
          this.seek(e);
        }),
        (t.prototype.addLiveTimeDisplay = function () {
          var e = this.ctrlbar.el.querySelector(".txp_left_controls");
          (this.liveTimeDisplayDom = domTool$1.creatDom(
            '<txpdiv class="txp_time_display txp_time_display_live" style="display: none;">\n      <txpdiv class="txp_live_badge" style="display: block">鐩存挱涓�</txpdiv>\n    </txpdiv>'
          )),
            (this.liveBadgeDom =
              this.liveTimeDisplayDom.querySelector(".txp_live_badge")),
            e.append(this.liveTimeDisplayDom);
        }),
        (t.prototype.addReturnLiveBtn = function () {
          var e = this,
            t = this.ctrlbar.el.querySelector(".txp_left_controls");
          (this.returnLiveBtn = domTool$1.creatDom(
            '<txpdiv class="txp_btn txp_btn_return txp_none">\n      <txpdiv class="txp_label">杩斿洖鐩存挱</txpdiv>\n    </txpdiv>'
          )),
            t.append(this.returnLiveBtn),
            this.returnLiveBtn.addEventListener("click", function () {
              e.seek(1);
            });
        }),
        (t.prototype.updateLiveTime = function (e, t) {
          void 0 === t && (t = ""),
            domTool$1.text(this.liveBadgeDom, e + " " + t);
        }),
        (t.prototype.setPlayBackState = function (e) {
          e
            ? (domTool$1.addClass(this.liveBadgeDom, "txp_live_badge_back"),
              this.showEl(this.returnLiveBtn))
            : (domTool$1.removeClass(this.liveBadgeDom, "txp_live_badge_back"),
              this.hideEl(this.returnLiveBtn));
        }),
        (t.prototype.addPlayerEvts = function () {
          var e = this;
          this.player.on(
            exports.H5_PLAY_EVENT.VIDEO_REQ_INFO_END,
            function (t) {
              var o,
                A = t.data.data;
              if (A && !A.error) {
                var i = (A || {}).resData;
                (e.clientStartTimeMS = Date.now()),
                  (e.playbackData =
                    null === (o = i) || void 0 === o ? void 0 : o.playback),
                  e.playbackData
                    ? e.playbackState === PLAY_BACK_STATE.IDLE &&
                      (e.setPlayBackEnabled(!0),
                      e.player.loadParam.videoReqInfoParam.playbacktime > 0
                        ? e.enterState(PLAY_BACK_STATE.BACK_PLAYING)
                        : e.enterState(PLAY_BACK_STATE.LIVE_PLAYING))
                    : e.setPlayBackEnabled(!1);
              }
            }
          ),
            this.player.on(exports.H5_PLAY_EVENT.PLAY_SESSION_END, function () {
              e.isSwitchBackOp
                ? (e.isSwitchBackOp = !1)
                : e.enterState(PLAY_BACK_STATE.IDLE);
            }),
            this.player.on(exports.H5_PLAY_EVENT.VIDEO_PLAYING, function () {
              e.isSwitchBackOp = !1;
            });
        }),
        (t.prototype.setPlayBackEnabled = function (e) {
          this.setActive(e), this.setTimeupdateTimer(e);
        }),
        (t.prototype.enterState = function (e, t) {
          var o = this;
          if (this.playbackData && this.playbackState !== e) {
            var A = this.playbackState;
            if (
              (this.logger.log("enterState from " + A + " to " + e),
              A === PLAY_BACK_STATE.IDLE && e === PLAY_BACK_STATE.LIVE_PLAYING)
            )
              this.playbackState = e;
            else if (
              A === PLAY_BACK_STATE.LIVE_PLAYING &&
              e === PLAY_BACK_STATE.BACK_PLAYING
            ) {
              var i = t.backDurationMS,
                r = this.calcBackAbsoluteTimeS(Date.now(), i);
              this.switchPlay(
                r,
                function () {
                  (o.curBackDurationMS = i), (o.playbackState = e);
                },
                function (e) {
                  o.playbackState = PLAY_BACK_STATE.LIVE_PLAYING;
                  var t = e || {},
                    A = t.code,
                    i = t.message,
                    r = t.data;
                  (null == A
                    ? void 0
                    : A.startsWith(
                        exports.ErrorCode.GETINFO_LIVE_SERVER_CODE_PREFIX
                      )) &&
                    o.emitPlayerEvts(
                      "playbackFailed",
                      __assign$1({ code: A, message: i }, r)
                    );
                  var n = o.player.plugins.tips;
                  "function" == typeof (null == n ? void 0 : n.show) &&
                    n.show("鎶辨瓑锛岃繘鍏ュ洖鐪嬪け璐�..."),
                    o.logger.warn(
                      "enter playback failed, code=" + A + ", message=" + i
                    );
                }
              );
            } else
              A === PLAY_BACK_STATE.BACK_PLAYING &&
              e === PLAY_BACK_STATE.LIVE_PLAYING
                ? this.switchPlay(0, function () {
                    o.playbackState = e;
                  })
                : e === PLAY_BACK_STATE.IDLE && (this.playbackState = e);
          }
        }),
        Object.defineProperty(t.prototype, "playbackState", {
          get: function () {
            return this.playbackStateInner;
          },
          set: function (e) {
            (this.playbackStateInner = e),
              this.onPlaybackStateChange(e),
              this.emitPlayerEvts("playbackStateChange", {
                state: this.playbackState,
              });
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.onPlaybackStateChange = function (e) {
          switch (e) {
            case PLAY_BACK_STATE.LIVE_PLAYING:
              this.exitBackPlaying();
              break;
            case PLAY_BACK_STATE.BACK_PLAYING:
              this.enterBackPlaying();
              break;
            case PLAY_BACK_STATE.IDLE:
              this.exitBackPlaying(), this.setPlayBackEnabled(!1);
          }
        }),
        (t.prototype.emitPlayerEvts = function (e) {
          for (var t, o = [], A = 1; A < arguments.length; A++)
            o[A - 1] = arguments[A];
          (t = this.player).emit.apply(t, __spreadArray([e], o, !1));
        }),
        (t.prototype.switchPlay = function (e, t, o) {
          var A;
          (this.isSwitchBackOp = !0),
            (null === (A = this.playerApiForPlugins) || void 0 === A
              ? void 0
              : A.replayInCurFlowNode) &&
              this.playerApiForPlugins
                .replayInCurFlowNode(this.player.vid, {
                  videoReqInfoParam: { playbacktime: e },
                })
                .then(function () {
                  null == t || t();
                })
                .catch(function (e) {
                  null == o || o(e);
                });
        }),
        (t.prototype.seekInBackState = function (e) {
          var t,
            o = e.backDurationMS,
            A = this.calcBackAbsoluteTimeS(Date.now(), o),
            i = this.player.currentVideoInfo.loadingUrl,
            r = urlTool$1.updateUrlParam(i, "wsStreamTimeABS", "" + A);
          (this.curBackDurationMS = o),
            (this.isSwitchBackOp = !0),
            (null === (t = this.playerApiForPlugins) || void 0 === t
              ? void 0
              : t.replayInCurFlowNode) &&
              this.playerApiForPlugins.replayInCurFlowNode({ url: r });
        }),
        (t.prototype.enterBackPlaying = function () {
          this.setPlayBackState(!0), this.updateLiveTime("鍥炵湅涓�");
        }),
        (t.prototype.exitBackPlaying = function () {
          this.updateProgress(1),
            this.setPlayBackState(!1),
            (this.curBackDurationMS = 0),
            this.updatePlaybackTime(0),
            this.updateLiveTime("鐩存挱涓�");
        }),
        (t.prototype.updatePlaybackTime = function (e) {
          var t, o;
          (this.player.loadParam.videoReqInfoParam.playbacktime = e),
            null === (o = (t = this.player).updateReqInfo) ||
              void 0 === o ||
              o.call(t, { videoReqInfoParam: { playbacktime: e } });
        }),
        (t.prototype.setTimeupdateTimer = function (e) {
          e
            ? 0 === this.timeupdateTimerID &&
              (this.timeupdateTimerID = window.setInterval(
                this.onTimeupdate.bind(this),
                TIME_UPDATE_GAP_MS
              ))
            : this.timeupdateTimerID > 0 &&
              (window.clearInterval(this.timeupdateTimerID),
              (this.timeupdateTimerID = 0));
        }),
        (t.prototype.calcMaxBackDurationS = function (e) {
          var t = this.playbackData.playbacktime;
          if (this.maxBackDurationOverflow) return t;
          var o = this.calcStreamAbsoluteDurationMS(e) / 1e3;
          return o < t
            ? ((this.maxBackDurationOverflow = !1), o)
            : ((this.maxBackDurationOverflow = !0), t);
        }),
        (t.prototype.calcAbsoluteTimeMS = function (e) {
          return 1e3 * this.playbackData.svrtick + (e - this.clientStartTimeMS);
        }),
        (t.prototype.calcStreamAbsoluteDurationMS = function (e) {
          return (
            this.calcAbsoluteTimeMS(e) - 1e3 * this.playbackData.playbackstart
          );
        }),
        (t.prototype.calcBackAbsoluteTimeS = function (e, t) {
          return Math.round((this.calcAbsoluteTimeMS(e) - t) / 1e3);
        }),
        (t.prototype.onTimeupdate = function () {
          if (
            !this.isMouseDown &&
            this.player.state === exports.VIDEO_STATE.PLAYING
          ) {
            var e = "",
              t = "",
              o = Date.now(),
              A = this.calcStreamAbsoluteDurationMS(o);
            if (this.playbackState === PLAY_BACK_STATE.BACK_PLAYING) {
              var i = this.calcMaxBackDurationS(o),
                r = (A - this.curBackDurationMS) / 1e3,
                n = this.calcBackAbsoluteTimeS(o, this.curBackDurationMS);
              if (
                (this.updatePlaybackTime(n),
                (t = "鍥炵湅涓�"),
                (e = "" + commonTool$1.formatPlayTime(r)),
                !this.maxBackDurationOverflow)
              ) {
                var a = (i - this.curBackDurationMS / 1e3) / i;
                this.updateProgress(a);
              }
            } else
              (t = "鐩存挱涓�"),
                (e = "" + commonTool$1.formatPlayTime(A / 1e3));
            this.liveStateTimeStr !== e &&
              ((this.liveStateTimeStr = e), this.updateLiveTime(t, e));
          }
        }),
        (t.prototype.calcPercent2BackTimeS = function (e) {
          return (1 - e) * this.calcMaxBackDurationS(Date.now());
        }),
        (t.prototype.getTimeTip = function (e) {
          var t = this.calcPercent2BackTimeS(e);
          return "鍥為€€" + commonTool$1.formatPlayTime(t);
        }),
        (t.prototype.seek = function (e) {
          if (1 === e)
            return (
              this.logger.log("percent===1, return to live"),
              void this.enterState(PLAY_BACK_STATE.LIVE_PLAYING)
            );
          var t = 1e3 * this.calcPercent2BackTimeS(e);
          this.playbackState === PLAY_BACK_STATE.LIVE_PLAYING
            ? (this.logger.log("live to playback"),
              this.enterState(PLAY_BACK_STATE.BACK_PLAYING, {
                backDurationMS: t,
              }))
            : this.playbackState === PLAY_BACK_STATE.BACK_PLAYING &&
              (this.logger.log("seek in playback"),
              this.seekInBackState({ backDurationMS: t }));
        }),
        t
      );
    })(Progress),
    LoopStatus;
  !(function (e) {
    (e.Loop = "true"), (e.NotLoop = "false");
  })(LoopStatus || (LoopStatus = {}));
  var LocalLoopConfigKey = "thumbplayer-h5-loop",
    Loop = (function (e) {
      function t(o, A, i) {
        var r = e.call(this, o, t.sel, A) || this;
        return (
          (r.ctrlbar = i),
          (r.tip = r.el.querySelector(".txp_tooltip")),
          r.setupDOMEvents(),
          r.initLoopConfig(),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          var t = e.enableLoop,
            o = e.isMobile;
          return t && !o;
        }),
        Object.defineProperty(t.prototype, "isLoopMode", {
          get: function () {
            return this.el.dataset.status === LoopStatus.Loop;
          },
          set: function (e) {
            (this.player.config.loop = e),
              (this.el.dataset.status = String(e)),
              (this.tip.innerText = e
                ? "鍏抽棴寰幆鎾斁"
                : "鎵撳紑寰幆鎾斁");
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.setupDOMEvents = function () {
          var e = this;
          this.el.addEventListener(this.CLICK_EVENT_NAME, function () {
            (e.isLoopMode = !e.isLoopMode),
              lsTool.setData(
                LocalLoopConfigKey,
                e.isLoopMode ? LoopStatus.Loop : LoopStatus.NotLoop
              ),
              e.ctrlbar.emit(CTRL_EVENTS$1.CLICK_LOOP, { loop: e.isLoopMode });
          });
        }),
        (t.prototype.initLoopConfig = function () {
          var e = this.player.config.loop;
          if (void 0 === e) {
            var t = lsTool.getData(LocalLoopConfigKey);
            t && (this.isLoopMode = t === LoopStatus.Loop);
          } else this.isLoopMode = !!e;
        }),
        (t.compName = "Loop"),
        (t.sel = ".txp_left_controls .txp_btn_loop"),
        t
      );
    })(Component),
    DEFAULT_AUTO_HIDE_TIMEOUT = 1e4,
    MuteTips = (function (e) {
      function t(o, A, i) {
        var r = e.call(this, o, t.sel, A) || this;
        return (
          (r.ctrlbar = i),
          (r.onUnmuteBtnClick = function () {
            (r.player.muted = !1), r.hideEl();
          }),
          (r.onCloseBtnClick = function () {
            r.hideEl();
          }),
          (r.onRootMouseEnter = function () {
            r.hide(r.hideTimeout);
          }),
          (r.onAutoplayInMuted = function () {
            r.show(r.hideTimeout);
          }),
          r.setDOM(),
          r.bindEvents(!0),
          r.hideEl(),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          return !e.isMobile;
        }),
        Object.defineProperty(t.prototype, "isShow", {
          get: function () {
            return this.el.classList.contains("txp_none");
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "hideTimeout", {
          get: function () {
            var e;
            return null !== (e = this.config.muteTipsHideTimeout) &&
              void 0 !== e
              ? e
              : DEFAULT_AUTO_HIDE_TIMEOUT;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.destroy = function () {
          this.bindEvents(!1), clearTimeout(this.autoHideTimer);
        }),
        (t.prototype.hide = function (e) {
          var t = this;
          void 0 === e && (e = 300),
            clearTimeout(this.autoHideTimer),
            e > 0 &&
              (this.autoHideTimer = setTimeout(function () {
                t.hideEl();
              }, e));
        }),
        (t.prototype.setDOM = function () {
          (this.unmuteBtn = this.el.querySelector(".txp_btn_unmuted")),
            (this.closeBtn = this.el.querySelector(".txp_tips_close_btn"));
        }),
        (t.prototype.bindEvents = function (e) {
          void 0 === e && (e = !1);
          var t = getEventTargetBinder(this.el, e),
            o = getEventTargetBinder(this.closeBtn, e),
            A = getEventTargetBinder(this.unmuteBtn, e),
            i = getEventEmitterBinder(this.player.pluginMsg, e);
          t("mouseenter", this.onRootMouseEnter),
            o("click", this.onCloseBtnClick),
            A("click", this.onUnmuteBtnClick),
            i(exports.PLAY_EVENT_EXT.AUTOPLAY_IN_MUTED, this.onAutoplayInMuted);
        }),
        (t.prototype.show = function (e) {
          this.showEl(), this.hide(e);
        }),
        (t.compName = "MuteTips"),
        (t.sel = ".txp_popup_mute_tips"),
        t
      );
    })(Component),
    NextBtn = (function (e) {
      function t(o, A, i) {
        var r,
          n = e.call(this, o, t.sel, A) || this;
        n.ctrlbar = i;
        var a = A.showNextBtnUIOnly;
        return (
          a
            ? n.el.classList.remove(Component.disabledClassName)
            : ((n.onVideoNodeChange = n.onVideoNodeChange.bind(n)),
              (n.eventMap =
                (((r = {})[exports.PLAY_EVENT.VIDEONODE_CHANGE] =
                  n.onVideoNodeChange),
                (r[exports.PLAY_EVENT.LIST_CHANGE] = n.onVideoNodeChange),
                r)),
              n.setEvts()),
          n.el.addEventListener(n.CLICK_EVENT_NAME, function () {
            if (
              (n.player.setStateKv(
                "ctrlbar:" + t.compName + ":" + n.CLICK_EVENT_NAME,
                { type: exports.LOG_TYPE.USER_ACTION }
              ),
              n.ctrlbar.emit(CTRL_EVENTS$1.CLICK_NEXTBTN),
              !a)
            ) {
              var e = n.player.currentVideoInfoIdx;
              -1 === e ||
                e >= n.player.totalVideoInfoCount - 1 ||
                n.player.playNext();
            }
          }),
          n
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          var t = e.isMobile,
            o = e.disableNextBtn,
            A = e.showNextBtnUIOnly;
          return !(t || (o && !A));
        }),
        (t.prototype.onVideoNodeChange = function () {
          var e = this.player.currentVideoInfoIdx;
          -1 !== e && e + 1 < this.player.totalVideoInfoCount
            ? this.el.classList.remove(Component.disabledClassName)
            : this.el.classList.add(Component.disabledClassName);
        }),
        (t.sel = ".txp_left_controls .txp_btn_next"),
        (t.compName = "NextBtn"),
        t
      );
    })(Component),
    PictureInPicture = (function (e) {
      function t(o, A, i) {
        var r = e.call(this, o, t.sel, A) || this;
        return (
          (r.ctrlbar = i),
          (r.isPiP = !1),
          (r.onEnterPiP = function () {
            (r.isPiP = !0), r.setDOMStatus(!1);
          }),
          (r.onLeavePiP = function () {
            (r.isPiP = !1), r.setDOMStatus(!0);
          }),
          void 0 === HTMLVideoElement.prototype.requestPictureInPicture
            ? (r.el.classList.add(Component.hideClassName), r)
            : (r.setupDOMEvents(),
              r.setupPlayerEvents(),
              (r.tooltip = r.el.querySelector(".txp_tooltip")),
              r)
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          return !e.isMobile;
        }),
        (t.prototype.enterPicInPic = function () {
          var e = this.player.currentVideoElement;
          e && (e.requestPictureInPicture(), this.setDOMStatus(!1));
        }),
        (t.prototype.leavePicInPic = function () {
          var e, t;
          try {
            null ===
              (t =
                null === (e = document.exitPictureInPicture()) || void 0 === e
                  ? void 0
                  : e.catch) ||
              void 0 === t ||
              t.call(e, function () {});
          } catch (e) {}
          this.setDOMStatus(!0);
        }),
        (t.prototype.destroy = function () {
          this.setupVideoListener(!1),
            this.leavePicInPic(),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.setupDOMEvents = function () {
          var e = this;
          this.el.addEventListener("click", function () {
            e.isPiP
              ? (e.leavePicInPic(), (e.isPiP = !1))
              : (e.enterPicInPic(), (e.isPiP = !0)),
              e.ctrlbar.emit(CTRL_EVENTS$1.CLICK_PIPBTN, e.isPiP);
          });
        }),
        (t.prototype.setupPlayerEvents = function () {
          var e = this;
          this.player.on(exports.H5_PLAY_EVENT.VIDEO_PLAYING, function (t) {
            t.data.isFirst && e.setPipSupportStatus(e.isKernelSupport());
          }),
            this.player.on(
              exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
              function (t) {
                t.data.code === exports.ErrorCode.SUC &&
                  e.setPipSupportStatus(e.isKernelSupport());
              }
            );
        }),
        (t.prototype.setPipSupportStatus = function (e) {
          e
            ? (this.el.classList.remove(Component.hideClassName),
              this.setVideoPip())
            : (this.leavePicInPic(),
              this.el.classList.add(Component.hideClassName));
        }),
        (t.prototype.isKernelSupport = function () {
          var e = this.player.currentVideoElement;
          return (
            e instanceof HTMLVideoElement &&
            !e.getAttribute("disablePictureInPicture") &&
            "function" == typeof e.requestPictureInPicture
          );
        }),
        (t.prototype.setVideoPip = function () {
          this.isPiP && this.enterPicInPic(),
            this.setupVideoListener(!1),
            this.setupVideoListener(!0);
        }),
        (t.prototype.setupVideoListener = function (e) {
          void 0 === e && (e = !0);
          var t = this.player.currentVideoElement;
          if (t) {
            var o = e ? t.addEventListener : t.removeEventListener;
            o.call(t, "enterpictureinpicture", this.onEnterPiP),
              o.call(t, "leavepictureinpicture", this.onLeavePiP);
          }
        }),
        (t.prototype.setDOMStatus = function (e) {
          this.el &&
            (this.tooltip &&
              (this.tooltip.innerText = e ? "鐢讳腑鐢�" : "閫€鍑虹敾涓敾"),
            (this.el.dataset.status = String(!e)));
        }),
        (t.sel = ".txp_right_controls .txp_btn_pip"),
        (t.compName = "PictureInPicture"),
        t
      );
    })(Component);
  function showTips(e, t) {
    var o = e.plugins.tips;
    "function" == typeof (null == o ? void 0 : o.show) && o.show(t);
  }
  function hideTips(e) {
    var t = e.plugins.tips;
    "function" == typeof (null == t ? void 0 : t.hide) && t.hide();
  }
  function getIsInAd(e) {
    var t = e,
      o = t.flowManager,
      A = t.videoNode;
    return !(
      !getAdPlugin(e.config.instanceId) ||
      !A ||
      A === o.currentFlowNode
    );
  }
  var PlayBtn = (function (e) {
      function t(o, A, i) {
        var r,
          n = e.call(this, o, t.sel, A) || this;
        return (
          (n.ctrlbar = i),
          (n.onPlaySessionStart = function () {
            n.setPlayStatus(exports.PlayBtnStatus.PLAY),
              (n.tooltip.innerText = "鎾斁");
          }),
          (n.onPlaySessionEnd = function () {
            n.setPlayStatus(
              n.isLive
                ? exports.PlayBtnStatus.PLAY
                : exports.PlayBtnStatus.REPLAY
            ),
              (n.tooltip.innerText = "鎾斁");
          }),
          (n.eventMap =
            (((r = {})[exports.PLAY_EVENT.STATE_CHANGE] =
              n.onPlayerStateChange.bind(n)),
            (r[exports.H5_PLAY_EVENT.PLAY_SESSION_START] =
              n.onPlaySessionStart),
            (r[exports.H5_PLAY_EVENT.PLAY_SESSION_END] = n.onPlaySessionEnd),
            r)),
          n.setPlayStatus(exports.PlayBtnStatus.PLAY),
          n.setEvts(),
          (n.tooltip = n.el.querySelector(".txp_tooltip")),
          n.addEventListener(),
          n
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.setPlayStatus = function (e) {
          (this.el.dataset.status = e),
            (this.el.className = "txp_btn txp_btn_play play_btn_" + e);
        }),
        (t.prototype.addEventListener = function () {
          var e = this,
            o = this.player;
          this.el.addEventListener("click", function () {
            if (
              (o.setStateKv(
                "ctrlbar:" + t.compName + ":" + e.CLICK_EVENT_NAME,
                { type: exports.LOG_TYPE.USER_ACTION }
              ),
              !e.el.classList.contains(Component.disabledClassName))
            )
              switch (
                (e.ctrlbar.emit(CTRL_EVENTS$1.CLICK_PLAYBTN, e.el.dataset),
                e.el.dataset.status)
              ) {
                case exports.PlayBtnStatus.PAUSE:
                  o.pause(exports.H5_PAUSE_TYPE.USER_CLICK);
                  break;
                case exports.PlayBtnStatus.STOP:
                  o.stop();
                  break;
                case exports.PlayBtnStatus.PLAY:
                  if (!e.isLive) return onBtnClickPlay(o, e.ctrlbar);
                  e.replay();
                  break;
                case exports.PlayBtnStatus.REPLAY:
                  e.ctrlbar.emit(CTRL_EVENTS$1.CLICK_REPLAY), e.replay();
              }
          });
        }),
        (t.prototype.replay = function () {
          var e = this.player;
          e.vid
            ? e.triggerAutoplay().then(function () {
                return e.replay();
              })
            : e.replay();
        }),
        (t.prototype.onVodPlaying = function () {
          var e = this.tooltip;
          this.setPlayStatus(exports.PlayBtnStatus.PAUSE),
            (e.innerText = "鏆傚仠");
        }),
        (t.prototype.onLivePlaying = function () {
          var e = this,
            t = this.tooltip,
            o = function () {
              e.setPlayStatus(exports.PlayBtnStatus.STOP),
                (t.innerText = "鍋滄");
            };
          getIsInAd(this.player)
            ? this.player.once(exports.H5_PLAY_EVENT.AD_END, o)
            : o();
        }),
        (t.prototype.onPlayerStateChange = function (e) {
          var t = this,
            o = e.data.new,
            A = this.tooltip;
          switch (o) {
            case exports.VIDEO_STATE.PLAYING:
              this.isLive ? this.onLivePlaying() : this.onVodPlaying();
              break;
            case exports.VIDEO_STATE.PAUSE:
            case exports.VIDEO_STATE.CANPLAY:
              var i = function () {
                t.setPlayStatus(exports.PlayBtnStatus.PLAY),
                  (A.innerText = "鎾斁");
              };
              getIsInAd(this.player)
                ? this.player.once(exports.H5_PLAY_EVENT.AD_END, i)
                : i();
          }
        }),
        (t.sel = ".txp_left_controls .txp_btn_play"),
        (t.compName = "PlayBtn"),
        t
      );
    })(Component),
    PlayratePopup = (function (e) {
      function t(o, A, i) {
        var r =
          e.call(
            this,
            o,
            __assign$1(__assign$1({}, A), {
              selector: t.popupSelector,
              modSelector: t.modSelector,
            }),
            i
          ) || this;
        return (
          (r.popupName = "playrate"),
          (r.onSelect = function (e) {
            var t = r,
              o = t.player;
            t.ctrlbar.emit(CTRL_EVENTS$1.SET_PLAYRATE, e);
            var A = Number(e.value);
            o.playbackRate !== A &&
              ((o.playbackRate = A),
              (r.selected = A),
              showTips(r.player, "姝ｅ湪<em>" + A + "</em>鍊嶉€熷害鎾斁"));
          }),
          (r.onPlayRestart = function () {
            r.el.classList.toggle(
              Component.hideClassName,
              !r.player.supportPlaybackRate
            );
          }),
          (r.popupOptions = [
            { label: "0.5X", value: 0.5 },
            { label: "0.75X", value: 0.75 },
            { label: "1.0X", value: 1, btnLabel: "鍊嶉€�" },
            { label: "1.25X", value: 1.25 },
            { label: "1.5X", value: 1.5 },
            { label: "1.75X", value: 1.75 },
            { label: "2.0X", value: 2 },
          ]),
          (r.selected = 1),
          r.bindEvts(!0),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          var t = e.isMobile,
            o = e.enablePlayrate;
          return !t || (t && o);
        }),
        (t.prototype.destroy = function () {
          this.bindEvts(!1), e.prototype.destroy.call(this);
        }),
        (t.prototype.bindEvts = function (e) {
          (e
            ? this.player.on.bind(this.player)
            : this.player.off.bind(this.player))(
            exports.PLAY_EVENT.RESTART,
            this.onPlayRestart
          );
        }),
        (t.compName = "PlayratePopup"),
        (t.popupSelector = ".txp_right_controls .txp_btn_playrate"),
        (t.modSelector = ".mod_overlay.playrate"),
        t
      );
    })(Popup),
    TimeArea = (function (e) {
      function t(o, A, i) {
        var r,
          n = e.call(this, o, t.sel, A) || this;
        (n.ctrlbar = i),
          (n.clickCount = 0),
          (n.clickTimer = 0),
          (n.onMouseup = function () {
            n.isMouseDown = !1;
          }),
          (n.onMousemove = function (e) {
            var t = e.data;
            n.timeCur.innerText = commonTool$1.formatPlayTime(
              t * n.ctrlbar.duration
            );
          }),
          (n.onMousedown = function (e) {
            var t = e.data;
            (n.isMouseDown = !0),
              (n.timeCur.innerText = commonTool$1.formatPlayTime(
                t * n.ctrlbar.duration
              ));
          });
        var a = CTRL_EVENTS$1.MOUSE_DOWN,
          s = CTRL_EVENTS$1.MOUSE_MOVE,
          g = CTRL_EVENTS$1.MOUSE_UP;
        return (
          (n.eventMap =
            (((r = {})[exports.PLAY_EVENT.DURATION_CHANGE] =
              n.onDurationChange.bind(n)),
            (r[exports.PLAY_EVENT.TIME_UPDATE] = n.onTimeUpdate.bind(n)),
            (r[exports.PLAY_EVENT.STATE_CHANGE] =
              n.onPlayerStateChange.bind(n)),
            r)),
          n.setEvts(),
          i.on(a, n.onMousedown),
          i.on(s, n.onMousemove),
          i.on(g, n.onMouseup),
          (n.timeCur = n.el.querySelector(".txp_time_current")),
          (n.timeDur = n.el.querySelector(".txp_time_duration")),
          A.disableTestEvent || n.bindClickOnMobile(),
          n
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.bindClickOnMobile = function () {
          var e = this;
          if (this.isMobile) {
            this.el.addEventListener("click", function () {
              (e.clickCount += 1),
                e.clickCount >= 5 &&
                  ((e.clickCount = 0),
                  e.ctrlbar.emit(CTRL_EVENTS$1.TEST_EVENT)),
                e.clickTimer && clearTimeout(e.clickTimer),
                (e.clickTimer = window.setTimeout(function () {
                  e.clickCount = 0;
                }, 300));
            });
          }
        }),
        (t.prototype.onPlayerStateChange = function (e) {
          e.data.new === exports.VIDEO_STATE.IDLE &&
            (this.timeCur.innerText = "00:00");
        }),
        (t.prototype.onDurationChange = function () {
          var e = this.ctrlbar.duration;
          (this.timeDur.innerText = commonTool$1.formatPlayTime(e)),
            this.el.classList.toggle("reach_hour", e >= 3600);
        }),
        (t.prototype.onTimeUpdate = function () {
          if (!this.isMouseDown) {
            var e = commonTool$1.formatPlayTime(this.playtime);
            this.timeCur.innerText !== e && (this.timeCur.innerText = e);
          }
        }),
        (t.sel = ".txp_left_controls .txp_time_display"),
        (t.compName = "TimeArea"),
        t
      );
    })(Component),
    VolumeStatus;
  !(function (e) {
    (e.Mute = "mute"), (e.Normal = "normal");
  })(VolumeStatus || (VolumeStatus = {}));
  var LOCAL_KEY = {
      VOLUME: "thumbplayer-h5-volume",
      MUTED: "thumbplayer-h5-volume:muted",
    },
    MutedStatus;
  !(function (e) {
    (e.muted = "true"), (e.unmuted = "false");
  })(MutedStatus || (MutedStatus = {}));
  var initDragVolume = -1,
    Volume = (function (e) {
      function t(o, A, i) {
        var r,
          n = e.call(this, o, t.sel, A) || this;
        return (
          (n.ctrlbar = i),
          (n.lastVolume = 0.5),
          (n.dragVolume = initDragVolume),
          (n.onVideoPlaying = function (e) {
            e.data.isFirst &&
              (n.isInLiveAd() || (n.player.muted && n.setUi(0)));
          }),
          (n.onVolumeChange = function () {
            if (!n.isInLiveAd()) {
              var e = n.player.volume;
              n.player.muted && (e = 0), n.setUi(e);
            }
          }),
          (n.onAdVolumeChange = function (e) {
            var t = e.data;
            getIsInAd(n.player) && n.setUi(t.volume);
          }),
          n.isMobile ||
            ((n.eventMap =
              (((r = {})[exports.H5_PLAY_EVENT.VIDEO_VOLUME_CHANGE] =
                n.onVolumeChange),
              (r[exports.H5_PLAY_EVENT.AD_VOLUME_CHANGE] = n.onAdVolumeChange),
              (r[exports.H5_PLAY_EVENT.VIDEO_PLAYING] = n.onVideoPlaying),
              r)),
            n.setEvts(),
            (n.popup = n.el.querySelector(".txp_popup_volume")),
            (n.volumeSvg = n.el.querySelector(".txp_icon_volume")),
            (n.volumeValue = n.el.querySelector(".txp_volume_range_current")),
            (n.volumeRange = n.el.querySelector(".txp_volume_range")),
            (n.volumeText = n.el.querySelector(".txp_volume_text")),
            n.initDOMEvents(),
            n.config.disableCacheVolume || n.setVolumeByCache()),
          n
        );
      }
      return (
        __extends$1(t, e),
        (t.isEnabled = function (e) {
          return !e.isMobile;
        }),
        Object.defineProperty(t.prototype, "muteTips", {
          get: function () {
            return this.ctrlbar.instances.MuteTips;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.setVolumeByCache = function () {
          var e = Number(lsTool.getData(LOCAL_KEY.VOLUME)),
            t = lsTool.getData(LOCAL_KEY.MUTED);
          (Number.isNaN(e) || e > 1) &&
            ((e = 1), lsTool.setData(LOCAL_KEY.VOLUME, "1")),
            e && (this.lastVolume = e),
            t === MutedStatus.muted && (e = 0),
            this.setVolume(e),
            this.setUi();
        }),
        (t.prototype.setUi = function (e) {
          void 0 === e && (e = this.getCurrentNodeVolume()),
            (this.el.dataset.status =
              0 === e ? VolumeStatus.Mute : VolumeStatus.Normal),
            (this.volumeValue.style.height = 100 * e + "%"),
            (this.volumeText.innerText = String(Math.round(100 * e)));
        }),
        (t.prototype.getCurrentNodeVolume = function () {
          var e,
            t,
            o = this.player;
          return getIsInAd(o) &&
            null !==
              (t =
                null === (e = getAdPlugin(o.config.instanceId)) || void 0 === e
                  ? void 0
                  : e.getAdVolume()) &&
            void 0 !== t
            ? t
            : o.volume;
        }),
        (t.prototype.isInLiveAd = function () {
          return this.isLive && getIsInAd(this.player);
        }),
        (t.prototype.setPercent = function (e, t) {
          var o = e.clientY;
          (this.clientY = this.volumeRange.getBoundingClientRect().top),
            (this.clientHeight = this.volumeRange.clientHeight);
          var A = (o - this.clientY) / this.clientHeight;
          A = Math.floor(100 * (1 - A));
          var i = (A = Math.max(Math.min(A, 100), 0)) / 100;
          this.player.volume !== i &&
            (this.ctrlbar.emit(CTRL_EVENTS$1.SET_VOLUME, i),
            (this.dragVolume = A)),
            this.setVolume(i),
            this.setUi(),
            t &&
              (lsTool.setData(LOCAL_KEY.VOLUME, i),
              lsTool.setData(LOCAL_KEY.MUTED, !1));
        }),
        (t.prototype.setVolume = function (e) {
          var t;
          this.isInLiveAd()
            ? null === (t = getAdPlugin(this.player.config.instanceId)) ||
              void 0 === t ||
              t.setAdVolume(e)
            : (this.player.volume = e);
        }),
        (t.prototype.initDOMEvents = function () {
          this.setupBtnMouseEvents(),
            this.setupVolumeClick(),
            this.setupVolumeRangeMouseEvents();
        }),
        (t.prototype.showVolumeTips = function () {
          var e = this;
          if (this.dragVolume !== initDragVolume) {
            this.clearTipsTimer();
            this.volumeTipsTimer = window.setTimeout(function () {
              showTips(
                e.player,
                "褰撳墠闊抽噺: <em>" + e.dragVolume.toFixed(0) + "</em>"
              );
            }, 500);
          }
        }),
        (t.prototype.clearTipsTimer = function () {
          this.volumeTipsTimer &&
            (window.clearTimeout(this.volumeTipsTimer),
            (this.volumeTipsTimer = 0));
        }),
        (t.prototype.setupBtnMouseEvents = function () {
          var e = this;
          this.el.addEventListener("mouseenter", function (t) {
            var o;
            null === (o = e.muteTips) || void 0 === o || o.hide(),
              e.showEl(e.popup),
              (e.dragVolume = initDragVolume),
              e.clearTipsTimer();
          }),
            this.el.addEventListener("mouseleave", function () {
              e.isMouseDown || (e.hideEl(e.popup), e.showVolumeTips());
            });
        }),
        (t.prototype.setupVolumeRangeMouseEvents = function () {
          var e = this,
            t = this.volumeRange,
            o = this.player;
          t.addEventListener("mousedown", function () {
            e.isMouseDown = !0;
          }),
            t.addEventListener("mousemove", function (t) {
              e.isMouseDown && e.setPercent(t);
            }),
            o.container.addEventListener("mousemove", function (t) {
              e.isMouseDown && e.setPercent(t);
            }),
            t.addEventListener("mouseup", function (t) {
              (e.isMouseDown = !1), e.setPercent(t, !0);
            }),
            o.container.addEventListener("mouseup", function (t) {
              e.isMouseDown &&
                ((e.isMouseDown = !1),
                e.setPercent(t, !0),
                e.hideEl(e.popup),
                e.showVolumeTips());
            });
        }),
        (t.prototype.setupVolumeClick = function () {
          var e = this;
          this.volumeSvg.addEventListener(this.CLICK_EVENT_NAME, function () {
            e.el.dataset.status === VolumeStatus.Mute
              ? ((e.el.dataset.status = VolumeStatus.Normal),
                e.setVolume(e.lastVolume),
                lsTool.setData(LOCAL_KEY.MUTED, MutedStatus.unmuted),
                lsTool.setData(LOCAL_KEY.VOLUME, e.lastVolume))
              : ((e.lastVolume = e.getCurrentNodeVolume()),
                (e.el.dataset.status = VolumeStatus.Mute),
                e.setVolume(0),
                lsTool.setData(LOCAL_KEY.MUTED, MutedStatus.muted)),
              (e.player.played &&
                -1 ===
                  [exports.VIDEO_STATE.END, exports.VIDEO_STATE.IDLE].indexOf(
                    e.player.state
                  )) ||
                e.setUi();
          });
        }),
        (t.compName = "Volume"),
        (t.sel = ".txp_btn_volume"),
        t
      );
    })(Component),
    THUMBPLAYER_PREFIX = "thumbplayer",
    svgSpriteClassName = "txp_svg_sprite",
    ctrlBarClassName = "txp_controls",
    svgSpriteSelector = "." + THUMBPLAYER_PREFIX + "." + svgSpriteClassName,
    ctrlBarSelector = "." + THUMBPLAYER_PREFIX + "." + ctrlBarClassName,
    pcViewBox = "0 0 28 28",
    svgSprite =
      '\n<svg class="' +
      THUMBPLAYER_PREFIX +
      " " +
      svgSpriteClassName +
      '" display="none" xmlns="http://www.w3.org/2000/svg">\n    <symbol id="txp_svg_play" viewBox="' +
      pcViewBox +
      '">\n        <path d="M6.308 6.057S6 6.857 6 13.964c0 7.108.308 7.978.308 7.978 0 .788.827 1.299 1.526.943 0 0 1.603-.25 8.057-3.493 6.455-3.244 7.534-4.45 7.534-4.45.767-.39.767-1.493 0-1.884 0 0-1.768-1.617-7.531-4.553-5.7-2.904-8.06-3.39-8.06-3.39a1.051 1.051 0 0 0-1.526.942" fill-rule="evenodd"/>\n    </symbol>\n    <symbol id="txp_svg_replay" viewBox="' +
      pcViewBox +
      '">\n        <path d="M14 4a9.994 9.994 0 0 1 8.5 4.731V6a1 1 0 0 1 2 0v5a1 1 0 0 1-.883.993L23.5 12h-5a1 1 0 0 1 0-2h2.43a8 8 0 1 0 .816 6.01 1 1 0 0 1 1.936.5A10.003 10.003 0 0 1 14 24C8.477 24 4 19.523 4 14S8.477 4 14 4Z" fill-rule="evenodd"/>\n    </symbol>\n    <symbol id="txp_svg_pause" viewBox="' +
      pcViewBox +
      '">\n        <path d="M9 5a1.5 1.5 0 0 1 1.5 1.5v15A1.5 1.5 0 0 1 9 23h-.5A1.5 1.5 0 0 1 7 21.5v-15A1.5 1.5 0 0 1 8.5 5H9Zm10.5 0A1.5 1.5 0 0 1 21 6.5v15a1.5 1.5 0 0 1-1.5 1.5H19a1.5 1.5 0 0 1-1.5-1.5v-15A1.5 1.5 0 0 1 19 5h.5Z" fill-rule="evenodd"/>\n    </symbol>\n    <symbol id="txp_svg_stop" viewBox="' +
      pcViewBox +
      '">\n      <rect x="5" y="5" width="18" height="18" rx="4" fill-rule="evenodd"/>\n    </symbol>\n\n    <symbol id="txp_svg_fake" viewBox="' +
      pcViewBox +
      '">\n        <rect fill="none" stroke-width="1.75" transform="translate(0 3.5)" x="5.25" y="3.5" width="17.5" height="14" rx="2.042"/>\n    </symbol>\n\n    <symbol id="txp_svg_loop_off" viewBox="' +
      pcViewBox +
      '">\n        <g fill-rule="evenodd"><path d="M16.859 14.22c2.738 0 4.958 2.164 4.958 4.834 0 2.67-2.22 4.834-4.958 4.834-2.739 0-4.959-2.164-4.959-4.834 0-2.67 2.22-4.835 4.959-4.835Zm0 .966c-2.19 0-3.967 1.732-3.967 3.868s1.776 3.867 3.967 3.867c2.19 0 3.967-1.731 3.967-3.867s-1.776-3.868-3.967-3.868Zm-1.206 2.02.069.056 2.975 2.9a.475.475 0 0 1 0 .684.506.506 0 0 1-.633.056l-.068-.056-2.975-2.9a.475.475 0 0 1 0-.684.506.506 0 0 1 .632-.056ZM12.591 4.9a.69.69 0 0 1 .456.171l3.812 3.346H11.9v-.001H8.925c-1.584 0-2.88 1.208-2.97 2.731l-.005.17v3.868c0 1.545 1.239 2.808 2.8 2.896l.175.005.992-.001v1.934h-.992c-2.664 0-4.838-2.048-4.953-4.619l-.005-.215v-3.868c0-2.597 2.101-4.717 4.737-4.83l.221-.004H11.9v-.892c0-.382.31-.691.691-.691Zm7.243 1.68c2.19.433 3.856 2.274 3.961 4.512l.006.225v3.868c0 .432-.058.85-.167 1.248l-1.817-2.215v-2.9c0-1.263-.827-2.338-1.982-2.736V6.581Z" fill-rule="nonzero"/></g>\n    </symbol>\n    <symbol id="txp_svg_loop" viewBox="' +
      pcViewBox +
      '">\n        <g fill-rule="evenodd"><path d="M9 8.877a3 3 0 0 0-2.995 2.824L6 11.877v4a3 3 0 0 0 2.824 2.995l.176.005a1 1 0 1 1 0 2 5 5 0 0 1-4.995-4.783L4 15.877v-4a5 5 0 0 1 4.783-4.995L9 6.877h3V5.5a.5.5 0 0 1 .834-.372L17 8.878H9Zm11 10a3 3 0 0 0 2.995-2.823l.005-.177v-4a3 3 0 0 0-2.824-2.995L20 8.877a1 1 0 0 1 0-2 5 5 0 0 1 4.995 4.783l.005.217v4a5 5 0 0 1-4.783 4.996l-.217.004h-3v1.378a.5.5 0 0 1-.834.371L12 18.877h8Z" fill-rule="nonzero"/></g>\n    </symbol>\n\n    <symbol id="txp_svg_next" viewBox="' +
      pcViewBox +
      '">\n        <path d="M21.5 7A1.5 1.5 0 0 1 23 8.5v11a1.5 1.5 0 0 1-3 0v-11A1.5 1.5 0 0 1 21.5 7Zm-16.261.822a.817.817 0 0 1 1.186-.732s1.835.378 6.266 2.636c4.481 2.282 5.855 3.54 5.855 3.54a.825.825 0 0 1 0 1.467s-.839.936-5.857 3.46c-5.017 2.522-6.264 2.715-6.264 2.715a.817.817 0 0 1-1.186-.732S5 19.498 5 13.97v-.326c.01-5.226.239-5.823.239-5.823Z" fill-rule="evenodd"/>\n    </symbol>\n\n    <symbol id="txp_svg_fullscreen" viewBox="' +
      pcViewBox +
      '">   \n        <path d="M7.438 17.063v2.625c0 .483.391.875.875.875h2.624m0-13.125H8.312a.875.875 0 0 0-.875.875v2.624h0m13.126 6.126v2.625a.875.875 0 0 1-.875.875h-2.625 0m0-13.125h2.625c.483 0 .875.391.875.874v2.625h0" stroke-width="2.188" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/>\n    </symbol>\n    <symbol id="txp_svg_fullscreen_true" viewBox="' +
      pcViewBox +
      '">\n        <g stroke-width="2.188" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M10.938 20.563v-2.625a.875.875 0 0 0-.875-.875H7.438h0M7.438 10.938h2.625a.875.875 0 0 0 .874-.876V7.438h0M17.063 20.562v-2.625c0-.483.391-.875.875-.875h2.625M20.563 10.938h-2.625a.875.875 0 0 1-.875-.876V7.438h0"/></g>\n    </symbol>\n\n    <symbol id="txp_svg_volume_mute" viewBox="' +
      pcViewBox +
      '">\n        <g stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M8.75 10.041H5.749c-.828 0-1.499.671-1.499 1.499v4.92c0 .828.671 1.499 1.499 1.499H8.75l4.143 4.143a.502.502 0 0 0 .857-.355V6.253a.502.502 0 0 0-.857-.355L8.75 10.041ZM17.5 11l6 6M23.5 11l-6 6"/></g>\n    </symbol>\n    <symbol id="txp_svg_volume" viewBox="' +
      pcViewBox +
      '">\n        <g stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M8.75 10.041H5.749c-.828 0-1.499.671-1.499 1.499v4.92c0 .828.671 1.499 1.499 1.499H8.75l4.143 4.143a.502.502 0 0 0 .857-.355V6.253a.502.502 0 0 0-.857-.355L8.75 10.041ZM20.786 7a9.717 9.717 0 0 1 2.964 7 9.717 9.717 0 0 1-2.964 7M17.75 9.477c1.235 1.154 2 2.753 2 4.522 0 1.746-.747 3.328-1.955 4.478"/></g>\n    </symbol>\n\n    <symbol id="txp_svg_pip" viewBox="' +
      pcViewBox +
      '">\n        <path d="M23.625 15.75c.966 0 1.75.784 1.75 1.75v4.375a1.75 1.75 0 0 1-1.75 1.75H17.5a1.75 1.75 0 0 1-1.75-1.75V17.5c0-.966.784-1.75 1.75-1.75h6.125ZM21 5.25a2.625 2.625 0 0 1 2.62 2.47l.005.155v5.25a.875.875 0 0 1-1.744.102l-.006-.102v-5.25a.875.875 0 0 0-.773-.87L21 7H7a.875.875 0 0 0-.87.773l-.005.102V19.25c0 .449.338.819.773.87l.102.005h6.125a.875.875 0 0 1 .102 1.744l-.102.006H7a2.625 2.625 0 0 1-2.62-2.47l-.005-.155V7.875a2.625 2.625 0 0 1 2.47-2.62L7 5.25h14Z" stroke-width=".5" fill-rule="evenodd"/>\n    </symbol>\n\n    <symbol id="txp_air_play" viewBox="0 0 1024 1024">\n        <path d="M547.413333 573.866667a42.666667 42.666667 0 0 0-70.826666 0l-170.666667 256a42.666667 42.666667 0 0 0 0 42.666666A42.666667 42.666667 0 0 0 341.333333 896h341.333334a42.666667 42.666667 0 0 0 37.546666-22.613333 42.666667 42.666667 0 0 0-2.133333-42.666667zM421.12 810.666667L512 674.133333l90.88 136.533334zM810.666667 128H213.333333a128 128 0 0 0-128 128v384a128 128 0 0 0 128 128h36.266667a42.666667 42.666667 0 1 0 0-85.333333H213.333333a42.666667 42.666667 0 0 1-42.666666-42.666667V256a42.666667 42.666667 0 0 1 42.666666-42.666667h597.333334a42.666667 42.666667 0 0 1 42.666666 42.666667v384a42.666667 42.666667 0 0 1-42.666666 42.666667h-36.266667a42.666667 42.666667 0 0 0 0 85.333333H810.666667a128 128 0 0 0 128-128V256a128 128 0 0 0-128-128z"/>\n    </symbol>\n    <symbol id="txp_close_btn" viewBox="0 0 24 24">\n        <path d="M6.5 6.5L17.5 17.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n        <path d="M6.5 17.5L17.5 6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n    </symbol>\n</svg>\n',
    h5SvgSprite =
      '\n<svg class="' +
      THUMBPLAYER_PREFIX +
      " " +
      svgSpriteClassName +
      '" display="none" xmlns="http://www.w3.org/2000/svg">\n\t<symbol id="txp_svg_play" viewBox="0 0 56 56">\n\t\t<path d="M14.569 13.867s-.563 1.42-.563 14.059.563 14.188.563 14.188a1.925 1.925 0 0 0 2.8 1.677s2.938-.442 14.763-6.211 13.8-7.914 13.8-7.914a1.859 1.859 0 0 0 0-3.352s-3.24-2.875-13.8-8.095c-10.444-5.165-14.767-6.029-14.767-6.029a1.924 1.924 0 0 0-2.796 1.677z" style="fill:#fff" />\n\t</symbol>\n    <symbol id="txp_svg_replay" viewBox="0 0 32 32">\n      <path d="M18 30a13.956 13.956 0 0 1-9.9-4.1l2.121-2.121A11 11 0 1 0 7 16h4.006L5.5 22 0 16h4a14 14 0 1 1 14 14z">\n      </path>\n    </symbol>\n    <symbol id="txp_svg_pause" viewBox="0 0 56 56">\n      <path d="M39 49a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4 4 4 0 0 1 4 4v34a4 4 0 0 1-4 4zm-22 0a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4 4 4 0 0 1 4 4v34a4 4 0 0 1-4 4z">\n      </path>\n    </symbol>\n    <symbol id="txp_svg_stop" viewBox="0 0 32 32">\n      <path d="M24 26H12c-1.1 0-2-0.9-2-2V12c0-1.1 0.9-2 2-2h12c1.1 0 2 0.9 2 2v12C26 25.1 25.1 26 24 26z"></path>\n    </symbol>\n\n\t<symbol id="txp_svg_fullscreen" viewBox="0 0 48 48">\n\t\t<path d="M9.5 37h10a1.5 1.5 0 0 1 0 3h-10a1.5 1.5 0 0 1 0-3zm0-10a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-3 0v-10A1.5 1.5 0 0 1 9.5 27zM8.43 37.353L19.353 26.43a1.545 1.545 0 1 1 2.185 2.184L10.614 39.538a1.545 1.545 0 1 1-2.184-2.185zM28.5 8h10a1.5 1.5 0 0 1 0 3h-10a1.5 1.5 0 0 1 0-3zm10 0A1.5 1.5 0 0 1 40 9.5v10a1.5 1.5 0 0 1-3 0v-10A1.5 1.5 0 0 1 38.5 8zM26.43 19.354L37.353 8.43a1.545 1.545 0 0 1 2.185 2.184L28.614 21.538a1.545 1.545 0 0 1-2.184-2.184z"/>\n\t</symbol>\n\t<symbol id="txp_svg_fullscreen_true" viewBox="0 0 48 48">\n\t\t<path d="M39.538 10.615L31.153 19H37.5a1.5 1.5 0 0 1 0 3h-10a1.5 1.5 0 0 1-1.386-.937 1.52 1.52 0 0 1-.114-.735V10.5a1.5 1.5 0 0 1 3 0v6.283l8.353-8.353a1.545 1.545 0 1 1 2.185 2.185zM20.5 39a1.5 1.5 0 0 1-1.5-1.5v-6.347l-8.386 8.385a1.545 1.545 0 1 1-2.184-2.184L16.783 29H10.5a1.5 1.5 0 0 1 0-3h9.828a1.518 1.518 0 0 1 .733.113A1.5 1.5 0 0 1 22 27.5v10a1.5 1.5 0 0 1-1.5 1.5z"/>\n\t</symbol>\n\t<symbol id="txp_svg_pause" viewBox="0 0 56 56">\n\t\t<path d="M39 49a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4 4 4 0 0 1 4 4v34a4 4 0 0 1-4 4zm-22 0a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4 4 4 0 0 1 4 4v34a4 4 0 0 1-4 4z"/>\n\t</symbol>\n\t<symbol id="txp_svg_replay" viewBox="0 0 32 32">\n\t\t<path d="M18 30a13.956 13.956 0 0 1-9.9-4.1l2.121-2.121A11 11 0 1 0 7 16h4.006L5.5 22 0 16h4a14 14 0 1 1 14 14z"/>\n\t</symbol>\n\t<symbol id="txp_svg_next" viewBox="0 0 60 60">\n\t\t<path d="M47.13825,15.0141429 C45.3628929,15.0141429 43.9239643,16.4530714 43.9239643,18.2284286 L43.9239643,41.7998571 C43.9239643,43.5752143 45.3628929,45.0141429 47.13825,45.0141429 C48.9136071,45.0141429 50.3525357,43.5752143 50.3525357,41.7998571 L50.3525357,18.2284286 C50.3525357,16.4530714 48.9136071,15.0141429 47.13825,15.0141429 M39.7389643,28.4327143 C39.7389643,28.4327143 36.7936071,25.737 27.1946786,20.8437857 C17.6986071,16.002 13.7686071,15.192 13.7686071,15.192 C12.6050357,14.5995 11.2261071,15.4502143 11.2261071,16.7637857 C11.2261071,16.7637857 10.7139643,18.0955714 10.7139643,29.9455714 C10.7139643,41.7945 11.2261071,43.2462857 11.2261071,43.2462857 C11.2261071,44.5598571 12.6050357,45.4116429 13.7686071,44.8180714 C13.7686071,44.8180714 16.4396786,44.4034286 27.1893214,38.9948571 C37.9411071,33.5852143 39.7389643,31.5762857 39.7389643,31.5762857 C41.0171786,30.9248571 41.0171786,29.0852143 39.7389643,28.4327143" id="Fill-1"></path>\n\t</symbol>\n    <symbol id="txp_air_play" viewBox="0 0 1024 1024">\n        <path d="M547.413333 573.866667a42.666667 42.666667 0 0 0-70.826666 0l-170.666667 256a42.666667 42.666667 0 0 0 0 42.666666A42.666667 42.666667 0 0 0 341.333333 896h341.333334a42.666667 42.666667 0 0 0 37.546666-22.613333 42.666667 42.666667 0 0 0-2.133333-42.666667zM421.12 810.666667L512 674.133333l90.88 136.533334zM810.666667 128H213.333333a128 128 0 0 0-128 128v384a128 128 0 0 0 128 128h36.266667a42.666667 42.666667 0 1 0 0-85.333333H213.333333a42.666667 42.666667 0 0 1-42.666666-42.666667V256a42.666667 42.666667 0 0 1 42.666666-42.666667h597.333334a42.666667 42.666667 0 0 1 42.666666 42.666667v384a42.666667 42.666667 0 0 1-42.666666 42.666667h-36.266667a42.666667 42.666667 0 0 0 0 85.333333H810.666667a128 128 0 0 0 128-128V256a128 128 0 0 0-128-128z"/>\n    </symbol>\n</svg>\n',
    getDomText = function (e) {
      return (
        '\n<div class="' +
        gradientClassName.slice(1) +
        '"></div>\n<div class="' +
        getRootClassName(e).slice(1) +
        '">\n    <div class="' +
        THUMBPLAYER_PREFIX +
        " " +
        ctrlBarClassName +
        '">\n        <div class="txp_left_controls">\n            <div class="txp_none txp_btn txp_btn_play" data-status="play" aria-label="鎾斁/鏆傚仠">\n                <svg class="txp_icon txp_icon_play" viewBox="' +
        pcViewBox +
        '">\n                    <use class="txp_svg_symbol txp_svg_play" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_play"></use>\n                    <use class="txp_svg_symbol txp_svg_pause" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_pause"></use>\n                    <use class="txp_svg_symbol txp_svg_stop" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_stop"></use>\n                    <use class="txp_svg_symbol txp_svg_replay" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_replay"></use>\n                </svg>\n                <div class="txp_tooltip">鎾斁</div>\n            </div>\n            <div class="txp_none txp_btn txp_btn_next txp_disabled" aria-label="涓嬩竴涓�">\n                <svg class="txp_icon txp_icon_next" viewBox="' +
        pcViewBox +
        '">\n                    <use class="txp_svg_symbol txp_svg_next" xlink:href="#txp_svg_next"></use>\n                </svg>\n                <div class="txp_tooltip">涓嬩竴涓�</div>\n            </div>\n            <div class="txp_btn txp_btn_loop txp_none" data-status="false" aria-label="寰幆鎾斁">   \n                <svg data-role="txp-ui-control-loop-play-btn" class="txp_icon txp_icon_loop" viewBox="' +
        pcViewBox +
        '">\n                    <use class="txp_svg_symbol txp_svg_loop" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_loop"></use>\n                    <use class="txp_svg_symbol txp_svg_loop_off" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_loop_off"></use>\n                </svg>\n                <div class="txp_tooltip">鎵撳紑寰幆鎾斁</div> \n            </div>\n\n\n            <div class="txp_none txp_time_display">\n                <div class="txp_time_current">00:00</div>\n                <div class="txp_time_separator">/</div>\n                <div class="txp_time_duration">00:00</div>\n            </div>\n        </div>\n\n        <div class="txp_none txp_progress_bar_container">\n            <div class="txp_progress_list">\n                <div class="txp_progress_load" style="width: 0;"></div>\n                <div class="txp_progress_play" style="width: 0;">\n                </div>\n                <div class="txp_btn_scrubber" style="left: 0">\n                    <div class="txp_scrubber_indicator"></div>\n                </div>\n            </div>\n            <div class="txp_tooltip txp_none"></div>\n            \x3c!-- 杩涘害鏉℃爣璁版墦鐐� --\x3e\n            <div class="txp_hotpoint"></div> \n        </div>\n\n        <div class="txp_center_controls"></div>\n\n        <div class="txp_right_controls">\n            <div class="txp_btn txp_btn_definition txp_none" aria-label="娓呮櫚搴�">\n                <div class="txp_label">娓呮櫚搴�</div>\n                <div class="txp_popup txp_popup_definition txp_none">\n                    <div class="txp_popup_content"></div>\n                </div>\n            </div>\n\n            <div class="txp_btn txp_btn_playrate txp_none" aria-label="鍊嶉€�">\n                <div class="txp_label">鍊嶉€�</div>\n                <div class="txp_popup txp_popup_playrate txp_none">\n                    <div class="txp_popup_content"></div>\n                </div>\n            </div>\n\n            <div class="txp_btn txp_btn_language txp_none" aria-label="璇█">\n                <div class="txp_label">璇█</div>\n                <div class="txp_popup txp_popup_language txp_none">\n                    <div class="txp_popup_content"></div>\n                </div>\n            </div>\n\n            <div class="txp_btn txp_btn_audio_track txp_none" aria-label="澶氶煶杞�">\n                <div class="txp_label">澶氶煶杞�</div>\n                <div class="txp_popup txp_popup_audio_track txp_none">\n                    <div class="txp_popup_content"></div>\n                </div>\n            </div>\n            \n            <div class="txp_btn txp_btn_airplay txp_none" aria-label="AirPlay">\n                <svg class="txp_icon txp_icon_airplay" viewBox="0 0 1024 1024">\n                    <use class="txp_svg_symbol" xlink:href="#txp_air_play"></use>\n                </svg>\n                <div class="txp_tooltip">AirPlay</div> \n            </div>\n\n            <div class="txp_btn_group">\n                <div class="txp_btn txp_btn_volume txp_none" data-status="normal" aria-label="闊抽噺">     \n                    <svg class="txp_icon txp_icon_volume" viewBox="' +
        pcViewBox +
        '">         \n                        <use class="txp_svg_symbol txp_svg_volume" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_volume"></use> \n                        <use class="txp_svg_symbol txp_svg_volume_mute" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_volume_mute"></use>     \n                    </svg>\n                    <div class="txp_popup txp_popup_volume txp_none">\n                        <div class="txp_popup_content">             \n                            <div class="txp_volume_text">100</div>     \n                            <div class="txp_volume_range">                 \n                                <div class="txp_volume_range_current" style="height: 100%;">                     \n                                    <div class="txp_volume_handle"></div>                 \n                                </div>             \n                            </div>\n                        </div>\n                    </div>\n                </div>  \n                <div class="txp_popup txp_popup_mute_tips txp_none">\n                    <div class="txp_popup_content">\n                        <div class="txp_text">\n                            闈欓煶鎾斁涓紝鐐瑰嚮\n                            <a class="txp_text_btn txp_btn_unmuted">鎭㈠闊抽噺</a>\n                        </div>\n                        <svg class="txp_tips_close_btn" viewBox="0 0 24 24">\n                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_close_btn"></use> \n                        </svg>\n                    </div>\n                </div>\n            </div>\n\n            <div class="txp_btn txp_btn_pip txp_none" data-status="false" aria-label="鐢讳腑鐢�">   \n                <svg class="txp_icon txp_icon_pip" viewBox="' +
        pcViewBox +
        '">     \n                    <use class="txp_svg_symbol txp_svg_pip" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_pip"></use>   \n                </svg>  \n                <div class="txp_tooltip">鐢讳腑鐢�</div> \n            </div>\n\n            <div class="txp_btn txp_btn_fake txp_none" data-status="false" aria-label="缃戦〉鍏ㄥ睆">   \n                <svg class="txp_icon txp_icon_fake" viewBox="' +
        pcViewBox +
        '">     \n                    <use class="txp_svg_symbol txp_svg_fake" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_fake"></use>   \n                    <use class="txp_svg_symbol txp_svg_fake_true" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_fake"></use>  \n                </svg>  \n                <div class="txp_tooltip">缃戦〉鍏ㄥ睆</div> \n            </div>\n\n            <div class="txp_btn txp_btn_fullscreen txp_none" data-status="false" aria-label="绯荤粺鍏ㄥ睆">\n                <svg class="txp_icon txp_icon_fullscreen" viewBox="' +
        pcViewBox +
        '">     \n                    <use class="txp_svg_symbol txp_svg_fullscreen" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_fullscreen"></use>     \n                    <use class="txp_svg_symbol txp_svg_fullscreen_true" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#txp_svg_fullscreen_true"></use>   \n                </svg>\n                <div class="txp_tooltip">鍏ㄥ睆</div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class="' +
        shadowClassName.slice(1) +
        '"></div>\n'
      );
    },
    h5CtrlRightDomText =
      '\n<button class="txp_btn txp_btn_playrate txp_none" aria-label="鍊嶉€�">\n    <div class="txp_label">鍊嶉€�</div>\n</button>\n<button class="txp_btn txp_btn_definition txp_none" data-status="false" aria-label="娓呮櫚搴�">\n    <div class="txp_label">娓呮櫚搴�</div>\n</button>\n<button class="txp_btn txp_btn_airplay txp_none" data-status="false" aria-label="AirPlay">\n    <svg class="txp_icon txp_icon_airplay" viewBox="0 0 1024 1024">\n        <use class="txp_svg_symbol" xlink:href="#txp_air_play"></use>\n    </svg>\n</button>\n<button class="txp_btn txp_btn_fullscreen txp_none" data-status="false" aria-label="鍏ㄥ睆">\n    <svg class="txp_icon txp_icon_fullscreen" viewBox="0 0 24 24">\n        <use class="txp_svg_fullscreen" xlink:href="#txp_svg_fullscreen"></use>     \n        <use class="txp_svg_fullscreen_true" xlink:href="#txp_svg_fullscreen_true"></use>   \n    </svg>\n</button>\n<button class="txp_btn txp_btn_fullscreen txp_none txp_btn_fake" data-status="false" aria-label="浼叏灞�">\n    <svg class="txp_icon txp_icon_fullscreen" viewBox="0 0 24 24">\n        <use class="txp_svg_fullscreen" xlink:href="#txp_svg_fullscreen"></use>     \n        <use class="txp_svg_fullscreen_true" xlink:href="#txp_svg_fullscreen_true"></use>   \n    </svg>\n</button>\n',
    h5OverlayText =
      '<div class="plugin_ctrl_mod_overlay_wrapper">\n<div class="mod_overlay definition txp_none">\n    <div class="mod_speed_select">\n        <div class="title">鐢昏川</div>\n        <ul class="select_list"></ul>\n    </div>\n</div>\n<div class="mod_overlay language txp_none">\n    <div class="mod_speed_select">\n        <div class="title">璇█</div>\n        <ul class="select_list"></ul>\n    </div>\n</div>\n<div class="mod_overlay playrate txp_none">\n    <div class="mod_speed_select">\n        <div class="title">鎾斁閫熷害</div>\n        <ul class="select_list"></ul>\n    </div>\n</div>\n</div>\n',
    DEFAULT_AUTO_HIDE_DELAY = 3e3,
    CtrlShow = (function (e) {
      function t(t, o, A) {
        var i,
          r = e.call(this, t, getRootClassName(o.isMobile), o) || this;
        (r.ctrlbar = A),
          (r.isMouseHoverControl = !1),
          (r.isMouseDown = !1),
          (r.shadowClickDisabled = !1),
          (r.onShadowClick = function (e) {
            if (
              e.target === r.shadow &&
              (r.clearClickTimer(), !r.shadowClickDisabled)
            ) {
              r.clickTimer = window.setTimeout(function () {
                var e = r.player;
                e.state === exports.VIDEO_STATE.PLAYING
                  ? e.pause(exports.H5_PAUSE_TYPE.USER_CLICK)
                  : onBtnClickPlay(e, r.ctrlbar);
              }, 300);
            }
          }),
          (r.clearClickTimer = function () {
            r.clickTimer && (clearTimeout(r.clickTimer), (r.clickTimer = null));
          }),
          (r.clearHideTimer = function () {
            r.hideTid && (clearTimeout(r.hideTid), (r.hideTid = null));
          }),
          (r.clearTouchTimer = function () {
            r.touchTid && (clearTimeout(r.touchTid), (r.touchTid = null));
          }),
          (r.hideDelay = o.autoHideDelay || DEFAULT_AUTO_HIDE_DELAY),
          (r.show = r.show.bind(r)),
          (r.hide = r.hide.bind(r)),
          (r.onFullscreenChange = r.onFullscreenChange.bind(r)),
          (r.eventMap =
            (((i = {})[exports.PLAY_EVENT.STATE_CHANGE] =
              r.onPlayerStateChange.bind(r)),
            (i[exports.PLAY_EVENT.VIDEONODE_START_PLAY] =
              r.onStartPlay.bind(r)),
            i)),
          r.setEvts(),
          (r.control = t.container.querySelector(ctrlBarSelector)),
          (r.shadow = t.container.querySelector(shadowClassName)),
          (r.gradientBottom = t.container.querySelector(gradientClassName)),
          A.on(CTRL_EVENTS$1.FULLSCREEN_CHANGE, r.onFullscreenChange),
          A.on(CTRL_EVENTS$1.FAKE_FULLSCREEN_CHANGE, r.onFullscreenChange);
        var n = o.showCtrlShadow;
        return (
          void 0 === n || n || (r.shadow.remove(), (r.shadow = null)),
          r.addEventListener(),
          r.isMobile && r.toggleControlOnClick(),
          r
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "isShow", {
          get: function () {
            return !this.el.classList.contains(Component.hideClassName);
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.show = function () {
          this.autoHide(),
            this.isShow ||
              (this.showEl(),
              this.showEl(this.gradientBottom),
              this.ctrlbar.emit(CTRL_EVENTS$1.SHOW));
        }),
        (t.prototype.hide = function (e) {
          this.isShow &&
            (e ||
              (!this.isMouseHoverControl &&
                this.player.state !== exports.VIDEO_STATE.PAUSE)) &&
            (this.hideEl(),
            this.hideEl(this.gradientBottom),
            this.ctrlbar.emit(CTRL_EVENTS$1.HIDE));
        }),
        (t.prototype.autohide = function () {
          this.autoHide();
        }),
        (t.prototype.autoHide = function () {
          this.clearHideTimer(),
            this.hideDelay !== 1 / 0 &&
              (this.hideTid = window.setTimeout(this.hide, this.hideDelay));
        }),
        (t.prototype.destroy = function () {
          this.clearHideTimer(),
            this.clearClickTimer(),
            this.clearTouchTimer(),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.toggleShadowClickDisabled = function (e) {
          this.shadowClickDisabled = e;
        }),
        (t.prototype.addEventListener = function () {
          var e = this,
            t = this,
            o = t.ctrlbar,
            A = t.player,
            i = t.shadow,
            r = A.container;
          this.isMobile
            ? (o.on(CTRL_EVENTS$1.TOGGLE_OVERLAY, function (t) {
                var o = t.data;
                (e.isMouseHoverControl = o), o || e.autoHide();
              }),
              o.on(CTRL_EVENTS$1.MOUSE_DOWN, function () {
                return (e.isMouseHoverControl = !0);
              }),
              o.on(CTRL_EVENTS$1.MOUSE_UP, function () {
                e.autoHide(), (e.isMouseHoverControl = !1);
              }))
            : (this.control.addEventListener("mouseenter", function () {
                return (e.isMouseHoverControl = !0);
              }),
              this.control.addEventListener("mouseleave", function () {
                return (e.isMouseHoverControl = !1);
              }),
              o.on(CTRL_EVENTS$1.MOUSE_DOWN, function () {
                return (e.isMouseDown = !0);
              }),
              o.on(CTRL_EVENTS$1.MOUSE_UP, function () {
                return (e.isMouseDown = !1);
              }),
              r.addEventListener("mouseenter", this.show),
              r.addEventListener("mousemove", this.show),
              r.addEventListener("mouseleave", function () {
                e.isMouseDown || e.hide();
              }),
              !this.isLive &&
                i &&
                (i.addEventListener("click", this.onShadowClick),
                i.addEventListener("dblclick", this.clearClickTimer)));
        }),
        (t.prototype.toggleControlOnClick = function () {
          var e,
            t = this;
          null === (e = this.shadow) ||
            void 0 === e ||
            e.addEventListener("click", function () {
              t.isShow ? t.hide() : t.show();
            });
        }),
        (t.prototype.onFullscreenChange = function () {
          (this.isMouseHoverControl = !1), this.hide();
        }),
        (t.prototype.onPlayerStateChange = function (e) {
          var t = e.data.new;
          -1 !==
          [
            exports.VIDEO_STATE.PAUSE,
            exports.VIDEO_STATE.END,
            exports.VIDEO_STATE.IDLE,
          ].indexOf(t)
            ? this.show()
            : t === exports.VIDEO_STATE.PLAYING && this.autoHide();
        }),
        (t.prototype.onStartPlay = function () {
          this.autoHide();
        }),
        (t.compName = "CtrlShow"),
        t
      );
    })(Component),
    HotKeyCode;
  !(function (e) {
    (e.ArrowLeft = "ArrowLeft"),
      (e.ArrowRight = "ArrowRight"),
      (e.ArrowUp = "ArrowUp"),
      (e.ArrowDown = "ArrowDown"),
      (e.Space = " "),
      (e.Escape = "Escape"),
      (e.LEFT_SQUARE_BRACKET = "["),
      (e.LEFT_SQUARE_BRACKET_CN = "銆�"),
      (e.RIGHT_SQUARE_BRACKET = "]"),
      (e.RIGHT_SQUARE_BRACKET_CN = "銆�");
  })(HotKeyCode || (HotKeyCode = {}));
  var defaultSeekGap = 5,
    defaultBackwardGap = 2,
    defaultActivePressTime = 0.5,
    defaultBackwardTimeout = 500,
    liveHotKeys = [HotKeyCode.ArrowUp, HotKeyCode.ArrowDown, HotKeyCode.Escape],
    volumeGap = 0.05,
    HotKeys = (function () {
      function e(e, t, o) {
        var A,
          i = this;
        (this.player = e),
          (this.config = t),
          (this.comps = o),
          (this.isDisabled = !1),
          (this.spyKeyUpOnBody = function (e) {
            i.isEvtKeyInConfig(e) && i.spyKeyUp(e);
          }),
          (this.spyKeyDownOnBody = function (e) {
            i.isEvtKeyInConfig(e) && i.spyKeyDown(e);
          }),
          (this.fastBackwardHandler = function () {
            var e = i.player,
              t = e.duration;
            i.backwardPlaytime = e.playtime;
            var o = function () {
              (i.backwardPlaytime = Math.max(
                0,
                i.backwardPlaytime - defaultBackwardGap
              )),
                i.comps.progress.updateProgress(i.backwardPlaytime / t),
                e.seek(i.backwardPlaytime),
                showTips(
                  e,
                  "蹇€€鑷� " + commonTool$1.formatPlayTime(i.backwardPlaytime)
                );
            };
            (i.backwardTimer = setInterval(o, defaultBackwardTimeout)), o();
          }),
          (this.fastForwardHandler = function () {
            var e = i.config.pressFastForwardRate,
              t = void 0 === e ? 3 : e,
              o = i.comps.playRate,
              A = (o || {}).selected;
            if (A && !(t <= A)) {
              var r = { label: t + "X", value: t };
              i.player.play(),
                (i.lastPlaybackRate = o.selected),
                (i.player.playbackRate = t),
                showTips(
                  i.player,
                  "姝ｅ湪 <em>" + r.value + "</em> 鍊嶆挱鏀句腑"
                ),
                setTimeout(function () {
                  o.setCurrent(r);
                }, 0);
            }
          }),
          (this.spyKeyUp = this.spyKeyUp.bind(this)),
          (this.spyKeyDown = this.spyKeyDown.bind(this));
        var r = e.container;
        uaTool$1.mobile || (r.tabIndex = -1),
          r.addEventListener("keyup", this.spyKeyUp),
          r.addEventListener("keydown", this.spyKeyDown),
          (null === (A = this.config.keysListenedOnBody) || void 0 === A
            ? void 0
            : A.length) &&
            (document.body.addEventListener("keyup", this.spyKeyUpOnBody),
            document.body.addEventListener("keydown", this.spyKeyDownOnBody));
      }
      return (
        (e.prototype.destroy = function () {
          var e;
          if (this.player) {
            var t = this.player.container;
            this.cancelPressState(!0),
              t.removeEventListener("keyup", this.spyKeyUp),
              t.removeEventListener("keydown", this.spyKeyDown),
              (null === (e = this.config.keysListenedOnBody) || void 0 === e
                ? void 0
                : e.length) &&
                (document.body.removeEventListener(
                  "keyup",
                  this.spyKeyUpOnBody
                ),
                document.body.removeEventListener(
                  "keydown",
                  this.spyKeyDownOnBody
                )),
              (this.player = null);
          }
        }),
        (e.prototype.isEvtKeyInConfig = function (e) {
          return (
            this.config.keysListenedOnBody.includes(e.key) &&
            e.target === document.body
          );
        }),
        (e.prototype.prevent = function (e) {
          var t, o;
          null === (t = e.preventDefault) || void 0 === t || t.call(e),
            null === (o = e.stopPropagation) || void 0 === o || o.call(e);
        }),
        (e.prototype.spyKeyUp = function (e) {
          var t;
          if (!e.shiftKey && !this.isDisabled) {
            var o = e.key,
              A = this.player,
              i = A.state,
              r = this.config.seekGap,
              n = void 0 === r ? defaultSeekGap : r;
            if (this.pressKey) o === this.pressKey && this.cancelPressState();
            else if (!this.isLive() || liveHotKeys.includes(o))
              switch (o) {
                case HotKeyCode.ArrowLeft:
                  A.setStateKv("ctrlbar:hotkey:" + o, {
                    type: exports.LOG_TYPE.USER_ACTION,
                  }),
                    A.seek(A.playtime - n),
                    this.prevent(e),
                    this.showSeekLeftTips();
                  break;
                case HotKeyCode.ArrowRight:
                  A.setStateKv("ctrlbar:hotkey:" + o, {
                    type: exports.LOG_TYPE.USER_ACTION,
                  }),
                    A.seek(A.playtime + n),
                    this.prevent(e),
                    this.showSeekRightTips();
                  break;
                case HotKeyCode.Space:
                  A.setStateKv("ctrlbar:hotkey:space", {
                    type: exports.LOG_TYPE.USER_ACTION,
                  }),
                    i === exports.VIDEO_STATE.PLAYING ||
                    i === exports.VIDEO_STATE.BUFFERING
                      ? A.pause(exports.H5_PAUSE_TYPE.USER_CLICK)
                      : A.play(),
                    this.prevent(e);
                  break;
                case HotKeyCode.Escape:
                  (null === (t = this.comps.fakeFullscreen) || void 0 === t
                    ? void 0
                    : t.isFullScreen) &&
                    (this.comps.fakeFullscreen.requestFullScreen("exit"),
                    this.prevent(e));
                  break;
                case HotKeyCode.LEFT_SQUARE_BRACKET:
                case HotKeyCode.LEFT_SQUARE_BRACKET_CN:
                  this.setNextPlayBackRate(!0), this.prevent(e);
                  break;
                case HotKeyCode.RIGHT_SQUARE_BRACKET:
                case HotKeyCode.RIGHT_SQUARE_BRACKET_CN:
                  this.setNextPlayBackRate(!1), this.prevent(e);
              }
          }
        }),
        (e.prototype.setNextPlayBackRate = function (e) {
          void 0 === e && (e = !1);
          var t = this.comps.playRate,
            o = t.popupOptions,
            A = t.selected,
            i = o.findIndex(function (e) {
              return e.value === A;
            });
          if (-1 !== i && !((e && 0 === i) || (!e && i === o.length - 1))) {
            var r = Number(o[e ? i - 1 : i + 1].value);
            (this.player.playbackRate = r),
              showTips(
                this.player,
                "姝ｅ湪 <em>" + r + "</em> 鍊嶉€熸挱鏀句腑"
              );
          }
        }),
        (e.prototype.enterPressMode = function (e) {
          var t = this;
          if (!this.pressKey) {
            var o = this.config,
              A = o.pressFastBackwardGap,
              i = void 0 === A ? defaultActivePressTime : A,
              r = o.pressFastForwardGap,
              n = e ? (void 0 === r ? defaultActivePressTime : r) : i,
              a = e ? this.fastForwardHandler : this.fastBackwardHandler;
            n &&
              (clearTimeout(this.pressTimer),
              (this.pressTimer = setTimeout(function () {
                var e = t.player.state;
                [
                  exports.VIDEO_STATE.PAUSE,
                  exports.VIDEO_STATE.PLAYING,
                ].includes(e) && a();
              }, 1e3 * n)));
          }
        }),
        (e.prototype.cancelPressState = function (e) {
          void 0 === e && (e = !1);
          var t = this.comps.playRate;
          t &&
            this.lastPlaybackRate &&
            ((t.selected = this.lastPlaybackRate),
            e || (this.player.playbackRate = this.lastPlaybackRate)),
            hideTips(this.player),
            (this.lastPlaybackRate = NaN),
            (this.pressKey = null),
            (this.backwardPlaytime = NaN),
            (this.pressKey = null),
            clearTimeout(this.backwardTimer),
            clearTimeout(this.pressTimer);
        }),
        (e.prototype.spyKeyDown = function (e) {
          if (e.shiftKey || this.isDisabled || this.pressKey) this.prevent(e);
          else {
            var t = e.key,
              o = e.repeat,
              A = this.player;
            if (!this.isLive() || liveHotKeys.includes(t))
              switch (t) {
                case HotKeyCode.ArrowUp:
                  (A.volume = this.volumeToFixedNumber(A.volume + volumeGap)),
                    this.prevent(e),
                    this.showVolumeTips();
                  break;
                case HotKeyCode.ArrowDown:
                  (A.volume = this.volumeToFixedNumber(A.volume - volumeGap)),
                    this.prevent(e),
                    this.showVolumeTips();
                  break;
                case HotKeyCode.Space:
                  this.prevent(e);
                  break;
                case HotKeyCode.ArrowLeft:
                case HotKeyCode.ArrowRight:
                  this.prevent(e),
                    o &&
                      (this.enterPressMode(t === HotKeyCode.ArrowRight),
                      (this.pressKey = t));
              }
          }
        }),
        (e.prototype.isLive = function () {
          return this.config.mode === exports.PLAY_MODE.LIVE;
        }),
        (e.prototype.volumeToFixedNumber = function (e) {
          var t = Math.max(Math.min(e, 1), 0);
          return (
            (t = Number(t.toFixed(2))), lsTool.setData(LOCAL_KEY.VOLUME, t), t
          );
        }),
        (e.prototype.showSeekLeftTips = function () {
          if (this.player.state !== exports.VIDEO_STATE.IDLE) {
            var e = this.config.seekGap,
              t = void 0 === e ? defaultSeekGap : e,
              o = Math.max(0, this.player.playtime - t);
            showTips(this.player, "蹇€€鑷� " + commonTool$1.formatPlayTime(o));
          }
        }),
        (e.prototype.showSeekRightTips = function () {
          if (this.player.state !== exports.VIDEO_STATE.IDLE) {
            var e = this.player,
              t = e.playtime,
              o = e.duration,
              A = this.config.seekGap,
              i = void 0 === A ? defaultSeekGap : A,
              r = Math.min(t + i, o);
            showTips(this.player, "蹇繘鑷� " + commonTool$1.formatPlayTime(r));
          }
        }),
        (e.prototype.showVolumeTips = function () {
          var e;
          (null === (e = this.comps.volume) || void 0 === e
            ? void 0
            : e.popup.classList.contains(Component.hideClassName)) &&
            showTips(
              this.player,
              "褰撳墠闊抽噺: <em>" +
                (100 * this.player.volume).toFixed(0) +
                "</em>"
            );
        }),
        (e.compName = "HotKeys"),
        e
      );
    })(),
    componentMap = {
      PlayBtn: PlayBtn,
      NextBtn: NextBtn,
      TimeArea: TimeArea,
      Progress: Progress,
      Fullscreen: Fullscreen,
      FakeFullscreen: FakeFullscreen,
      Volume: Volume,
      CtrlShow: CtrlShow,
      HotPoint: HotPoint,
      Loop: Loop,
      PictureInPicture: PictureInPicture,
      LiveProgress: LiveProgress,
      CenterBtn: CenterBtn,
      DefinitionPopup: DefinitionPopup,
      PlayratePopup: PlayratePopup,
      LanguagePopup: LanguagePopup,
      AudioTrackPopup: AudioTrackPopup,
      MuteTips: MuteTips,
    },
    CtrlbarPlugin = (function (e) {
      function t(t, o, A) {
        var i,
          r,
          n,
          a,
          s,
          g,
          l = e.call(this, t, o, A) || this;
        (l.instances = {}),
          (l.isInRequest = !1),
          (l.hasCustomPlayBackRate = !1),
          (l.config = __assign$1(__assign$1({}, t.config.ctrlConfig), o));
        var E = uaTool$1.mobile;
        return (
          (null !== (i = (a = l.config).mode) && void 0 !== i) ||
            (a.mode = l.player.config.type),
          (null !== (r = (s = l.config).isMobile) && void 0 !== r) ||
            (s.isMobile = E),
          (null !== (n = (g = l.config).showCenterPlayBtn) && void 0 !== n) ||
            (g.showCenterPlayBtn = E),
          l.setMaxListeners(20),
          l.insertDom(),
          l.createSubComponents(A),
          l.setupResizeEvent(),
          l.setPluginEvts(!0),
          adaptMobileAdPlugin(l, t),
          l.config.isMobile && l.hide(!0),
          l.config.uiDuration && (l.duration = l.config.uiDuration),
          l
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "duration", {
          get: function () {
            var e;
            return null !== (e = this.uiDuration) && void 0 !== e
              ? e
              : this.player.duration;
          },
          set: function (e) {
            (isNaN(e) && void 0 !== e) ||
              ((this.uiDuration = e),
              this.instances[TimeArea.compName] &&
                (this.instances[TimeArea.compName].timeDur.innerText =
                  commonTool$1.formatPlayTime(e)));
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "audio", {
          get: function () {
            var e;
            return null === (e = this.instances[AudioTrackPopup.compName]) ||
              void 0 === e
              ? void 0
              : e.selected;
          },
          set: function (e) {
            this.instances[AudioTrackPopup.compName] &&
              (this.instances[AudioTrackPopup.compName].selected = e);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "audioOpts", {
          get: function () {
            var e;
            return null === (e = this.instances[AudioTrackPopup.compName]) ||
              void 0 === e
              ? void 0
              : e.popupOptions;
          },
          set: function (e) {
            this.instances[AudioTrackPopup.compName] &&
              (this.instances[AudioTrackPopup.compName].popupOptions = e);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "level", {
          get: function () {
            var e;
            return null === (e = this.instances[DefinitionPopup.compName]) ||
              void 0 === e
              ? void 0
              : e.selected;
          },
          set: function (e) {
            this.instances[DefinitionPopup.compName] &&
              (this.instances[DefinitionPopup.compName].selected = e);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "levelOpts", {
          get: function () {
            var e;
            return null === (e = this.instances[DefinitionPopup.compName]) ||
              void 0 === e
              ? void 0
              : e.popupOptions;
          },
          set: function (e) {
            this.instances[DefinitionPopup.compName] &&
              (this.instances[DefinitionPopup.compName].popupOptions = e);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "lang", {
          get: function () {
            var e;
            return null === (e = this.instances[LanguagePopup.compName]) ||
              void 0 === e
              ? void 0
              : e.selected;
          },
          set: function (e) {
            this.instances[LanguagePopup.compName] &&
              (this.instances[LanguagePopup.compName].selected = e);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "langOpts", {
          get: function () {
            var e;
            return null === (e = this.instances[LanguagePopup.compName]) ||
              void 0 === e
              ? void 0
              : e.popupOptions;
          },
          set: function (e) {
            this.instances[LanguagePopup.compName] &&
              (this.instances[LanguagePopup.compName].popupOptions = e);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "playrate", {
          get: function () {
            var e;
            return null === (e = this.instances[PlayratePopup.compName]) ||
              void 0 === e
              ? void 0
              : e.selected;
          },
          set: function (e) {
            this.instances[PlayratePopup.compName] &&
              (this.instances[PlayratePopup.compName].selected = e);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "playrateOpts", {
          get: function () {
            var e;
            return null === (e = this.instances[PlayratePopup.compName]) ||
              void 0 === e
              ? void 0
              : e.popupOptions;
          },
          set: function (e) {
            this.instances[PlayratePopup.compName] &&
              (this.instances[PlayratePopup.compName].popupOptions = e);
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.getIsHotKeysDisabled = function () {
          return this.hotKeys.isDisabled;
        }),
        (t.prototype.prependElementToLevels = function (e) {
          var t, o, A;
          null ===
            (A =
              null ===
                (o =
                  null === (t = this.instances) || void 0 === t
                    ? void 0
                    : t[DefinitionPopup.compName]) || void 0 === o
                ? void 0
                : o.popup) ||
            void 0 === A ||
            A.firstElementChild.insertAdjacentElement("afterbegin", e);
        }),
        (t.prototype.show = function (e) {
          void 0 === e && (e = !1),
            this.el.classList.remove(Component.hideClassName),
            this.instances.CtrlShow.gradientBottom.classList.remove(
              Component.hideClassName
            ),
            e &&
              ((this.el.style.display = ""),
              (this.instances.CtrlShow.gradientBottom.style.display = "")),
            this.emit(CTRL_EVENTS$1.SHOW);
        }),
        (t.prototype.hide = function (e) {
          void 0 === e && (e = !1),
            this.el.classList.add(Component.hideClassName),
            this.instances.CtrlShow.gradientBottom.classList.add(
              Component.hideClassName
            ),
            e &&
              ((this.el.style.display = "none"),
              (this.instances.CtrlShow.gradientBottom.style.display = "none")),
            this.emit(CTRL_EVENTS$1.HIDE);
        }),
        (t.prototype.setHotKeysDisable = function (e) {
          void 0 === e && (e = !0),
            this.hotKeys && (this.hotKeys.isDisabled = !!e);
        }),
        (t.prototype.setCompDisable = function (e, t) {
          var o = this;
          void 0 === t && (t = !0),
            (Array.isArray(e) ? e : [e]).forEach(function (e) {
              var A, i;
              "CtrlShow" !== e
                ? null ===
                    (i =
                      null === (A = o.instances[e]) || void 0 === A
                        ? void 0
                        : A.el) ||
                  void 0 === i ||
                  i.classList.toggle(Component.disabledClassName, t)
                : o.instances.CtrlShow.toggleShadowClickDisabled(t);
            });
        }),
        (t.prototype.setCompVisable = function (e, t) {
          var o = this;
          void 0 === t && (t = !0),
            (Array.isArray(e) ? e : [e]).forEach(function (e) {
              var A, i;
              null ===
                (i =
                  null === (A = o.instances[e]) || void 0 === A
                    ? void 0
                    : A.el) ||
                void 0 === i ||
                i.classList.toggle(Component.hideClassName, !t);
            });
        }),
        (t.prototype.removeComponent = function (e) {
          var t, o;
          null ===
            (o =
              null === (t = this.instances[e]) || void 0 === t
                ? void 0
                : t.el) ||
            void 0 === o ||
            o.remove();
        }),
        (t.prototype.destroy = function () {
          var t, o;
          this.setPluginEvts(!1),
            this.callAllComponents("destroy"),
            (null === (t = this.el) || void 0 === t ? void 0 : t.parentNode) &&
              this.el.remove(),
            (this.el = null),
            null === (o = this.hotKeys) || void 0 === o || o.destroy(),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.hookVideoCanplay = function () {
          this.config.isMobile && this.show(!0);
        }),
        (t.prototype.hookAdReqInfoStart = function () {
          this.isInRequest = !0;
        }),
        (t.prototype.hookAdReqInfoEnd = function () {
          this.isInRequest = !1;
        }),
        (t.prototype.hookVideoReqInfoStart = function () {
          this.isInRequest = !0;
        }),
        (t.prototype.hookVideoReqInfoEnd = function () {
          this.isInRequest = !1;
        }),
        (t.prototype.hookVideoRateChange = function (e) {
          var t,
            o = e.rate;
          if (
            !(null === (t = this.playrateOpts) || void 0 === t
              ? void 0
              : t.find(function (e) {
                  return Number(e.value) === o;
                }))
          ) {
            var A = __spreadArray([], this.playrateOpts || [], !0);
            if (this.hotKeys.pressKey) return;
            return (
              this.hasCustomPlayBackRate &&
                (A = this.deleteCustomPlaybackRate(A)),
              (this.playrateOpts = __spreadArray(
                [this.getCustomPlaybackRate(o)],
                A,
                !0
              )),
              (this.hasCustomPlayBackRate = !0),
              void (this.playrate = o)
            );
          }
          this.hasCustomPlayBackRate &&
            ((this.hasCustomPlayBackRate = !1),
            (this.playrateOpts = this.deleteCustomPlaybackRate(
              this.playrateOpts
            ))),
            (this.playrate = o);
        }),
        (t.prototype.hookVideoPlaying = function (e) {
          var t;
          e.isFirst &&
            (null === (t = this.instances.CtrlShow.shadow) ||
              void 0 === t ||
              t.classList.remove(Component.hideClassName));
        }),
        (t.prototype.hookPlaySessionEnd = function (e) {
          this.callAllComponents("hookPlaySessionEnd", e);
        }),
        (t.prototype.onFlowNodeStart = function (e) {
          this.callAllComponents("hookFlowNodeStart", e);
        }),
        (t.prototype.callAllComponents = function (e) {
          for (var t = this, o = [], A = 1; A < arguments.length; A++)
            o[A - 1] = arguments[A];
          var i = {};
          Object.keys(this.instances).forEach(function (A) {
            try {
              var r = t.instances[A];
              if (r instanceof Popup) {
                if (i[r.popupName]) return;
                i[r.popupName] = !0;
              }
              "function" == typeof r[e] && r[e].apply(r, o);
            } catch (o) {
              t.error("ctrlbar " + e + " err: ", o);
            }
          });
        }),
        (t.prototype.setPluginEvts = function (e) {
          var t = this;
          this.pluginMsgEvtMap ||
            (this.pluginMsgEvtMap = {
              FLOW_NODE_START: this.onFlowNodeStart.bind(this),
            });
          var o = e ? this.msg.on : this.msg.off;
          Object.keys(this.pluginMsgEvtMap).forEach(function (e) {
            o.call(t.msg, e, t.pluginMsgEvtMap[e]);
          });
        }),
        (t.prototype.getCustomPlaybackRate = function (e) {
          return {
            value: e,
            label: "鑷畾涔夛紙" + e + "x锛�",
            btnLabel: e + "x",
            payload: { customOpt: !0 },
          };
        }),
        (t.prototype.deleteCustomPlaybackRate = function (e) {
          return e.filter(function (e) {
            var t;
            return (
              !0 !==
              (null === (t = e.payload) || void 0 === t ? void 0 : t.customOpt)
            );
          });
        }),
        (t.prototype.insertDom = function () {
          var e = this.player.container,
            o = this.config.isMobile;
          e.classList.add(containerClassName),
            e.insertAdjacentHTML("beforeend", getDomText(o));
          var A = o ? css_248z$5 : css_248z$1$1;
          domTool$1.insertStyle(A, t.styleDataTag);
          var i = getRootClassName(o);
          (this.el = e.querySelector(i)),
            document.querySelector(svgSpriteSelector) ||
              document.body.insertAdjacentHTML(
                "afterbegin",
                o ? h5SvgSprite : svgSprite
              ),
            o &&
              ((this.el.innerHTML =
                this.el.querySelector(ctrlBarSelector).innerHTML),
              (e.querySelector(i + " .txp_right_controls").innerHTML =
                h5CtrlRightDomText),
              e.insertAdjacentHTML("beforeend", h5OverlayText));
        }),
        (t.prototype.createSubComponents = function (e) {
          if ((this.initComps(e), !this.config.disableHotKey)) {
            var t = this.instances,
              o = t.Volume,
              A = t.FakeFullscreen,
              i = t.PlayratePopup,
              r = t.Progress;
            this.hotKeys = new HotKeys(this.player, this.config, {
              volume: o,
              fakeFullscreen: A,
              playRate: i,
              progress: r,
            });
          }
        }),
        (t.prototype.initComps = function (e) {
          var t = this,
            o = this.config,
            A = o.isMobile,
            i = o.comps,
            r = o.removeComps,
            n = "live" === this.config.mode,
            a = n
              ? [
                  PlayBtn,
                  Fullscreen,
                  FakeFullscreen,
                  LiveProgress,
                  Volume,
                  CenterBtn,
                  AirPlayBtn,
                  CtrlShow,
                  DefinitionPopup,
                ]
              : [
                  PlayBtn,
                  TimeArea,
                  Progress,
                  Fullscreen,
                  HotPoint,
                  Loop,
                  NextBtn,
                  FakeFullscreen,
                  Volume,
                  MuteTips,
                  PictureInPicture,
                  CenterBtn,
                  AirPlayBtn,
                  CtrlShow,
                  DefinitionPopup,
                  LanguagePopup,
                  PlayratePopup,
                  AudioTrackPopup,
                ],
            s = [];
          (null == i ? void 0 : i.length)
            ? -1 ===
                (s = i.map(function (e) {
                  return componentMap[e];
                })).indexOf(CtrlShow) && s.push(CtrlShow)
            : (s = (s = s.concat(a)).filter(function (e) {
                var t = !!r && -1 !== r.indexOf(e.compName),
                  A = e.isEnabled(o);
                return !t && A;
              })),
            this.log(
              "readyCompClasses=" +
                s.map(function (e) {
                  return e.compName;
                })
            ),
            s.forEach(function (A) {
              var i = new A(t.player, o, t, e);
              (t.instances[A.compName] = i),
                i instanceof Popup && (t.instances[i.popupName] = i);
            }),
            n && A && (this.el.style.justifyContent = "space-between");
        }),
        (t.prototype.setupResizeEvent = function () {
          var e = this,
            t = function (t) {
              var o = t.data;
              e.player.container.classList.toggle(largeSizeClassName, o),
                e.emit(CTRL_EVENTS$1.RESIZE, {
                  size: o ? exports.CTRL_SIZE.LARGE : exports.CTRL_SIZE.NORMAL,
                });
            };
          this.on(CTRL_EVENTS$1.FULLSCREEN_CHANGE, function (o) {
            var A;
            (!o.data &&
              (null === (A = e.instances.FakeFullscreen) || void 0 === A
                ? void 0
                : A.isFullScreen)) ||
              t(o);
          }),
            this.on(CTRL_EVENTS$1.FAKE_FULLSCREEN_CHANGE, function (o) {
              var A,
                i = o.data;
              document.body.classList.toggle(bodyOverflowClassName, i),
                (!i &&
                  (null === (A = e.instances.Fullscreen) || void 0 === A
                    ? void 0
                    : A.isFullScreen)) ||
                  t(o);
            }),
            uaTool$1.mobile &&
              this.player.container.addEventListener("touchmove", function (t) {
                var o;
                (null === (o = e.instances.FakeFullscreen) || void 0 === o
                  ? void 0
                  : o.isFullScreen) && t.preventDefault();
              });
        }),
        (t.pluginName = CtrlbarPluginName$2),
        (t.styleDataTag = "thumb-ctrlbar-style"),
        t
      );
    })(Plugin);
  H5Player.registerPlugin(CtrlbarPlugin.pluginName, CtrlbarPlugin);
  var isMobile = uaTool$1.mobile,
    txpHideClass = "txp_none";
  function styleInject$4(e, t) {
    void 0 === t && (t = {});
    var o = t.insertAt;
    if (e && "undefined" != typeof document) {
      var A = document.head || document.getElementsByTagName("head")[0],
        i = document.createElement("style");
      (i.type = "text/css"),
        "top" === o && A.firstChild
          ? A.insertBefore(i, A.firstChild)
          : A.appendChild(i),
        i.styleSheet
          ? (i.styleSheet.cssText = e)
          : i.appendChild(document.createTextNode(e));
    }
  }
  var css_248z$4 =
    ".txp_video_error{position:absolute;top:0;left:0;width:100%;height:100%;z-index:99;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:#111;color:#fff}.txp_video_error.txp_none,.txp_video_error .txp_none{display:none!important}.txp_video_error a{color:#fff;text-decoration:none}.txp_video_error .txp_error_title{margin:10px 20px;font-size:18px;line-height:1.6;text-align:center}.txp_video_error .txp_error_title .txp_btn{color:#ff6428;font-size:inherit}.txp_video_error .error-noise-bg{position:absolute;width:100%;height:100%;left:0;top:0;z-index:-1}.txp_video_error .txp_error_code{margin:30px 20px 0;line-height:1.5;color:#666;pointer-events:auto;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.txp_video_error .txp_error_code a{cursor:pointer;color:#666;border-bottom:1px solid}.txp_video_error .txp_error_code a:hover{color:#ff6428}.txp_video_error .txp_error_code::-moz-selection, .txp_video_error .txp_error_code ::-moz-selection{color:#fff;background:#eee}.txp_video_error .txp_error_code::selection,.txp_video_error .txp_error_code ::selection{color:#fff;background:#eee}.txp_video_error .txp_error_code::-moz-selection,.txp_video_error .txp_error_code ::-moz-selection{color:#fff;background:#eee}.txp_video_error .none{display:none}.txp_video_error .txp_link_refresh{color:#fc6526}.txp_video_error .txp_link_btn{display:block;outline:none;border:none;margin-bottom:16px;padding:0 20px;border-radius:15px;background:#26262b;color:#fc6526;font-size:14px;line-height:30px;cursor:pointer}.txp_video_error .txp_link_btn:hover{color:#fff;background-color:#fc6526}.txp_video_error .txp_browser a{text-decoration:underline;cursor:pointer}.txp_video_error .txp_browser a:hover{color:#ff6428}";
  styleInject$4(css_248z$4);
  var queue = [],
    isReq = !1,
    qqlive = 0,
    getClient = function (e) {
      if (qqlive) e(qqlive);
      else if ((queue.push(e), !isReq)) {
        if (((isReq = !0), "qq.com" != document.domain))
          throw new Error("document.domain is not qq.com");
        var t = document.createElement("iframe");
        (t.src =
          "javascript:'<script>window.onload=function(){document.write(\\'<script>document.domain=\\\"qq.com\\\";<\\\\/script>\\');document.close();};</script>'"),
          (t.style.cssText = "display:none;"),
          document.body.appendChild(t),
          (t.getClient = function (e) {
            qqlive = e;
            for (var t = queue.shift(); t; ) t && t(e), (t = queue.shift());
          }),
          (t.src = "//v.qq.com/iframe/client.html");
      }
    },
    ErrorPagePluginName$1 = "error-page",
    ErrorPagePluginEvents$1 = { REPORT_LOG: "error-page:report-log" },
    defaultErrorText = "鍑洪敊鍟�",
    defaultErrorMsg = "杩欎釜瑙嗛琚鏄熶汉鍔蛋锛屾殏鏃剁湅涓嶄簡浜唦",
    dataRoleMap = {
      error: "txp-ui-error",
      errorMsg: "txp-ui-error-msg",
      errorHandler: "txp-ui-error-handler",
      errorRefresh: "txp-ui-error-refresh",
      errorCode: "txp-ui-error-code",
      background: "txp-ui-error-background",
      clientBtn: "txp-ui-error-client-btn",
      browserTip: "txp-ui-error-browser",
    },
    DRM_MODULE_ERROR_CODE_REGEX = /^7009\d+(\.?-?\d+)?$/,
    ENV_NOT_SUPPORT_ENCRYPTION_LIVE_CODES = ["70023097", "70023098"],
    ENV_NOT_SUPPORT_ENCRYPTION_VOD_CODES = [
      "70013069.4",
      "70013097.0",
      "70013097.2",
      "70013098.1",
      "70013080.14",
    ],
    NO_PLAYBACK_COPYRIGHTS_CODE = "70013080.2";
  function getGuidingMessage(e) {
    return -1 !==
      __spreadArray(
        __spreadArray([], ENV_NOT_SUPPORT_ENCRYPTION_LIVE_CODES, !0),
        ENV_NOT_SUPPORT_ENCRYPTION_VOD_CODES,
        !0
      ).indexOf(e) || DRM_MODULE_ERROR_CODE_REGEX.test(e)
      ? "<p>涓轰繚鎶ゆ鐗堥槻姝㈢洍鐗堬紝鎮ㄥ彲浠ュ皾璇�</p>"
      : "<p>鎮ㄥ彲浠ュ皾璇�</p>";
  }
  function checkIfClientNeeded(e, t) {
    return (
      void 0 === t && (t = !1),
      !!DRM_MODULE_ERROR_CODE_REGEX.test(e) ||
        (t
          ? -1 !== ENV_NOT_SUPPORT_ENCRYPTION_LIVE_CODES.indexOf(e)
          : -1 !==
            __spreadArray(
              __spreadArray([], ENV_NOT_SUPPORT_ENCRYPTION_VOD_CODES, !0),
              [NO_PLAYBACK_COPYRIGHTS_CODE],
              !1
            ).indexOf(e))
    );
  }
  function saveChannel(e) {
    var t = "qqlivechannel=channel1." + e;
    if (uaTool$1.browser.ie) {
      var o = new Date();
      o.setTime(o.getTime() + 864e5),
        (document.cookie = t + ";path=/;expires=" + o.toUTCString());
    } else {
      var A = document.createElement("input");
      document.querySelector("body").append(A),
        (A.style.position = "absolute"),
        (A.style.top = "-9999px"),
        (A.value = t),
        (A.style.top = document.querySelector("body").scrollTop + "px"),
        A.focus(),
        A.setSelectionRange(0, t.length),
        document.queryCommandSupported("copy") &&
          document.execCommand("copy", !0),
        A.remove();
    }
  }
  function openClient(e) {
    if (e.support && e.sso) {
      try {
        saveChannel(e.atag);
      } catch (e) {}
      try {
        getClient(function (t) {
          t &&
            t
              .exist()
              .done(function () {
                t.open(e.sso), e.success();
              })
              .fail(function () {
                e.error();
              });
        });
      } catch (e) {
        console.log(e);
      }
    }
  }
  Object.keys(defaultI18nConfig.core).forEach(function (e) {
    /ERROR_DRM_.*/.test(e) &&
      (defaultI18nConfig.core[e] =
        "璇ヨ棰戝洜鐗堟潈鏂瑰畨鍏ㄤ繚瀵嗙骇鍒緝楂橈紝褰撳墠娴忚鍣ㄤ笉鏀寔鍔犲瘑鎾斁");
  });
  var qqbrowserHelper = {
      exist: !1,
      isLatestChromeSupportDrm: function () {
        var e = uaTool$1.os;
        if (e.windows) return parseFloat(e.version) > 6;
        if (e.mac) {
          if (uaTool$1.browser.qqbrowser) return !1;
          var t = (e.version || "").split(".");
          return parseFloat((t[0] || "0") + "." + (t[1] || "0")) > 10.1;
        }
        return !e.linux && void 0;
      },
      detect: function () {
        var e = new SimpleDefer$1(),
          t = document.createElement("meta");
        return (
          (t.name = "referrer"),
          (t.content = "always"),
          document.head.prepend(t),
          this.isLatestChromeSupportDrm()
            ? fetch("http://127.0.0.1:28653/api/handle", {
                method: "POST",
                body: JSON.stringify({ action: "GetQBVersion", cmd: "" }),
              })
                .then(function (e) {
                  return e.json();
                })
                .then(function (o) {
                  t.remove();
                  var A = !1,
                    i = o.result || "";
                  i &&
                    (A =
                      -1 !== commonTool$1.compareVersion(i, "10.2.2101.400")),
                    A
                      ? ((qqbrowserHelper.exist = !0), e.resolve({ exist: !0 }))
                      : ((qqbrowserHelper.exist = !1),
                        e.resolve({ exist: !1 }));
                })
                .catch(function () {
                  t.remove(),
                    (qqbrowserHelper.exist = !1),
                    e.resolve({ exist: !1 });
                })
            : e.reject(),
          e
        );
      },
      download: function () {
        try {
          location.assign(
            "https://dldir1.qq.com/invc/tt/QQBrowser_Setup_DRM.exe"
          );
        } catch (e) {}
      },
      open: function (e) {
        if (qqbrowserHelper.exist) {
          var t = document.createElement("meta");
          (t.name = "referrer"),
            (t.content = "always"),
            document.head.prepend(t),
            fetch("http://127.0.0.1:28653/api/handle", {
              method: "POST",
              body: JSON.stringify({
                action: "Open",
                cmd: encodeURIComponent(e),
              }),
            })
              .then(function () {
                t.remove();
              })
              .catch(function () {
                t.remove();
              });
        } else this.download();
      },
    },
    defaultNoiseConfig = {
      enable: !isMobile,
      interval: 150,
      performanceRatio: 5,
      size: 4,
      opacity: 0.05,
    },
    WHITE_RGB_VALUE = 16777215,
    ErrorPagePlugin = (function (e) {
      function t(t, o, A) {
        var i,
          r = e.call(this, t, o, A) || this;
        return (
          (r.innerElements = {}),
          (r.clientExistDefer = new SimpleDefer$1()),
          (r.noiseAnimation = function (e, t, o, A, i) {
            var r = Math.floor(o / i),
              n = e.createImageData(t, r),
              a = new Uint32Array(n.data.buffer);
            e.clearRect(0, 0, t, o);
            for (var s = 0; s < a.length; s++)
              a[s] = (((255 * Math.random() * A) | 0) << 24) + WHITE_RGB_VALUE;
            for (s = 0; s <= i; s++) e.putImageData(n, 0, r * s);
          }),
          (r.browserTipClick = function () {
            qqbrowserHelper.open(location.href);
          }),
          (r.config = __assign$1(__assign$1({}, t.config.errorPageConfig), o)),
          (r.config.noiseConfig = __assign$1(
            __assign$1({}, defaultNoiseConfig),
            null === (i = r.config) || void 0 === i ? void 0 : i.noiseConfig
          )),
          r.insertDOM(),
          r.setupDOMEvents(),
          r.setupPlayerEvents(),
          r
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.show = function (e) {
          void 0 === e && (e = defaultErrorText);
          var t = this.player.getCommonKv(COMMON_DATA_KEY.flowid) || "",
            o = "object" == typeof e && Boolean(null == e ? void 0 : e.img);
          if ("string" == typeof e)
            (this.innerElements.errorMsg.innerHTML = e),
              (this.innerElements.errorCode.innerHTML = t),
              this.innerElements.background.classList.add(txpHideClass),
              this.innerElements.errorRefresh.classList.remove(txpHideClass);
          else {
            var A = e.text,
              i = void 0 === A ? defaultErrorText : A,
              r = e.code,
              n = void 0 === r ? "" : r,
              a = e.img,
              s = void 0 === a ? "" : a,
              g = e.hideRefresh,
              l = void 0 !== g && g;
            (this.innerElements.errorMsg.innerHTML = i),
              (this.innerElements.errorCode.innerHTML = n
                ? String(n) + "-" + t
                : t),
              (this.innerElements.background.src = s),
              this.innerElements.background.classList.toggle(txpHideClass, !s),
              this.innerElements.errorRefresh.classList.toggle(txpHideClass, l);
          }
          this.rootEl.classList.remove(txpHideClass), this.setNoise(!o);
        }),
        (t.prototype.hide = function () {
          this.rootEl.classList.add(txpHideClass),
            this.setNoise(!1),
            domTool$1.addClass(this.innerElements.clientBtn, txpHideClass),
            domTool$1.addClass(this.innerElements.browserTip, txpHideClass),
            domTool$1.addClass(this.innerElements.errorRefresh, txpHideClass);
        }),
        (t.prototype.destroy = function () {
          var t;
          this.setNoise(!1),
            this.rootEl.parentNode && this.rootEl.remove(),
            (this.innerElements = {}),
            null === (t = this.noiseBg) || void 0 === t || t.remove(),
            (this.noiseBg = null),
            (this.rootEl = null),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.insertDOM = function () {
          var e = this,
            t = this.player.container,
            o = this.config.noiseConfig,
            A =
              '<div data-role="' +
              dataRoleMap.error +
              '" class="txp_video_error ' +
              txpHideClass +
              '">\n      ' +
              (o.enable ? '<canvas class="error-noise-bg"></canvas>' : "") +
              '\n      <img data-role="' +
              dataRoleMap.background +
              '" alt="error-background"/>\n      <div data-role="' +
              dataRoleMap.errorMsg +
              '" class="txp_error_title"></div>\n      <div data-role="' +
              dataRoleMap.errorHandler +
              '" class="txp_error_desc">\n        <span data-role="' +
              dataRoleMap.errorRefresh +
              '">\n          浣犲彲浠� <a href="javascript:;" class="txp_link_refresh">鍒锋柊</a> 璇曡瘯\n        </span>\n      </div>\n      <button data-role="' +
              dataRoleMap.clientBtn +
              '" class="txp_link_btn ' +
              txpHideClass +
              '"></button>\n      <div data-role="' +
              dataRoleMap.browserTip +
              '" class="txp_browser ' +
              txpHideClass +
              '"></div>\n      <div class="txp_error_code" data-role="' +
              dataRoleMap.errorCode +
              '"></div>\n    </div>';
          t.insertAdjacentHTML("beforeend", A),
            (this.rootEl = t.querySelector(
              '[data-role="' + dataRoleMap.error + '"]'
            )),
            (this.noiseBg = this.rootEl.querySelector("canvas")),
            Object.keys(dataRoleMap).forEach(function (o) {
              e.innerElements[o] = t.querySelector(
                '[data-role="' + dataRoleMap[o] + '"]'
              );
            });
        }),
        (t.prototype.setupDOMEvents = function () {
          var e = this;
          this.innerElements.errorRefresh
            .querySelector(".txp_link_refresh")
            .addEventListener("click", function () {
              e.config.useReplay ? e.player.replay() : location.reload();
            });
          var o = 0,
            A = 0;
          this.innerElements.errorCode.addEventListener("click", function () {
            (o += 1) >= 5 && ((o = 0), e.emit(t.Events.REPORT_LOG)),
              A && clearTimeout(A),
              (A = window.setTimeout(function () {
                return (o = 0);
              }, 300));
          }),
            this.innerElements.clientBtn.addEventListener("click", function () {
              e.clientExistDefer.promise
                .then(function (t) {
                  e.clickClientBtnOnExist(t);
                })
                .catch(function () {
                  e.clickClientBtnOnNoExist();
                });
            });
        }),
        (t.prototype.setupPlayerEvents = function () {
          var e = this,
            t = this.player;
          t.on(exports.H5_PLAY_EVENT.PLAY_SESSION_END, function (o) {
            var A = o.data;
            if (e.config.showOnError) {
              var i = A.code;
              if (i !== exports.ErrorCode.SUC) {
                var r = e.config.img,
                  n = e.config.hideRefresh,
                  a = t.config.type === exports.PLAY_MODE.LIVE,
                  s = checkIfClientNeeded(i, a);
                if (a && A.data) {
                  if ("setErrorView" !== A.data.name) return;
                  var g = A.data.params,
                    l = g.hideRefresh,
                    E = g.hideCode;
                  l
                    ? domTool$1.addClass(
                        e.innerElements.errorRefresh,
                        txpHideClass
                      )
                    : domTool$1.removeClass(
                        e.innerElements.errorRefresh,
                        txpHideClass
                      ),
                    (n = l),
                    E
                      ? domTool$1.addClass(
                          e.innerElements.errorCode,
                          txpHideClass
                        )
                      : domTool$1.removeClass(
                          e.innerElements.errorCode,
                          txpHideClass
                        );
                }
                s &&
                  (e.config.useClientBtn &&
                    (e.checkClientExist(), e.setClientBtn(), (n = !0)),
                  e.config.useBrowserTip && (e.setBrowserTip(), (n = !0)));
                var c = e.getErrMsg(A, a, s);
                e.show({ code: i, text: c, hideRefresh: n, img: r });
              }
            }
          }),
            t.on(exports.PLAY_EVENT.STATE_CHANGE, function (t) {
              var o = t.data.new;
              (o !== exports.VIDEO_STATE.PLAYING &&
                o !== exports.VIDEO_STATE.CANPLAY) ||
                e.hide();
            }),
            t.on(exports.H5_PLAY_EVENT.PLAY_SESSION_START, function () {
              return e.hide();
            });
        }),
        (t.prototype.getErrMsg = function (e, t, o) {
          var A = e.code,
            i = this.config,
            r = i.fuzzy,
            n = i.dictionary,
            a = void 0 === n ? {} : n,
            s = r ? A.split(".")[0] : null,
            g = a[A] || a[s];
          if (g) return g;
          var l = o && (this.config.useClientBtn || this.config.useBrowserTip);
          return (
            (t ? this.getLiveErrMsg(e, l) : this.getVodErrMsg(e, l)) ||
            defaultErrorMsg
          );
        }),
        (t.prototype.getLiveErrMsg = function (e, t) {
          var o = e.message;
          if (!e.data) return o;
          var A = e.data.params.msg,
            i = e.code;
          return A && (o = A), t && (o = "" + o + getGuidingMessage(i)), o;
        }),
        (t.prototype.getVodErrMsg = function (e, t) {
          var o = e.message,
            A = e.code;
          return A.startsWith(exports.ErrorCode.GETINFO_SERVER_CODE_PREFIX) ||
            A.startsWith("7009")
            ? (t && (o = "" + o + getGuidingMessage(A)), o)
            : o;
        }),
        (t.prototype.setClientBtn = function () {
          var e = this,
            t = uaTool$1.os.mac ? "Mac瀹㈡埛绔鐪�" : "PC瀹㈡埛绔鐪�";
          uaTool$1.os.mac
            ? (this.innerElements.clientBtn.innerHTML = "鎵撳紑" + t)
            : this.clientExistDefer.promise
                .then(function () {
                  e.innerElements.clientBtn.innerHTML = "鎵撳紑" + t;
                })
                .catch(function () {
                  e.innerElements.clientBtn.innerHTML = "涓嬭浇" + t;
                }),
            domTool$1.removeClass(this.innerElements.clientBtn, txpHideClass);
        }),
        (t.prototype.setNoise = function (e) {
          var t = this;
          void 0 === e && (e = !0);
          var o = this.config.noiseConfig,
            A = o.enable,
            i = o.performanceRatio,
            r = o.opacity;
          if (
            A &&
            this.noiseBg &&
            (clearInterval(this.noiseTimer),
            domTool$1.css(this.noiseBg, "display", e ? "block" : "none"),
            e)
          ) {
            var n = this.noiseBg.getContext("2d");
            this.resizeNoise();
            var a = this.noiseBg,
              s = a.width,
              g = a.height;
            if (!s || !g) return;
            this.noiseAnimation(n, s, g, r, i),
              (this.noiseTimer = setInterval(function () {
                t.noiseAnimation(n, s, g, r, i);
              }, o.interval));
          }
        }),
        (t.prototype.resizeNoise = function () {
          if (this.noiseBg) {
            var e = this.player.container,
              t = e.clientWidth,
              o = e.clientHeight,
              A = this.config.noiseConfig.size;
            (this.noiseBg.width = t / A), (this.noiseBg.height = o / A);
          }
        }),
        (t.prototype.checkClientExist = function () {
          var e = this;
          try {
            getClient(function (t) {
              t
                ? t
                    .exist()
                    .done(function () {
                      e.clientExistDefer.resolve(t);
                    })
                    .fail(function () {
                      e.clientExistDefer.reject();
                    })
                : e.clientExistDefer.reject();
            });
          } catch (e) {
            this.clientExistDefer.reject();
          }
        }),
        (t.prototype.clickClientBtnOnExist = function (e) {
          if (this.player.config.type === exports.PLAY_MODE.LIVE) {
            var t =
              "qqlive://sso/pid=" +
              (this.player.getCommonKv(COMMON_DATA_KEY.livepid) || "") +
              "&projectid=" +
              (this.player.vid || "");
            e.open(t);
          } else {
            var o = this.player.vid;
            openClient({
              support: !0,
              atag: "playererror",
              sso:
                "qqlive://sso/vbarid=" +
                (this.player.getCommonKv(COMMON_DATA_KEY.cid) || "") +
                "&videoid=" +
                o +
                "&start=" +
                Math.max(this.player.playtime - 5, 0) +
                "&atag=web.playererror",
              success: function () {},
              error: function () {
                this.openDownLoadLink();
              },
            });
          }
        }),
        (t.prototype.clickClientBtnOnNoExist = function () {
          this.openDownLoadLink();
        }),
        (t.prototype.openDownLoadLink = function () {
          window.open(
            "https://v.qq.com/download.html#" +
              (uaTool$1.os.mac ? "Mac" : "Windows"),
            "_blank"
          );
        }),
        (t.prototype.setBrowserTip = function () {
          this.innerElements.browserTip.removeEventListener(
            "click",
            this.browserTipClick
          ),
            domTool$1.removeClass(this.innerElements.browserTip, txpHideClass),
            uaTool$1.os.mac
              ? (this.innerElements.browserTip.innerHTML =
                  "鎴栦笅杞芥渶鏂� Chrome銆丼afari 娴忚鍣ㄨ鐪�")
              : (this.innerElements.browserTip.innerHTML =
                  "鎴栦笅杞芥渶鏂� Chrome銆丒dge 娴忚鍣ㄨ鐪�");
        }),
        (t.Events = ErrorPagePluginEvents$1),
        (t.pluginName = ErrorPagePluginName$1),
        t
      );
    })(Plugin);
  function styleInject$3(e, t) {
    void 0 === t && (t = {});
    var o = t.insertAt;
    if (e && "undefined" != typeof document) {
      var A = document.head || document.getElementsByTagName("head")[0],
        i = document.createElement("style");
      (i.type = "text/css"),
        "top" === o && A.firstChild
          ? A.insertBefore(i, A.firstChild)
          : A.appendChild(i),
        i.styleSheet
          ? (i.styleSheet.cssText = e)
          : i.appendChild(document.createTextNode(e));
    }
  }
  H5Player.registerPlugin(ErrorPagePlugin.pluginName, ErrorPagePlugin);
  var css_248z$3 =
    '.txp_console{position:absolute;top:0;left:0;width:100%;height:100%;z-index:10;color:#fff;font-family:PingFangSC-Regular,Helvetica Neue,Helvetica,Roboto,Microsoft Yahei,Arial,sans-serif;font-size:10px;font-weight:400;pointer-events:none}.txp_console.txp_none,.txp_console .txp_none{display:none!important}.txp_console .txp_console_header .txp_info_panel_btn{margin:2px;padding:2px 4px;border-radius:2px;-webkit-transition:all .5s;transition:all .5s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;background-color:#444;color:#fff;outline:none;border:none;font-size:10px}.txp_console .txp_console_header .txp_info_panel_btn:hover{-webkit-filter:contrast(1.5) brightness(.8);filter:contrast(1.5) brightness(.8)}.txp_console .txp_console_header .txp_info_panel_btn:active{-webkit-filter:unset;filter:unset}.txp_console .txp_console_header .txp_btn_close{-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;border:none;background:0 0;font-family:inherit;cursor:pointer;outline:0 none;font-size:1em;color:#fff}.txp_console .txp_console_inner{position:absolute;margin:10px 0 0 10px;padding:8px 5px;background-color:rgba(28,28,28,.8);pointer-events:auto;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;border-radius:4px}.txp_console .txp_console_inner .txp_line_container{overflow-y:auto;overflow-x:hidden;margin-top:8px}.txp_console .txp_console_inner .txp_console_header{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0 8px}.txp_console .txp_console_inner .txp_console_header .txp_console_header_title{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-size:12px;font-weight:900}.txp_console .txp_console_inner .txp_console_header .txp_log_upload{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-right:4px}.txp_console .txp_console_inner .txp_console_header .txp_log_upload.info_panel_uploading:before{display:block}.txp_console .txp_console_inner .txp_console_header .txp_log_upload:before{content:"";display:none;width:10px;height:10px;background-image:url(data:image/svg+xml;base64,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)}.txp_console .txp_console_inner .txp_console_header .txp_log_upload.txp_none{display:none}.txp_console .txp_console_inner .txp_line{display:-webkit-box;display:-ms-flexbox;display:flex;line-height:1.6}.txp_console .txp_console_inner .txp_line .txp_compact_label,.txp_console .txp_console_inner .txp_line .txp_label{display:inline-block;-ms-flex-negative:0;flex-shrink:0;width:7em;padding-right:6px;text-align:right}.txp_console .txp_console_inner .txp_line .txp_compact_label:after,.txp_console .txp_console_inner .txp_line .txp_label:after{content:":"}.txp_console .txp_console_inner .txp_line .txp_compact_label{display:none}.txp_console .txp_console_inner .txp_line .txp_value{display:inline-block;text-align:left;vertical-align:text-top;width:30em;word-break:break-all}.txp_console.fullscreen .txp_console_inner{margin:0;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden;width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.txp_console.fullscreen .txp_console_inner .txp_line{display:none}.txp_console.fullscreen .txp_console_inner .txp_line.line-compact{display:-webkit-box;display:-ms-flexbox;display:flex}.txp_console.fullscreen .txp_console_inner .txp_line.line-compact .txp_compact_label,.txp_console.fullscreen .txp_console_inner .txp_line.line-compact .txp_label{display:none;width:4em}.txp_console.fullscreen .txp_console_inner .txp_line.line-compact .txp_compact_label{display:block}.txp_info_icon{position:absolute;top:8px;right:8px;z-index:4;width:24px;height:24px;fill:#fff;opacity:.5;border-radius:5px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transition:all .3s;transition:all .3s}.txp_info_icon:hover{opacity:1}.txp_info_icon.small{width:16px;height:16px}.txp_info_icon.txp_none{display:none!important}';
  styleInject$3(css_248z$3);
  var INFO_SVG_DOM_STR =
      '<div class="txp_info_icon txp_none">\n  <svg\n  viewBox="0 0 1024 1024"\n  version="1.1"\n  xmlns="http://www.w3.org/2000/svg"\n  >\n  <path\n    d="M512 958.016C266.08 958.016 65.984 757.952 65.984 512 65.984 266.08 266.08 65.984 512 65.984c245.952 0 446.016 200.064 446.016 446.016C958.016 757.952 757.952 958.016 512 958.016zM512 129.984C301.344 129.984 129.984 301.344 129.984 512c0 210.624 171.36 382.016 382.016 382.016 210.624 0 382.016-171.36 382.016-382.016C894.016 301.344 722.624 129.984 512 129.984z"\n  ></path>\n  <path\n    d="M512 304m-48 0a1.5 1.5 0 1 0 96 0 1.5 1.5 0 1 0-96 0Z"\n  ></path>\n  <path\n    d="M512 768c-17.664 0-32-14.304-32-32l0-288c0-17.664 14.336-32 32-32s32 14.336 32 32l0 288C544 753.696 529.664 768 512 768z"\n  ></path>\n  </svg>\n</div>\n',
    InfoPanelPluginName$1 = "info-panel",
    InfoPanelEvents = { CLICK_UPLOAD: "contextmenu:click-upload" },
    DEFAULT_SHOW_QUERY = "show_info_panel";
  function copyToClipBoard(e) {
    return canUseClipboardAPI() ? copyAsync(e) : copySynchronized(e);
  }
  function copySynchronized(e) {
    var t = document.createElement("input");
    t.setAttribute(
      "style",
      "position: absolute; clip: rect(0 0 0 0); opacity: 0;"
    ),
      (t.value = e),
      document.body.appendChild(t),
      t.select(),
      document.execCommand("copy", !0),
      t.remove();
  }
  function copyAsync(e) {
    return navigator.clipboard.writeText(e);
  }
  function canUseClipboardAPI() {
    var e;
    return (
      "function" ==
        typeof (null === (e = navigator.clipboard) || void 0 === e
          ? void 0
          : e.writeText) &&
      !uaTool$1.browser.x5 &&
      !uaTool$1.browser.mqqbrowser
    );
  }
  function getHtml(e) {
    return (
      '<div class="txp_console txp_none" style="z-index: 100">\n    <div class="txp_console_inner">\n      <div class="txp_console_header">\n      <span class="txp_console_header_title">鎾斁淇℃伅</span>\n      <span class="txp_info_panel_btn txp_info_copy">澶嶅埗</span>\n      <span class="txp_info_panel_btn txp_log_upload">\n        涓婁紶鏃ュ織\n      </span>\n      <button class="txp_info_panel_btn txp_log_download">\n        璋冭瘯淇℃伅\n      </button>\n      <button class="txp_btn_close" title="鍏抽棴">[X]</button>\n      </div>\n    <div class="txp_line_container">\n      ' +
      e
        .map(function (e) {
          var t = e.key,
            o = e.title,
            A = void 0 === o ? "" : o,
            i = e.style,
            r = void 0 === i ? "" : i,
            n = e.label,
            a = e.value,
            s = e.compactLabel;
          return (
            '<div class="txp_line ' +
            (s ? "line-compact" : "") +
            '" data-key="' +
            t +
            '" title="' +
            (A || "") +
            '" style="' +
            (r || "") +
            '">\n            <div class="txp_label">' +
            n +
            "</div>\n            " +
            (s ? '<div class="txp_compact_label">' + s + "</div>" : "") +
            '\n            <div class="txp_value">' +
            a +
            "</div>\n          </div>"
          );
        })
        .join("") +
      "\n    </div>\n    </div>\n  </div>"
    );
  }
  var InfoPanelPlugin = (function (e) {
    function t(t, o, A) {
      var i = e.call(this, t, o, A) || this;
      (i.inited = !0),
        (i.itemDomMap = {}),
        (i.isShowing = !1),
        (i.isReporting = !1),
        (i.curInfoMap = {}),
        (i.autoplayBlockedType = ""),
        (i.stateQueue = []),
        (i.disabled = !1),
        (i.onKeyDown = function (e) {
          var t = e.metaKey,
            o = e.ctrlKey;
          "KeyI" === e.code &&
            ((t && uaTool$1.os.mac) || (o && !uaTool$1.os.mac)) &&
            i.toggle();
        }),
        (i.onDebugInfoChange = function () {
          var e,
            t,
            o,
            A,
            r,
            n,
            a =
              i.player.getCommonKv(COMMON_DATA_KEY.sessionRetryBackUrlCount) ||
              0,
            s =
              i.player.getCommonKv(COMMON_DATA_KEY.sessionRetryPlayCount) || 0,
            g = a || s ? "r:" + [a, s].join("/") : "",
            l = i.player.getCommonKv(COMMON_DATA_KEY.sessionBufferCount) || 0,
            E = l ? "b:" + l : "",
            c = i.player.videoBuffered
              .map(function (e) {
                return e.start.toFixed(3) + "-" + e.end.toFixed(3);
              })
              .join(","),
            u = c ? "br:" + c : "",
            p = "t:" + i.player.playtime.toFixed(2),
            d =
              "pg:" +
              +!!(null ===
                (A =
                  null ===
                    (o =
                      null ===
                        (t =
                          null === (e = i.player.corePlayer) || void 0 === e
                            ? void 0
                            : e.getHls) || void 0 === t
                        ? void 0
                        : t.call(e)) || void 0 === o
                    ? void 0
                    : o.config) || void 0 === A
                ? void 0
                : A.progressive),
            B = "s:" + i.stateQueue.join("->"),
            h = i.autoplayBlockedType ? "a:" + i.autoplayBlockedType : "",
            I =
              null ===
                (n =
                  null === (r = i.player.currentVideoInfo) || void 0 === r
                    ? void 0
                    : r.performance) || void 0 === n
                ? void 0
                : n.latency,
            C = I ? "lc:" + (I / 1e3).toFixed(2) : "",
            _ = i.player.getCommonKv(COMMON_DATA_KEY.drm),
            f = [g, E, u, p, d, B, h, C, _ ? "enc:" + _ : ""]
              .filter(Boolean)
              .join(" ");
          i.setItemTextByKey("debug", f, !1);
        }),
        (i.onVideoAutoPlayBlock = function () {
          i.autoplayBlockedType = "vb";
        }),
        (i.onAdAutoPlayBlock = function () {
          i.autoplayBlockedType = "ab";
        }),
        (i.onStatsChange = function (e) {
          i.infoItems.forEach(function (t) {
            var o = e.data.find(function (e) {
              return e.key === t.key;
            });
            o && i.setItemTextByKey(o.key, o.value, t.hideItemIfEmpty);
          });
        }),
        (i.onPlayerStatsChange = function () {
          var e = i.player.state,
            t = e.charAt(0) + e.charAt(e.length - 1);
          i.stateQueue.push(t),
            (i.stateQueue = i.stateQueue.slice(-5)),
            i.onDebugInfoChange();
        }),
        (i.onDatasetUpdate = function (e) {
          -1 !==
            [
              COMMON_DATA_KEY.sessionRetryBackUrlCount,
              COMMON_DATA_KEY.sessionRetryPlayCount,
              COMMON_DATA_KEY.sessionBufferCount,
              COMMON_DATA_KEY.drm,
            ].indexOf(e.data.key) && i.onDebugInfoChange();
        });
      var r = i.player.config.infoPanelConfig,
        n = void 0 === r ? { defaultInfo: !1, disableDefaultKey: [] } : r;
      return (
        (i.config = __assign$1(__assign$1({}, n), o)),
        exports.STATS_NAME
          ? (i.renderInfoIcon(),
            i.createInfoItems(),
            i.renderInfoItems(),
            i.bindInfoItemEvts(!0),
            i.addUIEvts(),
            i.bindHotKeyEvts(!0),
            i)
          : ((i.disabled = !0), i)
      );
    }
    return (
      __extends$1(t, e),
      (t.prototype.start = function (e) {}),
      (t.prototype.getItemDom = function (e) {
        return this.elInner ? this.itemDomMap[e] : null;
      }),
      (t.prototype.show = function () {
        this.disabled ||
          (this.updateInfoItems(),
          this.isMiniPanel()
            ? this.elInner.classList.add("fullscreen")
            : this.elInner.classList.remove("fullscreen"),
          (this.isShowing = !0),
          this.elInner.classList.remove("txp_none"));
      }),
      (t.prototype.hide = function () {
        this.disabled ||
          ((this.isShowing = !1), this.elInner.classList.add("txp_none"));
      }),
      (t.prototype.toggle = function () {
        if (this.isShowing) return this.hide();
        this.show();
      }),
      (t.prototype.showIcon = function () {
        this.disabled ||
          (this.isMiniPanel()
            ? this.infoIcon.classList.add("small")
            : this.infoIcon.classList.remove("small"),
          this.infoIcon.classList.remove("txp_none"));
      }),
      (t.prototype.hideIcon = function () {
        this.disabled || this.infoIcon.classList.add("txp_none");
      }),
      (t.prototype.trigger = function () {
        this.isShowing ? this.hide() : this.show();
      }),
      Object.defineProperty(t.prototype, "showing", {
        get: function () {
          return this.isShowing;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (t.prototype.destroy = function () {
        var t, o;
        clearTimeout(this.copyBtnClearTimer),
          this.bindInfoItemEvts(!1),
          this.bindHotKeyEvts(!1),
          null === (t = this.elInner) || void 0 === t || t.remove(),
          null === (o = this.infoIcon) || void 0 === o || o.remove(),
          (this.itemDomMap = null),
          (this.elInner = null),
          (this.infoItems = null),
          e.prototype.destroy.call(this);
      }),
      (t.prototype.hookPlaySessionStart = function () {
        var e = this.config.showOnQuery,
          t = void 0 === e ? DEFAULT_SHOW_QUERY : e;
        urlTool$1.getUrlParamByKey(location.href, t) && this.show();
      }),
      (t.prototype.hookVideoPause = function () {
        var e = this.config.showInfoIconOnPause;
        (void 0 === e || e) && this.showIcon();
      }),
      (t.prototype.hookVideoPlaying = function () {
        var e = this.config.showInfoIconOnPause;
        (void 0 === e || e) && this.hideIcon();
      }),
      (t.prototype.renderInfoIcon = function () {
        var e = this,
          t = this.player.container;
        t.insertAdjacentHTML("beforeend", INFO_SVG_DOM_STR),
          (this.infoIcon = t.querySelector(".txp_info_icon")),
          this.infoIcon.addEventListener("click", function () {
            e.toggle();
          });
      }),
      (t.prototype.renderInfoItems = function () {
        var e,
          t = this,
          o = this.config.showUploadBtn,
          A = void 0 === o ? uaTool$1.mobile : o,
          i = this.infoItems,
          r = this.player.container,
          n = getHtml(i);
        r.insertAdjacentHTML("beforeend", n),
          (this.elInner = r.querySelector(".txp_console")),
          (this.closeBtn = this.elInner.querySelector(".txp_btn_close")),
          (this.uploadBtn = this.elInner.querySelector(
            ".txp_info_panel_btn.txp_log_upload"
          )),
          (this.copyBtn = this.elInner.querySelector(
            ".txp_info_panel_btn.txp_info_copy"
          )),
          (this.downloadBtn = this.elInner.querySelector(
            ".txp_info_panel_btn.txp_log_download"
          )),
          this.player.offlineLog ||
            (this.uploadBtn.classList.add(txpHideClass),
            this.downloadBtn.classList.add(txpHideClass)),
          !A &&
          (null === (e = this.player.offlineLog) || void 0 === e
            ? void 0
            : e.downloadLogs)
            ? this.uploadBtn.classList.add(txpHideClass)
            : this.downloadBtn.classList.add(txpHideClass),
          i.forEach(function (e) {
            var o = { el: null, value: null };
            (o.el = t.elInner.querySelector('[data-key="' + e.key + '"]')),
              (o.value = o.el.querySelector(".txp_value")),
              (t.itemDomMap[e.key] = o);
          });
      }),
      (t.prototype.setUploadBtnState = function (e) {
        (this.uploadBtn.textContent = e ? "涓婁紶涓�..." : "涓婁紶鏃ュ織"),
          this.uploadBtn.classList.toggle("info_panel_uploading"),
          (this.uploadBtn.dataset.reporting = String(e)),
          (this.isReporting = e);
      }),
      (t.prototype.addUIEvts = function () {
        var e = this;
        this.closeBtn.addEventListener("click", function () {
          return e.hide();
        }),
          this.uploadBtn.addEventListener("click", function (t) {
            return __awaiter$1(e, void 0, void 0, function () {
              var e,
                o,
                A,
                i = this;
              return __generator$1(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (
                      (t.stopPropagation(),
                      this.isReporting ||
                        !(null === (A = this.player.offlineLog) || void 0 === A
                          ? void 0
                          : A.report))
                    )
                      return [2];
                    (e = this.player.offlineLog.report.bind(
                      this.player.offlineLog
                    )),
                      (r.label = 1);
                  case 1:
                    return (
                      r.trys.push([1, 3, 4, 5]),
                      this.setUploadBtnState(!0),
                      this.showTips("寮€濮嬩笂浼犳棩蹇�..."),
                      copyToClipBoard(JSON.stringify(this.curInfoMap)),
                      [
                        4,
                        e(!0, "info-panel:click", function (e) {
                          i.showTips(
                            "涓婁紶涓�..." + (100 * e).toFixed(0) + "%"
                          );
                        }),
                      ]
                    );
                  case 2:
                    return (
                      (o = r.sent()),
                      this.showTips({
                        text: (null == o ? void 0 : o.status)
                          ? "鏃ュ織涓婃姤鎴愬姛"
                          : "鏃ュ織涓婃姤澶辫触 " +
                            ((null == o ? void 0 : o.msg) || ""),
                        time: 10,
                        showClose: !0,
                      }),
                      [3, 5]
                    );
                  case 3:
                    return (
                      r.sent(),
                      this.showTips({
                        text:
                          "鏃ュ織涓婃姤澶辫触 " + (null == o ? void 0 : o.msg),
                        showClose: !0,
                        time: -1,
                      }),
                      [3, 5]
                    );
                  case 4:
                    return this.setUploadBtnState(!1), [7];
                  case 5:
                    return [2];
                }
              });
            });
          }),
          this.downloadBtn.addEventListener("click", function () {
            return __awaiter$1(e, void 0, void 0, function () {
              var e, t;
              return __generator$1(this, function (o) {
                return (
                  null ===
                    (t =
                      null === (e = this.player.offlineLog) || void 0 === e
                        ? void 0
                        : e.downloadLogs) ||
                    void 0 === t ||
                    t.call(e),
                  [2]
                );
              });
            });
          }),
          this.copyBtn.addEventListener("click", function (t) {
            return __awaiter$1(e, void 0, void 0, function () {
              var e,
                o,
                A = this;
              return __generator$1(this, function (i) {
                switch (i.label) {
                  case 0:
                    (e = 3e3), t.stopPropagation(), (i.label = 1);
                  case 1:
                    return (
                      i.trys.push([1, 3, , 4]),
                      [4, copyToClipBoard(JSON.stringify(this.curInfoMap))]
                    );
                  case 2:
                    return (
                      i.sent(), (this.copyBtn.textContent = "宸插鍒�"), [3, 4]
                    );
                  case 3:
                    return (
                      (o = i.sent()),
                      (this.copyBtn.textContent = "澶嶅埗澶辫触"),
                      this.log(o),
                      [3, 4]
                    );
                  case 4:
                    return (
                      clearTimeout(this.copyBtnClearTimer),
                      (this.copyBtnClearTimer = setTimeout(function () {
                        A.copyBtn.textContent = "澶嶅埗";
                      }, e)),
                      [2]
                    );
                }
              });
            });
          }),
          isMobile &&
            this.elInner.addEventListener("click", function () {
              return e.hide();
            });
      }),
      (t.prototype.bindHotKeyEvts = function (e) {
        var t = this.config.enableHotKeys,
          o = void 0 === t || t,
          A = this.player.container,
          i = getEventTargetBinder(A, e);
        o &&
          (A.hasAttribute("tabindex") || A.setAttribute("tabindex", "-1"),
          i("keydown", this.onKeyDown));
      }),
      (t.prototype.showTips = function (e) {
        var t = this.player.plugins.tips;
        null == t || t.show(e);
      }),
      (t.prototype.createInfoItems = function () {
        if (this.config.defaultInfo) {
          var e = this.config.disableDefaultKey,
            t = void 0 === e ? [] : e,
            o = [
              {
                key: exports.STATS_NAME.VID,
                label: "瑙嗛ID",
                compactLabel: "VID",
                value: "-",
                hideItemIfEmpty: !0,
              },
              {
                key: exports.STATS_NAME.FLOW_ID,
                label: "鎾斁娴佹按",
                compactLabel: "Flowid",
                value: "-",
              },
              {
                key: exports.STATS_NAME.KERNEL_NAME,
                label: "鎾斁鍐呮牳",
                compactLabel: "Kernel",
                value: "-",
              },
              {
                key: exports.STATS_NAME.PLAYER_SIZE,
                label: "鏄剧ず鍣ㄤ俊鎭�",
                compactLabel: "Res",
                value: "-",
              },
              {
                key: exports.STATS_NAME.FRAME_RATE,
                label: "甯ф暟",
                value: "-",
              },
              {
                key: exports.STATS_NAME.BUFFER_HEALTH,
                label: "缂撳啿鍋ュ悍搴�",
                value: "-",
              },
              {
                key: exports.STATS_NAME.NET,
                label: "缃戠粶娲诲姩",
                compactLabel: "net",
                value: "-",
              },
              {
                key: exports.STATS_NAME.VIDEO_SIZE,
                label: "瑙嗛鍒嗚鲸鐜�",
                value: "-",
              },
              {
                key: exports.STATS_NAME.CODEC,
                label: "缂栫爜",
                compactLabel: "Codec",
                value: "-",
                hideItemIfEmpty: !0,
              },
              {
                key: "debug",
                label: "mystery",
                compactLabel: "mystery",
                value: "-",
              },
            ];
          this.infoItems = o.filter(function (e) {
            return !t.includes(e.key);
          });
        } else this.infoItems = [];
      }),
      (t.prototype.setItemTextByKey = function (e, t, o) {
        if (e) {
          var A = this.getItemDom(e);
          if (A) {
            if (((this.curInfoMap[e] = t), o)) {
              if (!t) return void A.el.classList.add(txpHideClass);
              A.el.classList.remove(txpHideClass);
            }
            A && (A.value.innerText = t || "-");
          }
        }
      }),
      (t.prototype.bindInfoItemEvts = function (e) {
        var t = getEventEmitterBinder(this.msg, e),
          o = getEventEmitterBinder(this.player, e);
        t(exports.PLAY_EVENT_EXT.STATS_CHANGE, this.onStatsChange),
          t(exports.PLAY_EVENT_EXT.DATASET_UPDATE, this.onDatasetUpdate),
          o(exports.PLAY_EVENT.STATE_CHANGE, this.onPlayerStatsChange),
          o(exports.H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS, this.onDebugInfoChange),
          o(
            exports.H5_PLAY_EVENT.VIDEO_AUTOPLAY_BLOCKED,
            this.onVideoAutoPlayBlock
          ),
          o(exports.H5_PLAY_EVENT.VIDEO_TIMEUPDATE, this.onDebugInfoChange),
          o(exports.H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, this.onAdAutoPlayBlock);
      }),
      (t.prototype.updateInfoItems = function () {
        var e,
          t,
          o = this,
          A =
            null === (t = (e = this.player).getStats) || void 0 === t
              ? void 0
              : t.call(e);
        A &&
          this.infoItems.forEach(function (e) {
            o.setItemTextByKey(e.key, A[e.key], e.hideItemIfEmpty);
          });
      }),
      (t.prototype.isMiniPanel = function () {
        var e = this.config.smallSizeThreshold,
          t = void 0 === e ? 400 : e;
        return this.player.container.clientWidth < t;
      }),
      (t.pluginName = InfoPanelPluginName$1),
      (t.Events = InfoPanelEvents),
      t
    );
  })(Plugin);
  function styleInject$2(e, t) {
    void 0 === t && (t = {});
    var o = t.insertAt;
    if (e && "undefined" != typeof document) {
      var A = document.head || document.getElementsByTagName("head")[0],
        i = document.createElement("style");
      (i.type = "text/css"),
        "top" === o && A.firstChild
          ? A.insertBefore(i, A.firstChild)
          : A.appendChild(i),
        i.styleSheet
          ? (i.styleSheet.cssText = e)
          : i.appendChild(document.createTextNode(e));
    }
  }
  H5Player.registerPlugin(InfoPanelPlugin.pluginName, InfoPanelPlugin);
  var css_248z$2 =
    ".txp_poster_img{position:absolute;left:0;top:0;width:100%;height:100%;z-index:2;-o-object-fit:contain;object-fit:contain}.txp_poster_img.txp_none{display:none}";
  styleInject$2(css_248z$2);
  var PosterPluginName$1 = "poster",
    hideClass = "txp_none",
    POSTER_IMAGE_ALT = "Thumbplayer Poster Plugin Image",
    POSTER_IMAGE_CLASS_NAME = "txp_poster_img",
    DEFAULT_RES = ["496", "360", "228"];
  function findPoster(e) {
    var t = e.vid,
      o = e.resolution,
      A = e.vidFirstPic,
      i = void 0 !== A && A,
      r = e.h5Defn,
      n = e.dir,
      a = void 0 === n ? "hz" : n;
    return i
      ? "https://puui.qpic.cn/vpic_cover/" +
          t +
          "/" +
          t +
          "_first.jpg/" +
          ("hz" === a ? "640x360" : "360x640")
      : o || DEFAULT_RES[r]
      ? "https://puui.qpic.cn/vpic_cover/" +
        t +
        "/" +
        t +
        "_hz.jpg/" +
        (o || DEFAULT_RES[r] || "0")
      : "https://puui.qpic.cn/vpic_cover/" + t + "/" + t + "_" + a + ".jpg";
  }
  var PosterPlugin = (function (e) {
    function t(t, o, A) {
      var i,
        r = e.call(this, t, o, A) || this;
      return (
        (r.config = __assign$1(__assign$1({}, t.config.poster || {}), o)),
        (r.objectFitMode =
          null === (i = t.config.videoElementConfig) || void 0 === i
            ? void 0
            : i.objectFit),
        (r.el = r.init()),
        r.tryShow(),
        r
      );
    }
    return (
      __extends$1(t, e),
      (t.prototype.destroy = function () {
        var t;
        e.prototype.destroy.call(this),
          null === (t = this.el) || void 0 === t || t.remove();
      }),
      (t.prototype.show = function (e) {
        this.el &&
          (e && (this.el.src = e), this.el.classList.remove(hideClass));
      }),
      (t.prototype.showByVid = function (e) {
        var t = e.vid,
          o = e.vidFirstPic,
          A = e.h5Defn,
          i = e.dir,
          r = e.resolution;
        if ((e.pcFmt, t)) {
          var n = findPoster({
            vid: t,
            vidFirstPic: o,
            h5Defn: A,
            dir: i,
            resolution: r,
          });
          this.show(n);
        }
      }),
      (t.prototype.hide = function () {
        this.el && this.el.classList.add(hideClass);
      }),
      (t.prototype.hookAdPlaying = function () {
        this.hide();
      }),
      (t.prototype.hookVideoPlaying = function (e) {
        e.isFirst && this.hide();
      }),
      (t.prototype.hookVideoEnd = function (e) {
        e.endState !== exports.END_STATE.NORMAL ||
          this.player.config.loop ||
          this.tryShow();
      }),
      (t.prototype.init = function () {
        var e,
          t = this.player.container,
          o = document.createElement("img");
        (o.alt = POSTER_IMAGE_ALT),
          o.classList.add(POSTER_IMAGE_CLASS_NAME, hideClass),
          this.objectFitMode &&
            domTool$1.css(o, { objectFit: this.objectFitMode }),
          t.prepend(o);
        var A = null === (e = this.config) || void 0 === e ? void 0 : e.zIndex;
        return A > 0 && domTool$1.css(o, { zIndex: A }), o;
      }),
      (t.prototype.tryShow = function () {
        var e, t;
        (null === (e = this.config) || void 0 === e ? void 0 : e.vid)
          ? this.showByVid(this.config)
          : (null === (t = this.config) || void 0 === t ? void 0 : t.src) &&
            this.show(this.config.src);
      }),
      (t.pluginName = PosterPluginName$1),
      t
    );
  })(Plugin);
  function styleInject$1(e, t) {
    void 0 === t && (t = {});
    var o = t.insertAt;
    if (e && "undefined" != typeof document) {
      var A = document.head || document.getElementsByTagName("head")[0],
        i = document.createElement("style");
      (i.type = "text/css"),
        "top" === o && A.firstChild
          ? A.insertBefore(i, A.firstChild)
          : A.appendChild(i),
        i.styleSheet
          ? (i.styleSheet.cssText = e)
          : i.appendChild(document.createTextNode(e));
    }
  }
  H5Player.registerPlugin(PosterPlugin.pluginName, PosterPlugin);
  var css_248z$1 =
      '.txp_alert_info{position:absolute;left:10px;bottom:67px;padding:2px 8px;line-height:24px;font-size:13px;text-align:left;color:#fff;background:rgba(0,0,0,.6);-webkit-transition:bottom .15s ease;transition:bottom .15s ease;z-index:2;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.txp_alert_info.txp_none{display:none}.txp_alert_info.ctrl_resize{bottom:107px}.txp_alert_info.ctrl_hide{bottom:20px}.txp_alert_info .txp_btn{-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;border:none;background:0 0;font-family:inherit;cursor:pointer;outline:0 none;font-size:1em}.txp_alert_info .txp_btn.txp_btn_close{position:relative;display:inline-block;margin-left:3px;width:14px;height:24px;vertical-align:top;color:#fff;cursor:pointer}.txp_alert_info .txp_btn.txp_btn_close:hover{color:#ff6429}.txp_alert_info .txp_btn.txp_btn_close:hover:before{background:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+PHBhdGggZmlsbD0iI0ZGNzgwMCIgZD0iTTEwLjUgMTBsLS41LjUtNC00LTQgNC0uNS0uNSA0LTQtNC00IC41LS41IDQgNCA0LTQgLjUuNS00IDQgNCA0eiIvPjwvc3ZnPg==) 50% no-repeat}.txp_alert_info .txp_btn.txp_btn_close:before{content:"";position:absolute;left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:12px;height:12px;background:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEwLjUgMTBsLS41LjUtNC00LTQgNC0uNS0uNSA0LTQtNC00IC41LS41IDQgNCA0LTQgLjUuNS00IDQgNCA0eiIvPjwvc3ZnPg==) 50% no-repeat;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;padding:0;text-indent:0}.txp_alert_info .txp_btn.txp_none{display:none}.txp_alert_info .txp_alert_content a,.txp_alert_info .txp_alert_content em{padding:0 1px;color:#ff6429;font-style:normal;font-weight:400}.txp_alert_info .txp_alert_content .txp_alert_text{display:inline}.txp_alert_info .txp_none{display:none}',
    HOTPOINT_EVENTS;
  styleInject$1(css_248z$1),
    (function (e) {
      (e.HOT_MOUSE_OVER = "ctrl:hotpoint-mouseover"),
        (e.HOT_MOUSE_MOVE = "ctrl:hotpoint-mousemove"),
        (e.HOT_MOUSE_OUT = "ctrl:hotpoint-mouseout");
    })(HOTPOINT_EVENTS || (HOTPOINT_EVENTS = {}));
  var CtrlbarPluginName$1 = "ctrlbar",
    CTRL_EVENTS = __assign$1(
      __assign$1(
        {
          FULLSCREEN_CHANGE: "windowFullscreenChange",
          FULLSCREEN_ERROR: "fullscreenError",
          FAKE_FULLSCREEN_CHANGE: "browserFullscreenChange",
          CLICK_PIPBTN: "ctrl:click-pipbtn",
          CLICK_NEXTBTN: "ctrl:click-nextbtn",
          CLICK_PLAYBTN: "ctrl:click-playbtn",
          CLICK_REPLAY: "ctrl:click-replay",
          CLICK_LOOP: "ctrl:click-loop",
          SET_LANGUAGE: "ctrl:set-language",
          SET_LEVEL: "ctrl:set-level",
          SET_AUDIO: "ctrl:set-audio",
          SET_PLAYRATE: "ctrl:set-playrate",
          SET_VOLUME: "ctrl:set-volume",
          TOGGLE_OVERLAY: "ctrl:toggle-overlay",
          MOUSE_DONW: "ctrl:progress-mousedown",
          MOUSE_DOWN: "ctrl:progress-mousedown",
          MOUSE_MOVE: "ctrl:progress-mousemove",
          MOUSE_UP: "ctrl:progress-mouseup",
          SHOW: "ctrl:show",
          HIDE: "ctrl:hide",
        },
        HOTPOINT_EVENTS
      ),
      {
        TEST_EVENT: "ctrl:inner-test-event",
        RESIZE: "ctrl:resize",
        SHOW_LEVELS: "ctrl:show-levels",
        HOVER_PROGRESS: "ctrl:hover-progress",
      }
    ),
    CTRL_SIZE,
    PlayBtnStatus;
  !(function (e) {
    (e.LARGE = "large"), (e.NORMAL = "normal");
  })(CTRL_SIZE || (CTRL_SIZE = {})),
    (function (e) {
      (e.PAUSE = "pause"),
        (e.PLAY = "play"),
        (e.REPLAY = "replay"),
        (e.STOP = "stop");
    })(PlayBtnStatus || (PlayBtnStatus = {}));
  var defaultShowTime = 3,
    classNameOnCtrlHide = "ctrl_hide",
    classNameOnCtrlResize = "ctrl_resize",
    TipsPluginName$1 = "tips",
    TipsPlugin = (function (e) {
      function t(t, o, A) {
        var i = e.call(this, t, o, A) || this;
        return (
          (i.hide = function () {
            i.el.removeEventListener("click", i.clickTips),
              (i.showOptions = null),
              i.el.classList.add(txpHideClass),
              i.emit(TipsEvents.Hide);
          }),
          (i.clickTips = function (e) {
            var t;
            if (i.showOptions) {
              var o =
                null === (t = e.target) || void 0 === t
                  ? void 0
                  : t.dataset.callback;
              o && "function" == typeof i.showOptions[o] && i.showOptions[o]();
            }
          }),
          i.prepareDOM(),
          i.initDOMVars(),
          !1 !== o.followCtrlbar && i.followCtrlbar(),
          i
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.destroy = function () {
          this.hide(), e.prototype.destroy.call(this);
        }),
        (t.prototype.show = function (e) {
          var t,
            o = !1,
            A = defaultShowTime;
          "string" == typeof e || "number" == typeof e
            ? (t = String(e))
            : ((t = e.text),
              (o = !!e.showClose),
              (A = e.time || defaultShowTime),
              (this.showOptions = e)),
            (this.$text.innerHTML = t),
            this.$close.classList.toggle(txpHideClass, !o),
            this.el.addEventListener("click", this.clickTips),
            this.el.classList.remove(txpHideClass),
            clearTimeout(this.timeoutId),
            -1 !== A &&
              (this.timeoutId = window.setTimeout(this.hide, 1e3 * A)),
            this.emit(TipsEvents.Show);
        }),
        (t.prototype.prepareDOM = function () {
          var e = this.player.container,
            t = document.createElement("div");
          (t.className = "txp_alert_info " + txpHideClass),
            (t.innerHTML =
              '<div class="txp_alert_content">\n      <div class="txp_alert_text"></div>\n      <button class="txp_btn txp_btn_close" title="鍏抽棴"></button>\n    </div>'),
            e.insertAdjacentElement("beforeend", t),
            (this.el = t);
        }),
        (t.prototype.initDOMVars = function () {
          (this.$text = this.el.querySelector(
            ".txp_alert_content .txp_alert_text"
          )),
            (this.$close = this.el.querySelector(".txp_btn_close")),
            this.$close.addEventListener("click", this.hide),
            isMobile && (this.el.style.bottom = "40px");
        }),
        (t.prototype.followCtrlbar = function () {
          var e = this;
          this.msg.on("pluginsetup:" + CtrlbarPluginName$1, function () {
            var t = e.player.plugins[CtrlbarPluginName$1];
            t.on(CTRL_EVENTS.SHOW, function () {
              e.el.classList.remove(classNameOnCtrlHide);
            }),
              t.on(CTRL_EVENTS.HIDE, function () {
                e.el.classList.add(classNameOnCtrlHide);
              }),
              t.on(CTRL_EVENTS.RESIZE, function (t) {
                var o = t.data;
                e.el.classList.toggle(
                  classNameOnCtrlResize,
                  o.size === CTRL_SIZE.LARGE
                );
              });
          });
        }),
        (t.pluginName = TipsPluginName$1),
        t
      );
    })(Plugin),
    TipsEvents;
  function styleInject(e, t) {
    void 0 === t && (t = {});
    var o = t.insertAt;
    if (e && "undefined" != typeof document) {
      var A = document.head || document.getElementsByTagName("head")[0],
        i = document.createElement("style");
      (i.type = "text/css"),
        "top" === o && A.firstChild
          ? A.insertBefore(i, A.firstChild)
          : A.appendChild(i),
        i.styleSheet
          ? (i.styleSheet.cssText = e)
          : i.appendChild(document.createTextNode(e));
    }
  }
  !(function (e) {
    (e.Show = "show"), (e.Hide = "hide");
  })(TipsEvents || (TipsEvents = {})),
    H5Player.registerPlugin(TipsPlugin.pluginName, TipsPlugin);
  var css_248z =
    "@-webkit-keyframes txp_overlay_play{0%{-webkit-transform:scale(.5);transform:scale(.5);opacity:1}to{-webkit-transform:scale(1);transform:scale(1);opacity:0}}@keyframes txp_overlay_play{0%{-webkit-transform:scale(.5);transform:scale(.5);opacity:1}to{-webkit-transform:scale(1);transform:scale(1);opacity:0}}.txp_contextmenu{background:rgba(30,30,32,.9);position:fixed;width:234px;z-index:9999;padding:10px 0;color:#bbb;overflow:hidden;font-size:12px}.txp_contextmenu.txp_none,.txp_contextmenu .txp_none{display:none}.txp_contextmenu .txp_clipboard{top:0;left:100%;position:absolute;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}.txp_contextmenu .txp_menuitem{padding-left:20px;height:34px;line-height:34px;cursor:pointer;max-width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.txp_contextmenu .txp_menuitem:hover{background-color:#26262b}.txp_overlay_link{position:absolute;left:0;top:0;width:100%;height:100%;z-index:5;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;visibility:hidden;font-size:14px}.txp_overlay_link.txp_show{display:-webkit-box;display:-ms-flexbox;display:flex;visibility:visible;-webkit-animation:txp_overlay_play 1s ease-out both;animation:txp_overlay_play 1s ease-out both;pointer-events:none}.txp_overlay_link .txp_icon_link{background:rgba(30,30,32,.9);width:60px;height:60px;border-radius:30px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.txp_overlay_link .txp_icon_link .txp_icon{position:relative;width:36px;height:36px;fill:#fff}";
  styleInject(css_248z);
  var UIContextMenuPluginName$1 = "context-menu",
    UIContextMenuPlugin = (function (e) {
      function t(t, o, A) {
        var i = e.call(this, t, o, A) || this;
        return (
          (i.menuConfig = []),
          (i.show = function () {
            i.$el.classList.remove(txpHideClass);
          }),
          (i.hide = function () {
            i.$el.classList.add(txpHideClass);
          }),
          (i.config = i.mergeConfig(o)),
          i.start(i.config.menus, { hideVInfo: i.config.hideVInfo }),
          i
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.start = function (e, t) {
          if (e && !(e.length <= 0))
            if (
              (!0 !== (null == t ? void 0 : t.hideVInfo) &&
                e.unshift({ role: "openvinfo", label: "瑙嗛淇℃伅" }),
              (this.menuConfig = e),
              this.$el)
            )
              this.$el.innerHTML =
                "\n      " +
                e
                  .map(function (e) {
                    return (
                      '<div class="txp_menuitem" data-role="' +
                      (e.role || "") +
                      '">' +
                      e.label +
                      "</div>"
                    );
                  })
                  .join("") +
                '\n      <textarea class="txp_clipboard" style="position: absolute; left: 100%; top: 0;"></textarea>\n      ';
            else {
              var o =
                  '\n    <div class="txp_contextmenu ' +
                  txpHideClass +
                  '" style="overflow:hidden">\n      ' +
                  e
                    .map(function (e) {
                      return (
                        '<div class="txp_menuitem" data-role="' +
                        (e.role || "") +
                        '">' +
                        e.label +
                        "</div>"
                      );
                    })
                    .join("") +
                  '\n      <textarea class="txp_clipboard" style="position: absolute; left: 100%; top: 0;"></textarea>\n    </div>\n    <div class="txp_overlay_link ' +
                  txpHideClass +
                  '">\n        <div class="txp_icon_link">\n            <svg class="txp_icon" viewBox="0 0 36 36" >\n              <path d="M26.5 26h-5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h5c2.5 0 4.5-2 4.5-4.5S29 14 26.5 14h-5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h5c4.1 0 7.5 3.4 7.5 7.5S30.6 26 26.5 26zM12 18.5c0-.8.7-1.5 1.5-1.5h9c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-9c-.8 0-1.5-.7-1.5-1.5zm2.5-4.5h-5C7 14 5 16 5 18.5S7 23 9.5 23h5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-5C5.4 26 2 22.6 2 18.5S5.4 11 9.5 11h5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"></path>\n            </svg>\n        </div>\n    </div>\n    ',
                A = this.player.container;
              A.insertAdjacentHTML("beforeend", o),
                (this.$el = A.querySelector(".txp_contextmenu")),
                (this.$link = A.querySelector(".txp_overlay_link")),
                this.bindDOMEvent();
            }
        }),
        (t.prototype.showSuccess = function () {
          var e, t;
          if (
            !isMobile &&
            !(null === (e = this.config) || void 0 === e
              ? void 0
              : e.disableSuccessTip) &&
            !(null === (t = this.config) || void 0 === t
              ? void 0
              : t.disableSuccussTip)
          ) {
            var o = this.$link,
              A = "txp_show";
            o.classList.remove(txpHideClass),
              o.classList.add(A),
              clearTimeout(this.sucTid),
              (this.sucTid = setTimeout(function () {
                o.classList.add(txpHideClass), o.classList.remove(A);
              }, 1e3));
          }
        }),
        (t.prototype.destroy = function () {
          [this.$el, this.$link].forEach(function (e) {
            return (null == e ? void 0 : e.parentNode) && e.remove();
          }),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.mergeConfig = function (e) {
          var t = this.player.config.contextMenuConfig;
          return __assign$1(__assign$1(__assign$1({}, t), e), {
            menus: __spreadArray(
              __spreadArray([], (null == t ? void 0 : t.menus) || [], !0),
              (null == e ? void 0 : e.menus) || [],
              !0
            ),
          });
        }),
        (t.prototype.bindDOMEvent = function () {
          var e = this,
            t = this.player.container;
          t.addEventListener("contextmenu", function (t) {
            if (!e.player.isPlayingAd) {
              e.show();
              var o = e.player.container.getBoundingClientRect(),
                A = o.left,
                i = o.top,
                r = o.width,
                n = o.height,
                a = t.clientX,
                s = t.clientY,
                g = e.$el,
                l = r + A - g.clientWidth,
                E = n + i - g.clientHeight,
                c = Math.min(l, a),
                u = Math.min(E, s);
              (e.$el.style.left = c + "px"),
                (e.$el.style.top = u + "px"),
                t.preventDefault();
            }
          }),
            t.addEventListener("click", this.hide),
            this.$el.addEventListener("click", function (t) {
              var o,
                A,
                i = t.target;
              e.showSuccess();
              var r =
                null === (o = e.menuConfig) || void 0 === o
                  ? void 0
                  : o.find(function (e) {
                      return e.role === i.dataset.role;
                    });
              "function" == typeof (null == r ? void 0 : r.callback) &&
                r.callback(e),
                "openvinfo" === i.dataset.role &&
                  (null === (A = e.player.plugins["info-panel"]) ||
                    void 0 === A ||
                    A.trigger()),
                e.emit("clickContextMenu", i.dataset);
            });
        }),
        (t.pluginName = UIContextMenuPluginName$1),
        t
      );
    })(Plugin);
  H5Player.registerPlugin(UIContextMenuPlugin.pluginName, UIContextMenuPlugin);
  var WaterMarkCoverClassName = "thumbplayer-watermark-cover",
    WatermarkPluginName$1 = "ui-watermark",
    MaxRequestRetry = 3,
    RequestTimeout = 5e3,
    LottieSDKUrl = "https://vm.gtimg.cn/thumbplayer/lottie/5.5.6/lottie.min.js",
    WatermarkError,
    WatermarkEvents,
    ActionWatermarkType,
    ReferenceType;
  function requestActionWatermark(e, t) {
    return __awaiter$1(this, void 0, void 0, function () {
      var o, A;
      return __generator$1(this, function (i) {
        switch (i.label) {
          case 0:
            if (!e) return [2, Promise.reject(o)];
            (A = 0), (i.label = 1);
          case 1:
            if (!(A < MaxRequestRetry)) return [3, 6];
            i.label = 2;
          case 2:
            return (
              i.trys.push([2, 4, , 5]),
              [4, netTool.jsonp(e, { timeout: RequestTimeout })]
            );
          case 3:
            return [2, parseActionWatermark(i.sent(), t)];
          case 4:
            return (
              i.sent(), (o = WatermarkError.WATERMARK_REQUEST_FAILED), [3, 5]
            );
          case 5:
            return A++, [3, 1];
          case 6:
            return [2, Promise.reject(o)];
        }
      });
    });
  }
  function parseActionWatermark(e, t) {
    for (
      var o = {},
        A = {},
        i = e.start,
        r = e.duration,
        n = e.repeat,
        a = e.rw,
        s = 0 === n ? Math.ceil(t / r) : n,
        g = function (t) {
          var n = i + t * r;
          e.scenes.forEach(function (e) {
            var i = e.wi,
              r = e.in,
              s = e.out,
              g = e.start,
              l = e.end;
            i.forEach(function (e) {
              (A[e.id] = __assign$1(__assign$1({}, e), {
                actionType: ActionWatermarkType.IMAGE,
                rw: a,
              })),
                o[e.id] || (o[e.id] = []),
                t >= g &&
                  (t <= l || 0 === t) &&
                  o[e.id].push({ start: (n + r) / 1e3, end: (n + s) / 1e3 });
            });
          });
        },
        l = 0;
      l < s;
      l++
    )
      g(l);
    return { schedules: o, watermarks: A };
  }
  function computeActualPlaytime(e, t, o) {
    var A = e;
    return (
      t.forEach(function (e) {
        A > e.start ? (A += e.end - e.start) : A + o > e.start && (A = e.end);
      }),
      A
    );
  }
  function computeTopLeftOffset(e, t, o, A, i) {
    var r = e[0] + o[0];
    (i !== ReferenceType.BOTTOM_RIGHT && i !== ReferenceType.TOP_RIGHT) ||
      (r = e[0] + t[0] - (o[0] + A[0]));
    var n = e[1] + o[1];
    return (
      (i !== ReferenceType.BOTTOM_RIGHT && i !== ReferenceType.BOTTOM_LEFT) ||
        (n = e[1] + t[1] - (o[1] + A[1])),
      [r, n]
    );
  }
  function computeCss(e, t, o) {
    var A = e.x,
      i = e.y,
      r = e.h,
      n = e.w,
      a = e.a,
      s = e.rw,
      g = void 0 === s ? 0 : s,
      l = e.position,
      E = void 0 === l ? ReferenceType.TOP_RIGHT : l,
      c = o.width,
      u = o.height;
    c <= 0 && (c = t.clientWidth), u <= 0 && (u = t.clientHeight);
    var p = g > 0 ? Math.min(u, c) / g : 1,
      d = A * p,
      B = i * p,
      h = r * p,
      I = n * p,
      C = Math.min(t.clientWidth / c, t.clientHeight / u),
      _ = c * C,
      f = u * C,
      y = Math.max((t.clientWidth - _) / 2, 0),
      m = Math.max((t.clientHeight - f) / 2, 0),
      v = I * C,
      Q = h * C,
      T = computeTopLeftOffset([y, m], [_, f], [d * C, B * C], [v, Q], E),
      S = T[0],
      D = T[1],
      R = {
        left: S + "px",
        top: D + "px",
        width: v + "px",
        height: Q + "px",
        position: "absolute",
        display: "block",
        opacity: "" + a / 100,
        userSelect: "none",
      };
    return (
      isInScreen({ x: y, y: m, w: _, h: f }, { x: S, y: D, w: v, h: Q }) ||
        (R.display = "none"),
      R
    );
  }
  function isInScreen(e, t) {
    var o = e.x,
      A = e.y,
      i = e.w,
      r = e.h,
      n = t.x,
      a = t.y,
      s = t.w,
      g = t.h;
    return !(n < o) && !(a < A) && !(n > o + i - s) && a <= A + r - g;
  }
  function offsetAnimationTime(e, t, o) {
    for (var A = 0, i = t; A < i.length; A++) {
      var r = i[A],
        n = r.start,
        a = r.end;
      if (!(e < n || e > a)) return (1e3 * (e - n)) % o;
    }
    return e;
  }
  function parseAnimationWatermark(e, t) {
    void 0 === t && (t = []);
    var o = e.rw,
      A = e.scenes,
      i = {},
      r = {};
    return (
      A.forEach(function (e) {
        var A = e.wi,
          n = e.stime;
        A.forEach(function (e, A) {
          var a = n.map(function (o) {
              return computeActualPlaytime(o / 1e3, t, e.duration / 1e3);
            }),
            s = "animation-id-" + A;
          (r[s] = __assign$1(__assign$1({}, e), {
            id: s,
            url: e.web_surl,
            actionType: ActionWatermarkType.LOTTIE,
            rw: o,
          })),
            (i[s] = a.map(function (t) {
              return { start: t, end: t + e.duration };
            }));
        });
      }),
      { schedules: i, watermarks: r }
    );
  }
  function loadLottie() {
    return __awaiter$1(this, void 0, void 0, function () {
      return __generator$1(this, function (e) {
        switch (e.label) {
          case 0:
            return window.lottie
              ? [2]
              : [4, domTool$1.loadScript(LottieSDKUrl)];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }
  function requestAnimationWatermark(e, t) {
    return __awaiter$1(this, void 0, void 0, function () {
      var o, A;
      return __generator$1(this, function (i) {
        switch (i.label) {
          case 0:
            if (!e) return [2, Promise.reject(o)];
            (A = 0), (i.label = 1);
          case 1:
            if (!(A < MaxRequestRetry)) return [3, 6];
            i.label = 2;
          case 2:
            return (
              i.trys.push([2, 4, , 5]),
              [4, netTool.jsonp(e, { timeout: RequestTimeout })]
            );
          case 3:
            return [2, parseAnimationWatermark(i.sent(), t)];
          case 4:
            return (
              i.sent(), (o = WatermarkError.WATERMARK_REQUEST_FAILED), [3, 5]
            );
          case 5:
            return A++, [3, 1];
          case 6:
            return [2, Promise.reject(o)];
        }
      });
    });
  }
  !(function (e) {
    e.WATERMARK_REQUEST_FAILED = "001";
  })(WatermarkError || (WatermarkError = {})),
    (function (e) {
      e.READY = "ready";
    })(WatermarkEvents || (WatermarkEvents = {})),
    (function (e) {
      (e.IMAGE = "image"), (e.LOTTIE = "lottie");
    })(ActionWatermarkType || (ActionWatermarkType = {})),
    (function (e) {
      (e[(e.TOP_RIGHT = 0)] = "TOP_RIGHT"),
        (e[(e.TOP_LEFT = 1)] = "TOP_LEFT"),
        (e[(e.BOTTOM_LEFT = 2)] = "BOTTOM_LEFT"),
        (e[(e.BOTTOM_RIGHT = 3)] = "BOTTOM_RIGHT");
    })(ReferenceType || (ReferenceType = {}));
  var AnimationWatermark = (function () {
      function e(e, t, o) {
        void 0 === o && (o = !1),
          (this.lottieAnimation = null),
          (this.shown = !1);
        var A = t.cfg,
          i = t.schedule,
          r = t.duration;
        (this.id = A.id),
          (this.config = t),
          (this.container = e),
          (this.schedule = i),
          (this.duration = r),
          this.initLottie(A.url),
          o ? this.show() : this.hide();
      }
      return (
        (e.prototype.destroy = function () {
          var e, t, o;
          null === (e = this.lottieAnimation) || void 0 === e || e.destroy(),
            (null === (t = this.element) || void 0 === t
              ? void 0
              : t.parentNode) &&
              (null === (o = this.element) || void 0 === o || o.remove()),
            (this.element = null),
            (this.lottieAnimation = null),
            (this.schedule = null),
            (this.config = null),
            (this.container = null);
        }),
        (e.prototype.restore = function () {
          this.initLottie(this.config.cfg.url);
        }),
        (e.prototype.play = function (e) {
          if (this.shown && this.lottieAnimation)
            if (void 0 !== e) {
              var t = offsetAnimationTime(e, this.schedule, this.duration);
              this.lottieAnimation.goToAndPlay(t);
            } else this.lottieAnimation.play();
        }),
        (e.prototype.pause = function () {
          this.shown && this.lottieAnimation && this.lottieAnimation.pause();
        }),
        (e.prototype.draw = function (e) {
          var t = this;
          this.element &&
            Object.keys(e).forEach(function (o) {
              var A;
              null === (A = t.element) ||
                void 0 === A ||
                A.style.setProperty(o, e[o]);
            });
        }),
        (e.prototype.show = function () {
          var e;
          null === (e = this.element) ||
            void 0 === e ||
            e.style.setProperty("display", "block"),
            (this.shown = !0);
        }),
        (e.prototype.hide = function () {
          var e;
          this.shown &&
            this.lottieAnimation &&
            (null === (e = this.element) ||
              void 0 === e ||
              e.style.setProperty("display", "none"),
            this.lottieAnimation.stop(),
            (this.shown = !1));
        }),
        (e.prototype.initLottie = function (e) {
          return __awaiter$1(this, void 0, void 0, function () {
            var t;
            return __generator$1(this, function (o) {
              switch (o.label) {
                case 0:
                  return this.createWatermarkNode(), [4, loadLottie()];
                case 1:
                  return o.sent(), [4, requireModule("lottie", "lottie")];
                case 2:
                  return (
                    (t = o.sent()),
                    (this.lottieAnimation =
                      null == t
                        ? void 0
                        : t.loadAnimation({
                            container: this.element,
                            loop: !0,
                            autoplay: !1,
                            path: e,
                          })),
                    [2]
                  );
              }
            });
          });
        }),
        (e.prototype.createWatermarkNode = function () {
          var e = this.config,
            t = this.container,
            o = e.css,
            A = document.createElement("div");
          Object.keys(o).forEach(function (e) {
            A.style.setProperty(e, o[e]);
          }),
            (this.element = A),
            t.appendChild(A);
        }),
        e
      );
    })(),
    CoverWatermark = (function () {
      function e(e, t) {
        (this.container = e),
          (this.config = t),
          (this.id = t.cfg.id),
          this.createWatermarkNode();
      }
      return (
        (e.prototype.draw = function (e) {}),
        (e.prototype.restore = function () {
          this.createWatermarkNode();
        }),
        (e.prototype.show = function () {
          var e;
          null === (e = this.element) ||
            void 0 === e ||
            e.style.setProperty("display", "block");
        }),
        (e.prototype.hide = function () {}),
        (e.prototype.play = function () {}),
        (e.prototype.pause = function () {}),
        (e.prototype.destroy = function () {
          var e;
          (null === (e = this.element) || void 0 === e
            ? void 0
            : e.parentNode) && this.element.remove(),
            (this.element = null),
            (this.container = null),
            (this.config = null);
        }),
        (e.prototype.createWatermarkNode = function () {
          var e = this.config,
            t = this.container;
          t.querySelectorAll("." + WaterMarkCoverClassName).forEach(function (
            e
          ) {
            return e.remove();
          });
          var o = document.createElement("div"),
            A = document.createElementNS("http://www.w3.org/2000/svg", "svg"),
            i = document.createElementNS("http://www.w3.org/2000/svg", "text"),
            r = e.svgConfig,
            n = void 0 === r ? {} : r,
            a = e.textConfig,
            s = void 0 === a ? {} : a,
            g = e.watermarkText;
          o.classList.add(WaterMarkCoverClassName);
          var l = __assign$1(
            {
              position: "absolute",
              width: "100%",
              height: "100%",
              userSelect: "none",
              zIndex: "1",
            },
            e.css
          );
          Object.keys(l).forEach(function (e) {
            o.style.setProperty(e, l[e]);
          }),
            A.setAttribute("xmlns", "http://www.w3.org/2000/svg");
          var E = __assign$1({ width: "200px", height: "200px" }, n);
          Object.keys(E).forEach(function (e) {
            A.setAttribute(e, E[e]);
          });
          var c = __assign$1(
            {
              stroke: "black",
              transform: "translate(20, 120) rotate(-30)",
              fill: "rgb(222, 222, 222)",
              opacity: 0.3,
              "stroke-opacity": 0.3,
              "stroke-width": 1,
              "font-size": "22",
            },
            s
          );
          return (
            Object.keys(c).forEach(function (e) {
              i.setAttribute(e, c[e]);
            }),
            (i.textContent = g),
            A.appendChild(i),
            (o.style.backgroundImage =
              'url("data:image/svg+xml;utf8,' +
              A.outerHTML.replace(/"/g, "'") +
              '")'),
            t.appendChild(o),
            (this.element = o),
            (this.config = e),
            o
          );
        }),
        e
      );
    })(),
    ImageWatermark = (function () {
      function e(e, t, o) {
        void 0 === o && (o = !1),
          (this.id = t.cfg.id),
          (this.config = t),
          (this.container = e),
          this.createWatermarkNode(),
          o ? this.show() : this.hide();
      }
      return (
        (e.prototype.play = function () {}),
        (e.prototype.pause = function () {}),
        (e.prototype.destroy = function () {
          var e;
          (null === (e = this.element) || void 0 === e
            ? void 0
            : e.parentNode) && this.element.remove(),
            (this.element = null),
            (this.config = null),
            (this.container = null);
        }),
        (e.prototype.restore = function () {
          this.createWatermarkNode();
        }),
        (e.prototype.show = function () {
          this.element.style.setProperty("display", "block");
        }),
        (e.prototype.hide = function () {
          var e;
          null === (e = this.element) ||
            void 0 === e ||
            e.style.setProperty("display", "none");
        }),
        (e.prototype.draw = function (e) {
          var t = this;
          this.element &&
            Object.keys(e).forEach(function (o) {
              t.element.style.setProperty(o, e[o]);
            });
        }),
        (e.prototype.createWatermarkNode = function () {
          var e = this.config,
            t = this.container,
            o = e.css,
            A = e.cfg,
            i = new Image();
          return (
            Object.keys(o).forEach(function (e) {
              i.style.setProperty(e, o[e]);
            }),
            (this.element = i),
            (this.element.onload = A.onload),
            (this.element.onerror = A.onerror),
            (this.element.src = A.url),
            (this.element.dataset.id = "" + A.id),
            t.appendChild(this.element),
            i
          );
        }),
        e
      );
    })(),
    WatermarkObserver = (function () {
      function e(e) {
        (this.watchList = {}),
          (this.container = e),
          this.initMutationObserver();
      }
      return (
        (e.prototype.destroy = function () {
          var e;
          null === (e = this.mutationObserver) ||
            void 0 === e ||
            e.disconnect(),
            (this.mutationObserver = null),
            (this.watchList = {});
        }),
        (e.prototype.watch = function (e, t) {
          this.watchList[e] = t;
        }),
        (e.prototype.unwatch = function (e) {
          delete this.watchList[e];
        }),
        (e.prototype.clear = function () {
          this.watchList = {};
        }),
        (e.prototype.initMutationObserver = function () {
          var e = this;
          this.mutationObserver && this.mutationObserver.disconnect(),
            (this.mutationObserver = new MutationObserver(function () {
              e.checkIfWatermarkRemoved();
            })),
            this.mutationObserver.observe(this.container, {
              childList: !0,
              subtree: !0,
              attributes: !0,
            });
        }),
        (e.prototype.checkIfWatermarkRemoved = function () {
          var e = this;
          this.container.offsetParent &&
            Object.keys(this.watchList).forEach(function (t) {
              var o,
                A = e.watchList[t];
              (null === (o = A.element) || void 0 === o
                ? void 0
                : o.offsetParent) || (A.restore(), A.show());
            });
        }),
        e
      );
    })(),
    Scheduler = (function () {
      function e(e) {
        (this.schedules = {}),
          (this.innerCurrentTime = 0),
          (this.onStatusChange = e);
      }
      return (
        Object.defineProperty(e.prototype, "currentTime", {
          set: function (e) {
            (this.innerCurrentTime = e), this.updateWatermarkStatus();
          },
          enumerable: !1,
          configurable: !0,
        }),
        (e.prototype.add = function (e, t) {
          var o, A, i;
          (null !== (A = (i = this.schedules)[e]) && void 0 !== A) ||
            (i[e] = []),
            (o = this.schedules[e]).push.apply(o, t);
        }),
        (e.prototype.remove = function (e) {
          this.schedules[e] &&
            (delete this.schedules[e], this.onStatusChange(e, !1));
        }),
        (e.prototype.get = function (e) {
          return this.schedules[e];
        }),
        (e.prototype.clear = function () {
          this.schedules = {};
        }),
        (e.prototype.destroy = function () {
          this.clear(), (this.onStatusChange = null);
        }),
        (e.prototype.updateWatermarkStatus = function () {
          var e = this;
          Object.keys(this.schedules).forEach(function (t) {
            var o = e.schedules[t].some(function (t) {
              var o = t.start,
                A = t.end,
                i = void 0 === A ? 1 / 0 : A;
              return e.innerCurrentTime > o && e.innerCurrentTime < i;
            });
            e.onStatusChange(t, o);
          });
        }),
        e
      );
    })(),
    str =
      '<txpdiv data-role="txp-ui-watermark-mod" class="txp-watermark">\n</txpdiv>',
    WatermarkPlugin = (function (e) {
      function t(t, o, A) {
        var i = e.call(this, t, o, A) || this;
        (i.watermarks = {}),
          (i.watermarkLoadingDefer = null),
          (i.observer = null),
          (i.onResize = function () {
            Object.values(i.watermarks).forEach(function (e) {
              var t = e[0],
                o = e[1];
              if (o) {
                var A = computeCss(o, i.player.container, i.player.videoSize);
                t.draw(A);
              }
            });
          }),
          (i.onWatermarkStatusChange = function (e, t) {
            if (i.watermarks[e]) {
              var o = i.watermarks[e][0];
              t ? (o.show(), o.play()) : (o.hide(), o.pause());
            }
          }),
          (i.config = __assign$1(
            __assign$1(
              { enableProtectionWatermark: !0, enableObserver: !1 },
              i.player.config.watermarkConfig || {}
            ),
            o
          )),
          (i.$watermarkContainer = i.prepareDom()),
          window.addEventListener("resize", i.onResize),
          t.on(exports.PLAY_EVENT.FULLSCREEN_CHANGE, i.onResize, -1);
        var r = i.config.defaultText;
        return (
          r && i.watermarkThis(r),
          i.setupPlayerEvents(),
          i.listenFakeFullscreen(),
          (i.scheduler = new Scheduler(i.onWatermarkStatusChange.bind(i))),
          i.config.enableObserver &&
            (i.observer = new WatermarkObserver(i.player.container)),
          i
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.add = function (e, t, o) {
          var A;
          void 0 === t && (t = !1), void 0 === o && (o = !1);
          var i = e.id;
          if (!this.watermarks[i]) {
            var r = this.watermarkFactory(e, t);
            return (
              (this.watermarks[i] = [r, e]),
              o &&
                (null === (A = this.observer) || void 0 === A || A.watch(i, r)),
              r
            );
          }
        }),
        (t.prototype.watch = function (e) {
          var t,
            o = this.watermarks[e][0];
          o && (null === (t = this.observer) || void 0 === t || t.watch(e, o));
        }),
        (t.prototype.unwatch = function (e) {
          var t;
          null === (t = this.observer) || void 0 === t || t.unwatch(e);
        }),
        (t.prototype.watermarkThis = function (e, t) {
          var o, A;
          void 0 === t && (t = {}),
            null === (o = this.observer) ||
              void 0 === o ||
              o.unwatch(WaterMarkCoverClassName);
          var i = {
              watermarkText: e,
              cfg: { id: "cover-" + e },
              svgConfig: t.svg || {},
              textConfig: t.text || {},
              css: {},
            },
            r = new CoverWatermark(this.player.container, i);
          (this.watermarks[WaterMarkCoverClassName] = [r, null]),
            null === (A = this.observer) ||
              void 0 === A ||
              A.watch(WaterMarkCoverClassName, r);
        }),
        (t.prototype.remove = function (e) {
          var t,
            o,
            A = (null !== (t = this.watermarks[e]) && void 0 !== t ? t : [])[0];
          A &&
            (null === (o = this.observer) || void 0 === o || o.unwatch(e),
            A.destroy(),
            delete this.watermarks[e],
            this.scheduler.remove(e));
        }),
        (t.prototype.clear = function () {
          var e;
          Object.values(this.watermarks).forEach(function (e) {
            return e[0].destroy();
          }),
            (this.watermarks = {}),
            null === (e = this.observer) || void 0 === e || e.clear(),
            this.scheduler.clear();
        }),
        (t.prototype.get = function (e) {
          return this.watermarks[e];
        }),
        (t.prototype.schedule = function (e, t, o) {
          var A;
          void 0 === o && (o = 1 / 0),
            this.scheduler.add(e, [{ start: t, end: o }]),
            null === (A = this.observer) || void 0 === A || A.unwatch(e);
        }),
        (t.prototype.unschedule = function (e) {
          this.scheduler.remove(e);
        }),
        (t.prototype.destroy = function () {
          var t, o, A;
          window.removeEventListener("resize", this.onResize),
            this.player.off(
              exports.PLAY_EVENT.FULLSCREEN_CHANGE,
              this.onResize
            ),
            null === (t = this.observer) || void 0 === t || t.destroy(),
            (this.observer = null),
            this.scheduler.destroy(),
            (this.scheduler = null),
            (null === (o = this.$watermarkContainer) || void 0 === o
              ? void 0
              : o.parentNode) &&
              (null === (A = this.$watermarkContainer) ||
                void 0 === A ||
                A.remove()),
            e.prototype.destroy.call(this);
        }),
        (t.prototype.hookPlaySessionStart = function () {
          this.clear();
        }),
        (t.prototype.hookVideoSetlevelEnd = function (e) {
          var t = this;
          e.code === exports.ErrorCode.SUC &&
            (this.clear(),
            this.watermarkLoadingDefer &&
              this.watermarkLoadingDefer.then(function (e) {
                t.addPendingData.apply(t, e);
              }));
        }),
        (t.prototype.hookVideoPlaying = function (e) {
          var t = this;
          this.watermarkLoadingDefer &&
            e.isFirst &&
            this.watermarkLoadingDefer.then(function (e) {
              t.addPendingData.apply(t, e);
            }),
            Object.keys(this.watermarks).forEach(function (e) {
              var o = t.watermarks[e][0];
              null == o || o.play();
            });
        }),
        (t.prototype.hookVideoPause = function (e) {
          var t = this;
          Object.keys(this.watermarks).forEach(function (e) {
            var o = t.watermarks[e][0];
            null == o || o.pause();
          });
        }),
        (t.prototype.hookVideoSeeked = function () {
          var e = this;
          Object.keys(this.watermarks).forEach(function (t) {
            var o = e.watermarks[t][0];
            null == o || o.play(e.player.playtime);
          });
        }),
        (t.prototype.hookVideoTimeupdate = function (e) {
          this.scheduler.currentTime = e.playtime;
        }),
        (t.prototype.watermarkFactory = function (e, t) {
          void 0 === t && (t = !1);
          var o = e.actionType;
          switch (void 0 === o ? ActionWatermarkType.IMAGE : o) {
            case ActionWatermarkType.IMAGE:
              return this.createImageWatermark(e, t);
            case ActionWatermarkType.LOTTIE:
              return this.createAnimationWatermark(e, t);
          }
        }),
        (t.prototype.createAnimationWatermark = function (e, t) {
          void 0 === t && (t = !1);
          var o = e.url,
            A = e.id,
            i = {
              css: computeCss(e, this.player.container, this.player.videoSize),
              cfg: { id: A, url: o },
              schedule: this.scheduler.get(A),
              duration: e.duration,
            };
          return new AnimationWatermark(this.$watermarkContainer, i, t);
        }),
        (t.prototype.createImageWatermark = function (e, t) {
          void 0 === t && (t = !1);
          var o = e.url,
            A = e.surl,
            i = e.id,
            r = {
              css: computeCss(e, this.player.container, this.player.videoSize),
              cfg: {
                id: i,
                url: A || o,
                onerror: function () {
                  this.remove();
                },
              },
            };
          return new ImageWatermark(this.$watermarkContainer, r, t);
        }),
        (t.prototype.setupPlayerEvents = function () {
          var e = this;
          this.msg.on(exports.PLAY_EVENT_EXT.GETINFO_OVER, function (t) {
            var o = t.data;
            e.watermarkLoadingDefer = new Promise(function (t) {
              return __awaiter$1(e, void 0, void 0, function () {
                var e, A, i, r, n, a, s, g, l, E, c, u, p, d, B, h;
                return __generator$1(this, function (I) {
                  switch (I.label) {
                    case 0:
                      if (!(e = o.parseData)) return [2];
                      (A = e.watermarkList),
                        (i = e.supplementaryInfo),
                        (r = e.duration),
                        (n = void 0 === r ? 0 : r),
                        (a = (i || {}).contentInfo),
                        (s = (a || {}).protectionWatermark),
                        this.config.enableProtectionWatermark &&
                          s &&
                          this.watermarkThis(s),
                        (g = []),
                        (l = {}),
                        (I.label = 1);
                    case 1:
                      return (
                        I.trys.push([1, 3, , 4]),
                        [
                          4,
                          requestActionWatermark(
                            null === (d = A) || void 0 === d
                              ? void 0
                              : d.action,
                            1e3 * n
                          ),
                        ]
                      );
                    case 2:
                      return (
                        (E = I.sent()),
                        (g = Object.keys(E.watermarks).map(function (e) {
                          return E.watermarks[e];
                        })),
                        (l = E.schedules),
                        [3, 4]
                      );
                    case 3:
                      return I.sent(), [3, 4];
                    case 4:
                      !g.length && (null == A ? void 0 : A.wi) && (g = A.wi),
                        (I.label = 5);
                    case 5:
                      return (
                        I.trys.push([5, 7, , 8]),
                        [
                          4,
                          requestAnimationWatermark(
                            null === (B = A) || void 0 === B
                              ? void 0
                              : B.animation,
                            null !== (h = null == a ? void 0 : a.ad) &&
                              void 0 !== h
                              ? h
                              : []
                          ),
                        ]
                      );
                    case 6:
                      return (
                        (c = I.sent()),
                        (u = c.watermarks),
                        (p = c.schedules),
                        g.push.apply(
                          g,
                          Object.keys(u).map(function (e) {
                            return u[e];
                          })
                        ),
                        (l = __assign$1(__assign$1({}, l), p)),
                        [3, 8]
                      );
                    case 7:
                      return I.sent(), [3, 8];
                    case 8:
                      return t([g, l]), [2];
                  }
                });
              });
            });
          });
        }),
        (t.prototype.addPendingData = function (e, t) {
          var o = this;
          t &&
            Object.keys(t).forEach(function (e) {
              return o.scheduler.add(e, t[e]);
            }),
            e &&
              e.forEach(function (e) {
                var t = e.actionType;
                o.add(e, !t, !t);
              }),
            (this.watermarkLoadingDefer = null);
        }),
        (t.prototype.prepareDom = function () {
          var e = this.player.container;
          return (
            e.insertAdjacentHTML("beforeend", str),
            e.querySelector('[data-role="txp-ui-watermark-mod"]')
          );
        }),
        (t.prototype.listenFakeFullscreen = function () {
          var e = this;
          this.msg.on("pluginsetup:ctrlbar", function () {
            e.player.plugins.ctrlbar.on("browserFullscreenChange", e.onResize);
          });
        }),
        (t.pluginName = WatermarkPluginName$1),
        t
      );
    })(Plugin);
  H5Player.registerPlugin(WatermarkPlugin.pluginName, WatermarkPlugin);
  var CtrlbarPluginName = CtrlbarPlugin.pluginName,
    ErrorPagePluginName = ErrorPagePlugin.pluginName,
    InfoPanelPluginName = InfoPanelPlugin.pluginName,
    PosterPluginName = PosterPlugin.pluginName,
    TipsPluginName = TipsPlugin.pluginName,
    UIContextMenuPluginName = UIContextMenuPlugin.pluginName,
    WatermarkPluginName = WatermarkPlugin.pluginName,
    ErrorPagePluginEvents = ErrorPagePlugin.Events,
    PLUGINS_URL =
      "https://vm.gtimg.cn/thumbplayer/plugins/thumbplayer-plugin-super-player-plugins/latest/index.min.js",
    SuperStepKey;
  (exports.SuperStepKey = void 0),
    (SuperStepKey = exports.SuperStepKey || (exports.SuperStepKey = {})),
    (SuperStepKey.READY_2_NEW = "ready2new"),
    (SuperStepKey.NEW = "new"),
    (SuperStepKey.NEW_2_PLAY = "new2play"),
    (SuperStepKey.FIRST_PLAYING = "firstPlaying"),
    (SuperStepKey.PREPARE_REQ = "prepareReq");
  var PLAY_CODEC = { AUTO: 0, H264: 1, H265: 2 },
    SUPER_END_STATE,
    SUPER_DATA_KEY;
  (exports.SUPER_END_STATE = void 0),
    (SUPER_END_STATE =
      exports.SUPER_END_STATE || (exports.SUPER_END_STATE = {})),
    (SUPER_END_STATE.PREVIEW = "preview"),
    (exports.SUPER_DATA_KEY = void 0),
    (SUPER_DATA_KEY = exports.SUPER_DATA_KEY || (exports.SUPER_DATA_KEY = {})),
    (SUPER_DATA_KEY.vodCGIUsed = "super:cgiUsed"),
    (SUPER_DATA_KEY.getinfoAdInfo = "getinfoAdInfo"),
    (SUPER_DATA_KEY.hlsAdRanges = "hlsAdRanges");
  var LOCAL_STORAGE_KEY = {
      ENV_CACHE: "__thumbplayer_env_cache",
      RENDER_STATS_INFO: "__thumbplayer_render_stats_info",
      DEGRADE_CODEC_TIME: "__thumbplayer_degradecodec_time",
      DYNAMIC_CONFIG: "__thumbplayer_dynamic_config",
    },
    ctrlbarPluginName = CtrlbarPluginName,
    contextMenuPluginName = UIContextMenuPluginName,
    SuperPlayerEnum = Object.freeze({
      __proto__: null,
      get SuperStepKey() {
        return exports.SuperStepKey;
      },
      PLAY_CODEC: PLAY_CODEC,
      get SUPER_END_STATE() {
        return exports.SUPER_END_STATE;
      },
      get SUPER_DATA_KEY() {
        return exports.SUPER_DATA_KEY;
      },
      LOCAL_STORAGE_KEY: LOCAL_STORAGE_KEY,
      ctrlbarPluginName: ctrlbarPluginName,
      contextMenuPluginName: contextMenuPluginName,
      adGlobalName: adGlobalName,
      adVersion: adVersion,
      adScriptMaxLoadTime: adScriptMaxLoadTime,
      skipAdDomainWhiteList: skipAdDomainWhiteList,
      isInDomainWhiteList: isInDomainWhiteList,
      get PlayBtnStatus() {
        return exports.PlayBtnStatus;
      },
      CTRL_EVENTS: CTRL_EVENTS$1,
      get CTRL_SIZE() {
        return exports.CTRL_SIZE;
      },
      TipsPluginName: TipsPluginName,
      ErrorPagePluginName: ErrorPagePluginName,
      PosterPluginName: PosterPluginName,
      CtrlbarPluginName: CtrlbarPluginName,
      InfoPanelPluginName: InfoPanelPluginName,
      WatermarkPluginName: WatermarkPluginName,
      UIContextMenuPluginName: UIContextMenuPluginName,
      PLUGINS_URL: PLUGINS_URL,
      ErrorPagePluginEvents: ErrorPagePluginEvents,
    }),
    SUPER_EVENTS;
  (exports.SUPER_EVENTS = void 0),
    (SUPER_EVENTS = exports.SUPER_EVENTS || (exports.SUPER_EVENTS = {})),
    (SUPER_EVENTS.DEGRADE_CODEC = "degradeCodec"),
    (SUPER_EVENTS.PREVIEW_START = "previewStart"),
    (SUPER_EVENTS.PREVIEW_END = "previewEnd"),
    (SUPER_EVENTS.GET_VIDEO_MARK_ALL_OVER = "getVideoMarkAllOver"),
    (SUPER_EVENTS.ENTER_HLS_AD = "enterHlsAd"),
    (SUPER_EVENTS.EXIT_HLS_AD = "exitHlsAd");
  var SuperPlayerEvt = Object.freeze({
      __proto__: null,
      get SUPER_EVENTS() {
        return exports.SUPER_EVENTS;
      },
    }),
    coreExportKeys = [
      "PLAY_EVENT",
      "VIDEO_STATE",
      "KERNEL_NAME",
      "PLAY_MODE",
      "END_STATE",
      "EvtEmitter",
      "kernelEvtBus",
      "preloadEvtBus",
      "PAUSE_TYPE",
      "commonTool",
      "uaTool",
      "Logger",
      "cookieTool",
      "lsTool",
      "urlTool",
      "i18nConfig",
      "domTool",
      "netTool",
      "videoTool",
      "stringTool",
      "VIDEO_CODEC",
      "AUDIO_CODEC",
      "CONTAINER_FORMAT",
    ],
    h5ExportKeys = [
      "H5_PLAY_EVENT",
      "COMMON_DATA_KEY",
      "DATA_EVENTS",
      "DRM_TYPE",
      "DRM_VALUE",
      "H5_EXT_EVENT",
      "AdPluginName",
      "FullScreenMode",
      "Plugin",
    ],
    superPlayerExportKeys = [
      "PLAY_CODEC",
      "CTRL_EVENTS",
      "SUPER_END_STATE",
      "SUPER_EVENTS",
      "ctrlbarPluginName",
      "contextMenuPluginName",
    ],
    tvkExportKeys = ["TVK_EVENTS", "TVK_EVENT_DETAILS"],
    _a,
    STATE;
  function bindExports(e) {
    var t = __spreadArray(
      __spreadArray(
        __spreadArray(__spreadArray([], coreExportKeys, !0), h5ExportKeys, !0),
        superPlayerExportKeys,
        !0
      ),
      tvkExportKeys,
      !0
    );
    (t = t.filter(function (t) {
      return void 0 === e[t];
    })).forEach(function (t) {
      [
        ThumbPlayerH5$1,
        ThumbPlayerCore$1,
        SuperPlayerEnum,
        SuperPlayerEvt,
        TVK$1,
      ].forEach(function (o) {
        (null == o ? void 0 : o[t]) && (e[t] = o[t]);
      });
    });
  }
  !(function (e) {
    (e[(e.enabled = 0)] = "enabled"), (e[(e.disabled = 1)] = "disabled");
  })(STATE || (STATE = {}));
  var AdType = {
      MidRoll: "ZC",
      HlsAd: "PHLS",
      BeforePlay: exports.AD_TYPE.PRE,
      BeforePlayCodeName: "LD",
      AfterPlay: exports.AD_TYPE.POST,
      AfterPlayCodeName: "HT",
    },
    AD_INFO_OP_TYPE;
  !(function (e) {
    e[(e.HLS_AD = 2)] = "HLS_AD";
  })(AD_INFO_OP_TYPE || (AD_INFO_OP_TYPE = {}));
  var disabledCtrlBarComps = [
      "playrate",
      "definition",
      "audiotrack",
      "language",
      "PlayBtn",
      "NextBtn",
      "Progress",
      "CtrlShow",
      "PictureInPicture",
    ],
    disabledCtrlBarCompsWhenHlsAd = [
      "playrate",
      "definition",
      "audiotrack",
      "language",
    ],
    disabledCtrlBarCompsMap =
      ((_a = {}),
      (_a[AdType.AfterPlay] = disabledCtrlBarComps),
      (_a[AdType.BeforePlay] = disabledCtrlBarComps),
      (_a[AdType.MidRoll] = disabledCtrlBarComps),
      (_a[AdType.HlsAd] = disabledCtrlBarCompsWhenHlsAd),
      _a);
  function parseGetinfoHlsAdRanges(e) {
    var t,
      o = [];
    if (!(null == e ? void 0 : e.adpinfo)) return o;
    var A = null;
    try {
      A = JSON.parse(e.adpinfo);
    } catch (e) {}
    return (
      null === (t = null == A ? void 0 : A.plugin_info) ||
        void 0 === t ||
        t.forEach(function (e) {
          +e.optype === AD_INFO_OP_TYPE.HLS_AD &&
            o.push({
              start: e.ad_offset_time,
              end: e.ad_offset_time + e.ad_dura,
            });
        }),
      o
    );
  }
  var AdLogic = (function () {
      function e(e, t) {
        var o = this;
        (this.player = e),
          (this.corePlayer = t),
          (this.isHlsAdPlaying = !1),
          (this.adSlotInfo = []),
          (this.logger = new Logger(this.player.config.instanceId, "AdLogic")),
          this.setEvts(!0),
          this.player.pluginMsg.once(
            "pluginsetup:".concat(AdPluginName),
            function () {
              var e, t;
              if (
                ((o.adPlugin = getAdPlugin(o.player.config.instanceId)),
                uaTool$1.browser.safari)
              )
                try {
                  null === (t = (e = o.adPlugin).setPhlsPlayType) ||
                    void 0 === t ||
                    t.call(e);
                } catch (e) {
                  o.logger.error("call adPlugin::setPhlsPlayType", e);
                }
              o.setAdPluginEvts(!0);
            }
          );
      }
      return (
        (e.prototype.destroy = function () {
          getAdPlugin(this.player.config.instanceId) &&
            this.setAdPluginEvts(!1),
            this.setEvts(!1),
            (this.player = null),
            (this.corePlayer = null);
        }),
        (e.prototype.setEvts = function (e) {
          var t,
            o,
            A = this;
          this.evtMap ||
            (this.evtMap = {
              player:
                ((t = {}),
                (t[exports.H5_PLAY_EVENT.AD_PLAYING] =
                  this.onAdPlaying.bind(this)),
                (t[exports.H5_PLAY_EVENT.AD_END] = this.onAdEnd.bind(this)),
                (t[exports.H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED] =
                  this.onAdAutoplayBlocked.bind(this)),
                (t[exports.H5_PLAY_EVENT.VIDEO_TIMEUPDATE] =
                  this.onVideoTimeUpdate.bind(this)),
                (t[exports.H5_PLAY_EVENT.AD_PAUSE] =
                  this.onAdPaused.bind(this)),
                (t[exports.H5_PLAY_EVENT.AD_RESUME] =
                  this.onAdResume.bind(this)),
                (t[exports.PLAY_EVENT.ENTER_INSERT_STREAM] =
                  this.onEnterInsertStream.bind(this)),
                (t[exports.PLAY_EVENT.EXIT_INSERT_STREAM] =
                  this.onExitInsertStream.bind(this)),
                t),
              adPlugin: {
                enterCountdownCompleteEvt: this.onWillPlayMidRollAd.bind(this),
                enterCountdownEvt: this.onEnterMidRollAdCountdown.bind(this),
              },
              msg:
                ((o = {}),
                (o[exports.PLAY_EVENT_EXT.GETINFO_OVER] =
                  this.onVideoReqInfoEnd.bind(this)),
                o),
            });
          var i = e ? this.player.on : this.player.off;
          Object.keys(this.evtMap.player).forEach(function (e) {
            i.apply(A.player, [e, A.evtMap.player[e]]);
          });
          var r = e ? this.player.on : this.player.off;
          Object.keys(this.evtMap.msg).forEach(function (e) {
            r.apply(A.player.pluginMsg, [e, A.evtMap.msg[e]]);
          });
        }),
        (e.prototype.setAdPluginEvts = function (e) {
          var t = this,
            o = getAdPlugin(this.player.config.instanceId),
            A = e ? o.on : o.off;
          Object.keys(this.evtMap.adPlugin).forEach(function (e) {
            A.apply(o, [e, t.evtMap.adPlugin[e]]);
          });
        }),
        (e.prototype.onAdPlaying = function (e) {
          var t,
            o,
            A,
            i,
            r = this;
          null ===
            (A = (((t = {})[AdType.BeforePlay] = function () {
              return r.setCtrlBarState(STATE.disabled, AdType.BeforePlay);
            }),
            (t[AdType.MidRoll] = function () {
              return r.setCtrlBarState(STATE.disabled, AdType.MidRoll);
            }),
            (t[AdType.AfterPlay] = function () {
              return r.setCtrlBarState(STATE.disabled, AdType.AfterPlay);
            }),
            t)[null === (o = e.data) || void 0 === o ? void 0 : o.adType]) ||
            void 0 === A ||
            A.apply(this),
            null === (i = this.player.loadingPlugin) ||
              void 0 === i ||
              i.hide();
        }),
        (e.prototype.onAdPaused = function () {
          var e = this.player.ctrlbarPlugin;
          e &&
            !uaTool$1.mobile &&
            (e.show(!0), e.setCompDisable("PlayBtn", !1));
        }),
        (e.prototype.onAdResume = function (e) {
          var t = e.data.adtype,
            o = [
              AdType.AfterPlayCodeName,
              AdType.MidRoll,
              AdType.BeforePlayCodeName,
            ],
            A = this.player.ctrlbarPlugin;
          A && !uaTool$1.mobile && o.includes(t) && A.setCompDisable("PlayBtn");
        }),
        (e.prototype.onAdEnd = function (e) {
          var t,
            o,
            A,
            i = this;
          null ===
            (A = (((t = {})[AdType.BeforePlay] = function () {
              return i.setCtrlBarState(STATE.enabled, AdType.BeforePlay);
            }),
            (t[AdType.MidRoll] = function () {
              i.setCtrlBarState(STATE.enabled, AdType.MidRoll), i.player.play();
            }),
            (t[AdType.AfterPlay] = function () {
              return i.setCtrlBarState(STATE.enabled, AdType.AfterPlay);
            }),
            t)[null === (o = e.data) || void 0 === o ? void 0 : o.adType]) ||
            void 0 === A ||
            A.apply(this);
        }),
        (e.prototype.onAdAutoplayBlocked = function (e) {
          var t;
          if (e.data.adType === AdType.BeforePlay) {
            null === (t = this.player.loadingPlugin) ||
              void 0 === t ||
              t.hide();
            var o = this.player.ctrlbarPlugin;
            o &&
              (o.show(!0),
              o.setCompDisable("PlayBtn", !1),
              o.setCompDisable(["PictureInPicture", "playrate"], !0));
          }
        }),
        (e.prototype.onWillPlayMidRollAd = function () {
          this.player.pause();
          try {
            getAdPlugin(this.player.config.instanceId).playAd({
              adType: AdType.MidRoll,
            });
          } catch (e) {
            this.logger.error("playMidRollAd, call adPlugin::playAd", e);
          }
        }),
        (e.prototype.onEnterMidRollAdCountdown = function () {
          this.setCtrlBarState(STATE.disabled, AdType.MidRoll);
        }),
        (e.prototype.setCtrlBarState = function (e, t) {
          var o = this.player.plugins[CtrlbarPluginName];
          if (o) {
            var A = disabledCtrlBarCompsMap[t];
            if ((o.setCompDisable(A, !!e), t === AdType.HlsAd));
            else o.setHotKeysDisable(!!e);
          }
        }),
        (e.prototype.onVideoReqInfoEnd = function (e) {
          var t,
            o,
            A,
            i,
            r = e.data,
            n = ((null == r ? void 0 : r.parseData) || {}).vitem;
          if (!(null == r ? void 0 : r.error)) {
            if (!(null == n ? void 0 : n.ad))
              return (
                this.player.setCommonKv(
                  exports.SUPER_DATA_KEY.hlsAdRanges,
                  null
                ),
                void this.player.setCommonKv(
                  exports.SUPER_DATA_KEY.getinfoAdInfo,
                  null
                )
              );
            var a = parseGetinfoHlsAdRanges(n.ad);
            this.player.setCommonKv(exports.SUPER_DATA_KEY.hlsAdRanges, a),
              this.player.setCommonKv(
                exports.SUPER_DATA_KEY.getinfoAdInfo,
                n.ad
              ),
              (this.adSlotInfo = commonTool$1.mergeTimeRanges(
                null !==
                  (i =
                    null ===
                      (A =
                        null ===
                          (o =
                            null === (t = r.parseData) || void 0 === t
                              ? void 0
                              : t.supplementaryInfo) || void 0 === o
                          ? void 0
                          : o.contentInfo) || void 0 === A
                      ? void 0
                      : A.ad) && void 0 !== i
                  ? i
                  : []
              )),
              this.logger.log(
                "hlsAdRanges from srv is ".concat(
                  a.map(function (e) {
                    return "[".concat(e.start, ", ").concat(e.end, "]");
                  })
                )
              );
          }
        }),
        (e.prototype.onVideoTimeUpdate = function (e) {
          var t = (e.data || {}).playtime;
          uaTool$1.browser.safari ||
            t <= 0 ||
            this.checkWhetherEnterOrExitHlsAd(t);
        }),
        (e.prototype.checkWhetherEnterOrExitHlsAd = function (e) {
          var t = this.player.getCommonKv(exports.SUPER_DATA_KEY.hlsAdRanges);
          if (!t || t.length <= 0) this.exitHlsAd();
          else {
            var o = t.find(function (t) {
              return t.start <= e && e <= t.end;
            });
            !this.isHlsAdPlaying && o
              ? this.enterHlsAd(e, o)
              : this.isHlsAdPlaying && !o && this.exitHlsAd();
          }
        }),
        (e.prototype.enterHlsAd = function (e, t) {
          this.isHlsAdPlaying ||
            (this.logger.log(
              "enter hlsAd, playtime="
                .concat(e, ", range=[")
                .concat(t.start, ", ")
                .concat(t.end, "]")
            ),
            (this.isHlsAdPlaying = !0),
            this.player.emit(exports.SUPER_EVENTS.ENTER_HLS_AD, {
              hlsAdRange: t,
            }));
        }),
        (e.prototype.exitHlsAd = function () {
          this.isHlsAdPlaying &&
            (this.logger.log("exit hlsAd...."),
            (this.isHlsAdPlaying = !1),
            this.player.emit(exports.SUPER_EVENTS.EXIT_HLS_AD));
        }),
        (e.prototype.onEnterInsertStream = function (e) {
          var t,
            o,
            A,
            i,
            r = (
              null !== (t = null == e ? void 0 : e.data) && void 0 !== t
                ? t
                : {}
            ).index;
          this.logger.log("enter insert stream", this.adSlotInfo[r]);
          var n =
            null === (o = this.adSlotInfo) || void 0 === o ? void 0 : o[r];
          n &&
            (this.setCtrlBarState(STATE.disabled, AdType.HlsAd),
            null ===
              (i =
                null === (A = this.adPlugin) || void 0 === A
                  ? void 0
                  : A.startSoloPlayPhls) ||
              void 0 === i ||
              i.call(A, n.start),
            this.player.emit(exports.H5_PLAY_EVENT.AD_PLAYING, {
              adType: AdType.HlsAd,
            }));
        }),
        (e.prototype.onExitInsertStream = function (e) {
          var t,
            o,
            A,
            i = (
              null !== (t = null == e ? void 0 : e.data) && void 0 !== t
                ? t
                : {}
            ).index;
          this.logger.log("exit insert stream", this.adSlotInfo[i]),
            this.setCtrlBarState(STATE.enabled, AdType.HlsAd),
            null ===
              (A =
                null === (o = this.adPlugin) || void 0 === o
                  ? void 0
                  : o.endSoloPlayPhls) ||
              void 0 === A ||
              A.call(o),
            this.player.emit(exports.H5_PLAY_EVENT.AD_END, {
              code: exports.ErrorCode.SUC,
              adType: AdType.HlsAd,
            });
        }),
        e
      );
    })(),
    PosterLogic = (function () {
      function e(e) {
        (this.player = e),
          (this.hasPostAdInPlaySession = !1),
          this.setEvts(!0),
          this.showDefaultPoster();
      }
      return (
        (e.prototype.destroy = function () {
          this.setEvts(!1), (this.player = null);
        }),
        (e.prototype.showDefaultPoster = function () {
          var e = this,
            t = this.player.config,
            o = t.videoId,
            A = t.type,
            i = t.videoInitConfig,
            r = o;
          if (i)
            if ("string" == typeof i) r = i;
            else {
              var n = i.vid;
              n && (r = n);
            }
          A === exports.PLAY_MODE.VOD && r && e.showPoster(r);
        }),
        (e.prototype.showPoster = function (e) {
          var t = this.player.config,
            o = t.poster,
            A = t.disablePoster,
            i = t.type,
            r = this.player.getPlugin(PosterPluginName);
          !A &&
            r &&
            ((null == o ? void 0 : o.src)
              ? r.show(o.src)
              : i !== exports.PLAY_MODE.VOD
              ? r.show(
                  "https://puui.qpic.cn/vupload/0/20171225_1514277750947.jpeg/0"
                )
              : e &&
                "string" == typeof e &&
                r.showByVid(__assign$1(__assign$1({}, o), { vid: e })));
        }),
        (e.prototype.setEvts = function (e) {
          var t,
            o = this;
          this.evtMap ||
            (this.evtMap =
              (((t = {})[exports.H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED] =
                this.onAdAutoplayBlocked.bind(this)),
              (t[exports.H5_PLAY_EVENT.AD_PLAYING] =
                this.onAdPlaying.bind(this)),
              (t[exports.H5_PLAY_EVENT.PLAY_SESSION_END] =
                this.onPlaySessionEnd.bind(this)),
              t));
          var A = e ? this.player.on : this.player.off;
          Object.keys(this.evtMap).forEach(function (e) {
            A.apply(o.player, [e, o.evtMap[e]]);
          });
        }),
        (e.prototype.onAdAutoplayBlocked = function (e) {
          e.data.adType === exports.AD_TYPE.PRE &&
            this.showPoster(this.player.vid);
        }),
        (e.prototype.onAdPlaying = function (e) {
          e.data.adType === exports.AD_TYPE.POST &&
            (this.hasPostAdInPlaySession = !0);
        }),
        (e.prototype.waitSessionStart = function () {
          var e = this;
          return new Promise(function (t) {
            var o = function () {
              return t(!0);
            };
            e.player.once(exports.H5_PLAY_EVENT.PLAY_SESSION_START, o),
              setTimeout(function () {
                var A;
                null === (A = e.player) ||
                  void 0 === A ||
                  A.off(exports.H5_PLAY_EVENT.PLAY_SESSION_START, o),
                  t(!1);
              }, SESSION_DURATION);
          });
        }),
        (e.prototype.onPlaySessionEnd = function (e) {
          var t = e.data;
          return __awaiter$1(this, void 0, void 0, function () {
            var e, o;
            return __generator$1(this, function (A) {
              switch (A.label) {
                case 0:
                  return (
                    (e = t.curFlowNodeName),
                    (o = t.endState),
                    this.hasPostAdInPlaySession
                      ? ((this.hasPostAdInPlaySession = !1),
                        this.showPoster(this.player.vid),
                        [2])
                      : AD_FLOW_NODE_NAME_REG.test(e) &&
                        o !== exports.END_STATE.NORMAL
                      ? [4, this.waitSessionStart()]
                      : [3, 2]
                  );
                case 1:
                  !A.sent() && this.showPoster(this.player.vid), (A.label = 2);
                case 2:
                  return [2];
              }
            });
          });
        }),
        e
      );
    })(),
    AD_FLOW_NODE_NAME_REG = /AdFlowNode/i,
    SESSION_DURATION = 400,
    UrlParamKey;
  function checkParams(e, t, o) {
    if (t && o) {
      for (
        var A = i18nConfig.superPlayer,
          i = [
            {
              checker: function () {
                return "string" != typeof o && !o.vid && !o.cnlid && !o.url;
              },
              msg: compile(A.ERROR_EMPTY_PARAM),
            },
            {
              checker: function () {
                return e === exports.PLAY_MODE.LIVE && "load" === t;
              },
              msg: compile(A.ERROR_LOAD_PARAM_NOT_SUPPORT),
            },
            {
              checker: function () {
                return e === exports.PLAY_MODE.LIVE && "play" === t && o.vid;
              },
              msg: compile(A.ERROR_VID_NOT_SUPPORT),
            },
            {
              checker: function () {
                return e === exports.PLAY_MODE.VOD && o.cnlid;
              },
              msg: compile(A.ERROR_CNLID_NOT_SUPPORT),
            },
            {
              checker: function () {
                var e = "string" == typeof o ? o : o.vid;
                return "" === e || (e && !/^\w{11}$/.test(e));
              },
              msg: compile(A.ERROR_VID_INVALID),
            },
          ],
          r = 0,
          n = i.length;
        r < n;
        r++
      )
        if (i[r].checker()) return i[r].msg;
      return null;
    }
  }
  function formatDefnName(e, t) {
    if ((void 0 === t && (t = !1), t)) return formatLiveDefnName(e);
    var o = null == e ? void 0 : e.match(/(.*);\((.*)\)/);
    return (null == o ? void 0 : o.length) >= 3
      ? [o[1], o[2]]
      : [null != e ? e : "", ""];
  }
  function formatLiveDefnName(e) {
    var t = e.split(" ");
    return [t[0], t[1]];
  }
  function getIsOfficialScenes() {
    return [
      /^http(s?):\/\/v\.qq(\.com)\/x\/(cover|page)\//.test(location.href),
      uaTool$1.browser.qqlive,
    ].some(function (e) {
      return e;
    });
  }
  function isOfficialDomain() {
    return /^http(s?):\/\/(.*)\.(qq|woa|oa)\.com/.test(location.href);
  }
  function getTxVideoPageURLByVid(e, t, o) {
    if (!e) return "";
    t = "0" !== t ? "_".concat(t) : "";
    var A = e.substr(0, 1),
      i = e.substr(e.length - 2, 1),
      r = e.substr(e.length - 1, 1),
      n = ""
        .concat("https://v.qq.com/page", "/")
        .concat(A, "/")
        .concat(i, "/")
        .concat(r, "/")
        .concat(e)
        .concat(t, ".html");
    return o && (n += "?start=".concat(o)), n;
  }
  function getEnvVals() {
    var e = "npm";
    try {
      e = "cdn";
    } catch (e) {}
    var t = "";
    try {
      t = "1.28.0";
    } catch (e) {}
    var o = "";
    try {
      o = "1697610063807";
    } catch (e) {}
    var A = !1;
    try {
      A = "1" === process.env.__LOCAL_DEV__;
    } catch (e) {}
    var i = !1;
    try {
      i = !1;
    } catch (e) {}
    return {
      CHANNEL: e,
      VERSION: i ? "".concat(t, "-beta") : t,
      BUILD_TIME: o,
      LOCAL_DEV: A,
    };
  }
  function getDebugModeFromUrl() {
    return (
      "1" === urlTool$1.getUrlParamByKey(location.href, UrlParamKey.debugSuper)
    );
  }
  function getLogLevelFromUrl() {
    var e = +urlTool$1.getUrlParamByKey(location.href, UrlParamKey.logLevel);
    return isNaN(e) ? PLAYER_LOG_LEVEL.NONE : e;
  }
  function getForceCodecFromUrl() {
    return urlTool$1.getUrlParamByKey(location.href, UrlParamKey.forceCodec);
  }
  function getTestProxyHttpPath() {
    return "1" ===
      urlTool$1.getUrlParamByKey(location.href, UrlParamKey.testSrv)
      ? "https://testvd.l.qq.com/proxyhttp"
      : void 0;
  }
  !(function (e) {
    (e.debugSuper = "__debugSuper"),
      (e.logLevel = "__logLevel"),
      (e.downloadKit = "__downloadKit"),
      (e.forceCodec = "__forceCodec"),
      (e.testSrv = "__testSrv");
  })(UrlParamKey || (UrlParamKey = {}));
  var PreviewLogic = (function () {
      function e(e) {
        var t = this;
        (this.player = e),
          (this.previewDuration = NO_PREVIEW_FLAG),
          (this.previewStartPosition = 0),
          (this.isPreviewEnd = !1),
          (this.lastHotKeysDisabled = !1),
          (this.lastCtrlShowDisabled = !1),
          (this.previewStartTimeOnLive = 0),
          (this.previewRemainCount = 0),
          (this.onVideoSessionStart = function () {
            t.ctrlPlugin && t.isVod && (t.ctrlPlugin.duration = void 0);
          }),
          (this.onVideoReqInfoEnd = function (e) {
            var o = e.data,
              A = o.code,
              i = o.data;
            if (A === exports.ErrorCode.SUC) {
              var r = (null == i ? void 0 : i.parseData) || {},
                n = r.preview,
                a = r.duration,
                s = r.previewRemainCount,
                g = r.supplementaryInfo,
                l = (null != g ? g : {}).contentInfo,
                E = null != l ? l : {},
                c = E.preview,
                u = E.previewStartPosition,
                p = void 0 === u ? 0 : u,
                d = null != c ? c : n;
              Number.isNaN(d) ||
                d <= 0 ||
                ((t.previewDuration = d),
                (t.previewRemainCount = s),
                (t.previewStartPosition = p),
                t.isVod
                  ? (t.showTips(),
                    t.ctrlPlugin &&
                      ((t.player.ctrlbarPlugin.duration = uaTool$1.mobile
                        ? t.previewDuration
                        : a),
                      uaTool$1.mobile || t.setCtrlMaxPercent((d + p) / a)))
                  : t.showTips(),
                t.player.emit(exports.SUPER_EVENTS.PREVIEW_START, {
                  previewDuration: d,
                  previewStartPosition: p,
                }));
            }
          }),
          (this.onVideoPlaying = function (e) {
            if (
              (e.data.isFirst && (t.previewStartTimeOnLive = +new Date()),
              t.isPreviewEnd)
            ) {
              if (((t.isPreviewEnd = !1), !t.ctrlPlugin)) return;
              t.restoreCtrlBarAction();
            }
          }),
          (this.onVideoTimeUpdate = function (e) {
            var o = e.data.playtime;
            (t.isVod
              ? t.checkPreviewOverOnVodMode(o)
              : t.checkPreviewOverOnLiveMode()) &&
              ((t.isPreviewEnd = !0),
              t.player.emit(exports.SUPER_EVENTS.PREVIEW_END, {
                previewDuration: t.previewDuration,
                previewRemainCount: t.previewRemainCount,
              }));
          }),
          (this.onPlaySessionEnd = function () {
            var e;
            t.previewDuration !== NO_PREVIEW_FLAG &&
              (null === (e = t.player.tipsPlugin) || void 0 === e || e.hide()),
              (t.previewDuration = NO_PREVIEW_FLAG),
              (t.previewStartTimeOnLive = 0),
              (t.previewStartPosition = 0),
              t.ctrlPlugin &&
                (t.setCtrlMaxPercent(1), t.restoreCtrlBarAction());
          }),
          (this.onVideoPause = function () {
            t.isPreviewEnd &&
              t.setCtrlPlayBtnStatus(exports.PlayBtnStatus.REPLAY);
          }),
          this.setPreviewListener(!0);
      }
      return (
        (e.prototype.destroy = function () {
          this.setPreviewListener(!1), (this.player = null);
        }),
        (e.prototype.setPreviewListener = function (e) {
          var t = e
            ? this.player.on.bind(this.player)
            : this.player.off.bind(this.player);
          t(exports.H5_PLAY_EVENT.PLAY_SESSION_START, this.onVideoSessionStart),
            t(exports.H5_PLAY_EVENT.VIDEO_REQ_INFO_END, this.onVideoReqInfoEnd),
            t(exports.H5_PLAY_EVENT.VIDEO_PLAYING, this.onVideoPlaying),
            t(exports.H5_PLAY_EVENT.VIDEO_TIMEUPDATE, this.onVideoTimeUpdate),
            t(exports.H5_PLAY_EVENT.VIDEO_PAUSE, this.onVideoPause),
            t(exports.H5_PLAY_EVENT.PLAY_SESSION_END, this.onPlaySessionEnd);
        }),
        (e.prototype.checkPreviewOverOnVodMode = function (e) {
          var t = this;
          return (
            !(
              this.previewDuration === NO_PREVIEW_FLAG ||
              (e < this.previewStartPosition + this.previewDuration &&
                e >= this.previewStartPosition) ||
              this.isPreviewEnd
            ) &&
            (uaTool$1.mobile
              ? setTimeout(function () {
                  t.player.corePlayer.stop(exports.SUPER_END_STATE.PREVIEW);
                })
              : (this.player.pause(), this.disableCtrlAction()),
            !0)
          );
        }),
        (e.prototype.checkPreviewOverOnLiveMode = function () {
          var e = this;
          return (
            !(
              this.previewDuration === NO_PREVIEW_FLAG ||
              this.previewStartTimeOnLive <= 0 ||
              this.isPreviewEnd ||
              +new Date() - this.previewStartTimeOnLive <=
                1e3 * this.previewDuration
            ) &&
            (setTimeout(function () {
              e.player.corePlayer.stop(exports.SUPER_END_STATE.PREVIEW);
            }),
            !0)
          );
        }),
        (e.prototype.setCtrlPlayBtnStatus = function (e) {
          var t,
            o,
            A =
              null ===
                (o =
                  null === (t = this.ctrlPlugin) || void 0 === t
                    ? void 0
                    : t.instances) || void 0 === o
                ? void 0
                : o.PlayBtn;
          A && (A.el.dataset.status = e);
        }),
        (e.prototype.setCtrlMaxPercent = function (e) {
          var t, o;
          void 0 === e && (e = 1);
          var A =
            null ===
              (o =
                null === (t = this.ctrlPlugin) || void 0 === t
                  ? void 0
                  : t.instances) || void 0 === o
              ? void 0
              : o.Progress;
          A && (A.maxPercent = e);
        }),
        (e.prototype.disableCtrlAction = function () {
          this.ctrlPlugin &&
            ((this.lastHotKeysDisabled =
              this.ctrlPlugin.getIsHotKeysDisabled()),
            (this.lastCtrlShowDisabled = this.ctrlShow.shadowClickDisabled),
            (this.ctrlShow.shadowClickDisabled = !0),
            this.ctrlPlugin.setHotKeysDisable(!0));
        }),
        (e.prototype.restoreCtrlBarAction = function () {
          this.ctrlPlugin &&
            (this.ctrlPlugin.setHotKeysDisable(this.lastHotKeysDisabled),
            (this.ctrlShow.shadowClickDisabled = this.lastCtrlShowDisabled));
        }),
        (e.prototype.showTips = function () {
          var e;
          if (!getIsOfficialScenes()) {
            var t = commonTool$1.formatPlayTime(this.previewDuration),
              o = getTxVideoPageURLByVid(this.player.vid, "0");
            null === (e = this.player.tipsPlugin) ||
              void 0 === e ||
              e.show({
                text: compile(i18nConfig.superPlayer.PREVIEW_TIPS, t, o),
                time: -1,
              });
          }
        }),
        Object.defineProperty(e.prototype, "isVod", {
          get: function () {
            return this.player.config.type === exports.PLAY_MODE.VOD;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "ctrlShow", {
          get: function () {
            var e, t;
            return null ===
              (t =
                null === (e = this.ctrlPlugin) || void 0 === e
                  ? void 0
                  : e.instances) || void 0 === t
              ? void 0
              : t.CtrlShow;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(e.prototype, "ctrlPlugin", {
          get: function () {
            return this.player.plugins[CtrlbarPluginName];
          },
          enumerable: !1,
          configurable: !0,
        }),
        e
      );
    })(),
    NO_PREVIEW_FLAG = 0,
    FORMAT;
  !(function (e) {
    (e.SD = "sd"),
      (e.HD = "hd"),
      (e.SHD = "shd"),
      (e.FHD = "fhd"),
      (e.UHD = "uhd"),
      (e.DOLBY = "dolby"),
      (e.HDR10 = "hdr10"),
      (e.SFR_HDR = "sfr_hdr");
  })(FORMAT || (FORMAT = {}));
  var SuperBaseCheck = (function (e) {
      function t(t) {
        var o = e.call(this, t) || this;
        return (o.isRetryedInSession = !1), (o.superPlayer = t), o;
      }
      return (
        __extends$1(t, e),
        (t.prototype.onSessionStart = function () {
          this.isRetryedInSession = !1;
        }),
        (t.prototype.getRetryConfig = function (t, o) {
          var A = e.prototype.getRetryConfig.call(this, t),
            i = o || {},
            r = i.degradeCodecExpireTime,
            n = void 0 === r ? 0 : r,
            a = i.degradeReason,
            s = void 0 === a ? DEGRADE_CODEC_REASON.UNKNOWN : a;
          return (
            A &&
            s !== DEGRADE_CODEC_REASON.UNKNOWN &&
            this.canDegradeCodecDefn()
              ? ((A.updatePlayParam.videoReqInfoParam.hevclv =
                  HEVC_LV_VALUE.NOT_SPT),
                (A.updatePlayParam.videoReqInfoParam.spav1 = 0))
              : ((n = 0), (s = DEGRADE_CODEC_REASON.UNKNOWN)),
            __assign$1(__assign$1({}, A), {
              degradeCodecExpireTime: n,
              degradeReason: s,
            })
          );
        }),
        (t.prototype.canDegradeCodecDefn = function (e) {
          return (
            e ||
              (e = this.superPlayer.getCommonKv(COMMON_DATA_KEY.currentDefn)),
            -1 !== [FORMAT.SD, FORMAT.HD, FORMAT.SHD, FORMAT.FHD].indexOf(e)
          );
        }),
        t
      );
    })(BaseCheck),
    CheckFrameDropRate = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.name = RetryNames.CheckFrameDropRate),
          (t.checkEvt = exports.PLAY_EVENT.TIME_UPDATE),
          (t.intervalFrameDroppedArr = []),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.check = function (e) {
          return this.needIgnore(e) ||
            this.needIgnoreBecausePlayTimeCloseToBuffer()
            ? null
            : this.checkFrameDrop()
            ? this.getRetryConfig(e.data.videoInfo, {
                degradeCodecExpireTime:
                  this.superPlayer.config.maxDegradeCodecExpireTime,
                degradeReason: DEGRADE_CODEC_REASON.FRAME_DROP,
              })
            : null;
        }),
        (t.prototype.needIgnore = function (e) {
          var t,
            o = e.data.videoInfo;
          return (
            !(
              this.superPlayer.config.enableDegradeOnLowPerformance &&
              (null === (t = this.player) || void 0 === t
                ? void 0
                : t.currentVideoInfo) &&
              o.config.vcodec !== CODEC.H264 &&
              this.player.kernelName !== exports.KERNEL_NAME.WASM &&
              this.canDegradeCodecDefn()
            ) || !!this.isRetryedInSession
          );
        }),
        (t.prototype.needIgnoreBecausePlayTimeCloseToBuffer = function () {
          for (
            var e = this.player, t = e.playtime, o = e.videoBuffered, A = 0;
            A < o.length;
            A++
          )
            if (Math.abs(o[A].end - t) < PLAY_TIME_2_BUFFER_MIN_GAP) return !0;
          return !1;
        }),
        (t.prototype.checkFrameDrop = function () {
          var e,
            t = this.superPlayer.config.maxFrameDropRate,
            o = (
              (null === (e = this.player.currentVideoInfo) || void 0 === e
                ? void 0
                : e.qualityInfo) || {}
            ).intervalFrameDropped,
            A = void 0 === o ? 0 : o;
          if (
            (this.intervalFrameDroppedArr.push(A),
            this.intervalFrameDroppedArr.length >= DROP_FRAME_COUNT)
          ) {
            var i =
                this.intervalFrameDroppedArr.reduce(function (e, t) {
                  return e + t;
                }) / DROP_FRAME_COUNT,
              r = [].concat(this.intervalFrameDroppedArr);
            if (((this.intervalFrameDroppedArr.length = 0), i >= t))
              return (
                this.logger.log(
                  "dropframe rate "
                    .concat(i, " is more than ")
                    .concat(t, "\n        intervalFrameDroppedArrForLog=")
                    .concat(r)
                ),
                (this.isRetryedInSession = !0),
                !0
              );
          }
          return !1;
        }),
        t
      );
    })(SuperBaseCheck),
    CheckNoH264Error = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.name = RetryNames.CheckNoH264Error),
          (t.checkEvt = exports.PLAY_EVENT.ERROR),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.check = function (e) {
          var t,
            o,
            A = e.data.videoInfo,
            i = A.error,
            r = this.superPlayer.config.enableDegradeOnLowPerformance;
          if (this.isRetryedInSession) return null;
          if (!A.config || A.config.vcodec === CODEC.H264 || !r) return null;
          var n =
            null ===
              (o = null === (t = i.code) || void 0 === t ? void 0 : t.split) ||
            void 0 === o
              ? void 0
              : o.call(t, ".")[0];
          return n !== ERROR_CODE.MEDIA_ERR_DECODE &&
            n !== ERROR_CODE.MEDIA_ERR_SRC_NOT_SUPPORTED
            ? null
            : ((this.isRetryedInSession = !0),
              this.getRetryConfig(A, {
                degradeCodecExpireTime: 0,
                degradeReason: DEGRADE_CODEC_REASON.ORG_SPT_ERR,
              }));
        }),
        t
      );
    })(SuperBaseCheck),
    SuperCheckNormalError = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        __extends$1(t, e),
        (t.prototype.getRetryConfig = function (t) {
          var o = e.prototype.getRetryConfig.call(this, t),
            A = this.player.config.maxRetryGetinfoTimes,
            i = o.degradeReason || DEGRADE_CODEC_REASON.UNKNOWN;
          return (
            this.retryTimes === A &&
              (this.logger.log(
                "degrade retry on last time["
                  .concat(this.retryTimes, "/")
                  .concat(A, "]"),
                o
              ),
              (o.updatePlayParam.videoReqInfoParam.hevclv =
                HEVC_LV_VALUE.NOT_SPT),
              (o.updatePlayParam.videoReqInfoParam.spav1 = 0),
              (o.updatePlayParam.videoReqInfoParam.dtype = 1),
              (i = DEGRADE_CODEC_REASON.LAST)),
            __assign$1(__assign$1({}, o), {
              degradeCodecExpireTime: 0,
              degradeReason: i,
            })
          );
        }),
        t
      );
    })(CheckNormalError),
    CheckOriginPlayHevcError = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.name = RetryNames.CheckOriginPlayHevcError),
          (t.checkEvt = exports.PLAY_EVENT.ERROR),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.check = function (e) {
          var t,
            o = e.data.videoInfo,
            A = o.playtime,
            i = o.error;
          if (this.isRetryedInSession) return null;
          var r =
            null === (t = null == i ? void 0 : i.code) || void 0 === t
              ? void 0
              : t.split(".")[0];
          return !this.superPlayer.config.retryHevcByWasmIfOriginErr ||
            !o.config ||
            o.config.vcodec !== CODEC.H265 ||
            this.player.kernelName === exports.KERNEL_NAME.WASM ||
            (r !== ERROR_CODE.MEDIA_ERR_DECODE &&
              r !== ERROR_CODE.MEDIA_ERR_SRC_NOT_SUPPORTED)
            ? null
            : ((this.isRetryedInSession = !0),
              {
                error: i,
                updatePlayParam: {
                  videoLoadParam: {
                    startTime: A,
                    kernelName: exports.KERNEL_NAME.WASM,
                  },
                },
              });
        }),
        t
      );
    })(SuperBaseCheck),
    CheckRenderPerformance = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.name = RetryNames.CheckRenderPerformance),
          (t.checkEvt = exports.PLAY_EVENT.VIDEO_FRAME_RENDER),
          (t.lowRenderFrameCount = 0),
          (t.lowRenderFrameTimeCostArr = []),
          (t.renderTotalCount = 0),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.onSessionStart = function () {
          (this.lowRenderFrameCount = 0),
            (this.renderTotalCount = 0),
            e.prototype.onSessionStart.call(this);
        }),
        (t.prototype.check = function (e) {
          var t = this.superPlayer.config,
            o = t.minRenderFrameRate,
            A = t.maxLowRenderFrameRate,
            i = t.enableDegradeOnLowPerformance,
            r = t.maxDegradeCodecExpireTime,
            n = e.data.videoInfo;
          if (
            !i ||
            !(o < 1 && o > 0 && A < 1 && A > 0) ||
            this.player.kernelName !== exports.KERNEL_NAME.WASM ||
            !this.canDegradeCodecDefn()
          )
            return null;
          var a = (this.player.currentVideoInfo || {}).videoFrameRate;
          if (!a || a < 0) return null;
          if (this.isRetryedInSession) return null;
          var s = (1e3 / a) * o,
            g = e.data.renderCostTime;
          if (
            (this.lowRenderFrameTimeCostArr.push(g),
            g < s && this.lowRenderFrameCount++,
            this.renderTotalCount++,
            this.renderTotalCount >= 1e3)
          ) {
            var l = this.recordStats(),
              E = this.lowRenderFrameCount / this.renderTotalCount;
            if (
              ((this.renderTotalCount = 0),
              (this.lowRenderFrameCount = 0),
              E > A)
            )
              return (
                this.logger.log(
                  "low render frame rate ".concat(E, " is more than ").concat(A)
                ),
                this.writeStats(l),
                (this.isRetryedInSession = !0),
                this.getRetryConfig(n, {
                  degradeCodecExpireTime: r,
                  degradeReason: DEGRADE_CODEC_REASON.WASM_RENDER,
                })
              );
          }
          return null;
        }),
        (t.prototype.recordStats = function () {
          var e = this.superPlayer.config,
            t = e.minRenderFrameRate,
            o = e.maxLowRenderFrameRate,
            A = {
              lowRenderFrameTimeCostArr:
                this.lowRenderFrameTimeCostArr.slice(-200),
              lowRenderFrameCount: this.lowRenderFrameCount,
              renderTotalCount: this.renderTotalCount,
              maxLowRenderFrameRate: o,
              minRenderFrameRate: t,
            };
          return (this.lowRenderFrameTimeCostArr.length = 0), A;
        }),
        (t.prototype.writeStats = function (e) {
          try {
            var t = JSON.stringify(e);
            lsTool.setData(LOCAL_STORAGE_KEY.RENDER_STATS_INFO, t);
          } catch (e) {}
        }),
        t
      );
    })(SuperBaseCheck),
    CheckSafariHlsError = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.name = RetryNames.CheckSafariHlsError),
          (t.checkEvt = exports.PLAY_EVENT.ERROR),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.check = function (e) {
          var t,
            o,
            A = e.data.videoInfo,
            i = A.playtime,
            r = A.error;
          if (this.isRetryedInSession) return null;
          var n =
            null === (t = null == r ? void 0 : r.code) || void 0 === t
              ? void 0
              : t.split(".")[0];
          return uaTool$1.browser.safari &&
            this.player.kernelName === exports.KERNEL_NAME.HLS_JS &&
            (null === (o = A.config) || void 0 === o ? void 0 : o.vcodec) ===
              CODEC.H264 &&
            n === ERROR_CODE.MEDIA_ERR_DECODE
            ? ((this.isRetryedInSession = !0),
              {
                error: r,
                updatePlayParam: {
                  videoLoadParam: {
                    startTime: i,
                    kernelName: exports.KERNEL_NAME.ORIGIN,
                  },
                },
              })
            : null;
        }),
        t
      );
    })(SuperBaseCheck),
    CheckWasmError = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.name = RetryNames.CheckWasmError),
          (t.checkEvt = exports.PLAY_EVENT.ERROR),
          t
        );
      }
      return (
        __extends$1(t, e),
        (t.prototype.check = function (e) {
          var t = e.data.videoInfo,
            o = t.error.code;
          if (this.isRetryedInSession) return null;
          return this.superPlayer.config.enableDegradeOnLowPerformance
            ? "70060003" !== o
              ? null
              : ((this.isRetryedInSession = !0),
                this.getRetryConfig(t, {
                  degradeCodecExpireTime: 0,
                  degradeReason: DEGRADE_CODEC_REASON.WASM_SPT_ERR,
                }))
            : null;
        }),
        t
      );
    })(SuperBaseCheck),
    DEGRADE_CODEC_REASON;
  !(function (e) {
    (e[(e.UNKNOWN = 0)] = "UNKNOWN"),
      (e[(e.FRAME_DROP = 1)] = "FRAME_DROP"),
      (e[(e.WASM_RENDER = 2)] = "WASM_RENDER"),
      (e[(e.WASM_SPT_ERR = 3)] = "WASM_SPT_ERR"),
      (e[(e.ORG_SPT_ERR = 4)] = "ORG_SPT_ERR"),
      (e[(e.USER = 5)] = "USER"),
      (e[(e.LAST = 6)] = "LAST");
  })(DEGRADE_CODEC_REASON || (DEGRADE_CODEC_REASON = {}));
  var DROP_FRAME_COUNT = 60,
    PLAY_TIME_2_BUFFER_MIN_GAP = 3,
    RetryNames = {
      CheckFrameDropRate: "CheckFrameDropRate",
      CheckNoH264Error: "CheckNoH264Error",
      CheckOriginPlayHevcError: "CheckOriginPlayHevcError",
      CheckRenderPerformance: "CheckRenderPerformance",
      CheckSafariHlsError: "CheckSafariHlsError",
      CheckWasmError: "CheckWasmError",
    },
    RetryClasses = [
      CheckFrameDropRate,
      CheckRenderPerformance,
      CheckWasmError,
      CheckOriginPlayHevcError,
      CheckSafariHlsError,
      CheckNoH264Error,
      SuperCheckNormalError,
    ];
  function writeDegradeCodecToLocal(e, t, o) {
    var A = JSON.stringify(
      __assign$1(
        { time: Date.now(), degradeExpireTime: e, degradeReason: t },
        o
      )
    );
    lsTool.setData(LOCAL_STORAGE_KEY.DEGRADE_CODEC_TIME, A);
  }
  function readDegradeCodecFromLocal() {
    var e = NaN,
      t = NaN,
      o = DEGRADE_CODEC_REASON.UNKNOWN;
    try {
      var A = lsTool.getData(LOCAL_STORAGE_KEY.DEGRADE_CODEC_TIME),
        i = JSON.parse(A || "{}");
      (e = +i.time), (t = +i.degradeExpireTime), (o = i.degradeReason);
    } catch (e) {}
    return Number.isNaN(e) || Number.isNaN(t) || Date.now() >= e + t
      ? { needDegrade: !1 }
      : { needDegrade: !0, degradeReason: o };
  }
  var StepTimeRptPlugin = (function (e) {
    function t(t, o, A) {
      var i = e.call(this, t, o, A) || this;
      return (
        (i.REPORT_URL =
          "https://h.trace.qq.com/kv?attaid=01000076328&token=3117637266"),
        (i.isOnceHidden = !1),
        (i.visibleChangeHandler = function () {
          "hidden" === document.visibilityState && (i.isOnceHidden = !0);
        }),
        (i.onSessionFirstPlaying = function (e) {
          var t = e.data;
          i.player.timeEnd(exports.SuperStepKey.FIRST_PLAYING),
            i.end({
              hasAd: "VideoFlowNode" === (null == t ? void 0 : t.name) ? 0 : 1,
            });
        }),
        document.addEventListener("visibilitychange", i.visibleChangeHandler),
        i.player.pluginMsg.on(
          exports.PLAY_EVENT_EXT.SESSION_FIRST_PLAYING,
          i.onSessionFirstPlaying
        ),
        i
      );
    }
    return (
      __extends$1(t, e),
      Object.defineProperty(t.prototype, "reportHeader", {
        get: function () {
          return {
            vid: this.player.vid,
            cid: this.player.getCommonKv(COMMON_DATA_KEY.cid) || "",
            flowid: this.player.getCommonKv(COMMON_DATA_KEY.flowid),
            guid: this.player.getCommonKv(COMMON_DATA_KEY.guid),
            appver: this.player.getCommonKv(COMMON_DATA_KEY.appVer),
          };
        },
        enumerable: !1,
        configurable: !0,
      }),
      (t.prototype.start = function () {
        this.player.timeStart(exports.SuperStepKey.FIRST_PLAYING),
          (this.isOnceHidden = !1),
          this.visibleChangeHandler();
      }),
      (t.prototype.destroy = function () {
        var t;
        document.removeEventListener(
          "visibilitychange",
          this.visibleChangeHandler
        ),
          (null === (t = this.player) || void 0 === t ? void 0 : t.pluginMsg) &&
            this.player.pluginMsg.off(
              exports.PLAY_EVENT_EXT.SESSION_FIRST_PLAYING,
              this.onSessionFirstPlaying
            ),
          e.prototype.destroy.call(this);
      }),
      (t.prototype.end = function (e) {
        var t = this.player.config,
          o = t.rptRate,
          A = t.instanceId;
        if (
          this.player.getCommonKv(COMMON_DATA_KEY.platform) ===
            OfficialPlatform.vodVQQ &&
          !(Math.random() > o) &&
          StepTimer.recordMap[A]
        ) {
          var i = StepTimer.getCostMap(stepTimerFakeGlobalInstanceId),
            r = StepTimer.getCostMap(A, !0),
            n = __assign$1(__assign$1(__assign$1(__assign$1({}, e), i), r), {
              isFirstVid: void 0 !== r[exports.SuperStepKey.NEW] ? 1 : 0,
              hided: this.isOnceHidden ? 1 : 0,
            });
          this.report(n);
        }
      }),
      (t.pluginName = "steptime-rpt"),
      t
    );
  })(BaseReporter);
  function getDefaultVodPlatform() {
    return uaTool$1.mobile
      ? "11001"
      : isOfficialSite()
      ? OfficialPlatform.vodVQQ
      : OfficialPlatform.vodDefault;
  }
  function isOfficialSite() {
    if (urlTool$1.isInFrame()) return !1;
    var e = urlTool$1.getTopFrameUrl(),
      t = urlTool$1.getDomainOfURL(e);
    return ["v.qq.com", "film.qq.com"].some(function (e) {
      return new RegExp("^(\\w+\\.)?".concat(e, "$")).test(t);
    });
  }
  function getDefautVodSdtfrom(e) {
    if ("11001" === e) {
      if (uaTool$1.os.iphone || uaTool$1.os.ipod) return "v3010";
      if (uaTool$1.os.ipad) return "v4010";
      if (uaTool$1.os.tablet) return "v6010";
      if (uaTool$1.os.android) return "v5010";
      if (uaTool$1.browser.IEMobile) return "v7010";
    }
    return { 70201: "v1104" }[e] || "v1010";
  }
  H5Player.registerPlugin(StepTimeRptPlugin.pluginName, StepTimeRptPlugin);
  var VERSION$1 = getEnvVals().VERSION,
    defaultVodPlatform = getDefaultVodPlatform(),
    defautVodSdtfrom = getDefautVodSdtfrom(defaultVodPlatform),
    defaultVodBusinessConfig = {
      platform: defaultVodPlatform,
      sdtfrom: defautVodSdtfrom,
    },
    defaultSuperConfig = {
      enableDegradeOnLowPerformance: !0,
      maxDegradeCodecExpireTime: 432e5,
      minRenderFrameRate: 0.8,
      maxLowRenderFrameRate: 0.3,
      maxFrameDropRate: 0.2,
      enableTVK: !0,
      enableP2P: !0,
      proxyHttpPath: getTestProxyHttpPath(),
    },
    defaultLiveBusinessConfig = {
      platform: OfficialPlatform.liveVQQ,
      sdtfrom: OfficialPlatform.liveVQQ,
    };
  function getBuiltInPlugins(e, t) {
    var o, A;
    void 0 === e && (e = exports.PLAY_MODE.VOD);
    var i = t.removeComponents,
      r = void 0 === i ? [] : i,
      n = r.includes(PosterPluginName) || !!t.disablePoster,
      a = r.includes(CtrlbarPluginName) || !!t.disableCtrlbar,
      s = r.includes(ErrorPagePluginName) || !!t.disableErrorPage,
      g = r.includes(TipsPluginName) || !!t.disableTips,
      l = r.includes(UILoadingPlugin.pluginName) || !!t.disableLoading,
      E = r.includes(UIContextMenuPluginName) || !!t.disableCtxMenu,
      c = r.includes(WatermarkPluginName) || !!t.disableWatermark,
      u = r.includes(InfoPanelPluginName),
      p =
        (((o = {})[PosterPluginName] = { isEnabled: !n, config: t.poster }),
        (o[CtrlbarPluginName] = { isEnabled: !a }),
        (o[ErrorPagePluginName] = {
          isEnabled: !s,
          config: { showOnError: !0 },
        }),
        (o[TipsPluginName] = { isEnabled: !g }),
        (o[UILoadingPlugin.pluginName] = { isEnabled: !l }),
        (o[UIContextMenuPluginName] = {
          isEnabled: !isMobile && !E,
          config: { menus: [{ role: "version", label: VERSION$1 || "1.3.0" }] },
        }),
        (o[InfoPanelPluginName] = {
          isEnabled: !u,
          config: { defaultInfo: !0 },
        }),
        (o[LivepollPlugin.pluginName] = {
          isEnabled: e === exports.PLAY_MODE.LIVE,
          config: {
            livepid:
              null === (A = t.livepollConfig) || void 0 === A
                ? void 0
                : A.livepid,
          },
        }),
        (o[WatermarkPluginName] = { isEnabled: !c }),
        (o[StepTimeRptPlugin.pluginName] = {
          isEnabled: e === exports.PLAY_MODE.VOD,
        }),
        o),
      d = [];
    return (
      Object.keys(p).forEach(function (e) {
        var t = p[e],
          o = t.isEnabled,
          A = t.config;
        o && d.push(A ? [e, A] : e);
      }),
      d
    );
  }
  function getSuperConfig(e) {
    var t,
      o,
      A,
      i = e.plugins,
      r = void 0 === i ? [] : i,
      n = e.mode,
      a = void 0 === n ? exports.PLAY_MODE.VOD : n,
      s = e.businessConfig,
      g = void 0 === s ? {} : s,
      l = e.coreConfig,
      E = void 0 === l ? {} : l,
      c = e.pluginConfig,
      u = void 0 === c ? {} : c,
      p = e.dynamicConfig,
      d = void 0 === p ? {} : p;
    e.type = null !== (t = e.type) && void 0 !== t ? t : a;
    var B = e.type,
      h =
        B === exports.PLAY_MODE.VOD
          ? defaultVodBusinessConfig
          : defaultLiveBusinessConfig,
      I = __assign$1(__assign$1({}, h), g),
      C = __spreadArray(__spreadArray([], getBuiltInPlugins(B, e), !0), r, !0),
      _ = I.platform,
      f = __assign$1(
        __assign$1(
          __assign$1(
            __assign$1(
              __assign$1(__assign$1({}, defaultSuperConfig), {
                supportedPaidFormat: isOfficialSite()
                  ? [
                      exports.PAID_FORMAT.FHD,
                      exports.PAID_FORMAT.DOLBY,
                      exports.PAID_FORMAT.SFR_HDR,
                      exports.PAID_FORMAT.UHD,
                    ]
                  : [],
                logLevel: getLogLevelFromUrl(),
                videoElementConfig: { playsinline: !0 },
                maxVideoNodeCount:
                  isMobile || B === exports.PLAY_MODE.LIVE ? 1 : 2,
                watermarkConfig: {},
              }),
              u
            ),
            E
          ),
          e
        ),
        {
          businessConfig: I,
          plugins: C,
          offlineConfig: __assign$1({ platform: _ }, e.offlineConfig),
          getinfoConfig: __assign$1({}, e.getinfoConfig),
          errorPageConfig: __assign$1(
            { useBrowserTip: isOfficialSite(), useClientBtn: isOfficialSite() },
            e.errorPageConfig
          ),
          ctrlConfig: __assign$1(
            __assign$1(
              { disableNextBtn: !0, hidePopupOnClick: !0 },
              u.ctrlConfig
            ),
            e.ctrlConfig
          ),
          infoPanelConfig: __assign$1({ defaultInfo: !0 }, e.infoPanelConfig),
          vodQaReporterConfig: __assign$1(
            __assign$1({}, null == e ? void 0 : e.vodQaReporterConfig),
            {
              paramsKey: __assign$1(
                __assign$1(
                  {},
                  null === (o = u.vodQaReporterConfig) || void 0 === o
                    ? void 0
                    : o.paramsKey
                ),
                null === (A = null == e ? void 0 : e.vodQaReporterConfig) ||
                  void 0 === A
                  ? void 0
                  : A.paramsKey
              ),
            }
          ),
          tvkConfig: __assign$1(
            {
              enableTEE:
                _ === OfficialPlatform.vodVQQ && B === exports.PLAY_MODE.VOD,
              hevcGPUBlackList: {
                "edg<118": [
                  "AMD Radeon\\(TM\\) Graphics",
                  "AMD Radeon\\(TM\\) Vega \\d+ Graphics",
                ],
              },
            },
            e.tvkConfig
          ),
        }
      );
    return (
      e.isPrivateDeployment && (f.enableTVK = !1),
      { superPlayerConfig: mergeDynamicConfig(f, getLocalDynamicConfig() || d) }
    );
  }
  function getAdInitConfig(e) {
    var t,
      o = e.adKernelName,
      A = void 0 === o ? exports.KERNEL_NAME.DEMUX_2_FMP4 : o,
      i = e.adInitConfig,
      r = e.useSingleVideoElement,
      n = !!KernelFactory$1.getKernelByName(exports.KERNEL_NAME.DEMUX_2_FMP4),
      a =
        !uaTool$1.browser.safari && n && A === exports.KERNEL_NAME.DEMUX_2_FMP4;
    return __assign$1(__assign$1({}, i), {
      playerData: __assign$1(
        __assign$1({}, null == i ? void 0 : i.playerData),
        {
          playerVideoDom: (null != r ? r : uaTool$1.mobile)
            ? null === (t = e.videoElements) || void 0 === t
              ? void 0
              : t[0]
            : void 0,
        }
      ),
      isUseDemuxKernel: a,
      opencache: a,
    });
  }
  function getLocalDynamicConfig() {
    var e = window.SUPER_PLAYER_DYNAMIC_CONFIG_ID;
    if (!e) return null;
    try {
      var t = lsTool.getData(LOCAL_STORAGE_KEY.DYNAMIC_CONFIG);
      if (!t) return null;
      var o = JSON.parse(t)[e];
      return (null == o ? void 0 : o.app_config) &&
        "{}" !== o.app_config &&
        "" !== o.app_config
        ? JSON.parse(o.app_config)
        : null;
    } catch (e) {}
    return null;
  }
  function mergeDynamicConfig(e, t) {
    var o = e;
    return (
      Object.keys(t).forEach(function (e) {
        var A = o[e];
        "[object Object]" === Object.prototype.toString.call(A)
          ? (o[e] = __assign$1(__assign$1({}, A), t[e]))
          : (o[e] = t[e]);
      }),
      o
    );
  }
  var extInfoCgi = "https://h5vv6.video.qq.com/getextinfo";
  function requestVideoExtInfo(e) {
    return __awaiter$1(this, void 0, void 0, function () {
      var t, o, A, i, r, n, a, s, g;
      return __generator$1(this, function (l) {
        switch (l.label) {
          case 0:
            return (
              (t = e.vid),
              (o = e.platform),
              (A = {
                vid: t,
                platform: void 0 === o ? "11001" : o,
                h5flag: 1,
                otype: "json",
              }),
              (i = ""
                .concat(extInfoCgi, "?")
                .concat(urlTool$1.object2string(A, "&"))),
              [4, netTool.jsonp(i)]
            );
          case 1:
            return "o" !== (r = l.sent()).s || (r.em && 0 != +r.em)
              ? [2, null]
              : ((n = r.limit),
                (a = r.td),
                (s = r.preview),
                (g = r.fs),
                [
                  2,
                  { duration: 0 == +n ? +a : +s, payLimit: +n, fileSize: g },
                ]);
        }
      });
    });
  }
  var EnvCache = (function () {
      function e() {}
      return (
        (e.get = function (e) {
          var t;
          return null === (t = getEnvData()) || void 0 === t ? void 0 : t[e];
        }),
        (e.set = function (e, t) {
          var o,
            A = null !== (o = getEnvData()) && void 0 !== o ? o : {};
          (A[e] = t),
            lsTool.setData(LOCAL_STORAGE_KEY.ENV_CACHE, JSON.stringify(A));
        }),
        (e.clear = function () {
          lsTool.setData(LOCAL_STORAGE_KEY.ENV_CACHE, "");
        }),
        e
      );
    })(),
    EnvCacheKeys;
  function getEnvData() {
    var e = lsTool.getData(LOCAL_STORAGE_KEY.ENV_CACHE);
    if ("" !== e)
      try {
        var t = JSON.parse(e);
        if ("[object Object]" === Object.prototype.toString.call(t)) return t;
        EnvCache.clear();
      } catch (e) {}
  }
  function sptWasmHevcOnTx(e) {
    var t,
      o = e.enableTxHevc,
      A = e.reqDefn;
    if (
      !o ||
      !(null === (t = KernelFactory$1.kernelMap[exports.KERNEL_NAME.WASM]) ||
      void 0 === t
        ? void 0
        : t.isEnvSupport)
    )
      return !1;
    if (void 0 !== A && -1 === [FORMAT.SD, FORMAT.HD].indexOf(A)) return !1;
    var i =
        uaTool$1.browser.chrome &&
        commonTool$1.compareVersion(uaTool$1.browser.chrome.version, "92.0") >=
          0,
      r = EnvCache.get(EnvCacheKeys.enableHevc);
    void 0 === r && (r = 1);
    var n = navigator.hardwareConcurrency > 8;
    return i && 1 === r && n;
  }
  function getCodecParams(e, t, o) {
    var A,
      i = e.preferCodec,
      r = t.playCodec,
      n = getForceCodecFromUrl();
    n && (r = +n);
    var a = {};
    if (r === PLAY_CODEC.H264) return {};
    if (r === PLAY_CODEC.H265) return { hevclv: HEVC_LV_VALUE.UHD };
    if (readDegradeCodecFromLocal().needDegrade) return {};
    if (0 === (null == i ? void 0 : i.length)) return {};
    for (
      var s = !!i,
        g = i || [exports.VIDEO_CODEC.AV1, exports.VIDEO_CODEC.H265],
        l =
          (((A = {})[exports.VIDEO_CODEC.AV1] = getSptAv1Param),
          (A[exports.VIDEO_CODEC.H265] = function () {
            var A;
            return getHevcLevelParam({
              isForceDisableHevc: !!t.roomid,
              isSupportedWasmHevcOnTx: sptWasmHevcOnTx({
                enableTxHevc: e.enableTxHevc,
                reqDefn: o.defn,
              }),
              hevcGPUBlackList:
                null === (A = e.tvkConfig) || void 0 === A
                  ? void 0
                  : A.hevcGPUBlackList,
              supportedPaidFormat: e.supportedPaidFormat,
            });
          }),
          A),
        E = 0;
      E < g.length;
      E++
    ) {
      var c = l[g[E]],
        u = null == c ? void 0 : c();
      if (u && (Object.assign(a, u), s)) break;
    }
    return a;
  }
  function getVodBuiltInVideoReqInfoParam(e, t, o, A) {
    var i, r;
    return (
      void 0 === A && (A = !0),
      __awaiter$1(this, void 0, void 0, function () {
        var n, a, s, g, l, E;
        return __generator$1(this, function (c) {
          return (
            (n = e.businessConfig),
            (a = {
              guid: o(COMMON_DATA_KEY.guid),
              platform: n.platform,
              sdtfrom: n.sdtfrom,
              appVer: o(COMMON_DATA_KEY.appVer),
            }),
            (s = o(exports.PersistedUserSettings.definition)) && (a.defn = s),
            (g = t || {}),
            (a.spvvpay = 1),
            Object.assign(a, getSptAdSegParam(!0)),
            (l = o(exports.SUPER_DATA_KEY.getinfoAdInfo)) &&
              A &&
              ((a.adsid = l.adsid || ""), (a.adpinfo = l.adpinfo || "")),
            Object.assign(a, getDtypeParam()),
            Object.assign(a, getCodecParams(e, g, a)),
            (E = e.supportedPaidFormat) &&
              Object.assign(a, getPaidFormatParam(E)),
            Object.assign(a, getLogintoken()),
            e.enableTVK &&
              (Object.assign(a, getM3u8Param()),
              (null === (i = e.tvkConfig) || void 0 === i
                ? void 0
                : i.showUHDClientGuide) &&
                (null === (r = e.supportedPaidFormat) || void 0 === r
                  ? void 0
                  : r.includes(exports.PAID_FORMAT.UHD)) &&
                (!a.hevclv || a.hevclv < HEVC_LV_VALUE.UHD) &&
                !videoTool$1.supportHevc() &&
                (a.hevclv = HEVC_LV_VALUE.UHD_ONLY)),
            [2, a]
          );
        });
      })
    );
  }
  function getLiveBuiltInVideoReqInfoParam(e, t, o) {
    return __awaiter$1(this, void 0, void 0, function () {
      var A, i, r, n, a;
      return __generator$1(this, function (s) {
        return (
          (A = e.businessConfig),
          (i = {
            guid: o(COMMON_DATA_KEY.guid),
            platform: A.platform,
            sdtfrom: A.sdtfrom,
            appver: o(COMMON_DATA_KEY.appVer),
          }),
          (r = o(exports.PersistedUserSettings.definition)) && (i.defn = r),
          (n = t || {}),
          (i.livepid = n.livepid || ""),
          (i.roomid = n.roomid || ""),
          (i.defnswitch = 1),
          Object.assign(i, getCodecParams(e, n, i)),
          (a = e.supportedPaidFormat) &&
            Object.assign(i, getPaidFormatParamForLive(a)),
          Object.assign(i, { defauto: i.defnswitch, appVer: i.appver }),
          [2, i]
        );
      });
    });
  }
  !(function (e) {
    (e.drm = "drm"), (e.hdr = "hdr"), (e.enableHevc = "enableHevc_20220822");
  })(EnvCacheKeys || (EnvCacheKeys = {}));
  var envVals = getEnvVals(),
    adInitDefer,
    logMethodCall = logMethodCallDecoratorCreator("SuperPlayer"),
    performanceCost = performanceCostDecoratorCreator("SuperPlayer"),
    hlsADShift = 1,
    SuperPlayer = (function (e) {
      function t(o) {
        var A,
          i = this;
        StepTimer.end(exports.SuperStepKey.READY_2_NEW);
        var r = Date.now(),
          n = getSuperConfig(o).superPlayerConfig;
        n.isPrivateDeployment ||
          ReferenceReport.getReporter().collectUsage(
            2,
            envVals.CHANNEL,
            null === (A = n.businessConfig) || void 0 === A
              ? void 0
              : A.platform
          );
        ((i = e.call(this, n) || this).type = exports.PLAY_MODE.VOD),
          (i.videoLoadParamModifier = function (e) {
            var t, o;
            if (i.config.keepOriginalStartTime) return e;
            var A = e.startTime;
            i.previewDuration > 0 &&
              (A > i.previewDuration + i.previewStartPosition ||
                A < i.previewStartPosition) &&
              (A = i.previewStartPosition);
            var r =
                null !==
                  (t = i.getCommonKv(exports.SUPER_DATA_KEY.hlsAdRanges)) &&
                void 0 !== t
                  ? t
                  : [],
              n = commonTool$1.findDiscontinuityTimeRangeAtPlaytime(A, r);
            if (n && A) {
              var a = n.start - hlsADShift;
              return (
                i.log(
                  "start time modified due to hls ad, origin: "
                    .concat(A, ", new: ")
                    .concat(a)
                ),
                __assign$1(__assign$1({}, e), { startTime: a })
              );
            }
            return (
              null === (o = i.removedAdRange) || void 0 === o
                ? void 0
                : o.length
            )
              ? __assign$1(__assign$1({}, e), {
                  startTime: i.getVVIPOffsetTime(A),
                })
              : __assign$1(__assign$1({}, e), { startTime: A });
          }),
          (i.logger = new Logger(i.config.instanceId, "SuperPlayer")),
          i.log("new SuperPlayer(), input config=", o);
        var a = o.mode,
          s = void 0 === a ? exports.PLAY_MODE.VOD : a,
          g = o.type;
        return (
          (i.type = g || s),
          (i.adLogic = new AdLogic(i, i.corePlayer)),
          (i.previewLogic = new PreviewLogic(i)),
          (i.posterLogic = new PosterLogic(i)),
          i.writeGlobalCommonKvs(),
          i.initPlugins(),
          i.initInnerEvts(),
          i.reqExtInfoOnMobile(),
          i.setupRemovedAdRange(),
          getDebugModeFromUrl() && (t._instances[i.config.instanceId] = i),
          (o.videoId || o.adInitConfig) && i.loadAdPlugin(),
          n.enableTVK && (i.tvk = enableTVK(i, n.tvkConfig)),
          StepTimer.push(
            exports.SuperStepKey.NEW,
            r,
            Date.now(),
            i.config.instanceId
          ),
          i.timeStart(exports.SuperStepKey.NEW_2_PLAY),
          i
        );
      }
      return (
        __extends$1(t, e),
        Object.defineProperty(t.prototype, "vinfo", {
          get: function () {
            return this.currentVideoInfo;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "ctrlbarPlugin", {
          get: function () {
            return this.plugins[CtrlbarPluginName];
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "tipsPlugin", {
          get: function () {
            return this.plugins[TipsPluginName];
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "loadingPlugin", {
          get: function () {
            return this.plugins[UILoadingPlugin.pluginName];
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "errorPagePlugin", {
          get: function () {
            return this.plugins[ErrorPagePluginName];
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "posterPlugin", {
          get: function () {
            return this.plugins[PosterPluginName];
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "config", {
          get: function () {
            return this.corePlayer.config || {};
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "previewDuration", {
          get: function () {
            return this.previewLogic.previewDuration;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "previewStartPosition", {
          get: function () {
            return this.previewLogic.previewStartPosition;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "core", {
          get: function () {
            return this;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "coreConfig", {
          get: function () {
            return this.config;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "levelList", {
          get: function () {
            return this.getCommonKv(COMMON_DATA_KEY.currentDefnList);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "level", {
          get: function () {
            return this.getCommonKv(COMMON_DATA_KEY.currentDefn);
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "stepTimeRptPlugin", {
          get: function () {
            return this.plugins[StepTimeRptPlugin.pluginName];
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.log = function () {
          for (var e, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          (e = this.logger).log.apply(e, t);
        }),
        (t.prototype.warn = function () {
          for (var e, t = [], o = 0; o < arguments.length; o++)
            t[o] = arguments[o];
          (e = this.logger).warn.apply(e, t);
        }),
        Object.defineProperty(t.prototype, "videoSize", {
          get: function () {
            var e;
            return (
              this.videoSizeFromGetInfo ||
              (null === (e = this.corePlayer) || void 0 === e
                ? void 0
                : e.videoSize) || { width: 0, height: 0 }
            );
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(t.prototype, "cnlid", {
          get: function () {
            return this.config.type === exports.PLAY_MODE.LIVE ? this.vid : "";
          },
          enumerable: !1,
          configurable: !0,
        }),
        (t.prototype.degradeCodecRetry = function (e) {
          var t;
          return (
            void 0 === e && (e = 0),
            null === (t = this.startGetinfoRetry) || void 0 === t
              ? void 0
              : t.call(
                  this,
                  {
                    updatePlayParam: {
                      videoReqInfoParam: { hevclv: HEVC_LV_VALUE.NOT_SPT },
                      videoLoadParam: {
                        startTime: this.playtime,
                        kernelName: void 0,
                      },
                    },
                    degradeCodecExpireTime: e,
                    degradeReason: DEGRADE_CODEC_REASON.USER,
                  },
                  !1
                )
          );
        }),
        (t.prototype.clearLocalstorage = function (e) {
          return (
            -1 !==
              Object.keys(LOCAL_STORAGE_KEY).findIndex(function (t) {
                return LOCAL_STORAGE_KEY[t] === e;
              }) && (lsTool.delData(e), !0)
          );
        }),
        (t.prototype.destroy = function () {
          var o, A, i, r, n;
          return (
            null === (o = this.tvk) || void 0 === o || o.destroy(),
            (this.tvk = null),
            null === (A = this.adLogic) || void 0 === A || A.destroy(),
            (this.adLogic = null),
            null === (i = this.previewLogic) || void 0 === i || i.destroy(),
            (this.previewLogic = null),
            null === (r = this.posterLogic) || void 0 === r || r.destroy(),
            (this.posterLogic = null),
            (null === (n = this.config) || void 0 === n
              ? void 0
              : n.instanceId) &&
              t._instances[this.config.instanceId] &&
              delete t._instances[this.config.instanceId],
            e.prototype.destroy.call(this)
          );
        }),
        (t.prototype.play = function (e, t) {
          var o, A, i;
          return __awaiter$1(this, void 0, void 0, function () {
            var r;
            return __generator$1(this, function (n) {
              return e
                ? (this.timeEnd(exports.SuperStepKey.NEW_2_PLAY),
                  null === (o = this.stepTimeRptPlugin) ||
                    void 0 === o ||
                    o.start(),
                  null === (A = this.loadingPlugin) || void 0 === A || A.show(),
                  (r =
                    null === (i = this.ctrlbarPlugin) || void 0 === i
                      ? void 0
                      : i.instances.CenterBtn) && r.hideEl(r.playBtn),
                  [2, this.loadOrPlay(e, t, "play")])
                : [2, this.playByInitConfig()];
            });
          });
        }),
        (t.prototype.loadOrPlay = function (t, o, A) {
          var i, r, n;
          return (
            void 0 === A && (A = "load"),
            __awaiter$1(this, void 0, void 0, function () {
              var a, s, g, l, E, c, u, p, d, B;
              return __generator$1(this, function (h) {
                switch (h.label) {
                  case 0:
                    return t
                      ? (a = checkParams(this.type, A, t))
                        ? (this.logger.error(a, t),
                          null === (i = this.errorPagePlugin) ||
                            void 0 === i ||
                            i.show({ text: a, hideRefresh: !0 }),
                          [2])
                        : (this.clearBeforeReplay(),
                          (s = t),
                          (this.replayConfig = t),
                          "string" == typeof t &&
                            (this.type === exports.PLAY_MODE.LIVE
                              ? ((g = (
                                  null === (r = this.currentPlayItem) ||
                                  void 0 === r
                                    ? void 0
                                    : r.cnlid
                                )
                                  ? this.currentPlayItem
                                  : {}),
                                (s = __assign$1(__assign$1({}, g), {
                                  cnlid: t,
                                })))
                              : ((g = (
                                  null === (n = this.currentPlayItem) ||
                                  void 0 === n
                                    ? void 0
                                    : n.vid
                                )
                                  ? this.currentPlayItem
                                  : {}),
                                (s = __assign$1(__assign$1({}, g), {
                                  vid: t,
                                })))),
                          (E = (l = s).vid),
                          (c = l.cnlid),
                          (u = l.livepid),
                          (p = this.isH5PlayParam(o)
                            ? o
                            : { videoLoadParam: o }),
                          (this.currentPlayItem = E || c || s),
                          this.playtimeLimiter.clearAllConfig(),
                          hasGetinfoModule(this.config.instanceId) && (E || c)
                            ? (this.timeStart(exports.SuperStepKey.PREPARE_REQ),
                              [4, this.getBuiltInVideoReqInfoParam(s)])
                            : [3, 3])
                      : [2];
                  case 1:
                    return (
                      (d = h.sent()),
                      this._destroyed
                        ? [2]
                        : (this.timeEnd(exports.SuperStepKey.PREPARE_REQ),
                          (p.videoReqInfoParam = __assign$1(
                            __assign$1({}, d),
                            p.videoReqInfoParam
                          )),
                          [4, this.loadAdPlugin()])
                    );
                  case 2:
                    return (
                      h.sent(),
                      this._destroyed
                        ? [2]
                        : (c
                            ? ((p.videoReqInfoParam.cnlid = c),
                              (this.getPlugin(
                                LivepollPlugin.pluginName
                              ).livepid = u),
                              this.setCommonKv(COMMON_DATA_KEY.livepid, u))
                            : E && (p.videoReqInfoParam.vid = E),
                          [2, e.prototype[A].call(this, E || c, p)])
                    );
                  case 3:
                    return (
                      (B = s),
                      this.setLevelOptions(B.levels, B.url),
                      [2, e.prototype[A].call(this, B, p)]
                    );
                }
              });
            })
          );
        }),
        (t.prototype.replay = function () {
          var e, t, o;
          null ===
            (t =
              null === (e = this.loadParam) || void 0 === e
                ? void 0
                : e.videoLoadParam) ||
            void 0 === t ||
            delete t.startTime;
          var A = this.getCommonKv(COMMON_DATA_KEY.currentDefn);
          return this.vid && A
            ? this.play(
                this.replayConfig,
                __assign$1(__assign$1({}, this.loadParam), {
                  videoReqInfoParam: __assign$1(
                    __assign$1(
                      {},
                      null === (o = this.loadParam) || void 0 === o
                        ? void 0
                        : o.videoReqInfoParam
                    ),
                    { defn: A }
                  ),
                })
              )
            : this.play(this.replayConfig, this.loadParam);
        }),
        (t.prototype.load = function (t, o) {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (A) {
              return t
                ? [2, this.loadOrPlay(t, o, "load")]
                : [2, e.prototype.load.call(this)];
            });
          });
        }),
        (t.prototype.preload = function (t, o, A) {
          var i;
          return __awaiter$1(this, void 0, void 0, function () {
            var r, n, a, s;
            return __generator$1(this, function (g) {
              switch (g.label) {
                case 0:
                  return t
                    ? (r = checkParams(this.type, "load", t))
                      ? (this.logger.error(r, t),
                        null === (i = this.errorPagePlugin) ||
                          void 0 === i ||
                          i.show({ text: r, hideRefresh: !0 }),
                        [2])
                      : ((n =
                          "string" == typeof t
                            ? t
                            : null == t
                            ? void 0
                            : t.vid),
                        (a = this.isH5PlayParam(o) ? o : { videoLoadParam: o }),
                        hasGetinfoModule(this.config.instanceId) && n
                          ? [4, this.getBuiltInVideoReqInfoParam(t, !1)]
                          : [2])
                    : [2];
                case 1:
                  return (
                    (s = g.sent()),
                    this._destroyed
                      ? [2]
                      : ((a.videoReqInfoParam = __assign$1(
                          __assign$1({}, s),
                          null == a ? void 0 : a.videoReqInfoParam
                        )),
                        [2, e.prototype.preload.call(this, n, a, A)])
                  );
              }
            });
          });
        }),
        (t.prototype.seek = function (t) {
          var o = t,
            A = this.getCommonKv(exports.SUPER_DATA_KEY.hlsAdRanges);
          if (A) {
            var i = commonTool$1.findDiscontinuityTimeRangeAtPlaytime(o, A);
            i && (o = i.start - hlsADShift);
          }
          return e.prototype.seek.call(this, o);
        }),
        (t.prototype.setLevel = function (t, o) {
          return (
            void 0 === o && (o = {}),
            __awaiter$1(this, void 0, void 0, function () {
              var A,
                i,
                r,
                n,
                a,
                s,
                g,
                l,
                E,
                c,
                u,
                p,
                d,
                B,
                h,
                I,
                C = this;
              return __generator$1(this, function (_) {
                return "string" != typeof t
                  ? [2, Promise.reject("setLevel received illegal parameter")]
                  : hasGetinfoModule(this.config.instanceId) && this.vid
                  ? (this.state === exports.VIDEO_STATE.PAUSE &&
                      this.type === exports.PLAY_MODE.VOD &&
                      this.play(),
                    (A = this.getCommonKv(COMMON_DATA_KEY.currentDefn)),
                    o.userTrigger &&
                      this.setCommonKv(
                        exports.PersistedUserSettings.definition,
                        t
                      ),
                    (i = {
                      defn: t,
                      logintoken: jsonTool$1.safelyStringify(getUserCookies()),
                    }),
                    (r = void 0),
                    this.type === exports.PLAY_MODE.LIVE
                      ? ((n = __assign$1(__assign$1({}, i), {
                          defnswitch: o.userTrigger ? 1 : 0,
                        })),
                        Object.assign(n, { defauto: +!n.defnswitch }),
                        (r = n))
                      : ((a = __assign$1(
                          { fhdswitch: o.userTrigger ? 1 : 0 },
                          i
                        )),
                        (s = this.getCommonKv(
                          exports.SUPER_DATA_KEY.getinfoAdInfo
                        )) &&
                          ((a.adsid = s.adsid || ""),
                          (a.adpinfo = s.adpinfo || "")),
                        (g = this.currentVideoInfo),
                        (l = g.audioTracks),
                        (E = g.currentAudioTrack),
                        l.length > 1 &&
                          (c = l.find(function (e) {
                            return e.id === E;
                          })) &&
                          Object.assign(a, { track: c.name }),
                        (r = a)),
                    (u = [FORMAT.DOLBY, FORMAT.HDR10, FORMAT.SFR_HDR]),
                    (p = o.setLevelMode),
                    (-1 === u.indexOf(A) && -1 === u.indexOf(t)) ||
                      (p = SET_LEVEL_MODE.HARD),
                    [
                      2,
                      e.prototype.setLevel
                        .call(this, r, { setLevelMode: p })
                        .catch(function (e) {
                          C.log(e),
                            C.ctrlbarPlugin && (C.ctrlbarPlugin.level = A),
                            C.setCommonKv(COMMON_DATA_KEY.currentDefn, A);
                        }),
                    ])
                  : ((d = this.getCommonKv(COMMON_DATA_KEY.currentDefnList)),
                    (B =
                      null == d
                        ? void 0
                        : d.findIndex(function (e) {
                            return e.value === t;
                          })),
                    (h = d[B])
                      ? (!(I = h.url) &&
                          this.defnIdToUrl &&
                          ((I = this.defnIdToUrl(t)), (h.url = I)),
                        I
                          ? (this.setCommonKv(COMMON_DATA_KEY.currentDefn, t),
                            (this.replayConfig.url = I),
                            [
                              2,
                              e.prototype.setLevel.call(
                                this,
                                __assign$1(__assign$1({}, this.replayConfig), {
                                  defn: h.value,
                                  url: h.url,
                                  level: h,
                                  levelIndex: B,
                                })
                              ),
                            ])
                          : [
                              2,
                              Promise.reject(
                                new Error("definition must contains url")
                              ),
                            ])
                      : [2, Promise.reject(new Error("no definition info"))]);
              });
            })
          );
        }),
        (t.prototype.getPlugin = function (e) {
          return this.plugins[e];
        }),
        (t.prototype.closePayTipsCallback = function (e) {
          var t = getAdPlugin(this.config.instanceId);
          if (
            "ad" === e &&
            "function" == typeof (null == t ? void 0 : t.resumeAd)
          )
            try {
              t.resumeAd();
            } catch (e) {
              this.logger.error(
                "closePayTipsCallback, call adPlugin::resumeAd",
                e
              );
            }
        }),
        (t.prototype.createPlugin = function (t, o) {
          void 0 === o && (o = {});
          var A = o.pluginName;
          (void 0 === A ? t : A) === AdPluginName
            ? e.prototype.createPlugin.call(
                this,
                t,
                __assign$1(__assign$1({}, o), {
                  requestProxyHttp: this.requestAdCallback4AdPlugin.bind(this),
                })
              )
            : e.prototype.createPlugin.call(this, t, o);
        }),
        (t.prototype.setAdConfig = function (e) {
          return this.waitAdPlugin().then(function (t) {
            return t.setConf(e);
          });
        }),
        (t.prototype.resizeAd = function () {
          return this.waitAdPlugin().then(function (e) {
            var t;
            return null === (t = e.resizeAd) || void 0 === t
              ? void 0
              : t.call(e);
          });
        }),
        (t.prototype.hideAdBeforeResize = function () {
          return this.waitAdPlugin().then(function (e) {
            var t;
            return null === (t = e.hideAdBeforeResize) || void 0 === t
              ? void 0
              : t.call(e);
          });
        }),
        (t.prototype.getVVIPOffsetTime = function (e, t) {
          void 0 === t && (t = !1);
          var o = this.removedAdRange;
          if (!(null == o ? void 0 : o.length)) return e;
          if (t) return this.getPlusAdOffsetTime(e);
          for (var A = 0, i = 0; i < o.length; i++) {
            var r = o[i],
              n = r.start,
              a = r.end;
            if (n > e) break;
            if (a > e) {
              A += e - n;
              break;
            }
            A += a - n;
          }
          return e - A;
        }),
        (t.prototype.startGetinfoRetry = function (t, o) {
          var A,
            i = t.degradeCodecExpireTime,
            r = void 0 === i ? 0 : i,
            n = t.degradeReason,
            a = void 0 === n ? DEGRADE_CODEC_REASON.UNKNOWN : n;
          if (a === DEGRADE_CODEC_REASON.USER && !this.canGetinfoRetry())
            return !1;
          if (
            (commonTool$1.merge(t, {
              updatePlayParam: {
                videoReqInfoParam: {
                  logintoken: jsonTool$1.safelyStringify(getUserCookies()),
                },
              },
            }),
            r > 0)
          ) {
            var s = {
              playerSize: domTool$1.getDomSize(this.player.container),
              videoSize: this.player.videoSize,
              url: location.href,
              topUrl: urlTool$1.getTopFrameUrl(),
              kernelName: this.player.kernelName,
              flowid: this.player.getCommonKv(COMMON_DATA_KEY.flowid),
              guid: this.player.getCommonKv(COMMON_DATA_KEY.guid),
              playtime: this.player.playtime,
              duration: this.player.duration,
              vid: this.player.vid,
              loadingUrl:
                null === (A = this.player.currentVideoInfo) || void 0 === A
                  ? void 0
                  : A.loadingUrl,
            };
            this.logger.log(
              "start degrade retry, degradeReason=".concat(a, ", extraInfo="),
              s
            ),
              writeDegradeCodecToLocal(r, a, s);
          }
          return e.prototype.startGetinfoRetry.call(this, t, o);
        }),
        (t.prototype.getRetryCheckClasses = function () {
          return RetryClasses;
        }),
        (t.prototype.getPlusAdOffsetTime = function (e) {
          return this.removedAdRange.reduce(function (e, t) {
            var o = t.start,
              A = t.end;
            return o <= e && (e += A - o), e;
          }, e);
        }),
        (t.prototype.waitAdPlugin = function () {
          var e,
            t = this,
            o = getAdPlugin(
              null === (e = this.config) || void 0 === e ? void 0 : e.instanceId
            );
          return o
            ? Promise.resolve(o)
            : new Promise(function (e) {
                t.pluginMsg.on(
                  "pluginsetup:".concat(AdPluginName),
                  function () {
                    e(getAdPlugin(t.config.instanceId));
                  }
                );
              });
        }),
        (t.prototype.playByInitConfig = function () {
          var t = this.config,
            o = t.videoId,
            A = t.videoInitConfig,
            i = void 0 === A ? o : A;
          return !i || this.currentPlayItem
            ? e.prototype.play.call(this)
            : this.play(i);
        }),
        (t.prototype.nodeBeforePostAd = function (t) {
          return uaTool$1.mobile ||
            this.previewLogic.previewDuration === NO_PREVIEW_FLAG
            ? e.prototype.nodeBeforePostAd.call(this, t)
            : null;
        }),
        (t.prototype.setupRemovedAdRange = function () {
          var e = this;
          this.on(exports.H5_PLAY_EVENT.VIDEO_REQ_INFO_END, function (t) {
            var o = t.data;
            if (
              o.code === exports.ErrorCode.SUC &&
              e.config.type !== exports.PLAY_MODE.LIVE
            )
              try {
                var A = o.data,
                  i = A.parseData,
                  r = A.reqParams,
                  n = i.vitem,
                  a = n.purevid,
                  s = n.dotinfo,
                  g = void 0 === s ? "" : s;
                a && r.vid !== a && g
                  ? (e.removedAdRange = JSON.parse(g).dot_time.map(function (
                      e
                    ) {
                      return {
                        start: +e.start_time / 1e3,
                        end: +e.end_time / 1e3,
                      };
                    }))
                  : (e.removedAdRange = null);
              } catch (t) {
                e.log("set ad range err,", t), (e.removedAdRange = null);
              }
          });
        }),
        (t.prototype.selectGetinfoModule = function (e) {
          var t = e.type,
            o = void 0 === t ? exports.PLAY_MODE.VOD : t,
            A = e.getinfoModule;
          return e.enableTVK
            ? A || (o === exports.PLAY_MODE.VOD ? VodGetinfo : LiveGetinfo)
            : null;
        }),
        (t.prototype.initPlugins = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (e) {
              return (
                this.initAdPlugin(),
                this.initErrorPage(),
                this.initTipsPlugin(),
                this.initCtrlbarPlugin(),
                this.initLivepoll(),
                this.initLoadingPlugin(),
                this.clearCache(),
                [2]
              );
            });
          });
        }),
        (t.prototype.initAdPlugin = function () {
          var e = this,
            t = this.ctrlbarPlugin;
          t &&
            (t.on(CTRL_EVENTS$1.FAKE_FULLSCREEN_CHANGE, function () {
              return e.resizeAd();
            }),
            t.on(CTRL_EVENTS$1.FULLSCREEN_CHANGE, function () {
              e.hideAdBeforeResize();
              setTimeout(function () {
                e.resizeAd();
              }, 300);
            }));
        }),
        (t.prototype.reqExtInfoOnMobile = function () {
          return __awaiter$1(this, void 0, void 0, function () {
            var e, t, o, A, i;
            return __generator$1(this, function (r) {
              switch (r.label) {
                case 0:
                  return (
                    (e = this.config),
                    (t = e.videoId),
                    (o = e.enableGetExtInfo),
                    (void 0 === o || o) &&
                    uaTool$1.mobile &&
                    "string" == typeof t
                      ? ((A = this.getCommonKv(COMMON_DATA_KEY.platform)),
                        [4, requestVideoExtInfo({ vid: t, platform: A })])
                      : [2]
                  );
                case 1:
                  return (
                    (i = r.sent().duration),
                    this.state === exports.VIDEO_STATE.IDLE &&
                      !this.played &&
                      this.ctrlbarPlugin &&
                      (this.ctrlbarPlugin.duration = i),
                    [2]
                  );
              }
            });
          });
        }),
        (t.prototype.initLoadingPlugin = function () {
          var e = this;
          this.on(exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_START, function () {
            var t;
            return null === (t = e.loadingPlugin) || void 0 === t
              ? void 0
              : t.show();
          }),
            this.on(exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_END, function () {
              var t;
              return null === (t = e.loadingPlugin) || void 0 === t
                ? void 0
                : t.hide();
            }),
            this.pluginMsg.on(exports.PLAY_EVENT_EXT.RETRY_PLAY, function (t) {
              var o,
                A,
                i = t.data;
              null === (o = e.loadingPlugin) || void 0 === o || o.show(),
                null === (A = e.tipsPlugin) ||
                  void 0 === A ||
                  A.show(
                    (null == i ? void 0 : i.degradeReason)
                      ? compile(i18nConfig.superPlayer.TIPS_DEGRADE_TEXT_REASON)
                      : compile(
                          i18nConfig.superPlayer.TIPS_DEGRADE_TEXT_NO_REASON
                        )
                  );
            });
        }),
        (t.prototype.initLivepoll = function () {
          var e = this,
            t = this.plugins[LivepollPlugin.pluginName];
          t &&
            t.on(LIVE_EVENTS.statusChange, function (t) {
              var o;
              t.data.new === LIVE_STATUS.OVER &&
                (null === (o = e.errorPagePlugin) ||
                  void 0 === o ||
                  o.show({
                    text: compile(i18nConfig.superPlayer.LIVE_STREAM_END),
                    hideRefresh: !0,
                  }));
            });
        }),
        (t.prototype.initErrorPage = function () {
          var e = this;
          if (this.errorPagePlugin) {
            var t = i18nConfig.superPlayer;
            this.errorPagePlugin.on(
              ErrorPagePluginEvents.REPORT_LOG,
              function () {
                return __awaiter$1(e, void 0, void 0, function () {
                  var e, o, A;
                  return __generator$1(this, function (i) {
                    switch (i.label) {
                      case 0:
                        return (
                          i.trys.push([0, 2, , 3]),
                          [
                            4,
                            this.offlineLog.reportLogs({
                              reportSource: "error-page:click",
                            }),
                          ]
                        );
                      case 1:
                        return (
                          i.sent(),
                          null === (o = this.tipsPlugin) ||
                            void 0 === o ||
                            o.show(compile(t.ERROR_PAGE_REPORT_SUCCESS)),
                          [3, 3]
                        );
                      case 2:
                        return (
                          (e = i.sent()),
                          null === (A = this.tipsPlugin) ||
                            void 0 === A ||
                            A.show(
                              compile(
                                t.ERROR_PAGE_REPORT_FAILED,
                                null == e ? void 0 : e.message
                              )
                            ),
                          [3, 3]
                        );
                      case 3:
                        return [2];
                    }
                  });
                });
              }
            );
          }
        }),
        (t.prototype.initTipsPlugin = function () {
          var e = this;
          this.tipsPlugin &&
            this.on(exports.H5_PLAY_EVENT.VIDEO_SETLEVEL_END, function (t) {
              var o,
                A,
                i,
                r = t.data,
                n = e.getCommonKv(COMMON_DATA_KEY.currentDefn),
                a =
                  null === (o = e.levelList) || void 0 === o
                    ? void 0
                    : o.find(function (e) {
                        return e.value === n;
                      }),
                s =
                  (null ===
                    (i =
                      null === (A = null == a ? void 0 : a.payload) ||
                      void 0 === A
                        ? void 0
                        : A.trim) || void 0 === i
                    ? void 0
                    : i.call(A)) || (null == a ? void 0 : a.label);
              e.tipsPlugin.show(
                r.code !== exports.ErrorCode.SUC
                  ? "".concat(
                      r.message ||
                        compile(i18nConfig.superPlayer.DEFN_SWITCH_FAILED)
                    )
                  : compile(i18nConfig.superPlayer.DEFN_SWITCH_SUCCESS, s)
              );
            });
        }),
        (t.prototype.initCtrlbarPlugin = function () {
          var e = this,
            t = i18nConfig.superPlayer;
          if (this.ctrlbarPlugin) {
            (this.ctrlbarPlugin.level = this.getCommonKv(
              COMMON_DATA_KEY.currentDefn
            )),
              (this.ctrlbarPlugin.audio = this.getCommonKv(
                COMMON_DATA_KEY.currentAudioTrack
              )),
              (this.ctrlbarPlugin.lang = this.getCommonKv(
                COMMON_DATA_KEY.currentSubtitle
              )),
              this.pluginMsg.on(
                exports.PLAY_EVENT_EXT.DATASET_UPDATE,
                function (t) {
                  var o,
                    A = t.data,
                    i = A.key,
                    r = A.newVal;
                  if (r !== A.oldVal)
                    switch (i) {
                      case COMMON_DATA_KEY.currentAudioTrackList:
                        e.ctrlbarPlugin.audioOpts = r;
                        break;
                      case COMMON_DATA_KEY.currentAudioTrack:
                        e.ctrlbarPlugin.audio = r;
                        break;
                      case COMMON_DATA_KEY.currentDefn:
                        e.ctrlbarPlugin.level = r;
                        break;
                      case COMMON_DATA_KEY.currentDefnList:
                        if (!r || r.length <= 1) {
                          e.ctrlbarPlugin.levelOpts = [];
                          break;
                        }
                        (o = [].concat(r)), (e.ctrlbarPlugin.levelOpts = o);
                    }
                }
              ),
              this.ctrlbarPlugin.on(CTRL_EVENTS$1.SET_LEVEL, function (o) {
                var A, i;
                if (e.checkCanSetLevel()) {
                  var r = o.data,
                    n = r.value,
                    a = r.payload,
                    s = r.label;
                  null === (A = e.tipsPlugin) ||
                    void 0 === A ||
                    A.show({
                      text: compile(
                        t.DEFN_SWITCHING,
                        (null === (i = null == a ? void 0 : a.trim) ||
                        void 0 === i
                          ? void 0
                          : i.call(a)) || s
                      ),
                      time: -1,
                    }),
                    e.setLevel(n, { userTrigger: !0 });
                }
              });
            var o = function () {
              e.tipsPlugin.show(compile(t.AUDIO_SWITCH_FAILED)),
                (e.ctrlbarPlugin.audio = e.currentVideoInfo.currentAudioTrack);
            };
            this.ctrlbarPlugin.on(CTRL_EVENTS$1.SET_AUDIO, function (A) {
              var i,
                r = A.data,
                n = r.label,
                a = r.value;
              null === (i = e.tipsPlugin) ||
                void 0 === i ||
                i.show({ text: compile(t.AUDIO_SWITCHING, n), time: -1 }),
                e
                  .setAudioTrack(a)
                  .then(function (A) {
                    A.fail
                      ? o()
                      : (function (o) {
                          e.tipsPlugin.show(compile(t.AUDIO_SWITCH_SUCCESS, o));
                        })(n);
                  })
                  .catch(function () {
                    o();
                  });
            }),
              this.on(exports.PLAY_EVENT.SET_AUDIO_TRACK_OVER, function (t) {
                e.setCommonKv(COMMON_DATA_KEY.currentAudioTrack, t.data.id);
              }),
              this.ctrlbarPlugin.on(CTRL_EVENTS$1.TEST_EVENT, function () {
                var t;
                null === (t = e.getPlugin(InfoPanelPluginName)) ||
                  void 0 === t ||
                  t.show();
              });
          }
        }),
        (t.prototype.shouldHideMouse = function () {
          if (!this.ctrlbarPlugin)
            return e.prototype.shouldHideMouse.call(this);
          var t = (this.ctrlbarPlugin.instances.CtrlShow || {})
              .isMouseHoverControl,
            o = void 0 !== t && t;
          return e.prototype.shouldHideMouse.call(this) && !o;
        }),
        (t.prototype.setLevelOptions = function (e, t) {
          var o;
          if (e) {
            var A = e.list,
              i =
                (null ===
                  (o = A.find(function (e) {
                    return e.default || e.url === t;
                  })) || void 0 === o
                  ? void 0
                  : o.value) || A[0].value;
            this.setCommonKv(COMMON_DATA_KEY.currentDefn, i),
              this.setCommonKv(COMMON_DATA_KEY.currentDefnList, A),
              (this.defnIdToUrl = e.callback);
          } else
            this.setCommonKv(COMMON_DATA_KEY.currentDefn, void 0),
              this.setCommonKv(COMMON_DATA_KEY.currentDefnList, void 0),
              (this.defnIdToUrl = void 0);
        }),
        (t.prototype.isH5PlayParam = function (e) {
          void 0 === e && (e = {});
          var t = e;
          return !!(
            t.videoReqInfoParam ||
            t.videoLoadParam ||
            t.adParam ||
            t.playTimeLimit
          );
        }),
        (t.prototype.initInnerEvts = function () {
          var e = this;
          this.pluginMsg.on(exports.PLAY_EVENT_EXT.GETINFO_OVER, function (t) {
            var o,
              A = (t.data || {}).resData,
              i = ((null === (o = null == A ? void 0 : A.vl) || void 0 === o
                ? void 0
                : o.vi) || [])[0];
            if (i) {
              var r = i.vw,
                n = i.vh;
              e.videoSizeFromGetInfo = { width: r, height: n };
            }
          }),
            uaTool$1.mobile &&
              this.on(exports.H5_PLAY_EVENT.VIDEO_TIMEUPDATE, function (t) {
                var o = t.data;
                if (e.previewDuration !== NO_PREVIEW_FLAG) {
                  o.playtime >= e.previewDuration - 10 && e.loadPostAd();
                }
              });
        }),
        (t.prototype.writeGlobalCommonKvs = function () {
          this.setCommonKv(COMMON_DATA_KEY.appVer, envVals.VERSION),
            this.setCommonKv(this.config.businessConfig),
            this.writeLoginCommonKV();
        }),
        (t.prototype.getDefnNameById = function (e) {
          var t,
            o,
            A =
              null ===
                (o =
                  null === (t = this.getinfoCtx) || void 0 === t
                    ? void 0
                    : t.parseData) || void 0 === o
                ? void 0
                : o.definitionList.find(function (t) {
                    return t.name === e;
                  });
          if (A) {
            var i = formatDefnName(
                A.cname,
                this.type === exports.PLAY_MODE.LIVE
              ),
              r = i[0],
              n = void 0 === r ? "" : r,
              a = i[1];
            return ""
              .concat(void 0 === a ? "" : a, " ")
              .concat(n)
              .trim();
          }
          return "";
        }),
        (t.prototype.requestProxyHttpOnlyAd = function (e, t) {
          return __awaiter$1(this, void 0, void 0, function () {
            var o, A, i, r;
            return __generator$1(this, function (n) {
              switch (n.label) {
                case 0:
                  if (!getAdPlugin(this.config.instanceId)) return [2];
                  (o = new ProxyHttp(this.config, {
                    pluginMsg: this.pluginMsg,
                  })),
                    (A = getAdReqParams(
                      this.config.instanceId,
                      __assign$1({ vid: this.curReqInfo.vid, adType: e }, t)
                    )),
                    (n.label = 1);
                case 1:
                  return n.trys.push([1, 3, , 4]), [4, o.request(A, null)];
                case 2:
                  return (i = n.sent()), [3, 4];
                case 3:
                  return (
                    (r = n.sent()),
                    this.warn("proxyhttp request err in catch, ".concat(r)),
                    [3, 4]
                  );
                case 4:
                  return [2, i];
              }
            });
          });
        }),
        (t.prototype.requestAdCallback4AdPlugin = function (e, t) {
          var o;
          return __awaiter$1(this, void 0, void 0, function () {
            var A, i;
            return __generator$1(this, function (r) {
              switch (r.label) {
                case 0:
                  return (A = getAdPlugin(this.config.instanceId))
                    ? [4, this.requestProxyHttpOnlyAd(e, t)]
                    : [2];
                case 1:
                  if (
                    ((i = r.sent()),
                    null === (o = null == i ? void 0 : i.parseData) ||
                    void 0 === o
                      ? void 0
                      : o.ad)
                  )
                    try {
                      A.setAdInfo(i.parseData.ad);
                    } catch (e) {
                      this.logger.error(
                        "requestAd, call adPlugin::setAdInfo",
                        e
                      );
                    }
                  return [2, i];
              }
            });
          });
        }),
        (t.prototype.requestAdCallback = function (e, t) {
          var o;
          return __awaiter$1(this, void 0, void 0, function () {
            var A;
            return __generator$1(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, this.requestProxyHttpOnlyAd(e, t)];
                case 1:
                  return (
                    (A = i.sent()),
                    [
                      2,
                      null === (o = null == A ? void 0 : A.parseData) ||
                      void 0 === o
                        ? void 0
                        : o.ad,
                    ]
                  );
              }
            });
          });
        }),
        (t.prototype.stop = function (t) {
          return (
            (this.videoSizeFromGetInfo = null), e.prototype.stop.call(this, t)
          );
        }),
        (t.prototype.emit = function (t, o) {
          return e.prototype.emit.call(this, t, o);
        }),
        (t.prototype.on = function (t, o, A) {
          return e.prototype.on.call(this, t, o, A);
        }),
        (t.prototype.once = function (t, o) {
          return e.prototype.once.call(this, t, o);
        }),
        (t.prototype.off = function (t, o) {
          return e.prototype.off.call(this, t, o);
        }),
        (t.prototype.listeners = function (t) {
          return e.prototype.listeners.call(this, t);
        }),
        (t.prototype.listenerCount = function (t) {
          return e.prototype.listenerCount.call(this, t);
        }),
        (t.prototype.writeLoginCommonKV = function () {
          var e,
            t,
            o,
            A = function (e) {
              return cookieTool$1.get(e);
            },
            i = getUserCookies();
          this.setCommonKv(
            (((e = {})[COMMON_DATA_KEY.hc_main_login] =
              i[COOKIE_NAME.MAIN_LOGIN]),
            (e[COMMON_DATA_KEY.hc_vuserid] = i[COOKIE_NAME.VUSERID]),
            (e[COMMON_DATA_KEY.hc_openid] = i[COOKIE_NAME.OPENID]),
            (e[COMMON_DATA_KEY.hc_appid] = i[COOKIE_NAME.APPID]),
            (e[COMMON_DATA_KEY.hc_access_token] = i[COOKIE_NAME.ACCESS_TOKEN]),
            e)
          );
          var r = i[COOKIE_NAME.GUID] || cookieTool$1.get(COOKIE_NAME.GUID);
          r &&
            (this.setCommonKv(COMMON_DATA_KEY.guid, r),
            lsTool.setData(exports.LOCAL_KEY.GUID, r));
          var n = "qq" === i[COOKIE_NAME.MAIN_LOGIN],
            a =
              null === (o = A("luin") || A("uin")) || void 0 === o
                ? void 0
                : o.replace(/\D/g, "").replace(/^0+/, "");
          this.setCommonKv(
            (((t = {})[COMMON_DATA_KEY.loginid] = n ? a : A("openid")),
            (t[COMMON_DATA_KEY.loginex] = n ? A("openid") : a),
            t)
          );
          this.setCommonKv(
            COMMON_DATA_KEY.logintype,
            { qq: 1, wx: 2 }[i[COOKIE_NAME.MAIN_LOGIN]] || 0
          ),
            this.setCommonKv(
              COMMON_DATA_KEY.hc_vuession,
              i[COOKIE_NAME.VUSESSION]
            );
        }),
        (t.prototype.loadAdPlugin = function () {
          var e = this,
            t = this.config.enableCreativePlugin;
          if (!(void 0 === t || t) || envVals.LOCAL_DEV || isInDomainWhiteList)
            return Promise.resolve();
          var o = getAdInitConfig(this.config),
            A = !!H5Player.getPlugin(AdPluginName),
            i = document.querySelector('script[data-dynamic="creative"]');
          if (!adInitDefer)
            if (A) adInitDefer = Promise.resolve();
            else if (i) adInitDefer = this.waitForPageAdPlugin(i);
            else {
              var r =
                  isOfficialDomain() && this.config.adVersion
                    ? this.config.adVersion
                    : adVersion,
                n = "https://vm.gtimg.cn/thumbplayer/creative/"
                  .concat(r, "/creative-player-")
                  .concat(uaTool$1.mobile ? "m" : "v", ".js");
              adInitDefer = this.loadPlugin({
                url: n,
                globalName: adGlobalName,
                pluginName: AdPluginName,
                timeout: adScriptMaxLoadTime,
                config: o,
                crossOrigin: "anonymous",
              });
            }
          return adInitDefer
            .then(function () {
              e._destroyed ||
                getAdPlugin(e.config.instanceId) ||
                !H5Player.getPlugin(AdPluginName) ||
                e.createPlugin(AdPluginName, o);
            })
            .catch(function (t) {
              e.log(
                "adPlugin load fail. ".concat(null == t ? void 0 : t.message)
              );
            });
        }),
        (t.prototype.waitForPageAdPlugin = function (e) {
          var t = 0;
          return new Promise(function (o, A) {
            var i = function () {
              (e.onload = null),
                (e.onerror = null),
                t > 0 && window.clearTimeout(t),
                H5Player.getPlugin(AdPluginName) ? o() : A();
            };
            (e.onload = i),
              (e.onerror = i),
              (t = window.setTimeout(i, adScriptMaxLoadTime));
          });
        }),
        (t.prototype.clearBeforeReplay = function () {
          this.setCommonKv(exports.SUPER_DATA_KEY.hlsAdRanges, null),
            this.setCommonKv(exports.SUPER_DATA_KEY.getinfoAdInfo, null);
        }),
        (t.prototype.getBuiltInVideoReqInfoParam = function (e, t) {
          return (
            void 0 === t && (t = !0),
            __awaiter$1(this, void 0, void 0, function () {
              var o;
              return __generator$1(this, function (A) {
                return (
                  (o = this.getCommonKv.bind(this)),
                  this.type === exports.PLAY_MODE.VOD
                    ? [2, getVodBuiltInVideoReqInfoParam(this.config, e, o, t)]
                    : [2, getLiveBuiltInVideoReqInfoParam(this.config, e, o)]
                );
              });
            })
          );
        }),
        (t._instances = {}),
        __decorate(
          [
            logMethodCall,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "destroy",
          null
        ),
        __decorate(
          [
            logMethodCall,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "play",
          null
        ),
        __decorate(
          [
            performanceCost,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Object, String]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "loadOrPlay",
          null
        ),
        __decorate(
          [
            logMethodCall,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", []),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "replay",
          null
        ),
        __decorate(
          [
            logMethodCall,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "load",
          null
        ),
        __decorate(
          [
            logMethodCall,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Object, Number]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "preload",
          null
        ),
        __decorate(
          [
            logMethodCall,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Number]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "seek",
          null
        ),
        __decorate(
          [
            logMethodCall,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String, Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "setLevel",
          null
        ),
        __decorate(
          [
            logMethodCall,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "closePayTipsCallback",
          null
        ),
        __decorate(
          [
            logMethodCall,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String, Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "createPlugin",
          null
        ),
        __decorate(
          [
            logMethodCall,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "setAdConfig",
          null
        ),
        __decorate(
          [
            destroyProtectDecorator,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String, Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "requestProxyHttpOnlyAd",
          null
        ),
        __decorate(
          [
            destroyProtectDecorator,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String, Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "requestAdCallback4AdPlugin",
          null
        ),
        __decorate(
          [
            logMethodCall,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [String]),
            __metadata("design:returntype", void 0),
          ],
          t.prototype,
          "stop",
          null
        ),
        __decorate(
          [
            performanceCost,
            __metadata("design:type", Function),
            __metadata("design:paramtypes", [Object, Object]),
            __metadata("design:returntype", Promise),
          ],
          t.prototype,
          "getBuiltInVideoReqInfoParam",
          null
        ),
        t
      );
    })(H5Player),
    BUILD_TIME = envVals.BUILD_TIME,
    VERSION = envVals.VERSION;
  return (
    bindExports(SuperPlayer),
    mountGlobal({
      globalName: "SuperPlayer",
      target: SuperPlayer,
      onDuplicate: function () {
        console.warn(
          "Possible duplicated SuperPlayer detected. Avoid to import this package multiple times."
        );
      },
    }),
    StepTimer.start(exports.SuperStepKey.READY_2_NEW),
    (exports.AdPluginName = AdPluginName),
    (exports.BUILD_TIME = BUILD_TIME),
    (exports.BaseCheck = BaseCheck),
    (exports.BaseFlowNode = BaseFlowNode),
    (exports.BaseReporter = BaseReporter),
    (exports.BeaconRequest = BeaconRequest),
    (exports.COMMON_DATA_KEY = COMMON_DATA_KEY),
    (exports.CTRL_EVENTS = CTRL_EVENTS$1),
    (exports.CheckNormalError = CheckNormalError),
    (exports.CtrlbarPluginName = CtrlbarPluginName),
    (exports.DEFAULT_KEY = DEFAULT_KEY),
    (exports.DRM_TYPE = DRM_TYPE),
    (exports.DRM_VALUE = DRM_VALUE),
    (exports.ErrorPagePluginEvents = ErrorPagePluginEvents),
    (exports.ErrorPagePluginName = ErrorPagePluginName),
    (exports.EvtEmitter = s$1$1),
    (exports.H5Player = H5Player),
    (exports.H5_EXT_EVENT = exports.PLAY_EVENT_EXT),
    (exports.ImageRequest = report),
    (exports.InfoPanelPluginName = InfoPanelPluginName),
    (exports.LOCAL_STORAGE_KEY = LOCAL_STORAGE_KEY),
    (exports.OFFICIAL_PLUGIN = OFFICIAL_PLUGIN),
    (exports.PLAY_CODEC = PLAY_CODEC),
    (exports.PLUGINS_URL = PLUGINS_URL),
    (exports.PLUGIN_MAP = PLUGIN_MAP),
    (exports.Plugin = Plugin),
    (exports.PosterPluginName = PosterPluginName),
    (exports.StepTimer = StepTimer),
    (exports.TipsPluginName = TipsPluginName),
    (exports.UIContextMenuPluginName = UIContextMenuPluginName),
    (exports.VERSION = VERSION),
    (exports.VideoReqInfoPluginName = VideoReqInfoPluginName),
    (exports.WatermarkPluginName = WatermarkPluginName),
    (exports.adEvents = adEvents),
    (exports.adGlobalName = adGlobalName),
    (exports.adScriptMaxLoadTime = adScriptMaxLoadTime),
    (exports.adVersion = adVersion),
    (exports.autobind = autobind),
    (exports.contextMenuPluginName = contextMenuPluginName),
    (exports.createGetinfoModule = createGetinfoModule),
    (exports.createH5Player = createH5Player),
    (exports.createPluginFactory = createPluginFactory),
    (exports.ctrlbarPluginName = ctrlbarPluginName),
    (exports.default = SuperPlayer),
    (exports.defaultLiveBusinessConfig = defaultLiveBusinessConfig),
    (exports.defaultSuperConfig = defaultSuperConfig),
    (exports.defaultVodBusinessConfig = defaultVodBusinessConfig),
    (exports.defaultVodPlatform = defaultVodPlatform),
    (exports.defautVodSdtfrom = defautVodSdtfrom),
    (exports.definePlugins = definePlugins),
    (exports.deregisterPlugin = deregisterPlugin),
    (exports.destroyGetinfoModule = destroyGetinfoModule),
    (exports.doGetinfo = doGetinfo),
    (exports.envVals = envVals$1),
    (exports.formatDefnName = formatDefnName),
    (exports.getAdInitConfig = getAdInitConfig),
    (exports.getAdPlugin = getAdPlugin),
    (exports.getAdReqParams = getAdReqParams),
    (exports.getBuiltInPlugins = getBuiltInPlugins),
    (exports.getEnvVals = getEnvVals$1),
    (exports.getGetinfoModule = getGetinfoModule),
    (exports.getHookMethodName = getHookMethodName),
    (exports.getLocalDynamicConfig = getLocalDynamicConfig),
    (exports.getPlugin = getPlugin),
    (exports.getPlugins = getPlugins),
    (exports.getSuperConfig = getSuperConfig),
    (exports.hasGetinfoModule = hasGetinfoModule),
    (exports.i18nConfig = i18nConfig),
    (exports.isFunctionPlugin = isFunctionPlugin),
    (exports.isInDomainWhiteList = isInDomainWhiteList),
    (exports.isPreOrPostAd = isPreOrPostAd),
    (exports.isVideoId = isVideoId),
    (exports.kernelEvtBus = kernelEvtBus),
    (exports.logApiInvoke = logApiInvoke),
    (exports.mergeDynamicConfig = mergeDynamicConfig),
    (exports.once = once),
    (exports.pluginExists = pluginExists),
    (exports.preloadEvtBus = preloadEvtBus),
    (exports.registerPlugin = registerPlugin),
    (exports.skipAdDomainWhiteList = skipAdDomainWhiteList),
    (exports.stepTimerFakeGlobalInstanceId = stepTimerFakeGlobalInstanceId),
    (exports.t = compile),
    (exports.tryEmit = tryEmit),
    Object.defineProperty(exports, "__esModule", { value: !0 }),
    exports
  );
})({});